webpackJsonp([0],{

/***/ "../node_modules/css-hot-loader/hotModuleReplacement.js":
/***/ (function(module, exports, __webpack_require__) {

var normalizeUrl = __webpack_require__("../node_modules/normalize-url/index.js");
var srcByModuleId = Object.create(null);

var getCurrentScriptUrl = function(moduleId) {
  var src = srcByModuleId[moduleId];
  if (!src && document) {
    if (document.currentScript) {
      src = document.currentScript.src;
    } else {
      var scripts = document.getElementsByTagName('script');
      src = scripts[scripts.length - 1].src;
    }
    srcByModuleId[moduleId] = src;
  }

  return function(fileMap) {
    var splitResult = /([^\\/]+)\.js$/.exec(src);
    var filename = splitResult && splitResult[1];
    if (!filename) {
      return [src.replace('.js', '.css')];
    }
    return fileMap.split(',').map(function(mapRule) {
      var reg = new RegExp(filename + '\\.js$', 'g')
      return normalizeUrl(src.replace(reg, mapRule.replace(/{fileName}/g, filename) + '.css'), { stripWWW: false });
    });
  };
}

function updateCss(el, url) {
  if (!url) {
    url = el.href.split('?')[0];
  }

  if (!url || !(url.indexOf('.css') > -1)) return;

  var newEl = el.cloneNode();
  newEl.addEventListener('load', function () {
    el.remove();
  });
  newEl.addEventListener('error', function () {
    el.remove();
  });
  newEl.href = url + '?' + Date.now();
  el.parentNode.replaceChild(newEl, el)
}

function reloadStyle(src) {
  var elements = document.querySelectorAll('link');
  var loaded = false;
  [].slice.call(elements).forEach(function(el) {
    var url = getReloadUrl(el.href, src);
    if (url) {
      updateCss(el, url);
      loaded = true;
    }
  });
  return loaded;
}

function getReloadUrl(href, src) {
  href = normalizeUrl(href, { stripWWW: false });
  var ret;
  src.some(function(url) {
    if (href.indexOf(src) > -1) {
      ret = url;
    }
  });
  return ret;
}

function reloadAll() {
  var elements = document.querySelectorAll('link');
  [].slice.call(elements).forEach(function(el) {
    updateCss(el);
  });
}

module.exports = function(moduleId, options) {
  var getScriptSrc = getCurrentScriptUrl(moduleId);
  return function() {
    if (typeof document === 'undefined') {
      return;
    }

    var src = getScriptSrc(options.fileMap);
    var reloaded = reloadStyle(src);
    if (reloaded) {
      console.log('[HMR] css reload %s', src.join(' '));
    } else {
      console.log('[HMR] Reload all css');
      reloadAll();
    }
  }
};


/***/ }),

/***/ "../node_modules/is-plain-obj/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toString = Object.prototype.toString;

module.exports = function (x) {
	var prototype;
	return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};


/***/ }),

/***/ "../node_modules/normalize-url/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var url = __webpack_require__("../node_modules/url/url.js");
var punycode = __webpack_require__("../node_modules/punycode/punycode.js");
var queryString = __webpack_require__("../node_modules/query-string/index.js");
var prependHttp = __webpack_require__("../node_modules/prepend-http/index.js");
var sortKeys = __webpack_require__("../node_modules/sort-keys/index.js");
var objectAssign = __webpack_require__("../node_modules/object-assign/index.js");

var DEFAULT_PORTS = {
	'http:': 80,
	'https:': 443,
	'ftp:': 21
};

// protocols that always contain a `//`` bit
var slashedProtocol = {
	'http': true,
	'https': true,
	'ftp': true,
	'gopher': true,
	'file': true,
	'http:': true,
	'https:': true,
	'ftp:': true,
	'gopher:': true,
	'file:': true
};

function testParameter(name, filters) {
	return filters.some(function (filter) {
		return filter instanceof RegExp ? filter.test(name) : filter === name;
	});
}

module.exports = function (str, opts) {
	opts = objectAssign({
		normalizeProtocol: true,
		normalizeHttps: false,
		stripFragment: true,
		stripWWW: true,
		removeQueryParameters: [/^utm_\w+/i],
		removeTrailingSlash: true,
		removeDirectoryIndex: false
	}, opts);

	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	var hasRelativeProtocol = str.indexOf('//') === 0;

	// prepend protocol
	str = prependHttp(str.trim()).replace(/^\/\//, 'http://');

	var urlObj = url.parse(str);

	if (opts.normalizeHttps && urlObj.protocol === 'https:') {
		urlObj.protocol = 'http:';
	}

	if (!urlObj.hostname && !urlObj.pathname) {
		throw new Error('Invalid URL');
	}

	// prevent these from being used by `url.format`
	delete urlObj.host;
	delete urlObj.query;

	// remove fragment
	if (opts.stripFragment) {
		delete urlObj.hash;
	}

	// remove default port
	var port = DEFAULT_PORTS[urlObj.protocol];
	if (Number(urlObj.port) === port) {
		delete urlObj.port;
	}

	// remove duplicate slashes
	if (urlObj.pathname) {
		urlObj.pathname = urlObj.pathname.replace(/\/{2,}/g, '/');
	}

	// decode URI octets
	if (urlObj.pathname) {
		urlObj.pathname = decodeURI(urlObj.pathname);
	}

	// remove directory index
	if (opts.removeDirectoryIndex === true) {
		opts.removeDirectoryIndex = [/^index\.[a-z]+$/];
	}

	if (Array.isArray(opts.removeDirectoryIndex) && opts.removeDirectoryIndex.length) {
		var pathComponents = urlObj.pathname.split('/');
		var lastComponent = pathComponents[pathComponents.length - 1];

		if (testParameter(lastComponent, opts.removeDirectoryIndex)) {
			pathComponents = pathComponents.slice(0, pathComponents.length - 1);
			urlObj.pathname = pathComponents.slice(1).join('/') + '/';
		}
	}

	// resolve relative paths, but only for slashed protocols
	if (slashedProtocol[urlObj.protocol]) {
		var domain = urlObj.protocol + '//' + urlObj.hostname;
		var relative = url.resolve(domain, urlObj.pathname);
		urlObj.pathname = relative.replace(domain, '');
	}

	if (urlObj.hostname) {
		// IDN to Unicode
		urlObj.hostname = punycode.toUnicode(urlObj.hostname).toLowerCase();

		// remove trailing dot
		urlObj.hostname = urlObj.hostname.replace(/\.$/, '');

		// remove `www.`
		if (opts.stripWWW) {
			urlObj.hostname = urlObj.hostname.replace(/^www\./, '');
		}
	}

	// remove URL with empty query string
	if (urlObj.search === '?') {
		delete urlObj.search;
	}

	var queryParameters = queryString.parse(urlObj.search);

	// remove query unwanted parameters
	if (Array.isArray(opts.removeQueryParameters)) {
		for (var key in queryParameters) {
			if (testParameter(key, opts.removeQueryParameters)) {
				delete queryParameters[key];
			}
		}
	}

	// sort query parameters
	urlObj.search = queryString.stringify(sortKeys(queryParameters));

	// decode query parameters
	urlObj.search = decodeURIComponent(urlObj.search);

	// take advantage of many of the Node `url` normalizations
	str = url.format(urlObj);

	// remove ending `/`
	if (opts.removeTrailingSlash || urlObj.pathname === '/') {
		str = str.replace(/\/$/, '');
	}

	// restore relative protocol, if applicable
	if (hasRelativeProtocol && !opts.normalizeProtocol) {
		str = str.replace(/^http:\/\//, '//');
	}

	return str;
};


/***/ }),

/***/ "../node_modules/object-assign/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "../node_modules/prepend-http/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (url) {
	if (typeof url !== 'string') {
		throw new TypeError('Expected a string, got ' + typeof url);
	}

	url = url.trim();

	if (/^\.*\/|^(?!localhost)\w+:/.test(url)) {
		return url;
	}

	return url.replace(/^(?!(?:\w+:)?\/\/)/, 'http://');
};


/***/ }),

/***/ "../node_modules/punycode/punycode.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../node_modules/webpack/buildin/module.js")(module), __webpack_require__("../node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "../node_modules/query-string/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__("../node_modules/strict-uri-encode/index.js");
var objectAssign = __webpack_require__("../node_modules/object-assign/index.js");

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ "../node_modules/querystring-es3/decode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),

/***/ "../node_modules/querystring-es3/encode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),

/***/ "../node_modules/querystring-es3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("../node_modules/querystring-es3/decode.js");
exports.encode = exports.stringify = __webpack_require__("../node_modules/querystring-es3/encode.js");


/***/ }),

/***/ "../node_modules/sort-keys/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isPlainObj = __webpack_require__("../node_modules/is-plain-obj/index.js");

module.exports = function (obj, opts) {
	if (!isPlainObj(obj)) {
		throw new TypeError('Expected a plain object');
	}

	opts = opts || {};

	// DEPRECATED
	if (typeof opts === 'function') {
		opts = {compare: opts};
	}

	var deep = opts.deep;
	var seenInput = [];
	var seenOutput = [];

	var sortKeys = function (x) {
		var seenIndex = seenInput.indexOf(x);

		if (seenIndex !== -1) {
			return seenOutput[seenIndex];
		}

		var ret = {};
		var keys = Object.keys(x).sort(opts.compare);

		seenInput.push(x);
		seenOutput.push(ret);

		for (var i = 0; i < keys.length; i++) {
			var key = keys[i];
			var val = x[key];

			ret[key] = deep && isPlainObj(val) ? sortKeys(val) : val;
		}

		return ret;
	};

	return sortKeys(obj);
};


/***/ }),

/***/ "../node_modules/strict-uri-encode/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ "../node_modules/url/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__("../node_modules/punycode/punycode.js");
var util = __webpack_require__("../node_modules/url/util.js");

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__("../node_modules/querystring-es3/index.js");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),

/***/ "../node_modules/url/util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),

/***/ "./_app.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182514489
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./app.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var appController = function appController(APP, APP_VERSION, Events) {
  var vm = this;
  vm.events = Events;

  // Defaults
  vm.appVersion = APP_VERSION;
  vm.googleStatus = APP.googleStatus;
};

appController['$inject'] = ['APP', 'APP_VERSION', 'Events'];

var inkApp = exports.inkApp = {
  template: __webpack_require__("./app.template.html"),
  controller: appController
};

/***/ }),

/***/ "./app.config.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder')

// Global loading bar config
.config(['cfpLoadingBarProvider', function (cfpLoadingBarProvider) {
  cfpLoadingBarProvider.latencyThreshold = 300;
  cfpLoadingBarProvider.includeSpinner = false;
}])

// Intercom configuration
// .config(function($intercomProvider, INTERCOM_APPID) {
//   $intercomProvider
//     .appID(INTERCOM_APPID);
//   $intercomProvider.asyncLoading(true);
// })

// Stripe config.
// .config(function(stripeProvider) {
// Stripe key
// stripeProvider.setPublishableKey('pk_test_eQS565yugdj2oZewaD7puTL4');
// })

// Add the Auth Inerceptor as a HTTP Provider Interceptor.
.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AuthInterceptor');
}])

// Lightbox gallery config
.config(['LightboxProvider', function (LightboxProvider) {
  LightboxProvider.getImageUrl = function (image) {
    return image.image_1024;
  };
}])

// Satellizer config
.config(['$authProvider', 'ENDPOINT', 'APP', function ($authProvider, ENDPOINT, APP) {
  $authProvider.facebook({
    clientId: APP.facebook,
    url: ENDPOINT.server + 'collectors/api/v1.1/auth/facebook/'
  });

  $authProvider.loginUrl = ENDPOINT.server + 'collectors/api/v1.1/login/';
  $authProvider.signupUrl = ENDPOINT.server + 'collectors/api/v1.1/';
}])

// ui router config
.config(['$urlServiceProvider', '$locationProvider', 'DEFAULT_STATES', function ($urlServiceProvider, $locationProvider, DEFAULT_STATES) {
  // Use the HTML5 History API
  $locationProvider.html5Mode(true);

  // Trailing slashes are not required
  $urlServiceProvider.config.strictMode(false);

  // Set the default state if no states match the URL entered
  $urlServiceProvider.rules.when('', DEFAULT_STATES.public);

  // Set the default state if no states match the URL entered
  $urlServiceProvider.rules.otherwise(DEFAULT_STATES.public);
}]);

/***/ }),

/***/ "./app.environment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').constant('ENDPOINT', {
  server: getServer()
}).constant('APP', {
  facebook: getFacebookKey(),
  googleStatus:  false ? 'auto' : 'none'
}).config(['$logProvider', function ($logProvider) {
  $logProvider.debugEnabled(true);
  if (true) {
    $logProvider.debugEnabled(false);
  }
}]);

/**
 * @name getServer
 * @description Function to get the value of the server URL based on the
 * environment
 * @return {string} Returns the value of the server URL
 */
function getServer() {
  if (false) {
    return 'https://staging-app.inkfinder.tattoo:8443/';
  }
  if (true) {
    return 'https://inkfinder.tattoo:8100/';
  }
  if (false) {
    return 'http://localhost:8300/';
  }
  return 'http://localhost:8300/';
}

/**
 * @name getFacebookKey
 * @description Function to get the Facebook key ID based on the environment
 * @return {string} Returns the Facebook key
 */
function getFacebookKey() {
  if (false) {
    return '246422285698548';
  }
  if (true) {
    return '237772826563494';
  }
  return '237777829896327';
}

/***/ }),

/***/ "./app.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inkfinder = undefined;

var _appComponent = __webpack_require__("./app.component.js");

// Ink Finder app
var inkfinder = exports.inkfinder = angular.module('inkfinder', ['ui.router', 'angular-loading-bar', 'angulartics', 'angulartics.google.analytics', 'angularMoment', 'angularUtils.directives.dirPagination', 'bootstrapLightbox', 'duScroll', 'fcsa-number', 'monospaced.elastic', 'ngAnimate', 'ngSanitize', 'ngCookies', 'ngMask', 'ngFileUpload', 'ngPasswordStrength', 'satellizer', 'ui.bootstrap', 'ui.router.title', 'ui.select', 'ngMap', 'tw.directives.clickOutside', 'picardy.fontawesome', 'ng.ckeditor']).component('inkApp', _appComponent.inkApp).name;

/***/ }),

/***/ "./app.run.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').run(['$rootScope', '$auth', 'Auth', 'AUTH_EVENTS', 'Session', '$transitions', '$location', 'Events', '$document', '_', function ($rootScope, $auth, Auth, AUTH_EVENTS, Session, $transitions, $location, Events, $document, _) {
  // Boolean to determine if a state requires authentication
  var requiresAuth = {
    to: function to(state) {
      return state.data && state.data.authorizedRoles;
    }
  };

  // Boolean to determine if a state requires authentication
  var doesNotRequireAuth = {
    to: function to(state) {
      return !state.data;
    }
  };

  // Function to get the session if the state requires authentication so we can
  // validate the state transition based on the user credentials.
  var requiresSession = function requiresSession(transition) {
    if ($auth.isAuthenticated() && _.isUndefined(Session.collector)) {
      return Auth.getSession().then(function () {
        return authorizeTransition(transition);
      });
    }
    return authorizeTransition(transition);
  };

  /**
   * @name loadSession
   * @description If the user has a token but no Session.collector (such as when
   * the browser is reloaded), then get the session.
   */
  function loadSession() {
    if ($auth.isAuthenticated() && _.isUndefined(Session.collector)) {
      Auth.getSession();
    }
  }

  // Before every state transition, check to see if authentication is required.
  $transitions.onBefore(requiresAuth, requiresSession, { priority: 10 });
  $transitions.onBefore(doesNotRequireAuth, loadSession, { priority: 15 });

  /**
   * @name authorizeTransition
   * @description Function to authorize if the user can view the to state.
   * @param {unknown} transition unknown.
   * @return {unknown} Returns target state.
   */
  function authorizeTransition(transition) {
    var $state = transition.router.stateService;
    var authorizedRoles = transition.to().data.authorizedRoles;
    if (Auth.isAllowed(authorizedRoles) === false) {
      $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
      Auth.redirect.url = $location.path();
      return $state.target('login', undefined, { location: false });
    }
  }

  var requiresStateChange = {
    to: function to(state) {
      if (state.data && state.data.authorizedRoles && Session.activeState) {
        return state.data.authorizedRoles.indexOf(Session.activeState.role) === -1;
      }
    }
  };

  /**
   * @name changeState
   * @description Function to change the mode to match the role in data.
   * @return {function} changeState Returns the changeState function.
   */
  function changeState() {
    return Auth.changeState();
  }

  $transitions.onBefore(requiresStateChange, changeState, { priority: 20 });

  $transitions.onStart({}, function ($transition$) {
    var to = $transition$.to().name;
    var from = $transition$.from().name;
    if (to === 'inkfinder.messages.inbox' && from === 'inkfinder.messages.conversations') {
      return;
    }
    Events.loading = true;
  });

  $transitions.onSuccess({}, function () {
    Events.loading = false;
  });

  $transitions.onFinish({}, function () {
    var top = 0;
    var duration = 500; // milliseconds
    $document.scrollTop(top, duration);
  });
}]);

/***/ }),

/***/ "./app.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=app ng-class=\"{\n  'logged-in': $ctrl.events.loggedIn,\n  'nav-active': $ctrl.events.navActive,\n  'secondary-nav-active': $ctrl.events.secondaryNavActive,\n  'nav-small': $ctrl.events.navSize === 'small',\n  'chat-open': $ctrl.events.chatOpen,\n  'stats-open': $ctrl.events.statsOpen,\n  'artist-stats-open': $ctrl.events.artistStatsOpen}\"> <ink-alert></ink-alert> <div class=overlay ng-class=\"{'load': $ctrl.events.loading === true}\"></div> <div class=\"region-content fade-view\" ui-view></div> <div ui-view=stats-shelf></div> <div ui-view=navigation></div> <div ui-view=mobile-navigation></div> </div> ";

/***/ }),

/***/ "./common/403/403.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ink403 = {
  template: '\n  <h1>Sorry, this content isn\u2019t available right now.</h1>\n  <p>The link you followed may have expired, or the page may only be visible to\n  an audience you\'re not in.</p>\n  '
};

angular.module('inkfinder').component('ink403', ink403);

/***/ }),

/***/ "./common/403/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./common/403/403.component.js");

/***/ }),

/***/ "./common/404/404.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ink404 = {
  template: '\n  <h1>Sorry, this page isn\u2019t available.</h1>\n  <p>The link you followed may be broken, or the page may have been removed.</p>\n  '
};

angular.module('inkfinder').component('ink404', ink404);

/***/ }),

/***/ "./common/404/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./common/404/404.component.js");

/***/ }),

/***/ "./common/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./common/403/index.js");

__webpack_require__("./common/404/index.js");

__webpack_require__("./common/more/index.js");

__webpack_require__("./common/nav/index.js");

/***/ }),

/***/ "./common/more/_more.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509814
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./common/more/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./common/more/more.component.js");

__webpack_require__("./common/more/more.controller.js");

__webpack_require__("./common/more/more.template.html");

__webpack_require__("./common/more/_more.styles.scss");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.more', {
    url: '/more',
    views: {
      '@': {
        component: 'inkMore'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Find more';
      }
    }
  }).state('site.more', {
    url: '/site-more',
    views: {
      '@': {
        component: 'inkMore'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Find more';
      }
    }
  });
}]);

/***/ }),

/***/ "./common/more/more.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkMore = {
  controller: 'MoreController',
  template: __webpack_require__("./common/more/more.template.html")
};

angular.module('inkfinder').component('inkMore', inkMore);

/***/ }),

/***/ "./common/more/more.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MoreController.$inject = ['$rootScope', 'Auth', 'Session', '$state', 'DEFAULT_STATES', 'SWITCH_MESSAGE', '$cookies'];


/**
 * @name MoreController
 * @param {unknown} $rootScope Unknown
 * @param {object} Auth Our global auth service
 * @param {object} Session The service that holds session data
 * @param {unknown} $state Unknown
 * @param {unknown} DEFAULT_STATES The constant for default states per role
 * @param {unknown} SWITCH_MESSAGE The switch messages constant
 * @param {unknown} $cookies Angular $cookies service
 */
function MoreController($rootScope, Auth, Session, $state, DEFAULT_STATES, SWITCH_MESSAGE, $cookies) {
  var vm = this;

  vm.$onInit = function () {
    vm.logout = logout;
    vm.changeState = changeState;
    vm.switchToBuying = switchToBuying;
    vm.session = Session;
  };

  /**
   * @name changeState
   * @description Function to change states (buy/selling) and the user role
   * associated with the state
   * @param {object} activeState The selected state
   */
  function changeState(activeState) {
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(activeState);
    $cookies.putObject('inkfinder', activeState);
    if (activeState.role === 'operator') {
      $state.go(DEFAULT_STATES.operator);
    } else {
      $state.go(DEFAULT_STATES.artist);
    }
  }

  /**
   * @name switchToBuying
   * @description Function to move the user to the collector's dashboard
   */
  function switchToBuying() {
    var state = {
      mode: 'buying',
      role: 'collector',
      switchMessage: SWITCH_MESSAGE.buying,
      id: 1
    };
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(state);
    $cookies.putObject('inkfinder', state);
    $state.go(DEFAULT_STATES.buying);
  }

  /**
   * @name logout
   * @description Wrapper for the Auth logout function
   */
  function logout() {
    Auth.logout();
  }
}

angular.module('inkfinder').controller('MoreController', MoreController);

/***/ }),

/***/ "./common/more/more.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=more-menu class=\"section dark\"> <div class=background-photo></div> <div class=container-fluid> <div class=row ng-if=$ctrl.session.collector> <div class=col-sm-12> <div class=\"intro center\"> <a ui-sref=inkfinder.collector.update> <ink-profile-photo type=\"'collector'\" show-name=true profile=$ctrl.session.collector size=\"'large'\" image-id=$ctrl.session.collector.profile_photo> </ink-profile-photo> </a> </div> </div> </div> <div class=row> <div class=col-sm-12> <div> <div class=\"menu finder\"> <small>Ink Finder</small> <a ng-click=$ctrl.changeState(state) ng-repeat=\"state in $ctrl.session.states.selling track by state.id\"> <span ng-if=\"state.role === 'operator'\">Operator at {{state.association.shop.name}}</span> <span ng-if=\"state.role === 'artist'\">Artist at {{state.association.shop.name}}</span> </a> <a ng-if=$ctrl.session.collector ng-click=$ctrl.switchToBuying()>Buy art</a> <a ng-if=$ctrl.session.collector ui-sref=inkfinder.collector.update> Settings </a> <a ui-sref=inkfinder.shop.profile({shop_id:$ctrl.association.shop.id}) ng-if=\"$ctrl.session.activeState.association.operatorOwner || $ctrl.session.activeState.association.operatorAdmin\"> Shop settings </a> <a ng-if=!$ctrl.session.collector ui-sref=login>Sign in</a> <a ng-if=$ctrl.session.collector ng-click=$ctrl.logout()>Sign out</a> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./common/nav/_mobile-menu.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509789
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./common/nav/_nav.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509904
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./common/nav/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./common/nav/mobile-nav.component.js");

__webpack_require__("./common/nav/mobile-nav.controller.js");

__webpack_require__("./common/nav/nav.component.js");

__webpack_require__("./common/nav/nav.controller.js");

__webpack_require__("./common/nav/_nav.styles.scss");

__webpack_require__("./common/nav/_mobile-menu.styles.scss");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder', {
    abstract: true,
    views: {
      'navigation@': {
        component: 'inkNav'
      },
      'stats-shelf@': {
        component: 'inkStatsShelf'
      },
      'mobile-navigation@': {
        component: 'inkMobileNav'
      }
    },
    onEnter: ['Events', function onEnter(Events) {
      Events.navActive = true;
    }],
    onExit: ['Events', function onExit(Events) {
      Events.navActive = false;
    }],
    // Resolve for a new messages count in the message center
    resolve: {
      participants: ['Participants', 'Events', function participants(Participants, Events) {
        Participants.getUnreadCount().then(function (count) {
          Events.newMessagesCount = count;
        });
      }]
    },
    data: {
      authorizedRoles: [USER_ROLES.collector, USER_ROLES.artist, USER_ROLES.operator]
    }
  });
}]);

/***/ }),

/***/ "./common/nav/mobile-nav.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkMobileNav = {
  bindings: {
    type: '<'
  },
  template: __webpack_require__("./common/nav/mobile-nav.template.html"),
  controller: 'MobileNavController'
};

angular.module('inkfinder').component('inkMobileNav', inkMobileNav);

/***/ }),

/***/ "./common/nav/mobile-nav.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MobileNavController.$inject = ['Session'];


/**
 * @name MobileNavController
 * @description Controller for the mobile nav shelf
 * @param {object} Session The service delivering the user's session.
 */
function MobileNavController(Session) {
  var vm = this;
  vm.session = Session;
}

angular.module('inkfinder').controller('MobileNavController', MobileNavController);

/***/ }),

/***/ "./common/nav/mobile-nav.template.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"region-menu-shelf background-light\"> <div ng-if=\"$ctrl.session.activeState.role === 'collector'\"> <a ui-sref=inkfinder.projects ui-sref-active=\"{'active': 'inkfinder.projects'}\"> <i class=\"icon star\"></i> <span>Projects</span> </a> <a ui-sref=inkfinder.messages.inbox ui-sref-active=active> <i class=\"icon chat-bubble\"></i> <span>Messages</span> </a> <a ui-sref=inkfinder.more ui-sref-active=active> <fa name=ellipsis-h></fa> <span>More</span> </a> </div> <div ng-if=\"$ctrl.session.activeState.role === 'operator'\"> <a ui-sref=inkfinder.dashboard ui-sref-active=active> <i class=\"icon star\"></i> <span>Today</span> </a> <a ui-sref=inkfinder.messages.inbox ui-sref-active=active> <i class=\"icon chat-bubble\"></i> <span>Messages</span> </a> <a ui-sref=inkfinder.appointments.days ui-sref-active=\"{'active': 'inkfinder.appointments'}\"> <i class=\"icon calendar\"></i> <span>Schedule</span> </a> <a ui-sref=inkfinder.clients-list ui-sref-active=active> <i class=\"icon diamond\"></i> <span>Clients</span> </a> <a ui-sref=inkfinder.artists ui-sref-active=\"{'active': 'inkfinder.artists'}\" ng-if=\"$ctrl.session.activeState.association.operatorOwner || $ctrl.session.activeState.association.operatorAdmin\"> <i class=\"icon skull\"></i> <span>Artists</span> </a> <a ui-sref=inkfinder.more ui-sref-active=active> <fa name=ellipsis-h></fa> <span>More</span> </a> </div> <div ng-if=\"$ctrl.session.activeState.role === 'artist'\"> <a ui-sref=inkfinder.dashboard ui-sref-active=active> <i class=\"icon star\"></i> <span>Today</span> </a> <a ui-sref=inkfinder.messages.inbox ui-sref-active=active> <i class=\"icon chat-bubble\"></i> <span>Messages</span> </a> <a ui-sref=inkfinder.appointments.days ui-sref-active=\"{'active': 'inkfinder.appointments'}\"> <i class=\"icon calendar\"></i> <span>Schedule</span> </a> <a ui-sref=inkfinder.clients-list ui-sref-active=active> <i class=\"icon diamond\"></i> <span>Clients</span> </a> <a ui-sref=inkfinder.more ui-sref-active=active> <fa name=ellipsis-h></fa> <span>More</span> </a> </div> </div> ";

/***/ }),

/***/ "./common/nav/nav.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkNav = {
  bindings: {
    session: '<'
  },
  template: __webpack_require__("./common/nav/nav.template.html"),
  controller: 'NavController'
};

angular.module('inkfinder').component('inkNav', inkNav);

/***/ }),

/***/ "./common/nav/nav.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


NavController.$inject = ['Auth', 'Session', 'Events'];


/**
 * @name NavController
 * @param {object} Auth Our global auth service
 * @param {object} Session The service that holds session data
 * @param {object} Events The system events service
 */
function NavController(Auth, Session, Events) {
  var vm = this;

  vm.$onInit = function () {
    vm.logout = logout;
    vm.navSizeChange = navSizeChange;
    vm.session = Session;
    vm.events = Events;
  };

  /**
   * Function to change the size of the side bar nav
   */
  function navSizeChange() {
    if (Events.navSize === 'large') {
      Events.navSize = 'small';
    } else {
      Events.navSize = 'large';
    }
  }

  /**
   * @name logout
   * @description Wrapper for the Auth logout function
   */
  function logout() {
    Auth.logout();
  }
}

angular.module('inkfinder').controller('NavController', NavController);

/***/ }),

/***/ "./common/nav/nav.template.html":
/***/ (function(module, exports) {

module.exports = " <div class=region-sidebar ng-class=\"{'nav-small': $ctrl.navSize === 'small'}\"> <div class=toggle> <a ng-click=$ctrl.navSizeChange()> <fa name=caret-left></fa> </a> </div> <div> <span class=logo-flat></span> </div> <ink-state-switcher></ink-state-switcher> <div class=region-inner> <div id=menu ng-if=\"$ctrl.session.activeState.mode === 'buying'\"> <a ui-sref=inkfinder.projects ui-sref-active=\"{'active': 'inkfinder.projects'}\"> <i class=\"icon star\"></i> <span>Projects</span> </a> <a ui-sref=inkfinder.messages.inbox ui-sref-active=\"{'active': 'inkfinder.messages'}\" class=menu__chat> <i class=\"icon chat-bubble\"></i> <span>Messages</span> <div class=badge ng-if=\"$ctrl.events.newMessagesCount > 0\"> {{$ctrl.events.newMessagesCount}} </div> </a> </div> <div id=menu ng-if=\"$ctrl.session.activeState.role === 'operator'\"> <a ui-sref=inkfinder.dashboard ui-sref-active=active> <i class=\"icon star\"></i> <span>Today</span> </a> <a ui-sref=inkfinder.messages.inbox ui-sref-active=\"{'active': 'inkfinder.messages'}\" class=menu__chat> <i class=\"icon chat-bubble\"></i> <span>Messages</span> <div class=badge ng-if=\"$ctrl.events.newMessagesCount > 0\"> {{$ctrl.events.newMessagesCount}} </div> </a> <a ui-sref=inkfinder.appointments.days ui-sref-active=\"{'active': 'inkfinder.appointments'}\"> <i class=\"icon calendar\"></i> <span>Schedule</span> </a> <a ui-sref=inkfinder.clients-list ui-sref-active=active> <i class=\"icon diamond\"></i> <span>Clients</span> </a> <div ng-if=\"$ctrl.session.activeState.association.operatorOwner || $ctrl.session.activeState.association.operatorAdmin\"> <a ui-sref=inkfinder.artists ui-sref-active=\"{'active': 'inkfinder.artists'}\"> <i class=\"icon skull\"></i> <span>Artists</span> </a> <a ui-sref=inkfinder.shop.profile({shop_id:$ctrl.association.shop.id}) ui-sref-active=\"{'active': 'inkfinder.shop'}\"> <i class=\"icon machine\"></i> <span>Shop</span> </a> </div> </div> <div id=menu ng-if=\"$ctrl.session.activeState.role === 'artist'\"> <a ui-sref=inkfinder.dashboard ui-sref-active=active> <i class=\"icon star\"></i> <span>Today</span> </a> <a ui-sref=inkfinder.messages.inbox ui-sref-active=\"{'active': 'inkfinder.messages'}\" class=menu__chat> <i class=\"icon chat-bubble\"></i> <span>Messages</span> <div class=badge ng-if=\"$ctrl.events.newMessagesCount > 0\"> {{$ctrl.events.newMessagesCount}} </div> </a> <a ui-sref=inkfinder.appointments.days ui-sref-active=\"{'active': 'inkfinder.appointments'}\"> <i class=\"icon calendar\"></i> <span>Schedule</span> </a> <a ui-sref=inkfinder.clients-list ui-sref-active=active> <i class=\"icon diamond\"></i> <span>Clients</span> </a> </div> <div class=logout> <a ng-click=$ctrl.logout()> <fa name=sign-out class=icon></fa> <span class=nav-label>Sign out</span> </a> </div> </div> </div> ";

/***/ }),

/***/ "./components/account-payments/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/account-payments/payments.controller.js");

/***/ }),

/***/ "./components/account-payments/payments.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


PaymentController.$inject = ['$scope', '$http', 'stripe', 'ENDPOINT', '$log', '_'];


/**
 * @name PaymentController
 * @description Controller for payments
 * @param {unknown} $scope Description
 * @param {unknown} $http Description
 * @param {unknown} stripe Description
 * @param {unknown} ENDPOINT Description
 * @param {unknown} $log Description
 * @param {library} _ The Lodash library
 */
function PaymentController($scope, $http, stripe, ENDPOINT, $log, _) {
  var vm = this;

  // Get card token
  vm.charge = function () {
    return stripe.card.createToken($scope.card).then(function (response) {
      $log.debug('token created for card ending in ', response.card.last4);
      var payment = _.cloneDeep($scope.card);
      payment.card = null;
      payment.token = response.id;
      $log.debug(payment.token);
      return $http.post(ENDPOINT.server + 'payments/api/v1.1/pay/');
    }).then(function (payment) {
      $log.debug('successfully submitted payment for $', payment.amount);
    }).catch(function (err) {
      if (err.type && /^Stripe/.test(err.type)) {
        $log.debug('Stripe error: ', err.message);
      } else {
        $log.debug('Other error occurred, possibly with your API', err.message);
      }
    });
  };
}

angular.module('inkfinder').controller('PaymentController', PaymentController);

/***/ }),

/***/ "./components/activity/_activity.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509480
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/activity/activity.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkActivity = {
  bindings: {
    conversationId: '<',
    appointmentId: '<',
    activityTitle: '<',
    projectId: '<',
    hasMessages: '<',
    hasAppointmentActivity: '<',
    hasProjectActivity: '<'
  },
  controller: 'ActivityController',
  template: __webpack_require__("./components/activity/activity.template.html")
};

angular.module('inkfinder').component('inkActivity', inkActivity);

/***/ }),

/***/ "./components/activity/activity.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ActivityController.$inject = ['$timeout', 'Messages', 'Activity', '_', '$rootScope', '$scope', 'Session', '$log', 'Participants', '$q', 'moment'];
/**
 * @name ActivityController
 * @description Controller for activity
 * @param {type} $timeout Description
 * @param {type} Messages Description
 * @param {type} Activity Description
 * @param {type} _ Description
 * @param {type} $rootScope Angular rootScope service
 * @param {type} $scope Angular scope service
 * @param {service} Session The session service
 * @param {service} $log Angular log service
 * @param {service} Participants The Participants service
 * @param {service} $q Angular $q service
 * @param {service} moment The moment library
 */
function ActivityController($timeout, Messages, Activity, _, $rootScope, $scope, Session, $log, Participants, $q, moment) {
  var vm = this;

  vm.$onInit = function () {
    vm.messages = [];
    vm.apptActivity = [];
    vm.projectActivity = [];
    vm.mergedData = [];
    vm.session = Session;
    vm.markAsRead = markAsRead;
    vm.hasMessages = _.isUndefined(vm.hasMessages) ? true : vm.hasMessages;
    vm.hasAppointmentActivity = _.isUndefined(vm.hasAppointmentActivity) ? true : vm.hasAppointmentActivity;
    vm.hasProjectActivity = _.isUndefined(vm.hasProjectActivity) ? true : vm.hasProjectActivity;
  };

  vm.$onChanges = function (changes) {
    if (changes.conversationId && !_.isUndefined(changes.conversationId.currentValue)) {
      get(changes.conversationId.currentValue);
    }
    if (changes.projectId && !_.isUndefined(changes.projectId.currentValue)) {
      getActivity('project', changes.projectId.currentValue);
    }
    if (changes.appointmentId && !_.isUndefined(changes.appointmentId.currentValue)) {
      getActivity('appointment', changes.appointmentId.currentValue);
    }
  };

  // Merge activity when updating activity or message arrays
  var deregister = $scope.$on('merge-activity', function (event, conversationId, appointmentId, projectId) {
    if (!_.isUndefined(conversationId)) {
      get(conversationId);
    }
    if (!_.isUndefined(projectId)) {
      getActivity('project', projectId);
    }
    if (!_.isUndefined(appointmentId)) {
      getActivity('appointment', appointmentId);
    }
  });
  $scope.$on('$destroy', deregister);

  /**
   * @name get
   * @description Function to get conversations for an appointment by ID
   * @param {number} conversationId The ID of the conversation to retrieve
   */
  function get(conversationId) {
    var appointmentId = void 0;
    var collectorId = Session.collector.id;
    Messages.get(conversationId, appointmentId, collectorId).then(function (messages) {
      vm.messages = messages;
      vm.mergedData = _.concat(vm.messages, vm.apptActivity, vm.projectActivity);
      Participants.get(conversationId, appointmentId, collectorId).then(function (participant) {
        if (participant.length) {
          vm.lastReadDate = moment(participant[0].last_read_date).format('YYYY-MM-DDTHH:mm:ss');
        }
      });
    });
  }

  /**
   * @name getActivity
   * @description Function to get activity for appointments and projects
   * @param {type} contentType The type of content activity. Options are
   * 'appointment' and 'project'
   * @param {type} objectId The ID of the object to get
   */
  function getActivity(contentType, objectId) {
    Activity.get(contentType, objectId).then(function (activity) {
      if (contentType === 'project') {
        vm.projectActivity = activity;
      } else if (contentType === 'appointment') {
        vm.apptActivity = activity;
      }
      vm.mergedData = _.concat(vm.messages, vm.apptActivity, vm.projectActivity);
    });
  }

  /**
   * @name markAsRead
   * @description Function to update the last read date for the user's
   * participant
   * @param {type} conversationId The ID of the conversation
   */
  function markAsRead(conversationId) {
    var appointmentId = void 0;
    var collectorId = Session.collector.id;
    Participants.get(conversationId, appointmentId, collectorId).then(function (participant) {
      if (participant.length) {
        var participantToUpdate = participant[0];
        participantToUpdate.last_read_date = moment.utc().format('YYYY-MM-DDTHH:mm:ss');
        Participants.update(participantToUpdate).then(function (updatedParticipant) {
          vm.lastReadDate = updatedParticipant.last_read_date;
        });
      }
    });
  }
}

angular.module('inkfinder').controller('ActivityController', ActivityController);

/***/ }),

/***/ "./components/activity/activity.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formatActivity = __webpack_require__("./utils/format-activity.js");

var _formatActivity2 = _interopRequireDefault(_formatActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('inkfinder').factory('Activity', ['$http', 'ENDPOINT', 'Session', 'AlertMessages', '_', function Activity($http, ENDPOINT, Session, AlertMessages, _) {
  // Public methods
  Activity.get = get;

  /**
   * @name get
   * @description Get an object's activity based on ID and type.
   * @param {string} contentType The contentType of the object to retrieve.
   * @param {number} objectId The ID of the object to retrieve.
   * @return {array} Returns the array of activity
   */
  function get(contentType, objectId) {
    var role = Session.activeState.role;
    var url = ENDPOINT.server + 'activities/api/v1.1/?role=' + role + '&content_type=' + contentType + '&object_id=' + objectId;
    if (!_.isUndefined(Session.activeState.association)) {
      url += '&association_id=' + Session.activeState.association.id;
    }
    return $http.get(url).then(function (response) {
      var formattedActivity = (0, _formatActivity2.default)(contentType, response.data);
      return formattedActivity;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return Activity;
}]);

/***/ }),

/***/ "./components/activity/activity.template.html":
/***/ (function(module, exports) {

module.exports = "<h4>{{$ctrl.activityTitle}}</h4> <div class=button-container> <button class=\"button small gray\" ng-click=\"$ctrl.hasMessages = !$ctrl.hasMessages\" ng-class=\"{'active': $ctrl.hasMessages}\"> <fa name=check fw></fa> Messages </button> <button class=\"button small gray\" ng-click=\"$ctrl.hasAppointmentActivity = !$ctrl.hasAppointmentActivity\" ng-class=\"{'active': $ctrl.hasAppointmentActivity}\"> <fa name=check fw></fa> Appointment activity </button> <button class=\"button small gray\" ng-click=\"$ctrl.hasProjectActivity = !$ctrl.hasProjectActivity\" ng-class=\"{'active': $ctrl.hasProjectActivity}\"> <fa name=check fw></fa> Project activity </button> <button class=\"button small gray float-right\" ng-click=$ctrl.markAsRead($ctrl.conversationId)> Mark as read </button> <div class=clearfix></div> </div> <div ng-repeat=\"message in $ctrl.mergedData | orderBy: '-created' | activityFilter:$ctrl.hasMessages:$ctrl.hasAppointmentActivity:$ctrl.hasProjectActivity as results\" ng-if=\"$ctrl.mergedData.length > 0\"> <div class=row> <div class=col-sm-12> <div class=activity ng-class=\"{'private': message.private,\n      'new': $ctrl.lastReadDate < message.localCreatedDate,\n      'me': $ctrl.session.collector.id === message.collector.id,\n      'is-activity': message.type === 'activity',\n      'is-message': message.type !== 'activity'}\"> <div class=\"col-xs-3 col-sm-2 center\" ng-class=\"{'col-xs-push-9 col-sm-push-10': $ctrl.session.collector.id === message.collector.id && message.type !== 'activity'}\"> <ink-profile-photo show-name=false image-id=message.collector.profile_photo size=\"'standard'\"> </ink-profile-photo> </div> <div class=\"col-xs-9 col-sm-10 message-body\" ng-class=\"{\n          'col-xs-pull-3 col-sm-pull-2': $ctrl.session.collector.id === message.collector.id && message.type !== 'activity'}\"> <div class=\"arrow arrow__space-gray\" ng-class=\"{'arrow__left': $ctrl.session.collector.id !== message.collector.id, 'arrow__right': $ctrl.session.collector.id === message.collector.id}\"></div> <div class=row> <div class=col-xs-11> <div> <p class=allow-breaks>{{message.content}}</p> </div> <div ng-if=\"message.type === 'activity'\"> <p ng-if=\"message.description.length === 1\">{{message.collector.first_name}} {{message.collector.last_name}} {{message.description[0].message}} <span ng-if=\"message.description[0].oldValue !== null\">from <span class=value-old>{{message.description[0].oldValue}}</span> </span> <span ng-if=\"message.description[0].newValue !== null\"> to <span class=value-new>{{message.description[0].newValue}}</span> </span> </p> <div ng-if=\"message.description.length > 1\"> <p>{{message.collector.first_name}} {{message.collector.last_name}} made the following changes to this {{message.object}}: </p> <ul> <li ng-repeat=\"eachActivity in message.description\" class=capitalize> {{eachActivity.message}} <span ng-if=\"eachActivity.oldValue !== null\">from <span class=value-old>{{eachActivity.oldValue}}</span> </span> <span ng-if=\"eachActivity.newValue !== null\"> to <span class=value-new>{{eachActivity.newValue}}</span> </span> </li> </ul> </div> </div> <small>{{message.collector.first_name}} {{message.collector.last_name}} <span class=capitalize am-time-ago=\"message.created | amUtc  | amLocal\"></span> </small> </div> <div class=col-xs-1 ng-if=message.private> <fa name=lock tooltip-placement=left uib-tooltip=\"This message is private.\" tooltip-class=light tooltip-append-to-body=true tooltip-enable=message.private></fa> </div> </div> </div> <div class=clearfix></div> </div> </div> </div> </div> <p ng-show=\"results.length === 0\"> There’s nothing here. </p> ";

/***/ }),

/***/ "./components/activity/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/activity/activity.component.js");

__webpack_require__("./components/activity/activity.controller.js");

__webpack_require__("./components/activity/activity.service.js");

__webpack_require__("./components/activity/_activity.styles.scss");

/***/ }),

/***/ "./components/alerts/_alert-messages.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509383
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/alerts/alert-messages.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAlert = {
  controller: 'AlertMessagesController',
  template: '\n  <div class="alerts">\n    <div class="alert" uib-alert ng-repeat="alert in $ctrl.alerts"\n      ng-class="\'alert-\' + (alert.type || \'warning\')"\n      dismiss-on-timeout="4000"\n      close="$ctrl.closeAlert($index)">\n      {{alert.msg}}\n    </div>\n  </div>\n  '
};

angular.module('inkfinder').component('inkAlert', inkAlert);

/***/ }),

/***/ "./components/alerts/alert-messages.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AlertMessagesController.$inject = ['AlertMessages'];


/**
  * @description The function to login to Ink Finder
  * @param {unknown} AlertMessages Unknown
  */
function AlertMessagesController(AlertMessages) {
  var vm = this;
  vm.closeAlert = closeAlert;

  /**
    * @description
    * Alerts system
    * @param {array} alert The alert message object
    */
  vm.alerts = AlertMessages.list;

  /**
    * @name closeAlert
    * @description Function to close the alert from the view
    * @param {number} index The index of the alerts array to close
    */
  function closeAlert(index) {
    AlertMessages.close(index);
  }
}

angular.module('inkfinder').controller('AlertMessagesController', AlertMessagesController);

/***/ }),

/***/ "./components/alerts/alert-messages.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AlertMessages.$inject = ['_'];


/**
 * @name AlertMessages
 * @description Service to push and retrieve global system alerts
 * @param {Unknown} _ Lodash services
 * @return {object} Returns the AlertMessages object
 */
function AlertMessages(_) {
  var AlertMessages = {};
  AlertMessages.list = [];
  AlertMessages.add = function (alert) {
    var _alert = {
      msg: 'Something went wrong. Contact us so we can prevent this error in\n      the future.',
      type: alert.type
    };

    if (_.isString(alert.msg)) {
      _alert.msg = alert.msg;
    } else if (!_.isUndefined(alert.msg) && alert.msg.data && alert.msg.data !== null) {
      _alert.msg = alert.msg.data;
    } else if (!_.isUndefined(alert.msg) && !_.isUndefined(alert.msg.message)) {
      _alert.msg = alert.msg.message;
    } else if (!_.isUndefined(alert.msg) && !_.isUndefined(alert.msg.status) && alert.msg.status === 500) {
      _alert.msg = 'Something went wrong. Contact us so we can prevent this\n      error in the future.';
    } else if (!_.isUndefined(alert.msg) && alert.msg.data === null) {
      _alert.msg = 'Could not connect to Ink Finder. Please check\n      your internet connection.';
    }
    AlertMessages.list.push(_alert);
  };
  AlertMessages.close = function (index) {
    AlertMessages.list.splice(index, 1);
  };
  return AlertMessages;
}
angular.module('inkfinder').factory('AlertMessages', AlertMessages);

/***/ }),

/***/ "./components/alerts/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/alerts/alert-messages.component.js");

__webpack_require__("./components/alerts/alert-messages.controller.js");

__webpack_require__("./components/alerts/alert-messages.service.js");

__webpack_require__("./components/alerts/_alert-messages.styles.scss");

/***/ }),

/***/ "./components/app-version/app-version.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAppVersion = {
  controller: 'AppVersionController',
  template: __webpack_require__("./components/app-version/app-version.template.html"),
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
};

angular.module('inkfinder').component('inkAppVersion', inkAppVersion);

/***/ }),

/***/ "./components/app-version/app-version.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AppVersionController.$inject = ['Session', '$window', 'AppVersion'];
/**
 * @name AppVersionController
 * @description Controller for the AppVersion component
 * @param {service} Session The Session service
 * @param {angular} $window The $window service from Angular
 * @param {service} AppVersion The AppVersion service
 */
function AppVersionController(Session, $window, AppVersion) {
  var vm = this;
  vm.$onInit = function () {
    vm.reloadBrowser = reloadBrowser;
    Session.cancelAppVersionPoll();
  };

  var getDescriptions = true;
  AppVersion.get(getDescriptions).then(function (appVersions) {
    vm.appVersions = appVersions;
  });

  /**
   * @name reloadBrowser
   * @description Function to reload the browser
   */
  function reloadBrowser() {
    $window.location.reload();
  }
}

angular.module('inkfinder').controller('AppVersionController', AppVersionController);

/***/ }),

/***/ "./components/app-version/app-version.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AppVersion.$inject = ['$http', 'ENDPOINT', 'AlertMessages'];
/**
 * @name AppVersion
 * @description Function for the AppVersion service
 * @param {type} $http Description
 * @param {type} ENDPOINT Description
 * @param {type} AlertMessages Description
 * @return {object} Returns the ArtistHours service
 */
function AppVersion($http, ENDPOINT, AlertMessages) {
  AppVersion.get = get;

  /**
   * @name get
   * @description Function to get the app version from the API
   * @param {boolean} getDescription Flag to determine if we should get the
   * description for each app version.
   * @return {string} Returns the result of the app version
   */
  function get(getDescription) {
    var url = ENDPOINT.server + 'inkutils/api/v1.1/app-version/';
    if (getDescription) {
      url += '?description=true';
    }
    return $http.get(url).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return AppVersion;
}

angular.module('inkfinder').factory('AppVersion', AppVersion);

/***/ }),

/***/ "./components/app-version/app-version.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h4 class=modal-title>Ink Finder has been updated</h4> </div> <div class=\"modal-body background-light\"> <h5>There’s a new version of Ink Finder ready for you.</h5> <p><a ng-click=$ctrl.reloadBrowser()>Refresh your browser</a> to start using the latest version.</p> <uib-accordion class=\"accordion medium\"> <div uib-accordion-group ng-repeat=\"version in $ctrl.appVersions | orderBy:'-created' track by version.id\" is-open=$first> <uib-accordion-heading> <h6>Version {{version.app_version}} released on {{version.created | amDateFormat:'dddd, MMMM Do YYYY'}}</h6> </uib-accordion-heading> <div ng-bind-html=version.update_description></div> </div> </uib-accordion> <p>To start using the latest version, <strong>refresh your browser now</strong>.</p> </div> <div class=modal-footer> <button class=\"button large shop-solid\" ng-click=$ctrl.reloadBrowser()>Refresh your browser</button> </div> ";

/***/ }),

/***/ "./components/app-version/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/app-version/app-version.component.js");

__webpack_require__("./components/app-version/app-version.controller.js");

__webpack_require__("./components/app-version/app-version.service.js");

/***/ }),

/***/ "./components/appointments-list/_appointments-list.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509242
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/appointments-list/appointments-list.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAppointmentsList = {
  controller: 'AppointmentsListController',
  template: __webpack_require__("./components/appointments-list/appointments-list.template.html"),
  bindings: {
    $transition$: '<',
    appointments: '<'
  }
};

angular.module('inkfinder').component('inkAppointmentsList', inkAppointmentsList);

/***/ }),

/***/ "./components/appointments-list/appointments-list.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AppointmentsListController.$inject = ['STATUS', 'SORTOPTIONS', 'Appointments', 'MergeProjects', '$document', '$state', 'Session', '_'];


/**
 * @name AppointmentsListController
 * @description Controller for the appointments list component
 * @param {constant} STATUS The STATUS constant
 * @param {constant} SORTOPTIONS The SORTOPTIONS constant
 * @param {object} Appointments The appointments service
 * @param {object} MergeProjects The merge projects service
 * @param {unknown} $document unknown
 * @param {unknown} $state unknown
 * @param {object} Session The user session service
 * @param {unknown} _ The lodash service
 */
function AppointmentsListController(STATUS, SORTOPTIONS, Appointments, MergeProjects, $document, $state, Session, _) {
  var vm = this;

  // Public functions
  vm.resetSearch = resetSearch;
  vm.searchTermsUpdated = searchTermsUpdated;
  vm.uiOnParamsChanged = uiOnParamsChanged;
  vm.loadPage = loadPage;
  vm.session = Session;

  // Public variabls
  vm.statusOptions = STATUS;
  vm.sortOptions = SORTOPTIONS;
  vm.loading = false;

  // Appointments are loaded in the state resolve.

  // Load search parameters from the params in the state defintion.
  vm.search = {
    page: vm.$transition$.params().page,
    status: vm.$transition$.params().status,
    sort: vm.$transition$.params().sort,
    search: vm.$transition$.params().search
  };

  /**
   * @name searchTermsUpdated
   * @description Function to update the URL parameters by calling $state.go.
   * '.' calls the current state and loads new params based on changes in the
   * view form.
   */
  function searchTermsUpdated() {
    vm.search.page = '1';
    $state.go('.', vm.search, { reload: true });
  }

  /**
   * @name uiOnParamsChanged
   * @description A ui-router function callback when param values change.
   * @param {object} newParams The name of the param that changed and its new value
   */
  function uiOnParamsChanged(newParams) {
    _.assign(vm.search, newParams);
    if (!_.isUndefined(newParams.status) || !_.isUndefined(newParams.sort) || !_.isUndefined(newParams.search)) {
      vm.search.page = '1';
    }
    $state.go('.', vm.search, { reload: true });
  }

  /**
   * @name loadPage
   * @description Updates the page number in vm.search and calls $state.go to
   * update the URL with the new page number.
   * @param {number} page The new page number.
   */
  function loadPage(page) {
    vm.search.page = page.toString();
    $state.go('.', vm.search, { reload: true });
  }

  /**
    * @name resetSearch
    * @description Remove the text input field value to trigger the watcher on
    * local variable
    */
  function resetSearch() {
    vm.search.search = '';
    vm.search.page = '1';
    $state.go('.', vm.search, { reload: true });
  }
}

angular.module('inkfinder').controller('AppointmentsListController', AppointmentsListController);

/***/ }),

/***/ "./components/appointments-list/appointments-list.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=appointments class=\"section photo background-dark\"> <div class=background-photo></div> <div class=container-fluid> <div class=row> <div class=col-sm-12> <div class=intro> <h6 class=\"no-margin center\">{{$ctrl.session.activeState.association.shop.name}}</h6> <h1 class=center>Appointments.</h1> <form name=searchClients novalidate> <div class=row> <div class=\"col-md-2 col-md-offset-3\"> <label><strong>Status</strong></label><br/> <select class=\"select small inline\" ng-options=\"status as status for status in $ctrl.statusOptions\" ng-model=$ctrl.search.status ng-change=$ctrl.searchTermsUpdated() title=Status> </select> </div> <div class=col-md-2> <label><strong>Sort</strong></label><br/> <select class=\"select small inline\" ng-options=\"sort as sort for sort in $ctrl.sortOptions\" ng-model=$ctrl.search.sort ng-change=$ctrl.searchTermsUpdated() title=Sort> </select> </div> <div class=col-md-2> <label><strong>Search</strong></label><br/> <input name=search id=search type=text autocapitalize=off placeholder=\"Search terms\" class=\"form-control small inline\" ng-model=$ctrl.search.search uib-tooltip=\"Enter a name, email, or phone number.\" ng-model-options=\"{ debounce: 1000 }\" ng-change=$ctrl.searchTermsUpdated()> </div> </div> <button type=button class=\"button small gray\" ng-if=$ctrl.search.search ng-click=$ctrl.resetSearch()>Reset</button> </form> </div> </div> </div> <div class=row ng-if=\"$ctrl.appointments.count === 0\"> <div class=\"col-sm-12 center\"> <p ng-if=\"$ctrl.loading === false\">I didn't find any appointments with {{$ctrl.search.status | lowercase}} status<span ng-if=$ctrl.search.search> using “{{$ctrl.search.search}}”</span>.</p> </div> </div> <div class=row ng-if=\"$ctrl.appointments.count > 0\"> <div class=\"col-sm-12 center no-padding\"> <div class=\"list projects\"> <div class=project-group dir-paginate=\"dateGroup in $ctrl.appointments.dateGroups | itemsPerPage: 10 track by $index\" total-items=$ctrl.appointments.count current-page=$ctrl.search.page> <div class=smal-col-12> <h6>{{dateGroup.date}}</h6> <div class=\"divider small tight\"></div> </div> <a class=\"item project link\" ui-sref=inkfinder.appointments.details({appointment_id:card.appointment.id}) ng-repeat=\"card in dateGroup.appointments track by $index\"> <ink-project-card card=card color=\"'finder'\"></ink-project-card> </a> </div> </div> </div> <div class=\"col-sm-12 center\"> <dir-pagination-controls max-size=7; on-page-change=$ctrl.loadPage(newPageNumber) ng-disabled=$ctrl.loading> </dir-pagination-controls> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/appointments-list/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments-list/appointments-list.component.js");

__webpack_require__("./components/appointments-list/appointments-list.controller.js");

__webpack_require__("./components/appointments-list/_appointments-list.styles.scss");

var _groupApptsByDate = __webpack_require__("./utils/group-appts-by-date.js");

var _groupApptsByDate2 = _interopRequireDefault(_groupApptsByDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.appointments-list', {
    url: '/appointments-list?page&status&sort&search',
    views: {
      '@': {
        component: 'inkAppointmentsList'
      }
    },
    params: {
      page: {
        value: '1',
        dynamic: true
      },
      status: {
        value: 'All types of',
        dynamic: true
      },
      sort: {
        value: 'Appointment date',
        dynamic: true
      },
      search: {
        value: '',
        dynamic: true
      }
    },
    resolve: {
      $title: function $title() {
        return 'Appointments List';
      },
      appointments: ['$stateParams', 'Appointments', 'MergeProjects', '$document', function appointments($stateParams, Appointments, MergeProjects, $document) {
        var search = $stateParams;
        return Appointments.get(search).then(function (appointments) {
          if (appointments.results.length > 0) {
            return MergeProjects.merge(appointments.results).then(function (mergedData) {
              appointments.results = mergedData;
              var top = 0;
              var duration = 500; // milliseconds
              $document.scrollTop(top, duration);
              appointments.dateGroups = (0, _groupApptsByDate2.default)(appointments.results);
              return appointments;
            });
          }
          appointments.results = [];
          var top = 0;
          var duration = 500; // milliseconds
          $document.scrollTop(top, duration);
          appointments.dateGroups = (0, _groupApptsByDate2.default)(appointments.results);
          return appointments;
        });
      }]
    },
    bindings: {
      $transition$: '<',
      appointments: '<'
    },
    data: {
      authorizedRoles: [USER_ROLES.operator, USER_ROLES.artist]
    }
  });
}]);

/***/ }),

/***/ "./components/appointments/_appointments-legend.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509292
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/appointments/_appointments.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509762
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/appointments/add/appointment-add-workflow.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _findDuplicateAssociation = __webpack_require__("./utils/find-duplicate-association.js");

var _findDuplicateAssociation2 = _interopRequireDefault(_findDuplicateAssociation);

var _groupApptsByDate = __webpack_require__("./utils/group-appts-by-date.js");

var _groupApptsByDate2 = _interopRequireDefault(_groupApptsByDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('inkfinder').controller('AppointmentAddWorkflowController', ['$state', 'filterFilter', 'StyleFactory', 'Project', 'Projects', 'Appointments', 'Artists', 'Collector', 'Appointment', 'FormatAppointment', 'MergeProjects', 'AppointmentAddFactory', 'Association', 'NOTIFICATIONS', 'AlertMessages', 'Notification', 'InvitationFactory', 'Session', 'moment', '_', function AppointmentAddWorkflowController($state, filterFilter, StyleFactory, Project, Projects, Appointments, Artists, Collector, Appointment, FormatAppointment, MergeProjects, AppointmentAddFactory, Association, NOTIFICATIONS, AlertMessages, Notification, InvitationFactory, Session, moment, _) {
  var vm = this;

  // Public Functions
  vm.searchCollectors = searchCollectors;
  vm.selectCollector = selectCollector;
  vm.createCollector = createCollector;
  vm.startOver = startOver;
  vm.saveProject = saveProject;
  vm.session = Session;
  startOver(); // Reset everything
  getOptions(); // Get options for the creation project function

  /**
  * @name searchCollectors
  * @description Search for a collector by searching collector object phone and
  * email fields
  * @param {object} query The search criteria
  */
  function searchCollectors(query) {
    var searchFields = 'phone,email';
    Collector.searchCollectors(query, searchFields).then(function (collectors) {
      vm.collectors = collectors;
      $state.go('inkfinder.appointments.add.collector-select');
    });
  }

  /**
  * @name createCollector
  * @description Create a collector
  * @param {object} form The entire form object
  */
  function createCollector() {
    Collector.createCollector(vm.newCollector).then(function (collector) {
      sendInvitation(collector);
    }, function () {
      vm.createCollectorForm.$submitted = false;
    });
  }

  /**
  * @name sendInvitation
  * @description Function to send invitation after a collector is created.
  * @param {type} collector The collector to send the invitation to
  */
  function sendInvitation(collector) {
    var id = collector.id;
    Collector.getCollector(id).then(function (collector) {
      vm.selectedCollector = collector;

      /**
      * @name createInvitation
      * @description Define the function to create invitations and define
      * the invitation object
      * @param {type} association Description
      * @return {type} Description
      */
      function createInvitation(association) {
        var invitation = {
          collectorId: association.collector.id,
          shopId: association.shop.id,
          associationId: association.id
        };
        return InvitationFactory.createInvitation(invitation);
      }

      /**
      * @name sendNotification
      * @description Define the function to send notifications and define
      * the notification object
      * @param {type} invitation Description
      */
      function sendNotification(invitation) {
        var notification = {
          recipients: [invitation.collector.id],
          notificationId: NOTIFICATIONS.collectorWelcome,
          messageObjects: {
            invitationId: invitation.id,
            // The logged in artist or operator
            operatorId: Session.collector.id
          },
          messageVariables: {
            subject: invitation.collector.first_name + ', ' + vm.session.collector.first_name + ' ' + vm.session.collector.last_name + ' invited you to collaborate on Ink Finder'
          }
        };
        if (vm.session.activeState.association.shop.id) {
          notification.messageObjects.shopId = vm.session.activeState.association.shop.id;
          notification.messageVariables.subject = vm.selectedCollector.first_name + ', ' + vm.session.collector.first_name + ' ' + vm.session.collector.last_name + ' at ' + vm.session.activeState.association.shop.name + ' invited you to collaborate on Ink Finder';
        }
        Notification.send(notification);
      }

      // Must create a new association
      var type = 'Collector';
      var _association = {
        collector_id: collector.id,
        shop_id: vm.session.activeState.association.shop.id,
        status: 'Shop Invited',
        startDatetime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        endDatetime: null,
        can_update_appts: true
      };
      Association.createAssociation(type, _association).then(createInvitation).then(sendNotification).catch(function (_association) {
        AlertMessages.add({
          msg: 'We tried to save this invitation, but something failed. Please try again.',
          type: 'danger'
        });
      });
      $state.go('inkfinder.appointments.add.project-create');
    });
  }

  /**
  * @name selectCollector
  * @description Select a collector and return any appointments for this shop.
  * @param {object} collector The collector to select.
  */
  function selectCollector(collector) {
    vm.selectedCollector = collector;

    /**
    * @name createInvitation
    * @description Define the function to create invitations and define the
    * invitation object
    * @param {type} association Description
    * @return {type} Description
    */
    function createInvitation(association) {
      var invitation = {
        collectorId: association.collector.id,
        shopId: association.shop.id,
        associationId: association.id
      };
      return InvitationFactory.createInvitation(invitation);
    }

    /**
    * @name sendNotification
    * @description Define the function to send notifications and define the
    * notification object
    * @param {type} invitation Description
    */
    function sendNotification(invitation) {
      var notification = {
        recipients: [invitation.collector.id],
        notificationId: NOTIFICATIONS.collectorWelcome,
        messageObjects: {
          invitationId: invitation.id,
          operatorId: Session.collector.id // The logged in artist or operator
        },
        messageVariables: {
          subject: invitation.collector.first_name + ', ' + vm.session.collector.first_name + ' ' + vm.session.collector.last_name + ' invited you to collaborate on Ink Finder'
        }
      };
      if (vm.session.activeState.association.shop.id) {
        notification.messageObjects.shopId = vm.session.activeState.association.shop.id;
        notification.messageVariables.subject = vm.selectedCollector.first_name + ', ' + vm.session.collector.first_name + ' ' + vm.session.collector.last_name + ' at ' + vm.session.activeState.association.shop.name + ' invited you to collaborate on Ink Finder';
      }
      Notification.send(notification);
    }

    // Check for duplicate associations for this shop and collector
    var shopToCheck = Session.activeState.association.shop.id;
    var typeToCheck = 'Collector';
    var duplicateAssociations = (0, _findDuplicateAssociation2.default)(vm.selectedCollector.associations, shopToCheck, typeToCheck);
    if (!duplicateAssociations) {
      // Must create a new association
      var type = 'Collector';
      var _association = {
        collector_id: vm.selectedCollector.id,
        shop_id: vm.session.activeState.association.shop.id,
        status: 'Shop Invited',
        startDatetime: moment().format('YYYY-MM-DDTHH:mm:ss'),
        endDatetime: null,
        can_update_appts: true
      };
      Association.createAssociation(type, _association).then(createInvitation).then(sendNotification).catch(function (_association) {
        AlertMessages.add({
          msg: 'We tried to save this invitation, but something failed. Please try again.',
          type: 'danger'
        });
      });
    }

    var search = false;
    var start = void 0;
    var end = void 0;
    var timestamp = void 0;
    var artist = void 0;
    Appointments.get(search, start, end, timestamp, artist, vm.selectedCollector.id).then(function (appointments) {
      if (appointments.length > 0) {
        MergeProjects.merge(appointments).then(function (mergedData) {
          vm.collectorAppointments = (0, _groupApptsByDate2.default)(mergedData);
          // If the selected collector has projects, go to project select.
          // If not, go to project create.
          $state.go('inkfinder.appointments.add.project-select');
        });
      } else {
        // Get options for the creation project function
        getOptions();
        $state.go('inkfinder.appointments.add.project-create');
      }
    });
  }

  /**
  * @description Select the Size
  */
  vm.process_size = function () {
    vm.newProject.size = filterFilter(vm.options.sizes, {
      id: vm.selected_options.size
    })[0];
  };

  /**
  * @name getOptions
  * @description Get the Size/Placement/Area/Style Options
  */
  function getOptions() {
    Project.getOptions().then(function (options) {
      vm.options = options;
    });

    StyleFactory.getStyles().then(function (styles) {
      vm.styles = styles;
    });
  }

  /**
  * @name saveProject
  * @description Function to create a new project.
  * @param {object} newProject The project to be created.
  */
  function saveProject(newProject) {
    vm.data = {};
    // Assemble the missing Project Data
    newProject.collector = vm.selectedCollector.id;
    newProject.referenceImages = vm.referenceImages;
    newProject.coverupImages = vm.coverupImages;
    Project.create(newProject).then(function (project) {
      vm.data.project = project;
      var newAppointment = {
        project_id: project.id
      };
      return Appointment.create(newAppointment);
    }).then(function (appointment) {
      vm.data.appointment = appointment;
      AppointmentAddFactory.data = vm.data;

      // Send a notification to the collector when a project is created.
      var notification = {
        recipients: [vm.selectedCollector.id],
        notificationId: NOTIFICATIONS.projectCreated,
        messageObjects: {
          // The collector that created the project
          collectorId: vm.session.collector.id,
          projectId: vm.data.project.id
        },
        messageVariables: {
          subject: vm.selectedCollector.first_name + ', ' + vm.session.collector.first_name + ' ' + vm.session.collector.last_name + ' started a project for you on Ink Finder'
        }
      };
      if (vm.session.activeState.association.shop.id) {
        notification.messageObjects.shopId = vm.session.activeState.association.shop.id;
        notification.messageVariables.subject = vm.selectedCollector.first_name + ', ' + vm.session.collector.first_name + ' ' + vm.session.collector.last_name + ' at ' + vm.session.activeState.association.shop.name + ' started a project for you on Ink Finder';
      }
      Notification.send(notification);
      $state.go('inkfinder.appointments.add.update');
    }).catch(function (error) {
      // Error handling for project and appointment create goes here
    });
  }

  /**
  * @name startOver
  * @description Reset any data retrieved or saved in the add artist workflow
  * @param {boolean} transition Boolean to determine if the function should
  * change state to the starting point.
  */
  function startOver(transition) {
    // Collectors
    vm.collectors = [];
    vm.selectedCollector = {};
    vm.newCollector = {};
    vm.collectorAppointments = {};

    // Projects
    vm.newProject = {};
    vm.referenceImages = [];
    vm.coverupImages = [];
    vm.project = {}; // Result after submitting Project

    if (transition) {
      $state.go('inkfinder.appointments.add.collector');
    }
  }

  // Call the startOver function if a collector hasn't been selected later on
  // in the process
  if (!vm.selectedCollector.length) {
    startOver(true);
  }
  return vm;
}]);

/***/ }),

/***/ "./components/appointments/add/appointment-add.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').controller('AppointmentAddController', ['$state', 'Appointment', 'Messages', 'Payments', 'AppointmentAddFactory', 'moment', 'AlertMessages', 'MergeProjects', 'NOTIFICATIONS', 'Notification', 'Session', 'Participants', '_', 'collectorWantsNotif', function AppointmentAddController($state, Appointment, Messages, Payments, AppointmentAddFactory, moment, AlertMessages, MergeProjects, NOTIFICATIONS, Notification, Session, Participants, _, collectorWantsNotif) {
  var vm = this;
  vm.data = AppointmentAddFactory.data;
  vm.session = Session;

  if (Object.keys(vm.data.appointment).length) {
    vm.data.appointment = {
      id: vm.data.appointment.id,
      previously_paid: false,
      deposit_required: true,
      artist: {}
    };
  }

  // Exposed Functions
  vm.saveAppointment = saveAppointment;

  // Defaults
  vm.accordions = {};
  vm.message = {
    content: null,
    private: false
  };
  vm.payment_form = {
    payment_datetime: moment().toDate(),
    is_tip: false
  };

  // Get Payment Types
  Payments.getTypes().then(function (types) {
    vm.payment_types = types;
  });

  /**
   * @name saveAppointment
   * @description Function to save the Appointment
   * @param {type} status description
   */
  function saveAppointment(status) {
    Appointment.update(vm.data.appointment, status).then(function (appointment) {
      // Create a participant for the artist, if one exists
      var conversationId = appointment.conversations;
      Participants.get(conversationId).then(function (participants) {
        var artistParticipant = _.find(participants, function (participant) {
          if (appointment.artist && participant.collector === appointment.artist.id) {
            return true;
          }
        });
        if (!artistParticipant && appointment.artist) {
          var preparedParticipant = {
            role: Session.activeState.role,
            conversation_id: conversationId,
            collector_id: appointment.artist.id,
            appointment_id: appointment.id
          };
          Participants.create(preparedParticipant);
        }
      });

      // Merge the project/appointment
      var appointmentArray = [];
      appointmentArray[0] = appointment;
      MergeProjects.merge(appointmentArray).then(function (mergedAppointment) {
        vm.data = mergedAppointment[0];

        // Send email notifications to artists and collectors
        // Check to see if we have the appropriate data on the appointment
        if ((vm.data.appointment.estimate_min && vm.data.appointment.estimate_max || vm.data.appointment.previously_paid) && vm.data.appointment.artist && vm.data.appointment.appointment_datetime) {
          var notificationCollector = {};
          var notificationArtist = {};

          // If the appointment is unconfirmed, send the estimate notification
          if (vm.data.appointment.last_status.status_name === 'Unconfirmed') {
            // Collector notification
            notificationCollector = {
              recipients: [vm.data.project.collector.id],
              notificationId: NOTIFICATIONS.collectorEstimate,
              messageObjects: {
                appointmentId: vm.data.appointment.id,
                projectId: vm.data.project.id,
                collectorId: vm.data.project.collector.id, // The operator sending the estimate
                operatorId: Session.collector.id, // The operator sending the estimate
                artistId: vm.data.appointment.artist.id // The artist assigned to the appointment
              },
              messageVariables: {
                subject: vm.data.project.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' sent you an estimate for your project on Ink Finder'
              }
            };

            // If the logged in user is an operator
            if (Session.activeState.association.shop.id) {
              notificationCollector.messageObjects.shopId = Session.activeState.association.shop.id;
              notificationCollector.messageVariables.subject = vm.data.project.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' at ' + Session.activeState.association.shop.name + ' sent you an estimate for your project on Ink Finder';
            }

            // Artist notification
            notificationArtist = {
              recipients: [vm.data.appointment.artist.id],
              notificationId: NOTIFICATIONS.artistEstimate,
              messageObjects: {
                appointmentId: vm.data.appointment.id,
                projectId: vm.data.project.id,
                collectorId: vm.data.project.collector.id,
                operatorId: Session.collector.id, // The operator sending the estimate
                artistId: vm.data.appointment.artist.id // The artist assigned to the appointment
              },
              messageVariables: {
                subject: vm.data.appointment.artist.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' at ' + Session.activeState.association.shop.name + ' sent an estimate for an appointment with ' + vm.data.project.collector.first_name + ' ' + vm.data.project.collector.last_name + ' on Ink Finder'
              }
            };

            if (Session.activeState.association.shop.id) {
              notificationArtist.messageObjects.shopId = Session.activeState.association.shop.id;
            }

            // Only send artist notifications if the artist isn't the one
            // creating the appointment and they want to receive the email
            collectorWantsNotif.check(appointment.artist.id, appointment.shop, 'appointment_estimated', 'artist').then(function (collectorWantsNotif) {
              if (Session.collector.id !== vm.data.appointment.artist.id && collectorWantsNotif) {
                Notification.send(notificationArtist);
              }
            });

            // If the appointment is confirmed, send the confirmed notification
          } else if (vm.data.appointment.last_status.status_name === 'Confirmed') {
            // Collector notification
            notificationCollector = {
              recipients: [vm.data.project.collector.id],
              notificationId: NOTIFICATIONS.appointmentConfirmedByOperatorOrArtist,
              messageObjects: {
                appointmentId: vm.data.appointment.id,
                projectId: vm.data.project.id,
                collectorId: vm.data.project.collector.id, // The collector who owns the project
                operatorId: Session.collector.id, // The logged in operator or artist
                artistId: vm.data.appointment.artist.id // The artist assigned to the appointment
              },
              messageVariables: {
                subject: vm.data.project.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' confirmed an appointment for your project on Ink Finder'
              }
            };

            // If the logged in user is an operator
            if (Session.activeState.association.shop.id) {
              notificationCollector.messageObjects.shopId = Session.activeState.association.shop.id;
              notificationCollector.messageVariables.subject = vm.data.project.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' at ' + Session.activeState.association.shop.name + ' confirmed an appointment for your project on Ink Finder';
            }

            // Artist notification
            notificationArtist = {
              recipients: [vm.data.appointment.artist.id],
              notificationId: NOTIFICATIONS.artistConfirmed,
              messageObjects: {
                appointmentId: vm.data.appointment.id,
                projectId: vm.data.project.id,
                collectorId: vm.data.project.collector.id, // The collector who owns the project
                operatorId: Session.collector.id, // The operator updating the appointment
                artistId: vm.data.appointment.artist.id // The artist assigned to the appointment
              },
              messageVariables: {
                subject: vm.data.appointment.artist.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' at ' + Session.activeState.association.shop.name + ' confirmed your appointment with ' + vm.data.project.collector.first_name + ' ' + vm.data.project.collector.last_name + ' on Ink Finder'
              }
            };

            if (Session.activeState.association.shop.id) {
              notificationArtist.messageObjects.shopId = Session.activeState.association.shop.id;
            }

            // Only send artist notifications if the artist isn't the one
            // creating the appointment and they want to receive the email
            collectorWantsNotif.check(appointment.artist.id, appointment.shop, 'appointment_confirmed', 'artist').then(function (collectorWantsNotif) {
              if (Session.collector.id !== vm.data.appointment.artist.id && collectorWantsNotif) {
                Notification.send(notificationArtist);
              }
            });
          }

          // Send the notification
          Notification.send(notificationCollector);
        }

        // If Payment Fields are filled out
        if (vm.accordions.payment && vm.payment_form.amount && vm.payment_form.payment_type && vm.payment_form.payment_datetime) {
          vm.payment_form.status = 1;
          vm.payment_form.appointment_id = vm.data.appointment.id;
          vm.payment_form.collector_id = appointment.collector;
          Payments.create(vm.payment_form).then(function (response) {
            // Intentionally blank
          }, function (error) {
            AlertMessages.add({
              msg: 'We couldn’t save the payment right now, try adding it to the appointment later.',
              type: 'danger'
            });
          });
        }
        // Send a message to the shop team
        if (vm.message.content !== null && vm.message.content.replace(/\s/g, '').length) {
          var message = {
            content: vm.message.content,
            cid: appointment.conversations,
            private: vm.message.private
          };
          Messages.create(message);
        }
        $state.go('inkfinder.appointments.add.complete');
      });
    }, function (response) {
      AlertMessages.add({
        msg: 'There was a problem updating this appointment.',
        type: 'danger' });
    });
  }
}]);

/***/ }),

/***/ "./components/appointments/add/appointment-add.factory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('AppointmentAddFactory', function AppointmentAddFactory() {
  // Public variables
  AppointmentAddFactory.data = {};
  return AppointmentAddFactory;
});

/***/ }),

/***/ "./components/appointments/add/appointment-complete.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"intro center\"> <h1><fa name=check></fa></h1> <h5 class=finder-color>You’re all set.</h5> <p>View the new appoinment below or add another one.</p> <div class=\"list projects\" ng-if=$ctrl.data> <a class=\"item project link\" ui-sref=\"inkfinder.appointments.details({appointment_id: $ctrl.data.appointment.id})\"> <ink-project-card card=$ctrl.data></ink-project-card> </a> <a class=\"item project add\" ng-click=$ctrl.startOver(true)> <div class=project-background> <div class=button-add> <button type=button title=\"Add another appointment\" class=\"button circle\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> <small>Add another appointment</small> </div> </div> </a> </div> </div> ";

/***/ }),

/***/ "./components/appointments/add/appointment-update.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"intro center\"> <h1>Set the appointment.</h1> <h5 class=finder-color>Get in touch to set the appointment.</h5> </div> <div class=row> <div class=col-md-12> <div class=\"list projects\" ng-if=$ctrl.data> <div class=\"item project\"> <ink-project-card card=$ctrl.data show-artist=false></ink-project-card> </div> </div> </div> <div class=\"col-lg-10 col-lg-offset-1 col-md-12\"> <h6 class=center>Choose an option below.</h6> <uib-accordion class=\"accordion large\"> <div uib-accordion-group> <uib-accordion-heading> <div class=checkmark></div> <h5>Wait. I need more info about this tattoo.</h5> <p>Send a question to {{$ctrl.selectedCollector.first_name}} to get more details about this tattoo.</p> </uib-accordion-heading> <ink-need-more-form></ink-need-more-form> </div> <div uib-accordion-group> <uib-accordion-heading> <div class=checkmark></div> <h5>Create an <strong>unconfirmed</strong> appointment for this tattoo.</h5> <p>Send an estimate and tentative appointment date and time to {{$ctrl.selectedCollector.first_name}} to confirm.</p> </uib-accordion-heading> <ink-unconfirmed-form></ink-unconfirmed-form> </div> <div uib-accordion-group> <uib-accordion-heading> <div class=checkmark></div> <h5>Create a <strong>confirmed</strong> appointment for this tattoo.</h5> <p>Add a confirmed apointment for this tattoo for {{$ctrl.selectedCollector.first_name}} and the artist.</p> </uib-accordion-heading> <ink-confirmed-form></ink-confirmed-form> </div> </uib-accordion> <div class=center> <span class=\"inline-alert finder small\" ng-if=$ctrl.selectedCollector.email_is_confirmed> <fa name=thumbs-up></fa> {{$ctrl.selectedCollector.first_name}} will get an email notification about this appointment. </span> <span class=\"inline-alert warning small\" ng-if=!$ctrl.selectedCollector.email_is_confirmed> <fa name=thumbs-up></fa> {{$ctrl.selectedCollector.first_name}} hasn't confirmed their email address, but they will still get an email about this appointment. </span> </div> </div> </div> ";

/***/ }),

/***/ "./components/appointments/add/collector-create.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"intro center\"> <h1>Add a client.</h1> <h5>Create an Ink Finder account for your client.</h5> </div> <div class=row> <div class=\"col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 center\"> <form name=$ctrl.createCollectorForm class=left ng-submit=\"$ctrl.createCollectorForm.$valid && $ctrl.createCollector()\" novalidate> <div class=form-group> <label for=first_name>First name</label> <input name=first_name id=first_name type=text class=form-control placeholder=Darth required ng-model=$ctrl.newCollector.first_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"$ctrl.createCollectorForm.first_name.$invalid && !$ctrl.createCollectorForm.first_name.$pristine\"> We need a first name! </p> </div> </div> <div class=form-group> <label for=last_name>Last name</label> <input name=last_name id=last_name type=text class=form-control placeholder=Vader required ng-model=$ctrl.newCollector.last_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"$ctrl.createCollectorForm.last_name.$invalid && !$ctrl.createCollectorForm.last_name.$pristine\"> We need a last name! </p> </div> </div> <div class=form-group> <label for=email>Email</label> <input name=email id=email type=email class=form-control placeholder=vader@deathstar.com required ng-model=$ctrl.newCollector.email> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"$ctrl.createCollectorForm.email.$invalid && !$ctrl.createCollectorForm.email.$pristine\"> Hmm...I don’t think that's a real email address. </p> </div> </div> <div class=form-group> <label for=phone>Phone <small>Optional</small></label> <input name=phone id=phone placeholder=\"(555) 555–1234\" mask=\"(999) 999-9999\" clean=true restrict=reject type=text ng-model=$ctrl.newCollector.phone> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"$ctrl.createCollectorForm.phone.$invalid && !$ctrl.createCollectorForm.phone.$pristine\"> You won’t be talking to anyone with that number. </p> </div> </div> <div class=\"inline-alert warning\"> When you add a client, they will receive an email invitation to accept your invitation to Ink Finder. </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=\"$ctrl.createCollectorForm.$invalid || $ctrl.createCollectorForm.$submitted\">Add client</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.startOver(true)>Start Over</button> </div> </form> </div> </div> ";

/***/ }),

/***/ "./components/appointments/add/collector-search-add.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"intro center\"> <h1>Add an appointment.</h1> <h5>Search for an existing client or add a new one.</h5> </div> <div class=row> <div class=\"col-sm-5 col-sm-offset-1\"> <h6 class=left>Search for an existing client on Ink Finder</h6> <form name=searchCollectors ng-submit=\"searchCollectors.$valid && $ctrl.searchCollectors(query)\" novalidate> <div class=form-group> <label for=search>Enter an email or phone number</label> <input name=search id=search type=text autocapitalize=off placeholder=\"Email or phone number\" class=form-control required ng-init=\"query = ''\" ng-model=query ng-keyup=\"$event.keyCode === 13 && searchCollectors.$invalid\"> </div> <div class=button-container> <button class=\"button large shop-solid\" type=submit ng-disabled=searchCollectors.$invalid>Search</button> </div> </form> </div> <div class=\"col-sm-6 center\"> <h6 class=center>Add a new client</h6> <div class=\"button-add no-margin\" ui-sref=inkfinder.appointments.add.collector-create> <button class=\"button circle\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> </div> </div> </div> ";

/***/ }),

/***/ "./components/appointments/add/collector-select.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"intro center\" ng-if=\"$ctrl.collectors.length > 0\"> <h1>Recognize anyone?</h1> <h5>Select your client below, <a ui-sref=inkfinder.appointments.add.collector-create> create a new client </a> or <a ng-click=$ctrl.startOver(true)> search again. </a> </h5> </div> <div class=\"intro center\" ng-if=\"$ctrl.collectors.length === 0\"> <h1>We couldn't find anyone...</h1> <h5> <a ui-sref=inkfinder.appointments.add.collector-create> Create a new client </a> or <a ng-click=$ctrl.startOver(true)> search again </a> </h5> </div> <div ng-if=\"$ctrl.collectors.length > 0\" class=center> <div class=\"list profiles\"> <div class=\"item profile\" ng-repeat=\"collector in $ctrl.collectors\"> <ink-profile-photo profile=collector linkable=true image-id=collector.profile_photo click=$ctrl.selectCollector(collector)></ink-profile-photo> </div> </div> </div> ";

/***/ }),

/***/ "./components/appointments/add/confirmed-form/confirmed-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkConfirmedForm = {
  template: __webpack_require__("./components/appointments/add/confirmed-form/confirmed-form.template.html")
};

angular.module('inkfinder').component('inkConfirmedForm', inkConfirmedForm);

/***/ }),

/***/ "./components/appointments/add/confirmed-form/confirmed-form.template.html":
/***/ (function(module, exports) {

module.exports = " <form name=confirmedAppointmentForm ng-controller=\"AppointmentAddController as AppointmentAddController\" ng-submit=\"confirmedAppointmentForm.$valid && AppointmentAddController.saveAppointment(50)\" novalidate> <ink-availability appointment=AppointmentAddController.data.appointment type=\"'full'\"></ink-availability> <div class=row> <div class=col-md-12> <div class=\"divider small tight\"></div> <div class=form-group> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': AppointmentAddController.data.appointment.previously_paid === false}\"> <input type=radio name=estimate_or_previously_paid id=estimate ng-model=AppointmentAddController.data.appointment.previously_paid ng-value=false> Estimate this appointment </label> <label class=\"btn btn-default\" ng-class=\"{'active': AppointmentAddController.data.appointment.previously_paid === true}\"> <input type=radio name=estimate_or_previously_paid id=previously-paid ng-model=AppointmentAddController.data.appointment.previously_paid ng-value=true> Mark as previously paid </label> </div> </div> </div> </div> </div> <div class=row ng-if=!AppointmentAddController.data.appointment.previously_paid> <div class=col-md-12> <p>Estimate range</p> </div> <div class=col-md-6> <div class=\"form-group no-margin-bottom\"> <label for=estimate_min>From</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=estimate_min id=estimate_min type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=AppointmentAddController.data.appointment.estimate_min> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"confirmedAppointmentForm.estimate_min.$invalid && !confirmedAppointmentForm.estimate_min.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> <div class=col-md-6> <div class=\"form-group no-margin-bottom\"> <label for=estimate_max>To</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=estimate_max id=estimate_max type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=AppointmentAddController.data.appointment.estimate_max> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"confirmedAppointmentForm.estimate_max.$invalid && !confirmedAppointmentForm.estimate_max.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> <div class=col-md-12> <div class=\"divider small tight\"></div> <div class=form-group> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': AppointmentAddController.data.appointment.deposit_required === true}\"> <input type=radio name=deposit_required id=true ng-model=AppointmentAddController.data.appointment.deposit_required ng-value=true> Set a deposit amount </label> <label class=\"btn btn-default\" ng-class=\"{'active': AppointmentAddController.data.appointment.deposit_required === false}\"> <input type=radio name=deposit_required id=false ng-model=AppointmentAddController.data.appointment.deposit_required ng-value=false> No deposit required </label> </div> </div> </div> </div> <div ng-if=AppointmentAddController.data.appointment.deposit_required> <div class=col-md-12> <p>Deposit amount</p> </div> <div class=col-md-6> <div class=\"form-group no-margin-bottom\"> <div class=input-group> <span class=input-group-addon>$</span> <input name=deposit_amount id=deposit_amount type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=AppointmentAddController.data.appointment.deposit_amount> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"unconfirmedAppointmentForm.deposit_amount.$invalid && !unconfirmedAppointmentForm.deposit_amount.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> </div> <div class=col-md-12> <div class=\"divider small tight\"></div> <uib-accordion class=\"accordion inline-accordion\"> <div uib-accordion-group is-open=AppointmentAddController.accordions.payment> <uib-accordion-heading> <div class=heading> <h6 class=headline><fa name=money class=\"icon medium\"></fa> Add a payment for this appointment <small>Optional</small></h6> </div> </uib-accordion-heading> <div class=row> <div class=col-md-12> <div class=form-group> <label> <input name=is_deposit type=checkbox ng-model=AppointmentAddController.payment_form.is_deposit> This is a deposit </label> </div> </div> <div class=col-md-6> <div class=form-group> <label for=payment_datetime>Date</label> <div class=input-group> <input name=payment_datetime id=payment_datetime type=text class=form-control uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-required=AppointmentAddController.accordions.payment ng-model=AppointmentAddController.payment_form.payment_datetime placeholder=MM/DD/YYYY is-open=update.date_picker.date_open min-date=minDate max-date=maxDate datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"update.date_picker.date_open = !update.date_picker.date_open\"> <fa name=calendar-o></fa> </button> </span> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"addPaymentForm.payment_datetime.$invalid && !addPaymentForm.payment_datetime.$pristine\"> We need a date here. </p> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=payment_types>Select a source</label> <select name=payment_types id=payment_types ng-required=AppointmentAddController.accordions.payment ng-model=AppointmentAddController.payment_form.payment_type ng-value=option value=option ng-options=\"option.name for option in AppointmentAddController.payment_types track by option.id\"> <option value=\"\">Choose one</option> </select> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"addPaymentForm.payment_types.$invalid && !addPaymentForm.payment_types.$pristine\"> How did they pay you? </p> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=amount>Amount</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=amount id=amount type=text class=form-control ng-model=AppointmentAddController.payment_form.amount min=.01 fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" ng-required=AppointmentAddController.accordions.payment> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"addPaymentForm.amount.$invalid && !addPaymentForm.amount.$pristine\"> Help, I need a valid number! </p> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=receipt>Receipt #</label> <input name=receipt id=receipt type=text class=form-control ng-model=AppointmentAddController.payment_form.receipt> </div> </div> </div> </div> </uib-accordion> </div> </div> <div class=row> <div class=col-md-12> <div class=\"divider small tight\"></div> <div class=form-group> <label for=operatorMessage>Add a message</label> <textarea msd-elastic=\\n placeholder=\"Write a message...\" name=operatorMessage id=operatorMessage class=textarea ng-model=AppointmentAddController.message.content>\n        </textarea> <label ng-if=\"AppointmentAddController.session.activeState.role === 'operator' || AppointmentAddController.session.activeState.role === 'artist'\"> Private message? <small> <input name=private type=checkbox ng-model=AppointmentAddController.message.private /> <strong ng-if=\"AppointmentAddController.session.activeState.role === 'operator'\"> Yes, make this message visible only to others at {{AppointmentAddController.session.activeState.association.shop.name}}. </strong> <strong ng-if=\"AppointmentAddController.session.activeState.role === 'artist'\"> Yes, make this message visible only to you and others at the shop. </strong> </small> </label> </div> <div class=\"divider small tight\"></div> <div class=form-group ng-controller=\"ShopOperatorsController as ShopOperatorsController\"> <p>This appointment was taken by <select class=\"small inline\" ng-model=AppointmentAddController.data.appointment.managed_by value=operator ng-options=\"operator as (operator.first_name+' '+operator.last_name) for operator in ShopOperatorsController.operators.confirmed\"> <option value=\"\">Select an Operator</option> </select> </p> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=\"confirmedAppointmentForm.$invalid || !AppointmentAddController.data.appointment.artist.id || !AppointmentAddController.data.appointment.appointment_date || AppointmentAddController.clientAlerts.errors.length || AppointmentAddController.serverAlerts.errors.length\">Save appointment</button> </div> <div class=col-md-12 ng-if=AppointmentAddController.serverAlerts.errors.length> <div class=inline-alerts> <p class=\"inline-alert error\" ng-repeat=\"error in AppointmentAddController.serverAlerts.errors\"> {{error}} <a ng-click=AppointmentAddController.getAvailability()>Refresh the schedule</a> to select another time. </p> </div> </div> </div> </div> </form> ";

/***/ }),

/***/ "./components/appointments/add/confirmed-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/add/confirmed-form/confirmed-form.component.js");

/***/ }),

/***/ "./components/appointments/add/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/add/confirmed-form/index.js");

__webpack_require__("./components/appointments/add/need-more-form/index.js");

__webpack_require__("./components/appointments/add/unconfirmed-form/index.js");

__webpack_require__("./components/appointments/add/appointment-add-workflow.controller.js");

__webpack_require__("./components/appointments/add/appointment-add.controller.js");

__webpack_require__("./components/appointments/add/appointment-add.factory.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider
  // Add an appointment base
  .state('inkfinder.appointments.add', {
    url: '/add',
    abstract: true,
    views: {
      '@': {
        template: __webpack_require__("./components/appointments/add/template.base.html"),
        controller: 'AppointmentAddWorkflowController as $ctrl'
      }
    }
  })

  // Add an appointment: Collector search
  .state('inkfinder.appointments.add.collector', {
    url: '/search-collector',
    template: __webpack_require__("./components/appointments/add/collector-search-add.html"),
    resolve: {
      $title: function $title() {
        return 'Add an appointment';
      }
    }
  })

  // Add an appointment: Select a collector
  .state('inkfinder.appointments.add.collector-select', {
    url: '/select',
    template: __webpack_require__("./components/appointments/add/collector-select.html"),
    resolve: {
      $title: function $title() {
        return 'Search results';
      }
    }
  })

  // Add an appointment: Add a collector
  .state('inkfinder.appointments.add.collector-create', {
    url: '/create',
    template: __webpack_require__("./components/appointments/add/collector-create.html"),
    resolve: {
      $title: function $title() {
        return 'Create an account';
      }
    }
  })

  // Add an appointment: Select a project
  .state('inkfinder.appointments.add.project-select', {
    url: '/project/select',
    template: __webpack_require__("./components/appointments/add/project-select.html"),
    resolve: {
      $title: function $title() {
        return 'Select a project';
      }
    }
  })

  // Add an appointment: Add a project
  .state('inkfinder.appointments.add.project-create', {
    url: '/project/create',
    template: __webpack_require__("./components/appointments/add/project-create.html"),
    resolve: {
      $title: function $title() {
        return 'Create a new project';
      }
    }
  })

  // Add an appointment: Update the appointment status
  .state('inkfinder.appointments.add.update', {
    url: '/appointment/update',
    template: __webpack_require__("./components/appointments/add/appointment-update.html"),
    resolve: {
      $title: function $title() {
        return 'Update the appointment status';
      }
    }
  })

  // Add an appointment: Complete
  .state('inkfinder.appointments.add.complete', {
    url: '/appointment/complete',
    template: __webpack_require__("./components/appointments/add/appointment-complete.html"),
    resolve: {
      $title: function $title() {
        return 'Appointment complete';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/appointments/add/need-more-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/add/need-more-form/need-more-form.component.js");

/***/ }),

/***/ "./components/appointments/add/need-more-form/need-more-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkNeedMoreForm = {
  template: __webpack_require__("./components/appointments/add/need-more-form/need-more-form.template.html")
};

angular.module('inkfinder').component('inkNeedMoreForm', inkNeedMoreForm);

/***/ }),

/***/ "./components/appointments/add/need-more-form/need-more-form.template.html":
/***/ (function(module, exports) {

module.exports = " <form name=requestForm ng-controller=\"AppointmentAddController as AppointmentAddController\" ng-submit=\"requestForm.$valid && AppointmentAddController.saveAppointment(10)\" novalidate> <ink-availability appointment=AppointmentAddController.data.appointment type=\"'artist-selector'\"></ink-availability> <p>When would {{$ctrl.selectedCollector.first_name}} like an appointment?</p> <div class=row> <div class=col-md-6> <div class=form-group> <label for=raw_start_date>From</label> <div class=input-group> <input name=raw_start_date id=raw_start_date type=text class=form-control uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=AppointmentAddController.data.appointment.preferred_start_date placeholder=MM/DD/YYYY is-open=AppointmentAddController.date_picker.start_open datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default button large shop calendar-button\" ng-click=\"AppointmentAddController.date_picker.start_open = !AppointmentAddController.date_picker.start_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=raw_end_date>To</label> <div class=input-group> <input name=raw_end_date id=raw_end_date type=text class=form-control uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=AppointmentAddController.data.appointment.preferred_end_date placeholder=MM/DD/YYYY is-open=AppointmentAddController.date_picker.end_open min-date=AppointmentAddController.data.appointment.preferred_start_date datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default button large shop calendar-button\" ng-click=\"AppointmentAddController.date_picker.end_open = !AppointmentAddController.date_picker.end_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> </div> <div class=form-group> <label for=preferred_time>Preferred time</label> <select name=preferred_time id=preferred_time ng-model=AppointmentAddController.data.appointment.preferred_time> <option value=\"\">Choose one</option> <option value=1>Morning</option> <option value=2>Afternoon</option> <option value=3>Night</option> </select> </div> <div class=\"divider small tight\"></div> <div class=form-group> <label for=operatorMessage>Add a message</label> <textarea msd-elastic=\\n placeholder=\"Write a message...\" name=operatorMessage id=operatorMessage class=textarea ng-model=AppointmentAddController.message.content>\n    </textarea> <label ng-if=\"AppointmentAddController.session.activeState.role === 'operator' || AppointmentAddController.session.activeState.role === 'artist'\"> Private message? <small> <input name=private type=checkbox ng-model=AppointmentAddController.message.private /> <strong ng-if=\"AppointmentAddController.session.activeState.role === 'operator'\"> Yes, make this message visible only to others at {{AppointmentAddController.session.activeState.association.shop.name}}. </strong> <strong ng-if=\"AppointmentAddController.session.activeState.role === 'artist'\"> Yes, make this message visible only to you and others at the shop. </strong> </small> </label> </div> <div class=\"divider small tight\"></div> <div class=form-group ng-controller=\"ShopOperatorsController as ShopOperatorsController\"> <p>This appointment was taken by <select class=\"small inline\" ng-model=AppointmentAddController.data.appointment.managed_by value=operator ng-options=\"operator as (operator.first_name+' '+operator.last_name) for operator in ShopOperatorsController.operators.confirmed\"> <option value=\"\">Select an Operator</option> </select> </p> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=requestForm.$invalid>Save request</button> </div> </form> ";

/***/ }),

/***/ "./components/appointments/add/project-create.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"intro center\"> <h1>Start a project.</h1> <h5 class=finder-color>Collaborate with {{$ctrl.selectedCollector.first_name}} on a new project.</h5> </div> <div class=row> <div class=\"col-md-8 col-md-offset-2\"> <div class=\"collector center\"> <ink-profile-photo profile=$ctrl.selectedCollector image-id=$ctrl.selectedCollector.profile_photo show-email-confirmation=true> </ink-profile-photo> <div class=\"divider xtight transparent\"></div> <div class=center> <span class=\"inline-alert finder small\" ng-if=$ctrl.selectedCollector.email_is_confirmed> <fa name=thumbs-up></fa> {{$ctrl.selectedCollector.first_name}} will get an email notification about this project. </span> <span class=\"inline-alert warning small\" ng-if=!$ctrl.selectedCollector.email_is_confirmed> <fa name=thumbs-up></fa> {{$ctrl.selectedCollector.first_name}} hasn't confirmed their email address, but they will still get an email about this project. </span> </div> </div> <div class=\"divider tight transparent\"></div> <h5>Enter project details below<span ng-if=\"$ctrl.collectorAppointments.complete.length > 0 && $ctrl.collectorAppointments.incomplete.length\"> or <a ui-sref=inkfinder.appointments.add.project-select>go back to the project list</a></span>. </h5> <form name=createProjectForm ng-submit=\"createProjectForm.$valid && $ctrl.saveProject($ctrl.newProject)\" novalidate> <div class=form-group> <label for=project_name>Project name <small>Required</small></label> <input name=project_name id=project_name type=text placeholder=\"My awesome tattoo project\" class=form-control required ng-model=$ctrl.newProject.name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createProjectForm.project_name.$invalid && !createProjectForm.project_name.$pristine\"> To help identify this project, give it a name. </p> </div> </div> <div class=form-group> <label for=tattoo_concept>Tattoo concept</label> <textarea name=tattoo_concept id=tattoo_concept msd-elastic=\\n placeholder=\"I just want to be a badass...\" class=textarea ng-model=$ctrl.newProject.tattoo_concept>\n        </textarea> </div> <div class=row> <div class=col-md-6> <div class=form-group> <label for=project_width>Width <small>in inches</small></label> <input name=project_width id=project_width type=number placeholder=\"My tattoo width\" class=form-control ng-model=$ctrl.newProject.width min=1 ng-required=$ctrl.newProject.height> <div class=\"inline-message relative\"> <p class=\"message error\" ng-if=\"createProjectForm.project_width.$invalid && !createProjectForm.project_width.$pristine\"> If you’ve entered a height, enter a width. </p> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=project_height>Height <small>in inches</small></label> <input name=project_height id=project_height type=number placeholder=\"My tattoo height\" class=form-control ng-model=$ctrl.newProject.height min=1 ng-required=\"$ctrl.newProject.width && createProjectForm.project_width\"> <div class=\"inline-message relative\"> <p class=\"message error\" ng-if=createProjectForm.project_height.$invalid> If you’ve entered a width, enter a height. </p> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=project_style>Select a style</label> <select name=project_style id=project_style ng-model=$ctrl.newProject.style ng-value=option.id ng-options=\"option.name for option in $ctrl.styles | orderBy:'name' track by option.id\"> <option value=\"\">Choose one</option> </select> </div> </div> <div class=col-md-6> <div class=form-group> <label for=project_area>Select an area</label> <select name=project_area id=project_area ng-model=$ctrl.newProject.area ng-value=option.id ng-options=\"option.name for option in $ctrl.options.areas track by option.id\"> <option value=\"\">Choose one</option> </select> </div> </div> <div class=col-md-6> <div class=form-group> <label for=project_location>Specific location</label> <select name=project_location id=project_location ng-required=$ctrl.newProject.area ng-model=$ctrl.newProject.location ng-disabled=!$ctrl.newProject.area ng-value=option.id ng-options=\"option.name for option in $ctrl.options.locations |\n                        positionFilter:$ctrl.newProject.area.id track by option.id\"> <option value=\"\" selected=selected>Choose one</option> </select> </div> </div> </div> <div class=\"divider small tight\"></div> <div class=row> <div class=col-md-6> <div class=form-group> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.newProject.full_color === true}\"> <input type=radio name=color_options id=full_color ng-model=$ctrl.newProject.full_color ng-value=true> Full color </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.newProject.full_color === false}\"> <input type=radio name=color_options id=black_gray ng-model=$ctrl.newProject.full_color ng-value=false> Black and gray </label> </div> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label> <input name=coverup type=checkbox id=coverup ng-model=$ctrl.newProject.coverup> This is a coverup </label> </div> </div> </div> <div class=row> <div class=col-md-12> <h6>Placement images <small class=no-margin ng-if=$ctrl.newProject.coverup> Upload a photo of your existing tattoo. </small> </h6> <ink-file-upload images=$ctrl.coverupImages> </ink-file-upload> </div> </div> <div class=row> <div class=col-md-12> <h6>Reference images</h6> <ink-file-upload images=$ctrl.referenceImages> </ink-file-upload> </div> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=\"createProjectForm.$invalid || $ctrl.taskErrors.length || $ctrl.httpStatus\">Save project</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.startOver(true)>Start Over</button> </div> <div class=inline-alerts> <p class=\"inline-alert error\" ng-if=$ctrl.taskErrors.length> There was a problem saving this project. <button type=button ng-disabled=$ctrl.httpStatus class=\"button small light\" ng-click=$ctrl.resolveErrors()>Try again now</button> </p> </div> </form> </div> </div> ";

/***/ }),

/***/ "./components/appointments/add/project-select.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"intro center\"> <h1>Select a project.</h1> <h5>Pick an existing project or <a ui-sref=inkfinder.appointments.add.project-create>start a new one.</a></h5> </div> <div class=row> <div class=col-md-12> <div class=\"collector center animate fade-in-up\" ng-if=!$ctrl.collectorAppointments> <h6 class=\"\">Looking for existing appointments...</h6> </div> <div class=\"collectorAppointments animate fade-in-up center\" ng-if=$ctrl.collectorAppointments> <div class=\"list projects\"> <div class=project-group ng-repeat=\"dateGroup in $ctrl.collectorAppointments | orderBy:'-dateTime' track by $index\"> <div class=smal-col-12> <h6>{{dateGroup.date}}</h6> <div class=\"divider small tight\"></div> </div> <a class=\"item project link\" ui-sref=inkfinder.appointments.details({appointment_id:data.appointment.id}) ng-repeat=\"data in dateGroup.appointments track by $index\"> <ink-project-card card=data></ink-project-card> </a> </div> </div> </div> <div class=center> <div class=\"divider small tight\"></div> <div class=\"button-container margin\"> <button ui-sref=inkfinder.appointments.add.project-create class=\"button large finder-solid\"> Start a new project </button> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/appointments/add/template.base.html":
/***/ (function(module, exports) {

module.exports = "<div id=schedule-add class=\"section photo background-dark\"> <div class=background-photo></div> <div class=container-fluid> <div class=row> <div ui-view=\"\" class=col-sm-12></div> </div> </div> </div> ";

/***/ }),

/***/ "./components/appointments/add/unconfirmed-form/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/add/unconfirmed-form/unconfirmed-form.component.js");

/***/ }),

/***/ "./components/appointments/add/unconfirmed-form/unconfirmed-form.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkUnconfirmedForm = {
  template: __webpack_require__("./components/appointments/add/unconfirmed-form/unconfirmed-form.template.html")
};

angular.module('inkfinder').component('inkUnconfirmedForm', inkUnconfirmedForm);

/***/ }),

/***/ "./components/appointments/add/unconfirmed-form/unconfirmed-form.template.html":
/***/ (function(module, exports) {

module.exports = " <form name=unconfirmedAppointmentForm ng-controller=\"AppointmentAddController as AppointmentAddController\" ng-submit=\"unconfirmedAppointmentForm.$valid && AppointmentAddController.saveAppointment(40)\" novalidate> <ink-availability appointment=AppointmentAddController.data.appointment type=\"'full'\"></ink-availability> <div class=row> <div class=col-md-12> <div class=\"divider small tight\"></div> <div class=form-group> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': AppointmentAddController.data.appointment.previously_paid === false}\"> <input type=radio name=estimate_or_previously_paid id=estimate ng-model=AppointmentAddController.data.appointment.previously_paid ng-value=false> Estimate this appointment </label> <label class=\"btn btn-default\" ng-class=\"{'active': AppointmentAddController.data.appointment.previously_paid === true}\"> <input type=radio name=estimate_or_previously_paid id=previously-paid ng-model=AppointmentAddController.data.appointment.previously_paid ng-value=true> Mark as previously paid </label> </div> </div> </div> </div> </div> <div class=row ng-if=!AppointmentAddController.data.appointment.previously_paid> <div class=col-md-12> <p>Estimate range</p> </div> <div class=col-md-6> <div class=\"form-group no-margin-bottom\"> <label for=estimate_min>From</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=estimate_min id=estimate_min type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=AppointmentAddController.data.appointment.estimate_min> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"unconfirmedAppointmentForm.estimate_min.$invalid && !unconfirmedAppointmentForm.estimate_min.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> <div class=col-md-6> <div class=\"form-group no-margin-bottom\"> <label for=estimate_max>To</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=estimate_max id=estimate_max type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=AppointmentAddController.data.appointment.estimate_max> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"unconfirmedAppointmentForm.estimate_max.$invalid && !unconfirmedAppointmentForm.estimate_max.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> <div class=col-md-12> <div class=\"divider small tight\"></div> <div class=form-group> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': AppointmentAddController.data.appointment.deposit_required === true}\"> <input type=radio name=deposit_required id=true ng-model=AppointmentAddController.data.appointment.deposit_required ng-value=true> Set a deposit amount </label> <label class=\"btn btn-default\" ng-class=\"{'active': AppointmentAddController.data.appointment.deposit_required === false}\"> <input type=radio name=deposit_required id=false ng-model=AppointmentAddController.data.appointment.deposit_required ng-value=false> No deposit required </label> </div> </div> </div> </div> <div ng-if=AppointmentAddController.data.appointment.deposit_required> <div class=col-md-12> <p>Deposit amount</p> </div> <div class=col-md-6> <div class=\"form-group no-margin-bottom\"> <div class=input-group> <span class=input-group-addon>$</span> <input name=deposit_amount id=deposit_amount type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=AppointmentAddController.data.appointment.deposit_amount> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"unconfirmedAppointmentForm.deposit_amount.$invalid && !unconfirmedAppointmentForm.deposit_amount.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=\"divider small tight\"></div> <div class=form-group> <label for=operatorMessage>Add a message</label> <textarea msd-elastic=\\n placeholder=\"Write a message...\" name=operatorMessage id=operatorMessage class=textarea ng-model=AppointmentAddController.message.content>\n        </textarea> <label ng-if=\"AppointmentAddController.session.activeState.role === 'operator' || AppointmentAddController.session.activeState.role === 'artist'\"> Private message? <small> <input name=private type=checkbox ng-model=AppointmentAddController.message.private /> <strong ng-if=\"AppointmentAddController.session.activeState.role === 'operator'\"> Yes, make this message visible only to others at {{AppointmentAddController.session.activeState.association.shop.name}}. </strong> <strong ng-if=\"AppointmentAddController.session.activeState.role === 'artist'\"> Yes, make this message visible only to you and others at the shop. </strong> </small> </label> </div> <div class=\"divider small tight\"></div> <div class=form-group ng-controller=\"ShopOperatorsController as ShopOperatorsController\"> <p>This appointment was taken by <select class=\"small inline\" ng-model=AppointmentAddController.data.appointment.managed_by value=operator ng-options=\"operator as (operator.first_name+' '+operator.last_name) for operator in ShopOperatorsController.operators.confirmed\"> <option value=\"\">Select an Operator</option> </select> </p> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=\"unconfirmedAppointmentForm.$invalid || !AppointmentAddController.data.appointment.artist.id || AppointmentAddController.clientAlerts.errors.length || AppointmentAddController.serverAlerts.errors.length\">Send estimate</button> </div> <div class=col-md-12 ng-if=AppointmentAddController.serverAlerts.errors.length> <div class=inline-alerts> <p class=\"inline-alert error\" ng-repeat=\"error in AppointmentAddController.serverAlerts.errors\"> {{error}} <a ng-click=AppointmentAddController.getAvailability()>Refresh the schedule</a> to select another time. </p> </div> </div> </div> </div> </form> ";

/***/ }),

/***/ "./components/appointments/appointment/_appointment.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182511371
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/appointments/appointment/add-related/add.related.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddRelatedController.$inject = ['$uibModalInstance', 'Appointment', 'AlertMessages', 'appointment', 'project'];


/**
 * @name AddRelatedController
 * @description Controller to add related appointments
 * @param {type} $uibModalInstance Description
 * @param {type} Appointment Description
 * @param {type} AlertMessages Description
 * @param {type} appointment Description
 * @param {type} project Description
 */
function AddRelatedController($uibModalInstance, Appointment, AlertMessages, appointment, project) {
  var vm = this;

  // Defaults
  vm.newAppointment = {
    previously_paid: false,
    deposit_required: true,
    last_status: {},
    project: project.id
  };
  if (appointment.managed_by) {
    vm.newAppointment.managed_by = appointment.managed_by;
  }
  if (appointment.artist) {
    vm.newAppointment.artist = appointment.artist;
  }

  // Exposed Functions
  vm.submitDisabled = submitDisabled;
  vm.add = add;

  /**
  * @name submitDisabled
  * @description Disable the submit button
  * @return {Unknown} Unknown
  */
  function submitDisabled() {
    return vm.newAppointment.artist.id && !vm.newAppointment.appointment_datetime && vm.newAppointment.artist.id && !vm.newAppointment.appointment_date && !vm.newAppointment.appointment_start_time;
  }

  /**
  * @name createAppointment
  * @description Function to create a new appointment.
  * @param {object} appointment The appointment to be created.
  */
  function add(appointment) {
    var status = 40;
    Appointment.create(appointment, status).then(function (appointment) {
      $uibModalInstance.close(appointment);
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('AddRelatedController', AddRelatedController);

/***/ }),

/***/ "./components/appointments/appointment/add-related/add.related.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=updateAppointment ng-submit=\"updateAppointment.$valid && $ctrl.add($ctrl.newAppointment)\" novalidate> <div class=modal-header> <h4 class=modal-title>Add a session</h4> </div> <div class=modal-body> <div class=background-light> <ink-availability appointment=$ctrl.newAppointment></ink-availability> <div class=row> <div class=col-md-12> <div class=\"divider small tight\"></div> <div class=form-group> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.newAppointment.previously_paid === false}\"> <input type=radio name=estimate_or_previously_paid id=estimate ng-model=$ctrl.newAppointment.previously_paid ng-value=false> Estimate this appointment </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.newAppointment.previously_paid === true}\"> <input type=radio name=estimate_or_previously_paid id=previously-paid ng-model=$ctrl.newAppointment.previously_paid ng-value=true> Mark as previously paid </label> </div> </div> </div> </div> </div> <div class=row ng-if=!$ctrl.newAppointment.previously_paid> <div class=col-md-12> <p>Estimate range</p> </div> <div class=col-md-6> <div class=\"form-group no-margin-bottom\"> <label for=estimate_min>From</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=estimate_min id=estimate_min type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=$ctrl.newAppointment.estimate_min> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateAppointment.estimate_min.$invalid && !updateAppointment.estimate_min.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> <div class=col-md-6> <div class=\"form-group no-margin-bottom\"> <label for=estimate_max>To</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=estimate_max id=estimate_max type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=$ctrl.newAppointment.estimate_max> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateAppointment.estimate_max.$invalid && !updateAppointment.estimate_max.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> <div class=col-md-12> <div class=\"divider small tight\"></div> <div class=form-group> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.newAppointment.deposit_required === true}\"> <input type=radio name=deposit_required id=true ng-model=$ctrl.newAppointment.deposit_required ng-value=true> Set a deposit amount </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.newAppointment.deposit_required === false}\"> <input type=radio name=deposit_required id=false ng-model=$ctrl.newAppointment.deposit_required ng-value=false> No deposit required </label> </div> </div> </div> </div> <div ng-if=$ctrl.newAppointment.deposit_required> <div class=col-md-12> <p>Deposit amount</p> </div> <div class=col-md-6> <div class=\"form-group no-margin-bottom\"> <div class=input-group> <span class=input-group-addon>$</span> <input name=deposit_amount id=deposit_amount type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=$ctrl.newAppointment.deposit_amount> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateAppointment.deposit_amount.$invalid && !updateAppointment.deposit_amount.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> </div> </div> <div class=row> <div class=col-sm-12> <div class=\"divider small tight\"></div> <div class=form-group ng-controller=\"ShopOperatorsController as ShopOperatorsController\"> <p>This appointment was taken by <select class=\"small inline\" ng-model=$ctrl.newAppointment.managed_by.id value=operator.id ng-options=\"operator.id as (operator.first_name+' '+operator.last_name) for operator in ShopOperatorsController.operators.confirmed\"> <option value=\"\">Select an Operator</option> </select> </p> </div> </div> </div> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit ng-disabled=\"updateAppointment.$invalid || !$ctrl.newAppointment.artist.id || $ctrl.submitDisabled() || $ctrl.clientAlerts.errors.length || $ctrl.serverAlerts.errors.length\">Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/appointments/appointment/add-related/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/add-related/add.related.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/add/_add-appointment.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508315
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/appointments/appointment/add/add-appointment.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAddAppointment = {
  bindings: {
    provider: '<'
  },
  controller: 'AddAppointmentController',
  template: __webpack_require__("./components/appointments/appointment/add/add-appointment.template.html")
};

angular.module('inkfinder').component('inkAddAppointment', inkAddAppointment);

/***/ }),

/***/ "./components/appointments/appointment/add/add-appointment.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddAppointmentController.$inject = ['_', '$log'];


/**
 * @name AddAppointmentController
 * @description Controller called by the add project component.
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 */
function AddAppointmentController(_, $log) {
  var vm = this;
  vm.newAppointment = {};
  vm.selectArtist = selectArtist;

  vm.$onInit = function () {
    vm.steps = [{
      id: 1,
      name: 'selectArtist',
      description: 'Select an artist'
    }, {
      id: 3,
      name: 'addProject',
      description: 'Add a project'
    }, {
      id: 4,
      name: 'selectFavoriteWork',
      description: 'Choose your favorites'
    }, {
      id: 5,
      name: 'confirmation',
      description: 'You’re all set!'
    }];
    vm.activeStep = _.find(vm.steps, { name: 'selectArtist' });
  };

  /**
   * @name selectArtist
   * @description Function to select the artist and move to the next step in the process
   * @param {object} artist The selected artist
   */
  function selectArtist(artist) {
    vm.newAppointment.artist = artist;
    vm.activeStep = _.find(vm.steps, { name: 'addProject' });
    $log.debug('Active step: ', vm.activeStep);
  }
}

angular.module('inkfinder').controller('AddAppointmentController', AddAppointmentController);

/***/ }),

/***/ "./components/appointments/appointment/add/add-appointment.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=row> <div class=col-sm-12> <h4 class=center>Request an appointment</h4> <div class=row> <div class=\"col-sm-6 col-sm-offset-3\"> <ink-progress steps=$ctrl.steps active-step=$ctrl.activeStep></ink-progress> </div> </div> <div ng-switch=$ctrl.activeStep.name> <div class=step-selectArtist ng-if=\"$ctrl.provider.artists.confirmed.length > 0\" ng-switch-default> <div class=artist-card ng-repeat=\"artist in $ctrl.provider.artists.confirmed | orderBy:'last_name' track by artist.id\" ng-click=$ctrl.selectArtist(artist)> <a class=background> <ink-profile-photo profile=artist image-id=artist.artist.profile_photo size=\"'xxlarge'\"> </ink-profile-photo> </a> </div> <div ng-if=\"$ctrl.artists.length === 0\"> <h6>There are no active artists on the roster at {{$ctrl.provider.name}}.</h6> </div> </div> <div class=step-addProject ng-switch-when=addProject> <ink-add-project></ink-add-project> </div> <div class=step-selectFavoriteWork ng-switch-when=selectFavoriteWork> Select your favorite work from your artist <ink-select-favorite-work></ink-select-favorite-work> </div> <div class=step-confirmation ng-switch-when=confirmation> Confirmation </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/appointments/appointment/add/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/add/add-appointment.component.js");

__webpack_require__("./components/appointments/appointment/add/add-appointment.controller.js");

__webpack_require__("./components/appointments/appointment/add/_add-appointment.styles.scss");

/***/ }),

/***/ "./components/appointments/appointment/appointment.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAppointment = {
  controller: 'AppointmentController',
  bindings: {
    appointments: '<',
    project: '<',
    currentAppointment: '<',
    open: '<?',
    onAppointmentChange: '&'
  },
  template: __webpack_require__("./components/appointments/appointment/appointment.template.html")
};

angular.module('inkfinder').component('inkAppointment', inkAppointment);

/***/ }),

/***/ "./components/appointments/appointment/appointment.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

AppointmentController.$inject = ['$rootScope', '$state', '$uibModal', 'Appointment', 'Project', 'Activity', 'AlertMessages', 'RESPONSE_MESSAGES', 'Session', 'NOTIFICATIONS', 'Notification', 'collectorWantsNotif', 'STATUS_IDS', 'Shop', 'Operators', 'MessageTemplates', '$log'];


/**
 * @name AppointmentController
 * @description Controller called to displa and manage appointment details.
 * @param {Unknown} $rootScope Unknown
 * @param {Unknown} $state Unknown
 * @param {Unknown} $uibModal Unknown
 * @param {Unknown} Appointment Unknown
 * @param {Unknown} Project Unknown
 * @param {Unknown} Activity The activity service
 * @param {Unknown} AlertMessages Unknown
 * @param {Unknown} RESPONSE_MESSAGES Unknown
 * @param {Unknown} Session Unknown
 * @param {Unknown} NOTIFICATIONS Unknown
 * @param {Unknown} Notification Unknown
 * @param {service} collectorWantsNotif The collectorWantsNotif service
 * @param {constant} STATUS_IDS The STATUS_IDS constant
 * @param {service} Shop The Shop service
 * @param {service} Operators The Operators service
 * @param {service} MessageTemplates The MessageTemplates service
 * @param {library} $log The Angular $log service
 */
function AppointmentController($rootScope, $state, $uibModal, Appointment, Project, Activity, AlertMessages, RESPONSE_MESSAGES, Session, NOTIFICATIONS, Notification, collectorWantsNotif, STATUS_IDS, Shop, Operators, MessageTemplates, $log) {
  var vm = this;
  vm.$onInit = function () {
    // Defaults
    vm.status = {
      editOwner: false,
      editPrice: false
    };
    vm.price = vm.currentAppointment.paymentData.price;
    vm.isArchiveConfirmCollapsed = true;

    // Defaults
    vm.session = Session;
    vm.STATUS_IDS = STATUS_IDS;

    // Public methods
    vm.resetPrice = resetPrice;
    vm.updatePrice = updatePrice;
    vm.updateOperator = updateOperator;
    vm.confirmAppointment = confirmAppointment;
    vm.selectAppointment = selectAppointment;
    vm.updateAppointment = updateAppointment;
    vm.addRelatedAppointment = addRelatedAppointment;
    vm.declineRequest = declineRequest;
    vm.cancelAppointment = cancelAppointment;
    vm.completeAppointment = completeAppointment;
    vm.updatePayment = updatePayment;
    vm.openAppointmentResponseModal = openAppointmentResponseModal;
    vm.openDepositModal = openDepositModal;
    vm.archiveAppointment = archiveAppointment;
    vm.readMessageTemplate = readMessageTemplate;

    // If an operator is logged in, get the operators for the shop
    if (Session.activeState.role === 'operator') {
      var shopId = Session.activeState.association.shop.id;
      getOperators(shopId);
      vm.canUpdateAppts = true;
    }

    // If an artist is logged in, get the artist's appointment permissions
    if (Session.activeState.role === 'artist') {
      vm.canUpdateAppts = Session.activeState.association.can_update_appts;
    }
  };

  /**
   * @name getOperators
   * @description Get shop operators
   * @param {number} shopId The ID of the shop
   */
  function getOperators(shopId) {
    Operators.getAllForShop(shopId).then(function (operators) {
      vm.operators = operators;
    });
  }

  /**
   * @name selectAppointment
   * @description Function to load a related appointment/session
   * @param {number} appointmentId The appointment ID to load
   */
  function selectAppointment(appointmentId) {
    $state.go('.', { appointment_id: appointmentId });
  }

  /**
   * @name updateAppointment
   * @description Function to call the update appointment modalInstance
   */
  function updateAppointment() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/update/update.template.html"),
      animation: true,
      controller: 'UpdateAppointmentController as $ctrl',
      resolve: {
        appointment: function appointment() {
          return vm.currentAppointment;
        },
        project: function project() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(function (appointment) {
      updateAppointmentsData(appointment);

      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name openAppointmentResponseModal
   * @description Function to open the collector response modal.
   * @param {object} appointment The selected appointment.
   */
  function openAppointmentResponseModal(_appointment) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/respond/respond.template.html"),
      animation: true,
      controller: 'RespondAppointmentController',
      controllerAs: '$ctrl',
      resolve: {
        appointment: function appointment() {
          return _appointment;
        },
        project: function project() {
          return vm.project;
        },
        shopMessageTemplates: ['Shop', 'MessageTemplates', function shopMessageTemplates(Shop, MessageTemplates) {
          return Shop.get(vm.currentAppointment.shop.id).then(function (shop) {
            return MessageTemplates.get(shop.message_templates).then(function (messageTemplates) {
              return messageTemplates;
            });
          });
        }]
      }
    });
    modalInstance.result.then(function (updatedAppointment) {
      updateAppointmentsData(updatedAppointment);
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name openDepositModal
   * @description Function to open the collector deposit payment modal.
   * @param {object} appointment The selected appointment.
   */
  function openDepositModal() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/deposit/deposit.template.html"),
      animation: true,
      controller: 'CollectorDepositController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        appointment: function appointment() {
          return vm.currentAppointment;
        },
        project: function project() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(function () {}, function () {
      // No error handling needed.
    });
  }

  /**
  * @name archiveAppointment
  * @description Function to archive an appointment.
  * @param {object} appointment The appointment to archive.
  */
  function archiveAppointment() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/archive/archive.template.html"),
      animation: true,
      controller: 'ArchiveAppointmentController as $ctrl',
      resolve: {
        appointment: function appointment() {
          return vm.currentAppointment;
        },
        project: function project() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(function (appointment) {
      updateAppointmentsData(appointment);

      AlertMessages.add({
        msg: RESPONSE_MESSAGES.archived,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name addRelatedAppointment
   * @description Function to call the add related appointment modalInstance
   */
  function addRelatedAppointment() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/add-related/add.related.template.html"),
      animation: true,
      controller: 'AddRelatedController as $ctrl',
      resolve: {
        appointment: function appointment() {
          return vm.currentAppointment;
        },
        project: function project() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(function (appointment) {
      // Get the appointment shop again
      Shop.get(appointment.shop).then(function (response) {
        appointment.shop = response;

        // Get the shop's message tempaltes
        MessageTemplates.get(appointment.shop.message_templates).then(function (response) {
          appointment.shop.messageTemplates = response;
        });
      });

      vm.appointments.push(appointment);
      selectAppointment(appointment.id);

      // Update the appointment on the parent component
      vm.onAppointmentChange({ appointment: appointment });

      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name declineRequest
   * @descriptoin Function to call the decline request modalInstance
   */
  function declineRequest() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/decline/decline.template.html"),
      animation: true,
      controller: 'DeclineAppointmentController as $ctrl',
      resolve: {
        appointment: function appointment() {
          return vm.currentAppointment;
        }
      }
    });
    modalInstance.result.then(function (appointment) {
      updateAppointmentsData(appointment);

      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name confirmAppointment
   * @description Function to open the confirm appointment modal.
   */
  function confirmAppointment() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/confirm/confirm.template.html"),
      animation: true,
      controller: 'ConfirmAppointmentController as $ctrl',
      resolve: {
        appointment: function appointment() {
          return vm.currentAppointment;
        },
        project: function project() {
          return vm.project;
        },
        shopMessageTemplates: ['Shop', 'MessageTemplates', function shopMessageTemplates(Shop, MessageTemplates) {
          return Shop.get(vm.currentAppointment.shop.id).then(function (shop) {
            return MessageTemplates.get(shop.message_templates).then(function (messageTemplates) {
              return messageTemplates;
            });
          });
        }]
      }
    });
    modalInstance.result.then(function (appointment) {
      updateAppointmentsData(appointment);

      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name cancelAppointment
   * @descriptoin Function to call the cancel appointment modalInstance
   */
  function cancelAppointment() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/cancel/cancel.template.html"),
      animation: true,
      controller: 'CancelAppointmentController as $ctrl',
      resolve: {
        appointment: function appointment() {
          return vm.currentAppointment;
        },
        project: function project() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(function (appointment) {
      updateAppointmentsData(appointment);

      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name completeAppointment
   * @description Function to open the complete appointment modalInstance.
   */
  function completeAppointment() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/complete/complete.template.html"),
      animation: true,
      controller: 'CompleteAppointmentController as $ctrl',
      resolve: {
        appointment: function appointment() {
          return vm.currentAppointment;
        },
        project: function project() {
          return vm.project;
        },
        shopMessageTemplates: ['Shop', 'MessageTemplates', function shopMessageTemplates(Shop, MessageTemplates) {
          return Shop.get(vm.currentAppointment.shop.id).then(function (shop) {
            return MessageTemplates.get(shop.message_templates).then(function (messageTemplates) {
              return messageTemplates;
            });
          });
        }]
      }
    });
    modalInstance.result.then(function (appointment) {
      updateAppointmentsData(appointment);

      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name updatePayment
   * @description Function to call the update payment modalInstance.
   */
  function updatePayment() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/payments/payments.template.html"),
      animation: true,
      controller: 'PaymentsController as $ctrl',
      backdrop: 'static',
      keyboard: false,
      resolve: {
        appointment: function appointment() {
          return vm.currentAppointment;
        },
        project: function project() {
          return vm.project;
        }
      }
    });
    modalInstance.result.then(function (results) {
      if (!_lodash2.default.isUndefined(results.parsedPayments)) {
        vm.currentAppointment.paymentData = results.parsedPayments;
      }
      if (!_lodash2.default.isUndefined(results.message)) {
        var conversationId = vm.currentAppointment.conversations;
        var projectId = void 0;
        var appointmentId = vm.currentAppointment.id;
        $rootScope.$broadcast('merge-activity', conversationId, appointmentId, projectId);
      }
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name readMessageTemplate
   * @description Function to open a modal to display a message template
   * @param {string} messageTitle The title of the template
   * @param {string} messageTemplate The message template
   */
  function readMessageTemplate(_messageTitle, _messageTemplate) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/appointments/appointment/read-message-templates/read-message-templates.template.html"),
      animation: true,
      controller: 'ReadMessageTemplateController as $ctrl',
      resolve: {
        messageTitle: function messageTitle() {
          return _messageTitle;
        },
        messageTemplate: function messageTemplate() {
          return _messageTemplate;
        }
      }
    });
    modalInstance.result.then(function () {
      // Nothing to do
    });
  }

  /**
  * @name updatePrice
  * @description Function to update the price of an appointment
  * @param {string} price The new price of the appointment
  */
  function updatePrice(price) {
    var newPrice = parseFloat(price);

    // Invalid Price
    if (newPrice <= 0 || !newPrice) {
      AlertMessages.add({
        msg: 'Total Price cannot be negative, blank or zero.',
        type: 'danger'
      });
      vm.status.editPrice = false;
    } else {
      // Valid price. Update appointment with new price
      Appointment.update({
        id: vm.currentAppointment.id,
        price: newPrice
      }).then(function (appointment) {
        vm.status.editPrice = false;
        vm.price = appointment.price.toString();
        updateAppointmentsData(appointment);
      }, function () {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.paymentUpdateError,
          type: 'danger'
        });
      });
    }
  }

  /**
   * @name resetPrice
   * @description Function to reset the price of an appointment.
   */
  function resetPrice() {
    vm.price = vm.currentAppointment.price;
    vm.status.editPrice = false;
  }

  /**
   * @name updateOperator
   * @description Function to update the operator assigned to an appointment
   * @param {object} operator The operator to assign to the appointment.
   */
  function updateOperator(operator) {
    var updatedAppointment = _lodash2.default.cloneDeep(vm.currentAppointment);
    updatedAppointment.managed_by = operator;
    Appointment.update(updatedAppointment).then(function (appointment) {
      vm.status.editOwner = false;
      updateAppointmentsData(appointment);
    });
  }

  /**
   * @name updateAppointmentsData
   * @description Function to update the current appointent and  array of
   * appointments that build. The appointment sessions tabs after one of the
   * appointments listed is updated
   * @param {object} appointment The appointment to be inserted into the array
   */
  function updateAppointmentsData(appointment) {
    // Update the current appointment
    vm.currentAppointment = appointment;

    // Get the appointment shop again TODO Refactor the shop to a different data
    // structure to avoid making this call in the future
    Shop.get(vm.currentAppointment.shop).then(function (response) {
      vm.currentAppointment.shop = response;

      // Get the shop's message tempaltes
      MessageTemplates.get(appointment.shop.message_templates).then(function (response) {
        appointment.shop.messageTemplates = response;
      });

      // Update the current appointment on the parent component
      vm.onAppointmentChange({ appointment: appointment });
    });

    // Update appointment activity
    var conversationId = vm.currentAppointment.conversations;
    var projectId = void 0;
    $rootScope.$broadcast('merge-activity', conversationId, vm.currentAppointment.id, projectId);
  }
}

angular.module('inkfinder').controller('AppointmentController', AppointmentController);

/***/ }),

/***/ "./components/appointments/appointment/appointment.data.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('AppointmentData', ['$q', '$http', '$rootScope', '$interval', 'ENDPOINT', 'moment', 'Appointment', 'Project', '_', function AppointmentData($q, $http, $rootScope, $interval, ENDPOINT, moment, Appointment, Project, _) {
  // Public variables
  AppointmentData.project = {};
  AppointmentData.appointments = {};
  AppointmentData.currentAppointment = {};

  // Public methods
  AppointmentData.matchAppointment = matchAppointment;
  AppointmentData.get = get;
  AppointmentData.refresh = refresh;
  AppointmentData.reset = reset;

  // Private variables
  var timer = void 0;
  var refreshing = false;
  var timestamp = void 0;
  var refreshInterval = void 0;

  /**
  * @name matchAppointment
  * @description Function to match the selected appoinment with one in the
  * appointments array for a specific project. This sets the selected
  * appointment on the view.
  * @param {number} appointmentId The appointment ID of the selected appointment.
  */
  function matchAppointment(appointmentId) {
    var selectedAppointment = _.find(AppointmentData.appointments, function (appointment) {
      if (appointment.id === Number(appointmentId)) {
        return true;
      }
    });
    AppointmentData.currentAppointment = selectedAppointment;
  }

  /**
   * @name refresh
   * @description Function to determine if we should get new data from the API.
   * @param {number} id The ID of the appointment to retrieve.
   * @return {promise} Promise Returns a promise so the resolve on the state
   * loads.
   */
  function refresh() {
    return $q(function (resolve, reject) {
      if (shouldRefresh()) {
        resolve(get(AppointmentData.currentAppointment.id));
      } else {
        resolve('Load cache');
      }
    });
  }

  /**
   * @name createAppointmentTimer
   * @description Function to create an internal timer and call
   * refreshAppointments() at a specific interval.
   * @param {number} id The ID of the appointment to retrieve.
   */
  function createAppointmentTimer() {
    timer = $interval(function () {
      refresh();
    }, 1000);
  }

  /**
   * @name shouldRefresh
   * @description Unknown
   * @return {boolean} boolean Returns true/false depending on refreshing and updated.
   */
  function shouldRefresh() {
    var result = void 0;
    var isNotRefreshing = !refreshing;
    var now = moment();
    var isTime = !refreshInterval || now.diff(refreshInterval, 'seconds') >= 5;
    result = isNotRefreshing && isTime;
    return result;
  }

  /**
   * @name get
   * @description Function to get a single appointment and project
   * @param {number} id The ID number of the appointment to retrieve
   * @return {empty} Empty Returns without sending data.
   */
  function get(id) {
    refreshing = true;
    var _timestamp = null;
    if (timestamp) {
      _timestamp = timestamp.format('X');
    }
    return Appointment.get(id, _timestamp).then(function (appointment) {
      refreshing = false;
      refreshInterval = moment();
      return Project.get(appointment.project).then(function (project) {
        timestamp = moment();
        if (!timer) {
          createAppointmentTimer();
        }
        AppointmentData.appointments = project.appointments;
        AppointmentData.project = project;
        if (!AppointmentData.currentAppointment.id || appointment.id === AppointmentData.currentAppointment.id) {
          AppointmentData.currentAppointment = appointment;
        }
      });
    });
  }

  var deregister = $rootScope.$on('clear-data', reset);
  $rootScope.$on('$destroy', deregister);

  /**
   * @name reset
   * @description Reset variables
   */
  function reset() {
    AppointmentData.project = {};
    AppointmentData.appointments = {};
    AppointmentData.currentAppointment = {};
    $interval.cancel(timer);
    refreshing = false;
    refreshInterval = null;
    timestamp = null;
  }
  return AppointmentData;
}]);

/***/ }),

/***/ "./components/appointments/appointment/appointment.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Appointment', ['$http', 'ENDPOINT', 'Project', 'Session', 'moment', 'AlertMessages', 'FormatProject', 'FormatAppointment', 'AppointmentApiFormat', '_', function Appointment($http, ENDPOINT, Project, Session, moment, AlertMessages, FormatProject, FormatAppointment, AppointmentApiFormat, _) {
  // Public Functions
  Appointment.get = get;
  Appointment.create = create;
  Appointment.update = update;

  /**
   * @name get
   * @description Function to retrieve a single appointment from the API.
   * @param {number} appointmentId The ID of the appointment to retrieve.
   * @param {number} timestamp The ID of the appointment to retrieve.
   * @return {promise} Returns a promise from the $http.
   */
  function get(appointmentId, timestamp) {
    var role = Session.activeState.role;
    var associationId = void 0;
    if (!_.isUndefined(Session.activeState.association)) {
      associationId = Session.activeState.association.id;
    }
    return $http.get(ENDPOINT.server + 'appointments/api/v1.1/' + appointmentId + '/' + '?role=' + role + (associationId ? '&association_id=' + associationId : '')).then(function (response) {
      return FormatAppointment.format(response.data);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name create
   * @description Function to create an appointment
   * @param {object} input The appointment data
   * @param {Unknown} status Unknown
   * @return {object} Returns the new appointment
   */
  function create(input, status) {
    if (!status) {
      status = null;
    }
    // Association ID and role are being added in the format function
    var appointment = AppointmentApiFormat.format(input, status);
    return $http.post(ENDPOINT.server + 'appointments/api/v1.1/', appointment).then(function (response) {
      return FormatAppointment.format(response.data);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name update
   * @description Function to update an appointment
   * @param {object} input The appointment data
   * @param {Unknown} status Unknown
   * @return {object} Returns the updated appointment.
   */
  function update(input, status) {
    // Association ID and role are being added in the format function
    var appointment = AppointmentApiFormat.format(input, status);
    return $http.put(ENDPOINT.server + 'appointments/api/v1.1/' + appointment.id + '/', appointment).then(function (response) {
      return FormatAppointment.format(response.data);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return Appointment;
}]);

/***/ }),

/***/ "./components/appointments/appointment/appointment.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"\" ng-class=\"{'cancelled' : $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.requestDeclined || $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.declined || $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.collectorCancelled || $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.artistCancelled, 'active' : $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.requested || $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.unconfirmed || $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.confirmed, 'complete' : $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.completed, 'archived' : $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.archived}\"> <div class=row> <div class=col-sm-12> <div class=appointment-sessions ng-if=$ctrl.currentAppointment> <a class=appointment-session ng-class=\"{'active': $ctrl.currentAppointment.id === appointment.id}\" ng-repeat=\"appointment in $ctrl.appointments | orderBy:'appointment_datetime' track by appointment.id\" ng-click=$ctrl.selectAppointment(appointment.id)> <p> <span>Session</span> {{$index + 1}} </p> </a> <a class=\"appointment-session add\" ng-if=\"$ctrl.currentAppointment && $ctrl.session.activeState.role === 'operator'\" ng-click=$ctrl.addRelatedAppointment()> <p> <fa name=plus></fa> </p> </a> </div> </div> </div> <div class=row> <div class=col-sm-12> <div class=appointment-bar> <div class=\"flex-container flex-wrap\"> <div class=\"appointment-bar-body flex-container flex-column\"> <div class=appointment-bar-body-inner> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.requested\"> <fa name=envelope class=\"icon dark massive\"></fa> <h5>Appointment requested.</h5> <p> Waiting for a reply. <small ng-if=$ctrl.currentAppointment.preferredTime.description> <strong>Preferred appointment time:</strong> {{$ctrl.currentAppointment.preferredTime.description}}<span ng-if=$ctrl.currentAppointment.preferredTime>s</span> <span ng-if=$ctrl.currentAppointment.preferred_start_date> <span ng-if=$ctrl.currentAppointment.preferredTime>between</span> <span ng-if=!$ctrl.currentAppointment.preferredTime>Between</span> {{$ctrl.currentAppointment.preferred_start_date | amDateFormat:'MM/DD/YYYY'}} </span> <span ng-if=$ctrl.currentAppointment.preferred_end_date> <span ng-if=$ctrl.currentAppointment.preferred_start_date>and</span> {{$ctrl.currentAppointment.preferred_end_date | amDateFormat:'MM/DD/YYYY'}} </span> </small> </p> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.requestDeclined\"> <fa name=times-circle class=\"icon massive light\"></fa> <h5>This request has been declined.</h5> <p> The artist or operator declined on {{$ctrl.currentAppointment.last_status.created | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.last_status.created | amUtc | amLocal | amDateFormat:'h:mm a'}} </p> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.unconfirmed\"> <fa name=envelope class=\"icon dark massive\"></fa> <h5> <span ng-if=!$ctrl.currentAppointment.appointment_datetime>Waiting for appointment details.</span> <span ng-if=$ctrl.currentAppointment.appointment_datetime>Appointment unconfirmed.</span> <a ng-click=$ctrl.updateAppointment()> <fa name=pencil class=\"icon dark small link\" ng-if=\"$ctrl.session.activeState.role === 'operator'\"></fa> </a> </h5> <p ng-if=$ctrl.currentAppointment.appointment_datetime> Scheduled for {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'h:mm a'}} </p> <p ng-if=!$ctrl.currentAppointment.appointment_datetime> No appointment has been set. </p> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.confirmed\"> <fa name=calendar-o class=\"icon dark massive\"></fa> <h5>Appointment confirmed for {{$ctrl.currentAppointment.calendarTime}}.&nbsp;<a ng-click=$ctrl.updateAppointment()><fa name=pencil class=\"icon dark small link\" ng-if=\"$ctrl.session.activeState.role === 'operator'\"></fa> </a> </h5> <p> From {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'h:mm a'}} to {{$ctrl.currentAppointment.end_date | amDateFormat:'h:mm a'}} </p> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.declined\"> <fa name=times-circle class=\"icon massive light\"></fa> <h5>This appointment has been declined by {{$ctrl.project.collector.first_name}} {{$ctrl.project.collector.last_name}}.</h5> <p> Declined on {{$ctrl.currentAppointment.last_status.created | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.last_status.created | amUtc | amLocal | amDateFormat:'h:mm a'}}<br/> <small> Originally scheduled on {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'h:mm a'}} </small> </p> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.completed\"> <fa name=check class=\"icon dark massive\"></fa> <h5>Complete.</h5> <p> Marked as complete on {{$ctrl.currentAppointment.last_status.created | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.last_status.created | amUtc | amLocal | amDateFormat:'h:mm a'}}<br/> <small> Originally scheduled on {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'h:mm a'}} </small> </p> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.collectorCancelled\"> <fa name=times-circle class=\"icon massive light\"></fa> <h5>This appointment has been cancelled.</h5> <p> <span ng-if=\"$ctrl.session.activeState.role === 'collector'\">You</span> <span ng-if=\"$ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'operator'\">The collector</span> cancelled on {{$ctrl.currentAppointment.last_status.created | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.last_status.created | amUtc | amLocal | amDateFormat:'h:mm a'}}<br/> <small> Originally scheduled on {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'h:mm a'}} </small> </p> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.artistCancelled\"> <fa name=times-circle class=\"icon massive light\"></fa> <h5>This appointment has been cancelled.</h5> <p> The artist or shop operator cancelled on {{$ctrl.currentAppointment.last_status.created | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.last_status.created | amUtc | amLocal | amDateFormat:'h:mm a'}}<br/> <small>Originally scheduled on {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'h:mm a'}} </small> </p> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.archived\"> <fa name=times-circle class=\"icon massive light\"></fa> <h5>This appointment has been permanently archived.</h5> <p> The artist or shop operator archived on {{$ctrl.currentAppointment.last_status.created | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.last_status.created | amUtc | amLocal | amDateFormat:'h:mm a'}}<br/> <small>Originally scheduled on {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.currentAppointment.appointment_datetime | amDateFormat:'h:mm a'}} </small> </p> </div> <div class=row> <div class=\"col-xs-2 col-xs-offset-3 right\"> <ink-profile-photo profile=$ctrl.project.collector image-id=$ctrl.project.collector.profile_photo size=\"'small'\" show-name=false> </ink-profile-photo> </div> <div class=\"col-xs-2 center\"> <div class=\"plus dark\"> <div class=width></div> <div class=height></div> </div> </div> <div class=\"col-xs-2 left\"> <ink-profile-photo profile=$ctrl.currentAppointment.artist image-id=$ctrl.currentAppointment.artist.profile_photo size=\"'small'\" show-name=false> </ink-profile-photo> </div> <div class=\"col-xs-12 appointment-players\"> <p class=no-margin> <small> <strong> <span ng-if=$ctrl.currentAppointment.artist> {{$ctrl.project.collector.first_name}} {{$ctrl.project.collector.last_name}} with artist {{$ctrl.currentAppointment.artist.first_name}} {{$ctrl.currentAppointment.artist.last_name}} at </span> {{$ctrl.currentAppointment.shop.name}} </strong> <span ng-if=\"$ctrl.session.activeState.role === 'collector' || $ctrl.session.activeState.role === 'artist'\"> <br/> <a class=dark-link ng-href={{$ctrl.currentAppointment.shop.gmaddress_url}} target=_blank><fa name=map-marker></fa></a> <a class=dark-link ng-href={{$ctrl.currentAppointment.shop.gmaddress_url}} target=_blank> {{$ctrl.currentAppointment.shop.gmaddress}} </a> <br/> <a class=dark-link ng-if=$ctrl.currentAppointment.shop.phone href=tel:{{$ctrl.currentAppointment.shop.phone}}> <fa name=phone></fa> {{$ctrl.currentAppointment.shop.phone | tel}} </a> </span> </small> </p> </div> </div> </div> <div class=appointment-bar-footer> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.requested\"> <div class=button-container ng-if=\"($ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'operator') && $ctrl.canUpdateAppts\"> <button class=\"button medium shop-solid\" ng-if=\"$ctrl.session.activeState.role === 'operator'\" ng-click=$ctrl.updateAppointment()>Set appointment</button> <button class=\"button medium alert-btn-light\" ng-click=$ctrl.declineRequest()>Decline</button> </div> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.unconfirmed\"> <div class=button-container ng-if=\"($ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'operator') && $ctrl.canUpdateAppts\"> <button class=\"button medium dark equal-medium\" ng-if=\"$ctrl.session.activeState.role === 'operator' && (!$ctrl.currentAppointment.artist || !$ctrl.currentAppointment.appointment_datetime)\" ng-click=$ctrl.updateAppointment()>Set appointment</button> <button class=\"button medium shop-solid equal-medium\" ng-click=$ctrl.confirmAppointment() ng-if=\"$ctrl.currentAppointment.artist && $ctrl.currentAppointment.appointment_datetime\"> Confirm </button> <button class=\"button medium alert-btn-light equal-medium\" ng-click=$ctrl.declineRequest()>Decline</button> </div> <div class=button-container ng-if=\"$ctrl.session.activeState.role === 'collector'\"> <button class=\"button medium equal-medium shop-solid\" ng-click=$ctrl.openAppointmentResponseModal($ctrl.currentAppointment)> Respond </button> </div> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.confirmed\"> <div class=button-container ng-if=\"($ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'operator') && $ctrl.canUpdateAppts\"> <button class=\"button medium shop-solid disabled shop-tooltip equal-medium\" ng-if=$ctrl.currentAppointment.isPast tooltip-placement=top uib-tooltip=\"You can’t complete an appointment that hasn't started yet.\"> Complete </button> <button class=\"button medium shop-solid disabled shop-tooltip equal-medium\" tooltip-placement=top uib-tooltip=\"Zero out the balance to complete this appointment.\" ng-if=\"$ctrl.currentAppointment.paymentData.balance !== 0 &&\n                    !$ctrl.currentAppointment.isPast &&\n                    !$ctrl.currentAppointment.previously_paid\"> Complete </button> <button class=\"button medium shop-solid equal-medium\" ng-click=$ctrl.completeAppointment() ng-if=\"($ctrl.currentAppointment.paymentData.price !== 0 &&\n                    $ctrl.currentAppointment.paymentData.total !== 0 &&\n                    $ctrl.currentAppointment.paymentData.balance === 0 && !$ctrl.currentAppointment.isPast) ||\n                    (!$ctrl.currentAppointment.isPast && $ctrl.currentAppointment.previously_paid)\"> Complete </button> <button class=\"button medium alert-btn-light equal-medium\" ng-click=$ctrl.cancelAppointment()>Cancel</button> </div> <div ng-if=\"!$ctrl.currentAppointment.paymentData.hasPaidDeposit && $ctrl.currentAppointment.deposit_amount > 0 && !$ctrl.currentAppointment.previously_paid && $ctrl.session.activeState.role === 'collector'\"> <div class=button-container ng-if=$ctrl.currentAppointment.shop.deposit_payment_URL> <button class=\"button medium shop-solid\" ng-click=$ctrl.openDepositModal()>Pay deposit</button> </div> </div> </div> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.artistCancelled || $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.declined\"> <div class=button-container ng-if=\"($ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'operator') && $ctrl.canUpdateAppts\"> <button class=\"button medium shop-solid equal-medium\" ng-click=$ctrl.updateAppointment() ng-if=\"$ctrl.currentAppointment.artist && $ctrl.currentAppointment.appointment_datetime\"> Reschedule </button> <button type=button class=\"button medium alert-btn-light equal-medium\" ng-click=$ctrl.archiveAppointment()> Archive </button> </div> </div> </div> </div> <div class=appointment-details> <div class=row> <div class=\"col-xs-6 col-sm-4 col-lg-4\"> <div ng-if=$ctrl.currentAppointment.previously_paid> <label class=stacked> Price </label> <p><fa name=check></fa> Previously paid</p> </div> <div ng-if=!$ctrl.currentAppointment.previously_paid> <div ng-if=\"($ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'operator') && $ctrl.currentAppointment.last_status.status_id !== $ctrl.STATUS_IDS.completed\"> <label class=stacked>Price</label> <a ng-click=\"$ctrl.status.editPrice = !$ctrl.status.editPrice\" ng-class=\"{'hidden': $ctrl.status.editPrice}\" event-focus=click event-focus-id=project_price> <p> {{$ctrl.currentAppointment.paymentData.price | noFractionCurrency}} <fa name=pencil size=1 class=\"icon light small link\"></fa> </p> </a> <div class=form-group ng-class=\"{'hidden': !$ctrl.status.editPrice}\"> <input title=\"Appointment status\" type=text id=project_price step=0.01 class=\"light-color inline price-field\" fcsa-number=\"{ prepend: '$', maxDecimals: 2 }\" ng-model=$ctrl.price ng-change=\"$ctrl.status.editPrice = true\" ng-keyup=\"$event.keyCode === 13 && $ctrl.updatePrice($ctrl.price)\" ng-disabled=\"$ctrl.currentAppointment.last_status.status_id !== $ctrl.STATUS_IDS.unconfirmed && $ctrl.currentAppointment.last_status.status_id !== $ctrl.STATUS_IDS.confirmed\"> <div class=inline-confirm-icons> <a ng-click=$ctrl.updatePrice($ctrl.price)> <fa name=check class=\"shop-color confirm\"></fa> </a> <a ng-click=$ctrl.resetPrice()> <fa name=times-circle class=\"alert-color cancel\"></fa> </a> </div> </div> </div> <div ng-if=\"$ctrl.session.activeState.role === 'collector' || $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.completed\"> <label class=stacked>Price</label> <p ng-if=$ctrl.currentAppointment.paymentData.price> {{$ctrl.currentAppointment.paymentData.price | noFractionCurrency}} </p> <p ng-if=!$ctrl.currentAppointment.paymentData.price> None </p> </div> </div> </div> <div class=\"col-xs-6 col-sm-4 col-lg-4\" ng-if=!$ctrl.currentAppointment.previously_paid> <label class=stacked>Payments</label> <a ng-click=$ctrl.updatePayment() ng-if=\"$ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'operator'\"> <p class=shop-color> {{$ctrl.currentAppointment.paymentData.total | noFractionCurrency}} <fa name=pencil size=1 class=\"icon light small link\"></fa> </p> </a> <p class=\"\" ng-class=\"{'shop-color': $ctrl.currentAppointment.paymentData.total}\" ng-if=\"$ctrl.session.activeState.role === 'collector'\"> <span ng-if=!$ctrl.currentAppointment.paymentData.total> None </span> <span ng-if=$ctrl.currentAppointment.paymentData.total> {{$ctrl.currentAppointment.paymentData.total | noFractionCurrency}} </span> </p> </div> <div class=\"col-xs-6 col-sm-4 col-lg-4\" ng-if=\"($ctrl.currentAppointment.paymentData.balance >= 0 || $ctrl.currentAppointment.paymentData.balance <= 0) && $ctrl.currentAppointment.paymentData.price > 0\"> <label class=stacked>Balance</label> <p class=alert-color>{{$ctrl.currentAppointment.paymentData.balance | noFractionCurrency}}</p> </div> <div class=\"col-xs-6 col-sm-4 col-lg-4\"> <label class=stacked>Tip</label> <p ng-if=$ctrl.currentAppointment.paymentData.tipTotal> {{$ctrl.currentAppointment.paymentData.tipTotal | noFractionCurrency}} </p> <p ng-if=!$ctrl.currentAppointment.paymentData.tipTotal> None </p> </div> <div class=\"col-xs-6 col-sm-4 col-lg-4\" ng-if=!$ctrl.currentAppointment.previously_paid> <label class=stacked>Estimate</label> <p ng-if=\"$ctrl.currentAppointment.estimate_min && $ctrl.currentAppointment.estimate_max\"> {{$ctrl.currentAppointment.estimate_min | noFractionCurrency}}–{{$ctrl.currentAppointment.estimate_max | noFractionCurrency}} </p> <p ng-if=\"!$ctrl.currentAppointment.estimate_min && !$ctrl.currentAppointment.estimate_max\"> None </p> </div> <div class=\"col-xs-6 col-sm-4 col-lg-4\" ng-if=\"!$ctrl.currentAppointment.previously_paid && $ctrl.currentAppointment.last_status.status_id !== $ctrl.STATUS_IDS.requested\"> <label class=stacked>Deposit</label> <p ng-if=\"$ctrl.currentAppointment.deposit_amount > 0 && !$ctrl.currentAppointment.previously_paid\"> <fa name=check class=shop-color ng-if=\"$ctrl.currentAppointment.paymentData.hasPaidDeposit && $ctrl.currentAppointment.deposit_amount > 0\"></fa> {{$ctrl.currentAppointment.deposit_amount | noFractionCurrency}} <button class=\"button small shop-solid\" ng-click=$ctrl.openDepositModal() ng-if=\"$ctrl.session.activeState.role === 'collector' && $ctrl.currentAppointment.paymentData.hasPaidDeposit === false && $ctrl.currentAppointment.shop.deposit_payment_URL &&  $ctrl.currentAppointment.last_status.status_id === $ctrl.STATUS_IDS.confirmed\"> Pay </button> </p> <p ng-if=\"!$ctrl.currentAppointment.deposit_amount || $ctrl.currentAppointment.deposit_amount == 0 || $ctrl.currentAppointment.previously_paid\">No deposit required</p> </div> <div class=\"col-xs-6 col-sm-4 col-lg-4\" ng-if=\"$ctrl.currentAppointment.last_status.status_id !== $ctrl.STATUS_IDS.requested\"> <div ng-if=\"$ctrl.currentAppointment.agreed_to_cancellation_policy || $ctrl.session.activeState.role !== 'collector'\"> <label class=stacked>Cancellation policy</label> <p ng-if=$ctrl.currentAppointment.agreed_to_cancellation_policy> <fa name=check class=shop-color></fa> Agreed </p> <p ng-if=!$ctrl.currentAppointment.agreed_to_cancellation_policy> <fa name=thumbs-down class=alert-color></fa> Not agreed </p> </div> </div> <div class=\"col-xs-6 col-sm-4 col-lg-4\"> <label class=stacked>Managed by</label> <p> <span ng-if=\"$ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'collector'\"> <span ng-if=$ctrl.currentAppointment.managed_by> {{$ctrl.currentAppointment.managed_by.first_name}} {{$ctrl.currentAppointment.managed_by.last_name}} </span> <span ng-if=!$ctrl.currentAppointment.managed_by> Not set </span> </span> <span ng-if=\"$ctrl.session.activeState.role === 'operator'\"> <span ng-if=\"$ctrl.status.editOwner === false && !$ctrl.currentAppointment.managed_by\"> <button class=\"button small gray\" ng-click=\"$ctrl.status.editOwner = !$ctrl.status.editOwner\"> Add </button> </span> <span ng-if=\"$ctrl.status.editOwner === true\"> <span class=edit-owner> <select class=\"small full\" title=\"Managed by\" ng-model=$ctrl.currentAppointment.managed_by.id value=operator.id ng-options=\"operator.id as (operator.first_name+' '+operator.last_name) for operator in $ctrl.operators.confirmed\"> </select> <a ng-click=$ctrl.updateOperator($ctrl.currentAppointment.managed_by)> <fa name=check class=shop-color></fa> </a> <a ng-click=\"$ctrl.status.editOwner = !$ctrl.status.editOwner\"> <fa name=times-circle class=alert-color></fa> </a> </span> </span> <span ng-if=\"$ctrl.status.editOwner === false && $ctrl.currentAppointment.managed_by\"> <a ng-click=\"$ctrl.status.editOwner = !$ctrl.status.editOwner\"> {{$ctrl.currentAppointment.managed_by.first_name}} {{$ctrl.currentAppointment.managed_by.last_name}}&nbsp;<fa name=pencil class=\"icon small link\"></fa> </a> </span> </span> </p> </div> <div class=col-xs-12> <label class=stacked>Guides</label> <p ng-if=!$ctrl.currentAppointment.shop.message_templates> None available </p> </div> <div ng-if=$ctrl.currentAppointment.shop.message_templates> <div class=col-xs-12> <p class=no-margin ng-if=\"$ctrl.currentAppointment.shop.messageTemplates.tattoo_process !== '' && $ctrl.currentAppointment.shop.messageTemplates.tattoo_process !== null\"> <a ng-click=\"$ctrl.readMessageTemplate('Our tattoo process', $ctrl.currentAppointment.shop.messageTemplates.tattoo_process)\"> <fa name=caret-right></fa> Tattoo process </a> </p> </div> <div class=col-xs-12> <p class=no-margin ng-if=\"$ctrl.currentAppointment.shop.messageTemplates.aftercare_instructions !== '' && $ctrl.currentAppointment.shop.messageTemplates.aftercare_instructions !== null\"> <a ng-click=\"$ctrl.readMessageTemplate('Aftercare instructions', $ctrl.currentAppointment.shop.messageTemplates.aftercare_instructions)\"> <fa name=caret-right></fa> Aftercare instructions </a> </p> </div> <div class=col-xs-12> <p class=no-margin ng-if=\"$ctrl.currentAppointment.shop.messageTemplates.cancellation_policy !== '' && $ctrl.currentAppointment.shop.messageTemplates.cancellation_policy !== null\"> <a ng-click=\"$ctrl.readMessageTemplate('Our cancellation policy', $ctrl.currentAppointment.shop.messageTemplates.cancellation_policy)\"> <fa name=caret-right></fa> Cancellation policy </a> </p> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/appointments/appointment/archive/archive.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ArchiveAppointmentController.$inject = ['$uibModalInstance', 'Appointment', 'appointment', '_'];


/**
 * @name ArchiveAppointmentController
 * @description Controller for archiving appointments
 * @param {type} $uibModalInstance Description
 * @param {type} Appointment Description
 * @param {type} appointment Description
 * @param {library} _ The Lodash library
 */
function ArchiveAppointmentController($uibModalInstance, Appointment, appointment, _) {
  var vm = this;
  vm.appointment = _.cloneDeep(appointment);

  vm.submit = function () {
    var status = 100;

    // Send the Appointment Update
    Appointment.update(vm.appointment, status).then(function (appointment) {
      $uibModalInstance.close(appointment);
    });
  };

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('ArchiveAppointmentController', ArchiveAppointmentController);

/***/ }),

/***/ "./components/appointments/appointment/archive/archive.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=archiveRequestForm ng-submit=\"archiveRequestForm.$valid && $ctrl.submit()\" novalidate> <div class=modal-header> <h4 class=modal-title>Archive this appointment</h4> </div> <div class=\"modal-body background-light\"> <h5>When is it time to archive an appointment?</h5> <ul> <li>The cancelled appointment is not being re-scheduled for any reason.</li> <li>The client for the cancelled unconfirmed appointment is non-responsive after multiple attempts to contact.</li> <li>The cancelled appointment is older than two years.</li> <li>The cancelled appointment is with an artist that no longer works at the shop.</li> </ul> <p><strong>Hit the archive button below to permanently archive this appointment.</strong></p> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Archive</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/appointments/appointment/archive/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/archive/archive.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/cancel/cancel.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


CancelAppointmentController.$inject = ['$uibModalInstance', 'Appointment', 'appointment', 'project', 'Notification', 'Session', 'NOTIFICATIONS'];


/**
 * @name CancelAppointmentController
 * @description Controller to cancel appointments
 * @param {library} $uibModalInstance The $uibModalInstance library from ui bootstrap
 * @param {service} Appointment The Appointment service
 * @param {resolve} appointment The appointment resolved from the parent controller
 * @param {resolve} project The projects resolved from the parent controller
 * @param {service} Notification The Notification service
 * @param {service} Session The Session service
 * @param {constant} NOTIFICATIONS The NOTIFICATIONS constant
 */
function CancelAppointmentController($uibModalInstance, Appointment, appointment, project, Notification, Session, NOTIFICATIONS) {
  var vm = this;
  vm.cancelType = 'temporary';
  vm.appointment = appointment;
  vm.project = project;

  vm.submit = function () {
    var status = void 0;
    if (vm.cancelType === 'temporary') {
      status = 10;
    } else if (vm.cancelType === 'permanent') {
      status = 90;
    }

    // Send the Appointment Update
    Appointment.update(vm.appointment, status).then(function (appointment) {
      $uibModalInstance.close(appointment);

      // Send the reschedule later notification
      if (vm.cancelType === 'temporary') {
        var rescheduleNotification = {
          recipients: [/* API to send to everyone connected to this appointment */],
          notificationId: NOTIFICATIONS.appointmentReschedule,
          messageObjects: {
            appointmentId: vm.appointment.id,
            projectId: vm.appointment.project,
            artistId: vm.appointment.artist.id, // The artist assigned to the appointment
            collectorId: vm.project.collector.id, // The collector who owns the project
            operatorId: Session.collector.id // The operator/artist who's logged in and has cancelled the apointment
          },
          messageVariables: {
            subject: Session.collector.first_name + ' ' + Session.collector.last_name + ' cancelled this appointment and plans to reschedule a new one later'
          }
        };
        Notification.send(rescheduleNotification);

        // Send the cancellation notification
      } else if (vm.cancelType === 'permanent') {
        var cancelNotification = {
          recipients: [/* API to send to everyone connected to this appointment */],
          notificationId: NOTIFICATIONS.appointmentCancellation,
          messageObjects: {
            appointmentId: vm.appointment.id,
            projectId: vm.appointment.project,
            artistId: vm.appointment.artist.id, // The artist assigned to the appointment
            collectorId: vm.project.collector.id, // The collector who owns the project
            operatorId: Session.collector.id // The operator/artist who's logged in and has cancelled the apointment
          },
          messageVariables: {
            subject: Session.collector.first_name + ' ' + Session.collector.last_name + ' cancelled this appointment'
          }
        };
        Notification.send(cancelNotification);
      }
    });
  };

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('CancelAppointmentController', CancelAppointmentController);

/***/ }),

/***/ "./components/appointments/appointment/cancel/cancel.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=declineRequestForm ng-submit=\"declineRequestForm.$valid && $ctrl.submit()\" novalidate> <div class=modal-header> <h4 class=modal-title>Cancel this appointment</h4> </div> <div class=\"modal-body background-light center\"> <h5>How would you like to cancel this appointment?</h5> <div class=\"form-group center\"> <div class=\"input-group toggle inline\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.cancelType === 'temporary'}\"> <input type=radio name=cancelType ng-model=$ctrl.cancelType ng-value=\"'temporary'\">Reschedule later </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.cancelType === 'permanent'}\"> <input type=radio name=cancelType ng-model=$ctrl.cancelType ng-value=\"'permanent'\">Cancel for now </label> </div> </div> </div> <div ng-if=\"$ctrl.cancelType === 'temporary'\"> <p>The appointment status will be changed to Estimated instead of Confirmed so you can reschedule it later.</p> <p><small>You will find it under Unconfirmed appointments in Clients.</small></p> </div> <div ng-if=\"$ctrl.cancelType === 'permanent'\"> <p>This appointment will be cancelled.</p> <p><small>You’ll be able to schedule this appointment again in the future.</small></p> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/appointments/appointment/cancel/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/cancel/cancel.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/complete/complete.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


CompleteAppointmentController.$inject = ['$uibModalInstance', 'Appointment', 'appointment', 'project', 'shopMessageTemplates', 'moment', 'NOTIFICATIONS', 'Session', 'Notification', 'AlertMessages', 'Project', 'FormatProject', 'Activity', 'Messages', '_', '$q', '$log', 'collectorWantsNotif'];
/**
 * @name CompleteAppointmentController
 * @description Controller for completing appointments
 * @param {library} $uibModalInstance The modal instance from UI Boostrap
 * @param {service} Appointment The appointment service
 * @param {object} appointment The appointment resolve
 * @param {object} project The project resolve
 * @param {object} shopMessageTemplates The shopMessageTemplates resolve
 * @param {library} moment The moment library
 * @param {constant} NOTIFICATIONS The notifications constant
 * @param {service} Session The Session service
 * @param {service} Notification The notification service
 * @param {service} AlertMessages The alert messages constant
 * @param {service} Project The project service
 * @param {service} FormatProject The format project service
 * @param {service} Activity The Activity service
 * @param {service} Messages The Messages service
 * @param {library} _ The Lodash library
 * @param {angular} $q The Angular $q service
 * @param {angular} $log The Angular $log service
 * @param {service} collectorWantsNotif The collectorWantsNotif service
 */
function CompleteAppointmentController($uibModalInstance, Appointment, appointment, project, shopMessageTemplates, moment, NOTIFICATIONS, Session, Notification, AlertMessages, Project, FormatProject, Activity, Messages, _, $q, $log, collectorWantsNotif) {
  var vm = this;

  vm.shopMessageTemplates = shopMessageTemplates;
  vm.appointment = _.cloneDeep(appointment);
  vm.projectTmp = _.cloneDeep(project);
  vm.session = Session;
  vm.appointmentDateTime = null;
  vm.endNow = true;
  vm.currentTime = moment().format('hh:mm a');
  vm.completeAppointment = completeAppointment;
  vm.message = {
    cid: vm.appointment.conversations,
    content: null,
    private: false
  };

  determineProjectStatus();

  /**
   * @name completeAppointment
   * @description Function to complete an appointment
   */
  function completeAppointment() {
    var status = 70;

    var promises = $q.all({});

    // Check to see if the appiontment ended early
    if (vm.endNow && vm.inProgress) {
      vm.appointment.adjustedLength = parseInt(Math.abs(moment(vm.appointmentDateTime).unix() - moment().unix()) / 60, 10);
    }

    // Send the Appointment Update
    promises.appointment = Appointment.update(vm.appointment, status).then(function (appointment) {
      // Send a notification to the collector
      var notificationToCollector = {
        recipients: [vm.projectTmp.collector.id],
        notificationId: NOTIFICATIONS.appointmentCompleteToCollector,
        messageObjects: {
          appointmentId: vm.appointment.id,
          projectId: vm.projectTmp.id,
          // The artist assigned to the appointment
          artistId: vm.appointment.artist.id,
          // The operator updating the appointment
          operatorId: Session.collector.id,
          // The collector who owns the project
          collectorId: vm.projectTmp.collector.id
        },
        messageVariables: {
          subject: vm.projectTmp.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' completed an appointment for your project on Ink Finder',
          aftercareInstructions: vm.shopMessageTemplates && vm.shopMessageTemplates.aftercare_instructions !== '' ? vm.shopMessageTemplates.aftercare_instructions : ''
        }
      };
      if (Session.activeState.association && Session.activeState.association.shop.id) {
        notificationToCollector.messageObjects.shopId = Session.activeState.association.shop.id;
        notificationToCollector.messageVariables.subject = vm.projectTmp.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' at ' + Session.activeState.association.shop.name + ' completed an appointment for your project on Ink Finder';
      }
      Notification.send(notificationToCollector);

      // Send a notification to the artist if the artist did not complete appt
      if (vm.appointment.artist.id !== Session.collector.id) {
        var notificationToArtist = {
          recipients: [vm.appointment.artist.id],
          notificationId: NOTIFICATIONS.appointmentCompleteToArtist,
          messageObjects: {
            appointmentId: vm.appointment.id,
            projectId: vm.projectTmp.id,
            // The artist assigned to the appointment
            artistId: vm.appointment.artist.id,
            // The operator updating the appointment
            operatorId: Session.collector.id,
            // The collector who owns the project
            collectorId: vm.projectTmp.collector.id
          },
          messageVariables: {
            subject: vm.appointment.artist.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' completed your appointment with ' + vm.projectTmp.collector.first_name
          }
        };
        if (Session.activeState.association && Session.activeState.association.shop.id) {
          notificationToArtist.messageObjects.shopId = Session.activeState.association.shop.id;
          notificationToArtist.messageVariables.subject = vm.appointment.artist.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' at ' + Session.activeState.association.shop.name + ' completed your appointment with ' + vm.projectTmp.collector.first_name;
        }
        collectorWantsNotif.check(appointment.artist.id, appointment.shop, 'appointment_completed', 'artist').then(function (collectorWantsNotif) {
          if (collectorWantsNotif) {
            Notification.send(notificationToArtist);
          }
        });
      }
      return appointment;
    });

    // Save a message on the appointment if one exists
    if (vm.message.content !== null && vm.message.content.replace(/\s/g, '').length) {
      promises.message = Messages.create(vm.message).then(function (message) {
        return message;
      });
    }

    // Process all promises
    $q.all(promises).then(function (results) {
      $uibModalInstance.close(results.appointment);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'warning' });
    });
  }

  /**
   * @name determineProjectStatus
   * @description Figure out of the Appointment is in Progress or not
   */
  function determineProjectStatus() {
    vm.appointmentDateTime = moment(vm.appointment.appointment_datetime);
    var length = vm.appointment.length;
    var endTime = moment(vm.appointmentDateTime).add(moment.duration(length).hours(), 'hours').add(moment.duration(length).minutes(), 'minutes');
    if (moment(vm.appointmentDateTime).unix() <= moment().unix() && moment(endTime).unix() > moment().unix()) {
      vm.inProgress = true;
    }
  }
  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('CompleteAppointmentController', CompleteAppointmentController);

/***/ }),

/***/ "./components/appointments/appointment/complete/complete.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=completeAppointmentForm ng-submit=\"completeAppointmentForm.$valid && $ctrl.completeAppointment()\" ng-model-options=\"{debounce: 500}\" novalidate> <div class=modal-header> <h4 class=modal-title>Complete this session</h4> </div> <div class=\"modal-body background-light\"> <div class=\"row center\"> <div class=players> <div class=\"col-sm-10 col-sm-offset-1\"> <h4>{{$ctrl.appointment.name}}</h4> <div class=row> <div class=\"col-sm-5 center\"> <ink-profile-photo profile=$ctrl.projectTmp.collector image-id=$ctrl.projectTmp.collector.profile_photo></ink-profile-photo> </div> <div class=col-sm-2> <div class=\"plus margin\"> <div class=width></div> <div class=height></div> </div> </div> <div class=\"col-sm-5 center\"> <ink-profile-photo profile=$ctrl.appointment.artist image-id=$ctrl.appointment.artist.profile_photo></ink-profile-photo> </div> </div> </div> </div> </div> <div class=row ng-if=$ctrl.inProgress> <div class=col-sm-12> <div class=\"divider small xtight\"></div> </div> <div class=col-sm-12> <h6>This session finished before the scheduled time.</h6> <p> <label> <input name=change_confirmation type=checkbox id=coverup ng-model=$ctrl.endNow checked=checked> Change the scheduled end time to match the time now ({{$ctrl.currentTime}}). </label> </p> </div> </div> <div class=row> <div class=col-md-12> <div class=\"divider transparent xtight\"></div> <div class=form-group> <label for=message><h6>Send a thank you message to {{$ctrl.projectTmp.collector.first_name}}</h6></label> <textarea msd-elastic=\\n placeholder=\"Write a message...\" name=message id=message class=background-light ng-model=$ctrl.message.content>\n          </textarea> </div> </div> </div> <div class=row> <div class=col-md-12> <p ng-if=\"$ctrl.shopMessageTemplates.aftercare_instructions !== ''\"> <fa name=check class=darkshop></fa> Your <strong>aftercare instructions</strong> will be sent to {{$ctrl.projectTmp.collector.first_name}} via email. </p> <div ng-if=\"$ctrl.shopMessageTemplates.aftercare_instructions === ''\"> <p class=no-margin> <fa name=thumbs-down class=alert-color></fa> Aftercare instructions <strong>will not</strong> be sent to {{$ctrl.projectTmp.collector.first_name}} via email. </p> <p> <small>Add aftercare instructions to your shop profile to start sending them to collectors after an appointment is completed.</small> </p> </div> </div> <div class=col-md-12> <p ng-if=\"$ctrl.shopMessageTemplates.followup_14day !== ''\"> <fa name=check class=darkshop></fa> Your <strong>14 day follow-up message</strong> will be sent to {{$ctrl.projectTmp.collector.first_name}} via email. </p> <div ng-if=\"$ctrl.shopMessageTemplates.followup_14day === ''\"> <p class=no-margin> <fa name=thumbs-down class=alert-color></fa> A 14 day follow-up message <strong>will not</strong> be sent to {{$ctrl.projectTmp.collector.first_name}} via email. </p> <p> <small>Add a 14 day follow-up message to your shop profile to start sending them to collectors after an appointment is completed.</small> </p> </div> </div> <div class=col-md-12> <p ng-if=\"$ctrl.shopMessageTemplates.followup_30day !== ''\"> <fa name=check class=darkshop></fa> Your <strong>30 day follow-up message</strong> will be sent to {{$ctrl.projectTmp.collector.first_name}} via email. </p> <div ng-if=\"$ctrl.shopMessageTemplates.followup_30day === ''\"> <p class=no-margin> <fa name=thumbs-down class=alert-color></fa> A 30 day follow-up message <strong>will not</strong> be sent to {{$ctrl.projectTmp.collector.first_name}} via email. </p> <p> <small>Add a 30 day follow-up message to your shop profile to start sending them to collectors after an appointment is completed.</small> </p> </div> </div> </div> <div class=\"divider transparent tight\"></div> <div class=\"inline-alert finder small\" ng-if=$ctrl.projectTmp.collector.email_is_confirmed> <fa name=thumbs-up></fa> {{$ctrl.projectTmp.collector.first_name}} will get an email notification about this update since their email address has been confirmed. </div> <div class=\"inline-alert warning small\" ng-if=!$ctrl.projectTmp.collector.email_is_confirmed> <fa name=thumbs-down></fa> {{$ctrl.projectTmp.collector.first_name}} will <strong>not</strong> get an email notification about this update since their email address hasn’t been confirmed. </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Complete</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/appointments/appointment/complete/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/complete/complete.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/confirm/confirm.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ConfirmAppointmentController.$inject = ['$uibModalInstance', 'Appointment', 'appointment', 'project', 'shopMessageTemplates', 'NOTIFICATIONS', 'Session', 'Notification', 'AlertMessages', 'Messages', '$q', 'collectorWantsNotif'];


/**
 * @name ConfirmAppointmentController
 * @description Controller for confirming appointments
 * @param {library} $uibModalInstance The modal instance from UI Boostrap
 * @param {service} Appointment The appointment service
 * @param {object} appointment The appointment resolve
 * @param {object} project The project resolve
 * @param {object} shopMessageTemplates The shopMessageTemplates resolve
 * @param {constant} NOTIFICATIONS The notifications constant
 * @param {service} Session The Session service
 * @param {service} Notification The notification service
 * @param {service} AlertMessages The alert messages constant
 * @param {service} Messages The Messages service
 * @param {angular} $q The Angular $q service
 * @param {service} collectorWantsNotif The collectorWantsNotif service
 */
function ConfirmAppointmentController($uibModalInstance, Appointment, appointment, project, shopMessageTemplates, NOTIFICATIONS, Session, Notification, AlertMessages, Messages, $q, collectorWantsNotif) {
  var vm = this;

  vm.shopMessageTemplates = shopMessageTemplates;
  vm.appointment = _lodash2.default.cloneDeep(appointment);
  vm.project = _lodash2.default.cloneDeep(project);
  vm.session = Session;
  vm.confirmAppointment = confirmAppointment;
  vm.message = {
    cid: vm.appointment.conversations,
    content: null,
    private: false
  };

  /**
   * @name confirmAppointment
   * @description Function to confirm an appointment
   */
  function confirmAppointment() {
    var promises = $q.all({});

    var status = 50;
    var appointmentData = {
      id: vm.appointment.id
    };
    if (vm.appointment.previously_paid === false) {
      appointmentData.estimate_min = vm.appointment.estimate_min;
      appointmentData.estimate_max = vm.appointment.estimate_max;
    } else {
      appointmentData.previously_paid = true;
    }

    appointmentData.deposit_amount = vm.appointment.deposit_amount ? vm.appointment.deposit_amount : null;

    promises.appointment = Appointment.update(appointmentData, status).then(function (appointment) {
      // Send an email notification to collectors
      var notificationCollector = {
        recipients: [vm.project.collector.id],
        notificationId: NOTIFICATIONS.appointmentConfirmedByOperatorOrArtist,
        messageObjects: {
          appointmentId: appointment.id,
          projectId: vm.project.id,
          // The collector who owns the project
          collectorId: vm.project.collector.id,
          // The logged in operator or artist
          operatorId: Session.collector.id,
          // The artist assigned to the appointment
          artistId: appointment.artist.id
        },
        messageVariables: {
          subject: vm.project.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' confirmed an appointment for your project on Ink Finder',
          tattooProcess: vm.shopMessageTemplates && vm.shopMessageTemplates.tattoo_process !== '' ? vm.shopMessageTemplates.tattoo_process : ''
        }
      };
      if (Session.activeState.association.shop.id) {
        notificationCollector.messageObjects.shopId = Session.activeState.association.shop.id;
        notificationCollector.messageVariables.subject = vm.project.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' at ' + Session.activeState.association.shop.name + ' confirmed an appointment for your project on Ink Finder';
      }

      // Send an email notification to artists
      var notificationArtist = {
        recipients: [appointment.artist.id],
        notificationId: NOTIFICATIONS.artistConfirmed,
        messageObjects: {
          appointmentId: appointment.id,
          projectId: vm.project.id,
          // The collector who owns the project
          collectorId: vm.project.collector.id,
          // The logged in operator or artist
          operatorId: Session.collector.id,
          // The artist assigned to the appointment
          artistId: appointment.artist.id
        },
        messageVariables: {
          subject: appointment.artist.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' at ' + Session.activeState.association.shop.name + ' confirmed your appointment with ' + vm.project.collector.first_name + ' ' + vm.project.collector.last_name + ' on Ink Finder'
        }
      };
      if (Session.activeState.association.shop.id) {
        notificationArtist.messageObjects.shopId = Session.activeState.association.shop.id;
      }
      Notification.send(notificationCollector);
      // Only send artist notifications if the artist isn't the one creating
      // the appointment and they want to receive the email
      collectorWantsNotif.check(appointment.artist.id, appointment.shop, 'appointment_confirmed', 'artist').then(function (collectorWantsNotif) {
        if (Session.collector.id !== appointment.artist.id && collectorWantsNotif) {
          Notification.send(notificationArtist);
        }
      });
      return appointment;
    });

    // Save a message on the appointment if one exists
    if (vm.message.content !== null && vm.message.content.replace(/\s/g, '').length) {
      promises.message = Messages.create(vm.message).then(function (message) {
        return message;
      });
    }

    // Process all promises
    $q.all(promises).then(function (results) {
      $uibModalInstance.close(results.appointment);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'warning' });
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('ConfirmAppointmentController', ConfirmAppointmentController);

/***/ }),

/***/ "./components/appointments/appointment/confirm/confirm.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=confirmAppointmentForm ng-submit=\"confirmAppointmentForm.$valid && $ctrl.confirmAppointment()\" novalidate> <div class=modal-header> <h4 class=modal-title>Confirm this appointment</h4> </div> <div class=\"modal-body background-light\"> <div class=\"row center\"> <div class=players> <div class=\"col-sm-10 col-sm-offset-1\"> <h4>{{$ctrl.appointment.name}}</h4> <div class=row> <div class=\"col-sm-5 center\"> <ink-profile-photo profile=$ctrl.project.collector image-id=$ctrl.project.collector.profile_photo></ink-profile-photo> </div> <div class=col-sm-2> <div class=\"plus margin\"> <div class=width></div> <div class=height></div> </div> </div> <div class=\"col-sm-5 center\"> <ink-profile-photo profile=$ctrl.appointment.artist image-id=$ctrl.appointment.artist.profile_photo></ink-profile-photo> </div> </div> <div class=\"divider small xtight transparent\"></div> <p ng-if=$ctrl.appointment.appointment_datetime> Scheduled for {{$ctrl.appointment.appointment_datetime | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.appointment.appointment_datetime | amDateFormat:'h:mm a'}} </p> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=\"divider transparent xtight\"></div> <div class=form-group> <label for=message><h6>Add a message</h6></label> <textarea msd-elastic=\\n placeholder=\"Write a message...\" name=message id=message class=background-light ng-model=$ctrl.message.content>\n          </textarea> <label ng-if=\"$ctrl.session.activeState.role === 'operator' || $ctrl.session.activeState.role === 'artist'\"> Private message? <small> <input name=private type=checkbox ng-model=$ctrl.message.private /> <strong ng-if=\"$ctrl.session.activeState.role === 'operator'\"> Yes, make this message visible only to others at {{$ctrl.session.activeState.association.shop.name}}. </strong> <strong ng-if=\"$ctrl.session.activeState.role === 'artist'\"> Yes, make this message visible only to you and others at the shop. </strong> </small> </label> </div> </div> </div> <div class=row> <div class=col-md-12> <p ng-if=\"$ctrl.shopMessageTemplates.tattoo_process !== ''\"> <fa name=check class=darkshop></fa> Your <strong>tattoo process</strong> will be sent to {{$ctrl.project.collector.first_name}} via email. </p> <div ng-if=\"$ctrl.shopMessageTemplates.tattoo_process === ''\"> <p class=no-margin> <fa name=thumbs-down class=alert-color></fa> Your tattoo process <strong>will not</strong> be sent to {{$ctrl.project.collector.first_name}} via email. </p> <p> <small>Add your tattoo process to your shop profile to start sending them to collectors after an appointment is confirmed.</small> </p> </div> </div> </div> <div class=\"divider transparent tight\"></div> <div class=\"inline-alert finder small\" ng-if=$ctrl.project.collector.email_is_confirmed> <fa name=thumbs-up></fa> {{$ctrl.project.collector.first_name}} will get an email notification about this update since their email address has been confirmed. </div> <div class=\"inline-alert warning small\" ng-if=!$ctrl.project.collector.email_is_confirmed> <fa name=thumbs-down></fa> {{$ctrl.project.collector.first_name}} will <strong>not</strong> get an email notification about this update since their email address hasn’t been confirmed. </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Confirm</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/appointments/appointment/confirm/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/confirm/confirm.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/decline/decline.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


DeclineAppointmentController.$inject = ['$uibModalInstance', 'Appointment', 'appointment', '_'];


/**
 * @name DeclineAppointmentController
 * @description Controller for declining appointments
 * @param {type} $uibModalInstance Description
 * @param {type} Appointment Description
 * @param {type} appointment Description
 * @param {library} _ The Lodash library
 */
function DeclineAppointmentController($uibModalInstance, Appointment, appointment, _) {
  var vm = this;
  vm.appointment = _.cloneDeep(appointment);

  vm.submit = function () {
    var status = 20;

    // Send the Appointment Update
    Appointment.update(vm.appointment, status).then(function (appointment) {
      $uibModalInstance.close(appointment);
    });
  };

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('DeclineAppointmentController', DeclineAppointmentController);

/***/ }),

/***/ "./components/appointments/appointment/decline/decline.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=declineRequestForm ng-submit=\"declineRequestForm.$valid && $ctrl.submit()\" novalidate> <div class=modal-header> <h4 class=modal-title>Decline this appointment request</h4> </div> <div class=\"modal-body background-light center\"> <h5>You don’t want them all.</h5> <p>Hit the save button below to permanently decline this appointment request.</p> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/appointments/appointment/decline/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/decline/decline.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/deposit/deposit.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


CollectorDepositController.$inject = ['$uibModalInstance', 'appointment', 'project'];
/**
 * @name CollectorDepositController
 * @description Controller for collector deposits
 * @param {type} $uibModalInstance Description
 * @param {type} appointment The appointment from the resolve
 * @param {type} project The project from the resolve
 */
function CollectorDepositController($uibModalInstance, appointment, project) {
  var vm = this;
  // Defaults
  vm.appointment = appointment;
  vm.project = project;

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('CollectorDepositController', CollectorDepositController);

/***/ }),

/***/ "./components/appointments/appointment/deposit/deposit.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h4 class=modal-title>Pay deposit</h4> </div> <div class=modal-body> <div class=background-light> <div class=row> <div class=\"col-sm-10 col-sm-offset-1 center\"> <div class=row> <div class=\"col-xs-4 col-xs-offset-1\"> <ink-profile-photo type=\"'artist'\" profile=$ctrl.project.collector image-id=$ctrl.project.collector.profile_photo> </ink-profile-photo> </div> <div class=col-xs-2> <div class=\"plus margin\"> <div class=width></div> <div class=height></div> </div> </div> <div class=col-xs-4> <ink-profile-photo type=\"'artist'\" profile=$ctrl.appointment.artist image-id=$ctrl.appointment.artist.profile_photo> </ink-profile-photo> </div> </div> <div class=left> <div class=\"divider tight transparent\"></div> <label class=stacked>Appointment</label> <p> {{$ctrl.appointment.date | amDateFormat:'dddd, MMMM Do YYYY'}} from {{$ctrl.appointment.startTime}} to {{$ctrl.appointment.endTime}} </p> <label class=stacked>Estimate</label> <p> {{$ctrl.appointment.estimate_min | noFractionCurrency}} – {{$ctrl.appointment.estimate_max | noFractionCurrency}} </p> <label class=stacked>Deposit</label> <p> <span ng-if=$ctrl.appointment.deposit_amount> {{$ctrl.appointment.deposit_amount | noFractionCurrency}} </span> <span ng-if=!$ctrl.appointment.deposit_amount> No deposit required </span> </p> <p><strong>{{$ctrl.appointment.artist.first_name}} {{$ctrl.appointment.artist.last_name}}</strong> at <strong>{{$ctrl.appointment.shop.name}}</strong> accepts deposit payments through the link below. Click the button to pay this deposit.</p> </div> </div> <div class=\"col-sm-12 center\"> <div class=button-container> <a class=\"button large shop-solid equal-large\" ng-href={{$ctrl.appointment.shop.deposit_payment_URL}} target=_blank>Pay deposit</a> </div> </div> <div class=\"col-sm-12 center\" ng-if=\"$ctrl.appointment.managed_by !== null\"> <div class=\"divider small tight\"></div> <ink-profile-photo type=\"'operator'\" show-name=false profile=$ctrl.appointment.managed_by image-id=$ctrl.appointment.managed_by.profile_photo size=\"'small'\"> </ink-profile-photo> <p><small>This message was sent by {{$ctrl.appointment.managed_by.first_name}} {{$ctrl.appointment.managed_by.last_name}} at {{$ctrl.appointment.shop.name}}.</small></p> </div> </div> </div> </div> <div class=modal-footer> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.cancel()>Close</button> </div> ";

/***/ }),

/***/ "./components/appointments/appointment/deposit/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/deposit/deposit.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/add/index.js");

__webpack_require__("./components/appointments/appointment/add-related/index.js");

__webpack_require__("./components/appointments/appointment/archive/index.js");

__webpack_require__("./components/appointments/appointment/cancel/index.js");

__webpack_require__("./components/appointments/appointment/complete/index.js");

__webpack_require__("./components/appointments/appointment/confirm/index.js");

__webpack_require__("./components/appointments/appointment/decline/index.js");

__webpack_require__("./components/appointments/appointment/deposit/index.js");

__webpack_require__("./components/appointments/appointment/payments/index.js");

__webpack_require__("./components/appointments/appointment/read-message-templates/index.js");

__webpack_require__("./components/appointments/appointment/respond/index.js");

__webpack_require__("./components/appointments/appointment/statuses/index.js");

__webpack_require__("./components/appointments/appointment/update/index.js");

__webpack_require__("./components/appointments/appointment/appointment.component.js");

__webpack_require__("./components/appointments/appointment/appointment.controller.js");

__webpack_require__("./components/appointments/appointment/appointment.data.js");

__webpack_require__("./components/appointments/appointment/appointment.service.js");

__webpack_require__("./components/appointments/appointment/_appointment.styles.scss");

/***/ }),

/***/ "./components/appointments/appointment/payments/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/payments/payments.controller.js");

__webpack_require__("./components/appointments/appointment/payments/payments.service.js");

/***/ }),

/***/ "./components/appointments/appointment/payments/payments.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


PaymentsController.$inject = ['$uibModalInstance', 'Messages', 'Payments', 'appointment', 'project', 'moment', 'AlertMessages', '_', 'Session'];
/**
 * @name PaymentsController
 * @description Controller for recording appointment payments
 * @param {type} $uibModalInstance Description
 * @param {service} Messages Description
 * @param {service} Payments Description
 * @param {resolve} appointment The resolved appt from the appt controller
 * @param {resolve} project The resolved project from the appt controller
 * @param {library} moment Description
 * @param {service} AlertMessages Description
 * @param {library} _ Description
 * @param {service} Session The Session service
 */
function PaymentsController($uibModalInstance, Messages, Payments, appointment, project, moment, AlertMessages, _, Session) {
  var vm = this;

  vm.$onInit = function () {
    // Public Methods
    vm.savePayment = savePayment;
    vm.voidPayment = voidPayment;
    vm.toggleIsDeposit = toggleIsDeposit;
    vm.session = Session;

    // Public Variables
    vm.isAddPaymentCollapsed = true;
    vm.appointment = appointment;
    vm.project = project;
    vm.message = {
      cid: vm.appointment.conversations,
      content: null,
      private: false
    };
    vm.paymentData = {
      appointment_id: vm.appointment.id,
      collector_id: vm.project.collector.id,
      payment_datetime: moment().toDate(),
      is_deposit: false,
      is_tip: false
    };

    // If the appointment is completed, set is_tip to true
    if (vm.appointment.current_status === 70) {
      vm.paymentData.is_tip = true;
    }
    vm.canEdit = determineEditStatus();
    vm.canOnlyAddTips = determineOnlyTipPaymentStatus();
  };

  /**
   * @name determineEditStatus
   * @description Function to determine if payments are editable. If the
   * appointment is in any status other than unconfirmed or confirmed, you
   * should not be able to edit/add payments.
   * @return {boolean} Returns true of false based on the appointment status
   */
  function determineEditStatus() {
    if (vm.appointment.current_status === 40 || vm.appointment.current_status === 50) {
      return true;
    }
    return false;
  }

  /**
   * @name determineOnlyTipPaymentStatus
   * @description Function to determine if only tip payments are acceptable.
   * If the appointment is in any status other than completed, you should not be
   * able to add regular payments.
   * @return {boolean} Returns true of false based on the appointment status
   */
  function determineOnlyTipPaymentStatus() {
    if (vm.appointment.current_status === 70) {
      return true;
    }
    return false;
  }

  // Get Payment Types
  Payments.getTypes().then(function (paymentTypes) {
    vm.paymentTypes = paymentTypes;
  });

  /**
   * @name submit
   * @description Submit a Payment
   */
  function savePayment() {
    Payments.create(vm.paymentData).then(function (allPayments) {
      vm.appointment.payments = allPayments;
      Payments.process(vm.appointment).then(function (parsedPayments) {
        vm.parsedPayments = parsedPayments;
        vm.appointment.paymentData = parsedPayments;
        vm.isAddPaymentCollapsed = true;

        // Send a Message if one exists
        if (vm.message.content !== null && vm.message.content.replace(/\s/g, '').length) {
          Messages.create(vm.message).then(function (message) {
            vm.messageAdded = message;
            vm.message.content = null;
            vm.message.private = false;
          }, function (error) {
            AlertMessages.add({
              msg: 'There was a problem sending the message. Our server responded with: ' + error,
              type: 'warning' });
          });
        }

        // Reset the payment form
        resetPaymentForm();
      });
    });
  }

  /**
  * @description Void payment
  * @param {object} payment Unknown
  */
  function voidPayment(payment) {
    payment.status = 2; // 2 === void status
    Payments.update(payment).then(function (allPayments) {
      vm.appointment.payments = allPayments;
      Payments.process(vm.appointment).then(function (parsedPayments) {
        vm.parsedPayments = parsedPayments;
        vm.appointment.paymentData = parsedPayments;
      });
    });
  }

  /**
   * @name toggleIsDeposit
   * @description Function to save the payment with the is_deposit field set to
   * the opposite of what the field is currently
   * @param {type} payment The payment to change
   */
  function toggleIsDeposit(payment) {
    payment.is_deposit = payment.is_deposit ? false : true;
    Payments.update(payment).then(function (allPayments) {
      vm.appointment.payments = allPayments;
      Payments.process(vm.appointment).then(function (parsedPayments) {
        vm.parsedPayments = parsedPayments;
        vm.appointment.paymentData = parsedPayments;
      });
    });
  }

  /**
   * @name resetPaymentForm
   * @description Function to reset the form back to default
   */
  function resetPaymentForm() {
    vm.paymentData.is_deposit = false;
    vm.paymentData.payment_datetime = moment().toDate();
    vm.paymentData.payment_type = null;
    vm.paymentData.amount = null;
    vm.paymentData.receipt = null;
    vm.addPaymentForm.$setPristine();
  }

  // Close and send back all payments
  vm.close = function () {
    var parsedPayments = vm.parsedPayments;
    var message = vm.messageAdded;
    if (!_.isUndefined(vm.parsedPayments)) {
      $uibModalInstance.close({ parsedPayments: parsedPayments, message: message });
    } else {
      $uibModalInstance.dismiss();
    }
  };
}

angular.module('inkfinder').controller('PaymentsController', PaymentsController);

/***/ }),

/***/ "./components/appointments/appointment/payments/payments.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Payments.$inject = ['$http', '$q', 'ENDPOINT', 'PAYMENT_STATUS_IDS', 'AlertMessages', 'Session'];


/**
 * @name Payments
 * @description The payments service
 * @param {angular} $http The Angular $http service
 * @param {angular} $q The Angular $q service
 * @param {constant} ENDPOINT The ENDPOINT constant
 * @param {constant} PAYMENT_STATUS_IDS The PAYMENT_STATUS_IDS constant
 * @param {service} AlertMessages The AlertMessages service
 * @param {service} Session The Session service
 * @return {type} Returns the factory
 */
function Payments($http, $q, ENDPOINT, PAYMENT_STATUS_IDS, AlertMessages, Session) {
  // Public Functions
  Payments.process = process;
  Payments.create = create;
  Payments.getTypes = getTypes;
  Payments.update = update;

  /**
  * @name submit
  * @description Function to save a payments
  * @param {unknown} payment Unknown.
  * @return {unknown} Returns the saved payment.
  */
  function create(payment) {
    // Set the association and role
    if (!_lodash2.default.isUndefined(Session.activeState.association)) {
      payment.association_id = Session.activeState.association.id;
    }
    payment.role = Session.activeState.role;
    return $http.post(ENDPOINT.server + 'payments/api/v1.1/create/', payment).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getPaymentTypes
   * @description Get Payment Types
   * @return {unknown} data Returns the payment types
   */
  function getTypes() {
    return $http.get(ENDPOINT.server + 'payments/api/v1.1/all/payment-types/').then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name updatePaymentStatus
   * @description Update payment status
   * @param {unknown} payment Unknown
   * @param {unknown} status Unknown
   * @return {unknown} data Returns the updated payment
   */
  function update(payment) {
    // Set the association and role
    if (!_lodash2.default.isUndefined(Session.activeState.association)) {
      payment.association_id = Session.activeState.association.id;
    }
    payment.role = Session.activeState.role;
    var url = ENDPOINT.server + 'payments/api/v1.1/' + payment.id + '/';
    return $http.put(url, payment).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name process
   * @description Process appointent payments
   * @param {object} appointment The appoinment payments to process
   * @return {object} paymentData Returns the processed payments
   */
  function process(appointment) {
    return $q(function (resolve, reject) {
      var paymentData = {};

      // Format the price
      if (appointment.price) {
        paymentData.price = parseFloat(appointment.price);
      }

      // Calculate totals
      paymentData.hasPaidDeposit = false;
      if (appointment.payments && appointment.payments.length > 0) {
        // Total payments
        paymentData.total = appointment.payments.reduce(function (all, payment) {
          if (payment.status === PAYMENT_STATUS_IDS.approved && !payment.is_tip) {
            return all + payment.amount;
          }
          return all;
        }, 0);

        // Create deposit payments array
        var depositPayments = appointment.payments.filter(function (payment) {
          return payment.is_deposit === true;
        });

        // Total deposit payments
        paymentData.depositTotal = depositPayments.reduce(function (all, payment) {
          if (payment.status === PAYMENT_STATUS_IDS.approved) {
            return all + payment.amount;
          }
          return all;
        }, 0);

        // Create tip payments array
        var tipPayments = appointment.payments.filter(function (payment) {
          return payment.is_tip === true;
        });

        // Total tip payments
        paymentData.tipTotal = 0;
        if (tipPayments.length) {
          paymentData.tipTotal = tipPayments.reduce(function (all, payment) {
            if (payment.status === PAYMENT_STATUS_IDS.approved) {
              return all + payment.amount;
            }
            return all;
          }, 0);
        }

        // Set a deposit paid boolean if the deposit total is => deposit_amount
        if (appointment.deposit_amount && paymentData.depositTotal >= appointment.deposit_amount) {
          paymentData.hasPaidDeposit = true;
        }
      }

      // Caculate the balance
      if (paymentData.price && paymentData.total) {
        paymentData.balance = paymentData.price - paymentData.total;
      }
      resolve(paymentData);
    });
  }
  return Payments;
}

angular.module('inkfinder').factory('Payments', Payments);

/***/ }),

/***/ "./components/appointments/appointment/payments/payments.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h3 class=modal-title>Payments</h3> </div> <div class=\"modal-body inner-padding background-light\"> <div class=container-fluid> <div class=row> <div class=col-sm-12> <div class=\"divider small tight transparent\"></div> <h5>Totals</h5> </div> <div class=\"col-sm-3 price\"> <label class=stacked>Price</label> <p ng-if=$ctrl.appointment.paymentData.price>{{$ctrl.appointment.paymentData.price | noFractionCurrency}}</p> <p ng-if=!$ctrl.appointment.paymentData.price>None</p> </div> <div class=\"col-sm-3 payments\"> <label class=stacked>Payments</label> <p ng-if=$ctrl.appointment.paymentData.total class=darkshop>{{$ctrl.appointment.paymentData.total | noFractionCurrency}}</p> <p ng-if=!$ctrl.appointment.paymentData.total>None</p> </div> <div class=\"col-sm-3 balance\"> <label class=stacked>Balance</label> <p ng-if=$ctrl.appointment.paymentData.price class=alert-color>{{$ctrl.appointment.paymentData.balance | noFractionCurrency}}</p> <p ng-if=!$ctrl.appointment.paymentData.price>None</p> </div> <div class=\"col-sm-3 tip\"> <label class=stacked>Tip</label> <p ng-if=$ctrl.appointment.paymentData.tipTotal>{{$ctrl.appointment.paymentData.tipTotal | noFractionCurrency}}</p> <p ng-if=!$ctrl.appointment.paymentData.tipTotal>None</p> </div> <div class=\"col-sm-12 center\"> <p class=no-margin> <small ng-if=\"$ctrl.appointment.deposit_amount && $ctrl.appointment.deposit_required\"> This appointment requires a {{$ctrl.appointment.deposit_amount | noFractionCurrency}} deposit. </small> <small ng-if=!$ctrl.appointment.deposit_required> No deposit is required for this appointment. </small> </p> </div> </div> <div class=row> <div class=\"col-sm-12 center\" ng-if=\"$ctrl.canEdit || $ctrl.canOnlyAddTips\"> <div class=\"divider small tight\"></div> <div class=\"button-add openable no-margin\" ng-class=\"{'open': !$ctrl.isAddPaymentCollapsed}\"> <button class=\"button circle\" ng-click=\"$ctrl.isAddPaymentCollapsed = !$ctrl.isAddPaymentCollapsed\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> </div> </div> <div class=col-sm-12 uib-collapse=$ctrl.isAddPaymentCollapsed> <div class=row> <form name=$ctrl.addPaymentForm ng-submit=\"$ctrl.addPaymentForm.$valid && $ctrl.savePayment()\" novalidate> <div class=col-sm-12> <div class=\"divider small tight transparent\"></div> <h6>Payment type</h6> <div class=form-group ng-if=!$ctrl.canOnlyAddTips> <label> <input name=is_deposit type=checkbox ng-model=$ctrl.paymentData.is_deposit ng-disabled=\"$ctrl.paymentData.is_tip || $ctrl.canOnlyAddTips\"> This is a <strong>deposit</strong> </label> </div> <div class=form-group> <label> <input name=is_tip type=checkbox ng-model=$ctrl.paymentData.is_tip ng-disabled=\"$ctrl.paymentData.is_deposit || $ctrl.canOnlyAddTips\"> This is a <strong>tip</strong> </label> <p ng-if=$ctrl.canOnlyAddTips> <small>Only tip payments can be created when an appointment is completed</small> </p> </div> </div> <div class=col-sm-12> <div class=\"divider small xtight transparent\"></div> <h6>Payment details</h6> </div> <div class=col-sm-6> <div class=form-group> <label for=payment_datetime>Date</label> <div class=input-group> <input name=payment_datetime id=payment_datetime type=text class=form-control uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-required=true ng-model=$ctrl.paymentData.payment_datetime placeholder=MM/DD/YYYY is-open=$ctrl.date_picker.date_open min-date=minDate max-date=maxDate datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"$ctrl.date_picker.date_open = !$ctrl.date_picker.date_open\"> <fa name=calendar-o></fa> </button> </span> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"$ctrl.addPaymentForm.payment_datetime.$invalid && !$ctrl.addPaymentForm.payment_datetime.$pristine\"> We need a date here. </p> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=paymentTypes>Select a source</label> <select name=paymentTypes id=paymentTypes required ng-model=$ctrl.paymentData.payment_type ng-value=option value=option ng-options=\"option.name for option in $ctrl.paymentTypes track by option.id\"> <option value=\"\">Choose one</option> </select> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"$ctrl.addPaymentForm.paymentTypes.$invalid && !$ctrl.addPaymentForm.paymentTypes.$pristine\"> How did they pay you? </p> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=amount>Amount</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=amount id=amount type=text class=form-control ng-model=$ctrl.paymentData.amount min=.01 fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"$ctrl.addPaymentForm.amount.$invalid && !$ctrl.addPaymentForm.amount.$pristine\"> Help, I need a valid number! </p> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=receipt>Receipt #</label> <input name=receipt id=receipt type=text class=form-control ng-model=$ctrl.paymentData.receipt> </div> </div> <div class=col-sm-12> <div class=\"divider small xtight transparent\"></div> <h6>Add a message</h6> <div class=form-group> <textarea msd-elastic=\\n placeholder=\"Write a message...\" name=operatorMessage id=operatorMessage class=background-light ng-model=$ctrl.message.content>\n                </textarea> <label ng-if=\"$ctrl.session.activeState.role === 'operator' || $ctrl.session.activeState.role === 'artist'\"> Private message? <small> <input name=private type=checkbox ng-model=$ctrl.message.private /> <strong ng-if=\"$ctrl.session.activeState.role === 'operator'\"> Yes, make this message visible only to others at {{$ctrl.session.activeState.association.shop.name}}. </strong> <strong ng-if=\"$ctrl.session.activeState.role === 'artist'\"> Yes, make this message visible only to you and others at the shop. </strong> </small> </label> </div> </div> <div class=col-sm-12> <button class=\"button large shop-solid\" type=submit ng-disabled=$ctrl.addPaymentForm.$invalid>Save</button> </div> </form> </div> </div> </div> <div class=row> <div class=col-sm-12> <div class=\"divider small tight\"></div> <h5>Recorded payments</h5> <p ng-if=\"$ctrl.appointment.payments.length === 0\">No payments found.</p> <div ng-if=\"$ctrl.appointment.payments.length > 0\"> <div class=payments ng-repeat=\"payment in $ctrl.appointment.payments | orderBy:'-payment_datetime' track by payment.id\"> <h4 class=\"no-margin inline\" ng-class=\"{'darkshop': payment.status === 1, 'alert-color': payment.status === 2}\"> {{payment.amount | noFractionCurrency}} </h4> <p class=\"inline no-margin\" ng-class=\"{'darkshop': payment.status === 1, 'alert-color': payment.status === 2}\"> <span ng-if=payment.is_deposit>Deposit</span> <span ng-if=payment.is_tip>Tip</span> </p> <div> <p class=no-margin> {{payment.created_by.first_name}} {{payment.created_by.last_name}} on {{payment.payment_datetime | amDateFormat:'MM/DD/YYYY'}} </p> </div> <div> <small> <span ng-if=payment.receipt>Receipt number: {{payment.receipt}} | </span> <span>{{payment.payment_type.name}} payment</span> <span ng-if=\"payment.status === 1 && ($ctrl.canEdit || $ctrl.canOnlyAddTips)\"> <span ng-if=\"!payment.is_tip && $ctrl.canEdit\"> <span ng-if=payment.is_deposit> | <a ng-click=$ctrl.toggleIsDeposit(payment)><fa name=toggle-on></fa> Make regular payment</a></span> <span ng-if=!payment.is_deposit> | <a ng-click=$ctrl.toggleIsDeposit(payment)><fa name=toggle-off></fa> Make deposit payment</a></span> </span> <span ng-if=\"payment.is_tip || $ctrl.canEdit\"> | <a class=inline ng-click=\"payment.confirm_void = !payment.confirm_void\"> <fa name=times-circle></fa> Void </a> </span> </span> <span ng-if=\"payment.status === 2\"> | <span class=alert-color> Voided </span> </span> </small> </div> <div uib-collapse=!payment.confirm_void> <div class=\"divider small xtight\"></div> <p class=alert-color>Are you sure you want to void this payment?</p> <div class=button-container> <button class=\"button small shop-solid\" ng-click=$ctrl.voidPayment(payment)>Void</button> <button class=\"button small alert-btn-light\" ng-click=\"payment.confirm_void = false\">Cancel</button> </div> </div> <div class=\"divider small tight\" ng-class=\"{'transparent': $last}\"></div> </div> </div> </div> </div> </div> </div> <div class=modal-footer> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.close()>Close</button> </div> ";

/***/ }),

/***/ "./components/appointments/appointment/read-message-templates/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/read-message-templates/read-message-templates.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/read-message-templates/read-message-templates.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ReadMessageTemplateController.$inject = ['$uibModalInstance', 'messageTemplate', 'messageTitle'];
/**
 * @name ReadMessageTemplateController
 * @description Controller for displaying message templates
 * @param {library} $uibModalInstance The uib Modal Instance
 * @param {resolve} messageTemplate The resolved message template
 * @param {resolve} messageTitle The resolved message template title
 */
function ReadMessageTemplateController($uibModalInstance, messageTemplate, messageTitle) {
  var vm = this;
  vm.messageTemplate = messageTemplate;
  vm.messageTitle = messageTitle;

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('ReadMessageTemplateController', ReadMessageTemplateController);

/***/ }),

/***/ "./components/appointments/appointment/read-message-templates/read-message-templates.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h4 class=modal-title>{{$ctrl.messageTitle}}</h4> </div> <div class=\"modal-body background-light\"> <span ng-bind-html=$ctrl.messageTemplate></span> </div> <div class=modal-footer> <button class=\"button large alert-btn\" ng-click=$ctrl.cancel()> Close </button> </div> ";

/***/ }),

/***/ "./components/appointments/appointment/respond/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/respond/respond.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/respond/respond.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


RespondAppointmentController.$inject = ['$uibModalInstance', 'Appointment', 'appointment', 'project', 'shopMessageTemplates', 'Notification', 'Session', 'STATUS_IDS', 'NOTIFICATIONS'];
/**
 * @name RespondAppointmentController
 * @description Controller for the respond modal
 * @param {library} $uibModalInstance Description
 * @param {service} Appointment The Appointment service
 * @param {resolve} appointment The resolved appointment
 * @param {resolve} project The resolved project
 * @param {resolve} shopMessageTemplates The resolved shopMessageTemplates
 * @param {service} Notification Description
 * @param {service} Session Description
 * @param {type} STATUS_IDS Description
 * @param {type} NOTIFICATIONS Description
 */
function RespondAppointmentController($uibModalInstance, Appointment, appointment, project, shopMessageTemplates, Notification, Session, STATUS_IDS, NOTIFICATIONS) {
  var vm = this;
  // Defaults
  vm.appointment = appointment;
  vm.project = project;
  vm.shopMessageTemplates = shopMessageTemplates;
  vm.agreedToCancellationPolicy = vm.appointment.agreed_to_cancellation_policy;
  vm.privacyPolicyIsCollapsed = vm.appointment.agreed_to_cancellation_policy;

  // Exposed Functions
  vm.confirmAppointment = confirmAppointment;
  vm.declineAppointment = declineAppointment;

  /**
  * @name confirm
  * @description Function to change the status of an appt to confirmed
  * @param {object} appointment The appointment to update.
  */
  function confirmAppointment() {
    var status = STATUS_IDS.confirmed;
    vm.appointment.agreed_to_cancellation_policy = vm.agreedToCancellationPolicy;
    Appointment.update(vm.appointment, status).then(function (appointment) {
      $uibModalInstance.close(appointment);

      // Send appt notification when appointment is confirmed by collector
      var notification = {
        // Recipients of this email are determined in the API. The API will send
        // this email notification to all confirmed operators of the shop of the
        // appointment.
        notificationId: NOTIFICATIONS.appointmentConfirmedByCollector,
        messageObjects: {
          appointmentId: vm.appointment.id,
          projectId: vm.project.id,
          // The collector that confirmed the appointment
          collectorId: Session.collector.id,
          // The artist assigned to the appointment
          artistId: vm.appointment.artist.id
        },
        messageVariables: {
          subject: vm.project.collector.first_name + ' ' + vm.project.collector.last_name + ' confirmed their appointment on Ink Finder'
        }
      };
      Notification.send(notification);
    });
  }

  /**
  * @name decline
  * @description Function to change the status of an appt to declined
  * @param {object} appointment The appointment to update.
  */
  function declineAppointment() {
    var status = STATUS_IDS.declined;
    vm.appointment.agreed_to_cancellation_policy = false;
    Appointment.update(vm.appointment, status).then(function (appointment) {
      $uibModalInstance.close(appointment);

      // Send appointment notification when appointment is declined by collector
      var notification = {
        // Recipients of this email are determined in the API. The API will send
        // this email notification to all confirmed operators of the shop of the
        // appointment.
        notificationId: NOTIFICATIONS.appointmentDeclinedByCollector,
        messageObjects: {
          appointmentId: vm.appointment.id,
          projectId: vm.project.id,
          // The collector that declined the appointment
          collectorId: Session.collector.id,
          // The artist assigned to the appointment
          artistId: vm.appointment.artist.id
        },
        messageVariables: {
          subject: vm.project.collector.first_name + ' ' + vm.project.collector.last_name + ' declined their appointment on Ink Finder'
        }
      };
      Notification.send(notification);
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('RespondAppointmentController', RespondAppointmentController);

/***/ }),

/***/ "./components/appointments/appointment/respond/respond.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h4 class=modal-title>Estimate details</h4> </div> <div class=modal-body> <div class=background-light> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <div class=\"row center\"> <div class=\"col-xs-4 col-xs-offset-1\"> <ink-profile-photo profile=$ctrl.appointment.artist image-id=$ctrl.appointment.artist.profile_photo> </ink-profile-photo> </div> <div class=col-xs-2> <div class=\"plus margin\"> <div class=width></div> <div class=height></div> </div> </div> <div class=col-xs-4> <ink-profile-photo image-id=$ctrl.appointment.shop.profile_logo editable=false show-name=true profile=$ctrl.appointment.shop type=\"'shop'\"> </ink-profile-photo> </div> </div> <div class=\"divider tight transparent\"></div> <label class=stacked>Appointment</label> <p> {{$ctrl.appointment.date | amDateFormat:'dddd, MMMM Do YYYY'}} from {{$ctrl.appointment.startTime}} to {{$ctrl.appointment.endTime}} </p> <label class=stacked>Estimate</label> <p ng-if=\"$ctrl.appointment.previously_paid === false && $ctrl.appointment.estimate_min && $ctrl.appointment.estimate_max\"> {{$ctrl.appointment.estimate_min | noFractionCurrency}} – {{$ctrl.appointment.estimate_max | noFractionCurrency}} </p> <p ng-if=\"$ctrl.appointment.previously_paid === true\"> Previously paid </p> <label class=stacked>Deposit</label> <p> <span ng-if=\"$ctrl.appointment.deposit_amount > 0\"> {{$ctrl.appointment.deposit_amount | noFractionCurrency}} </span> <span ng-if=\"!$ctrl.appointment.deposit_amount || $ctrl.appointment.deposit_amount == 0\"> No deposit required </span> </p> <div ng-if=$ctrl.shopMessageTemplates.cancellation_policy> <label class=stacked>Cancellation policy</label> <p> <span ng-bind-html=$ctrl.shopMessageTemplates.cancellation_policy></span> </p> </div> <div class=\"divider small tight\"></div> <p> This estimate is for a tattoo created by <strong>{{$ctrl.appointment.artist.first_name}} {{$ctrl.appointment.artist.last_name}}</strong> at <strong>{{$ctrl.appointment.shop.name}}</strong> on {{$ctrl.appointment.date | amDateFormat:'dddd, MMMM Do, YYYY'}} from {{$ctrl.appointment.startTime}} to {{$ctrl.appointment.endTime}} <span ng-if=\"$ctrl.appointment.previously_paid === false && $ctrl.appointment.estimate_min && $ctrl.appointment.estimate_max\"> for an estimated price of {{$ctrl.appointment.estimate_min | noFractionCurrency}}–{{$ctrl.appointment.estimate_max | noFractionCurrency}}. </span> <span ng-if=\"$ctrl.appointment.previously_paid === true\">. This appointment was previously paid. </span> <span ng-if=\"$ctrl.appointment.deposit_amount > 0\"> A {{$ctrl.appointment.deposit_amount | noFractionCurrency}} deposit is required to book this appointment. </span> <span ng-if=\"$ctrl.appointment.deposit_amount == 0 || !$ctrl.appointment.deposit_amount\"> No deposit is required to book this appointment. </span> </p> <div ng-if=$ctrl.appointment.shop.collector_can_confirm_appt> <form> <div class=form-group ng-if=$ctrl.shopMessageTemplates.cancellation_policy> <div class=\"inline-alert warning\"> <label> <input name=agreedToCancellationPolicy ng-model=$ctrl.agreedToCancellationPolicy type=checkbox> <strong>I agree to the {{$ctrl.appointment.shop.name}} cancellation policy above</strong> </label> </div> </div> <div class=\"button-container margin\"> <button type=button class=\"button large shop-solid equal-medium\" ng-click=$ctrl.confirmAppointment() ng-disabled=\"$ctrl.agreedToCancellationPolicy == false && $ctrl.shopMessageTemplates.cancellation_policy != '' || $ctrl.appointment.shop.collector_can_confirm_appt == false\">Confirm appointment</button> <button type=button class=\"button large alert-btn-light equal-medium\" ng-click=$ctrl.declineAppointment()>Decline appointment</button> </div> </form> </div> <div ng-if=!$ctrl.appointment.shop.collector_can_confirm_appt> <div class=\"inline-alert warning\"> <p>Please contact <strong>{{ $ctrl.appointment.shop.name }}</strong> to confirm this appointment:<br/> <strong>Phone:</strong> {{ $ctrl.appointment.shop.phone | tel }}<br/> <strong>Email:</strong> <a href=\"mailto:{{ $ctrl.appointment.shop.email }}?subject=Appointment with {{ $ctrl.appointment.artist.first_name }} {{ $ctrl.appointment.artist.last_name }} at {{ $ctrl.appointment.shop.name }} on {{ $ctrl.appointment.calendarTime }}\">{{ $ctrl.appointment.shop.email }}</a> </p> </div> </div> <div class=center ng-if=\"$ctrl.appointment.managed_by !== null\"> <div class=\"divider small tight\"></div> <ink-profile-photo show-name=false profile=$ctrl.appointment.managed_by image-id=$ctrl.appointment.managed_by.profile_photo size=\"'small'\"> </ink-profile-photo> <p><small>This estimate was sent by {{$ctrl.appointment.managed_by.first_name}} {{$ctrl.appointment.managed_by.last_name}} at {{$ctrl.appointment.shop.name}}.</small></p> </div> </div> </div> </div> </div> <div class=modal-footer> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.cancel()>Close</button> </div> ";

/***/ }),

/***/ "./components/appointments/appointment/statuses/_statuses.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182511156
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/appointments/appointment/statuses/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/statuses/statuses.component.js");

__webpack_require__("./components/appointments/appointment/statuses/_statuses.styles.scss");

/***/ }),

/***/ "./components/appointments/appointment/statuses/statuses.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAppointmentStatuses = {
  bindings: {
    appointment: '<'
  },
  template: __webpack_require__("./components/appointments/appointment/statuses/statuses.template.html")
};

angular.module('inkfinder').component('inkAppointmentStatuses', inkAppointmentStatuses);

/***/ }),

/***/ "./components/appointments/appointment/statuses/statuses.template.html":
/***/ (function(module, exports) {

module.exports = " <div class=statuses> <div class=\"status appointment first\" ng-class=\"{\n    'declined': $ctrl.appointment.last_status.status_id === 20 ||\n    $ctrl.appointment.last_status.status_id === 60 ||\n    $ctrl.appointment.last_status.status_id === 80 ||\n    $ctrl.appointment.last_status.status_id === 90 ||\n    $ctrl.appointment.last_status.status_id === 100,\n    'deposit': $ctrl.appointment.paymentData.hasPaidDeposit ||\n    $ctrl.appointment.previously_paid,\n    'complete': $ctrl.appointment.last_status.status_id === 70\n    }\" ng-if=\"$ctrl.appointment.last_status.status_id >= 50 ||\n    $ctrl.appointment.last_status.status_id === 20\" tooltip-append-to-body=true uib-tooltip={{$ctrl.appointment.paymentToolTip}} tooltip-placement=top tooltip-class=light> <fa name=check></fa> </div> </div> ";

/***/ }),

/***/ "./components/appointments/appointment/update/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/appointment/update/update.controller.js");

/***/ }),

/***/ "./components/appointments/appointment/update/update.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


UpdateAppointmentController.$inject = ['$uibModalInstance', 'Appointment', 'NOTIFICATIONS', 'Session', 'Notification', 'appointment', 'project', '_', 'Participants', '$rootScope', 'collectorWantsNotif', '$log'];


/**
 * @name UpdateAppointmentController
 * @description Controller for updating appointments
 * @param {type} $uibModalInstance Description
 * @param {type} Appointment Description
 * @param {type} NOTIFICATIONS Description
 * @param {type} Session Description
 * @param {type} Notification Description
 * @param {type} appointment Description
 * @param {type} project Description
 * @param {type} _ Lodash
 * @param {type} Participants The Participants service
 * @param {type} $rootScope The Angular $rootScope service
 * @param {service} collectorWantsNotif The collectorWantsNotif service
 * @param {angular} $log The Angular $log service
 */
function UpdateAppointmentController($uibModalInstance, Appointment, NOTIFICATIONS, Session, Notification, appointment, // The resolved appointment from the modal
project, // The resolved project from the modal
_, Participants, $rootScope, collectorWantsNotif, $log) {
  var vm = this;
  // Defaults
  vm.voidStatus = true;
  vm.appointmentTmp = _.cloneDeep(appointment);
  vm.appointmentCompare = _.cloneDeep(appointment);
  vm.projectTmp = _.cloneDeep(project);

  // Exposed Functions
  vm.submitDisabled = submitDisabled;
  vm.update = update;

  /**
  * @name submitDisabled
  * @description Disable the submit button
  * @return {Unknown} Unknown
  */
  function submitDisabled() {
    return vm.appointmentTmp.artist.id && !vm.appointmentTmp.appointment_datetime && vm.appointmentTmp.artist.id && !vm.appointmentTmp.appointment_date && !vm.appointmentTmp.appointment_start_time;
  }

  /**
  * @name update
  * @description Function to update an appointment.
  * @param {object} appointmentToUpdate The appointment to be updated.
  */
  function update(appointmentToUpdate) {
    var status = 40;
    Appointment.update(appointmentToUpdate, status).then(function (appointment) {
      // Check to see if an artist is found on the appointment
      if (vm.appointmentCompare.artist === null) {
        // If so, create a participant for the new artist if the collector and
        // artist are not the same user
        if (vm.projectTmp.collector.id === appointment.artist.id) {
          $rootScope.$broadcast('refresh-participants');
          $uibModalInstance.close(appointment);
        } else {
          var newArtistParticipant = {
            role: Session.activeState.role,
            conversation_id: appointment.conversations,
            collector_id: appointment.artist.id,
            appointment_id: appointment.id
          };
          Participants.create(newArtistParticipant).then(function () {
            $rootScope.$broadcast('refresh-participants');
            $uibModalInstance.close(appointment);
          });
        }

        // If the artist doesn't change, close the modal and return the appt
      } else if (vm.appointmentCompare.artist.id === appointment.artist.id) {
        $uibModalInstance.close(appointment);

        // If the artist has changed, update the Participants
      } else {
        // Get all participants to find the former artist's participant
        Participants.get(appointment.conversations).then(function (participants) {
          // Find the participant for the former artist
          var formerArtistParticipant = _.find(participants, function (participant) {
            if (vm.appointmentCompare.artist.id === participant.collector) {
              return true;
            }
          });

          // Delete the former artist's participant if it exists
          if (formerArtistParticipant) {
            Participants.remove(formerArtistParticipant.id);
          }

          // Now create a participant for the new artist if the collector and
          // artist are not the same user and the new artist doesn't alredy
          // have a participant
          var newArtistParticipant = _.find(participants, function (participant) {
            if (appointment.artist.id === participant.collector) {
              return true;
            }
          });
          if (vm.projectTmp.collector.id === appointment.artist.id || newArtistParticipant) {
            $rootScope.$broadcast('refresh-participants');
            $uibModalInstance.close(appointment);
          } else {
            var _newArtistParticipant = {
              role: Session.activeState.role,
              conversation_id: appointment.conversations,
              collector_id: appointment.artist.id,
              appointment_id: appointment.id
            };
            Participants.create(_newArtistParticipant).then(function () {
              $rootScope.$broadcast('refresh-participants');
              $uibModalInstance.close(appointment);
            });
          }
        });
      }

      // Send an email notification
      if (!_.isEqual(vm.appointmentTmp, vm.appointmentCompare)) {
        // Email to collector
        var collectorNotification = {
          recipients: [project.collector.id],
          notificationId: NOTIFICATIONS.appointmentUpdate,
          messageObjects: {
            appointmentId: appointment.id,
            projectId: project.id,
            // The artist assigned to the appointment
            artistId: appointment.artist.id,
            // The operator updating the appointment
            operatorId: Session.collector.id,
            // The collector who owns the project
            collectorId: project.collector.id
          },
          messageVariables: {
            subject: project.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' updated the appointment for your project on Ink Finder'
          }
        };
        if (Session.activeState.association.shop.id) {
          collectorNotification.messageObjects.shopId = Session.activeState.association.shop.id;
          collectorNotification.messageVariables.subject = project.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' at ' + Session.activeState.association.shop.name + ' updated the appointment for your project on Ink Finder';
        }
        Notification.send(collectorNotification);

        // Email to artist. Only send if the logged in user is not the artist
        // on the appt and the artist wants the notification
        collectorWantsNotif.check(appointment.artist.id, appointment.shop, 'appointment_updated', 'artist').then(function (collectorWantsNotif) {
          if (appointment.artist.id !== Session.collector.id && collectorWantsNotif) {
            var artistNotification = {
              recipients: [appointment.artist.id],
              notificationId: NOTIFICATIONS.artistAppointmentUpdate,
              messageObjects: {
                appointmentId: appointment.id,
                projectId: project.id,
                // The artist assigned to the appointment
                artistId: appointment.artist.id,
                // The operator updating the appointment
                operatorId: Session.collector.id,
                // The collector who owns the project
                collectorId: project.collector.id
              },
              messageVariables: {
                subject: project.collector.first_name + ', ' + Session.collector.first_name + ' ' + Session.collector.last_name + ' updated the appointment for a project you’re working on'
              }
            };
            Notification.send(artistNotification);
          }
        });
      }
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('UpdateAppointmentController', UpdateAppointmentController);

/***/ }),

/***/ "./components/appointments/appointment/update/update.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=updateAppointment ng-submit=\"updateAppointment.$valid && $ctrl.update($ctrl.appointmentTmp)\" novalidate> <div class=modal-header> <h4 class=modal-title>Appointment details</h4> </div> <div class=modal-body> <div class=background-light> <ink-availability appointment=$ctrl.appointmentTmp></ink-availability> <div class=row> <div class=col-sm-12> <div class=\"divider small xtight transparent\"></div> <h6>Estimate</h6> <div class=form-group> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.appointmentTmp.previously_paid === false}\"> <input type=radio name=estimate_or_previously_paid id=estimate ng-model=$ctrl.appointmentTmp.previously_paid ng-value=false> Estimate this appointment </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.appointmentTmp.previously_paid === true}\" tooltip-placement=top uib-tooltip=\"Void all existing payments to mark as previously paid.\" ng-if=!$ctrl.voidStatus> <input type=radio name=estimate_or_previously_paid id=previously-paid ng-disabled=!$ctrl.voidStatus> Mark as previously paid </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.appointmentTmp.previously_paid === true}\" ng-if=$ctrl.voidStatus> <input type=radio name=estimate_or_previously_paid id=previously-paid ng-disabled=!$ctrl.voidStatus ng-model=$ctrl.appointmentTmp.previously_paid ng-value=true> Mark as previously paid </label> </div> </div> </div> </div> </div> <div class=row ng-if=\"$ctrl.appointmentTmp.previously_paid === false\"> <div class=col-sm-12> <p>Estimate range</p> </div> <div class=col-sm-6> <div class=form-group> <label for=estimate_min class=stacked>From</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=estimate_min id=estimate_min type=text class=form-control min=.01 fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=$ctrl.appointmentTmp.estimate_min> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateAppointment.estimate_min.$invalid && !updateAppointment.estimate_min.$pristine\"> Houston, we need a number. </p> </div> </div> </div> <div class=col-sm-6> <div class=form-group> <label for=estimate_max class=stacked>To</label> <div class=input-group> <span class=input-group-addon>$</span> <input name=estimate_max id=estimate_max type=text class=form-control min=.01 fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=$ctrl.appointmentTmp.estimate_max> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateAppointment.estimate_max.$invalid && !updateAppointment.estimate_max.$pristine\"> Houston, we need a number. </p> </div> </div> </div> <div class=col-sm-12> <div class=\"divider small xtight transparent\"></div> <h6>Deposit</h6> <div class=form-group> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.appointmentTmp.deposit_required === true}\"> <input type=radio name=deposit_required id=true ng-model=$ctrl.appointmentTmp.deposit_required ng-value=true> Require a deposit amount </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.appointmentTmp.deposit_required === false}\"> <input type=radio name=deposit_required id=false ng-model=$ctrl.appointmentTmp.deposit_required ng-value=false> No deposit required </label> </div> </div> </div> </div> <div ng-if=$ctrl.appointmentTmp.deposit_required> <div class=col-sm-12> <p>Deposit amount required</p> </div> <div class=col-sm-6> <div class=\"form-group no-margin-bottom\"> <div class=input-group> <span class=input-group-addon>$</span> <input name=deposit_amount id=deposit_amount type=text class=form-control fcsa-number=\"{ preventInvalidInput: true, maxDecimals: 2 }\" required ng-model=$ctrl.appointmentTmp.deposit_amount> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"unconfirmedAppointmentForm.deposit_amount.$invalid && !unconfirmedAppointmentForm.deposit_amount.$pristine\"> Houston, we need a valid number. </p> </div> </div> </div> </div> </div> <div class=row> <div class=col-sm-12> <div class=\"divider small xtight transparent\"></div> <div class=\"inline-alert finder small\" ng-if=$ctrl.projectTmp.collector.email_is_confirmed> <fa name=thumbs-up></fa> {{$ctrl.projectTmp.collector.first_name}} will get an email notification about this update since their email address has been confirmed. </div> <div class=\"inline-alert warning small\" ng-if=!$ctrl.projectTmp.collector.email_is_confirmed> <fa name=thumbs-down></fa> {{$ctrl.projectTmp.collector.first_name}} will <strong>not</strong> get an email notification about this update since their email address hasn’t been confirmed. </div> </div> </div> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit ng-disabled=\"updateAppointment.$invalid || !$ctrl.appointmentTmp.artist.id || $ctrl.submitDisabled() || $ctrl.clientAlerts.errors.length || $ctrl.serverAlerts.errors.length\">Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/appointments/appointments.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAppointments = {
  controller: 'AppointmentsController',
  bindings: {
    $transition$: '<'
  },
  template: __webpack_require__("./components/appointments/appointments.template.html")
};

angular.module('inkfinder').component('inkAppointments', inkAppointments);

/***/ }),

/***/ "./components/appointments/appointments.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AppointmentsController.$inject = ['$rootScope', '$scope', '$q', '$stateParams', '$state', '$interval', '$uibModal', 'ScheduleUtilFactory', 'SchedulingFactory', 'Operators', 'Collector', 'moment', 'Events', 'Session', 'AlertMessages', 'RESPONSE_MESSAGES', '_'];


/**
  * @name AppointmentsController
  * @description Controller for shop appointments
  * @param {unknown} $rootScope unknown
  * @param {unknown} $scope unknown
  * @param {unknown} $q unknown
  * @param {unknown} $stateParams unknown
  * @param {unknown} $state unknown
  * @param {unknown} $interval unknown
  * @param {unknown} $uibModal unknown
  * @param {unknown} ScheduleUtilFactory unknown
  * @param {unknown} SchedulingFactory unknown
  * @param {unknown} Operators unknown
  * @param {unknown} Collector unknown
  * @param {unknown} moment unknown
  * @param {unknown} Events unknown
  * @param {object} Session The session service
  * @param {object} AlertMessages The alerts service
  * @param {object} RESPONSE_MESSAGES The alerts service
  * @param {object} _ The Lodash service
  */
function AppointmentsController($rootScope, $scope, $q, $stateParams, $state, $interval, $uibModal, ScheduleUtilFactory, SchedulingFactory, Operators, Collector, moment, Events, Session, AlertMessages, RESPONSE_MESSAGES, _) {
  var vm = this;

  // Private variables
  var scheduleTimer = void 0;

  // Public variables
  vm.events = Events;

  // Public methods
  vm.updateArtistHours = updateArtistHours;
  vm.checkAvailability = checkAvailability;
  vm.prevDay = prevDay;
  vm.nextDay = nextDay;
  vm.goToToday = goToToday;
  vm.today = today;
  vm.open = open;
  vm.setDate = setDate;
  vm.setTall = setTall;
  vm.setCompact = setCompact;
  vm.setSkinny = setSkinny;
  vm.setWide = setWide;
  vm.selectDate = selectDate;
  vm.calcHeight = calcHeight;
  vm.calcHeightRoot = calcHeightRoot;
  vm.calcBlockOffset = calcBlockOffset;
  vm.calcOffset = calcOffset;
  vm.calcScheduleHeight = calcScheduleHeight;
  vm.uiOnParamsChanged = uiOnParamsChanged;
  vm.session = Session;

  // Calendar variables
  vm.date = {
    day: vm.$transition$.params().day,
    month: vm.$transition$.params().month,
    year: vm.$transition$.params().year
  };
  vm.weekdays = ScheduleUtilFactory.daysArray;
  vm.formats = ['dd-MMMM-yyyy', 'YYYY-MM-DD', 'dd.MM.yyyy', 'shortDate'];
  vm.format = vm.formats[0];
  vm.status = { opened: false };

  // Get the Schedule.
  getSchedule(vm.date, { forced: true });

  // Get the Schedule via Timer (no forced update).
  scheduleTimer = $interval(function () {
    getSchedule(vm.date);
  }, 60000);

  /**
   * @name uiOnParamsChanged
   * @description Callback from ui router when params change.
   * @param {object} newParams The param updates.
   */
  function uiOnParamsChanged(newParams) {
    _.assign(vm.date, newParams);
    getSchedule(vm.date, { forced: true });
  }

  /**
   * @name prevDay
   * @description Unknown
   */
  function prevDay() {
    var newDate = moment(vm.date.year + '-' + vm.date.month + '-' + vm.date.day, 'YYYY-MM-DD').subtract(1, 'day').format('YYYY-MM-DD');
    vm.date.year = moment(newDate).format('YYYY');
    vm.date.month = moment(newDate).format('MM');
    vm.date.day = moment(newDate).format('DD');
    $state.go('.', vm.date);
  }

  /**
   * @name nextDay
   * @description Unknown
   */
  function nextDay() {
    var newDate = moment(vm.date.year + '-' + vm.date.month + '-' + vm.date.day, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD');
    vm.date.year = moment(newDate).format('YYYY');
    vm.date.month = moment(newDate).format('MM');
    vm.date.day = moment(newDate).format('DD');
    $state.go('.', vm.date);
  }

  /**
   * @name goToToday
   * @description Unknown
   */
  function goToToday() {
    var today = {
      year: moment().format('YYYY'),
      month: moment().format('MM'),
      day: moment().format('DD')
    };
    $state.go('.', today);
  }

  /**
   * @name isToday
   * @description Function to return a boolean if the current day is today.
   * @param {object} date The date object from URL params.
   * @return {boolean} TrueFalse
   */
  function isToday(date) {
    var convertedDate = convertDateToMoment(date);
    return moment(convertedDate).startOf('day').unix() === moment().startOf('day').unix();
  }

  /**
   * @name isPast
   * @description Functino to return a boolean if the active day is in the
   * past.
   * @param {object} date The date object from URL params.
   * @return {boolean} TrueFalse
   */
  function isPast(date) {
    var convertedDate = convertDateToMoment(date);
    return moment(convertedDate).startOf('day') < moment().startOf('day');
  }

  /**
   * @name selectDate
   * @description Unknown
   */
  function selectDate() {
    vm.date.year = moment(vm.dateField).format('YYYY');
    vm.date.month = moment(vm.dateField).format('MM');
    vm.date.day = moment(vm.dateField).format('DD');
    $state.go('.', vm.date);
  }

  /**
   * @name today
   * @description Unknown
   */
  function today() {
    vm.dateField = moment().toDate();
  }

  /**
   * @name open
   * @description Unknown
   * @param {Unknown} $event Unknown
   */
  function open($event) {
    vm.status.opened = !vm.status.opened;
  }

  /**
   * @name setDate
   * @description Unknown
   * @param {Unknown} year Unknown
   * @param {Unknown} month Unknown
   * @param {Unknown} day Unknown
   */
  function setDate(year, month, day) {
    vm.dateField = new Date(year, month, day);
  }

  /**
  * @name convertDateToMoment
  * @description Function to convert our URL params date object to a moment
  * object.
  * @param {object} date Our URL params date object.
  * @return {object} convertedDate Returns a moment date object.
  */
  function convertDateToMoment(date) {
    var convertedDate = moment(date.year + '-' + date.month + '-' + date.day).format('YYYY-MM-DD');
    return convertedDate;
  }

  /**
   * @name getSchedule
   * @description Function to get all data for the schedule.
   * @param {object} dateObject The date object from URL params.
   * @param {object} request The type of request. If the request is from the
   * interval, this will be undefined.
   * @return {unknown} Unknown
   */
  function getSchedule(dateObject, request) {
    return $q(function (resolve, reject) {
      var date = moment(dateObject.year + '-' + dateObject.month + '-' + dateObject.day, 'YYYY-MM-DD');
      vm.lastCalledDate = date;
      // Show the loading status for forced updates
      if (request && request.forced) {
        vm.loading = true;
      }
      // Update dates
      vm.isToday = isToday(vm.date);
      vm.isPast = isPast(vm.date);
      vm.dateDisplay = convertDateToMoment(vm.date);

      SchedulingFactory.fetchScheduleData(date, null).then(function (data) {
        if (moment(vm.lastCalledDate).format('MM-DD-YYYY') === moment(date).format('MM-DD-YYYY')) {
          var schedules = SchedulingFactory.calculateSchedule(data.rules, data.shopHours, data.appointments, data.artists);
          var validSchedules = [];
          var appointmentTotal = 0;
          var availableTotal = 0;

          for (var i = 0; i < schedules.length; i++) {
            var schedule = schedules[i];

            // Merges schedule blocks together if they're back to back.
            schedule.available = ScheduleUtilFactory.mergeConsecutive(schedule.available);
            var availableCount = schedule.available.length;
            var appointmentCount = schedule.appointments.length;

            // Process Appointment/Available Blocks
            if (appointmentCount + availableCount) {
              appointmentTotal += appointmentCount;
              availableTotal += availableCount;

              // Calculate the Revenue total for this Particular Schedule Block.
              var revenueTotal = 0;
              for (var j = 0; j < appointmentCount; j++) {
                var appointment = schedule.appointments[j].appointment;
                if (appointment.last_status.status_name === 'Completed' && appointment.price) {
                  revenueTotal += parseFloat(appointment.price);
                }
              }
              schedule.stats = {
                revenue: revenueTotal
              };

              // Determine when the Artist is first Available.
              for (var q = 0; q < schedule.artist_start_end_times.length; q++) {
                var interval = schedule.artist_start_end_times[q];
                if (!schedule.first_available || interval.start < schedule.first_available.start) {
                  schedule.first_available = interval;
                }
              }

              // Only add Expired Artists if they have an Appointment.
              if (moment(schedule.artist.association.endDatetime).unix() < moment(date).unix()) {
                if (schedule.appointments.length) {
                  delete schedule.available;
                  delete schedule.artist_start_end_times;
                  delete schedule.first_available;
                  validSchedules.push(schedule);
                }
              } else {
                validSchedules.push(schedule);
              }
            }
          }
          vm.schedules = validSchedules;
          vm.appointmentCount = appointmentTotal;
          vm.availableCount = availableTotal;
          vm.period = calculateShopHours(data.shopHours);
          vm.timelineMarkers = generateTimeline(vm.period);
          vm.loading = false;
          resolve();
        } else {
          resolve();
          vm.loading = false;
        }
      }, function () {
        resolve();
        vm.loading = false;
      });
    });
  }

  /**
   * @name update
   * @description unknown
   * @param {unknown} shopHours Unknown
   * @return {unknown} Unkown
   */
  function calculateShopHours(shopHours) {
    var shopScheduleDetails = {};
    if (shopHours.earliest.rule) {
      shopScheduleDetails = {
        start: shopHours.earliest.start,
        end: shopHours.latest.end,
        duration: shopHours.latest.end.diff(shopHours.earliest.start, 'minutes')
      };
    }
    return shopScheduleDetails;
  }

  /**
   * @name updateArtistHours
   * @description Update artist schedule modal
   * @param {unknown} artist Unknown
   */
  function updateArtistHours(_artist) {
    var modalInstance = void 0;
    if (!vm.isPast) {
      modalInstance = $uibModal.open({
        template: __webpack_require__("./components/schedule/update/update-schedule.html"),
        animation: true,
        controller: 'ScheduleUpdateController as $ctrl',
        resolve: {
          artist: function artist() {
            return _artist;
          },
          schedule: function schedule() {
            return vm.schedules;
          },
          date: function date() {
            return convertDateToMoment(vm.date);
          }
        }
      });
    }
    modalInstance.result.then(function () {
      getSchedule(vm.date, { forced: true });
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      getSchedule(vm.date, { forced: true });
    });
  }

  /**
   * @name checkAvailability
   * @description Availability lookup for artists
   */
  function checkAvailability() {
    $uibModal.open({
      template: __webpack_require__("./components/schedule/check-availability/check-availability.html"),
      animation: true,
      controller: 'AvailabilityCheckController as $ctrl'
    });
  }

  /**
   * @name calcHeight
   * @description Unknown
   * @param {Unknown} length Unknown
   * @param {Unknown} parent Unknown
   * @return {Unknown} Unknown
   */
  function calcHeight(length, parent) {
    if (!parent) {
      return '100%';
    }
    return 100 * (length / parent) + '%';
  }

  /**
   * @name calcHeightRoot
   * @description Unknown
   * @param {Unknown} length Unknown
   * @return {Unknown} Unknown
   */
  function calcHeightRoot(length) {
    return calcHeight(length, vm.period.duration);
  }

  /**
   * @name calcBlockOffset
   * @description Unknown
   * @param {Unknown} data Unknown
   * @return {Unknown} Unknown
   */
  function calcBlockOffset(data) {
    return calcOffset(data.interval_back_to_shop_start_time);
  }

  /**
   * @name calcOffset
   * @description Unknown
   * @param {Unknown} minutes Unknown
   * @return {Unknown} Unknown
   */
  function calcOffset(minutes) {
    if (!vm.period.duration) {
      return '0';
    }
    return 100 * (minutes / vm.period.duration) + '%';
  }

  /**
   * @name calcScheduleHeight
   * @description Unknown
   * @param {Unknown} modifiers Unknown
   * @return {Unknown} Unknown
   */
  function calcScheduleHeight(modifiers) {
    return Math.ceil(modifiers.length * vm.period.duration) + 'px';
  }

  /**
   * @name generateTimeline
   * @description Unknown
   * @param {Unknown} schedulePeriod Unknown
   * @return {Unknown} Unknown
   */
  function generateTimeline(schedulePeriod) {
    var output = {
      hours: [],
      quarters: []
    };

    for (var time = moment(schedulePeriod.start); time <= schedulePeriod.end; time.add(15, 'minute')) {
      var interval = moment(time).format('mm');

      var marker = {
        id: time.unix(),
        time: moment(time),
        duration: time.diff(schedulePeriod.start, 'minutes')
      };

      if (interval % 60 === 0) {
        output.hours.push(marker);
      } else if (interval % 15 === 0) {
        output.quarters.push(marker);
      } else {
        var subAmount = interval % 15;
        if (subAmount) {
          time.subtract(subAmount, 'minute');
        }
      }
    }
    return output;
  }

  // Schedule view defaults
  vm.modifiers = {
    skinny: true,
    compact: true,
    length: 3
  };

  if (!_.isUndefined(Session.viewingMode)) {
    vm.modifiers = {
      skinny: Session.viewingMode.calendarSkinny,
      compact: Session.viewingMode.calendarCompact
    };
    if (Session.viewingMode.calendarCompact === true) {
      vm.modifiers.length = 1.5;
    } else if (Session.viewingMode.calendarCompact === false) {
      vm.modifiers.length = 3;
    }
  }

  /**
   * @name setTall
   * @description Function to set the height of appointment blocks to tall.
   */
  function setTall() {
    var skinny = Session.viewingMode.calendarSkinny;
    var compact = false;
    updateViewMode(skinny, compact);
  }

  /**
   * @name setCompact
   * @description Function to set the height of appointment blocks to compact.
   */
  function setCompact() {
    var skinny = Session.viewingMode.calendarSkinny;
    var compact = true;
    updateViewMode(skinny, compact);
  }

  /**
   * @name setSkinny
   * @description Function to set the width of appointment blocks to skinny.
   */
  function setSkinny() {
    var skinny = true;
    var compact = Session.viewingMode.calendarCompact;
    updateViewMode(skinny, compact);
  }

  /**
   * @name setWide
   * @description Function to set the width of appointment blocks to wide.
   */
  function setWide() {
    var skinny = false;
    var compact = Session.viewingMode.calendarCompact;
    updateViewMode(skinny, compact);
  }

  /**
   * @name udpateViewMode
   * @description Function to update the view mode stored in the operator object.
   * @param {boolean} calendarSkinny Boolean value of the skinny/wide view mode.
   * @param {boolean} calendarCompact Boolean value of the compact/tall view mode.
   */
  function updateViewMode(calendarSkinny, calendarCompact) {
    var collector = Session.collector;
    collector.calendar_skinny = calendarSkinny;
    collector.calendar_compact = calendarCompact;
    Collector.updateProfile(collector).then(function (updatedCollector) {
      Session.viewingMode = {
        calendarSkinny: updatedCollector.calendar_skinny,
        calendarCompact: updatedCollector.calendar_compact
      };
      vm.modifiers.compact = updatedCollector.calendar_compact;
      vm.modifiers.skinny = updatedCollector.calendar_skinny;
      if (updatedCollector.calendar_compact === true) {
        vm.modifiers.length = 1.5;
      } else if (updatedCollector.calendar_compact === false) {
        vm.modifiers.length = 3;
      }
    });
  }

  $scope.$on('clear-data', clear);
  $scope.$on('$destroy', clear);

  /**
   * @name clear
   * @description Unknown
   */
  function clear() {
    $interval.cancel(scheduleTimer);
  }
}

angular.module('inkfinder').controller('AppointmentsController', AppointmentsController);

/***/ }),

/***/ "./components/appointments/appointments.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Appointments', ['$http', '$rootScope', 'ENDPOINT', 'FormatAppointment', 'FormatProject', 'Session', 'moment', 'AlertMessages', '_', function Appointments($http, $rootScope, ENDPOINT, FormatAppointment, FormatProject, Session, moment, AlertMessages, _) {
  // Defaults
  Appointments.appointments = [];

  // Public methods
  Appointments.get = get;
  Appointments.detectAppointmentCollisions = detectAppointmentCollisions;

  /**
   * @name get
   * @description Function to get a collection of appointments. Supports
   * pagination from the endpoint.
   * @param {object} search The search criteria for paginated results.
   * @param {date} start The start datetime of search query
   * @param {date} end The end datetime of the search query
   * @param {number} timestamp A unix timestamp to use when checking the last
   * call to this endpoint.
   * @param {number} artist The artist ID to filter appointments by.
   * @param {number} collector The collector ID to filter appointments by.
   * @param {number} projectId The project ID to filter appointments by
   * @return {array} appointments Returns an array of appointments.
   */
  function get(search, start, end, timestamp, artist, collector, projectId) {
    var association_id = _.isUndefined(Session.activeState.association) ? '' : Session.activeState.association.id;
    var role = Session.activeState.role;
    var url = ENDPOINT.server + 'appointments/api/v1.1/?';
    url += (association_id ? 'association_id=' + association_id : '') + (timestamp ? '&timestamp=' + timestamp : '') + '&role=' + role;
    if (search !== false) {
      var _search = _.cloneDeep(search);
      // Determine if Status is 'All', then set status to false to not send
      // status to the endpoint
      if (search.status === 'All types of') {
        _search.status = undefined;
      }
      // Convert values to match the API.
      if (search.sort === 'Appointment date') {
        _search.sort = 'appointmentDatetime';
      }
      if (search.sort === 'Client last name') {
        _search.sort = 'collectorLastName';
      }
      url += '&page=' + _search.page + '&sort=' + _search.sort;
      url += '&page=' + _search.page + '&sort=' + _search.sort;
      if (_search.search !== '') {
        url += '&search=' + _search.search;
      }
      if (!_.isUndefined(_search.status)) {
        url += '&status=' + _search.status;
      }
    }
    if (!_.isUndefined(start) && !_.isUndefined(end)) {
      url += '&start_datetime=' + start.format() + '&end_datetime=' + end.format();
    }
    if (!_.isUndefined(artist)) {
      url += '&artist_id=' + artist;
    }
    if (!_.isUndefined(collector)) {
      url += '&collector_id=' + collector;
    }
    if (!_.isUndefined(projectId)) {
      url += '&project_id=' + projectId;
    }
    return $http.get(url).then(function (response) {
      var collection = void 0;
      if (!_.isUndefined(response.data.results)) {
        collection = response.data;
        collection.results = FormatAppointment.formatCollection(response.data.results);
        return collection;
      }
      collection = FormatAppointment.formatCollection(response.data);
      return collection;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name detectAppointmentCollisions
   * @description unknown
   * @param {unknown} rule Unknown
   * @param {unknown} appointmentDayGroups Unknown
   * @param {unknown} allAppointments Unknown
   * @param {unknown} day Unknown
   * @return {unknown} Unknown
   */
  function detectAppointmentCollisions(rule, appointmentDayGroups, allAppointments, day) {
    var applicable_appointments = [];
    var daily_appointments = [];
    var range_appointments = [];
    var collision_count = 0;

    // Figure out the Applicable Days based on a Rule
    for (var i = 0; i < rule.selected_days.length; i++) {
      var day_index = rule.selected_days[i].id;

      if (appointmentDayGroups[day_index].length) {
        var appointments_by_day = appointmentDayGroups[day_index];
        for (var j = 0; j < appointments_by_day.length; j++) {
          applicable_appointments.push(appointments_by_day[j]);
        }
      }
    }

    // Process Applicable Appointments
    for (var n = 0; n < applicable_appointments.length; n++) {
      var appointment_start = moment(applicable_appointments[n].appointment_datetime, 'YYYY-MM-DDTHH:mm:ss').startOf('minutes');
      var appointment_end = moment(applicable_appointments[n].appointment_datetime, 'YYYY-MM-DDTHH:mm:ss').add(applicable_appointments[n].duration, 'minutes');

      var start_time = void 0;
      var end_time = void 0;

      if (rule.start_time) {
        start_time = rule.start_time;
      }
      if (rule.end_time) {
        end_time = rule.end_time;
      }

      if (rule.temp) {
        if (rule.temp.raw_start_time) {
          start_time = moment(rule.temp.raw_start_time);
        }
        if (rule.temp.raw_end_time) {
          end_time = moment(rule.temp.raw_end_time);
        }
      }

      // Date Correction
      if (end_time < start_time) {
        end_time.add(1, 'day');
      }

      if (!(start_time.unix() >= appointment_end.unix() || end_time.unix() <= appointment_start.unix())) {
        collision_count++;
      }

      // Day's Appointments Only
      if (appointment_start.unix() < moment(day).endOf('day').unix()) {
        daily_appointments.push(applicable_appointments[n]);
      }
    }

    // Process Current + Future Appointments
    for (var c = 0; c < allAppointments.length; c++) {
      var start = moment(allAppointments[c].appointment_datetime, 'YYYY-MM-DDTHH:mm:ss').startOf('minutes');

      // If there's a Range
      if (rule.temp.raw_start_date && rule.temp.raw_end_date) {
        var range_start = moment(rule.temp.raw_start_date).startOf('day').unix();
        var range_end = moment(rule.temp.raw_end_date).endOf('day').unix();

        if (range_start <= moment(start).unix() && range_end >= moment(start).unix()) {
          range_appointments.push(allAppointments[c]);
        }
      }
    }
    return {
      appointment_collisions: collision_count,
      applicable_appointments: applicable_appointments,
      daily_appointments: daily_appointments,
      range_appointments: range_appointments
    };
  }

  /**
   * @name resetvariables
   * @description Reset variables
   */
  function reset() {
    Appointments.artistAppointments = {};
    Appointments.collectorAppointments = {};
    Appointments.appointment = {};
    Appointments.collector = {};
    Appointments.appointments = [];
    Appointments.currentAppointments = {};
  }

  // Called to Reset Data on Logout
  var deregister = $rootScope.$on('clear-data', function () {
    reset();
  });
  $rootScope.$on('$destroy', deregister);

  return Appointments;
}]);

/***/ }),

/***/ "./components/appointments/appointments.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=schedule class=\"photo section background-dark\"> <div class=background-photo></div> <div class=\"container-fluid center\"> <div class=row> <div class=col-sm-12> <div class=intro> <h6 class=no-margin>{{$ctrl.session.activeState.association.shop.name}}</h6> <h1>Schedule.</h1> <h5 ng-if=$ctrl.loading>Loading...</h5> <h5 ng-if=!$ctrl.loading>You <span ng-if=!$ctrl.isPast>have</span> <span ng-if=$ctrl.isPast>had</span> <ng-pluralize count=$ctrl.appointmentCount when=\"{'0': 'no appointments',\n              'one': '1 appointment',\n              'other': '{} appointments'}\"> </ng-pluralize><span ng-if=$ctrl.isToday> today</span>. </h5> <div class=\"row actions\"> <div class=\"col-md-3 col-sm-2\"> <div class=\"button-add margin-bottom\" ui-sref=inkfinder.appointments.add.collector ng-if=\"$ctrl.session.activeState.role === 'operator'\"> <button class=\"button circle\" title=\"Add an appointment\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> <small>Add an appointment</small> </div> </div> <div class=\"col-md-6 col-sm-8\"> <div class=datebox-wrapper> <a class=arrow-left ng-click=$ctrl.prevDay()> <fa name=chevron-left></fa> </a> <div class=datebox> <h5>{{$ctrl.dateDisplay | amDateFormat:'dddd, MMMM Do'}}</h5> <div class=datepop ng-click=$ctrl.open($event) uib-datepicker-popup={{$ctrl.format}} ng-model=$ctrl.dateField is-open=$ctrl.status.opened min-date=$ctrl.minDate max-date=$ctrl.maxDate datepicker-options=$ctrl.dateOptions ng-change=$ctrl.selectDate() date-disabled=\"$ctrl.disabled(date, mode)\" ng-required=true close-text=Close datepicker-append-to-body=true popup-placement=bottom> </div> </div> <a class=arrow-right ng-click=$ctrl.nextDay()> <fa name=chevron-right></fa> </a> </div> <a class=services-item ng-class=\"{'disabled':$ctrl.isToday}\" ng-click=$ctrl.goToToday()> <fa name=clock-o></fa> <small>Back to today</small> </a> <a class=\"services-item second\" ng-click=$ctrl.checkAvailability() ng-if=\"$ctrl.session.activeState.role === 'operator'\"> <fa name=search></fa> <small>Check availability</small> </a> </div> <div class=\"col-md-3 col-sm-2 view-icons\"> <a class=animate-container> <div ng-if=!$ctrl.modifiers.skinny class=\"skinny-view animate fade-in\" ng-click=$ctrl.setSkinny()><small>Skinny</small></div> <div ng-if=$ctrl.modifiers.skinny class=\"wide-view animate fade-in\" ng-click=$ctrl.setWide()><small>Wide</small></div> </a> <a class=animate-container> <div ng-if=!$ctrl.modifiers.compact class=\"compact-view animate fade-in\" ng-click=$ctrl.setCompact()><small>Compact</small></div> <div ng-if=$ctrl.modifiers.compact class=\"tall-view animate fade-in\" ng-click=$ctrl.setTall()><small>Tall</small></div> </a> <div class=\"divider tight transparent\"></div> <div class=appointments-legend-wrapper> <a class=\"appointments-legend cancelled\" ui-sref=\"inkfinder.appointments-list({page: '1', status: 'Artist cancelled', sort: 'Appointment date', search: ''})\"> <span class=appointments-legend__colorbox></span>Cancelled </a> <a class=\"appointments-legend unconfirmed\" ui-sref=\"inkfinder.appointments-list({page: '1', status: 'Unconfirmed', sort: 'Appointment date', search: ''})\"> <span class=appointments-legend__colorbox></span>Unconfirmed </a> <a class=\"appointments-legend confirmed\" ui-sref=\"inkfinder.appointments-list({page: '1', status: 'Confirmed', sort: 'Appointment date', search: ''})\"> <span class=appointments-legend__colorbox></span>Confirmed </a> <a class=\"appointments-legend complete\" ui-sref=\"inkfinder.appointments-list({page: '1', status: 'Completed', sort: 'Appointment date', search: ''})\"> <span class=appointments-legend__colorbox></span>Complete </a> </div> </div> </div> </div> </div> </div> <div class=row ng-if=!$ctrl.loading> <div class=\"col-md-8 col-md-offset-2\" ng-if=\"!$ctrl.timelineMarkers.hours.length || !$ctrl.timelineMarkers.quarters.length\"> <h6>Shop closed.</h6> </div> </div> <div class=\"row wrapper-wrapper\" ng-class=\"{'skinny':$ctrl.modifiers.skinny, 'compact':$ctrl.modifiers.compact}\" ng-if=\"$ctrl.timelineMarkers.hours.length || $ctrl.timelineMarkers.quarters.length\"> <div class=\"col-lg-12 schedule-wrapper\"> <div class=schedule> <div class=schedule-time ng-if=$ctrl.timelineMarkers ng-class=\"{'open': $ctrl.events.statsOpen}\" ng-style=\"{'height': $ctrl.calcScheduleHeight($ctrl.modifiers)}\"> <div class=hour ng-repeat=\"marker in $ctrl.timelineMarkers.hours track by marker.id\" ng-style=\"{'top': $ctrl.calcOffset(marker.duration)}\"> <span class={{marker.status}}>{{marker.time | amDateFormat:'h a'}}</span> <div class=\"marker zero\" ng-class=\"{'first': $first, 'last': $last}\"><div class=line></div></div> </div> <div class=hour ng-repeat=\"marker in $ctrl.timelineMarkers.quarters track by marker.id\" ng-style=\"{'top': $ctrl.calcOffset(marker.duration)}\"> <div class=\"marker tick\" ng-class=\"{'first': $first}\"><div class=line></div></div> </div> </div> <div class=schedule-columns> <div class=inner> <div class=schedule-column ng-repeat=\"schedule_item in $ctrl.schedules | orderBy: 'first_available.start_time' track by schedule_item.artist.id\"> <fa name=lock class=\"icon light medium link\" ng-show=$ctrl.isPast tooltip-placement=top uib-tooltip=\"This schedule is locked.\" tooltip-append-to-body=true tooltip-class=light></fa> <div class=schedule-artist ng-click=\"!$ctrl.isPast && $ctrl.updateArtistHours(schedule_item.artist)\" ng-class=\"{'link': !$ctrl.isPast}\" ng-if=\"$ctrl.session.activeState.role === 'operator'\"> <div class=hover-label ng-if=!$ctrl.isPast><small>Edit schedule</small></div> <ink-profile-photo show-name=false profile=schedule_item.artist image-id=schedule_item.artist.profile_photo></ink-profile-photo> <p>{{schedule_item.artist.first_name}} {{schedule_item.artist.last_name}}</p> <small> <span ng-repeat=\"artist_hours in schedule_item.artist_start_end_times | orderBy:'start_time'\"> {{artist_hours.start | amDateFormat:'h:mm a'}}–{{artist_hours.end | amDateFormat:'h:mm a'}} <span ng-if=\"schedule_item.artist_start_end_times.length > 1\">, </span> </span> <span ng-if=\"schedule_item.artist_start_end_times.length === 0\" class=alert-color>Off</span> </small> </div> <div class=schedule-artist ng-if=\"$ctrl.session.activeState.role === 'artist'\"> <ink-profile-photo show-name=false profile=schedule_item.artist image-id=schedule_item.artist.profile_photo></ink-profile-photo> <p>{{schedule_item.artist.first_name}} {{schedule_item.artist.last_name}}</p> <small> <span ng-repeat=\"artist_hours in schedule_item.artist_start_end_times | orderBy:'start_time'\"> {{artist_hours.start | amDateFormat:'h:mm a'}}–{{artist_hours.end | amDateFormat:'h:mm a'}} <span ng-if=\"schedule_item.artist_start_end_times.length > 1\">, </span> </span> <span ng-if=\"schedule_item.artist_start_end_times.length === 0\" class=alert-color>Off</span> </small> </div> <div ng-class=\"{'open':$ctrl.events.statsOpen}\"> <div class=artist-details> <div class=\"artist-stats list stats\" ng-show=$ctrl.events.statsOpen ng-class=\"{'open':$ctrl.events.statsOpen}\"> <div class=\"item stat\"> <h5>{{schedule_item.stats.revenue | noFractionCurrency}}</h5> <small>Total earned</small> </div> </div> </div> </div> <div class=schedule-projects ng-class=\"{'first' : $first, 'last' : $last, 'off':schedule_item.artist_start_end_times.length === 0}\" ng-style=\"{'height': $ctrl.calcScheduleHeight($ctrl.modifiers)}\"> <div class=\"list projects\"> <a class=\"item project compact animate fade-in fade-out appointment link {{block.appointment.last_status.status_name | lowercase}} appt-level-{{block.appointment.apptLevel}}\" ng-repeat=\"block in schedule_item.appointments track by block.appointment.id\" ng-class=\"{'buffer':block.appointment_buffer, 'short': block.length < 100, 'shorter': block.length < 80, 'shortest': block.length < 39, 'tiny': block.length < 20}\" ng-style=\"{'top': $ctrl.calcBlockOffset(block, $ctrl.modifiers), 'height': $ctrl.calcHeightRoot(block.length + block.appointment_buffer)}\" ui-sref=inkfinder.appointments.details({appointment_id:block.appointment.id})> <div class=appointment__status-bar ng-class=\"{'overlapping': block.appointment.overlappingAppt}\"> <div class=overlapping-handle title=\"This appointment overlaps one or more other appointments\"><fa name=exclamation-triangle></fa></div> </div> <div class=\"project-background no-photo\" ng-style=\"{'height': $ctrl.calcHeight(block.length, block.length + block.appointment_buffer)}\" ng-class=\"{'off':schedule_item.artist_start_end_times.length === 0}\"> <div class=project-overlay> <div class=timebox ng-if=block.appointment.appointment_datetime> <div class=day-date>{{block.appointment.appointment_datetime | amDateFormat:'h:mm a'}} - {{block.appointment.end_date | amDateFormat:'h:mm a'}}</div> </div> <div class=\"details flex-container flex-direction-column\"> <div class=details-wrapper> <h5 title=\"{{block.project.collector.first_name}} {{block.project.collector.last_name}}\">{{block.project.collector.first_name}} {{block.project.collector.last_name}}</h5> <p title={{block.project.name}}>{{block.project.name}}</p> <p><span ng-if=block.project.style.id>{{block.project.style.name}} on </span>{{block.project.location.name}}</p> <p ng-if=\"block.appointment.current_status === 40 || block.appointment.current_status === 50\" title=\"{{block.appointment.estimate_min | noFractionCurrency}} - {{block.appointment.estimate_max | noFractionCurrency}}\"> {{block.appointment.estimate_min | noFractionCurrency}} <span ng-if=block.appointment.estimate_max>–</span> {{block.appointment.estimate_max | noFractionCurrency}} </p> </div> <div class=statuses> <div class=\"status appointment first\" ng-class=\"{\n                              'deposit': block.appointment.paymentData.hasPaidDeposit ||\n                              block.appointment.previously_paid\n                            }\" tooltip-append-to-body=true uib-tooltip={{block.appointment.paymentToolTip}} tooltip-placement=top tooltip-class=light> <fa name=check></fa> </div> </div> </div> </div> </div> </a> <div class=\"item project compact add\" ng-repeat=\"block in schedule_item.available | orderBy:'-project.appointment_datetime':true\" ng-class=\"{'buffer':block.appointment_buffer, 'short': block.length < 100, 'shorter': block.length < 80, 'shortest': block.length < 39, 'tiny': block.length < 20}\" ng-style=\"{'top': $ctrl.calcBlockOffset(block, $ctrl.modifiers), 'height': $ctrl.calcHeightRoot(block.length)}\"> <div class=project-background ui-sref=inkfinder.appointments.add.collector ng-if=\"$ctrl.session.activeState.role === 'operator'\"> <div class=button-add ng-class=\"{'short' : block.length < 80}\"> <button class=\"button circle\" title=\"Add an appointment\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> <small>Add an appointment</small> </div> </div> </div> </div> </div> </div> <div class=schedule-column ng-if=\"$ctrl.isPast && !$ctrl.schedules.length\"> <div class=\"schedule-projects placeholder\" ng-class=\"{'stats-open':$ctrl.events.statsOpen}\"> <div class=project-background ng-if=$ctrl.period ng-style=\"{'height': $ctrl.calcScheduleHeight($ctrl.modifiers)}\"> </div> </div> </div> <div class=schedule-column ng-if=\"!$ctrl.isPast && $ctrl.session.activeState.role === 'operator'\"> <div class=\"schedule-artist add\"> <div class=button-add> <button class=\"button circle\" ng-click=$ctrl.updateArtistHours(null) title=\"Add an appointment\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> <small>Add an artist</small> </div> </div> <div class=\"schedule-projects add\" ng-class=\"{'stats-open':$ctrl.events.statsOpen}\"> <div class=project-background ng-if=$ctrl.period ng-style=\"{'height': $ctrl.calcScheduleHeight($ctrl.modifiers)}\"> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/appointments/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/add/index.js");

__webpack_require__("./components/appointments/appointment/index.js");

__webpack_require__("./components/appointments/util/index.js");

__webpack_require__("./components/appointments/appointments.component.js");

__webpack_require__("./components/appointments/appointments.controller.js");

__webpack_require__("./components/appointments/appointments.service.js");

__webpack_require__("./components/appointments/_appointments.styles.scss");

__webpack_require__("./components/appointments/_appointments-legend.styles.scss");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', 'moment', function ($stateProvider, USER_ROLES, moment) {
  $stateProvider.state('inkfinder.appointments', {
    abstract: true,
    url: '/appointments'
  }).state('inkfinder.appointments.days', {
    url: '/{year:[0-9]{1,4}}/{month:[0-9]{1,4}}/{day:[0-9]{1,4}}',
    views: {
      '@': {
        component: 'inkAppointments'
      }
    },
    params: {
      month: {
        value: moment().format('MM'),
        dynamic: true
      },
      year: {
        value: moment().format('YYYY'),
        dynamic: true
      },
      day: {
        value: moment().format('DD'),
        dynamic: true
      }
    },
    resolve: {
      $title: function $title() {
        return 'Schedule';
      }
    },
    data: {
      authorizedRoles: [USER_ROLES.operator, USER_ROLES.artist]
    },
    bindings: {
      $transition$: '<'
    }
  });
}]);

/***/ }),

/***/ "./components/appointments/util/api-format.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('AppointmentApiFormat', ['Session', 'moment', '_', function AppointmentApiFormat(Session, moment, _) {
  // Public methods
  AppointmentApiFormat.format = format;
  /**
  * @name format
  * @description Function to format the input of a new appointment to the object
  * the endpoint requires.
  * @param {object} input The appointment to be formatted.
  * @param {number} status The status of the new appointment.
  * @return {object} appointment Returns the saveda appointment.
  */
  function format(input, status) {
    var appointment = {};
    if (input.adjusted_appointment_date && input.appointment_start_time) {
      appointment.appointment_datetime = moment(input.adjusted_appointment_date).format('YYYY-MM-DD') + ' ' + moment(input.appointment_start_time).format('HH:mm:ss');
    } else if (input.appointment_date && input.appointment_start_time) {
      appointment.appointment_datetime = moment(input.appointment_date).format('YYYY-MM-DD') + ' ' + moment(input.appointment_start_time).format('HH:mm:ss');
    } else if (input.appointment_datetime) {
      appointment.appointment_datetime = moment(input.appointment_datetime).format('YYYY-MM-DD HH:mm:ss');
    }
    if (input.durationHours || input.durationMinutes) {
      var hours = 0;
      var minutes = 0;
      if (input.durationHours) {
        hours = input.durationHours * 60;
      }
      if (input.durationMinutes) {
        minutes = input.durationMinutes;
      }
      appointment.length = parseInt(hours, 10) + parseInt(minutes, 10);
    }

    if (input.adjustedLength) {
      // Used in Complete Appointment Only
      appointment.length = input.adjustedLength;
    }
    if (input.preferred_start_date) {
      appointment.preferred_start_date = input.preferred_start_date;
    }
    if (input.preferred_end_date) {
      appointment.preferred_end_date = input.preferred_end_date;
    }
    if (input.artist) {
      appointment.artist_id = input.artist.id;
    }
    if (input.previously_paid) {
      appointment.previously_paid = input.previously_paid;
    } else {
      appointment.previously_paid = false;
    }
    if (input.estimate_min || input.estimate_min === 0) {
      appointment.estimate_min = parseInt(input.estimate_min, 10);
    }
    if (input.estimate_max || input.estimate_max === 0) {
      appointment.estimate_max = parseInt(input.estimate_max, 10);
    }
    if (input.price) {
      appointment.price = input.price;
    }
    if (input.deposit_amount) {
      var deposit = parseFloat(input.deposit_amount);
      if (deposit > 0) {
        appointment.deposit_amount = deposit;
      } else if (deposit === 0) {
        appointment.deposit_amount = 0;
      } else if (deposit === null) {
        appointment.deposit_amount = null;
      }
    }
    if (input.deposit_required === false) {
      if (input.deposit_amount !== null && !_.isUndefined(input.deposit_amount)) {
        appointment.deposit_amount = 0;
      }
    }
    if (input.project) {
      appointment.project_id = input.project;
    }
    if (input.project_id) {
      // Create Appointment uses This.
      appointment.project_id = input.project_id;
    }
    if (input.preferred_time) {
      appointment.preferred_time = parseInt(input.preferred_time, 10);
    }
    if (input.preferred_start_date) {
      appointment.preferred_start_date = moment(input.preferred_start_date).format('YYYY-MM-DD');
    }
    if (input.preferred_end_date) {
      appointment.preferred_end_date = moment(input.preferred_end_date).format('YYYY-MM-DD');
    }
    if (input.managed_by) {
      appointment.managed_by = input.managed_by.id;
    }
    if (status) {
      appointment.status_id = status;
    }
    if (input.id) {
      appointment.id = input.id;
    }
    if (input.agreed_to_cancellation_policy) {
      appointment.agreed_to_cancellation_policy = input.agreed_to_cancellation_policy;
    }
    if (!_.isUndefined(Session.activeState.association)) {
      appointment.association_id = Session.activeState.association.id;
    }
    appointment.role = Session.activeState.role;
    return appointment;
  }
  return AppointmentApiFormat;
}]);

/***/ }),

/***/ "./components/appointments/util/format-appointments.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('FormatAppointment', ['moment', 'Payments', 'PREFERRED_TIME', 'STATUS_IDS', 'STATUS', '_', function FormatAppointment(moment, Payments, PREFERRED_TIME, STATUS_IDS, STATUS, _) {
  // Public methods
  FormatAppointment.formatCollection = formatCollection;
  FormatAppointment.format = format;

  /**
   * @name formatCollection
   * @description Formats an array of appointments
   * @param {array} appointments The array of appointments to format.
   * @return {array} formatted Returns an array of formatted appointments.
   */
  function formatCollection(appointments) {
    var formatted = _.each(appointments, function (appointment) {
      return format(appointment);
    });
    return formatted;
  }

  /**
   * @name format
   * @description Formats an appointment.
   * @param {object} appointment The appointment to format.
   * @return {object} formatted Returns the formatted appointment.
   */
  function format(appointment) {
    var formatted = appointment;

    // Appointment preferred time
    formatted.preferredTime = _.find(PREFERRED_TIME, function (time) {
      if (appointment.preferred_time === time.id) {
        return true;
      }
    });

    // Appointment datetime formatting
    if (appointment.appointment_datetime !== null) {
      formatted.date = moment(appointment.appointment_datetime);
      formatted.calendarTime = moment(appointment.appointment_datetime, 'YYYY-MM-DDTHH:mm:ss').calendar(null, {
        lastDay: '[Yesterday]',
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        lastWeek: '[last] dddd',
        nextWeek: 'dddd',
        sameElse: 'L'
      });
      formatted.startTime = moment(appointment.appointment_datetime, 'YYYY-MM-DDTHH:mm:ss').format('h:mm a');
      formatted.start = moment(appointment.appointment_datetime);
      formatted.startTimecode = moment(appointment.appointment_datetime).unix();
      formatted.endTime = moment(appointment.end_date, 'YYYY-MM-DDTHH:mm:ss').format('h:mm a');
      formatted.end = moment(appointment.end_date);

      // Determine if Appointment has occured yet.
      if (moment(appointment.appointment_datetime) > moment()) {
        formatted.isPast = true;
      } else {
        formatted.isPast = false;
      }
    }

    // Appointment duration
    if (appointment.length) {
      formatted.durationHours = moment.duration(appointment.length).hours();
      formatted.durationMinutes = moment.duration(appointment.length).minutes();
      formatted.duration = moment(appointment.end_date).diff(formatted.date, 'minutes');
    }

    // Payments formatting
    if (appointment.previously_paid === true) {
      formatted.outstandingBalance = false;
    } else if (appointment.price === null) {
      formatted.outstandingBalance = true;
    } else {
      var outstandingBalance = appointment.price;
      for (var k = 0; k < appointment.payments.length; k++) {
        var payment = appointment.payments[k];
        if (payment.status === 1) {
          outstandingBalance -= payment.amount;
        }
      }
      formatted.outstandingBalance = outstandingBalance > 0;
    }

    // Deposits
    if (formatted.deposit_amount > 0) {
      formatted.deposit_required = true;
    } else {
      formatted.deposit_required = false;
    }

    // appointment.status is an array
    var allStatus = _.sortBy(appointment.status, 'created').reverse();
    formatted.last_status = allStatus[0];
    // Set if this appointment is ready to archive. When an appointment has reached
    // confirmed status or higher, it is no longer ready to archive.
    if (formatted.last_status.status_id === STATUS_IDS.requested || formatted.last_status.status_id === STATUS_IDS.requestDeclined || formatted.last_status.status_id === STATUS_IDS.expired || formatted.last_status.status_id === STATUS_IDS.unconfirmed || formatted.last_status.status_id === STATUS_IDS.declined) {
      formatted.archiveReady = true;
    } else {
      formatted.archiveReady = false;
    }

    // Parse all appointment payments
    Payments.process(appointment).then(function (paymentData) {
      formatted.paymentData = paymentData;

      // Payment status tooltips
      if (formatted.deposit_amount && formatted.paymentData.depositTotal >= formatted.deposit_amount) {
        formatted.paymentToolTip = 'Deposit paid';
      } else if (formatted.previously_paid) {
        formatted.paymentToolTip = 'Previously paid';
      } else {
        formatted.paymentToolTip = 'Deposit not paid';
      }

      // Tooltips for all other statuses
      if (formatted.last_status.status_id === STATUS_IDS.confirmed) {
        formatted.statusToolTip = 'Appointment confirmed';
      } else if (formatted.last_status.status_id === STATUS_IDS.declined) {
        formatted.statusToolTip = 'Declined by the client';
      } else if (formatted.last_status.status_id === STATUS_IDS.requestDeclined) {
        formatted.statusToolTip = 'Declined by the artist';
      } else if (formatted.last_status.status_id === STATUS_IDS.collectorCancelled) {
        formatted.statusToolTip = 'Cancelled by the client';
      } else if (formatted.last_status.status_id === STATUS_IDS.artistCancelled) {
        formatted.statusToolTip = 'Cancelled by the artist';
      } else if (formatted.last_status.status_id === STATUS_IDS.completed) {
        formatted.statusToolTip = 'Complete';
      }
    });

    // Set status names to more friendly terms
    formatted.last_status.label = STATUS[_.camelCase(formatted.last_status.status_name)];

    // Set overlapping variable to false
    formatted.overlappingAppt = false;

    // Set appt overlapping level
    formatted.apptLevel = 0;

    return formatted;
  }
  return FormatAppointment;
}]);

/***/ }),

/***/ "./components/appointments/util/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/appointments/util/api-format.service.js");

__webpack_require__("./components/appointments/util/format-appointments.service.js");

__webpack_require__("./components/appointments/util/merge-projects.service.js");

/***/ }),

/***/ "./components/appointments/util/merge-projects.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('MergeProjects', ['Projects', '_', function MergeProjects(Projects, _) {
  // Public methods
  MergeProjects.merge = merge;
  /**
   * @name merge
   * @description Function to call and merge projects with appointments.
   * @param {array} appointments The array of appointments to merge projects with.
   * @return {array} MergeProjects Returns the grouped collection.
   */
  function merge(appointments) {
    if (appointments.length > 0) {
      var projectIds = _.map(appointments, function (appointment) {
        return appointment.project;
      }).join(',');
      return Projects.get(projectIds).then(function (projects) {
        var mergedAppointments = [];
        _.each(appointments, function (appointment) {
          var data = {};
          data.appointment = appointment;
          data.project = _.find(projects, function (project) {
            if (appointment.project === project.id) {
              return true;
            }
          });
          mergedAppointments.push(data);
        });
        return mergedAppointments;
      });
    }
  }
  return MergeProjects;
}]);

/***/ }),

/***/ "./components/artists/_artists.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509255
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/artists/add/add-user.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddUserController.$inject = ['$state', '$rootScope', 'Collector', 'Association', 'Operators', 'Artists', 'NOTIFICATIONS', 'Notification', 'InvitationFactory', 'moment', 'AlertMessages', 'Session'];
/**
 * @name AddUserController
 * @description Controller to add a user
 * @param {type} $state Description
 * @param {type} $rootScope Description
 * @param {type} Collector Description
 * @param {type} Association Description
 * @param {type} Operators Description
 * @param {type} Artists Description
 * @param {type} NOTIFICATIONS Description
 * @param {type} Notification Description
 * @param {type} InvitationFactory Description
 * @param {type} moment Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 */
function AddUserController($state, $rootScope, Collector, Association, Operators, Artists, NOTIFICATIONS, Notification, InvitationFactory, moment, AlertMessages, Session) {
  var vm = this;

  // Public Functions
  vm.searchCollectors = searchCollectors;
  vm.selectCollector = selectCollector;
  vm.createCollector = createCollector;
  vm.createAssociation = createAssociation;
  vm.startOver = startOver;

  // Public Variables
  vm.session = Session;
  vm.collectors = [];
  vm.selectedCollector = {};
  vm.newCollector = {};
  vm.association = {
    startDatetime: moment().startOf('day').toDate(),
    can_update_appts: true
  };

  // Private variables
  var startingRoute = $state.current.data.startingRoute[0];

  /**
   * @name searchCollectors
   * @description Search for an artist by searching collector object phone and email fields
   * @param {type} query Description
   * @param {type} type Description
   * @param {type} nextRoute Description
   */
  function searchCollectors(query, type, nextRoute) {
    var searchFields = 'phone,email';
    Collector.searchCollectors(query, searchFields).then(function (collectors) {
      vm.collectors = collectors;

      if (type === 'artist') {
        Artists.refreshArtists().then(function (artists) {
          Association.determineAssociationConflict(vm.collectors, artists);
          $state.go(nextRoute);
        });
      } else {
        Operators.getAllForShop().then(function (operators) {
          Association.determineAssociationConflict(vm.collectors, operators);
          $state.go(nextRoute);
        });
      }
    });
  }

  /**
   * @name createCollector
   * @description Create a collector
   * @param {type} nextRoute Description
   */
  function createCollector(nextRoute) {
    Collector.createCollector(vm.newCollector).then(function (collector) {
      var id = collector.id;
      Collector.getCollector(id).then(function (collector) {
        vm.selectedCollector = collector;
        $state.go(nextRoute);
      });
    });
  }

  /**
   * @name selectCollector
   * @description Select a Collector
   * @param {type} collector Description
   * @param {type} nextRoute Description
   */
  function selectCollector(collector, nextRoute) {
    if (!collector.inviteStatus) {
      vm.selectedCollector = collector;
      $state.go(nextRoute);
    }
  }

  /**
   * @name createAssociation
   * @description Create an association
   * @param {type} type Description
   * @param {type} nextRoute Description
   */
  function createAssociation(type, nextRoute) {
    // Set the notification object
    var _association = {
      collector_id: vm.selectedCollector.id,
      shop_id: Session.activeState.association.shop.id,
      status: 'Shop Invited',
      startDatetime: vm.association.startDatetime,
      endDatetime: vm.association.endDatetime,
      can_update_appts: vm.association.can_update_appts,
      operatorAdmin: vm.association.operatorAdmin,
      operatorOwner: vm.association.operatorOwner
    };

    /**
     * @name createInvitation
     * @description Define the function to create invitations and define the invitation object
     * @param {type} association Description
     * @return {type} Description
     */
    function createInvitation(association) {
      vm.newAssociation = association;
      var invitation = {
        collectorId: association.collector.id,
        shopId: association.shop.id,
        associationId: association.id
      };
      return InvitationFactory.createInvitation(invitation);
    }

    /**
     * @name sendNotification
     * @description Define the function to send notifications and define the notification object
     * @param {type} invitation Description
     */
    function sendNotification(invitation) {
      var _collectorType = invitation.association.type.toLowerCase();
      var _notificationType = _collectorType + 'Invite';
      var notification = {
        recipients: [vm.selectedCollector.id],
        notificationId: NOTIFICATIONS[_notificationType],
        messageObjects: {
          shopId: Session.activeState.association.shop.id,
          invitationId: invitation.id
        },
        messageVariables: {
          subject: vm.selectedCollector.first_name + ', you’re invited to join ' + Session.activeState.association.shop.name
        }
      };
      Notification.send(notification);
    }

    /**
     * @name wrapUp
     * @description Wrapup the create association function and send the user to
     * the complete route
     */
    function wrapUp() {
      $state.go(nextRoute);
    }

    // Chain the creation of associations, invitations, and notifications
    Association.createAssociation(type, _association).then(createInvitation).then(sendNotification).then(wrapUp).catch(function (error) {
      // Delete the association if an invitation could not be created
      Association.deleteAssociation(vm.newAssociation);
      AlertMessages.add({
        msg: 'We tried to save this invitation, but something failed. Please try again.',
        type: 'danger'
      });
      startOver();
    });
  }

  /**
   * @name startOver
   * @description Reset any data retrieved or saved in the add artist workflow
   */
  function startOver() {
    $state.go(startingRoute);
    vm.collectors = [];
    vm.selectedCollector = {};
    vm.newCollector = {};
  }

  // Return to search/add if a collector hasn't been selected anywhere in the process
  if (!vm.selectedCollector.length) {
    startOver();
  }
}

angular.module('inkfinder').controller('AddUserController', AddUserController);

/***/ }),

/***/ "./components/artists/add/artist-add-complete.html":
/***/ (function(module, exports) {

module.exports = " <div class=intro> <h1>Sent!</h1> <h5>You’re all set.</h5> </div> <div class=row> <div class=\"col-md-8 col-md-offset-2 center\"> <div class=\"collector center\"> <ink-profile-photo show-name=true profile=AddUserController.selectedCollector image-id=AddUserController.selectedCollector.profile_photo></ink-profile-photo> </div> <div class=\"divider small tight transparent\"></div> <h6>We’ll alert you as soon as {{AddUserController.selectedCollector.first_name}} confirms your invitation.</h6> <div class=button-container> <button class=\"button large shop-solid\" ui-sref=inkfinder.artists>View artists</button> </div> </div> </div> ";

/***/ }),

/***/ "./components/artists/add/artist-association.html":
/***/ (function(module, exports) {

module.exports = " <div class=intro> <h1>Set the dates.</h1> <h5>When will <span ng-if=AddUserController.selectedCollector.first_name>{{AddUserController.selectedCollector.first_name}}</span> <span ng-if=!AddUserController.selectedCollector.first_name>this artist</span> start at your shop? </h5> </div> <div class=row> <div class=\"col-md-8 col-md-offset-2 center\"> <div class=\"collector center\"> <ink-profile-photo profile=AddUserController.selectedCollector image-id=AddUserController.selectedCollector.profile_photo></ink-profile-photo> <div class=\"divider small tight transparent\"></div> </div> <div class=\"row left\"> <div class=col-md-6> <h6>Resident artists</h6> <p>Resident artists without an end date will stay on your roster indefinitely. You can remove them at any time.</p> </div> <div class=col-md-6> <h6>Guest artists</h6> <p>Guest artists with an end date will automatically be removed from your roster after their guest spot has ended.</p> </div> </div> <div class=\"divider small tight\"></div> </div> <div class=\"col-md-8 col-md-offset-2 center\"> <form name=createAssociation class=left ng-submit=\"createAssociation.$valid && AddUserController.createAssociation('Artist', 'inkfinder.artists.add.complete')\" novalidate> <div class=row> <div class=col-md-6> <div class=form-group> <label for=raw_start_date>Start date</label> <div class=input-group> <input name=start_date id=start_date type=text class=form-control uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=AddUserController.association.startDatetime placeholder=MM/DD/YYYY is-open=AddUserController.date_picker.start_open datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close required/> <span class=input-group-btn> <button type=button class=\"btn btn-default button large shop calendar-button\" ng-click=\"AddUserController.date_picker.start_open = !AddUserController.date_picker.start_open\"> <fa name=calendar-o></fa> </button> </span> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createAssociation.start_date.$invalid && !createAssociation.start_date.$pristine\"> We need a starting date! </p> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=raw_end_date>End date</label> <div class=input-group> <input name=end_date id=end_date type=text class=form-control uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=AddUserController.association.endDatetime placeholder=MM/DD/YYYY is-open=AddUserController.date_picker.end_open min-date=AddUserController.association.startDatetime datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default button large shop calendar-button\" ng-click=\"AddUserController.date_picker.end_open = !AddUserController.date_picker.end_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-12> <div class=form-group> <label> <input name=canUpdateAppts type=checkbox ng-model=AddUserController.association.can_update_appts> {{AddUserController.selectedCollector.first_name}} can update their own appointments<br/> <small>This includes rescheduling and cancelling appointments</small> </label> </div> </div> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=createAssociation.$invalid>Send invite</button> <button class=\"button large alert-btn\" type=reset ng-click=AddUserController.startOver()>Start Over</button> </div> </form> </div> </div> ";

/***/ }),

/***/ "./components/artists/add/collector-create.html":
/***/ (function(module, exports) {

module.exports = " <div class=intro> <h1>Create an account.</h1> <h5>Create an Ink Finder account for this artist.</h5> </div> <div class=row> <div class=\"col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 center\"> <form name=createCollector class=left ng-submit=\"createCollector.$valid && AddUserController.createCollector('inkfinder.artists.add.association')\" novalidate> <div class=form-group> <label for=first_name>First name</label> <input name=first_name id=first_name type=text class=form-control placeholder=Darth required ng-model=AddUserController.newCollector.first_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.first_name.$invalid && !createCollector.first_name.$pristine\"> We need a first name! </p> </div> </div> <div class=form-group> <label for=last_name>Last name</label> <input name=last_name id=last_name type=text class=form-control placeholder=Vader required ng-model=AddUserController.newCollector.last_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.last_name.$invalid && !createCollector.last_name.$pristine\"> We need a last name! </p> </div> </div> <div class=form-group> <label for=email>Email</label> <input name=email id=email type=email class=form-control placeholder=vader@deathstar.com required ng-model=AddUserController.newCollector.email> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.email.$invalid && !createCollector.email.$pristine\"> Hmm...I don’t think that's a real email address. </p> </div> </div> <div class=form-group> <label for=phone>Phone <small>Optional</small></label> <input name=phone id=phone placeholder=\"(555) 555–1234\" mask=\"(999) 999-9999\" clean=true restrict=reject type=text ng-model=AddUserController.newCollector.phone> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.phone.$invalid && !createCollector.phone.$pristine\"> You won’t be talking to anyone with that number. </p> </div> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=createCollector.$invalid>Create account</button> <button class=\"button large alert-btn\" type=reset ng-click=AddUserController.startOver()>Start Over</button> </div> </form> </div> </div> ";

/***/ }),

/***/ "./components/artists/add/collector-search-add.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"intro center\"> <h1>Add an artist.</h1> <h5>Search for an existing artist or add a new one.</h5> </div> <div class=row> <div class=\"col-sm-5 col-sm-offset-1 left\"> <h6>Search for an artist on Ink Finder</h6> <form name=searchCollectors ng-submit=\"searchCollectors.$valid && AddUserController.searchCollectors(query, 'artist', 'inkfinder.artists.add.collector-select')\" novalidate> <div class=form-group> <label for=search>Enter an email or phone number</label> <input name=search id=search type=text autocapitalize=off placeholder=\"Email or phone number\" class=form-control required ng-init=\"query = ''\" ng-model=query ng-keyup=\"$event.keyCode === 13 && searchCollectors.$invalid\"> </div> <div class=\"button-container left\"> <button class=\"button large shop-solid\" type=submit ng-disabled=searchCollectors.$invalid>Search</button> </div> </form> </div> <div class=\"col-sm-6 center\"> <h6 class=center>Add a new artist</h6> <div class=\"button-add no-margin\" ui-sref=inkfinder.artists.add.collector-create> <button class=\"button circle\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> </div> </div> </div> ";

/***/ }),

/***/ "./components/artists/add/collector-select.html":
/***/ (function(module, exports) {

module.exports = " <div class=intro> <h1>Recognize anyone?</h1> <h5>Select someone below, <a ui-sref=inkfinder.artists.add.collector-create>create a new account</a>, or <a ng-click=AddUserController.startOver()>search again</a>. </h5> </div> <div ng-if=\"AddUserController.collectors.length > 0\"> <ink-collector-list list=AddUserController.collectors type=\"'artist'\" select=\"AddUserController.selectCollector(collector, 'inkfinder.artists.add.association')\"> </ink-collector-list></div> <div ng-if=\"AddUserController.collectors.length === 0\" class=\"animate fade-in-up fade-out-down\"> <h5 class=shop-color>Oops. We couldn't find anyone...</h5> </div> ";

/***/ }),

/***/ "./components/artists/add/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/artists/add/add-user.controller.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.artists.add', {
    url: '/add',
    abstract: true,
    views: {
      '@': {
        template: __webpack_require__("./components/artists/add/template.base.html"),
        controller: 'AddUserController as AddUserController'
      }
    },

    // Set the starting route of the add artist process
    data: {
      startingRoute: ['inkfinder.artists.add.search']
    }
  })

  // Add an artist: Collector search
  .state('inkfinder.artists.add.search', {
    url: '/search',
    template: __webpack_require__("./components/artists/add/collector-search-add.html"),
    resolve: {
      $title: function $title() {
        return 'Invite an artist';
      }
    }
  })

  // Add an artist: Select a collector
  .state('inkfinder.artists.add.collector-select', {
    url: '/select',
    template: __webpack_require__("./components/artists/add/collector-select.html"),
    resolve: {
      $title: function $title() {
        return 'Search results';
      }
    }
  })

  // Add an artist: Add a collector
  .state('inkfinder.artists.add.collector-create', {
    url: '/invite',
    template: __webpack_require__("./components/artists/add/collector-create.html"),
    resolve: {
      $title: function $title() {
        return 'Create an account';
      }
    }
  })

  // Add an artist: Add the association
  .state('inkfinder.artists.add.association', {
    url: '/association',
    template: __webpack_require__("./components/artists/add/artist-association.html"),
    resolve: {
      $title: function $title() {
        return 'Set start and end dates';
      }
    }
  })

  // Add an artist: Invite complete
  .state('inkfinder.artists.add.complete', {
    url: '/complete',
    template: __webpack_require__("./components/artists/add/artist-add-complete.html"),
    resolve: {
      $title: function $title() {
        return 'Artist invite complete';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/artists/add/template.base.html":
/***/ (function(module, exports) {

module.exports = "<div id=artists class=\"section photo background-dark\"> <div class=background-photo></div> <div class=\"container-fluid center\"> <div class=row> <div ui-view=\"\" class=col-sm-12></div> </div> </div> </div> ";

/***/ }),

/***/ "./components/artists/artist/hours/artist-hours.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ArtistHours.$inject = ['$http', 'ENDPOINT', 'AlertMessages', 'Session'];


/**
 * @name ArtistHours
 * @description Function for the ArtistHours service
 * @param {type} $http Description
 * @param {type} ENDPOINT Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 * @return {object} Returns the ArtistHours service
 */
function ArtistHours($http, ENDPOINT, AlertMessages, Session) {
  ArtistHours.get = get;

  /**
   * @name get
   * @description Function to get an array of artist hours
   * @param {number} id The collector ID of the artist
   * @return {array} Returns an array of hours
   */
  function get(id) {
    return $http.get(ENDPOINT.server + 'schedules/api/v1.1/artist-hours/?artist_id=' + id).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return ArtistHours;
}

angular.module('inkfinder').factory('ArtistHours', ArtistHours);

/***/ }),

/***/ "./components/artists/artist/hours/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/artists/artist/hours/artist-hours.service.js");

/***/ }),

/***/ "./components/artists/artist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/artists/artist/hours/index.js");

__webpack_require__("./components/artists/artist/stats/index.js");

/***/ }),

/***/ "./components/artists/artist/stats/artist-stats.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkArtistStats = {
  controller: 'ArtistStatsController',
  template: __webpack_require__("./components/artists/artist/stats/artist-stats.template.html")
};

angular.module('inkfinder').component('inkArtistStats', inkArtistStats);

/***/ }),

/***/ "./components/artists/artist/stats/artist-stats.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ArtistStatsController.$inject = ['$scope', '$interval', 'Appointments', 'moment', 'STATUS_IDS'];


/**
 * @name ArtistStatsController
 * @description Controller for shop stats
 * @param {type} $scope Description
 * @param {type} $interval Description
 * @param {type} Appointments Description
 * @param {type} moment The Moment library
 * @param {type} STATUS_IDS The appointment status IDs constant
 */
function ArtistStatsController($scope, $interval, Appointments, moment, STATUS_IDS) {
  var vm = this;
  vm.$onInit = function () {
    vm.updateFilter = updateFilter;
    vm.intervalSelect = 'today';
    vm.period = {};
    vm.updating = false;
    vm.stats = {};
    updateFilter();
  };

  var statsTimer = void 0;
  statsTimer = $interval(update, 60000);

  // Called to Reset Data on Logout
  $scope.$on('clear-data', function () {
    $interval.cancel(statsTimer);
  });

  /**
   * @name update
   * @description Function to update stats
   */
  function update() {
    var start = vm.period.firstDay;
    var end = vm.period.lastDay;
    var search = false;
    var timestamp = null;

    Appointments.get(search, start, end, timestamp).then(function (appointments) {
      var revenueTotal = 0;
      var projectTotal = 0;
      var tipTotal = 0;

      for (var i = 0; i < appointments.length; i++) {
        var current = appointments[i];
        if (current.current_status === STATUS_IDS.completed) {
          projectTotal++;
          revenueTotal += current.price;
          current.paymentData.tipTotal ? tipTotal += current.paymentData.tipTotal : tipTotal + 0;
        }
      }
      vm.stats.appointments = projectTotal;
      vm.stats.revenue = revenueTotal;
      vm.stats.tips = tipTotal;
      vm.stats.average = projectTotal ? revenueTotal / projectTotal : 0;
      vm.updating = false;
    });
  }

  /**
   * @name setIntervals
   * @description Function to set the intervals of the quick stats shelf.
   */
  function updateFilter() {
    vm.updating = true;
    vm.period = {};

    if (vm.intervalSelect === 'yesterday') {
      vm.period.firstDay = moment().subtract(1, 'days').startOf('day');
      vm.period.lastDay = moment().subtract(1, 'days').endOf('day');
    } else if (vm.intervalSelect === 'thisWeek') {
      vm.period.firstDay = moment().startOf('week');
      vm.period.lastDay = moment().endOf('week');
    } else if (vm.intervalSelect === 'lastWeek') {
      vm.period.firstDay = moment().subtract(1, 'weeks').startOf('week');
      vm.period.lastDay = moment().subtract(1, 'weeks').endOf('week');
    } else if (vm.intervalSelect === 'thisMonth') {
      vm.period.firstDay = moment().startOf('month');
      vm.period.lastDay = moment().endOf('month');
    } else if (vm.intervalSelect === 'lastMonth') {
      vm.period.firstDay = moment().subtract(1, 'months').startOf('month');
      vm.period.lastDay = moment().subtract(1, 'months').endOf('month');
    } else if (vm.intervalSelect === 'thisQuarter') {
      vm.period.firstDay = moment().startOf('quarter');
      vm.period.lastDay = moment().endOf('quarter');
    } else if (vm.intervalSelect === 'lastQuarter') {
      vm.period.firstDay = moment().subtract(1, 'quarters').startOf('quarter');
      vm.period.lastDay = moment().subtract(1, 'quarters').endOf('quarter');
    } else if (vm.intervalSelect === 'thisYear') {
      vm.period.firstDay = moment().startOf('year');
      vm.period.lastDay = moment().endOf('year');
    } else if (vm.intervalSelect === 'lastYear') {
      vm.period.firstDay = moment().subtract(1, 'years').startOf('year');
      vm.period.lastDay = moment().subtract(1, 'years').endOf('year');
    } else {
      vm.period.firstDay = moment().startOf('day');
      vm.period.lastDay = moment().endOf('day');
    }
    update();
  }
}

angular.module('inkfinder').controller('ArtistStatsController', ArtistStatsController);

/***/ }),

/***/ "./components/artists/artist/stats/artist-stats.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182511126
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/artists/artist/stats/artist-stats.template.html":
/***/ (function(module, exports) {

module.exports = " <div class=artist-dashboard-stats> <div class=\"col-sm-12 artist-stats__selected\"> <h6>Your stats</h6> <select class=small ng-model=$ctrl.intervalSelect ng-change=$ctrl.updateFilter()> <option value=today>Today</option> <option value=yesterday>Yesterday</option> <option value=thisWeek>This week</option> <option value=thisMonth>This month</option> <option value=thisQuarter>This quarter</option> <option value=thisYear>This year</option> <option value=lastWeek>Last week</option> <option value=lastMonth>Last month</option> <option value=lastQuarter>Last quarter</option> <option value=lastYear>Last year</option> </select> </div> <div class=col-sm-12> <div class=artist-detail__item> <div class=artist-detail__label> <label class=stacked> Appointments </label> <p> {{$ctrl.stats.appointments}} completed </p> </div> </div> </div> <div class=col-sm-12> <div class=artist-detail__item> <div class=artist-detail__label> <label class=stacked> Income </label> <p> {{$ctrl.stats.revenue | noFractionCurrency}} </p> </div> </div> </div> <div class=col-sm-12> <div class=artist-detail__item> <div class=artist-detail__label> <label class=stacked> Tips </label> <p> {{$ctrl.stats.tips | noFractionCurrency}} </p> </div> </div> </div> <div class=col-sm-12> <div class=artist-detail__item> <div class=artist-detail__label> <label class=stacked> Average / appt </label> <p> {{$ctrl.stats.average | noFractionCurrency}} </p> </div> </div> <p class=left> <small tooltip-append-to-body=true uib-tooltip=\"Stats are counted on the day the appointment is scheduled for appointments scheduled after midnight.\" tooltip-placement=top tooltip-class=light> <fa name=info-circle></fa> Info on appointments scheduled after midnight. </small> </p> </div> </div> ";

/***/ }),

/***/ "./components/artists/artist/stats/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/artists/artist/stats/artist-stats.component.js");

__webpack_require__("./components/artists/artist/stats/artist-stats.controller.js");

__webpack_require__("./components/artists/artist/stats/artist-stats.styles.scss");

/***/ }),

/***/ "./components/artists/artists.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkArtists = {
  controller: 'ArtistsController',
  template: __webpack_require__("./components/artists/artists.template.html"),
  bindings: {
    artists: '<'
  }
};

angular.module('inkfinder').component('inkArtists', inkArtists);

/***/ }),

/***/ "./components/artists/artists.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ArtistsController.$inject = ['Artists', 'Association', 'Events', '$uibModal', 'AlertMessages', 'RESPONSE_MESSAGES', 'Session'];
/**
 * @name ArtistsController
 * @description Controller for artists.
 * @param {object} Artists The artists service.
 * @param {object} Association The association service
 * @param {object} Events The events service
 * @param {object} $uibModal The $uibModal service from ui Bootstrap
 * @param {object} AlertMessages The AlertMessages service
 * @param {object} RESPONSE_MESSAGES The RESPONSE_MESSAGES constant
 * @param {object} Session The Session service
 */
function ArtistsController(Artists, Association, Events, $uibModal, AlertMessages, RESPONSE_MESSAGES, Session) {
  var vm = this;
  vm.$onInit = function () {
    vm.events = Events;
    vm.cancelInvite = cancelInvite;
    vm.updateArtistAssociation = updateArtistAssociation;
    vm.expireArtistAssociation = expireArtistAssociation;
    vm.session = Session;
  };

  /**
  * @name refresh
  * @description Get shop artists
  */
  function refresh() {
    Artists.refreshArtists().then(function (artists) {
      vm.artists = artists;
    });
  }

  /**
   * @name updateArtistAssociation
   * @description Function to update an artist association through a modal
   * @param {object} artist The artist to edit
   */
  function updateArtistAssociation(_artist) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/artists/update/update-artist-modal.template.html"),
      animation: true,
      controller: 'UpdateArtistModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        artist: function artist() {
          return _artist;
        }
      }
    });
    modalInstance.result.then(function () {
      refresh();
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name expireArtistAssociation
   * @description Function to expire an artist association through a modal
   * @param {object} artist The artist to edit
   */
  function expireArtistAssociation(_artist2) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/artists/expire/expire-artist-modal.template.html"),
      animation: true,
      controller: 'ExpireArtistModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        artist: function artist() {
          return _artist2;
        }
      }
    });
    modalInstance.result.then(function () {
      refresh();
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
  * @name cancelInvite
  * @description Change association status to declined by shop
  * @param {object} collector The collector who's invite you want to cancel
  */
  function cancelInvite(collector) {
    Association.declineByShop(collector.association).then(function () {
      // Remove invited collector from the array
      for (var i = vm.artists.invited.length - 1; i >= 0; i--) {
        if (vm.artists.invited[i].id === collector.id) {
          vm.artists.invited.splice(i, 1);
        }
      }

      // Refresh the list of collectors on the template
      refresh();
    });
  }
}

angular.module('inkfinder').controller('ArtistsController', ArtistsController);

/***/ }),

/***/ "./components/artists/artists.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Artists', ['$q', '$http', '$rootScope', '$interval', 'ENDPOINT', 'StatsFactory', 'Association', 'moment', 'Session', 'AlertMessages', '_', function Artists($q, $http, $rootScope, $interval, ENDPOINT, StatsFactory, Association, moment, Session, AlertMessages, _) {
  Artists.fetchArtists = fetchArtists;
  Artists.refreshArtists = refreshArtists;
  Artists.createArtist = createArtist;

  var qwe = void 0; // The object holding all variables relating to queries
  resetVariables();

  /**
   * @name resetVariables
   * @description description
   */
  function resetVariables() {
    qwe = {
      artists: {}
    };
    Artists.artists = [];
  }

  /**
    * Create an artist
    * @param {input} input The artist object to create
    * @return {object} Returns a promise object containing the arist
    */
  function createArtist(input) {
    return $http.post(ENDPOINT.server + 'artists/api/v1.1/', input).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  // Called to Reset Data on Logout
  var deregister = $rootScope.$on('clear-data', function () {
    $interval.cancel(qwe.artists.timer);
    resetVariables();
  });
  $rootScope.$on('$destroy', deregister);

  /**
   * @name createArtistTimer
   * @description description
   */
  function createArtistTimer() {
    if (!qwe.artists.timer) {
      qwe.artists.timer = $interval(makeNewArtistPromise, 1000);
    }
  }

  /**
   * @name makeNewArtistPromise
   * @description description
   */
  function makeNewArtistPromise() {
    if (!shouldRefresh()) {
      return;
    }

    qwe.artists.promise = $q(function (resolve, reject) {
      qwe.artists.refreshing = true;
      var shopId = Session.activeState.association.shop.id;
      Association.getShopAssociations(shopId, Session.activeState.role, 'artist').then(function (collectors) {
        Artists.artists = collectors.artists;

        if (qwe.artists.timer) {
          _.each(Artists.artists.confirmed, function (artist) {
            artist.stats = StatsFactory.getArtistStats(artist.id);
          });
          qwe.artists.updated = moment();
        }
        qwe.artists.refreshing = false;
        resolve(Artists.artists);
      }, function () {
        reject();
      });
    });
  }

  /**
   * @name shouldRefresh
   * @description description
   * @return {type} Description
   */
  function shouldRefresh() {
    return !qwe.artists.refreshing && (!qwe.artists.updated || moment().diff(qwe.artists.updated, 'seconds') >= 79);
  }

  /**
   * @name fetchArtists
   * @description description
   * @return {type} Description
   */
  function fetchArtists() {
    createArtistTimer();
    makeNewArtistPromise();
    return qwe.artists.promise;
  }

  /**
   * @name refreshArtists
   * @description description
   * @return {type} Description
   */
  function refreshArtists() {
    qwe.artists.updated = null;
    return fetchArtists();
  }

  return Artists;
}]);

/***/ }),

/***/ "./components/artists/artists.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=artists class=\"photo section background-dark\"> <div class=background-photo></div> <div class=\"container center\"> <div class=row> <div class=col-sm-12> <div class=intro> <h1>Your artist network.</h1> <h5 ng-if=$ctrl.artists.confirmed> <ng-pluralize count=$ctrl.artists.confirmed.length when=\"{'0': 'Feels a bit lonely, don’t you think?',\n                'one': 'You have one artist on your roster. Make friends.',\n                'other': 'You have {} artists on your roster. Look who’s popular.'}\"> </ng-pluralize> </h5> <div class=row> <div class=col-sm-12> <div class=\"button-container margin\"> <button class=\"button large finder-solid\" ui-sref=inkfinder.artists.add.search> Add an artist </button> </div> </div> </div> </div> </div> <div class=\"cards profiles\"> <div class=\"col-sm-6 col-md-4 col-lg-3 card profile link\" ng-repeat=\"artist in $ctrl.artists.confirmed | orderBy: 'artist.last_name' track by artist.id\" ng-class=\"{'expire': artist.expireToggle}\"> <div class=profile-container> <div ng-if=\"($ctrl.session.activeState.association.operatorAdmin || $ctrl.session.activeState.association.operatorOwner) && $ctrl.session.activeState.association.type === 'operator'\"> <a ng-click=$ctrl.updateArtistAssociation(artist) class=profile-container__edit> <fa name=pencil></fa> </a> <a ng-click=$ctrl.expireArtistAssociation(artist) class=profile-container__expire> <fa name=trash></fa> </a> </div> <ink-profile-photo profile=artist image-id=artist.profile_photo size=\"'xxlarge'\" show-name=false> </ink-profile-photo> <p class=profile-container__name>{{artist.first_name}} {{artist.last_name}}</p> <div class=profile-details-container> <div class=row> <div class=\"col-xs-6 col-sm-12\"> <div class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <fa name=exclamation-triangle fw class=alert-color ng-if=!artist.email_is_confirmed tooltip-append-to-body=true uib-tooltip=\"Email not verified\" tooltip-placement=top tooltip-class=light></fa> <a href=mailto:{{artist.email}}> <fa name=envelope fw size=1></fa> {{artist.email}} </a> </small> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <a href=tel:{{artist.phone}} ng-if=artist.phone> <fa name=phone fw size=1></fa> <span>{{artist.phone | tel}}</span> </a> <span ng-if=!artist.phone> <fa name=phone fw size=1></fa> No phone listed </span> </small> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <fa name=calendar-o fw size=1></fa> {{artist.association.startDatetime | amDateFormat:'MM/DD/YY'}} – <span ng-if=\"artist.association.endDatetime !== null\"> {{artist.association.endDatetime | amDateFormat:'MM/DD/YY'}} </span> <span ng-if=\"artist.association.endDatetime === null\"> No end </span> </small> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <fa name=pencil fw size=1 ng-if=artist.association.can_update_appts></fa> <fa name=ban fw size=1 ng-if=!artist.association.can_update_appts></fa> <span ng-if=artist.association.can_update_appts> Can </span> <span ng-if=!artist.association.can_update_appts> Cannot </span> update their appts </small> </div> </div> <div class=\"col-xs-12 left\"> <div class=\"divider small tight\"></div> <label>Stats {{$ctrl.events.statsDateRange}}</label> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=profile-detail__item> <div class=profile-detail__icon> <span> <fa name=briefcase fw size=1></fa> </span> </div> <div class=profile-detail__label> <label> Appointments <fa name=arrow-up class=positive ng-if=\"artist.stats.current.change.appointments.value > 0\"></fa> <fa name=arrow-down class=negative ng-if=\"artist.stats.current.change.appointments.value < 0\"></fa> </label> <p> <small> {{artist.stats.current.stats.appointments}} completed </small> </p> </div> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=profile-detail__item> <div class=profile-detail__icon> <span> <fa name=money fw size=1></fa> </span> </div> <div class=profile-detail__label> <label> Total revenue <fa name=arrow-up class=positive ng-if=\"artist.stats.current.change.revenue.value > 0\"></fa> <fa name=arrow-down class=negative ng-if=\"artist.stats.current.change.revenue.value < 0\"></fa> </label> <p> <small> {{artist.stats.current.stats.revenue | noFractionCurrency}} </small> </p> </div> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=profile-detail__item> <div class=profile-detail__icon> <span> <fa name=heart fw size=1></fa> </span> </div> <div class=profile-detail__label> <label> Total tips <fa name=arrow-up class=positive ng-if=\"artist.stats.current.change.tips.value > 0\"></fa> <fa name=arrow-down class=negative ng-if=\"artist.stats.current.change.tips.value < 0\"></fa> </label> <p> <small> {{artist.stats.current.stats.tips | noFractionCurrency}} </small> </p> </div> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=profile-detail__item> <div class=profile-detail__icon> <span> <fa name=line-chart fw size=1></fa> </span> </div> <div class=profile-detail__label> <label> Average / appt <fa name=arrow-up class=positive ng-if=\"artist.stats.current.change.average.value > 0\"></fa> <fa name=arrow-down class=negative ng-if=\"artist.stats.current.change.average.value < 0\"></fa> </label> <p> <small> {{artist.stats.current.stats.average | noFractionCurrency}} </small> </p> </div> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=profile-detail__item> <div class=profile-detail__icon> <span> <fa name=clock-o fw size=1></fa> </span> </div> <div class=profile-detail__label> <label> Utilization <fa name=arrow-up class=positive ng-if=\"artist.stats.current.change.utilization.value > 0\"></fa> <fa name=arrow-down class=negative ng-if=\"artist.stats.current.change.utilization.value < 0\"></fa> </label> <p> <small> {{artist.stats.current.stats.utilization | percent: 0}} </small> </p> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"row left\" ng-if=\"$ctrl.artists.invited.length > 0\"> <div class=col-sm-12> <div class=\"divider small loose\"></div> <h4>Invited artists</h4> <div class=\"list profiles\"> <div class=\"row item profile invited\" ng-class-odd=\"'odd'\" ng-repeat=\"artist in $ctrl.artists.invited track by artist.id\"> <div class=\"col-md-1 col-sm-2 col-xs-3\"> <ink-profile-photo show-name=false profile=artist size=\"'standard'\" image-id=artist.profile_photo></ink-profile-photo> </div> <div class=\"col-md-2 col-sm-3 col-xs-5\"> <small>Name</small> <p>{{artist.first_name}} {{artist.last_name}}</p> </div> <div class=\"col-md-2 col-sm-2 col-xs-4\"> <small>Date invited</small> <p>{{artist.association.startDatetime | amDateFormat: 'M/D/YY'}}</p> </div> <div class=\"col-md-2 col-sm-3 col-xs-5\"> <small>Phone</small> <p ng-if=artist.phone>{{artist.phone | tel}}</p> <p ng-if=!artist.phone>No phone listed</p> </div> <div class=\"col-md-3 col-sm-3 col-xs-5\"> <small>Email</small> <p> <a href=mailto:{{artist.email}}>{{artist.email}}</a> </p> </div> <div class=\"clearfix visible-xs visible-sm\"></div> <div class=\"actions col-md-2 col-sm-6 col-xs-6\"> <button class=\"button medium gray\" ng-click=\"artist.cancelToggle = !artist.cancelToggle\">Cancel invite</button> </div> <div class=\"actions-confirm inline-alerts col-sm-12\"> <div ng-if=artist.cancelToggle class=\"inline-alert warning\"> <p><small>You sure?</small></p> <button class=\"button small inline dark\" ng-click=$ctrl.cancelInvite(artist)>Cancel invite</button> <button class=\"button small inline dark\" ng-click=\"artist.cancelToggle = false\">Go back</button> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/artists/cards/_artist-cards.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182511055
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/artists/cards/artist-cards.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkArtistCard = {
  bindings: {},
  controller: function controller() {},
  template: __webpack_require__("./components/artists/cards/artist-cards.template.html")
};

angular.module('inkfinder').component('inkArtistCard', inkArtistCard);

/***/ }),

/***/ "./components/artists/cards/artist-cards.template.html":
/***/ (function(module, exports) {

module.exports = "";

/***/ }),

/***/ "./components/artists/cards/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/artists/cards/artist-cards.component.js");

__webpack_require__("./components/artists/cards/_artist-cards.styles.scss");

/***/ }),

/***/ "./components/artists/expire/expire-artist-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ExpireArtistModalController.$inject = ['$uibModalInstance', 'Association', 'artist'];
/**
 * @name ExpireArtistModalController
 * @description Function to expire an artist associations with a shop
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} Association The association service
 * @param {unknown} artist Resolved artist from the artist controller
 */
function ExpireArtistModalController($uibModalInstance, Association, artist) {
  var vm = this;
  vm.artist = artist;
  vm.expireArtist = expireArtist;

  /**
   * @name expireArtist
   * @description Change association status to expired
   * @param {object} artist The artist's collector object who's association you
   * want to expire
   */
  function expireArtist(artist) {
    Association.expire(artist.association).then(function () {
      $uibModalInstance.close();
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('ExpireArtistModalController', ExpireArtistModalController);

/***/ }),

/***/ "./components/artists/expire/expire-artist-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=expireOperatorForm ng-submit=\"expireOperatorForm.$valid && $ctrl.expireArtist($ctrl.artist)\" novalidate> <div class=modal-header> <h4 class=modal-title>Remove <span ng-if=$ctrl.artist.first_name>{{$ctrl.artist.first_name}}</span><span ng-if=!$ctrl.artist.first_name>this artist</span> from the roster?</h4> </div> <div class=\"modal-body background-light center\"> <ink-profile-photo profile=$ctrl.artist image-id=$ctrl.artist.profile_photo></ink-profile-photo> <div class=\"divider small xtight transparent\"></div> <p> <span ng-if=$ctrl.artist.first_name>{{$ctrl.artist.first_name}}</span> <span ng-if=!$ctrl.artist.first_name>This artist</span> will no longer be available for scheduling, but all set hours will still appear on the schedule and need to be removed manually.<br/> <small>Also, all previous appointments and projects will be saved.</small> </p> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Remove</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/artists/expire/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/artists/expire/expire-artist-modal.controller.js");

/***/ }),

/***/ "./components/artists/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/artists/add/index.js");

__webpack_require__("./components/artists/artist/index.js");

__webpack_require__("./components/artists/expire/index.js");

__webpack_require__("./components/artists/cards/index.js");

__webpack_require__("./components/artists/notification-prefs/index.js");

__webpack_require__("./components/artists/update/index.js");

__webpack_require__("./components/artists/artists.service.js");

__webpack_require__("./components/artists/artists.component.js");

__webpack_require__("./components/artists/artists.controller.js");

__webpack_require__("./components/artists/_artists.styles.scss");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.artists', {
    url: '/artists',
    views: {
      '@': {
        component: 'inkArtists'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Your artist network';
      },
      artists: ['Artists', function artists(Artists) {
        return Artists.refreshArtists().then(function (artists) {
          return artists;
        });
      }]
    },
    data: {
      authorizedRoles: [USER_ROLES.operator]
    }
  });
}]);

/***/ }),

/***/ "./components/artists/notification-prefs/artist-notification-prefs.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ArtistNotificationPrefs.$inject = ['$http', 'ENDPOINT', 'Session', 'moment', 'AlertMessages', '_'];


/**
 * @name ArtistNotificationPrefs
 * @description The ArtistNotificationPrefs service
 * @param {library} $http Angular $http
 * @param {constant} ENDPOINT The ENDPOINT constant
 * @param {service} Session The Session service
 * @param {library} moment The moment library
 * @param {service} AlertMessages The AlertMessages service
 * @param {library} _ The lodash library
 * @return {service} Returns the service
 */
function ArtistNotificationPrefs($http, ENDPOINT, Session, moment, AlertMessages, _) {
  // Public Functions
  ArtistNotificationPrefs.get = get;
  ArtistNotificationPrefs.create = create;
  ArtistNotificationPrefs.update = update;

  /**
   * @name getArtistPrefs
   * @description Function to retrieve artist notification preferences
   * @param {number} id The ID of the preferences to retrieve
   * @return {object} Returns the notification preferences objdect
   */
  function get(id) {
    var url = ENDPOINT.server + 'collectors/api/v1.1/email/artist-preference/' + id + '/';
    if (Session.activeState.association) {
      url += '?association_id=' + Session.activeState.association.id;
    }
    return $http.get(url).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name create
   * @description Function to create notification preferences for artists
   * @return {object} Returns the notification preferences objdect
   */
  function create() {
    var associationId = Session.activeState.association.id;
    return $http.post(ENDPOINT.server + 'collectors/api/v1.1/email/artist-preference/', associationId).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name update
   * @description Function to update notification preferences for artists
   * @param {number} id The ID of the notification preferences to update
   * @param {object} notPrefs The notification preferences to update
   * @return {object} Returns the updated notification preferences
   */
  function update(id, notPrefs) {
    return $http.put(ENDPOINT.server + 'collectors/api/v1.1/email/artist-preference/' + id + '/', notPrefs).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return ArtistNotificationPrefs;
}

angular.module('inkfinder').factory('ArtistNotificationPrefs', ArtistNotificationPrefs);

/***/ }),

/***/ "./components/artists/notification-prefs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/artists/notification-prefs/artist-notification-prefs.service.js");

/***/ }),

/***/ "./components/artists/update/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/artists/update/update-artist-modal.controller.js");

/***/ }),

/***/ "./components/artists/update/update-artist-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


UpdateArtistModalController.$inject = ['$uibModalInstance', 'Association', 'artist'];
/**
 * @name UpdateArtistModalController
 * @description Function to update artist associations with a shop
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} Association The association service
 * @param {unknown} artist Resolved artist from the artist controller
 */
function UpdateArtistModalController($uibModalInstance, Association, artist) {
  var vm = this;
  vm.artist = artist;
  vm.updateArtist = updateArtist;

  /**
   * @name updateArtist
   * @description Function to update the artist association
   * @param {object} artist The artist's collector object who's association you
   * want to update
   */
  function updateArtist(artist) {
    Association.update(artist.association).then(function () {
      $uibModalInstance.close();
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('UpdateArtistModalController', UpdateArtistModalController);

/***/ }),

/***/ "./components/artists/update/update-artist-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=updateArtistForm ng-submit=\"updateArtistForm.$valid && $ctrl.updateArtist($ctrl.artist)\" novalidate> <div class=modal-header> <h4 class=modal-title>Update your connection with <span ng-if=$ctrl.artist.first_name>{{$ctrl.artist.first_name}}</span><span ng-if=!$ctrl.artist.first_name>this artist</span></h4> </div> <div class=\"modal-body background-light center\"> <ink-profile-photo profile=$ctrl.artist image-id=$ctrl.artist.profile_photo></ink-profile-photo> <div class=\"divider small xtight transparent\"></div> <div class=left> <div class=form-group> <label> <input name=canUpdateAppts type=checkbox ng-model=$ctrl.artist.association.can_update_appts> {{$ctrl.artist.first_name}} can update their own appointments <small>This includes rescheduling and cancelling appointments</small> </label> </div> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/auth/auth-intercept.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Responsible for detecting unauthorized or not authenticated access.
angular.module('inkfinder').factory('AuthInterceptor', ['$rootScope', '$q', 'AUTH_EVENTS', function ($rootScope, $q, AUTH_EVENTS) {
  return {
    responseError: function responseError(response) {
      $rootScope.$broadcast({
        401: AUTH_EVENTS.notAuthenticated,
        403: AUTH_EVENTS.notAuthorized,
        404: AUTH_EVENTS.notFound
      }[response.status], response);

      return $q.reject(response);
    }
  };
}]);

/***/ }),

/***/ "./components/auth/auth.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Auth', ['$window', '$auth', '$rootScope', '$state', '$stateParams', '$cookies', '$timeout', '$q', 'Collector', 'USER_ROLES', 'Session', 'AUTH_EVENTS', 'RESPONSE_MESSAGES', 'AlertMessages', 'DEFAULT_STATES', 'Events', '$uibModal', 'SWITCH_MESSAGE', '$location', '_', function Auth($window, $auth, $rootScope, $state, $stateParams, $cookies, $timeout, $q, Collector, USER_ROLES, Session, AUTH_EVENTS, RESPONSE_MESSAGES, AlertMessages, DEFAULT_STATES, Events, $uibModal, SWITCH_MESSAGE, $location, _) {
  // Public methods
  Auth.loginInkfinder = loginInkfinder;
  Auth.loginSocial = loginSocial;
  Auth.signupInkFinder = signupInkFinder;
  Auth.isAllowed = isAllowed;
  Auth.getRoles = getRoles;
  Auth.logout = logout;
  Auth.routeAfterAuthentication = routeAfterAuthentication;
  Auth.getSession = getSession;
  Auth.updateSession = updateSession;
  Auth.setState = setState;
  Auth.changeState = changeState;
  Auth.statePicker = statePicker;
  Auth.redirect = {
    url: null
  };

  // Monitor events to make it easier to plan what happens in certain
  // authorization scenarios
  var deregister = $rootScope.$on(AUTH_EVENTS.notAuthenticated, function () {
    AlertMessages.add({
      msg: RESPONSE_MESSAGES.authenticationError.message,
      type: 'danger'
    });
    $state.go('login');
  });

  var deregister1 = $rootScope.$on(AUTH_EVENTS.notAuthorized, function () {
    AlertMessages.add({
      msg: RESPONSE_MESSAGES.authorizationError.message,
      type: 'danger'
    });
  });

  var deregister2 = $rootScope.$on(AUTH_EVENTS.notFound, function () {
    AlertMessages.add({
      msg: RESPONSE_MESSAGES.notFoundError.message,
      type: 'danger'
    });
  });

  $rootScope.$on('$destroy', deregister, deregister1, deregister2);

  /**
  * @name loginInkfinder
  * @description This function takes login credentials (email, password) and
  * passes them to the Satellizer library to retrieve a token from the API.
  * @param {user} credentials The object passing email/password
  * @return {object} Returns an object containing the user and user roles.
  */
  function loginInkfinder(credentials) {
    $window.localStorage.clear();
    return $auth.login(credentials).then(function (response) {
      return Collector.refreshProfile().then(function (collector) {
        return setState(collector).then(function () {
          var roles = getRoles(collector);
          Session.create(response.data.token, roles, collector);
        });
      });
    });
  }

  /**
  * @description Log in using a third party account. This services is provided
  * by Sattellizer
  * @param {unknown} provider Unknown
  * @return {object} Returns the collector object
   */
  function loginSocial(provider) {
    $window.localStorage.clear();
    return $auth.authenticate(provider).then(function (response) {
      return Collector.refreshProfile().then(function (collector) {
        return setState(collector).then(function () {
          var roles = getRoles(collector);
          Session.create(response.data.token, roles, collector);
        });
      });
    });
  }

  /**
  * @description The Ink Finder signup function
  * @param {obejct} credentials The credentials object from the signup form
  * @return {object} Returns the collector object.
  */
  function signupInkFinder(credentials) {
    $window.localStorage.clear();
    return $auth.signup(credentials).then(function (response) {
      $auth.setToken(response.data.token); // Set the token for Satellizer
      var newCollector = {
        email: response.config.data.email,
        accepted_TOS_Privacy: true
      };
      return Collector.updateProfile(newCollector).then(function (collector) {
        var roles = getRoles(collector);
        Session.create(response.data.token, roles, collector);
      });
    });
  }

  /**
  * @name getSession
  * @description A function to get the session for the collector when a valid
  * token is present.
  * @return {object} Returns the session object.
  */
  function getSession() {
    return $q(function (resolve, reject) {
      if (_.isUndefined(Session.collector)) {
        return Collector.refreshProfile().then(function (collector) {
          var token = $auth.getToken;
          var roles = getRoles(collector);
          Session.create(token, roles, collector);
          return setState(collector).then(function () {
            Events.loggedIn = true;
            resolve(Session);
          });
        });
      }
      resolve(Session);
    });
  }

  /**
  * @name setState
  * @description Function to set the active state of the user.
  * @param {object} collector The collector of the logged in user.
  * @return {promise} Returns the statePicker to choose your active state
  * or the active state set when only one selling state exists.
  */
  function setState(collector) {
    return $q(function (resolve, reject) {
      var count = 1;
      var states = [];
      states.buying = [];
      states.selling = [];
      // By default, add a collector state
      var collectorState = {
        mode: 'buying',
        role: 'collector',
        switchMessage: SWITCH_MESSAGE.buying,
        associations: collector.associations.collectors.confirmed,
        id: count
      };
      states.buying.push(collectorState);
      count++;
      // Add an artist state if the collector is also an artist
      if (collector.associations.artists.confirmed.length > 0) {
        for (var i = 0; i < collector.associations.artists.confirmed.length; i++) {
          var artistState = {
            mode: 'selling',
            role: 'artist',
            switchMessage: SWITCH_MESSAGE.selling,
            association: collector.associations.artists.confirmed[i],
            id: count
          };
          states.selling.push(artistState);
          count++;
        }
      }
      // Add an operator state if the collector is an operator
      if (collector.operator !== null) {
        // Check for approved associations
        if (collector.associations.operators.confirmed.length > 0) {
          for (var _i = 0; _i < collector.associations.operators.confirmed.length; _i++) {
            var operatorState = {
              mode: 'selling',
              role: 'operator',
              switchMessage: SWITCH_MESSAGE.selling,
              association: collector.associations.operators.confirmed[_i],
              id: count
            };
            states.selling.push(operatorState);
            count++;
          }
        }
      }
      // Send the state to the Session
      Session.defineStates(states);
      // If the state was stored in a cookie, then resolve and set the active
      // state to the state found in the cookie. Otherwise, if there are more
      // than one selling state, allow the user to pick the one they want to
      // use initially. Otherwise, choose the selling state as the active
      // state. If no selling state exists, choose the buying state as the
      // active state.
      var _state = $cookies.getObject('inkfinder');
      var allStates = states.buying.concat(states.selling);

      if (!_.isUndefined(_state)) {
        // If only one operator state exists
        if (_state.association && _state.association.id) {
          _state.association = _.find(allStates, {
            association: { id: _state.association.id }
          }).association;
        }

        // If multiple artists states exists
        if (_state.associations && _state.associations.length) {
          var updatedAssociations = _.map(_state.associations, function (obj) {
            return _.find(collector.associations.all, function (o) {
              return o.id === obj.id;
            }) || obj;
          });
          _state.associations = updatedAssociations;
        }

        // Push a fresh copy of the state to the cookie
        $cookies.putObject('inkfinder', _state);
        resolve(Session.setActiveState(_state));
      } else if (states.selling.length > 1) {
        var logOutPossible = true;
        statePicker(states, logOutPossible).then(function (activeState) {
          $cookies.putObject('inkfinder', activeState);
          resolve(Session.setActiveState(activeState));
        });
      } else if (states.selling.length === 1) {
        $cookies.putObject('inkfinder', states.selling[0]);
        resolve(Session.setActiveState(states.selling[0]));
      } else {
        $cookies.putObject('inkfinder', states.buying[0]);
        resolve(Session.setActiveState(states.buying[0]));
      }
    });
  }

  /**
  * @name statePicker
  * @description Function to fire off a modal when there is more than one
  * selling mode state to allow the user to choose which profile to sell as.
  * @param {array} states The possible states for the logged in user.
  * @param {boolean} logOutPossible Boolean to determine if we can safely
  * dismiss the modal by clicking the escape key or outside the modal window.
  * @return {array} states The resolve function returns the states to the
  * modal controller.
  * @return {object} activeState Resolves the state chosen by the user.
  */
  function statePicker(_states, _logOutPossible) {
    return $q(function (resolve, reject) {
      var noClick = true;
      if (_logOutPossible === true) {
        noClick = 'static';
      }
      var modalInstance = $uibModal.open({
        template: __webpack_require__("./components/auth/state-picker/state-picker.template.html"),
        animation: true,
        controller: 'StatePickerController',
        bindToController: true,
        backdrop: noClick,
        keyboard: !_logOutPossible,
        controllerAs: '$ctrl',
        resolve: {
          states: function states() {
            return _states;
          },
          logOutPossible: function logOutPossible() {
            return _logOutPossible;
          }
        }
      });
      modalInstance.result.then(function (activeState) {
        resolve(activeState);
      }, function (error) {
        reject(error);
      });
    });
  }

  /**
  * @name changeState
  * @description This function is called from ui switchers when changing the
  * mode of the app.
  * @return {unknown} Unknown
  */
  function changeState() {
    return $q(function (resolve, reject) {
      if (Session.activeState.mode === 'selling') {
        var state = {
          mode: 'buying',
          role: 'collector',
          switchMessage: SWITCH_MESSAGE.buying,
          id: 1
        };
        $rootScope.$broadcast('clear-data');
        Session.setActiveState(state);
        $cookies.putObject('inkfinder', state);
        resolve($state.go(DEFAULT_STATES.buying));
      } else if (Session.states.selling.length > 1) {
        var logOutPossible = false;
        statePicker(Session.states, logOutPossible).then(function (activeState) {
          $rootScope.$broadcast('clear-data');
          Session.setActiveState(activeState);
          $cookies.putObject('inkfinder', activeState);
          if (activeState.role === 'operator') {
            resolve($state.go(DEFAULT_STATES.operator));
          } else {
            resolve($state.go(DEFAULT_STATES.artist));
          }
        });
      } else {
        $rootScope.$broadcast('clear-data');
        Session.setActiveState(Session.states.selling[0]);
        $cookies.putObject('inkfinder', Session.states.selling[0]);
        if (Session.states.selling[0].role === 'operator') {
          resolve($state.go(DEFAULT_STATES.operator));
        } else {
          resolve($state.go(DEFAULT_STATES.artist));
        }
      }
    });
  }

  /**
  * @name updateSession
  * @description A function to update the session for the collector when the
  * collector object is updated.
  * @return {object} Return the Session service.
  */
  function updateSession() {
    return Collector.refreshProfile().then(function (collector) {
      var token = $auth.getToken();
      var roles = getRoles(collector);
      return Session.create(token, roles, collector);
    });
  }

  /**
  * @description
  * The authorize function sets roles for the logged in user based on their
  * associations and extended role objects inside the collector object.
  * @param {object} collector The collector object containing extended objects
  * for artist and operator
  * @return {array} roles Returns an array of roles.
  */
  function getRoles(collector) {
    var roles = [];
    if (collector.operator !== null) {
      roles.push(USER_ROLES.operator);
    }
    if (collector.artist !== null) {
      roles.push(USER_ROLES.artist);
    }
    roles.push(USER_ROLES.collector);
    return roles;
  }

  /**
  * @name isAllowed
  * @description Determines if the collector has the roles needed to view the
  * state. If the collector has the authorized roles, then we check to see if
  * the collector is authenticated through Satellizer.
  * @param {array} authorizedRoles The array of authorized roles originating
  * from specific states
  * @return {boolean} Returns a boolean value.
  */
  function isAllowed(authorizedRoles) {
    var authenticated = $auth.isAuthenticated();
    var roleMatch = false;
    var session = Session;
    if (_.intersection(authorizedRoles, session.roles).length > 0) {
      roleMatch = true;
    }
    return authenticated && roleMatch;
  }

  /**
  * @name routeAfterAuthentication
  * @description Function called after a successful login.
  * TODO Integrate this with cookies to remember the selected path
  */
  function routeAfterAuthentication() {
    if (Auth.redirect.url !== null) {
      $location.path(Auth.redirect.url);
    } else if (Session.activeState.role === 'artist') {
      $state.go(DEFAULT_STATES.artist);
    } else if (Session.activeState.role === 'operator') {
      $state.go(DEFAULT_STATES.operator);
    } else {
      $state.go(DEFAULT_STATES.buying);
    }
  }

  /**
  * @name logout
  * @description Logout of Satellizer. Destroy Session data. Broadcast
  * 'clear-data' to cleanup factories. And go to the login state
  * @param {string} route The route to go to after logout
  */
  function logout() {
    $state.go('logout');
    $rootScope.$broadcast('clear-data');
    Events.loggedIn = false;
    Session.destroy(); // Remove roles, token, and collector
    $cookies.remove('inkfinder');
    $auth.logout(); // Satellizer logout
  }
  return Auth;
}]);

/***/ }),

/***/ "./components/auth/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/auth/state-switcher/index.js");

__webpack_require__("./components/auth/state-picker/index.js");

__webpack_require__("./components/auth/terms/index.js");

__webpack_require__("./components/auth/auth-intercept.service.js");

__webpack_require__("./components/auth/auth.service.js");

__webpack_require__("./components/auth/session.service.js");

/***/ }),

/***/ "./components/auth/session.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Session.$inject = ['$log', '$uibModal', '$rootScope', 'AUTH_EVENTS', '$interval', 'AppVersion', 'APP_VERSION', '_'];
/**
 * @name Session
 * @description A simple factory storing session data
 * @param {unknown} $log The angular log service
 * @param {unknown} $uibModal UI Bootstrap modal service
 * @param {unknown} $rootScope Angular rootScope service
 * @param {unknown} AUTH_EVENTS The auth events constant
 * @param {unknown} $interval Angular interval service
 * @param {service} AppVersion The AppVersion service
 * @param {constant} APP_VERSION The APP_VERSION constant
 * @param {library} _ The Lodash library
 * @return {object} Returns the Session object
 */
function Session($log, $uibModal, $rootScope, AUTH_EVENTS, $interval, AppVersion, APP_VERSION, _) {
  var Session = this;
  Session.mode = null;

  /**
   * @name Session.create
   * @description Creat a new session based on the JWT, roles, and collector
   * object
   * @param {string} token The token from the API
   * @param {array} roles An array of roles based on extended objects (artist,
   * operator) on collector
   * @param {object} collector The collector object. This conains all user
   * information
   */
  Session.create = function (token, roles, collector) {
    Session.token = token;
    Session.roles = roles;
    if (roles.indexOf('artist') !== -1) {
      Session.isArtist = true;
    }
    if (roles.indexOf('operator') !== -1) {
      Session.isOperator = true;
    }
    Session.collector = collector;
    if (collector.accepted_TOS_Privacy === false) {
      $uibModal.open({
        component: 'inkTerms',
        size: 'md',
        animation: true,
        backdrop: 'static',
        keyboard: false
      });
    }
    Session.acceptedTOSPrivacy = collector.accepted_TOS_Privacy;
    $log.debug('Session created for: ', Session.collector.email);

    Session.viewingMode = {
      calendarSkinny: collector.calendar_skinny,
      calendarCompact: collector.calendar_compact
    };
    $log.debug('Viewing mode: ', Session.viewingMode);

    Session.pollAppVersion = function () {
      Session.appVersionPoll = $interval(getAppVersion, 5000);
    };

    Session.cancelAppVersionPoll = function () {
      $interval.cancel(Session.appVersionPoll);
    };

    getAppVersion();
    Session.pollAppVersion();

    /**
     * @name checkAppVersion
     * @description Function to check the version of the app stored on the API
     */
    function getAppVersion() {
      AppVersion.get().then(function (appVersions) {
        var latestRelease = _.maxBy(appVersions, function (el) {
          return el.created;
        });
        if (latestRelease.app_version !== APP_VERSION) {
          $uibModal.open({
            component: 'inkAppVersion',
            size: 'lg',
            animation: true,
            backdrop: 'static',
            keyboard: false
          });
          return;
        }
        return;
      });
    }
  };

  /**
   * @name Session.destroy
   * @description Remove all values of the session
   */
  Session.destroy = function () {
    Session.token = null;
    Session.roles = null;
    Session.isArtist = null;
    Session.isOperator = null;
    Session.collector = null;
    Session.states = null;
    Session.activeState = null;
    $log.debug('Session destroyed');
  };

  /**
   * @name setState
   * @description Function to record all possible states of the logged in user.
   * @param {array} states An array of possible states for the logged in user.
   */
  Session.defineStates = function (states) {
    Session.states = states;
    $log.debug('Set states as: ', states);
  };

  /**
   * @name setActiveState
   * @description Function to set the active state of the logged in user.
   * The active state will determine the data sent by endpoints and interface
   * options.
   * @param {object} state The active state of the logged in user.
   */
  Session.setActiveState = function (state) {
    Session.activeState = state;
    $log.debug('Set active state as: ', state);
  };

  /**
   * @description This is being called from the Collector service when the
   * collector polling updates the collector.
   * @param {object} collector The collector object to update.
   */
  Session.updateCollector = function (collector) {
    Session.collector = collector;
    $rootScope.$broadcast(AUTH_EVENTS.collectorUpdated);
    $log.debug('Collector updated for: ', Session.collector);
  };

  return Session;
}

angular.module('inkfinder').factory('Session', Session);

/***/ }),

/***/ "./components/auth/state-picker/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/auth/state-picker/state-picker.controller.js");

__webpack_require__("./components/auth/state-picker/state-picker.template.html");

/***/ }),

/***/ "./components/auth/state-picker/state-picker.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


StatePickerController.$inject = ['$uibModalInstance', 'Collector', 'Session', 'Auth', 'states', 'logOutPossible', '_'];


/**
 * @name StatePickerController
 * @description Controller for the state picker modal
 * @param {type} $uibModalInstance Description
 * @param {type} Collector Description
 * @param {type} Session Description
 * @param {type} Auth Description
 * @param {type} states Description
 * @param {type} logOutPossible Description
 * @param {type} _ Description
 */
function StatePickerController($uibModalInstance, Collector, Session, Auth, states, logOutPossible, _) {
  var vm = this;

  // Public Methods
  vm.cancel = cancel;
  vm.selectState = selectState;
  vm.session = Session;
  vm.states = states;

  /**
    * Select a state
    * @param {object} state The selected state
    */
  function selectState(state) {
    $uibModalInstance.close(state);
  }

  /**
    * Cancel from the state picker modal
    */
  function cancel() {
    $uibModalInstance.dismiss('Canceled');
    if (logOutPossible === true) {
      Auth.logout();
    }
  }
}

angular.module('inkfinder').controller('StatePickerController', StatePickerController);

/***/ }),

/***/ "./components/auth/state-picker/state-picker.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h4 class=modal-title>Select your shop</h4> </div> <div class=modal-body> <div class=background-light> <div class=\"list profiles\"> <div class=\"item profile\" ng-repeat=\"state in $ctrl.states.selling track by state.id\" ng-click=\"$ctrl.session.activeState.id !== state.id && $ctrl.selectState(state)\"> <div ng-if=\"state.role === 'operator'\"> <ink-profile-photo show-name=false ng-if=\"state.role === 'operator'\" selectable=true editable=false type=\"'shop'\" image-id=state.association.shop.profile_logo selected=\"state.association.shop.id === $ctrl.session.activeState.association.shop.id\"> </ink-profile-photo> <small>Operator at {{state.association.shop.name}}</small> </div> <div ng-if=\"state.role === 'artist'\"> <ink-profile-photo selectable=true show-name=false profile=$ctrl.session.collector image-id=state.association.shop.profile_logo selected=\"state.association.shop.id === $ctrl.session.activeState.association.shop.id\"> </ink-profile-photo> <small>Artist at {{state.association.shop.name}}</small> </div> </div> </div> </div> </div> <div class=modal-footer> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.cancel()> Cancel </button> </div> ";

/***/ }),

/***/ "./components/auth/state-switcher/_state-switcher.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510750
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/auth/state-switcher/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/auth/state-switcher/state-switcher.component.js");

__webpack_require__("./components/auth/state-switcher/state-switcher.controller.js");

__webpack_require__("./components/auth/state-switcher/_state-switcher.styles.scss");

/***/ }),

/***/ "./components/auth/state-switcher/state-switcher.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkStateSwitcher = {
  controller: 'StateSwitcherController',
  template: __webpack_require__("./components/auth/state-switcher/state-switcher.template.html")
};

angular.module('inkfinder').component('inkStateSwitcher', inkStateSwitcher);

/***/ }),

/***/ "./components/auth/state-switcher/state-switcher.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


StateSwitcherController.$inject = ['Session', 'Auth', '$log', '_', '$cookies', '$rootScope', '$state', 'DEFAULT_STATES', 'SWITCH_MESSAGE'];


/**
 * @name ModeSwitcherController
 * @description Controller called to displa and manage appointment details.
 * @param {Unknown} Session Session service
 * @param {Unknown} Auth Authorization service
 * @param {Unknown} $log Angular log service
 * @param {Unknown} _ Lodash
 * @param {Unknown} $cookies Angular cookies service
 * @param {Unknown} $rootScope Angular rootScrop service
 * @param {Unknown} $state ui-router state service
 * @param {Unknown} DEFAULT_STATES Constant for state defaults
 * @param {Unknown} SWITCH_MESSAGE Constant for switch messages
 */
function StateSwitcherController(Session, Auth, $log, _, $cookies, $rootScope, $state, DEFAULT_STATES, SWITCH_MESSAGE) {
  var vm = this;

  vm.$onInit = function () {
    vm.changeState = changeState;
    vm.session = Session;
    vm.modalClose = modalClose;
    vm.logout = logout;
    vm.switchToBuying = switchToBuying;
    vm.toggleModal = toggleModal;
    vm.stateSwitcherModalOpen = false;
  };

  /**
   * @name toggleModal
   * @description Function to toggle the modal depending on the number of
   * selling states and the current state of the modal. If there are no selling
   * states, then the user would already be on the buying state and we will send
   * them to their user settings.
   */
  function toggleModal() {
    if (vm.stateSwitcherModalOpen === true) {
      vm.stateSwitcherModalOpen = false;
      return;
    }

    if (vm.session.states.selling && vm.session.states.selling.length > 0) {
      vm.stateSwitcherModalOpen = true;
    } else {
      $state.go('inkfinder.collector.update');
    }
  }

  /**
   * @name changeState
   * @description Function to change states (buy/selling) and the user role
   * associated with the state
   * @param {object} activeState The selected state
   */
  function changeState(activeState) {
    vm.modalClose();
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(activeState);
    $cookies.putObject('inkfinder', activeState);
    if (activeState.role === 'operator') {
      $state.go(DEFAULT_STATES.operator, {}, { reload: true });
    } else {
      $state.go(DEFAULT_STATES.artist, {}, { reload: true });
    }
  }

  /**
   * @name switchToBuying
   * @description Function to move the user to the collector's dashboard
   */
  function switchToBuying() {
    var state = {
      mode: 'buying',
      role: 'collector',
      switchMessage: SWITCH_MESSAGE.buying,
      id: 1
    };
    vm.modalClose();
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(state);
    $cookies.putObject('inkfinder', state);
    $state.go(DEFAULT_STATES.buying);
  }

  /**
   * @name modalClose
   * @description Function to close the login shelf
   */
  function modalClose() {
    vm.stateSwitcherModalOpen = false;
  }

  /**
   * @name logout
   * @description Wrapper for the Auth logout function
   */
  function logout() {
    vm.modalClose();
    Auth.logout();
  }
}

angular.module('inkfinder').controller('StateSwitcherController', StateSwitcherController);

/***/ }),

/***/ "./components/auth/state-switcher/state-switcher.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=state-switcher-display tw-click-outside=$ctrl.modalClose()> <a ng-click=$ctrl.toggleModal()> <div class=state-switcher-profile-photo> <ink-profile-photo show-name=false profile=$ctrl.session.collector size=\"'small'\" image-id=$ctrl.session.collector.profile_photo ui-sref-active=\"{'active': 'inkfinder.collector'}\" class=state-switcher-collector> </ink-profile-photo> <ink-profile-photo editable=false class=shop-profile ng-if=\"$ctrl.session.activeState.role === 'operator'\" type=\"'shop'\" size=\"'xsmall'\" image-id=$ctrl.session.activeState.association.shop.profile_logo> </ink-profile-photo> </div> </a> <div class=state-switcher-wrapper ng-class=\"{\n    'state-switcher-modal-open': $ctrl.stateSwitcherModalOpen,\n    'state-switcher-modal-closed': !$ctrl.stateSwitcherModalOpen,\n    }\"> <div class=state-switcher-modal ng-if=$ctrl.session.collector> <div class=arrow-left></div> <ul class=\"modal-menu background-light\"> <li ng-repeat=\"state in $ctrl.session.states.selling track by state.id\"> <a ng-click=$ctrl.changeState(state)> <span ng-if=\"state.role === 'operator'\">Operator at {{state.association.shop.name}}</span> <span ng-if=\"state.role === 'artist'\">Artist at {{state.association.shop.name}}</span> </a> </li> <li><a ng-click=$ctrl.switchToBuying()>Buy art</a></li> <li><a ui-sref=inkfinder.collector.update ng-click=$ctrl.modalClose()>Settings</a></li> <li><a ng-click=$ctrl.logout()>Sign out</a></li> </ul> </div> </div> </div> ";

/***/ }),

/***/ "./components/auth/terms/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/auth/terms/terms.component.js");

__webpack_require__("./components/auth/terms/terms.controller.js");

/***/ }),

/***/ "./components/auth/terms/terms.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkTerms = {
  controller: 'TermsController',
  controllerAs: '$ctrl',
  template: __webpack_require__("./components/auth/terms/terms.template.html"),
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
};

angular.module('inkfinder').component('inkTerms', inkTerms);

/***/ }),

/***/ "./components/auth/terms/terms.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


TermsController.$inject = ['Session', 'Auth', 'Collector'];


/**
 * @name TermsController
 * @description Controller for the terms component
 * @param {service} Session The session service
 * @param {service} Auth The auth service
 * @param {service} Collector The collector service
 */
function TermsController(Session, Auth, Collector) {
  var vm = this;
  vm.agree = agree;
  vm.cancel = cancel;

  /**
   * @name agree
   * @description Function to agree to the terms and privacy policies and update
   * the collector
   */
  function agree() {
    var updatedCollector = Session.collector;
    updatedCollector.accepted_TOS_Privacy = true;
    Collector.updateProfile(updatedCollector).then(function () {
      vm.modalInstance.close();
    });
  }

  /**
   * @name cancel
   * @description Function to not agree and log out
   */
  function cancel() {
    vm.modalInstance.dismiss();
    Auth.logout();
  }
}

angular.module('inkfinder').controller('TermsController', TermsController);

/***/ }),

/***/ "./components/auth/terms/terms.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=agreeToTermsForm ng-submit=\"agreeToTermsForm.$valid && $ctrl.agree()\" novalidate> <div class=modal-header> <h4 class=modal-title>Ink Finder terms and privacy policy</h4> </div> <div class=\"modal-body background-light center\"> <p>We've updated our <a href=https://inkfinder.tattoo/legal/terms-providers/ target=_blank>Provider Terms of Service</a>, <a href=https://inkfinder.tattoo/legal/terms-collectors/ target=_blank> Collector Terms of Service</a>, and <a href=https://inkfinder.tattoo/legal/privacy/ target=_blank>Privacy Policy</a>.</p> <p>Hit the agree button below to accept our policy updates and continue using Ink Finder.</p> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Agree</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Logout</button> </div> </form> ";

/***/ }),

/***/ "./components/clients-list/_clients-list.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509229
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/clients-list/appointments/client-appointments-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ClientAppointmentsModalController.$inject = ['$uibModalInstance', 'client', 'appointments'];
/**
 * @name ClientAppointmentsModalController
 * @description Function to update clients who are still new users
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} client Resolved client from the client list controller
 * @param {unknown} appointments Resolved appointments from the client list controller
 */
function ClientAppointmentsModalController($uibModalInstance, client, appointments) {
  var vm = this;
  vm.client = client;
  vm.appointments = appointments;

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('ClientAppointmentsModalController', ClientAppointmentsModalController);

/***/ }),

/***/ "./components/clients-list/appointments/client-appointments-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h4 class=modal-title>Appointments for <span ng-if=$ctrl.client.first_name>{{$ctrl.client.first_name}} {{$ctrl.client.last_name}}</span><span ng-if=!$ctrl.client.first_name>this client</span></h4> </div> <div class=\"modal-body background-dark\"> <div class=\"list projects\"> <a class=\"item project link\" ui-sref=inkfinder.appointments.details({appointment_id:card.appointment.id}) ng-repeat=\"card in $ctrl.appointments\" ng-click=$ctrl.cancel()> <ink-project-card card=card color=\"'finder'\"></ink-project-card> </a> </div> </div> <div class=modal-footer> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div>";

/***/ }),

/***/ "./components/clients-list/appointments/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/clients-list/appointments/client-appointments-modal.controller.js");

/***/ }),

/***/ "./components/clients-list/clients-list.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkClientsList = {
  controller: 'ClientsListController',
  template: __webpack_require__("./components/clients-list/clients-list.template.html"),
  bindings: {
    $transition$: '<',
    clients: '<'
  }
};

angular.module('inkfinder').component('inkClientsList', inkClientsList);

/***/ }),

/***/ "./components/clients-list/clients-list.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ClientsListController.$inject = ['$state', 'Session', 'Collector', 'Appointments', '$uibModal', 'MergeProjects', 'RESPONSE_MESSAGES', 'AlertMessages', '_'];


/**
 * @name ClientsListController
 * @description Controller for the clients list component
 * @param {unknown} $state unknown
 * @param {object} Session The user session service
 * @param {object} Collector The user session service
 * @param {object} Appointments The Appointments service
 * @param {object} $uibModal The bootstrap modal service
 * @param {object} MergeProjects The MergeProjects service
 * @param {object} RESPONSE_MESSAGES The RESPONSE_MESSAGES constant
 * @param {object} AlertMessages The AlertMessages service
 * @param {unknown} _ The lodash service
 */
function ClientsListController($state, Session, Collector, Appointments, $uibModal, MergeProjects, RESPONSE_MESSAGES, AlertMessages, _) {
  var vm = this;

  // Public functions
  vm.updateClient = updateClient;
  vm.getClientAppointments = getClientAppointments;
  vm.resetSearch = resetSearch;
  vm.searchTermsUpdated = searchTermsUpdated;
  vm.uiOnParamsChanged = uiOnParamsChanged;
  vm.loadPage = loadPage;
  vm.session = Session;

  // Public variabls
  vm.loading = false;

  // Clients are loaded in the state resolve.

  // Load search parameters from the params in the state defintion.
  vm.search = {
    page: vm.$transition$.params().page,
    search: vm.$transition$.params().search
  };

  /**
   * @name updateClient
   * @description Function to update a client through a modal window
   * @param {object} client The client to edit
   */
  function updateClient(_client) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/clients-list/update/update-client-modal.template.html"),
      animation: true,
      controller: 'UpdateClientModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        client: function client() {
          return _client;
        }
      }
    });
    modalInstance.result.then(function (client) {
      // Nothing to do
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
  * @name getClientAppointments
  * @description
  * @param {number} client The client to view appointments
  */
  function getClientAppointments(_client2) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/clients-list/appointments/client-appointments-modal.template.html"),
      animation: true,
      controller: 'ClientAppointmentsModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        appointments: function appointments() {
          // Set all variables to blank for the appointments service
          var collector = _client2.id;
          var search = false;
          var start = void 0;
          var end = void 0;
          var timestamp = void 0;
          var artist = void 0;
          return Appointments.get(search, start, end, timestamp, artist, collector).then(function (appointments) {
            if (appointments.length > 0) {
              return MergeProjects.merge(appointments).then(function (mergedData) {
                appointments = mergedData;
                return appointments;
              });
            }
          });
        },
        client: function client() {
          return _client2;
        }
      }
    });
    modalInstance.result.then(function () {
      // Nothing to do
    }, function () {
      // Nothing to do
    });
  }

  /**
   * @name searchTermsUpdated
   * @description Function to update the URL parameters by calling $state.go.
   * '.' calls the current state and loads new params based on changes in the
   * view form.
   */
  function searchTermsUpdated() {
    vm.search.page = '1';
    $state.go('.', vm.search, { reload: true });
  }

  /**
   * @name uiOnParamsChanged
   * @description A ui-router function callback when param values change.
   * @param {object} newParams The name of the param that changed and its new value
   */
  function uiOnParamsChanged(newParams) {
    _.assign(vm.search, newParams);
    if (!_.isUndefined(newParams.search)) {
      vm.search.page = '1';
    }
    $state.go('.', vm.search, { reload: true });
  }

  /**
   * @name loadPage
   * @description Updates the page number in vm.search.page and calls $state.go to
   * update the URL with the new page number.
   * @param {number} page The new page number.
   */
  function loadPage(page) {
    vm.search.page = page.toString();
    $state.go('.', vm.search, { reload: true });
  }

  /**
    * @name resetSearch
    * @description Remove the text input field value to trigger the watcher on
    * local variable
    */
  function resetSearch() {
    vm.search.search = '';
    vm.search.page = '1';
    $state.go('.', vm.search, { reload: true });
  }
}

angular.module('inkfinder').controller('ClientsListController', ClientsListController);

/***/ }),

/***/ "./components/clients-list/clients-list.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=clients class=\"section photo background-dark\"> <div class=background-photo></div> <div class=container> <div class=row> <div class=col-sm-12> <div class=\"intro center\"> <h6 class=no-margin>{{$ctrl.session.activeState.association.shop.name}}</h6> <h1>Clients.</h1> <form name=searchClients novalidate> <p> Filter by &nbsp;&nbsp;<input name=search id=search type=text autocapitalize=off placeholder=\"First or last name, email, or phone\" class=\"small inline\" ng-model=$ctrl.search.search uib-tooltip=\"Enter a first name, last name, email, or phone number\" ng-model-options=\"{ debounce: 1000 }\" ng-change=$ctrl.searchTermsUpdated() style=width:300px> <button type=button class=\"button large gray\" ng-if=$ctrl.search.search ng-click=$ctrl.resetSearch()>Reset</button> </p> </form> </div> </div> </div> <div class=row ng-if=\"$ctrl.clients.count === 0\"> <div class=\"col-sm-12 center\"> <p ng-if=\"$ctrl.loading === false\">I didn't find any clients<span ng-if=$ctrl.search.search> using “{{$ctrl.search.search}}”</span>.</p> </div> </div> <div class=row ng-if=\"$ctrl.clients.count > 0\"> <div class=col-md-12> <div class=\"row visible-md-block visible-lg-block\"> <div class=col-md-3> <p><strong>Name</strong></p> </div> <div class=col-md-2> <p><strong>Phone</strong></p> </div> <div class=col-md-3> <p><strong>Email</strong></p> </div> <div class=col-md-1> <p><strong>Status</strong></p> </div> <div class=col-md-3> </div> </div> <div class=\"row client-group\" dir-paginate=\"client in $ctrl.clients.associations.collectors.all | itemsPerPage: 50 track by $index\" total-items=$ctrl.clients.count current-page=$ctrl.search.page> <div class=\"col-md-3 flex-container\"> <ink-profile-photo profile=collector image-id=client.profile_photo size=\"'small'\" show-name=false> </ink-profile-photo> &nbsp;&nbsp;<p class=no-margin>{{client.first_name}} {{client.last_name}}</p> </div> <div class=\"col-md-2 flex-container flex-align-center\"> <p class=no-margin>{{client.phone | tel}}</p> </div> <div class=\"col-md-3 flex-container flex-align-center\"> <p class=\"text-overflow no-margin\"><a href=mailto:{{client.email}}>{{client.email}}</a></p> </div> <div class=\"col-md-1 flex-container flex-align-center\"> <p class=no-margin><span ng-if=\"client.association.status == 'Shop Invited'\">Invited</span><span ng-if=\"client.association.status != 'Shop Invited'\">{{client.association.status}}</span></p> </div> <div class=\"col-md-3 flex-container flex-align-center client-group__actions\"> <p class=no-margin> <a ng-click=$ctrl.getClientAppointments(client) class=\"button small finder-solid\">Appointments</a> <a ng-if=\"client.is_new_user == true\" ng-click=$ctrl.updateClient(client) class=\"button small shop-solid\">Edit</a> <button ng-if=\"client.is_new_user == false\" class=\"button small finder disabled\" tooltip-placement=left uib-tooltip=\"This client has already logged in and can’t be edited.\" tooltip-class=light tooltip-append-to-body=true>Edit</button> </p> </div> </div> <div class=\"divider small tight transparent\"></div> <div class=center> <dir-pagination-controls max-size=7; on-page-change=$ctrl.loadPage(newPageNumber) ng-disabled=$ctrl.loading> </dir-pagination-controls> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/clients-list/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/clients-list/clients-list.component.js");

__webpack_require__("./components/clients-list/clients-list.controller.js");

__webpack_require__("./components/clients-list/_clients-list.styles.scss");

__webpack_require__("./components/clients-list/appointments/index.js");

__webpack_require__("./components/clients-list/update/index.js");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.clients-list', {
    url: '/clients-list?page&search',
    views: {
      '@': {
        component: 'inkClientsList'
      }
    },
    params: {
      page: {
        value: '1',
        dynamic: true
      },
      search: {
        value: '',
        dynamic: true
      }
    },
    resolve: {
      $title: function $title() {
        return 'Clients List.';
      },
      clients: ['$stateParams', 'Association', 'Session', function clients($stateParams, Association, Session) {
        var page = $stateParams.page;
        var search = $stateParams.search;
        var shopId = Session.activeState.association.shop.id;
        var appointmentWith = void 0;
        if (Session.activeState.role == 'artist') {
          appointmentWith = Session.collector.id;
        }
        return Association.getShopAssociations(shopId, Session.activeState.role, 'collector', page, search, appointmentWith).then(function (response) {
          return response;
        });
      }]
    },
    bindings: {
      $transition$: '<',
      clients: '<'
    },
    data: {
      authorizedRoles: [USER_ROLES.operator, USER_ROLES.artist]
    }
  });
}]);

/***/ }),

/***/ "./components/clients-list/update/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/clients-list/update/update-client-modal.controller.js");

/***/ }),

/***/ "./components/clients-list/update/update-client-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


UpdateClientModalController.$inject = ['$uibModalInstance', 'Collector', 'client', '_'];
/**
 * @name UpdateClientModalController
 * @description Function to update clients who are still new users
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} Collector The Collector service
 * @param {unknown} client Resolved client from the client list controller
 * @param {unknown} _ Underscore service
 */
function UpdateClientModalController($uibModalInstance, Collector, client, _) {
  var vm = this;
  client.new_email = client.email;
  vm.client = client;
  vm.updateClient = updateClient;

  /**
   * @name updateClient
   * @description Function to update the artist association
   * @param {object} client The client's collector object you want to update
   */
  function updateClient(client) {
    if (client.new_email == client.email) {
      client.new_email = '';
    }
    Collector.updateCollector(client).then(function (response) {
      $uibModalInstance.close();
      client.email = response.data.email;
    });
  }

  vm.cancel = function () {
    vm.client = client;
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('UpdateClientModalController', UpdateClientModalController);

/***/ }),

/***/ "./components/clients-list/update/update-client-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=updateClientForm ng-submit=\"updateClientForm.$valid && $ctrl.updateClient($ctrl.client)\" novalidate> <div class=modal-header> <h4 class=modal-title>Proflie update for <span ng-if=$ctrl.client.first_name>{{$ctrl.client.first_name}} {{$ctrl.client.last_name}} </span><span ng-if=!$ctrl.client.first_name>this client</span></h4> </div> <div class=\"modal-body background-light\"> <div class=form-group> <label for=first_name>First name</label> <input name=first_name id=first_name type=text class=form-control required ng-model=$ctrl.client.first_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateClientForm.first_name.$invalid && !updateClientForm.first_name.$pristine\"> Please enter your first name. </p> </div> </div> <div class=form-group> <label for=first_name>Last name</label> <input name=last_name name=last_name type=text class=form-control required ng-model=$ctrl.client.last_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateClientForm.last_name.$invalid && !updateClientForm.last_name.$pristine\"> Please enter your last name. </p> </div> </div> <div class=form-group> <label for=email>Email</label> <input name=new_email id=new_email type=email class=form-control required ng-model=$ctrl.client.new_email> <p class=\"inline-alert error\" ng-if=\"updateClientForm.new_email.$invalid && !updateClientForm.new_email.$pristine\"> <small><fa name=exclamation-triangle fw></fa> Hmm...I don’t think that's a real email address.</small> </p> </div> <div class=form-group> <label for=phone>Phone</label> <input name=phone id=phone type=text class=form-control mask=\"(999) 999-9999\" clean=true ng-model=$ctrl.client.phone> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form>";

/***/ }),

/***/ "./components/collector/_collector.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509191
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/collector/account-alerts/account-alerts.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAccountAlerts = {
  controller: 'AccountAlertsController',
  template: __webpack_require__("./components/collector/account-alerts/account-alerts.template.html")
};

angular.module('inkfinder').component('inkAccountAlerts', inkAccountAlerts);

/***/ }),

/***/ "./components/collector/account-alerts/account-alerts.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AccountAlertsController.$inject = ['Session', 'NOTIFICATIONS', 'Notification', 'Collector'];


/**
 * @name AccountAlertsController
 * @description Controller for the account alerts component
 * @param {service} Session The session service
 * @param {constant} NOTIFICATIONS The NOTIFICATIONS constant
 * @param {service} Notification The Notification service
 * @param {service} Collector The Collector service
 */
function AccountAlertsController(Session, NOTIFICATIONS, Notification, Collector) {
  var vm = this;

  vm.$onInit = function () {
    vm.session = Session;
    vm.verifyEmail = verifyEmail;

    // Refresh the collector if email_is_confirmed is false to check to see if its
    // now true.
    if (!vm.session.collector.email_is_confirmed) {
      Collector.refreshProfile();
    }
  };

  /**
   * @name verifyEmail
   * @description description
   * @param {type} collector The collector to verify email for
   */
  function verifyEmail(collector) {
    var confirmEmailNotification = {
      recipients: [collector.id],
      notificationId: NOTIFICATIONS.emailConfirmation,
      messageObjects: {
        collectorId: collector.id
      },
      messageVariables: {
        subject: 'Action required: please verify your email address'
      }
    };
    Notification.send(confirmEmailNotification);
  }
}

angular.module('inkfinder').controller('AccountAlertsController', AccountAlertsController);

/***/ }),

/***/ "./components/collector/account-alerts/account-alerts.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"inline-alert error\" ng-if=\"$ctrl.session.collector !== null && !$ctrl.session.collector.email_is_confirmed\"> <div class=row> <div class=\"col-lg-8 col-md-6\"> <p> <fa name=exclamation-triangle class=light-color></fa> <strong>Your email addressed has not been verified, yo.</strong> <small><a ng-click=$ctrl.verifyEmail($ctrl.session.collector)>Confirm your email</a> so you continue to receive email notifications.</small> </p> </div> <div class=\"col-lg-4 col-md-5\"> <div class=\"divider xxtight transparent\"></div> <div class=\"button-container right\"> <button class=\"button medium light-solid\" ng-click=$ctrl.verifyEmail($ctrl.session.collector)>Confirm your email</button> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/collector/account-alerts/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/account-alerts/account-alerts.component.js");

__webpack_require__("./components/collector/account-alerts/account-alerts.controller.js");

/***/ }),

/***/ "./components/collector/add/add-collector.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAddCollector = {
  controller: 'AddCollectorController',
  template: __webpack_require__("./components/collector/add/add-collector.template.html")
};

angular.module('inkfinder').component('inkAddCollector', inkAddCollector);

/***/ }),

/***/ "./components/collector/add/add-collector.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddCollectorController.$inject = ['_', '$log'];


/**
 * @name AddCollectorController
 * @description Controller for adding collectors.
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 */
function AddCollectorController(_, $log) {}

angular.module('inkfinder').controller('AddCollectorController', AddCollectorController);

/***/ }),

/***/ "./components/collector/add/add-collector.template.html":
/***/ (function(module, exports) {

module.exports = "<p>Add collector template</p> ";

/***/ }),

/***/ "./components/collector/add/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/add/add-collector.component.js");

__webpack_require__("./components/collector/add/add-collector.controller.js");

/***/ }),

/***/ "./components/collector/associations/association.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _setIfExists = __webpack_require__("./utils/set-if-exists.js");

var _setIfExists2 = _interopRequireDefault(_setIfExists);

var _moment = __webpack_require__("../node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('inkfinder').factory('Association', ['$rootScope', '$http', '$q', 'ENDPOINT', '$uibModal', 'AlertMessages', 'Session', '_', function Association($rootScope, $http, $q, ENDPOINT, $uibModal, AlertMessages, Session, _) {
  // Public Methods
  Association.parseUserAssociations = parseUserAssociations;
  Association.createAssociation = createAssociation;
  Association.deleteAssociation = deleteAssociation;
  Association.getAssociations = getAssociations;
  Association.getAssociation = getAssociation;
  Association.getShopAssociations = getShopAssociations;
  Association.determineAssociationConflict = determineAssociationConflict;
  Association.sortByAssociations = sortByAssociations;

  // Convienence Functions
  Association.declineByShop = declineByShop;
  Association.declineByUser = declineByUser;
  Association.accept = accept;
  Association.expire = expire;
  Association.update = updateAssociation;

  // Clear data
  var deregister = $rootScope.$on('clear-data', function () {
    Association.associations = {};
    Association.association = {};
  });
  $rootScope.$on('$destroy', deregister);

  /**
  * Get all associations for the logged in user
  * @return {promise} Returns associations object
  * TODO Review if this function is needed now.
  */
  function getAssociations() {
    return $http.get(ENDPOINT.server + 'collectors/api/v1.1/association/').then(function (response) {
      var associations = response.data;
      Association.associations = parseUserAssociations(associations);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @name getShopAssociations
  * @description Get all associations for a shop
  * @param {shopId} shopId The ID of the shop to retrieve their associations
  * @param {string} role The role of the logged in user
  * @param {string} type The type of associations to return, ie, operator, artist, or collector
  * @param {number} page Pagination support
  * @param {string} search Text search support
  * @param {number} appointmentWith Filter to limit assocaitions to ones that have an appointment with
  * a particular artist
  * @return {promise} Returns a promise containing shop associations
  */
  function getShopAssociations(shopId, role, type, page, search, appointmentWith) {
    if (_.isUndefined(shopId)) {
      shopId = _.isUndefined(Session.activeState.association) ? '' : Session.activeState.association.shop.id;
    }
    if (_.isUndefined(role) || Session.activeState === null) {
      role = '';
    }
    return $http.get(ENDPOINT.server + 'collectors/api/v1.1/association/?' + (shopId ? 'shop_id=' + shopId : '') + (type ? '&type=' + type : '') + (role ? '&role=' + role : '') + (page ? '&page=' + page : '') + (search ? '&search=' + search : '') + (appointmentWith ? '&appointment-with=' + appointmentWith : '')).then(function (response) {
      var associations = void 0;
      if (page) {
        response.data.associations = parseCollectorAssociations(response.data.results);
        return response.data;
      }
      associations = parseCollectorAssociations(response.data);
      Association.associations = associations;
      return associations;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @name getAssociation
  * @description Get details for a single association based on the collector ID
  * @param {array} collectorIds The ID of the collector to retrieve their
  * association
  * @param {string} role The role of the activeState of the logged in user
  * association
  * @return {object} Returns an association object
  */
  function getAssociation(collectorIds) {
    var url = ENDPOINT.server + 'collectors/api/v1.1/association/?';
    if (!_.isUndefined(collectorIds)) {
      url += 'collector_ids=' + collectorIds;
    }
    if (Session.activeState) {
      if (Session.activeState.role === 'operator' || Session.activeState.role === 'artist') {
        var role = Session.activeState.role;
        url += '&role=' + role;
      }
    }
    return $http.get(url).then(function (associations) {
      var parsedAssociations = parseUserAssociations(associations.data);
      return parsedAssociations;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * Update a single association based on the association ID
  * @param {association} association The assoication to be updated
  * @return {object} Returns a promise object containing the updated association
  */
  function updateAssociation(association) {
    return $http.put(ENDPOINT.server + 'collectors/api/v1.1/association/' + association.id + '/', association).then(function (response) {
      var association = response.data;
      return association;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * Create an association
  * @param {type} type The type of association to create. Options accepted are
  * 'artist' and 'operator'.
  * @param {association} association The formatted association data
  * @return {object} Returns an association object
  */
  function createAssociation(type, association) {
    var _association = association;
    _association.type = type;
    var _formattedAssocation = formatAssociation(association);
    return $http.post(ENDPOINT.server + 'collectors/api/v1.1/association/', _formattedAssocation).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * Delete an association
  * @param {association} association The association to be deleted
  */
  function deleteAssociation(association) {
    $http.delete(ENDPOINT.server + 'collectors/api/v1.1/association/' + association.id + '/').then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error.data,
        type: 'danger'
      });
    });
  }

  /**
  * Update an association to shop declined
  * @param {input} input The association object to be changed
  * @return {object} Returns the updated association
  */
  function declineByShop(input) {
    input.status = 'Shop Declined';
    var association = formatAssociation(input);
    return updateAssociation(association);
  }

  /**
  * Update an association to user declined
  * @param {input} input The association object to be changed
  * @return {object} Returns the updated association
  */
  function declineByUser(input) {
    input.status = 'User Declined';
    var association = formatAssociation(input);
    return updateAssociation(association);
  }

  /**
  * Update an association to confirmed
  * @param {input} input The association object to be changed
  * @return {object} Returns the updated association
  */
  function accept(input) {
    input.status = 'Confirmed';
    var association = formatAssociation(input);
    return updateAssociation(association);
  }

  /**
  * Update an association to expired (will set expiration date to today)
  * @param {input} association The association object to be changed
  * @return {object} Returns the updated association
  */
  function expire(association) {
    association.status = 'Expired';
    association.endDatetime = (0, _moment2.default)().format();
    return updateAssociation(association);
  }

  /**
  * Formats Association Data
  * @param {input} input The association to format
  * @return {object} Returns a formatted association object
  */
  function formatAssociation(input) {
    var _association = {};
    if (!(0, _setIfExists2.default)(input, 'status', _association)) {
      _association.status = input.status;
    }
    if (!(0, _setIfExists2.default)(input, 'type', _association)) {
      _association.type = input.type;
    }
    if (!(0, _setIfExists2.default)(input, 'startDatetime', _association)) {
      _association.startDatetime = (0, _moment2.default)().format();
    }
    if (input.endDatetime) {
      _association.endDatetime = input.endDateTime;
    }
    if (input.operatorAdmin) {
      _association.operatorAdmin = input.operatorAdmin;
    }
    if (input.operatorOwner) {
      _association.operatorOwner = input.operatorOwner;
    }
    (0, _setIfExists2.default)(input, 'shop_id', _association);
    (0, _setIfExists2.default)(input, 'collector_id', _association);
    (0, _setIfExists2.default)(input, 'id', _association);
    (0, _setIfExists2.default)(input, 'can_update_appts', _association);
    return _association;
  }

  /** Parse user Associations (used for logged in user)
  * @param {associations} associations The object of associations to parse
  * @return {object} Returns an object of parsed associations
  */
  function parseUserAssociations(associations) {
    var sorted = { artist: [], operator: [], collector: [] };
    var processed = {};

    for (var i = 0; i < associations.length; i++) {
      delete associations[i].collector; // Delete the Collector (not needed)
      associations[i].type = associations[i].type.toLowerCase();
      if (associations[i].type === 'operator') {
        sorted.operator.push(associations[i]);
      } else if (associations[i].type === 'artist') {
        sorted.artist.push(associations[i]);
      } else {
        sorted.collector.push(associations[i]);
      }
    }
    processed.all = associations;
    processed.operators = sortByAssociations(sorted.operator);
    processed.artists = sortByAssociations(sorted.artist);
    processed.collectors = sortByAssociations(sorted.collector);
    return processed;
  }

  /**
  * Parse the Associations into Collector Prioritized Objects (collector oriented)
  * @param {associations} associations The associations of the collectors to parse
  * @return {object} Calls sortCollectors and returns an object of collectors
  */
  function parseCollectorAssociations(associations) {
    var collectors = [];
    for (var i = 0; i < associations.length; i++) {
      var association = associations[i];
      var collector = association.collector;
      collector.association = association;
      collector.association.type = collector.association.type.toLowerCase();
      delete collector.association.collector; // Delete Extra Collector Data
      collectors.push(collector);
    }
    return sortCollectors(collectors);
  }

  /**
  * Sort the Collectors into type based on their Association
  * @param {collectors} collectors The object of collectors to sort
  * @return {object} Returns an object of sorted collectors
  */
  function sortCollectors(collectors) {
    var sorted = { artist: [], operator: [], collector: [] };
    var processed = {};

    for (var i = 0; i < collectors.length; i++) {
      sorted[collectors[i].association.type].push(collectors[i]);
    }

    // Assign the Data
    processed.all = collectors;
    processed.artists = sortByAssociations(sorted.artist);
    processed.operators = sortByAssociations(sorted.operator);
    processed.collectors = sortByAssociations(sorted.collector);

    return processed;
  }

  /**
  * Sort by Association Type (abstracted to take collectors [w/ association] and associations).
  * @param {inputArray} inputArray The array of associations to sort
  * @return {object} Returns an object of arrays. Arrays are sorted by association status.
  */
  function sortByAssociations(inputArray) {
    var processed = {
      confirmed: [],
      invited: [],
      declined: [],
      expired: [],
      valid: [],
      inactive: []
    };

    // Loop through Associations
    for (var i = 0; i < inputArray.length; i++) {
      var item = inputArray[i];

      // Collector Object (w/ association object) or Association Object
      var association = void 0;
      if (item.association) {
        association = item.association;
      } else {
        association = item;
      }

      var status = association.status;
      var expiration = association.endDatetime;

      // Generate a list of Valid Associations
      if (status === 'Confirmed' || status === 'Expired') {
        processed.valid.push(item);
      }

      if (expiration && (0, _moment2.default)(expiration) < (0, _moment2.default)()) {
        if (status === 'Confirmed') {
          processed.inactive.push(item);
        } else {
          processed.expired.push(item);
        }
      } else if (status === 'Confirmed') {
        processed.confirmed.push(item);
      } else if (status === 'Shop Invited' || status === 'User Invited') {
        processed.invited.push(item);
      } else if (status === 'User Declined' || status === 'Shop Declined') {
        processed.declined.push(item);
      }
    }

    // Everything
    processed.all = inputArray;
    return processed;
  }

  /**
  * Check for conflicts with associations
  * @param {collectors} collectors The collectors to check for conflicts
  * @param {group} group The group to check within?
  */
  function determineAssociationConflict(collectors, group) {
    var conflict = [];

    for (var i = 0; i < group.invited.length; i++) {
      conflict[group.invited[i].id] = group.invited[i];
    }

    for (var d = 0; d < group.confirmed.length; d++) {
      conflict[group.confirmed[d].id] = group.confirmed[d];
    }

    for (var s = 0; s < collectors.length; s++) {
      if (conflict[collectors[s].id]) {
        collectors[s].associationConflict = true;
      } else {
        collectors[s].associationConflict = false;
      }
    }
  }
  return Association;
}]);

/***/ }),

/***/ "./components/collector/associations/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/associations/list/index.js");

__webpack_require__("./components/collector/associations/association.service.js");

/***/ }),

/***/ "./components/collector/associations/list/associations-list.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAssociationsList = {
  controller: 'AssociationsListController',
  bindings: {
    decline: '&',
    accept: '&',
    edit: '&',
    onChange: '&',
    associations: '<',
    title: '<',
    type: '<'
  },
  template: __webpack_require__("./components/collector/associations/list/associations-list.template.html")
};

angular.module('inkfinder').component('inkAssociationsList', inkAssociationsList);

/***/ }),

/***/ "./components/collector/associations/list/associations-list.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AssociationsListController.$inject = ['Association', 'NOTIFICATIONS', 'Notification', 'Session', '$uibModal', 'AlertMessages', 'RESPONSE_MESSAGES', '_'];


/**
 * @name AssociationsListController
 * @param {service} Association Service for association
 * @param {constant} NOTIFICATIONS The nofiticaitons constant
 * @param {service} Notification The nofiticaiton service
 * @param {service} Session The Session service
 * @param {service} $uibModal The $uibModal service from ui bootstrap
 * @param {service} AlertMessages The AlertMessages service
 * @param {constant} RESPONSE_MESSAGES The RESPONSE_MESSAGES constant
 * @param {library} _ The Lodash library
 */
function AssociationsListController(Association, NOTIFICATIONS, Notification, Session, $uibModal, AlertMessages, RESPONSE_MESSAGES, _) {
  var vm = this;

  vm.accept = accept;
  vm.decline = decline;
  vm.edit = edit;
  vm.expire = expire;

  /**
    * @description
    * Accept an Invite
    * @param {object} association The association to accept
    */
  function accept(association) {
    Association.accept(association).then(function (updatedAssociation) {
      vm.onChange();

      // Send email notifications
      if (association.type === 'operator') {
        // Send the  notification if an operator accepted this invite
        var notification = {
          recipients: [], // API will send email to all operators at the shop
          notificationId: NOTIFICATIONS.operatorAccept,
          messageObjects: {
            shopId: association.shop.id,
            // The operator accepting the invite
            operatorId: Session.collector.id
          },
          messageVariables: {
            subject: Session.collector.first_name + ' ' + Session.collector.last_name + ' accepted an invite to be an operator at ' + association.shop.name
          }
        };
        Notification.send(notification);
      } else if (association.type === 'artist') {
        // Send the notification if an operator accepted this invite
        var _notification = {
          recipients: [], // API will send email to all operators at the shop
          notificationId: NOTIFICATIONS.artistAccept,
          messageObjects: {
            shopId: association.shop.id,
            artistId: Session.collector.id // The artist accepting the invite
          },
          messageVariables: {
            subject: Session.collector.first_name + ' ' + Session.collector.last_name + ' accepted an invite to be an artist at ' + association.shop.name
          }
        };
        Notification.send(_notification);
      }
    });
  }

  /**
   * @name decline
   * @description Function to decline an association
   * @param {object} association The collector to cancel
   */
  function decline(_association) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/collector/associations/list/decline-association-modal.template.html"),
      animation: true,
      controller: 'DeclineAssociationController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        association: function association() {
          return _association;
        }
      }
    });
    modalInstance.result.then(function (udpatedAssociation) {
      _.remove(vm.associations, function (association) {
        return association.id === udpatedAssociation.id;
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name edit
   * @description Function to edit an association
   * @param {object} association The collector to cancel
   */
  function edit(_association2) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/collector/associations/list/edit-association-modal.template.html"),
      animation: true,
      controller: 'EditAssociationController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        association: function association() {
          return _association2;
        }
      }
    });
    modalInstance.result.then(function (udpatedAssociation) {
      vm.onChange();
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name expire
   * @description Function to open the expire association modal
   * @param {object} association The association to expire
   */
  function expire(_association3) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/collector/associations/list/expire-association-modal.template.html"),
      animation: true,
      controller: 'ExpireAssociationController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        association: function association() {
          return _association3;
        }
      }
    });
    modalInstance.result.then(function (udpatedAssociation) {
      _.remove(vm.associations, function (association) {
        return association.id === udpatedAssociation.id;
      });
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }
}

angular.module('inkfinder').controller('AssociationsListController', AssociationsListController);

/***/ }),

/***/ "./components/collector/associations/list/associations-list.template.html":
/***/ (function(module, exports) {

module.exports = "<h5 ng-if=$ctrl.title>{{$ctrl.title}}</h5> <p ng-if=\"$ctrl.associations.length === 0\">You have no {{$ctrl.title}}.</p> <div class=\"cards profiles\"> <div class=\"row flex-container flex-wrap\"> <div class=\"col-xs-12 col-sm-6 col-md-4 col-lg-3 card profile link flex\" ng-repeat=\"association in $ctrl.associations | orderBy: 'shop.name' track by association.id\"> <div class=profile-container> <a ng-click=$ctrl.edit(association) class=profile-container__edit ng-if=\"association.status === 'Confirmed'\"> <fa name=pencil></fa> </a> <a ng-click=$ctrl.expire(association) class=profile-container__expire ng-if=\"association.status === 'Confirmed'\"> <fa name=trash></fa> </a> <ink-profile-photo profile=association image-id=association.shop.profile_logo size=\"'large'\" show-name=false> </ink-profile-photo> <p class=profile-container__name> {{association.shop.name}} </p> <div class=profile-details-container> <div class=row> <div class=col-sm-12> <div class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <fa name=calendar-o fw size=1></fa> {{association.startDatetime | amDateFormat:'MM/DD/YY'}} – <span ng-if=\"association.endDatetime !== null\"> {{association.endDatetime | amDateFormat:'MM/DD/YY'}} </span> <span ng-if=\"association.endDatetime === null\"> No end </span> </small> </div> <div ng-if=\"$ctrl.type === 'operator'\" class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <span ng-if=association.operatorOwner> <fa name=university fw size=1></fa> Shop owner </span> <span ng-if=\"!association.operatorOwner && association.operatorAdmin\"> <fa name=trophy fw size=1></fa> Shop admin </span> </small> </div> <div ng-if=\"$ctrl.type === 'artist'\" class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <fa name=pencil fw size=1 ng-if=association.can_update_appts></fa> <fa name=ban fw size=1 ng-if=!association.can_update_appts></fa> <span ng-if=association.can_update_appts> Can </span> <span ng-if=!association.can_update_appts> Cannot </span> update your appts </small> </div> <div class=\"profile-detail__item profile-detail--less-margin\" ng-if=\"association.status === 'Shop Invited' || association.status === 'User Invited'\"> <div class=\"divider small xtight transparent\"></div> <div class=button-container> <button class=\"button small shop-solid\" ng-click=$ctrl.accept(association)> Accept </button> <button class=\"button small alert-btn\" ng-click=$ctrl.decline(association)> Decline </button> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/collector/associations/list/decline-association-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


DeclineAssociationController.$inject = ['$uibModalInstance', 'Association', 'association'];


/**
 * @name DeclineAssociationController
 * @description Function to handle association declines
 * @param {service} $uibModalInstance UI Bootstrap image modal instance
 * @param {service} Association The association service
 * @param {object} association Resolved association from the component controller
 */
function DeclineAssociationController($uibModalInstance, Association, association // From the resolve
) {
  var vm = this;
  vm.association = association;
  vm.decline = decline;

  /**
   * @name decline
   * @description Function to decline an association
   * @param {object} association The association to decline
   */
  function decline(association) {
    Association.declineByUser(association).then(function (updatedAssociation) {
      $uibModalInstance.close(updatedAssociation);
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('DeclineAssociationController', DeclineAssociationController);

/***/ }),

/***/ "./components/collector/associations/list/decline-association-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=declineAssociationForm ng-submit=\"declineAssociationForm.$valid && $ctrl.decline($ctrl.association)\" novalidate> <div class=modal-header> <h4 class=modal-title>Decline this invitation from {{$ctrl.association.shop.name}}?</h4> </div> <div class=\"modal-body background-light center\"> <ink-profile-photo profile=$ctrl.association.shop image-id=$ctrl.association.shop.profile_logo type=\"'shop'\" show-name=false> </ink-profile-photo> <div class=\"divider small xtight transparent\"></div> <p>If you decline, you will not be connected to this shop. You sure?</p><p> </p></div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Decline</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/collector/associations/list/edit-association-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


EditAssociationController.$inject = ['$uibModalInstance', 'Association', 'association', 'Session', 'ArtistNotificationPrefs', 'OperatorNotificationPrefs'];


/**
 * @name EditAssociationController
 * @description Function to remove operators from a shop
 * @param {library} $uibModalInstance UI Bootstrap modal service
 * @param {service} Association The association service
 * @param {object} association Resolved association from the comonent controller
 * @param {service} Session The Session service
 * @param {service} ArtistNotificationPrefs The ArtistNotificationPrefs service
 * @param {service} OperatorNotificationPrefs The OperatorNotificationPrefs service
 */
function EditAssociationController($uibModalInstance, Association, association, Session, ArtistNotificationPrefs, OperatorNotificationPrefs) {
  var vm = this;
  vm.association = association;
  vm.update = update;
  vm.session = Session;

  get(vm.association);

  /**
   * @name get
   * @description Function to get notification prefs for this association
   * @param {object} association The association related to the preferences
   */
  function get(association) {
    if (association.type === 'artist' && association.artistNotificationPreference) {
      ArtistNotificationPrefs.get(association.artistNotificationPreference).then(function (notprefs) {
        vm.artistNotPrefs = notprefs;
      });
    } else if (association.type === 'operator' && association.operatorNotificationPreference) {
      OperatorNotificationPrefs.get(association.operatorNotificationPreference).then(function (notprefs) {
        vm.operatorNotPrefs = notprefs;
      });
    }
  }

  /**
   * @name update
   * @description Function to update these notification preferences
   */
  function update() {
    if (vm.artistNotPrefs) {
      ArtistNotificationPrefs.update(vm.association.artistNotificationPreference, vm.artistNotPrefs).then(function (notprefs) {
        $uibModalInstance.close(notprefs);
      });
    } else if (vm.operatorNotPrefs) {
      OperatorNotificationPrefs.update(vm.association.operatorNotificationPreference, vm.operatorNotPrefs).then(function (notprefs) {
        $uibModalInstance.close(notprefs);
      });
    }
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('EditAssociationController', EditAssociationController);

/***/ }),

/***/ "./components/collector/associations/list/edit-association-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=editAssociationForm ng-submit=\"editAssociationForm.$valid && $ctrl.update($ctrl.association)\" novalidate> <div class=modal-header> <h4 class=modal-title>Edit this connection</h4> </div> <div class=\"modal-body background-light\"> <div class=center> <ink-profile-photo profile=$ctrl.association.shop image-id=$ctrl.association.shop.profile_logo type=\"'shop'\" show-name=false> </ink-profile-photo> </div> <div class=\"divider small xtight transparent\"></div> <h5>Notification settings with {{$ctrl.association.shop.name}}</h5> <div ng-if=\"$ctrl.association.type === 'operator' && $ctrl.operatorNotPrefs\"> <div class=form-group> <h6> Shop schedule and income notifications </h6> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.operatorNotPrefs.receive_the_shop_daily> The Shop Daily<br/> <small>The Shop Daily is a report of your shop’s appointments and income</small> </label> </div> <div class=\"divider small xtight transparent\"></div> <h6> Appointment notifications </h6> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.operatorNotPrefs.subscribe_all_appointment_conversations> Automatically subscribe to all appointment messages<br/> <small>When you’re subscribed to an appointment, you’ll get an email every time a new message is created.</small> </label> </div> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.operatorNotPrefs.collector_confirm_appointment> When collectors confirm appointments </label> </div> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.operatorNotPrefs.collector_decline_appointment> When collectors decline appointments </label> </div> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.operatorNotPrefs.appointment_cancel_to_reschedule> When other operators cancel appointments and plan to reschedule later </label> </div> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.operatorNotPrefs.appointment_cancel> When other operators permanently cancel appointments </label> </div> <div class=\"divider small xtight transparent\"></div> <h6> Project notifications </h6> <div class=form-group> <label> <input type=checkbox ng-model=$ctrl.operatorNotPrefs.project_updated> When a project your shop has an appointment for is updated </label> </div> </div> <div ng-if=\"$ctrl.association.type === 'operator' && !$ctrl.operatorNotPrefs\"> <p> We couldn’t find any settings to edit for this connection. </p> </div> <div class=\"divider small xxtight transparent\"></div> <div ng-if=\"$ctrl.association.type === 'artist' && $ctrl.artistNotPrefs\"> <h6> Schedule and income notifications </h6> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.artistNotPrefs.receive_the_artist_daily> The Artist Daily<br/><small>The Artist Daily is a report showing today’s appointments and your income for the week</small> </label> </div> <div class=\"divider small xtight transparent\"></div> <h6> Appointment notifications </h6> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.artistNotPrefs.collector_confirm_appointment> When collectors confirm appointments with you </label> </div> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.artistNotPrefs.collector_decline_appointment> When collectors decline appointments with you </label> </div> <div class=form-group> <label> <input type=checkbox ng-model=$ctrl.artistNotPrefs.appointment_confirmed> When operators confirm appointments </label> </div> <div class=form-group> <label> <input type=checkbox ng-model=$ctrl.artistNotPrefs.appointment_estimated> When operators estimate appointments </label> </div> <div class=form-group> <label> <input type=checkbox ng-model=$ctrl.artistNotPrefs.appointment_updated> When operators update appointments </label> </div> <div class=form-group> <label> <input type=checkbox ng-model=$ctrl.artistNotPrefs.appointment_completed> When operators complete appointments </label> </div> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.artistNotPrefs.appointment_cancel_to_reschedule> When operators cancel appointments and plan to reschedule later </label> </div> <div class=form-group> <label> <input name=shopDaily type=checkbox ng-model=$ctrl.artistNotPrefs.appointment_cancel> When operators permanently cancel appointments </label> </div> <div class=\"divider small xtight transparent\"></div> <h6> Project notifications </h6> <div class=form-group> <label> <input type=checkbox ng-model=$ctrl.artistNotPrefs.project_updated> When a project you have an appointment for is updated </label> </div> </div> <div ng-if=\"$ctrl.association.type === 'artist' && !$ctrl.artistNotPrefs\"> <p> We couldn’t find any settings to edit for this connection. </p> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/collector/associations/list/expire-association-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ExpireAssociationController.$inject = ['$uibModalInstance', 'Association', 'association'];


/**
 * @name ExpireAssociationController
 * @description Function to expire an association
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} Association The association service
 * @param {unknown} association Resolved artist from the artist controller
 */
function ExpireAssociationController($uibModalInstance, Association, association) {
  var vm = this;
  vm.association = association;
  vm.expire = expire;

  /**
   * @name expire
   * @description Change association status to expired
   * @param {object} association The association to expire
   */
  function expire(association) {
    Association.expire(association).then(function (expiredAssociation) {
      $uibModalInstance.close(expiredAssociation);
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('ExpireAssociationController', ExpireAssociationController);

/***/ }),

/***/ "./components/collector/associations/list/expire-association-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=expireAssociationForm ng-submit=\"expireAssociationForm.$valid && $ctrl.expire($ctrl.association)\" novalidate> <div class=modal-header> <h4 class=modal-title>Disconnect</h4> </div> <div class=\"modal-body background-light center\"> <ink-profile-photo profile=$ctrl.association.shop image-id=$ctrl.association.shop.profile_logo type=\"'shop'\" show-name=false> </ink-profile-photo> <p> Disconnect with {{$ctrl.association.shop.name}}?<br/> <small ng-if=\"$ctrl.association.type === 'artist'\">When you disconnect with a shop, you can no longer be scheduled for appointments there.</small> <small ng-if=\"$ctrl.association.type === 'operator'\">When you disconnect with a shop, you can no longer collaborate with their artists and collectors.</small> </p> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Disconnect</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Cancel</button> </div> </form> ";

/***/ }),

/***/ "./components/collector/associations/list/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/associations/list/associations-list.component.js");

__webpack_require__("./components/collector/associations/list/associations-list.controller.js");

__webpack_require__("./components/collector/associations/list/decline-association-modal.controller.js");

__webpack_require__("./components/collector/associations/list/edit-association-modal.controller.js");

__webpack_require__("./components/collector/associations/list/expire-association-modal.controller.js");

/***/ }),

/***/ "./components/collector/collector-association.data.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// /**
//  * @name CollectorAssociationData
//  * @description Service to poll for the logged in collector associations and
//  * keep them updated
//  * @param {type} $q Description
//  * @param {type} $http Description
//  * @param {type} $rootScope Description
//  * @param {type} $interval Description
//  * @param {type} ENDPOINT Description
//  * @param {type} Session Description
//  * @param {type} moment Description
//  * @param {type} Association Description
//  * @param {type} _ Description
//  * @return {service} Returns the service
//  */
// function CollectorAssociationData(
//   $q,
//   $http,
//   $rootScope,
//   $interval,
//   ENDPOINT,
//   Session,
//   moment,
//   Association,
//   _
// ) {
//   // Public variables
//   CollectorAssociationData.associations = [];
//
//   // Public methods
//   CollectorAssociationData.get = get;
//   CollectorAssociationData.refresh = refresh;
//   CollectorAssociationData.reset = reset;
//
//   // Private variables
//   let timer;
//   let refreshing = false;
//   let timestamp;
//   let refreshInterval;
//
//   /**
//    * @name refresh
//    * @description Function to determine if we should get new data from the API
//    * @param {number} collectorId The ID of the collector
//    * @return {promise} Returns a promise
//    * loads.
//    */
//   function refresh(collectorId) {
//     return $q(function(resolve, reject) {
//       if (shouldRefresh()) {
//         resolve(get(collectorId));
//       } else {
//         reject('Load cache');
//       }
//     });
//   }
//
//   /**
//    * @name createAppointmentTimer
//    * @description Function to create an internal timer and call
//    * @param {number} collectorId The ID of the collector
//    * refreshAppointments() at a specific interval
//    */
//   function createAssociationTimer(collectorId) {
//     timer = $interval(function() {
//       refresh(collectorId);
//     }, 1000);
//   }
//
//   /**
//    * @name shouldRefresh
//    * @description Unknown
//    * @return {boolean} boolean Returns true/false depending on refreshing and updated.
//    */
//   function shouldRefresh() {
//     let result;
//     let isNotRefreshing = !refreshing;
//     let now = moment();
//     let isTime = (!refreshInterval ||
//     now.diff(refreshInterval, 'seconds') >= 5);
//     result = isNotRefreshing && isTime;
//     return result;
//   }
//
//   /**
//    * @name get
//    * @description Function to get appointments.
//    * @param {date} collectorId Moment object for the start of the shop day.
//    * @return {empty} Empty Returns without sending data.
//    */
//   function get(collectorId) {
//     refreshing = true;
//     return Association.getAssociation(collectorId)
//     .then(function(associations) {
//       CollectorAssociationData.associations = associations;
//       refreshing = false;
//       refreshInterval = moment();
//       timestamp = moment();
//       if (!timer) {
//         createAssociationTimer(collectorId);
//       }
//       return associations;
//     });
//   }
//
//   let deregister = $rootScope.$on('clear-data', reset);
//   $rootScope.$on('$destroy', deregister);
//
//   /**
//    * @name reset
//    * @description Reset variables
//    */
//   function reset() {
//     CollectorAssociationData.associations = [];
//     $interval.cancel(timer);
//     refreshing = false;
//     refreshInterval = null;
//     timestamp = null;
//   }
//   return CollectorAssociationData;
// }
//
// angular
// .module('inkfinder')
// .factory('CollectorAssociationData', CollectorAssociationData);


/***/ }),

/***/ "./components/collector/collector-bar/_collector-bar.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510712
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/collector/collector-bar/collector-bar.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkCollectorBar = {
  template: __webpack_require__("./components/collector/collector-bar/collector-bar.template.html"),
  controller: ['Session', function controller(Session) {
    this.session = Session;
  }]
};

angular.module('inkfinder').component('inkCollectorBar', inkCollectorBar);

/***/ }),

/***/ "./components/collector/collector-bar/collector-bar.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=collector-bar> <div class=container-fluid> <div class=row> <div class=col-sm-12> <ink-login route=false type=\"'modal'\"></ink-login> <span class=logo-flat></span> <ink-state-switcher></ink-state-switcher> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/collector/collector-bar/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/collector-bar/collector-bar.component.js");

__webpack_require__("./components/collector/collector-bar/_collector-bar.styles.scss");

/***/ }),

/***/ "./components/collector/collector-list/_collector-list.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510968
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/collector/collector-list/collector-list.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkCollectorList = {
  bindings: {
    list: '<',
    select: '&',
    type: '<'
  },
  template: __webpack_require__("./components/collector/collector-list/collector-list.template.html")
};

angular.module('inkfinder').component('inkCollectorList', inkCollectorList);

/***/ }),

/***/ "./components/collector/collector-list/collector-list.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"list profiles\"> <div class=\"item profile\" ng-repeat=\"collector in $ctrl.list\" ng-click=\"!collector.associationConflict && $ctrl.select({collector: collector})\"> <ink-profile-photo type=$ctrl.type profile=collector linkable=\"collector.associationConflict === false\" invited=collector.associationConflict image-id=collector.profile_photo> </ink-profile-photo> </div> </div> ";

/***/ }),

/***/ "./components/collector/collector-list/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/collector-list/collector-list.component.js");

__webpack_require__("./components/collector/collector-list/_collector-list.styles.scss");

/***/ }),

/***/ "./components/collector/collector.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkCollector = {
  controller: 'CollectorController',
  template: __webpack_require__("./components/collector/collector.template.html")
};

angular.module('inkfinder').component('inkCollector', inkCollector);

/***/ }),

/***/ "./components/collector/collector.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


CollectorController.$inject = ['$scope', '$rootScope', 'Collector', 'Auth', 'AlertMessages', 'Session', 'CheckUsername', 'AUTH_EVENTS', 'NOTIFICATIONS', 'Notification', '_'];


/**
 * @description
 * Controller for the profile screen
 * @param {object?} $scope Injects scope
 * @param {object?} $rootScope Injects $rootScope
 * @param {object} Collector Injects Collector services
 * @param {object} Auth Authentication service
 * @param {object} AlertMessages AlertMessages service
 * @param {object} Session The session service
 * @param {object} CheckUsername The check username service
 * @param {object} AUTH_EVENTS The AUTH_EVENTS constant
 * @param {object} NOTIFICATIONS The NOTIFICATIONS constant
 * @param {object} Notification The Notification service
 * @param {library} _ The Lodash library
 */
function CollectorController($scope, $rootScope, Collector, Auth, AlertMessages, Session, CheckUsername, AUTH_EVENTS, NOTIFICATIONS, Notification, _) {
  var vm = this;

  // Public methods
  vm.checkUsername = checkUsername;
  vm.verifyEmail = verifyEmail;

  // Defaults
  vm.updateProfile = updateProfile;

  // Define the profile object from the Collector
  vm.collector = _.cloneDeep(Session.collector);
  vm.collectorCompare = Session.collector;

  var deregister = $rootScope.$on(AUTH_EVENTS.collectorUpdated, function () {
    vm.collector = _.cloneDeep(Session.collector);
  });
  $scope.$on('$destroy', deregister);

  /**
   * @name updateProfile
   * @description Function to update the collector object
   * @param {number} imageId The ID of the profile photo
   */
  function updateProfile(imageId) {
    var _collector = vm.collector;
    if (!_.isUndefined(imageId)) {
      _collector.profile_photo = imageId;
    }

    // Check if the current email address has been changed. If so, set the
    // email_is_confirmed field to false
    if (vm.collector.email !== vm.collectorCompare.email) {
      _collector.email_is_confirmed = false;
      _collector.new_email = vm.collector.email;
      _collector.email = vm.collectorCompare.email;
    }
    Collector.updateProfile(_collector).then(function (updatedCollector) {
      if (updatedCollector) {
        vm.collector = _.cloneDeep(updatedCollector);
        vm.collectorCompare = _.cloneDeep(updatedCollector);
        Auth.updateSession();
        AlertMessages.add({
          msg: 'We saved your profile.',
          type: 'success'
        });

        // Send the confirm email notification, if needed
        if (updatedCollector.email_is_confirmed === false) {
          verifyEmail(updatedCollector);
        }
      }
    }, function (messages) {
      AlertMessages.add({ msg: 'We tried to update your profile, but something went wrong.',
        type: 'warning' });
    });
  }

  /**
   * @name verifyEmail
   * @description description
   * @param {type} collector The collector to verify email for
   */
  function verifyEmail(collector) {
    var confirmEmailNotification = {
      recipients: [collector.id],
      notificationId: NOTIFICATIONS.emailConfirmation,
      messageObjects: {
        collectorId: collector.id
      },
      messageVariables: {
        subject: 'Action required: please verify your email address'
      }
    };
    Notification.send(confirmEmailNotification);
  }

  /**
   * @name checkUsername
   * @description Function to check it a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username, Session.collector.username).then(function (results) {
      vm.usernameResults = results;
    });
  }
}

angular.module('inkfinder').controller('CollectorController', CollectorController);

/***/ }),

/***/ "./components/collector/collector.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _setIfExists = __webpack_require__("./utils/set-if-exists.js");

var _setIfExists2 = _interopRequireDefault(_setIfExists);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('inkfinder').factory('Collector', ['$q', '$rootScope', '$state', '$http', '$interval', 'ENDPOINT', 'Association', 'moment', 'AlertMessages', 'Session', 'Shop', '_', function Collector($q, $rootScope, $state, $http, $interval, ENDPOINT, Association, moment, AlertMessages, Session, Shop, _) {
  // Public functions
  Collector.refreshProfile = refreshProfile;
  Collector.updateProfile = updateProfile;
  Collector.updateCollector = updateCollector;
  Collector.searchCollectors = searchCollectors;
  Collector.createCollector = createCollector;
  Collector.getCollector = getCollector;
  Collector.getCollectors = getCollectors;

  var qwe = void 0;
  resetVariables();

  /**
    * @description
    * Reset variables
    */
  function resetVariables() {
    qwe = { profile: {} };
    Collector.profile = {};
  }

  /**
    * @description
    * Called to Reset Data on Logout
    */
  var deregister = $rootScope.$on('clear-data', function () {
    $interval.cancel(qwe.profile.timer);
    resetVariables();
  });
  $rootScope.$on('$destroy', deregister);

  /**
    * @description
    * Create a new profile timing for polling
    */
  function createProfileTimer() {
    if (!qwe.profile.timer) {
      qwe.profile.timer = $interval(makeNewProfilePromise, 1000);
    }
  }

  /**
    * @description
    * make a new profile promise for caching
    */
  function makeNewProfilePromise() {
    if (!shouldRefresh()) {
      return;
    }

    qwe.profile.promise = $q(function (resolve, reject) {
      qwe.profile.refreshing = true;
      $http.get(ENDPOINT.server + 'collectors/api/v1.1/').then(function (response) {
        if (qwe.profile.timer) {
          parseProfile(response.data).then(function (profile) {
            profile.messages = {};
            Collector.profile = profile;
            qwe.profile.updated = moment();
            Session.updateCollector(Collector.profile);
            resolve(Collector.profile);
          });
        }
        qwe.profile.refreshing = false;
      }, function (error) {
        reject(error);
      });
    });
  }

  /**
    * @description
    * Unknown
    * @return {function} Unknown
    */
  function shouldRefresh() {
    return !qwe.profile.refreshing && (!qwe.profile.updated || moment().diff(qwe.profile.updated, 'seconds') >= 67);
  }

  /**
    * @description
    * Unknown
    * @return {function} Unknown
    */
  function fetchProfile() {
    createProfileTimer();
    makeNewProfilePromise();
    return qwe.profile.promise;
  }

  /**
    * @description
    * Unknown
    * @return {function} Unknown
    */
  function refreshProfile() {
    qwe.profile.updated = null;
    return fetchProfile();
  }

  /**
    * @description
    * Unknown
    * @param {unknown} input Unknown
    * @return {function} Unknown
    */
  function updateProfile(input) {
    var profile = formatProfile(input);
    return $http.put(ENDPOINT.server + 'collectors/api/v1.1/', profile).then(function (response) {
      return parseProfile(response.data).then(function (profile) {
        Collector.profile = profile;
        Session.updateCollector(profile);
        return profile;
      });
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @description
  * Unknown
  * @param {unknown} collector The collector to update
  * @return {function} Unknown
  */
  function updateCollector(collector) {
    var formattedCollector = formatProfile(collector);
    return $http.put(ENDPOINT.server + 'collectors/api/v1.1/', formattedCollector).then(function (collector) {
      AlertMessages.add({
        msg: 'We saved this profile.',
        type: 'success'
      });
      return collector;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
    * @description
    * Formats the collector object
    * @param {object} input The raw collector object
    * @return {object} The formatted collector object
    */
  function formatProfile(input) {
    var output = {};

    if (input) {
      (0, _setIfExists2.default)(input, 'id', output);
      (0, _setIfExists2.default)(input, 'username', output);
      (0, _setIfExists2.default)(input, 'first_name', output);
      (0, _setIfExists2.default)(input, 'last_name', output);
      (0, _setIfExists2.default)(input, 'phone', output);
      (0, _setIfExists2.default)(input, 'email', output);
      (0, _setIfExists2.default)(input, 'new_email', output);
      (0, _setIfExists2.default)(input, 'is_new_user', output);
      (0, _setIfExists2.default)(input, 'profile_photo', output);
      (0, _setIfExists2.default)(input, 'accepted_TOS_Privacy', output);
      (0, _setIfExists2.default)(input, 'email_is_confirmed', output);
      (0, _setIfExists2.default)(input, 'calendar_compact', output);
      (0, _setIfExists2.default)(input, 'calendar_skinny', output);
    }
    return output;
  }

  /**
    * @description
    * Parse the collector object
    * @param {object} input The collector object to be parsed
    * @return {object} input returns the parsed collector object
    */
  function parseProfile(input) {
    return Association.getAssociation(input.id).then(function (associations) {
      input.associations = associations;
      return input;
    });
  }

  /**
    * @description
    * Search collectors
    * @param {string} query The email or phone number to search
    * @param {string} searchFields The fields to perform the search over
    * @return {object} Returns a promise object?
    */
  function searchCollectors(query, searchFields) {
    var url = ENDPOINT.server + 'collectors/api/v1.1/all/?q=' + query + '&searchFields=' + searchFields;
    return $http.get(url).then(function (response) {
      var parsedCollectors = response.data.map(function (collector) {
        return parseProfile(collector);
      });
      return $q.all(parsedCollectors);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
    * @description
    * Create collector
    * @param {object} collector The details for the collector
    * @return {object} Returns a promise object?
    */
  function createCollector(collector) {
    var url = ENDPOINT.server + 'collectors/api/v1.1/';
    return $q(function (resolve, reject) {
      $http.post(url, collector).then(function (response) {
        resolve(response.data);
      }, function (error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
        reject(error);
      });
    });
  }

  /**
   * @description
   * Get collector
   * @param {object} id The ID of the collector to retrieve
   * @return {object} Returns a promise object?
   */
  function getCollector(id) {
    var url = ENDPOINT.server + 'collectors/api/v1.1/' + id + '/';
    return $http.get(url).then(function (response) {
      return parseProfile(response.data);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getCollectors
   * @description Function to get an array of collectors based on URL params
   * @param {object} username The username of the collector to filter by
   * @return {array} Returns an array of collectors. The array will be empty if
   * the filters exclude any results.
   */
  function getCollectors(username) {
    var url = ENDPOINT.server + 'collectors/api/v1.1/?';
    if (!_.isUndefined(username)) {
      url += 'username=' + username;
    }
    return $http.get(url).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Collector;
}]);

/***/ }),

/***/ "./components/collector/collector.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=profile class=\"section photo background-dark\"> <div class=background-photo></div> <div class=container> <div class=row> <div class=col-sm-12> <div class=\"intro center\"> <h1>Your settings</h1> <h5>Get your groove on.</h5> <ink-profile-photo linkable=true editable=true profile=$ctrl.collector image-id=$ctrl.collector.profile_photo on-change=$ctrl.updateProfile(imageId)> </ink-profile-photo> </div> </div> </div> <div class=row> <div class=\"col-sm-12 sub-nav\"> <ul class=nav-tabs> <li class=sub-nav-tab ui-sref=inkfinder.collector.update ui-sref-active=active><a>General</a></li> <li class=sub-nav-tab ui-sref=inkfinder.collector.password ui-sref-active=active><a>Password</a></li> <li class=sub-nav-tab ui-sref=inkfinder.collector.connections ui-sref-active=active><a>Connections</a></li> </ul> </div> <div class=col-sm-12 class=fade-view ui-view=base></div> </div> </div> </div> ";

/***/ }),

/***/ "./components/collector/connections/connections.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkCollectorConnections = {
  require: {
    parent: '^inkCollector'
  },
  controller: 'ProfileConnectionsController',
  template: __webpack_require__("./components/collector/connections/connections.template.html")
};

angular.module('inkfinder').component('inkCollectorConnections', inkCollectorConnections);

/***/ }),

/***/ "./components/collector/connections/connections.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ProfileConnectionsController.$inject = ['Collector'];


/**
 * @name ProfileConnectionsController
 * @param {service} Collector Service for profile
 */
function ProfileConnectionsController(Collector) {
  var vm = this;
  vm.refreshAssociations = refreshAssociations;

  /**
   * @name refreshAssociations
   * @description Function to get a list of associations for the collector
   */
  function refreshAssociations() {
    Collector.refreshProfile().then(function () {
      vm.allAssociations = Collector.profile.associations;
    });
  }

  // Get fresh assocaitions
  refreshAssociations();
}

angular.module('inkfinder').controller('ProfileConnectionsController', ProfileConnectionsController);

/***/ }),

/***/ "./components/collector/connections/connections.template.html":
/***/ (function(module, exports) {

module.exports = " <h4>Your artist connections</h4> <ink-associations-list associations=$ctrl.allAssociations.artists.confirmed title=\"'Active connections'\" edit=$ctrl.edit(association) on-change=$ctrl.refreshAssociations() type=\"'artist'\"> </ink-associations-list> <ink-associations-list associations=$ctrl.allAssociations.artists.invited title=\"'Invited connections'\" decline=$ctrl.decline(association) accept=$ctrl.accept(association) on-change=$ctrl.refreshAssociations() type=\"'artist'\"> </ink-associations-list> <div class=\"divider small transparent\"></div> <div class=\"divider small loose\"></div> <h4>Your operator connections</h4> <ink-associations-list associations=$ctrl.allAssociations.operators.confirmed title=\"'Active connections'\" edit=$ctrl.edit(association) on-change=$ctrl.refreshAssociations() type=\"'operator'\"> </ink-associations-list> <ink-associations-list associations=$ctrl.allAssociations.operators.invited title=\"'Invited connections'\" decline=$ctrl.decline(association) accept=$ctrl.accept(association) on-change=$ctrl.refreshAssociations() type=\"'operator'\"> </ink-associations-list> ";

/***/ }),

/***/ "./components/collector/connections/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/connections/connections.component.js");

__webpack_require__("./components/collector/connections/connections.controller.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.collector.connections', {
    url: '/connections',
    views: {
      'base@inkfinder.collector': {
        component: 'inkCollectorConnections'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Your connections';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/collector/create/create.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkCollectorCreate = {
  template: __webpack_require__("./components/collector/create/create.template.html")
};

angular.module('inkfinder').component('inkCollectorCreate', inkCollectorCreate);

/***/ }),

/***/ "./components/collector/create/create.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),

/***/ "./components/collector/create/create.template.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"intro center\"> <h1>Create an account.</h1> </div> <div class=row> <div class=\"col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 center\"> <form name=createCollector class=left ng-submit=\"createCollector.$valid && $ctrl.createCollector()\" novalidate> <div class=form-group> <label for=first_name>First name</label> <input name=first_name id=first_name type=text class=form-control placeholder=Darth required ng-model=$ctrl.newCollector.first_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.first_name.$invalid && !createCollector.first_name.$pristine\"> We need a first name! </p> </div> </div> <div class=form-group> <label for=last_name>Last name</label> <input name=last_name id=last_name type=text class=form-control placeholder=Vader required ng-model=$ctrl.newCollector.last_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.last_name.$invalid && !createCollector.last_name.$pristine\"> We need a last name! </p> </div> </div> <div class=form-group> <label for=email>Email</label> <input name=email id=email type=email class=form-control placeholder=vader@deathstar.com required ng-model=$ctrl.newCollector.email> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.email.$invalid && !createCollector.email.$pristine\"> Hmm...I don’t think that's a real email address. </p> </div> </div> <div class=form-group> <label for=phone>Phone <small>Optional</small></label> <input name=phone id=phone placeholder=\"(555) 555–1234\" mask=\"(999) 999-9999\" clean=true restrict=reject type=text ng-model=$ctrl.newCollector.phone> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.phone.$invalid && !createCollector.phone.$pristine\"> You won’t be talking to anyone with that number. </p> </div> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=createCollector.$invalid>Create account</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.startOver(true)>Start Over</button> </div> </form> </div> </div> ";

/***/ }),

/***/ "./components/collector/create/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/create/create.component.js");

__webpack_require__("./components/collector/create/create.controller.js");

/***/ }),

/***/ "./components/collector/email-confirmation/_email-confirmation.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510664
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/collector/email-confirmation/email-confirmation.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkEmailConfirmation = {
  controller: 'EmailConfirmationController',
  template: __webpack_require__("./components/collector/email-confirmation/email-confirmation.template.html"),
  bindings: {
    token: '<',
    response: '<'
  }
};

angular.module('inkfinder').component('inkEmailConfirmation', inkEmailConfirmation);

/***/ }),

/***/ "./components/collector/email-confirmation/email-confirmation.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


EmailConfirmationController.$inject = ['$stateParams'];


/**
 * @description Controller for the email confirmation workflow
 * @param {Angular} $stateParams The $stateParams service
 * @param {service} EmailConfirmation The EmailConfirmation service
 */
function EmailConfirmationController($stateParams) {
  var vm = this;

  vm.$onInit = function () {
    if (vm.response && vm.response.status) {
      vm.emailIsConfirmed = false;
    } else {
      vm.collector = vm.response;
      vm.emailIsConfirmed = true;
    }
  };
}

angular.module('inkfinder').controller('EmailConfirmationController', EmailConfirmationController);

/***/ }),

/***/ "./components/collector/email-confirmation/email-confirmation.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('EmailConfirmation', ['$http', 'ENDPOINT', function EmailConfirmation($http, ENDPOINT) {
  // Public functions
  EmailConfirmation.get = get;

  /**
   * @description Update the email_is_confirmed field by sending the
   * email_confirmation_token
   * @param {string} token The token to determine the collector to update
   * @return {object} Returns the collector
   */
  function get(token) {
    return $http.get(ENDPOINT.server + 'collectors/api/v1.1/email/confirmation/?email_confirmation_token=' + token).then(function (response) {
      return response.data;
    }, function (error) {
      return error;
    });
  }
  return EmailConfirmation;
}]);

/***/ }),

/***/ "./components/collector/email-confirmation/email-confirmation.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"email-confirmation no-sidebar section first last background-dark\"> <div class=background-photo></div> <div class=region-header> <div class=container> <div class=row> <div class=\"col-sm-12 center\"> <span class=\"logo finder full-logo\"></span> </div> </div> </div> </div> <div class=container-fluid> <div class=row> <div class=\"col-sm-6 col-sm-offset-3 center\" ng-if=$ctrl.emailIsConfirmed> <div class=intro> <h1>Your email is confirmed.</h1> <div ng-if=$ctrl.collector.profile_photo> <ink-profile-photo type=$ctrl.association.type.toLowerCase() profile=$ctrl.collector image-id=$ctrl.collector.profile_photo> </ink-profile-photo> </div> <div class=\"button-container margin\"> <a ui-sref=login class=\"button large finder-solid\">Sign in</a> </div> </div> </div> <div class=\"col-sm-6 col-sm-offset-3 center\" ng-if=!$ctrl.emailIsConfirmed> <div class=intro> <h1>Sorry, charlie.</h1> <h6>Your email has not been confirmed.</h6> <p> <button ui-sref=inkfinder.collector.update class=\"button small finder-solid\"> Try again </button> </p> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/collector/email-confirmation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/email-confirmation/email-confirmation.component.js");

__webpack_require__("./components/collector/email-confirmation/email-confirmation.controller.js");

__webpack_require__("./components/collector/email-confirmation/email-confirmation.service.js");

__webpack_require__("./components/collector/email-confirmation/_email-confirmation.styles.scss");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('email-confirmation', {
    url: '/email-confirmation?token',
    views: {
      '@': {
        component: 'inkEmailConfirmation'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Email confirmation';
      },
      response: ['EmailConfirmation', '$stateParams', function response(EmailConfirmation, $stateParams) {
        return EmailConfirmation.get($stateParams.token).then(function (response) {
          return response;
        });
      }]
    }
  });
}]);

/***/ }),

/***/ "./components/collector/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/account-alerts/index.js");

__webpack_require__("./components/collector/add/index.js");

__webpack_require__("./components/collector/associations/index.js");

__webpack_require__("./components/collector/collector-bar/index.js");

__webpack_require__("./components/collector/collector-list/index.js");

__webpack_require__("./components/collector/connections/index.js");

__webpack_require__("./components/collector/create/index.js");

__webpack_require__("./components/collector/email-confirmation/index.js");

__webpack_require__("./components/collector/notification-prefs/index.js");

__webpack_require__("./components/collector/profile-photo/index.js");

__webpack_require__("./components/collector/update/index.js");

__webpack_require__("./components/collector/update-password/index.js");

__webpack_require__("./components/collector/util/check-username.service.js");

__webpack_require__("./components/collector/collector-association.data.js");

__webpack_require__("./components/collector/collector.component.js");

__webpack_require__("./components/collector/collector.controller.js");

__webpack_require__("./components/collector/collector.service.js");

__webpack_require__("./components/collector/_collector.styles.scss");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.collector', {
    url: '/profile',
    abstract: true,
    views: {
      '@': {
        component: 'inkCollector'
      }
    }
  });
}]);

/***/ }),

/***/ "./components/collector/notification-prefs/collector-wants-notif.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

collectorWantsNotif.$inject = ['Association', 'ArtistNotificationPrefs', 'OperatorNotificationPrefs'];


/**
 * @name collectorWantsNotif
 * @description Function to check to see if a collector wants a notification
 * @param {type} Association The Association service
 * @param {type} ArtistNotificationPrefs The ArtistNotificationPrefs service
 * @param {type} OperatorNotificationPrefs The OperatorNotificationPrefs service
 * @return {service} Returns the service
 */
function collectorWantsNotif(Association, ArtistNotificationPrefs, OperatorNotificationPrefs) {
  // Public methods
  collectorWantsNotif.check = check;

  /**
   * @name check
   * @description Function to check if the username is available
   * @param {number} collectorId The collector to check the notification
   * @param {number} shopId The shop to find the correct association
   * @param {number} notificationPref The name of the notification pref to check
   * @param {number} notifType The type of notification to check. Can be either
   * 'artist', 'operator', or 'collector'
   * @return {boolean} Returns the answer
   */
  function check(collectorId, shopId, notificationPref, notifType) {
    /**
     * @name getAssociation
     * @description Function to get a collector association
     * @param {number} collectorId Description
     * @return {boolean} Returns a boolean value
     */
    function getAssociation(collectorId) {
      return Association.getAssociation(collectorId).then(function (associations) {
        var artistAssociation = _lodash2.default.find(associations.artists.confirmed, function (el) {
          if (shopId === el.shop.id) {
            return true;
          }
        });
        return artistAssociation;
      });
    }

    /**
     * @name getNotifPrefs
     * @description description
     * @param {type} artistAssociation Description
     * @return {boolean} Returns a boolean value
     */
    function getNotifPrefs(artistAssociation) {
      if (notifType === 'artist') {
        return ArtistNotificationPrefs.get(artistAssociation.artistNotificationPreference).then(function (prefs) {
          return prefs;
        });
      } else if (notifType === 'operator') {
        return OperatorNotificationPrefs.get(artistAssociation.operatorNotificationPreference).then(function (prefs) {
          return prefs;
        });
      }
    }

    /**
     * @name findNotif
     * @description description
     * @param {object} prefs The notification prefs
     * @return {boolean} Returns a boolean value
     */
    function findNotif(prefs) {
      return prefs[notificationPref];
    }

    return getAssociation(collectorId).then(getNotifPrefs).then(findNotif);

    // Add a catch statement above to bubble up errors
  }
  return collectorWantsNotif;
}

angular.module('inkfinder').factory('collectorWantsNotif', collectorWantsNotif);

/***/ }),

/***/ "./components/collector/notification-prefs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/notification-prefs/collector-wants-notif.service.js");

/***/ }),

/***/ "./components/collector/profile-photo/_profile-photo.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510654
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/collector/profile-photo/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/profile-photo/profile-photo.component.js");

__webpack_require__("./components/collector/profile-photo/profile-photo.controller.js");

__webpack_require__("./components/collector/profile-photo/_profile-photo.styles.scss");

/***/ }),

/***/ "./components/collector/profile-photo/profile-photo.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkProfilePhoto = {
  bindings: {
    imageId: '<',
    editable: '<',
    type: '<?',
    size: '<?',
    selectable: '<',
    locked: '<',
    showName: '<',
    showEmailConfirmation: '<',
    profile: '<',
    deletable: '<',
    linkable: '<',
    selected: '<',
    invited: '<',
    rightMargin: '<',
    click: '&',
    onChange: '&'
  },
  controller: 'ProfilePhotoController',
  template: __webpack_require__("./components/collector/profile-photo/profile-photo.template.html")
};

angular.module('inkfinder').component('inkProfilePhoto', inkProfilePhoto);

/***/ }),

/***/ "./components/collector/profile-photo/profile-photo.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ProfilePhotoController.$inject = ['_', '$log', '$uibModal', 'InkImage', 'AlertMessages', 'RESPONSE_MESSAGES', 'Session', '$rootScope', '$scope'];


/**
 * @name NewProfilePhotoController
 * @description Controller for profile photos
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 * @param {Unknown} $uibModal Bootstrap modal service
 * @param {Unknown} InkImage The InkImage service
 * @param {Unknown} AlertMessages The Alert Messages service
 * @param {Unknown} RESPONSE_MESSAGES The Response Messages constant
 * @param {object} Session The Session service
 * @param {object} $rootScope The Angular $rootScope service
 * @param {object} $scope The Angular $scope service
 */
function ProfilePhotoController(_, $log, $uibModal, InkImage, AlertMessages, RESPONSE_MESSAGES, Session, $rootScope, $scope) {
  var vm = this;
  vm.$onInit = function () {
    vm.openCropModal = openCropModal;
    vm.toggleDropdown = toggleDropdown;
    vm.remove = remove;
    vm.newImageFile = '';
    vm.size = _.isUndefined(vm.size) ? 'large' : vm.size;
    vm.type = _.isUndefined(vm.type) ? 'collector' : vm.type;
    vm.showName = _.isUndefined(vm.showName) ? true : vm.showName;
    vm.status = {
      isopen: false
    };
  };

  vm.$onChanges = function (updates) {
    if (!_.isUndefined(updates.imageId) && !_.isUndefined(updates.imageId.currentValue) && updates.imageId.currentValue !== null) {
      InkImage.get(_.isObject(updates.imageId.currentValue) ? updates.imageId.currentValue.id : updates.imageId.currentValue).then(function (image) {
        vm.imageId = image.id;
        vm.image = image;
      });
    } else if (!_.isUndefined(updates.imageId) && !_.isUndefined(updates.imageId.currentValue) && updates.imageId.currentValue === null) {
      vm.imageId = null;
      vm.image = null;
    }
  };

  /**
   * @name toggleDropdown
   * @description Function to open/close the dropdown menu
   * @param {type} $event Description
   */
  function toggleDropdown($event) {
    $event.preventDefault();
    $event.stopPropagation();
    vm.status.isopen = !vm.status.isopen;
  }

  /**
   * @name openCropModal
   * @description Function to open the crop modal after selecting a new image
   * @param {unknown} image The image to pass to the modal
   */
  function openCropModal(_image) {
    if (_image !== null) {
      var modalInstance = $uibModal.open({
        component: 'inkImageCrop',
        animation: true,
        backdrop: 'static',
        resolve: {
          image: function image() {
            return _image;
          }
        }
      });
      modalInstance.result.then(function (newImage) {
        if (vm.imageId === null || _.isUndefined(vm.imageId)) {
          InkImage.add(newImage).then(function (savedImage) {
            vm.onChange({ imageId: savedImage.id });
            vm.image = savedImage;
          });
        } else {
          InkImage.update(vm.imageId, newImage).then(function (savedImage) {
            vm.onChange({ imageId: savedImage.id });
            vm.image = savedImage;
            $rootScope.$broadcast('refresh-image', savedImage.id, vm.type);
          });
        }
      }, function () {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      });
    }
  }

  /**
   * @name remove
   * @description Function to remove the profile image
   * @param {number} id The image to remove
   */
  function remove() {
    var file = '';
    InkImage.remove(vm.image.id, file).then(function (image) {
      vm.imageId = null;
      vm.image = null;
      vm.onChange({ imageId: null });
    });
  }

  $scope.$on('refresh-image', function (event, imageId, type) {
    if (type === vm.type) {
      InkImage.get(imageId).then(function (image) {
        vm.imageId = image.id;
        vm.image = image;
      });
    }
  });
}

angular.module('inkfinder').controller('ProfilePhotoController', ProfilePhotoController);

/***/ }),

/***/ "./components/collector/profile-photo/profile-photo.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=profile-photo-wrapper ng-class=\"{'margin': $ctrl.rightMargin}\"> <div uib-dropdown is-open=$ctrl.status.isopen id=edit-menu class=\"profile-photo {{$ctrl.type}}\" ng-class=\"{\n      'default': !$ctrl.image-id,\n      'link': $ctrl.linkable === true,\n      'delete': $ctrl.deletable === true,\n      'edit': $ctrl.editable === true,\n      'invited': $ctrl.invited,\n      'select': $ctrl.selectable === true,\n      'selected': $ctrl.selected === true,\n      'locked': $ctrl.locked === true,\n      'xxlarge': $ctrl.size === 'xxlarge',\n      'xlarge': $ctrl.size === 'xlarge',\n      'large': $ctrl.size === 'large',\n      'standard': $ctrl.size === 'standard',\n      'small': $ctrl.size === 'small',\n      'xsmall': $ctrl.size === 'xsmall'\n    }\" tooltip-trigger=\"'none'\" tooltip-placement=bottom tooltip-is-open=$ctrl.invited tooltip-append-to-body=true tooltip-class=light uib-tooltip=\"{{$ctrl.profile.first_name}} has already been invited.\" ng-click=\"!$ctrl.locked && $ctrl.click()\"> <div class=profile-photo-image uib-dropdown-toggle ng-style=\"{'background-image': 'url(' + ($ctrl.image.image_341 ? $ctrl.image.image_341 : '')  + ')'}\" ng-disabled=!$ctrl.editable> </div> <ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=edit-menu> <li> <a ngf-select ngf-resize=\"{width: 500, quality: .8, type: 'image/jpeg', pattern='.jpg'}\" ngf-change=$ctrl.openCropModal($file) ngf-fix-orientation=true ngf-resize=\"{width: 800, height: 800, quality: .8, type: 'image/jpeg',\n               ratio: '1:2', centerCrop: true, pattern='.jpg'}\" ngf-resize-if=\"$width > 800 || $height > 800\" accept=image/*> Upload image </a> </li> <li ng-if=$ctrl.image><a ng-click=$ctrl.remove()>Remove</a></li> <li><a ng-click=$ctrl.toggleDropdown($event)>Cancel</a></li> </ul> <fa name=check class=icon></fa> <fa name=pencil class=icon ng-if=\"$ctrl.editable === true\" ng-cloak></fa> <fa name=lock ng-if=$ctrl.locked></fa> <fa name=exclamation-triangle fw class=\"alert-color email-confirmed-alert\" ng-if=\"!$ctrl.profile.email_is_confirmed && $ctrl.showEmailConfirmation\" tooltip-append-to-body=true uib-tooltip=\"Email not verified\" tooltip-placement=top tooltip-class=light> </fa> </div> <p class=\"\" ng-if=$ctrl.showName ng-class=\"{\n    'xlarge-name': $ctrl.size === 'xlarge',\n    'large-name': $ctrl.size === 'large',\n    'standard-name': $ctrl.size === 'standard',\n    'small-name': $ctrl.size === 'small',\n    'xsmall-name': $ctrl.size === 'xsmall'\n  }\"> <small ng-if=\"$ctrl.type !== 'shop'\">{{$ctrl.profile.first_name}} {{$ctrl.profile.last_name}}</small> <small ng-if=\"$ctrl.type === 'shop'\">{{$ctrl.profile.name}}</small> </p> </div> ";

/***/ }),

/***/ "./components/collector/update-password/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/update-password/update-password.component.js");

__webpack_require__("./components/collector/update-password/update-password.controller.js");

__webpack_require__("./components/collector/update-password/update-password.service.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.collector.password', {
    url: '/password',
    views: {
      'base@inkfinder.collector': {
        component: 'inkCollectorUpdatePassword'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Update your password';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/collector/update-password/update-password.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkCollectorUpdatePassword = {
  bindings: {
    collector: '<'
  },
  require: {
    parent: '^inkCollector'
  },
  controller: 'ProfileUpdatePasswordController',
  template: __webpack_require__("./components/collector/update-password/update-password.template.html")
};

angular.module('inkfinder').component('inkCollectorUpdatePassword', inkCollectorUpdatePassword);

/***/ }),

/***/ "./components/collector/update-password/update-password.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ProfileUpdatePasswordController.$inject = ['updatePasswordFactory'];


/**
  * @name ProfileUpdatePasswordController
  * @description Service to send the updated password to the API
  * @param {service} updatePasswordFactory The updatePasswordFactory service
  */
function ProfileUpdatePasswordController(updatePasswordFactory) {
  var vm = this;
  vm.updatePassword = function (password) {
    updatePasswordFactory.updatePassword(password);
  };
}

angular.module('inkfinder').controller('ProfileUpdatePasswordController', ProfileUpdatePasswordController);

/***/ }),

/***/ "./components/collector/update-password/update-password.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('updatePasswordFactory', ['AlertMessages', '$http', 'ENDPOINT', function updatePasswordFactory(AlertMessages, $http, ENDPOINT) {
  // Send your current and new passwords to the server
  updatePasswordFactory.updatePassword = function (request) {
    return $http.post(ENDPOINT.server + 'collectors/api/v1.1/password/change/', {
      current_password: request.current_password,
      password1: request.new_password,
      password2: request.new_password_confirm
    }).then(function (response) {
      AlertMessages.add({
        msg: response.data,
        type: 'success' });
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger' });
    });
  };
  return updatePasswordFactory;
}]);

/***/ }),

/***/ "./components/collector/update-password/update-password.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-inner col-lg-6 col-lg-offset-3 col-sm-8 col-sm-offset-2\"> <h4>Update your password</h4> <div class=\"divider small xtight\"></div> <p>If you signed up with an email address and password, you can change your password here.</p> <form name=updatePasswordForm ng-submit=\"updatePasswordForm.$valid && $ctrl.updatePassword(password)\" novalidate> <p>Enter your current password.</p> <div class=form-group> <input name=current_password type=password placeholder=\"Current password\" class=form-control required ng-minlength=5 ng-model=password.current_password> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updatePasswordForm.current_password.$invalid && !updatePasswordForm.current_password.$pristine\"> Your password is at least 5 characters, yo. </p> </div> </div> <p>Enter your new password.</p> <div class=form-group> <input name=new_password type=password placeholder=\"New password\" class=form-control required ng-minlength=5 ng-model=password.new_password> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updatePasswordForm.new_password.$invalid && !updatePasswordForm.new_password.$pristine\"> Your password needs to be at least 5 characters, yo. </p> </div> </div> <div class=form-group> <input name=new_password_confirm type=password placeholder=\"Confirm new password\" class=form-control compare-to=password.new_password ng-model=password.new_password_confirm> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updatePasswordForm.new_password_confirm.$error.compareTo && !updatePasswordForm.new_password_confirm.$pristine\"> Your passwords don’t match, or they are too short. </p> </div> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=updatePasswordForm.$invalid>Update password</button> </div> </form> </div> ";

/***/ }),

/***/ "./components/collector/update/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/collector/update/update.component.js");

__webpack_require__("./components/collector/update/update.controller.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.collector.update', {
    url: '/update',
    views: {
      'base@inkfinder.collector': {
        component: 'inkCollectorUpdate'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Update your profile';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/collector/update/update.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkCollectorUpdate = {
  require: {
    parent: '^inkCollector'
  },
  controller: 'CollectorUpdateController',
  template: __webpack_require__("./components/collector/update/update.template.html")
};

angular.module('inkfinder').component('inkCollectorUpdate', inkCollectorUpdate);

/***/ }),

/***/ "./components/collector/update/update.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


CollectorUpdateController.$inject = ['Session'];


/**
 * @name CollectorUpdateController
 * @description Controller for the profile update component
 * @param {object} Session The session service
 */
function CollectorUpdateController(Session) {
  var vm = this;
  vm.session = Session;
}

angular.module('inkfinder').controller('CollectorUpdateController', CollectorUpdateController);

/***/ }),

/***/ "./components/collector/update/update.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"content-inner col-lg-6 col-lg-offset-3 col-sm-8 col-sm-offset-2\"> <h4>General info</h4> <div class=\"divider small xtight\"></div> <p>Change your basic account settings.</p> <form name=profileForm ng-submit=\"profileForm.$valid && $ctrl.parent.updateProfile()\" novalidate> <div class=form-group> <label for=username>Username</label> <input name=username id=username type=text class=form-control ng-pattern=/^[a-z0-9]*$/ ng-trim=false ng-model=$ctrl.parent.collector.username ng-model-options=\"{updateOn: 'default blur', debounce: {'default': 500, 'blur': 0}}\" ng-change=$ctrl.parent.checkUsername($ctrl.parent.collector.username)> <div class=\"inline-message relative\"> <p class=\"message error absolute\"> <span ng-if=\"!profileForm.username.$invalid && $ctrl.parent.usernameResults.usernameValid !== null\" ng-class=\"{'shop-color': $ctrl.parent.usernameResults.usernameValid === true, 'alert-color': $ctrl.parent.usernameResults.usernameValid === false}\"> {{$ctrl.parent.usernameResults.usernameCheckMessage}} </span> <span ng-if=\"profileForm.username.$invalid && !profileForm.username.$pristine\" class=alert-color> Use lowercase letters and numbers only </span> </p> </div> </div> <div class=form-group> <label for=first_name>First name</label> <input name=first_name id=first_name type=text class=form-control required ng-model=$ctrl.parent.collector.first_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"profileForm.first_name.$invalid && !profileForm.first_name.$pristine\"> Please enter your first name. </p> </div> </div> <div class=form-group> <label for=first_name>Last name</label> <input name=last_name name=last_name type=text class=form-control required ng-model=$ctrl.parent.collector.last_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"profileForm.last_name.$invalid && !profileForm.last_name.$pristine\"> Please enter your last name. </p> </div> </div> <div class=form-group> <label for=email>Email</label> <input name=email id=email type=email class=form-control required ng-model=$ctrl.parent.collector.email> <p class=\"inline-alert warning\" ng-if=\"$ctrl.parent.collector.email === $ctrl.parent.collectorCompare.email && !$ctrl.parent.collector.email_is_confirmed\"> <small><fa name=exclamation-triangle fw></fa> Your email address has <strong>not been verified</strong>. <a class=\"button small light-solid float-right\" ng-click=$ctrl.parent.verifyEmail($ctrl.parent.collector)>Confirm it now </a></small> </p> <p class=\"inline-alert success\" ng-if=\"$ctrl.parent.collector.email === $ctrl.parent.collectorCompare.email && $ctrl.parent.collector.email_is_confirmed\"> <small><fa name=check fw></fa> Your email is confirmed</small> </p> <p class=\"inline-alert finder\" ng-if=\"$ctrl.parent.collector.email !== $ctrl.parent.collectorCompare.email && (!profileForm.email.$invalid && !profileForm.email.$pristine)\"> <small><fa name=bell fw></fa> An email will be sent to verify this new address</small> </p> <p class=\"inline-alert error\" ng-if=\"profileForm.email.$invalid && !profileForm.email.$pristine\"> <small><fa name=exclamation-triangle fw></fa> Hmm...I don’t think that's a real email address.</small> </p> </div> <div class=form-group> <label for=phone>Phone</label> <input name=phone id=phone type=text class=form-control mask=\"(999) 999-9999\" clean=true ng-model=$ctrl.parent.collector.phone> </div> <div class=\"button-container margin\"> <div> <button class=\"button large finder-solid\" type=submit ng-disabled=\"profileForm.$invalid || $ctrl.parent.usernameResults.usernameValid === false\">Save changes</button> </div> </div> </form> </div> ";

/***/ }),

/***/ "./components/collector/util/check-username.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('CheckUsername', ['Collector', 'Shop', 'Session', '$q', '_', 'RESERVED_ROUTES', function CheckUsername(Collector, Shop, Session, $q, _, RESERVED_ROUTES) {
  // Public methods
  CheckUsername.check = check;

  /**
   * @name check
   * @description Function to check if the username is available
   * @param {string} username The username to check
   * @param {string} currentUsername The existing username to check against
   * @return {object} Returns an object with the usernames array and status
   */
  function check(username, currentUsername) {
    var results = {};
    results.usernameValid = false;
    results.usernameCheckMessage = null;
    if (username && username.match(/^[a-z0-9]*$/)) {
      return $q.all([Collector.getCollectors(username), Shop.getShops(username)]).then(function (usernames) {
        results.usernames = _.merge(usernames[0], usernames[1]);
        if (results.usernames.length === 0 && checkReservedNames(username) !== true) {
          results.usernameValid = true;
          results.usernameCheckMessage = 'Available!';
        } else if (results.usernames.length > 0 && results.usernames[0].username === currentUsername) {
          results.usernameValid = true;
          results.usernameCheckMessage = 'That’s you!';
        } else {
          results.usernameValid = false;
          results.usernameCheckMessage = 'Not available';
        }
        return results;
      });
    }
    return $q(function (resolve, reject) {
      resolve(results);
    });
  }

  /**
   * @name checkReservedNames
   * @description Function to check a constant of reserved names.
   * @param {string} username The name to check against
   * @return {boolean} Returns a boolean
   */
  function checkReservedNames(username) {
    // return _.each(RESERVED_ROUTES, function(route) {
    //   if (route === username) {
    //     return true;
    //   }
    // });
    var value = _.some(RESERVED_ROUTES, function (route) {
      return route === username;
    });
    return value;
  }
  return CheckUsername;
}]);

/***/ }),

/***/ "./components/dashboard/_dashboard.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509154
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/dashboard/dashboard.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkDashboard = {
  controller: 'DashboardController',
  template: __webpack_require__("./components/dashboard/dashboard.template.html")
};

angular.module('inkfinder').component('inkDashboard', inkDashboard);

/***/ }),

/***/ "./components/dashboard/dashboard.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__("../node_modules/angular/index.js");

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @name DashboardController
 * @description description
 */
var DashboardController = function () {
  DashboardController.$inject = ['DashboardData', 'Project', 'Operators', 'ShopHours', 'Artists', 'Session', 'Appointments'];

  /**
   * @name name
   * @description description
   * @param {type} DashboardData Description
   * @param {type} Project Description
   * @param {type} Operators Description
   * @param {type} ShopHours Description
   * @param {type} Artists Description
   * @param {type} Session Description
   * @param {type} Appointments Description
   */
  function DashboardController(DashboardData, Project, Operators, ShopHours, Artists, Session, Appointments) {
    var _this = this;

    _classCallCheck(this, DashboardController);

    this.dashboardData = DashboardData;
    this.project = Project;
    this.operators = Operators;
    this.shopHours = ShopHours;
    this.Artists = Artists;
    this.session = Session;
    this.appointments = Appointments;
    this.isNew = false;
    this.appointmentCount = 0;
    this.shopHourCount = 0;
    this.artistCount = 0;

    if (this.session.activeState.role === 'operator') {
      this.operators.get(this.session.collector.operator.id).then(function (collector) {
        _this.isNew = collector.operator.is_new_user;
        if (_this.isNew) {
          var search = {
            page: 1,
            status: undefined,
            sort: 'appointmentDatetime',
            search: ''
          };
          _this.appointments.get(search).then(function (appointments) {
            _this.appointmentCount = appointments.results.length;
          });

          _this.shopHours.get(_this.session.activeState.association.shop.id).then(function (hours) {
            _this.shopHourCount = hours.all.length;
          });

          _this.Artists.fetchArtists().then(function (artists) {
            _this.artistCount = artists.confirmed.length;
          });
        }
      });
    }
  }

  /**
   * @name closeTutorial
   * @description Close the tutorial screen and update the operator object with
   * is_new_user = false
   */


  _createClass(DashboardController, [{
    key: 'closeTutorial',
    value: function closeTutorial() {
      var _this2 = this;

      this.isNew = false;
      this.operators.get(this.session.collector.operator.id).then(function (collector) {
        collector.operator.is_new_user = false;
        _this2.operators.update(collector.operator);
      });
    }
  }]);

  return DashboardController;
}();

_angular2.default.module('inkfinder').controller('DashboardController', DashboardController);

/***/ }),

/***/ "./components/dashboard/dashboard.data.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _groupByApptStatus = __webpack_require__("./utils/group-by-appt-status.js");

var _groupByApptStatus2 = _interopRequireDefault(_groupByApptStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('inkfinder').factory('DashboardData', ['$q', '$http', '$rootScope', '$interval', 'ENDPOINT', 'Session', 'moment', 'Appointments', 'Shop', 'ScheduleUtilFactory', 'MergeProjects', '_', function DashboardData($q, $http, $rootScope, $interval, ENDPOINT, Session, moment, Appointments, Shop, ScheduleUtilFactory, MergeProjects, _) {
  // Public variables
  DashboardData.data = [];
  DashboardData.merged = [];
  DashboardData.activeAppointmentsCount = 0;

  // Public methods
  DashboardData.get = get;
  DashboardData.refresh = refresh;
  DashboardData.reset = reset;

  // Private variables
  var timer = void 0;
  var refreshing = false;
  var timestamp = void 0;
  var refreshInterval = void 0;

  /**
   * @name refresh
   * @description Function to determine if we should get new data from the API.
   * @param {date} startOfDay Moment object for the start of the shop day.
   * @param {date} endOfDay Moment object for the end of the shop day.
   * @return {promise} Promise Returns a promise so the resolve on the state
   * loads.
   */
  function refresh(startOfDay, endOfDay) {
    return $q(function (resolve, reject) {
      if (shouldRefresh()) {
        resolve(get(startOfDay, endOfDay));
      } else {
        resolve('Load cache');
      }
    });
  }

  /**
   * @name createAppointmentTimer
   * @description Function to create an internal timer and call.
   * @param {date} startOfDay Moment object for the start of the shop day.
   * @param {date} endOfDay Moment object for the end of the shop day.
   * refreshAppointments() at a specific interval.
   */
  function createAppointmentTimer(startOfDay, endOfDay) {
    timer = $interval(function () {
      refresh(startOfDay, endOfDay);
    }, 1000);
  }

  /**
   * @name shouldRefresh
   * @description Unknown
   * @return {boolean} Returns true/false depending on refreshing and updated
   */
  function shouldRefresh() {
    var result = void 0;
    var isNotRefreshing = !refreshing;
    var now = moment();
    var isTime = !refreshInterval || now.diff(refreshInterval, 'seconds') >= 7;
    result = isNotRefreshing && isTime;
    return result;
  }

  /**
   * @name get
   * @description Function to get appointments.
   * @param {date} startOfDay Moment object for the start of the shop day.
   * @param {date} endOfDay Moment object for the end of the shop day.
   * @return {empty} Empty Returns without sending data.
   */
  function get(startOfDay, endOfDay) {
    refreshing = true;
    var search = false;
    var _timestamp = null;
    if (timestamp) {
      _timestamp = timestamp.format('X');
    }
    return Appointments.get(search, startOfDay, endOfDay, _timestamp).then(function (appointments) {
      refreshing = false;
      refreshInterval = moment();
      if (appointments.length > 0) {
        return MergeProjects.merge(appointments).then(function (mergedData) {
          DashboardData.merged = _.unionBy(mergedData, DashboardData.merged, function (data) {
            return data.appointment.id;
          });
          DashboardData.data = (0, _groupByApptStatus2.default)(DashboardData.merged);
          if (DashboardData.data.confirmed) {
            DashboardData.activeAppointmentsCount = DashboardData.data.confirmed.length;
          }
          if (DashboardData.data.completed) {
            DashboardData.activeAppointmentsCount += DashboardData.data.completed.length;
          }
          timestamp = moment();
          if (!timer) {
            createAppointmentTimer(startOfDay, endOfDay);
          }
        });
      }
    });
  }

  var deregister = $rootScope.$on('clear-data', reset);
  $rootScope.$on('$destroy', deregister);

  /**
   * @name reset
   * @description Reset variables
   */
  function reset() {
    DashboardData.data = [];
    DashboardData.merged = [];
    DashboardData.activeAppointmentsCount = 0;
    $interval.cancel(timer);
    refreshing = false;
    refreshInterval = null;
    timestamp = null;
  }
  return DashboardData;
}]);

/***/ }),

/***/ "./components/dashboard/dashboard.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=dashboard class=\"section photo background-dark\"> <div class=background-photo></div> <div class=container-fluid> <div class=\"row animate fade-in fade-out\" ng-if=!$ctrl.isNew> <div class=\"col-md-8 col-md-offset-2\"> <ink-account-alerts></ink-account-alerts> <div class=\"intro center\"> <h1>Hello, {{$ctrl.session.collector.first_name}}.</h1> <h5> <span ng-if=\"$ctrl.session.activeState.role === 'operator'\"> {{$ctrl.session.activeState.association.shop.name}} has </span> <span ng-if=\"$ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'collector'\"> You have </span> <ng-pluralize count=$ctrl.dashboardData.activeAppointmentsCount when=\"{'0': 'no appointments today. Those jerks.',\n              'one': '1 active appointment today. Wonder who?',\n              'other': '{} active appointments today. You badass.'}\"> </ng-pluralize> </h5> </div> </div> <ink-artist-stats ng-if=\"$ctrl.session.activeState.role === 'artist'\"></ink-artist-stats> <div class=\"col-sm-12 no-padding\"> <div class=\"list projects relative\"> <div ng-if=\"$ctrl.dashboardData.data.confirmed.length > 0\"> <h6>Confirmed appointments</h6> <a class=\"item project link {{card.appointment.last_status.status_name | lowercase}}\" ui-sref=inkfinder.appointments.details({appointment_id:card.appointment.id}) ng-repeat=\"card in $ctrl.dashboardData.data.confirmed | orderBy:'appointment.start' track by card.appointment.id\"> <ink-project-card card=card></ink-project-card> </a> </div> <div ng-if=\"$ctrl.dashboardData.data.unconfirmed.length > 0\"> <h6>Unconfirmed appointments</h6> <a class=\"item project link {{card.appointment.last_status.status_name | lowercase}}\" ui-sref=inkfinder.appointments.details({appointment_id:card.appointment.id}) ng-repeat=\"card in $ctrl.dashboardData.data.unconfirmed | orderBy:'appointment.start' track by card.appointment.id\"> <ink-project-card card=card></ink-project-card> </a> </div> <div ng-if=\"$ctrl.dashboardData.data.completed.length > 0\"> <h6>Completed appointments</h6> <a class=\"item project link {{card.appointment.last_status.status_name | lowercase}}\" ui-sref=inkfinder.appointments.details({appointment_id:card.appointment.id}) ng-repeat=\"card in $ctrl.dashboardData.data.completed | orderBy:'appointment.start' track by card.appointment.id\"> <ink-project-card card=card></ink-project-card> </a> </div> <div ng-if=\"$ctrl.dashboardData.data.declined.length > 0\"> <h6>Cancelled appointments</h6> <a class=\"item project link {{card.appointment.last_status.status_name | lowercase}}\" ui-sref=inkfinder.appointments.details({appointment_id:card.appointment.id}) ng-repeat=\"card in $ctrl.dashboardData.data.declined | orderBy:'appointment.start' track by card.appointment.id\"> <ink-project-card card=card></ink-project-card> </a> </div> <div class=\"item project add\" ng-if=\"$ctrl.session.activeState.role === 'operator'\" ui-sref=inkfinder.appointments.add.collector> <div class=project-background> <div class=button-add> <button type=button title=\"Add an appointment\" class=\"button circle\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> <small>Add an appointment</small> </div> </div> </div> <div class=col-sm-12> <div class=\"button-container margin single\"> <button class=\"button finder-solid large\" ui-sref=inkfinder.appointments.days>View Schedule</button> </div> </div> </div> </div> </div> <div class=\"row animate fade-in fade-out\" ng-if=$ctrl.isNew> <div class=col-md-12> <ink-account-alerts></ink-account-alerts> <div class=\"intro center\"> <h1>Hello, sunshine.</h1> <h5>Now that you’re here, let’s begin...</h5> </div> </div> <div class=\"col-md-8 col-md-offset-2\"> <div class=\"tutorial center\"> <h3>Getting started with Ink Finder</h3> <p>There's a few things we’ll need to do to get started. <strong>Ready?</strong></p> <div class=\"tutorial-steps row\"> <div class=\"step col-lg-2 col-md-5 col-sm-5\" ng-class=\"{'incomplete': !$ctrl.shopHourCount, 'complete': $ctrl.shopHourCount,}\"> <a class=\"inner link\" ui-sref=inkfinder.shop.hours> <fa name=clock-o class=icon></fa> <p ng-if=!$ctrl.shopHourCount><small>Add shop hours.</small></p> <p ng-if=$ctrl.shopHourCount><small>Shop hours added!</small></p> </a> <fa name=check class=icon></fa> </div> <div class=col-sm-1> <h2 class=connector>+</h2> </div> <div class=\"step col-lg-2 col-md-5 col-sm-5\" ng-class=\"{'incomplete': !$ctrl.artistCount, 'complete': $ctrl.artistCount}\"> <a class=\"inner link\" ui-sref=inkfinder.artists> <fa name=user-plus class=icon></fa> <p ng-if=!$ctrl.artistCount><small>Add artists.</small></p> <p ng-if=$ctrl.artistCount><small>Artists added!</small></p> </a> <fa name=check class=icon></fa> </div> <div class=col-sm-1> <h2 class=connector>+</h2> </div> <div class=\"step col-lg-2 col-md-5 col-sm-5\" ng-class=\"{'incomplete': !$ctrl.appointmentCount, 'complete': $ctrl.appointmentCount}\"> <a class=\"inner link\" ui-sref=inkfinder.appointments.add.collector> <fa name=pencil class=icon></fa> <p ng-if=!$ctrl.appointmentCount><small>Add appointments.</small></p> <p ng-if=$ctrl.appointmentCount><small>Appointments added!</small></p> </a> <fa name=check class=icon></fa> </div> <div class=col-sm-1> <h2 class=connector>=</h2> </div> <div class=\"step last col-lg-3 col-md-5 col-sm-5\" ng-class=\"{'complete': $ctrl.appointmentCount && $ctrl.artistCount && $ctrl.shopHourCount}\"> <div class=\"inner solid\"> <fa name=beer class=icon></fa> <p><small>Have a cold one.</small></p> </div> </div> </div> <div class=\"button-container margin\" ng-if=\"$ctrl.appointmentCount && $ctrl.artistCount && $ctrl.shopHourCount\"> <button class=\"button medium finder-solid\" ng-click=$ctrl.closeTutorial()>Close tutorial</button> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/dashboard/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/dashboard/dashboard.component.js");

__webpack_require__("./components/dashboard/dashboard.controller.js");

__webpack_require__("./components/dashboard/dashboard.data.js");

__webpack_require__("./components/dashboard/_dashboard.styles.scss");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.dashboard', {
    url: '/dashboard',
    cache: false,
    views: {
      '@': {
        component: 'inkDashboard'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Today';
      },
      dashboardData: ['DashboardData', 'ShopHours', 'ScheduleUtilFactory', 'moment', 'Session', function dashboardData(DashboardData, ShopHours, ScheduleUtilFactory, moment, Session) {
        var startOfDay = void 0;
        var endOfDay = void 0;
        if (Session.activeState.role === 'operator') {
          return ShopHours.get(Session.activeState.association.shop.id).then(function (hours) {
            var shopHours = ScheduleUtilFactory.getShopTimes(hours.all, moment());
            startOfDay = shopHours.earliest.start;
            endOfDay = shopHours.latest.end;
            return DashboardData.refresh(startOfDay, endOfDay);
          });
        }
        startOfDay = moment().startOf('day');
        endOfDay = moment().endOf('day');
        return DashboardData.refresh(startOfDay, endOfDay);
      }]
    },
    data: {
      authorizedRoles: [USER_ROLES.operator, USER_ROLES.artist]
    },
    onEnter: ['Session', 'Events', function onEnter(Session, Events) {
      if (Session.activeState.role === 'artist') {
        Events.artistStatsOpen = true;
      }
    }],
    onExit: ['DashboardData', 'Events', function onExit(DashboardData, Events) {
      DashboardData.reset();
      if (Events.artistStatsOpen) {
        Events.artistStatsOpen = false;
      }
    }]
  });
}]);

/***/ }),

/***/ "./components/events/events.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @name Events
 * @description A simple factory storing events data
 * @return {object} Returns the Events object.
 */
function Events() {
  var Events = this;

  // Defaults
  Events.navSize = 'large';
  Events.chatOpen = false;
  Events.statsOpen = false;
  Events.loggedIn = false;
  Events.loading = false;
  Events.navActive = false;
  Events.secondaryNavActive = false;
  Events.artistStatsOpen = false;
  Events.statsDateRange = 'today';
  Events.newMessagesCount = 0;

  return Events;
}

angular.module('inkfinder').factory('Events', Events);

/***/ }),

/***/ "./components/events/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/events/events.service.js");

/***/ }),

/***/ "./components/file-uploads/_file-uploads.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509215
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/file-uploads/file-uploads.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkFileUpload = {
  controller: 'FileUploadsController',
  template: __webpack_require__("./components/file-uploads/file-uploads.template.html"),
  bindings: {
    images: '<'
  }
};

angular.module('inkfinder').component('inkFileUpload', inkFileUpload);

/***/ }),

/***/ "./components/file-uploads/file-uploads.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


FileUploadsController.$inject = ['InkImage', 'AlertMessages'];


/**
 * @name FileUploadsController
 * @description The controller invoked when editing a project through a modal instance
 * @param {Unknown} InkImage Unknown
 * @param {Unknown} AlertMessages The alert messages service
 */
function FileUploadsController(InkImage, AlertMessages) {
  var vm = this;
  vm.$onInit = function () {
    vm.uploadFile = uploadFile;
    vm.removeFile = removeFile;
  };

  /**
   * @description Upload a File
   * @param {array} files The files to upload
   * @param {array} errFiles Unknown
   * @param {array} uploadArray The array to append uploaded files to
   */
  function uploadFile(files, errFiles, uploadArray) {
    if (errFiles.length > 0) {
      AlertMessages.add({
        msg: 'Sorry, that file won’t work: ' + errFiles[0].$error + ' - ' + errFiles[0].$errorParam,
        type: 'danger'
      });
    } else {
      InkImage.uploadFile(files, errFiles, uploadArray);
    }
  }

  /**
   * @description Remove a File
   * @param {Unknown} index The index of the file to remove
   * @param {file} file the file for the photo to be removed
   * @param {array} uploadArray The array where the file was stored
   */
  function removeFile(index, file, uploadArray) {
    InkImage.deleteImage(file).then(function () {
      uploadArray.splice(index, 1);
    }, function () {
      AlertMessages.add({
        msg: 'There was a problem deleting this image.',
        type: 'danger'
      });
    });
  }
}

angular.module('inkfinder').controller('FileUploadsController', FileUploadsController);

/***/ }),

/***/ "./components/file-uploads/file-uploads.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=row> <div class=\"list uploads\"> <div class=\"col-md-4 col-xs-6\" ng-repeat=\"upload in $ctrl.images track by upload.result.id\"> <div class=\"item upload\"> <uib-progressbar class=\"progress-striped active\" value=upload.progress></uib-progressbar> <div class=\"upload-background delete\" ng-if=upload.result.image_341 ng-style=\"{'background-image':'url(' + upload.result.image_341 + ')'}\" ng-click=\"$ctrl.removeFile($index, upload.result, $ctrl.images)\"> </div> </div> </div> <div class=\"col-md-4 col-xs-6\"> <a class=\"item upload add\" ngf-select=\"$ctrl.uploadFile($files, $invalidFiles, $ctrl.images)\" accept=image/* ngf-max-size=10MB> <button class=button-circle> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> </a> </div> </div> </div> ";

/***/ }),

/***/ "./components/file-uploads/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/file-uploads/file-uploads.component.js");

__webpack_require__("./components/file-uploads/file-uploads.controller.js");

__webpack_require__("./components/file-uploads/_file-uploads.styles.scss");

/***/ }),

/***/ "./components/image/crop-modal/_image-crop-modal.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510254
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/image/crop-modal/croppie.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global Croppie */

angular.module('inkfinder').component('croppie', {
  bindings: {
    src: '<',
    ngModel: '=',
    options: '<'
  },
  controller: ['$scope', '$element', function controller($scope, $element) {
    var ctrl = this;

    var options = angular.extend({
      viewport: {
        width: 200,
        height: 200
      }
    }, ctrl.options);

    options.update = function () {
      c.result('canvas').then(function (img) {
        $scope.$apply(function () {
          ctrl.ngModel = img;
        });
      });
    };

    var c = new Croppie($element[0], options);

    ctrl.$onChanges = function (changesObj) {
      var src = changesObj.src && changesObj.src.currentValue;
      if (src) {
        // bind an image to croppie
        c.bind({
          url: src
        });
      }
    };
  }]
});

/***/ }),

/***/ "./components/image/crop-modal/image-crop-modal.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkImageCrop = {
  bindings: {
    modalInstance: '<',
    resolve: '<',
    close: '&',
    dismiss: '&'
  },
  controller: 'ImageCropModalController',
  template: __webpack_require__("./components/image/crop-modal/image-crop-modal.template.html")
};

angular.module('inkfinder').component('inkImageCrop', inkImageCrop);

/***/ }),

/***/ "./components/image/crop-modal/image-crop-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @name ImageCropModalController
 * @description Function to handle the image crop modal
 * @param {file} resolve The image to crop and save
 */
function ImageCropModalController() {
  var vm = this;

  vm.$onInit = function () {
    vm.cropper = {
      croppedImage: null,
      sourceImage: vm.resolve.image
    };
    vm.rotate = rotate;
    vm.saveCroppedPhoto = saveCroppedPhoto;
  };

  /**
   * @name saveCroppedPhoto
   * @description Function to save the cropped image
   * @param {string} image The base64 image string
   */
  function saveCroppedPhoto(image) {
    vm.close({ $value: image });
  }

  /**
   * @name rotate
   * @description Function to rotate images in the crop modal
   */
  function rotate() {
    // rotateBase64Image(inputImage);
    vm.cropper.sourceImage.rotation += 90; // 90 deg rotation
  }

  vm.cancel = function () {
    vm.dismiss({ $value: 'cancel' });
  };
}

angular.module('inkfinder').controller('ImageCropModalController', ImageCropModalController);

/***/ }),

/***/ "./components/image/crop-modal/image-crop-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=saveCroppedPhotoForm ng-submit=\"saveCroppedPhotoForm.$valid && $ctrl.saveCroppedPhoto($ctrl.cropper.croppedImage)\" novalidate> <div class=modal-header> <h4 class=modal-title>Set your profile photo</h4> </div> <div class=\"modal-body background-light center\"> <croppie src=\"$ctrl.cropper.sourceImage | ngfDataUrl\" ng-model=$ctrl.cropper.croppedImage options=\"{boundary:{width:350,height:300}, enableExif: true, enableOrientation: true}\" result=\"{format: 'jpeg'}\"> </croppie> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/image/crop-modal/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/image/crop-modal/image-crop-modal.component.js");

__webpack_require__("./components/image/crop-modal/image-crop-modal.controller.js");

__webpack_require__("./components/image/crop-modal/croppie.component.js");

__webpack_require__("./components/image/crop-modal/_image-crop-modal.styles.scss");

/***/ }),

/***/ "./components/image/image.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


InkImage.$inject = ['$q', '$rootScope', '$http', '$timeout', 'ENDPOINT', 'Upload', 'AlertMessages', 'Session', '_'];


/**
 * @name InkImage
 * @description The InkImage service. Named InkImage to avoid a conflict over
 * 'Image' with the UI-Bootstrap Lightbox library
 * @param {type} $q Description
 * @param {type} $rootScope Description
 * @param {type} $http Description
 * @param {type} $timeout Description
 * @param {type} ENDPOINT Description
 * @param {type} Upload Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 * @return {type} Returns the service
 */
function InkImage($q, $rootScope, $http, $timeout, ENDPOINT, Upload, AlertMessages, Session, _) {
  InkImage.removeTempFile = removeTempFile;
  InkImage.deleteImage = deleteImage;
  InkImage.uploadFile = uploadFile;
  InkImage.get = get;
  InkImage.add = add;
  InkImage.update = update;
  InkImage.remove = remove;

  /**
   * @name get
   * @description Function to get an image
   * @param {number} id The id of the image to get
   * @return {object} Returns an object of strings representing the URLs of the
   * image
   */
  function get(id) {
    return $http.get(ENDPOINT.server + 'inkutils/api/v1.1/image/' + id + '/').then(function (response) {
      return response.data;
    });
  }

  /**
   * @name add
   * @description Function to add an image
   * @param {file} file The file of the image to update
   * @return {object} Returns an object of strings representing the URLs of the
   * image
   */
  function add(file) {
    return $http.post(ENDPOINT.server + 'inkutils/api/v1.1/image/', { file: file }).then(function (response) {
      return response.data;
    });
  }

  /**
   * @name update
   * @description Function to update an image
   * @param {number} id The id of the image to update
   * @param {unknown} file The file of the image to update
   * @return {object} Returns an object of strings representing the URLs of the
   * image
   */
  function update(id, file) {
    return $http.patch(ENDPOINT.server + 'inkutils/api/v1.1/image/' + id + '/', { file: file }).then(function (response) {
      return response.data;
    });
  }

  /**
   * @name remove
   * @description Function to remove an image
   * @param {number} id The ID of the image to remove
   * @return {object} Returns an empty object to represent an image that's been
   * removed
   */
  function remove(id) {
    var file = '';
    return $http.patch(ENDPOINT.server + 'inkutils/api/v1.1/image/' + id + '/', { file: file }).then(function (response) {
      return response.data;
    });
  }

  /**
   * @description Upload a File
   * @param {Unknown} files Unknown
   * @param {Unknown} errFiles Unknown
   * @param {array} uploadArray Unknown
   */
  function uploadFile(files, errFiles, uploadArray) {
    _.each(files, function (file) {
      uploadArray.push(file);
      file.progress = 0;
      file.upload = Upload.upload({ url: ENDPOINT.server + 'inkutils/api/v1.1/upload/ng-file-upload/', data: { file: file } }).then(function (response) {
        return response.data;
      }, function (error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
        uploadArray.splice(uploadArray.indexOf(file), 1);
        return;
      });

      file.upload.then(function (image) {
        $timeout(function () {
          file.result = image;
        });
      }, function (error) {
        // No error handling here.
      }, function (evt) {
        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total, 10));
      });
    });
  }

  /**
    * @description Remove a temp Image (when creating the project)
    * @param {Unknown} file Unknown
    * @param {array} uploadArray Unknown
    * @param {Unknown} index Unknown
    * @return {none} Returns API call
    */
  function removeTempFile(file, uploadArray, index) {
    return $http.post(ENDPOINT.server + 'inkutils/api/v1.1/delete/tmpimage/', file).then(function (response) {
      uploadArray.splice(index, 1);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
    * @description Remove an Image from a Project
    * @param {Unknown} file Unknown
    * @return {none} Returns API call
    */
  function deleteImage(file) {
    if (!_.isUndefined(file.type)) {
      var url = ENDPOINT.server;
      if (file.type === 'reference') {
        url += 'projects/api/v1.1/referenceimage/' + file.id + '/';
      } else if (file.type === 'coverup') {
        url += 'projects/api/v1.1/coverupimage/' + file.id + '/';
      } else if (file.type === 'completed') {
        url += 'projects/api/v1.1/completedimage/' + file.id + '/';
      }
      var role = Session.activeState.role;
      url += '?role=' + role;
      if (Session.activeState.association) {
        var associationId = Session.activeState.association.id;
        url += '&association_id=' + associationId;
      }
      return $http.delete(url).then(function () {}, function (error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
      });
    }
    return $http.post(ENDPOINT.server + 'inkutils/api/v1.1/delete/tmpimage/', file).then(function () {}, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return InkImage;
}

angular.module('inkfinder').factory('InkImage', InkImage);

/***/ }),

/***/ "./components/image/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/image/crop-modal/index.js");

__webpack_require__("./components/image/image.service.js");

/***/ }),

/***/ "./components/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/account-payments/index.js");

__webpack_require__("./components/activity/index.js");

__webpack_require__("./components/alerts/index.js");

__webpack_require__("./components/app-version/index.js");

__webpack_require__("./components/appointments/index.js");

__webpack_require__("./components/artists/index.js");

__webpack_require__("./components/auth/index.js");

__webpack_require__("./components/appointments-list/index.js");

__webpack_require__("./components/clients-list/index.js");

__webpack_require__("./components/collector/index.js");

__webpack_require__("./components/dashboard/index.js");

__webpack_require__("./components/events/index.js");

__webpack_require__("./components/file-uploads/index.js");

__webpack_require__("./components/image/index.js");

__webpack_require__("./components/invitation/index.js");

__webpack_require__("./components/login/index.js");

__webpack_require__("./components/message-templates/index.js");

__webpack_require__("./components/messages/index.js");

__webpack_require__("./components/notifications/index.js");

__webpack_require__("./components/profile/index.js");

__webpack_require__("./components/progress/index.js");

__webpack_require__("./components/projects/index.js");

__webpack_require__("./components/reset-password/index.js");

__webpack_require__("./components/schedule/index.js");

__webpack_require__("./components/shop/index.js");

__webpack_require__("./components/signup/index.js");

__webpack_require__("./components/stats/index.js");

__webpack_require__("./components/styles/index.js");

/***/ }),

/***/ "./components/invitation/_invitation.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508840
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/invitation/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/invitation/invitation.component.js");

__webpack_require__("./components/invitation/invitation.controller.js");

__webpack_require__("./components/invitation/invitation.factory.js");

__webpack_require__("./components/invitation/_invitation.styles.scss");

__webpack_require__("./components/invitation/new-collector-modal.controller.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('invitation', {
    url: '/invitation?token&type',
    views: {
      '@': {
        component: 'inkInvitation'
      }
    },
    resolve: {
      $title: function $title() {
        return 'You’re invited';
      },
      type: ['$stateParams', '_', function type($stateParams, _) {
        if (_.isUndefined($stateParams.type)) {
          return '';
        }
        return $stateParams.type;
      }]
    }
  });
}]);

/***/ }),

/***/ "./components/invitation/invitation.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkInvitation = {
  controller: 'InvitationController',
  template: __webpack_require__("./components/invitation/invitation.template.html"),
  bindings: {
    type: '<'
  }
};

angular.module('inkfinder').component('inkInvitation', inkInvitation);

/***/ }),

/***/ "./components/invitation/invitation.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


InvitationController.$inject = ['InvitationFactory', '$stateParams', 'moment', '$uibModal', 'NOTIFICATIONS', 'Notification', '_'];


/**
 * @description Controller for the invitation
 * @param {factory} InvitationFactory The service to deliver invitations
 * @param {unknown} $stateParams unknown
 * @param {unknown} moment The moment library
 * @param {unknown} $uibModal The $uibModal service from UI Bootstrap
 * @param {unknown} NOTIFICATIONS The NOTIFICATIONS constant
 * @param {unknown} Notification The notification service
 * @param {library} _ The Lodash service
 */
function InvitationController(InvitationFactory, $stateParams, moment, $uibModal, NOTIFICATIONS, Notification, _) {
  var vm = this;

  // Public methods
  vm.token = $stateParams.token;
  vm.type = $stateParams.type;

  // Pass the token and get the invitation
  InvitationFactory.getInvitation(vm.token).then(function (invitation) {
    if ('status' in invitation && invitation.status === 404) {
      vm.status = 'expired';
    } else if ('status' in invitation && invitation.status === 403) {
      vm.status = 'declined';
    } else {
      vm.status = 'invited';
      vm.collector = invitation.collector;
      vm.currentUsername = _.cloneDeep(invitation.collector.username);
      vm.shop = invitation.shop;
      vm.association = invitation.association;
      vm.created = moment(invitation.created);
      vm.createdBy = invitation.createdBy;

      if (vm.collector.is_new_user === true) {
        var modalInstance = $uibModal.open({
          template: __webpack_require__("./components/invitation/new-collector-modal.template.html"),
          animation: true,
          controller: 'NewCollectorModalController',
          bindToController: true,
          controllerAs: '$ctrl',
          backdrop: 'static',
          resolve: {
            collector: function collector() {
              return vm.collector;
            },
            token: function token() {
              return vm.token;
            }
          }
        });
        modalInstance.result.then(function (collector) {
          vm.collector = collector;
        }, function () {
          // No Error reporting yet
        });
      }
    }
  });
}

angular.module('inkfinder').controller('InvitationController', InvitationController);

/***/ }),

/***/ "./components/invitation/invitation.factory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('InvitationFactory', ['$http', '$rootScope', 'ENDPOINT', 'AlertMessages', function InvitationFactory($http, $rootScope, ENDPOINT, AlertMessages) {
  // Public functions
  InvitationFactory.createInvitation = createInvitation;
  InvitationFactory.updateInvitation = updateInvitation;
  InvitationFactory.getInvitation = getInvitation;
  InvitationFactory.updateAccount = updateAccount;
  InvitationFactory.updateAccount = updateAccount;

  /**
  * @description Create an invitation
  * @param {object} association The associaiton to base the invitation off of
  * @return {object} Returns the created invitation
  */
  function createInvitation(association) {
    return $http.post(ENDPOINT.server + 'collectors/api/v1.1/invitation/', association).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @description
  * Update the invitation
  * @param {object} invitation The invitation to update
  * @return {object} Returns the updated invitation
  */
  function updateInvitation(invitation) {
    return $http.put(ENDPOINT.server + 'collectors/api/v1.1/invitation/' + invitation.id + '/', invitation).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @description
  * Get the invitation by passing the token
  * @param {string} token The token to determine the invited user
  * @return {object} Returns the collector, associations, and invitation
  */
  function getInvitation(token) {
    return $http.get(ENDPOINT.server + 'collectors/api/v1.1/invitation/?token=' + token).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @description
  * Update the collector account by passing the token
  * @param {object} profile The collector profile to update.
  * @return {object} Returns the updated collector profile.
  */
  function updateAccount(profile) {
    return $http.post(ENDPOINT.server + 'collectors/api/v1.1/invitation/update-account/', profile).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error.data,
        type: 'danger'
      });
    });
  }
  return InvitationFactory;
}]);

/***/ }),

/***/ "./components/invitation/invitation.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"invitation no-sidebar section first last background-dark\"> <div class=background-photo></div> <div class=region-header> <div class=container> <div class=row> <div class=\"col-sm-12 center\"> <span class=\"logo finder full-logo\"></span> </div> </div> </div> </div> <div class=container-fluid> <div class=row> <div class=\"col-sm-6 col-sm-offset-3 center\" ng-if=\"$ctrl.status === 'invited'\"> <div class=intro> <h1>You’re in.</h1> <div ng-if=$ctrl.collector.profile_photo> <ink-profile-photo type=$ctrl.association.type.toLowerCase() show-name=false image-id=$ctrl.collector.profile_photo> </ink-profile-photo> </div> <h6 ng-if=\"$ctrl.association.type === 'Artist' || $ctrl.association.type === 'Operator'\"> You accepted an invite from {{$ctrl.createdBy.first_name}} {{$ctrl.createdBy.last_name}} to join <span ng-if=\"$ctrl.association.type === 'Artist'\">the</span> {{$ctrl.shop.name}} <span ng-if=\"$ctrl.association.type === 'Operator'\">as an operator.</span> <span ng-if=\"$ctrl.association.type === 'Artist'\">artist roster.</span> </h6> <h6 ng-if=\"$ctrl.association.type === 'Collector'\"> You accepted an invite from {{$ctrl.createdBy.first_name}} {{$ctrl.createdBy.last_name}} <span ng-if=$ctrl.shop>at {{$ctrl.shop.name}}</span> to collaborate on Ink Finder. </h6> </div> <div class=row ng-if=\"$ctrl.collector.is_new_user === false\"> <div class=col-sm-12 ng-if=\"$ctrl.association.type === 'Artist'\"> <div class=button-container> <a ui-sref=login class=\"button large finder-solid\">Sign in</a> <p><small>Sign in to Ink Finder to view your appointments and manage your shop connections.</small></p> </div> </div> <div class=\"col-sm-6 col-sm-offset-3\" ng-if=\"$ctrl.association.type === 'Operator'\"> <div class=button-container> <a class=\"button large finder-solid\" ui-sref=login>Sign in</a> <p><small>Sign in to start collaborating with artists at {{$ctrl.shop.name}}</small></p> </div> </div> <div class=\"col-sm-6 col-sm-offset-3\" ng-if=\"$ctrl.association.type === 'Collector'\"> <div class=button-container> <a class=\"button large finder-solid\" ui-sref=login>Sign in</a> <p><small>Sign in to update your project, confirm appointments, and more.</small></p> </div> </div> </div> </div> <div class=\"col-sm-6 col-sm-offset-3 center\" ng-if=\"$ctrl.status === 'expired'\"> <div class=intro> <h1>Sorry, charlie.</h1> <h6>This invitation has expired.</h6> <p>If you’ve already accepted this invitation,</p> <p> <button ui-sref=login class=\"button small finder-solid\"> Sign in </button> or <button ui-sref=resetpassword class=\"button small finder\"> reset your password </button> </p> </div> </div> <div class=\"col-sm-6 col-sm-offset-3 center\" ng-if=\"$ctrl.status === 'declined'\"> <div class=intro> <h1>Sorry, charlie.</h1> <h6>This invitation has been canclled.</h6> <p> <button ui-sref=login class=\"button small finder-solid\"> Sign in </button> or <button ui-sref=resetpassword class=\"button small finder\"> reset your password </button> </p> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/invitation/new-collector-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


NewCollectorModalController.$inject = ['$uibModalInstance', 'collector', 'token', 'InvitationFactory', 'CheckUsername'];


/**
 * @name NewCollectorModalController
 * @description Function to handle operator invite cancellations
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} collector Resolved collector from the invitation controller
 * @param {unknown} token Resolved token from the invitation controller
 * @param {unknown} InvitationFactory The Invitation service
 * @param {unknown} CheckUsername The CheckUsername service
 */
function NewCollectorModalController($uibModalInstance, collector, token, InvitationFactory, CheckUsername) {
  var vm = this;
  vm.collector = collector;
  vm.token = token;
  vm.updateAccount = updateAccount;
  vm.checkUsername = checkUsername;

  // Defaults
  vm.required = false;

  /**
   * @description Update the collector if one is a new user
   * @param {object} profile The collector profile to update
   */
  function updateAccount(profile) {
    var newProfile = {
      token: vm.token,
      username: profile.username,
      firstName: profile.first_name,
      lastName: profile.last_name,
      phone: profile.phone,
      password: profile.password,
      profile_photo: profile.profile_photo
    };
    InvitationFactory.updateAccount(newProfile).then(function (invitation) {
      $uibModalInstance.close(invitation.collector);
    });
  }

  /**
   * @name checkUsername
   * @description Function to check it a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username, vm.currentUsername).then(function (results) {
      vm.usernameResults = results;
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('NewCollectorModalController', NewCollectorModalController);

/***/ }),

/***/ "./components/invitation/new-collector-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=updateProfileForm ng-submit=\"updateProfileForm.$valid && $ctrl.updateAccount($ctrl.collector)\" novalidate> <div class=modal-header> <h4 class=modal-title>Ah, I see you’re new here.</h4> </div> <div class=\"modal-body background-light\"> <h6 class=center>Complete your profile and create a password for your account.</h6> <div class=center> <ink-profile-photo profile=$ctrl.collector image-id=$ctrl.collector.profile_photo editable=true linkable=true on-change=\"$ctrl.collector.profile_photo = imageId\"> </ink-profile-photo> </div> <div class=form-group> <label for=username>Username <small>Optional</small></label> <input name=username id=username type=text class=form-control ng-model=$ctrl.collector.username ng-model-options=\"{updateOn: 'default blur', debounce: {'default': 500, 'blur': 0}}\" ng-change=$ctrl.checkUsername($ctrl.collector.username) ng-pattern=/^[a-z0-9]*$/ ng-trim=false> <div class=\"inline-message relative\"> <p class=\"message error absolute\"> <span ng-if=\"!updateProfileForm.username.$invalid && $ctrl.usernameResults.usernameValid !== null\" ng-class=\"{'shop-color': $ctrl.usernameResults.usernameValid === true, 'alert-color': $ctrl.usernameResults.usernameValid === false}\"> {{$ctrl.usernameResults.usernameCheckMessage}} </span> <span ng-if=\"updateProfileForm.username.$invalid && !updateProfileForm.username.$pristine\" class=alert-color> Use lowercase letters and numbers only </span> </p> </div> </div> <div class=form-group> <label for=first_name>First name</label> <input name=first_name id=first_name type=text class=form-control placeholder=Seemore required ng-model=$ctrl.collector.first_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateProfileForm.first_name.$invalid && !updateProfileForm.first_name.$pristine\"> Please enter your first name. </p> </div> </div> <div class=form-group> <label for=last_name>Last name</label> <input name=last_name id=last_name type=text class=form-control placeholder=Butts required ng-model=$ctrl.collector.last_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateProfileForm.last_name.$invalid && !updateProfileForm.last_name.$pristine\"> Please enter your last name. </p> </div> </div> <div class=form-group> <label for=phone>Phone</label> <input type=text class=form-control name=phone id=phone mask=\"(999) 999-9999\" placeholder=\"(555) 867–5309\" clean=true ng-model=$ctrl.collector.phone> </div> <div class=form-group> <p>Create a password.</p> <label for=password>Password</label> <input name=password id=password type=password placeholder=Password class=form-control required ng-minlength=5 ng-model=$ctrl.collector.password> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateProfileForm.password.$invalid && !updateProfileForm.password.$pristine\"> Your password needs to be at least 5 characters, yo. </p> </div> </div> <div class=form-group> <label for=passwordConfirm>Confirm password</label> <input name=passwordConfirm id=passwordConfirm type=password placeholder=\"Confirm password\" class=form-control compare-to=$ctrl.collector.password ng-model=$ctrl.collector.passwordConfirm> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateProfileForm.passwordConfirm.$error.compareTo && !updateProfileForm.passwordConfirm.$pristine\"> Your passwords don’t match, or they are too short. </p> </div> </div> <div class=form-group> <label class=left><input name=terms ng-model=$ctrl.required type=checkbox ng-required=!$ctrl.required> I agree to the Ink Finder <a href=https://inkfinder.tattoo/legal/terms-providers/ target=_blank>Provider Terms of Service</a>, <a href=https://inkfinder.tattoo/legal/terms-collectors/ target=_blank> Collector Terms of Service</a>, and <a href=https://inkfinder.tattoo/legal/privacy/ target=_blank>Privacy Policy</a>.</label> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit ng-disabled=\"updateProfileForm.$invalid || $ctrl.usernameResults.usernameValid === false\">Save</button> </div> </form> ";

/***/ }),

/***/ "./components/login/_login.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508825
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/login/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/login/login.component.js");

__webpack_require__("./components/login/login.controller.js");

__webpack_require__("./components/login/_login.styles.scss");

/***/ }),

/***/ "./components/login/login.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkLogin = {
  controller: 'LoginController',
  bindings: {
    route: '<',
    type: '<?'
  },
  template: __webpack_require__("./components/login/login.template.html")
};

angular.module('inkfinder').component('inkLogin', inkLogin);

/***/ }),

/***/ "./components/login/login.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


LoginController.$inject = ['Auth', '$state', '$rootScope', 'DEFAULT_STATES', 'SWITCH_MESSAGE', 'AUTH_EVENTS', 'AlertMessages', 'Events', 'Session', '$cookies', '_'];


/**
 * @description The function to login to Ink Finder
 * @param {object} Auth The service providing authentication
 * @param {unknown} $state The $state service from ui-router
 * @param {unknown} $rootScope Unknown
 * @param {object} DEFAULT_STATES The constant to defines default states based on role type
 * @param {object} SWITCH_MESSAGE Constant for state switch messages
 * @param {array} AUTH_EVENTS A constant containing an array of auth events to use global
 * @param {object} AlertMessages A service for alerts.
 * @param {object} Events System events service
 * @param {object} Session Session service
 * @param {unknown} $cookies Angular cookies service
 * @param {library} _ The Lodash library
 */
function LoginController(Auth, $state, $rootScope, DEFAULT_STATES, SWITCH_MESSAGE, AUTH_EVENTS, AlertMessages, Events, Session, $cookies, _) {
  var vm = this;

  // Defaults
  vm.$onInit = function () {
    vm.type = _.isUndefined(vm.type) ? 'fixed' : vm.type;
    vm.loginModalOpen = false;
    vm.session = Session;
    vm.login = login;
    vm.authenticate = authenticate;
    vm.logout = logout;
    vm.switchToBuying = switchToBuying;
    vm.credentials = {};
    vm.changeState = changeState;
  };

  /**
   * @name login
   * @description Login via an Ink Finder account
   * @param {object} credentials The object passing email/password
   */
  function login(credentials) {
    Auth.loginInkfinder(credentials).then(function (response) {
      vm.credentials = null;
      Events.loggedIn = true;
      Auth.routeAfterAuthentication();
    }).catch(function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name authenticate
   * @description Login via Social API through Satellizer
   * @param {unknown} provider Unknown
   */
  function authenticate(provider) {
    Auth.loginSocial(provider).then(function (response) {
      vm.credentials = null;
      Events.loggedIn = true;
      Auth.routeAfterAuthentication();
    }).catch(function (error) {
      AlertMessages.add({
        msg: error, // This will catch the error message from Satellizer
        type: 'danger'
      });
    });
  }

  /**
   * @name changeState
   * @description Function to change states (buy/selling) and the user role
   * associated with the state
   * @param {object} activeState The selected state
   */
  function changeState(activeState) {
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(activeState);
    $cookies.putObject('inkfinder', activeState);
    if (activeState.role === 'operator') {
      $state.go(DEFAULT_STATES.operator);
    } else {
      $state.go(DEFAULT_STATES.artist);
    }
  }

  /**
   * @name switchToBuying
   * @description Function to move the user to the collector's dashboard
   */
  function switchToBuying() {
    var state = {
      mode: 'buying',
      role: 'collector',
      switchMessage: SWITCH_MESSAGE.buying,
      id: 1
    };
    $rootScope.$broadcast('clear-data');
    Session.setActiveState(state);
    $cookies.putObject('inkfinder', state);
    $state.go(DEFAULT_STATES.buying);
  }

  /**
   * @name logout
   * @description Wrapper for the Auth logout function
   */
  function logout() {
    Auth.logout();
  }
}

angular.module('inkfinder').controller('LoginController', LoginController);

/***/ }),

/***/ "./components/login/login.template.html":
/***/ (function(module, exports) {

module.exports = " <div id=login-component class=\"login login-modal-collector center\" ng-if=$ctrl.session.collector tw-click-outside=$ctrl.modalClose() ng-class=\"{\n  'login-modal': $ctrl.type === 'modal',\n  'login-fixed': $ctrl.type === 'fixed'\n  }\"> <a ng-if=\"$ctrl.type === 'modal'\" ui-sref=inkfinder.more> <fa name=bars class=icon></fa> </a> <ink-profile-photo ng-if=\"$ctrl.type === 'fixed'\" profile=$ctrl.session.collector size=\"'large'\" image-id=$ctrl.session.collector.profile_photo> </ink-profile-photo> <div class=login-modal-inner ng-class=\"{\n    'background-light': $ctrl.type === 'modal',\n    'login-modal-open': $ctrl.loginModalOpen,\n    'login-modal-closed': !$ctrl.loginModalOpen,\n    }\"> <div class=arrow-up></div> <ul class=modal-menu> <li ng-repeat=\"state in $ctrl.session.states.selling track by state.id\"> <a ng-click=$ctrl.changeState(state)> <span ng-if=\"state.role === 'operator'\">Operator at {{state.association.shop.name}}</span> <span ng-if=\"state.role === 'artist'\">Artist at {{state.association.shop.name}}</span> </a> </li> <li><a ng-click=$ctrl.switchToBuying()>Buy art</a></li> <li> <a ui-sref=inkfinder.collector.update ng-click=$ctrl.modalClose()>Settings</a> </li> <li> <a ng-click=$ctrl.logout()>Sign out</a> </li> </ul> </div> </div> <div class=login tw-click-outside=$ctrl.modalClose() ng-if=!$ctrl.session.collector ng-class=\"{\n    'login-modal': $ctrl.type === 'modal',\n    'login-fixed': $ctrl.type === 'fixed'\n  }\"> <div class=login-modal-toggle> <a ng-if=\"$ctrl.type === 'modal'\" ng-click=\"$ctrl.loginModalOpen = !$ctrl.loginModalOpen\" event-focus=click event-focus-id=email>Have an account? <button class=\"button small finder-solid\">Sign in</button></a> </div> <div class=login-modal-inner ng-class=\"{\n    'background-light': $ctrl.type === 'modal',\n    'login-modal-open': $ctrl.loginModalOpen,\n    'login-modal-closed': !$ctrl.loginModalOpen,\n  }\"> <div class=arrow-up></div> <form name=loginForm class=login-form ng-submit=\"loginForm.$valid && $ctrl.login($ctrl.credentials)\" novalidate> <div class=form-group> <label for=email>Email</label> <input name=email id=email type=email autocapitalize=off class=form-control required ng-model=$ctrl.credentials.email ng-model-options=\"{\n          updateOn: 'default blur',\n          debounce: { 'default': 1500, 'blur': 0 }\n          }\"> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"loginForm.email.$invalid && !loginForm.email.$pristine\"> Hmm...I don’t think that's a real email address. </p> </div> </div> <div class=\"form-group relative\"> <label for=password>Password</label> <input name=password id=password type=password class=form-control required ng-model=$ctrl.credentials.password ng-keyup=\"$event.keyCode === 13 && loginForm.$valid\"> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"loginForm.password.$invalid && !loginForm.password.$pristine\"> Your full password is required, yo. </p> </div> </div> <div class=button-container> <button class=\"button large finder-solid\" type=submit ng-disabled=loginForm.$invalid>Sign in</button> <p><small><a ui-sref=resetpassword>Forgot your password?</a></small></p> </div> </form> </div> </div> ";

/***/ }),

/***/ "./components/message-templates/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/message-templates/message-templates.component.js");

__webpack_require__("./components/message-templates/message-templates.controller.js");

__webpack_require__("./components/message-templates/message-templates.service.js");

/***/ }),

/***/ "./components/message-templates/message-templates.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkMessageTemplates = {
  controller: 'MessageTemplatesController',
  template: __webpack_require__("./components/message-templates/message-templates.template.html"),
  bindings: {
    messageTemplatesOwner: '<'
  }
};

angular.module('inkfinder').component('inkMessageTemplates', inkMessageTemplates);

/***/ }),

/***/ "./components/message-templates/message-templates.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MessageTemplatesController.$inject = ['Shop', 'Session', 'MessageTemplates'];
/**
 * @name MessageTemplatesController
 * @description Controller for message templates
 * @param {service} Shop Shop service
 * @param {service} Session Session service
 * @param {service} MessageTemplates The MessageTemplates service
 */
function MessageTemplatesController(Shop, Session, MessageTemplates) {
  var vm = this;

  vm.$onInit = function () {
    vm.saveMessageTemplates = saveMessageTemplates;
    vm.session = Session;
  };

  // Get the message templates from the entity passed through the resolve
  MessageTemplates.get(vm.messageTemplatesOwner.message_templates).then(function (response) {
    vm.messageTemplates = response;
  });

  /**
   * @name saveMessageTemplates
   * @description Function to update message templates
   * @param {object} messageTemplates The message templates to update
   */
  function saveMessageTemplates(messageTemplates) {
    MessageTemplates.update(messageTemplates).then(function (response) {
      vm.messageTemplates = response;
    });
  }
}

angular.module('inkfinder').controller('MessageTemplatesController', MessageTemplatesController);

/***/ }),

/***/ "./components/message-templates/message-templates.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MessageTemplates.$inject = ['$http', 'ENDPOINT', 'AlertMessages'];
/**
 * @name MessageTemplates
 * @description Function for the MessageTemplates service
 * @param {type} $http Description
 * @param {type} ENDPOINT Description
 * @param {type} AlertMessages Description
 * @return {object} Returns the Shopmessage-templates service
 */
function MessageTemplates($http, ENDPOINT, AlertMessages) {
  MessageTemplates.get = get;
  MessageTemplates.update = update;

  /**
   * @name get
   * @description Function to get an array of message templates
   * @param {number} id The ID of the message templates
   * @return {object} Returns a message templates object
   */
  function get(id) {
    return $http.get(ENDPOINT.server + 'message-templates/api/v1.1/' + id + '/').then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name update
   * @description Function to update message templates
   * @param {object} messageTemplates The message templates to update
   * @return {object} Returns the udpated message templates object
   */
  function update(messageTemplates) {
    return $http.put(ENDPOINT.server + 'message-templates/api/v1.1/' + messageTemplates.id + '/', messageTemplates).then(function (response) {
      AlertMessages.add({
        msg: 'Your message templates have been saved.',
        type: 'success'
      });
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return MessageTemplates;
}

angular.module('inkfinder').factory('MessageTemplates', MessageTemplates);

/***/ }),

/***/ "./components/message-templates/message-templates.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=row> <div class=col-sm-12> <form name=messageTemplatesForm ng-submit=\"messageTemplatesForm.$valid && $ctrl.saveMessageTemplates($ctrl.messageTemplates)\" novalidate> <h5 class=no-margin>Your cancellation policy</h5> <div class=form-group> <p> <small class=finder-color><fa name=eye></fa> Displayed to collectors when they respond to an estimated appointment. Collectors must agree to your cancellation policy below before confirming their appointment.</small> </p> <ng-ckeditor ng-model=$ctrl.messageTemplates.cancellation_policy remove-buttons=Image,Anchor,Underline,Strike,Subscript,Superscript,Table,Source,Styles,HorizontalRule remove-plugins=iframe,flash,smiley> </ng-ckeditor> </div> <div class=\"divider small loose\"></div> <h5 class=no-margin>Your tattoo process</h5> <div class=form-group> <p> <small class=finder-color><fa name=paper-plane></fa> Sent to collectors when an appointment is confirmed.</small> </p> <ng-ckeditor ng-model=$ctrl.messageTemplates.tattoo_process remove-buttons=Image,Anchor,Underline,Strike,Subscript,Superscript,Table,Source,Styles,HorizontalRule remove-plugins=iframe,flash,smiley> </ng-ckeditor> <div class=\"divider small xxtight transparent\"></div> <p> <small class=finder-color>This message is signed by the operator who managed the appointment, like this:</small> </p> <div class=row> <div class=col-sm-1> <ink-profile-photo profile=$ctrl.session.collector image-id=$ctrl.session.collector.profile_photo size=\"'standard'\" show-name=false> </ink-profile-photo> </div> <div class=col-sm-11> <p class=no-margin> {{$ctrl.session.collector.first_name}} {{$ctrl.session.collector.last_name}}<br/> <small>{{$ctrl.session.activeState.association.shop.name}}</small> </p> </div> </div> </div> <div class=\"divider small loose\"></div> <h5 class=no-margin>Aftercare instructions</h5> <div class=form-group> <p> <small class=finder-color><fa name=paper-plane></fa> Sent to collectors in the appointment completed notification.</small> </p> <ng-ckeditor ng-model=$ctrl.messageTemplates.aftercare_instructions remove-buttons=Image,Anchor,Underline,Strike,Subscript,Superscript,Table,Source,Styles,HorizontalRule remove-plugins=iframe,flash,smiley> </ng-ckeditor> <div class=\"divider small xxtight transparent\"></div> <p> <small class=finder-color>This message is signed by the operator who managed the appointment, like this:</small> </p> <div class=row> <div class=col-sm-1> <ink-profile-photo profile=$ctrl.session.collector image-id=$ctrl.session.collector.profile_photo size=\"'standard'\" show-name=false> </ink-profile-photo> </div> <div class=col-sm-11> <p class=no-margin> {{$ctrl.session.collector.first_name}} {{$ctrl.session.collector.last_name}}<br/> <small>{{$ctrl.session.activeState.association.shop.name}}</small> </p> </div> </div> </div> <div class=\"divider small loose\"></div> <h5 class=no-margin>14 day follow-up message</h5> <div class=form-group> <p> <small class=finder-color><fa name=paper-plane></fa> Sent to collectors 14 days after an appointment is completed.</small> </p> <ng-ckeditor ng-model=$ctrl.messageTemplates.followup_14day remove-buttons=Image,Anchor,Underline,Strike,Subscript,Superscript,Table,Source,Styles,HorizontalRule remove-plugins=iframe,flash,smiley> </ng-ckeditor> <div class=\"divider small xxtight transparent\"></div> <p> <small class=finder-color>This message is signed by the operator who managed the appointment, like this:</small> </p> <div class=row> <div class=col-sm-1> <ink-profile-photo profile=$ctrl.session.collector image-id=$ctrl.session.collector.profile_photo size=\"'standard'\" show-name=false> </ink-profile-photo> </div> <div class=col-sm-11> <p class=no-margin> {{$ctrl.session.collector.first_name}} {{$ctrl.session.collector.last_name}}<br/> <small>{{$ctrl.session.activeState.association.shop.name}}</small> </p> </div> </div> </div> <div class=\"divider small loose\"></div> <h5 class=no-margin>30 day follow-up message</h5> <div class=form-group> <p> <small class=finder-color><fa name=paper-plane></fa> Sent to collectors 30 days after an appointment is completed.</small> </p> <ng-ckeditor ng-model=$ctrl.messageTemplates.followup_30day remove-buttons=Image,Anchor,Underline,Strike,Subscript,Superscript,Table,Source,Styles,HorizontalRule remove-plugins=iframe,flash,smiley> </ng-ckeditor> <div class=\"divider small xxtight transparent\"></div> <p> <small class=finder-color>This message is signed by the operator who managed the appointment, like this:</small> </p> <div class=row> <div class=col-sm-1> <ink-profile-photo profile=$ctrl.session.collector image-id=$ctrl.session.collector.profile_photo size=\"'standard'\" show-name=false> </ink-profile-photo> </div> <div class=col-sm-11> <p class=no-margin> {{$ctrl.session.collector.first_name}} {{$ctrl.session.collector.last_name}}<br/> <small>{{$ctrl.session.activeState.association.shop.name}}</small> </p> </div> </div> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" ng-disabled=messageTemplatesForm.$invalid>Save</button> </div> </form> </div> </div> ";

/***/ }),

/***/ "./components/messages/_messages.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508759
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/messages/add/_add-message.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510243
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/messages/add/add-message.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAddMessage = {
  bindings: {
    conversationId: '<',
    appointmentId: '<',
    privateOption: '<'
  },
  controller: 'AddMessageController',
  template: __webpack_require__("./components/messages/add/add-message.template.html")
};

angular.module('inkfinder').component('inkAddMessage', inkAddMessage);

/***/ }),

/***/ "./components/messages/add/add-message.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AddMessageController.$inject = ['Messages', '_', '$rootScope', 'Session', '$log', 'Participants', 'moment'];


/**
 * @name AddMessageController
 * @description Controller for notes
 * @param {type} Messages Description
 * @param {type} _ Description
 * @param {type} $rootScope Angular rootScope service
 * @param {service} Session The session service
 * @param {service} $log Angular log service
 * @param {service} Participants The Participants service
 * @param {library} moment The moment service
 */
function AddMessageController(Messages, _, $rootScope, Session, $log, Participants, moment) {
  var vm = this;

  vm.$onInit = function () {
    vm.data = Messages;
    vm.session = Session;

    // Public methods
    vm.create = create;

    // Defaults
    vm.message = {
      content: null,
      private: false
    };
    vm.privateOption = _.isUndefined(vm.privateOption) ? true : false;
  };

  /**
   * @name get
   * @description Function to add a message to a conversation.
   * @param {number} message The new message to create
   */
  function create(message) {
    message.cid = vm.conversationId;
    // Check to ensure message is not null or spaces
    if (message.content !== null && message.content.replace(/\s/g, '').length) {
      Messages.create(message).then(function (newMessage) {
        var appointmentId = void 0;
        var projectId = void 0;
        $rootScope.$broadcast('merge-activity', vm.conversationId, appointmentId, projectId);
        vm.message.content = null;
        vm.message.private = false;
        var conversationId = newMessage.conversation;
        // let collectorId = Session.collector.id;
        Participants.get(conversationId, appointmentId).then(function (participants) {
          var loggedInParticipant = _.find(participants, function (participant) {
            if (participant.collector === Session.collector.id) {
              return true;
            }
          });
          if (loggedInParticipant) {
            var formattedParticipant = {
              id: loggedInParticipant.id,
              last_read_date: moment.utc().format('YYYY-MM-DDTHH:mm:ss')
            };
            Participants.update(formattedParticipant).then(function (updatedParticipant) {
              $rootScope.$broadcast('created-new-message', updatedParticipant.id);
            });
          }
        });
      });
    }
  }
}

angular.module('inkfinder').controller('AddMessageController', AddMessageController);

/***/ }),

/***/ "./components/messages/add/add-message.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=add-message> <form name=createMessage ng-submit=\"createMessage.$valid && $ctrl.create($ctrl.message)\" novalidate> <textarea msd-elastic=\\n placeholder=\"Write a message...\" class=background-light ng-model=$ctrl.message.content>\n    </textarea> <p ng-if=$ctrl.privateOption> <label ng-if=\"$ctrl.session.activeState.role === 'operator' || $ctrl.session.activeState.role === 'artist'\"> Private message? <small class=add-message__private> <input name=private type=checkbox ng-model=$ctrl.message.private /> <span ng-if=\"$ctrl.session.activeState.role === 'operator'\"> Yes, make this message visible only to others at {{$ctrl.session.activeState.association.shop.name}}. </span> <span ng-if=\"$ctrl.session.activeState.role === 'artist'\"> Yes, make this message visible only to you and others at the shop. </span> </small> </label> </p> <button class=\"button large shop-solid\" ng-disabled=\"createMessage.$valid && $ctrl.message.content === null\"> Send </button> <div class=\"divider small tight transparent\"></div> </form> </div> ";

/***/ }),

/***/ "./components/messages/add/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/messages/add/add-message.component.js");

__webpack_require__("./components/messages/add/add-message.controller.js");

__webpack_require__("./components/messages/add/_add-message.styles.scss");

/***/ }),

/***/ "./components/messages/conversations/conversations.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkConversations = {
  controller: 'ConversationsController',
  template: __webpack_require__("./components/messages/conversations/conversations.template.html"),
  bindings: {
    $transition$: '<',
    data: '<'
  }
};

angular.module('inkfinder').component('inkConversations', inkConversations);

/***/ }),

/***/ "./components/messages/conversations/conversations.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _moment = __webpack_require__("../node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ConversationsController.$inject = ['Session', 'Events', '$stateParams', 'Participants'];


/**
 * @name ConversationsController
 * @description The controller for conversations
 * @param {service} Session Unknown
 * @param {service} Events The Participants service
 * @param {angular} $stateParams Angular $stateParams service
 * @param {service} Participants The Participants service
 */
function ConversationsController(Session, Events, $stateParams, Participants) {
  var vm = this;
  vm.$onInit = function () {
    vm.session = Session;
    vm.isReplyCollapsed = true;
  };

  updateLastReadDate();

  /**
   * @name name
   * @description description
   * @param {type} parameter Description
   */
  function updateLastReadDate() {
    var collectorId = Session.collector.id;
    var conversationId = $stateParams.conversationId;
    var appointmentId = void 0;
    Participants.get(conversationId, appointmentId, collectorId).then(function (participants) {
      var formattedParticipant = {
        id: participants[0].id,
        last_read_date: _moment2.default.utc().format('YYYY-MM-DDTHH:mm:ss')
      };
      Participants.update(formattedParticipant).then(function () {
        Participants.getUnreadCount().then(function (count) {
          Events.newMessagesCount = count;
        });
      });
    });
  }
}

angular.module('inkfinder').controller('ConversationsController', ConversationsController);

/***/ }),

/***/ "./components/messages/conversations/conversations.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Conversations', ['$q', '$http', 'ENDPOINT', 'AlertMessages', 'filterFilter', 'Session', function Conversations($q, $http, ENDPOINT, AlertMessages, filterFilter, Session) {
  Conversations.get = get;
  Conversations.getBatch = getBatch;

  /**
   * @name get
   * @description Function to get a conversation from the api
   * @param {number} id The ID number of the converstation to retrieve
   * @return {object} data Returns the conversation object.
   */
  function get(id) {
    var url = ENDPOINT.server + 'conversations/api/v1.1/' + id + '/';
    var role = Session.activeState.role;
    url += '?role=' + role;
    return $http.get(url).then(function (response) {
      Conversations.conversation = response.data;
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getBatch
   * @description Function to get a conversation from the api
   * @param {number} ids The ID number of the converstation to retrieve
   * @return {object} data Returns the conversation object.
   */
  function getBatch(ids) {
    var url = ENDPOINT.server + 'conversations/api/v1.1/?ids=' + ids.toString();
    var role = Session.activeState.role;
    url += '&role=' + role;
    return $http.get(url).then(function (response) {
      Conversations.conversation = response.data;
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Conversations;
}]);

/***/ }),

/***/ "./components/messages/conversations/conversations.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-container flex-column height100\"> <div class=\"section background-dark tight\"> <div class=container-fluid> <div class=row> <div class=\"col-md-3 col-md-offset-1\"> <a class=right ui-sref=inkfinder.messages.inbox><fa name=chevron-circle-left></fa> All messages</a> <div class=\"divider small xxtight transparent\"></div> </div> <div class=col-md-4> <div class=\"list projects\"> <a class=\"item project link no-margin\" ui-sref=inkfinder.appointments.details({appointment_id:$ctrl.data.appointment.id})> <ink-project-card card=$ctrl.data show-full-datetime=true></ink-project-card> </a> </div> </div> </div> </div> </div> <div class=\"section background-light tight flex-col\"> <div class=container-fluid> <div class=row> <div class=\"col-sm-12 col-md-6 col-md-offset-3\"> <div class=messages__container> <div class=center> <div class=\"button-add openable no-margin\" ng-class=\"{'open': !$ctrl.isReplyCollapsed}\"> <button class=\"button circle\" ng-click=\"$ctrl.isReplyCollapsed = !$ctrl.isReplyCollapsed\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> </div> </div> <div uib-collapse=$ctrl.isReplyCollapsed> <div class=\"divider small xtight transparent\"></div> <ink-participants conversation-id=$ctrl.data.conversation.id appointment-id=$ctrl.data.appointment.id artist=$ctrl.data.appointment.artist collector=$ctrl.data.project.collector> </ink-participants> <ink-add-message conversation-id=$ctrl.data.conversation.id appointment-id=$ctrl.data.appointment.id> </ink-add-message> </div> <ink-activity conversation-id=$ctrl.data.conversation.id appointment-id=$ctrl.data.appointment.id project-id=$ctrl.data.project.id has-project-activity=false has-appointment-activity=false> </ink-activity> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/messages/conversations/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/messages/conversations/conversations.component.js");

__webpack_require__("./components/messages/conversations/conversations.controller.js");

__webpack_require__("./components/messages/conversations/conversations.service.js");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.messages.conversations', {
    url: '/{conversationId:[0-9]{1,100}}',
    views: {
      '@': {
        component: 'inkConversations'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Your conversation';
      },
      data: ['Conversations', 'Appointment', 'Project', '$transition$', function data(Conversations, Appointment, Project, $transition$) {
        var data = {};
        return Conversations.get($transition$.params().conversationId).then(function (conversation) {
          data.conversation = conversation;
          return Appointment.get(data.conversation.appointment).then(function (appointment) {
            data.appointment = appointment;
            return Project.get(data.appointment.project).then(function (project) {
              data.project = project;
              return data;
            });
          });
        });
      }]
    },
    data: {
      authorizedRoles: [USER_ROLES.collector, USER_ROLES.operator, USER_ROLES.artist]
    },
    params: {
      conversationId: { dynamic: true }
    },
    bindings: {
      $transition$: '<'
    }
  });
}]);

/***/ }),

/***/ "./components/messages/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/messages/add/index.js");

__webpack_require__("./components/messages/conversations/index.js");

__webpack_require__("./components/messages/participants/index.js");

__webpack_require__("./components/messages/messages.component.js");

__webpack_require__("./components/messages/messages.controller.js");

__webpack_require__("./components/messages/messages.service.js");

__webpack_require__("./components/messages/_messages.styles.scss");

/***/ }),

/***/ "./components/messages/messages.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkMessages = {
  controller: 'MessagesController',
  template: __webpack_require__("./components/messages/messages.template.html"),
  bindings: {
    participants: '<',
    messagesType: '<',
    $transition$: '<'
  }
};

angular.module('inkfinder').component('inkMessages', inkMessages);

/***/ }),

/***/ "./components/messages/messages.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


MessagesController.$inject = ['Session', 'Events', '$log', '$state', 'moment', 'Participants', '_', '$scope', '$q', 'GroupParticipants', 'Appointment', '$rootScope', 'Conversations'];
/**
 * @name MessagesController
 * @description The controller for inbox messages
 * @param {service} Session Unknown
 * @param {service} Events The Participants service
 * @param {service} $log Angular $log service
 * @param {service} $state Angular $log service
 * @param {library} moment The moment library
 * @param {service} Participants The Participants service
 * @param {library} _ The lodash library
 * @param {Angular} $scope The Angular $scope service
 * @param {Angular} $q The Angular $q service
 * @param {service} GroupParticipants The GroupParticipants service
 * @param {service} Appointment The Appointment service
 * @param {Angular} $rootScope The Angular $rootScope service
 * @param {service} Conversations The Conversations service
 */
function MessagesController(Session, Events, $log, $state, moment, Participants, _, $scope, $q, GroupParticipants, Appointment, $rootScope, Conversations) {
  var vm = this;
  vm.$onInit = function () {
    vm.session = Session;
    vm.events = Events;
    vm.loadConversation = loadConversation;
    vm.archive = archive;
    vm.unArchive = unArchive;
    vm.getParticipants = getParticipants;
    vm.uiOnParamsChanged = uiOnParamsChanged;
    vm.loadPage = loadPage;
    vm.loading = false;
    vm.page = vm.$transition$.params().page;
  };

  // Get the unread count on load
  getUnreadCount();

  /**
   * @name getUnreadCount
   * @description Function to get the unread count of participants for the
   * logged in user
   */
  function getUnreadCount() {
    Participants.getUnreadCount().then(function (count) {
      Events.newMessagesCount = count;
    });
  }

  /**
   * @name loadConversation
   * @description Function to select a conversation and get the appointment and
   * project
   * @param {type} participant The participant to update
   */
  function loadConversation(participant) {
    $state.go('inkfinder.messages.conversations', { conversationId: participant.conversation });
    var formattedParticipant = {
      id: participant.id,
      last_read_date: moment.utc().format('YYYY-MM-DDTHH:mm:ss')
    };
    Participants.update(formattedParticipant);
  }

  /**
   * @name archive
   * @description Function to update the the read boolean and last read date for
   * a participant effectively archiving the participant object
   * @param {array} participant The participant to archive
   */
  function archive(participant) {
    // read:true is how we flag an archived message
    participant.read = true;
    // Set the last read date to now when archiving
    participant.last_read_date = moment.utc().format('YYYY-MM-DDTHH:mm:ss');
    Participants.update(participant).then(function (updatedParticipant) {
      _.remove(vm.participants.results, function (participant) {
        return participant.id === updatedParticipant.id;
      });
      var type = 'inbox';
      getParticipants(type);
    });
  }

  /**
   * @name unArchive
   * @description Function to update the the read boolean and last read date for
   * a participant to move it to the inbox
   * @param {array} participant The participant to unarchive
   */
  function unArchive(participant) {
    // read:true is how we flag an archived message
    participant.read = false;
    // Set the last read date to now when archiving
    participant.last_read_date = moment.utc().format('YYYY-MM-DDTHH:mm:ss');
    Participants.update(participant).then(function (updatedParticipant) {
      _.remove(vm.participants.results, function (participant) {
        return participant.id === updatedParticipant.id;
      });
      var type = 'archive';
      getParticipants(type);
    });
  }

  /**
   * @name getNewParticipants
   * @description Function to get archived participants. This is called when
   * this controller loads so participants with unread messages load first.
   * @param {string} type The type of participants to get. Inbox or Archive.
   */
  function getParticipants(type) {
    vm.loading = true;
    var collectorId = Session.collector.id;
    var conversationId = void 0;
    var appointmentId = void 0;
    var read = 'False';
    if (type === 'archive') {
      read = 'True';
    }
    var page = getCurrentPage();
    var sort = 'last_message_date';
    var lastMessage = 'notnull';
    Participants.get(conversationId, appointmentId, collectorId, read, page, sort, lastMessage).then(function (participants) {
      vm.participants = participants;
      vm.loading = false;
      getUnreadCount();
    });
  }

  /**
   * @name getCurrentPage
   * @description Function to get the last page of results to avoid page not
   * found errors when calling the API
   * @return {string} Returns the page number (as a string) of the last page
   */
  function getCurrentPage() {
    if (vm.participants.results.length === 0 && vm.page > 1) {
      vm.page = (vm.page - 1).toString();
    }
    return vm.page;
  }

  /**
   * @name uiOnParamsChanged
   * @description A ui-router function callback when param values change.
   * @param {object} newParams The params change
   */
  function uiOnParamsChanged(newParams) {
    vm.page = newParams.page;
    $state.go('.', { page: vm.page }, { reload: true });
  }

  /**
   * @name loadPage
   * @description Updates the page number and calls $state.go to update the URL
   * with the new page number.
   * @param {number} page The new page number.
   */
  function loadPage(page) {
    vm.page = page.toString();
    $state.go('.', { page: vm.page }, { reload: true });
  }
}

angular.module('inkfinder').controller('MessagesController', MessagesController);

/***/ }),

/***/ "./components/messages/messages.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formatMessages = __webpack_require__("./utils/format-messages.js");

var _formatMessages2 = _interopRequireDefault(_formatMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('inkfinder').factory('Messages', ['$q', '$http', 'ENDPOINT', 'AlertMessages', 'filterFilter', 'Session', function Messages($q, $http, ENDPOINT, AlertMessages, filterFilter, Session) {
  // Public functions
  Messages.create = create;
  Messages.get = get;

  /**
   * @name get
   * @description Function to get a conversation from the api
   * @param {number} conversationId The ID number of the converstation to
   * retrieve
   * @param {number} appointmentId The ID of the appointment of the conversation
   * @param {number} collectorId The ID of the logged in collector
   * @return {object} data Returns the conversation object.
   */
  function get(conversationId, appointmentId, collectorId) {
    var url = ENDPOINT.server + 'conversations/api/v1.1/messages/';
    var role = Session.activeState.role;
    url += '?role=' + role;
    if (conversationId) {
      url += '&conversation_id=' + conversationId;
    }
    if (appointmentId) {
      url += '&appointment_id=' + appointmentId;
    }
    if (collectorId) {
      url += '&collector_id=' + collectorId;
    }
    return $http.get(url).then(function (response) {
      var formattedMessaged = (0, _formatMessages2.default)(response.data);
      return formattedMessaged;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name create
   * @description create a Message
   * @param {object} message The message to create.
   * @return {object} Returns the new message object.
   */
  function create(message) {
    message.role = Session.activeState.role;
    if (Session.activeState.association) {
      message.association_id = Session.activeState.association.id;
    }
    return $http.post(ENDPOINT.server + 'conversations/api/v1.1/messages/', message).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Messages;
}]);

/***/ }),

/***/ "./components/messages/messages.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=container> <div class=row> <div class=col-sm-12> <div ng-if=!$ctrl.participants.results.length> <p>No messages found.</p> </div> <div ng-if=\"$ctrl.participants.results.length && $ctrl.messagesType === 'inbox'\"> <div class=row> <div class=\"col-xs-6 col-sm-7 col-md-7\"> <h6>You have <ng-pluralize count=$ctrl.events.newMessagesCount when=\"{'0': 'no new messages',\n                'one': '1 new message',\n                'other': '{} new messages'}\"> </ng-pluralize> out of {{$ctrl.participants.count}} total messages. </h6> </div> <div class=\"col-xs-6 col-sm-5 col-md-3 right\"> <button class=\"button small shop-solid\" ng-click=\"$ctrl.getParticipants('inbox')\" ng-disabled=$ctrl.newLoading> <fa name=spinner spin ng-if=$ctrl.loading></fa> Get new messages </button> </div> <div class=col-xs-12> <div class=\"divider small xxtight transparent\"></div> </div> </div> </div> <div class=\"list conversations\"> <div dir-paginate=\"participant in $ctrl.participants.results | itemsPerPage: 10 track by participant.id\" total-items=$ctrl.participants.count current-page=$ctrl.page> <div class=\"row conversation-wrapper\"> <div class=\"col-xs-12 col-sm-12 col-md-10\"> <a class=\"item conversation\" ng-click=$ctrl.loadConversation(participant) ng-class=\"{'new': participant.last_read_date < participant.last_message_date}\"> <div class=row> <div class=\"col-xs-3 col-sm-1\"> <ink-profile-photo profile=participant.last_message.collector image-id=participant.last_message.collector.profile_photo show-name=false size=\"'standard'\"> </ink-profile-photo> </div> <div class=\"col-xs-3 col-sm-3\"> <p> {{participant.last_message.collector.first_name}} {{participant.last_message.collector.last_name}}<br/> <small class=\"datetime capitalize\" am-time-ago=\"participant.last_message.created | amUtc | amLocal\"></small> </p> </div> <div class=\"col-xs-6 col-sm-8\"> <label class=stacked><small>Latest message</small></label> <p> {{participant.last_message.content | cut:false:140:'...'}} </p> </div> </div> </a> </div> <div class=\"col-xs-12 col-md-2 conversation__actions\"> <button class=\"button small finder-solid\" ng-if=\"$ctrl.messagesType === 'inbox'\" ng-click=$ctrl.archive(participant)> <fa name=archive></fa> Archive </button> <button class=\"button small finder-solid\" ng-if=\"$ctrl.messagesType === 'archive'\" ng-click=$ctrl.unArchive(participant)> <fa name=archive></fa> Unarchive </button> </div> </div> <div class=clearfix></div> </div> </div> <div class=\"button-container margin\"> <dir-pagination-controls max-size=7; on-page-change=$ctrl.loadPage(newPageNumber)> </dir-pagination-controls> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/messages/participants/_participants.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510213
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/messages/participants/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/messages/participants/util/group-participants.service.js");

__webpack_require__("./components/messages/participants/participants.component.js");

__webpack_require__("./components/messages/participants/participants.controller.js");

__webpack_require__("./components/messages/participants/participants.service.js");

__webpack_require__("./components/messages/participants/_participants.styles.scss");

/***/ }),

/***/ "./components/messages/participants/participants.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkParticipants = {
  bindings: {
    conversationId: '<',
    appointmentId: '<',
    artist: '<',
    collector: '<'
  },
  controller: 'ParticipantsController',
  template: __webpack_require__("./components/messages/participants/participants.template.html")
};

angular.module('inkfinder').component('inkParticipants', inkParticipants);

/***/ }),

/***/ "./components/messages/participants/participants.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ParticipantsController.$inject = ['Participants', 'Collector', 'Operators', 'Session', 'moment', '$log', '$q', '$rootScope', '_'];


/**
 * @name ParticipantsController
 * @description Controller for participants
 * @param {service} Participants The Participants service
 * @param {service} Collector The Collector service
 * @param {service} Operators The Operators service
 * @param {service} Session The Session service
 * @param {library} moment The moment library
 * @param {service} $log The Angular $log service
 * @param {service} $q The Angular $q service
 * @param {service} $rootScope The Angular $rootScope service
 * @param {service} _ The Lodash library
 */
function ParticipantsController(Participants, Collector, Operators, Session, moment, $log, $q, $rootScope, _) {
  var vm = this;

  vm.$onInit = function () {
    vm.participants = [];
    vm.possibleParticipants = [];
    vm.toggle = toggle;
    vm.session = Session;
    vm.isParticipantsCollapsed = true;
  };

  vm.$onChanges = function (changes) {
    if (!_.isUndefined(changes.conversationId) && !_.isUndefined(changes.conversationId.currentValue) && !_.isUndefined(vm.appointmentId)) {
      var conversationId = changes.conversationId.currentValue;
      get(conversationId, vm.appointmentId);
    } else if (!_.isUndefined(vm.appointmentId) && !_.isUndefined(vm.conversationId)) {
      get(vm.conversationId, vm.appointmentId);
    }
  };

  /**
   * @name get
   * @description Function to get a list of participants
   * @param {number} conversationId The ID of the conversation to retrieve
   * @param {number} appointmentId The ID of the appointment for the
   * conversation
   */
  function get(conversationId, appointmentId) {
    var collectorId = void 0;
    Participants.get(conversationId, appointmentId, collectorId).then(function (participants) {
      var promises = [];
      _.each(participants, function (participant) {
        var promise = Collector.getCollector(participant.collector).then(function (collector) {
          participant.collector = collector;
          participant.active = true;
          participant.isArtist = false;
          participant.isProjectOwner = false;
          if (!_.isUndefined(vm.artist) && vm.artist !== null && vm.artist.id === participant.collector.id) {
            participant.isArtist = true;
          }
          if (!_.isUndefined(vm.collector) && vm.collector.id === participant.collector.id) {
            participant.isProjectOwner = true;
          }
          return participant;
        });
        promises.push(promise);
      });
      if (Session.activeState.role === 'operator') {
        var operatorsPromise = Operators.getAllForShop(Session.activeState.association.shop.id).then(function (operators) {
          var newOperators = [];
          _.each(operators.confirmed, function (operator) {
            var newOperator = {
              collector: operator,
              isOperator: true,
              active: false
            };
            newOperator.isArtist = false;
            newOperator.isProjectOwner = false;
            if (!_.isUndefined(vm.artist) && vm.artist !== null && newOperator.collector.id === vm.artist.id) {
              newOperator.isArtist = true;
            }
            if (!_.isUndefined(vm.collector) && newOperator.collector.id === vm.collector.id) {
              newOperator.isProjectOwner = true;
            }
            newOperators.push(newOperator);
          });
          return newOperators;
        });
        promises.push(operatorsPromise);
      }

      // Get the results
      $q.all(promises).then(function (results) {
        var flatResults = _.union(_.flatten(results));
        vm.participants = _.uniqBy(flatResults, function (flatResult) {
          return flatResult.collector.id;
        });
        if (!_.isUndefined(vm.artist) && vm.artist !== null) {
          var hasArtist = _.some(vm.participants, function (participant) {
            return vm.artist.id === participant.collector.id;
          });
          if (!hasArtist) {
            vm.participants.push({
              isArtist: true,
              collector: vm.artist,
              active: false
            });
          }
        }
        var hasCollector = void 0;
        if (!_.isUndefined(vm.collector)) {
          hasCollector = _.some(vm.participants, function (participant) {
            return vm.collector.id === participant.collector.id;
          });
        }
        if (!hasCollector) {
          vm.participants.push({
            isProjectOwner: true,
            collector: vm.collector,
            active: false
          });
        }
        vm.totalParticipants = vm.participants.length;
        vm.activeParticipants = _.countBy(vm.participants, function (participant) {
          return participant.active;
        });
        if (_.isUndefined(vm.activeParticipants.true)) {
          vm.activeParticipants.true = 0;
        }
        $log.debug('All participants', vm.participants);
      });
    });
  }

  /**
   * @name toggle
   * @description Function to create or delete a participant
   * @param {array} participant The participate to create or delete
   */
  function toggle(participant) {
    if (participant.active === true) {
      // Delete the participant
      Participants.remove(participant.id).then(function () {
        get(vm.conversationId);
      });
    } else if (participant.active === false) {
      // Create a new participant
      var preparedParticipant = {
        role: Session.activeState.role,
        conversation_id: vm.conversationId,
        collector_id: participant.collector.id,
        appointment_id: vm.appointmentId,
        last_read_date: moment().format('YYYY-MM-DDTHH:mm:ss')
      };
      Participants.create(preparedParticipant).then(function () {
        get(vm.conversationId);
      });
    }
  }

  var deregister = $rootScope.$on('refresh-participants', function () {
    get(vm.conversationId, vm.appointmentId);
  });
  $rootScope.$on('$destroy', deregister);
}

angular.module('inkfinder').controller('ParticipantsController', ParticipantsController);

/***/ }),

/***/ "./components/messages/participants/participants.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Participants.$inject = ['$http', 'ENDPOINT', 'AlertMessages', 'Session', 'Events', '_'];
/**
 * @name Participants
 * @description Function for the participants service
 * @param {type} $http Description
 * @param {constant} ENDPOINT Description
 * @param {service} AlertMessages Description
 * @param {service} Session Description
 * @param {service} Events The Events service
 * @param {library} _ The Lodash libary
 * @return {object} Returns the service
 */
function Participants($http, ENDPOINT, AlertMessages, Session, Events, _) {
  // Public functions
  Participants.get = get;
  Participants.create = create;
  Participants.update = update;
  Participants.remove = remove;
  Participants.getUnreadCount = getUnreadCount;

  /**
   * @name get
   * @description Function to get an array of participans of a
   * conversation
   * @param {number} conversationId The ID of the converstation to
   * retrieve the participants
   * @param {number} appointmentId The ID of the appointment to
   * retrieve the participants
   * @param {number} collectorId The ID of the collector to
   * retrieve the participants
   * @param {boolean} read The boolean for the read field filter
   * @param {number} page The page number of the paginated results
   * @param {string} sort Field to sort by
   * @param {string} last_message Filter by the last_message field. Options are
   * `notnull`
   * @return {array} Returns the an array of participants
   */
  function get(conversationId, appointmentId, collectorId, read, page, sort, last_message) {
    var url = ENDPOINT.server + 'conversations/api/v1.1/participants/';
    var role = Session.activeState.role;
    url += '?role=' + role;
    if (conversationId) {
      url += '&conversation_id=' + conversationId;
    }
    if (appointmentId) {
      url += '&appointment_id=' + appointmentId;
    }
    if (collectorId) {
      url += '&collector_id=' + collectorId;
    }
    if (!_.isUndefined(read)) {
      url += '&read=' + read;
    }
    if (!_.isUndefined(page)) {
      url += '&page=' + page;
    }
    if (!_.isUndefined(sort)) {
      url += '&sort=' + sort;
    }
    if (!_.isUndefined(last_message)) {
      url += '&last_message=' + last_message;
    }
    if (Session.activeState.association) {
      var associationId = Session.activeState.association.id;
      url += '&association_id=' + associationId;
    }
    return $http.get(url).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name create
   * @description Function to create a participant
   * @param {object} participant The participant to create
   * @return {object} Returns the participant
   */
  function create(participant) {
    return $http.post(ENDPOINT.server + 'conversations/api/v1.1/participants/', participant).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name update
   * @description Function to update a participant
   * @param {object} participant The participant to update
   * @return {object} Returns the participant
   */
  function update(participant) {
    return $http.put(ENDPOINT.server + 'conversations/api/v1.1/participants/' + participant.id + '/', participant).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name remove
   * @description Function to delete a participant
   * @param {object} participantId The participant to delete
   * @return {object} Returns the function
   */
  function remove(participantId) {
    return $http.delete(ENDPOINT.server + 'conversations/api/v1.1/participants/' + participantId + '/').then(function () {
      // Intentionally left blank
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getUnreadCount
   * @description Function to get an unread count for participants
   * @return {string} Returns the count
   */
  function getUnreadCount() {
    var url = ENDPOINT.server + 'conversations/api/v1.1/participants/?unread_count=true';
    var role = Session.activeState.role;
    url += '&role=' + role;
    if (Session.activeState.association) {
      var associationId = Session.activeState.association.id;
      url += '&association_id=' + associationId;
    }
    return $http.get(url).then(function (response) {
      return response.data;
    });
  }
  return Participants;
}

angular.module('inkfinder').factory('Participants', Participants);

/***/ }),

/***/ "./components/messages/participants/participants.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=participants> <div class=row> <div class=col-sm-12 ng-if=$ctrl.totalParticipants> <p> {{$ctrl.activeParticipants.true}} out of {{$ctrl.totalParticipants}} people are subscribed to this appointment&nbsp; <button class=\"button small finder-solid\" ng-click=\"$ctrl.isParticipantsCollapsed = !$ctrl.isParticipantsCollapsed\"> <span ng-if=$ctrl.isParticipantsCollapsed>Change</span> <span ng-if=!$ctrl.isParticipantsCollapsed>Close</span> </button> </p> <div uib-collapse=$ctrl.isParticipantsCollapsed> <p> <small> The people selected will be notified by email every time a message is added. </small> </p> <div class=\"list profiles left\"> <div class=\"item profile\" ng-repeat=\"participant in $ctrl.participants | orderBy:['-isProjectOwner','-isArtist','collector.last_name'] track by participant.collector.id\"> <div class=participant ng-class=\"{'active': participant.active}\"> <ink-profile-photo show-name=true image-id=participant.collector.profile_photo size=\"'standard'\" profile=participant.collector class=center selected=participant.active selectable=\"($ctrl.session.activeState.role === 'operator' || $ctrl.session.collector.id === participant.collector.id) && (!participant.isProjectOwner && !participant.isArtist)\" locked=\"$ctrl.session.collector.id !== participant.collector.id && ($ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'collector') || (participant.isArtist || participant.isProjectOwner)\" show-email-confirmation=true click=$ctrl.toggle(participant)> </ink-profile-photo> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/messages/participants/util/group-participants.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('GroupParticipants', ['Session', 'Messages', 'Conversations', '_', '$log', 'moment', function GroupParticipants(Session, Messages, Conversations, _, $log, moment) {
  // Public methods
  GroupParticipants.group = group;

  /**
   * @name filter
   * @description Filter the participants by comparing the date of the last
   * message to the last read date.
   * @param {array} participants The array of participants to filter
   * @return {array} Returns an array of filtered messages
   */
  function group(participants) {
    var newParticipants = [];

    // Filter out all participants with no last message object
    var participantsWithLastMessages = _.filter(participants, function (participant) {
      return participant.last_message !== null;
    });

    // Ordering to get the latest message
    newParticipants = _.orderBy(participantsWithLastMessages, [function (participant) {
      if (participant.last_message) {
        return participant.last_message.created;
      }
    }], ['desc']);
    return newParticipants;
  }
  return GroupParticipants;
}]);

/***/ }),

/***/ "./components/notifications/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/notifications/notifications.service.js");

/***/ }),

/***/ "./components/notifications/notifications.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Notification', ['$http', 'ENDPOINT', 'AlertMessages', 'RESPONSE_MESSAGES', function Notification($http, ENDPOINT, AlertMessages, RESPONSE_MESSAGES) {
  // Public Methods
  Notification.send = send;

  /**
    * @name sendNotification
    * @descriptions This function sends email notifications to users
    * @param {object} notification The notification to send
    * @return {object} Returns the Notification object
    */
  function send(notification) {
    return $http.post(ENDPOINT.server + 'emails/api/v1.1/notify/', notification).then(function (response) {
      // Add if statement here to check the contents of the messages being sent
      if (response.data.includes('We couldn')) {
        AlertMessages.add({
          msg: response,
          type: 'warning'
        });
      } else {
        AlertMessages.add({
          msg: response,
          type: 'success'
        });
      }
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger' });
      throw error;
    });
  }
  return Notification;
}]);

/***/ }),

/***/ "./components/profile/_profile.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508661
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/profile/_shop-hours.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508685
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/profile/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/profile/profile.component.js");

__webpack_require__("./components/profile/profile.controller.js");

__webpack_require__("./components/profile/_profile.styles.scss");

__webpack_require__("./components/profile/_shop-hours.scss");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('profile', {
    url: '/{username}',
    abstract: true,
    views: {
      '@': {
        component: 'inkProfile'
      }
    },
    resolve: {
      $title: ['provider', '_', function $title(provider, _) {
        if (!_.isUndefined(provider)) {
          return _.isUndefined(provider.name) ? provider.first_name + ' ' + provider.last_name : provider.name;
        }
        return 'Not found';
      }],
      provider: ['$stateParams', '$q', 'Collector', 'Shop', '_', function provider($stateParams, $q, Collector, Shop, _) {
        var results = {
          usernames: []
        };
        var formattedUsername = $stateParams.username.toLowerCase();
        if (formattedUsername !== '' && formattedUsername.match(/^[a-z0-9]*$/)) {
          return $q.all([Collector.getCollectors(formattedUsername), Shop.getShops(formattedUsername)]).then(function (usernames) {
            results.usernames = _.merge(usernames[0], usernames[1]);
            return results.usernames[0];
          });
        }
        return $q(function (resolve, reject) {
          resolve(results.usernames[0]);
        });
      }]
    },
    params: {
      username: { dynamic: true }
    },
    onEnter: ['Events', function onEnter(Events) {
      Events.secondaryNavActive = true;
    }],
    onExit: ['Events', function onExit(Events) {
      Events.secondaryNavActive = false;
    }]
  })

  // This is the default state based on the blank URL value.
  .state('profile.appointment', {
    url: '',
    views: {
      profile: {
        component: 'inkAddProject'
      }
    }
  });
}]);

/***/ }),

/***/ "./components/profile/profile.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkProfile = {
  controller: 'ProfileController',
  bindings: {
    provider: '<'
  },
  template: __webpack_require__("./components/profile/profile.template.html")
};

angular.module('inkfinder').component('inkProfile', inkProfile);

/***/ }),

/***/ "./components/profile/profile.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ProfileController.$inject = ['Association', 'ShopHours', 'FormatShopHoursDescription', '_', '$log'];


/**
 * @name AppointmentController
 * @description Controller called to displa and manage appointment details.
 * @param {Unknown} Association Service to get associations
 * @param {Unknown} ShopHours Service to get shop data
 * @param {Unknown} FormatShopHoursDescription Service to format the shop hours description
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 */
function ProfileController(Association, ShopHours, FormatShopHoursDescription, _, $log) {
  var vm = this;
  $log.debug('Provider: ', vm.provider);

  // Determine the provider status. If the provider is undefined, we'll show
  // a 'Page not availabe' message. If the provider is a collector or artist,
  // we'll show a content not avaiable message. If it's a shop, we'll show the
  // shop profile
  if (_.isUndefined(vm.provider)) {
    vm.providerStatus = 'notFound';
  } else if (_.has(vm.provider, 'first_name') && vm.provider.artist) {
    vm.providerStatus = 'artist';
  } else if (_.has(vm.provider, 'first_name') && !vm.provider.artist) {
    vm.providerStatus = 'collector';
  } else if (_.has(vm.provider, 'name')) {
    // vm.providerStatus = 'shop'; <-- hidden for now
    // getShopArtists(vm.provider.id); <-- hidden for now
    // getShopHours(vm.provider.id); <-- hidden for now
    vm.providerStatus = 'notFound'; // Show not found for shop profiles till we
    // release this functionality
  }

  // /**
  //  * @name getShopArtists
  //  * @description Function to get shop artists from the associations api
  //  * @param {number} shopId The ID of the shop to filter by
  //  */
  // function getShopArtists(shopId) {
  //   Association.getShopAssociations(shopId)
  //   .then(function(associations) {
  //     vm.provider.artists = associations.artists;
  //   });
  // }

  // /**
  //  * @name getShopHours
  //  * @description Function to get shop hours
  //  * @param {number} shopId The ID of the shop to filter by
  //  */
  // function getShopHours(shopId) {
  //   ShopHours.get(shopId).then(function(hours) {
  //     vm.provider.hours = FormatShopHoursDescription.format(hours.current);
  //   });
  // }
}

angular.module('inkfinder').controller('ProfileController', ProfileController);

/***/ }),

/***/ "./components/profile/profile.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"profile section background-dark\"> <div class=background-photo></div> <div ng-if=\"$ctrl.providerStatus === 'notFound'\"> <div class=container> <div class=row> <div class=col-sm-12> <div class=\"intro center no-padding-bottom\"> <ink-403></ink-403> </div> </div> </div> </div> </div> <div ng-if=\"$ctrl.providerStatus === 'artist' || $ctrl.providerStatus === 'collector'\"> <div class=container> <div class=row> <div class=col-sm-12> <div class=\"intro center no-padding-bottom\"> <ink-404></ink-404> </div> </div> </div> </div> </div> <div ng-if=\"$ctrl.providerStatus === 'shop'\"> <div class=\"region-sidebar secondary\"> <ink-profile-photo image-id=$ctrl.provider.profile_logo editable=false type=\"'shop'\" size=\"'large'\"> </ink-profile-photo> <h6>{{$ctrl.provider.name}}</h6> <p> </p><div><label>Address</label></div> <small> {{$ctrl.provider.address}}<br/> {{$ctrl.provider.city}}, {{$ctrl.provider.state}} {{$ctrl.provider.zip}} {{$ctrl.provider.city}} </small> <p></p> <p> </p><div><label>Hours</label></div> <small> {{$ctrl.provider.hours}} </small> <p></p> </div> <div class=container-fluid> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <div ui-view=profile></div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/progress/_progress.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508647
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/progress/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/progress/progress.component.js");

__webpack_require__("./components/progress/_progress.styles.scss");

/***/ }),

/***/ "./components/progress/progress.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkProgress = {
  bindings: {
    steps: '<',
    activeStep: '<',
    title: '<?',
    description: '<?'
  },
  template: __webpack_require__("./components/progress/progress.template.html"),
  controller: ['_', function controller(_) {
    // this.stepWidth = (100 / this.steps.length) + '%';
    this.stepWidth = _.isUndefined(this.steps) ? true : 100 / this.steps.length + '%';
    this.title = _.isUndefined(this.title) ? true : this.title;
    this.description = _.isUndefined(this.description) ? true : this.description;
  }]
};

angular.module('inkfinder').component('inkProgress', inkProgress);

/***/ }),

/***/ "./components/progress/progress.template.html":
/***/ (function(module, exports) {

module.exports = " <div class=progress-steps> <ul> <li class=progress-steps-step ng-class=\"{\n        'active': step.id === $ctrl.activeStep.id,\n        'complete': step.id < $ctrl.activeStep.id,\n        'last': $last\n      }\" ng-style=\"{width: $last ? '0' : $ctrl.stepWidth}\" ng-repeat=\"step in $ctrl.steps track by step.id\"> <div class=\"progress-steps-line transition\"></div> <div class=progress-steps-line></div> <div class=progress-steps-circle></div> <div class=\"progress-steps-circle transition\"></div> </li> </ul> <div class=row> <div class=\"col-md-8 col-md-offset-2 sm-col-10 sm-col-offset-1\"> <h4 class=center ng-if=$ctrl.title>{{$ctrl.activeStep.title}}</h4> <p ng-if=\"$ctrl.activeStep.description && $ctrl.description\"><small>{{$ctrl.activeStep.description}}</small></p> </div> </div> </div> ";

/***/ }),

/***/ "./components/projects/cards/_project-cards.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510563
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/projects/cards/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/projects/cards/project-cards.component.js");

__webpack_require__("./components/projects/cards/_project-cards.styles.scss");

/***/ }),

/***/ "./components/projects/cards/project-cards.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkProjectCard = {
  bindings: {
    card: '<',
    showFullDatetime: '<?',
    showEstimate: '<?',
    showArtist: '<?',
    showCollector: '<?',
    showDetails: '<?',
    showName: '<?',
    showStyle: '<?'
  },
  controller: ['Session', '_', function controller(Session, _) {
    this.showEstimate = _.isUndefined(this.showEstimate) ? true : this.showEstimate;
    if (_.isUndefined(this.showArtist) && Session.activeState && Session.activeState.role === 'artist') {
      this.showArtist = false;
    } else if (_.isUndefined(this.showArtist) && Session.activeState && Session.activeState.role !== 'artist') {
      this.showArtist = true;
    }
    this.showCollector = _.isUndefined(this.showCollector) ? true : this.showCollector;
    this.showDetails = _.isUndefined(this.showDetails) ? true : this.showDetails;
    this.showStyle = _.isUndefined(this.showStyle) ? true : this.showStyle;
    this.showEstimate = _.isUndefined(this.showEstimate) ? true : this.showEstimate;
    this.showName = _.isUndefined(this.showName) ? false : this.showName;
  }],
  template: __webpack_require__("./components/projects/cards/project-cards.template.html")
};

angular.module('inkfinder').component('inkProjectCard', inkProjectCard);

/***/ }),

/***/ "./components/projects/cards/project-cards.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=project-background ng-style=\"{'background-image':'url(' + $ctrl.card.project.referenceImage + ')'}\" ng-class=\"{'no-photo': !$ctrl.card.project.referenceImage}\"> <div class=project-overlay> <div class=timebox ng-if=\"$ctrl.card.appointment.startTime && $ctrl.card.appointment.endTime\"> <div class=day-date><span ng-if=\"$ctrl.showFullDatetime && $ctrl.card.appointment.appointment_datetime\">{{$ctrl.card.appointment.appointment_datetime | amDateFormat:'MM/DD/YY'}} from </span>{{$ctrl.card.appointment.startTime}} - {{$ctrl.card.appointment.endTime}}</div> </div> <div class=details> <div class=profiles-wrapper ng-if=\"$ctrl.showCollector === true || $ctrl.showArtist === true\"> <div ng-if=\"$ctrl.showCollector === true && $ctrl.showArtist === true\"> <ink-profile-photo show-name=false profile=$ctrl.card.project.collector image-id=$ctrl.card.project.collector.profile_photo></ink-profile-photo> <ink-profile-photo ng-if=$ctrl.card.appointment.artist type=\"'artist'\" size=\"'small'\" show-name=false profile=$ctrl.card.appointment.artist image-id=$ctrl.card.appointment.artist.profile_photo></ink-profile-photo> </div> <div ng-if=\"$ctrl.showCollector === true && $ctrl.showArtist === false\"> <ink-profile-photo show-name=false profile=$ctrl.card.project.collector image-id=$ctrl.card.project.collector.profile_photo></ink-profile-photo> </div> <div ng-if=\"$ctrl.showCollector === false && $ctrl.showArtist === true\"> <ink-profile-photo ng-if=\"$ctrl.card.appointment.artist && $ctrl.showArtist === true\" type=\"'artist'\" show-name=false profile=$ctrl.card.appointment.artist image-id=$ctrl.card.appointment.artist.profile_photo></ink-profile-photo> </div> </div> <div class=details-wrapper ng-class=\"{'center': (!$ctrl.card.appointment.artist || $ctrl.showArtist === false) && (!$ctrl.card.project.collector || $ctrl.showCollector === false)}\"> <h5 ng-if=\"$ctrl.showCollector === true && $ctrl.showName === false\">{{$ctrl.card.project.collector.first_name}} {{$ctrl.card.project.collector.last_name}}</h5> <h5 ng-if=\"$ctrl.showName === true\">{{$ctrl.card.project.name}}</h5> <p ng-if=\"$ctrl.card.appointment.artist.id && $ctrl.showArtist === true\"> <small>with</small> {{$ctrl.card.appointment.artist.first_name}} {{$ctrl.card.appointment.artist.last_name}} </p> <small ng-if=\"$ctrl.showDetails === true\"> <span class=detail ng-if=\"$ctrl.card.project.size.measurement || $ctrl.card.project.area.location.name\"> <span ng-if=\"$ctrl.card.project.width && $ctrl.card.project.width\">{{$ctrl.card.project.width}}\" x {{$ctrl.card.project.height}}\"</span> <span ng-if=$ctrl.card.project.area.location.name>on</span> {{$ctrl.card.project.area.location.name}} </span> <span class=detail ng-if=\"$ctrl.showEstimate && $ctrl.card.appointment.estimate_min > 0\"> <span ng-if=\"($ctrl.card.project.area.location.name || $ctrl.card.project.size.measurement) && ($ctrl.card.appointment.estimate_min || $ctrl.card.appointment.estimate_max)\"><br/></span> <span ng-if=\"$ctrl.card.appointment.current_status === 40 || $ctrl.card.appointment.current_status === 50\"> {{$ctrl.card.appointment.estimate_min | noFractionCurrency}} <span ng-if=$ctrl.card.appointment.estimate_max>–</span> {{$ctrl.card.appointment.estimate_max | noFractionCurrency}} </span> <span ng-if=\"$ctrl.card.appointment.current_status === 70\"> Price: {{$ctrl.card.appointment.price | noFractionCurrency}} </span> </span> <span class=detail ng-if=\"$ctrl.showStyle && $ctrl.card.project.style\"> {{$ctrl.card.project.style.name}} </span> </small> </div> </div> </div> <div class=project-card__statuses> <ink-appointment-statuses appointment=$ctrl.card.appointment></ink-appointment-statuses> </div> </div> ";

/***/ }),

/***/ "./components/projects/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/projects/cards/index.js");

__webpack_require__("./components/projects/project/index.js");

__webpack_require__("./components/projects/util/format-projects.service.js");

__webpack_require__("./components/projects/projects.component.js");

__webpack_require__("./components/projects/projects.controller.js");

__webpack_require__("./components/projects/projects.service.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.projects', {
    url: '/projects',
    views: {
      '@': {
        component: 'inkProjects'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Your projects';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/projects/project/_project.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510177
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/projects/project/add/_add-project.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508309
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/projects/project/add/add-project.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAddProject = {
  controller: 'AddProjectController',
  template: __webpack_require__("./components/projects/project/add/add-project.template.html"),
  bindings: {
    onComplete: '&'
  }
};

angular.module('inkfinder').component('inkAddProject', inkAddProject);

/***/ }),

/***/ "./components/projects/project/add/add-project.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formatProjectApi = __webpack_require__("./utils/format-project-api.js");

var _formatProjectApi2 = _interopRequireDefault(_formatProjectApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

AddProjectController.$inject = ['_', '$log', 'StyleFactory', 'filterFilter', 'Project', 'FormatProject', '$document'];


/**
 * @name AddProjectController
 * @description Controller called by the add project component.
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 * @param {Unknown} StyleFactory The style service
 * @param {Unknown} filterFilter The filter service
 * @param {Unknown} Project The project service
 * @param {Unknown} FormatProject The format project service
 * @param {Unknown} $document The Angular $document service
 */
function AddProjectController(_, $log, StyleFactory, filterFilter, Project, FormatProject, $document) {
  var vm = this;
  vm.$onInit = function () {
    vm.steps = [{
      id: 1,
      name: 'description',
      title: 'Describe your project',
      description: 'Give your project a name and describe your concept with as\n        much detail as possible.'
    }, {
      id: 2,
      name: 'reference-photos',
      title: 'Add reference photos',
      description: 'Good reference photos will help show your artist your\n        vision and communicate the details you\u2019re looking for in your project.\n        Upload as many as you need.'
    }, {
      id: 3,
      name: 'location',
      title: 'Add a location',
      description: 'Select the area on your body where you\u2019d like your new\n        tattoo and send photos of the area to allow your artist to plan\n        properly.'
    }, {
      id: 4,
      name: 'body-placement',
      title: 'Add placement photos',
      description: 'Show your artist the area on your body where you want your\n        tattoo. If you want to cover-up an existing tattoo, be sure to send a\n        clear photo of your existing tattoo.'
    }, {
      id: 5,
      name: 'size',
      title: 'Select a size',
      description: 'Select the ideal size for your project. Remember, smaller\n        sizes require less detail and aren\u2019t always quick to produce.'
    }, {
      id: 6,
      name: 'style',
      title: 'Define your style',
      description: 'Select a color profile and style for your art. Some\n        artists are better at certain styles, so be sure the style you like\n        matches well with the artist you want.'
    }, {
      id: 7,
      name: 'confirmation',
      title: 'Confirm your project',
      description: 'Give your project a quick look. You can always update it\n        later, if needed.'
    }];
    vm.newProject = {
      appointments: []
    };
    vm.referenceImages = [];
    vm.coverupImages = [];
    vm.selectedSize = '';
    vm.activeStep = _.find(vm.steps, { name: 'description' });
    vm.nextStep = nextStep;
    vm.previousStep = previousStep;
    vm.startOver = startOver;
    vm.getOptions = getOptions;
    vm.processSize = processSize;
    vm.selectStyle = selectStyle;
    vm.addProject = addProject;
    vm.top = 0;
    vm.duration = 500; // milliseconds
    getOptions();
  };

  /**
   * @name prepareConfirmation
   * @description Function to prepare a confirmation step for the project
   */
  function prepareConfirmation() {
    var apiFormattedProject = (0, _formatProjectApi2.default)(vm.newProject);
    vm.formattedNewProject = {
      project: FormatProject.format(apiFormattedProject)
    };
    $log.debug('Formatted project: ', vm.formattedNewProject);
  }

  /**
   * @name nextStep
   * @description Function to advance the add project step
   * @param {object} activeStep The current step of the workflow
   */
  function nextStep(activeStep) {
    vm.activeStep = _.find(vm.steps, { id: activeStep.id + 1 });
    if (_.findLastIndex(vm.steps) === vm.activeStep.id - 1) {
      prepareConfirmation();
    }
    $document.scrollTop(vm.top, vm.duration);
  }

  /**
   * @name previousStep
   * @description Function to advance the add project step
   * @param {object} activeStep The current step of the workflow
   */
  function previousStep(activeStep) {
    vm.activeStep = _.find(vm.steps, { id: vm.activeStep.id - 1 });
    $document.scrollTop(vm.top, vm.duration);
  }

  /**
   * @name startOver
   * @description Function to start the process over again
   */
  function startOver() {
    vm.activeStep = _.find(vm.steps, { id: 1 });
  }

  /**
   * @name processSize
   * @description Select the Size
   * @param {object} size The select size
   */
  function processSize(size) {
    vm.newProject.size = _.find(vm.options.sizes, { id: size.id });
  }

  /**
   * @name getOptions
   * @description Get the Size/Placement/Area/Style Options
   */
  function getOptions() {
    Project.getOptions().then(function (options) {
      vm.options = options;
    });

    StyleFactory.getStyles().then(function (styles) {
      vm.styles = styles;
    });
  }

  /**
   * @name selectStyle
   * @description Function to set the style on newProject to the selected style
   * @param {object} style The selected style
   */
  function selectStyle(style) {
    vm.newProject.style = style;
  }

  /**
   * @name addProject
   * @description Function to push the finished project up to the parent
   * component
   * @param {object} project The project to push up
   */
  function addProject(project) {
    $log.debug('Completed project: ', project);
    vm.onComplete({ project: project });
  }
}

angular.module('inkfinder').controller('AddProjectController', AddProjectController);

/***/ }),

/***/ "./components/projects/project/add/add-project.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=row> <div class=col-sm-12> <ink-progress steps=$ctrl.steps active-step=$ctrl.activeStep></ink-progress> <div ng-switch=$ctrl.activeStep.name> <form name=addProjectForm ng-submit=\"addProjectForm.$valid && $ctrl.addProject($ctrl.newProject)\" novalidate> <div class=step-description ng-switch-default> <div class=form-group> <label for=project_name>Give your project a name</label> <input name=project_name id=project_name type=text class=form-control required ng-model=$ctrl.newProject.name> <div class=\"inline-message relative\"> <p class=\"message error absolute\" ng-if=\"addProjectForm.project_name.$invalid && !addProjectForm.project_name.$pristine\"> To help identify this project, give it a name. </p> </div> </div> <div class=form-group> <label for=tattoo_concept>Describe your concept <small>Optional</small></label> <textarea name=tattoo_concept id=tattoo_concept msd-elastic=\\n class=textarea ng-model=$ctrl.newProject.tattoo_concept>\n            </textarea> </div> <div class=\"button-container margin center\"> <a class=\"button large shop-solid equal-medium\" ng-click=$ctrl.nextStep($ctrl.activeStep) ng-disabled=addProjectForm.$invalid>Next</a> </div> </div> <div class=step-reference-photos ng-switch-when=reference-photos> <div class=row> <ink-file-upload images=$ctrl.referenceImages> </ink-file-upload> </div> <div class=\"button-container margin center\"> <a class=\"button large shop-solid equal-medium\" ng-click=$ctrl.nextStep($ctrl.activeStep) ng-disabled=addProjectForm.$invalid>Next</a> <a class=\"button large finder equal-medium\" ng-click=$ctrl.previousStep($ctrl.activeStep)>Back</a> </div> </div> <div class=step-location ng-switch-when=location> <div class=form-group> <label for=project_area>Select an area</label> <select name=project_area id=project_area ng-model=$ctrl.newProject.area ng-value=option.id ng-options=\"option.name for option in $ctrl.options.areas track by option.id\"> <option value=\"\">Choose one</option> </select> </div> <div class=form-group ng-show=$ctrl.newProject.area> <label for=project_location>Specific location</label> <select name=project_location id=project_location ng-required=$ctrl.newProject.area ng-model=$ctrl.newProject.area.location ng-disabled=!$ctrl.newProject.area ng-value=option.id ng-options=\"option.name for option in $ctrl.options.locations |\n                positionFilter:$ctrl.newProject.area.id track by option.id\"> <option value=\"\" selected=selected>Choose one</option> </select> </div> <div class=\"button-container margin center\"> <a class=\"button large shop-solid equal-medium\" ng-click=$ctrl.nextStep($ctrl.activeStep) ng-disabled=addProjectForm.$invalid>Next</a> <a class=\"button large finder equal-medium\" ng-click=$ctrl.previousStep($ctrl.activeStep)>Back</a> </div> </div> <div class=step-body-placement ng-switch-when=body-placement> <div class=form-group> <label> <input name=coverup type=checkbox id=coverup ng-model=$ctrl.newProject.coverup> I want to cover-up an existing tattoo </label> </div> <ink-file-upload images=$ctrl.coverupImages> </ink-file-upload> <div class=\"button-container margin center\"> <a class=\"button large shop-solid equal-medium\" ng-click=$ctrl.nextStep($ctrl.activeStep) ng-disabled=addProjectForm.$invalid>Next</a> <a class=\"button large finder equal-medium\" ng-click=$ctrl.previousStep($ctrl.activeStep)>Back</a> </div> </div> <div class=step-size ng-switch-when=size> <div class=\"form-group center\"> <a class=button-size ng-click=$ctrl.processSize(size) ng-class=\"{'selected': $ctrl.newProject.size.id === size.id}\" ng-repeat=\"size in $ctrl.options.sizes track by size.id\"> <div class=size-name>{{size.name}}</div> <div class=size-measurement><small>{{size.measurement}}</small></div> </a> <div class=clearfix></div> </div> <div class=\"button-container margin center\"> <a class=\"button large shop-solid equal-medium\" ng-click=$ctrl.nextStep($ctrl.activeStep) ng-disabled=addProjectForm.$invalid>Next</a> <a class=\"button large finder equal-medium\" ng-click=$ctrl.previousStep($ctrl.activeStep)>Back</a> </div> </div> <div class=step-style ng-switch-when=style> <div class=form-group> <label>Choose a color profile</label> <div class=\"input-group toggle\"> <div class=\"btn-group center\" data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.newProject.full_color === true}\"> <input type=radio name=color_options id=full_color ng-model=$ctrl.newProject.full_color ng-value=true> Full color </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.newProject.full_color === false}\"> <input type=radio name=color_options id=black_gray ng-model=$ctrl.newProject.full_color ng-value=false> Black and gray </label> </div> </div> </div> <div class=\"divider small tight\"></div> <label>Choose a style</label> <div class=styles> <div class=art-styles-wrapper ng-repeat=\"style in $ctrl.styles | orderBy: 'name' track by style.id\"> <a class=art-styles ng-class=\"{'selected': $ctrl.newProject.style.id === style.id}\" ng-click=$ctrl.selectStyle(style)> <div class=art-styles-background ng-if=style.image_1024 ng-style=\"{'background-image':'url(' + style.image_1024 + ')'}\"> <p class=name>{{style.name}}</p> </div> </a> <p><small>{{style.description}}</small></p> </div> </div> <div class=row ng-if=$ctrl.newProject.style> <div class=\"col-sm-12 center\"> <div class=\"divider small tight\"></div> <h6>You’ve selected {{$ctrl.newProject.style.name}}</h6> </div> </div> <div class=\"button-container margin center\"> <a class=\"button large shop-solid equal-medium\" ng-click=$ctrl.nextStep($ctrl.activeStep) ng-disabled=addProjectForm.$invalid>Next</a> <a class=\"button large finder equal-medium\" ng-click=$ctrl.previousStep($ctrl.activeStep)>Back</a> </div> </div> <div class=step-confirmation ng-switch-when=confirmation> <div class=\"list projects relative\"> <div class=\"item project\"> <ink-project-card card=$ctrl.formattedNewProject show-collector=true show-artist=false show-name=true> </ink-project-card> </div> </div> <div class=row> <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"divider small tight\"></div> <h6>Project description</h6> <p><strong>Name:</strong> {{$ctrl.formattedNewProject.project.name}}</p> <p><strong>Concept:</strong> {{$ctrl.formattedNewProject.project.tattoo_concept}}</p> </div> </div> <div class=row> <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"divider small tight\"></div> <h6>Reference photos</h6> <ink-file-upload images=$ctrl.referenceImages> </ink-file-upload> </div> </div> <div class=row> <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"divider small tight\"></div> <h6>Location</h6> <p><strong>Area:</strong> {{$ctrl.formattedNewProject.project.area.name}}</p> <p><strong>Specific location:</strong> {{$ctrl.formattedNewProject.project.area.location.name}}</p> </div> </div> <div class=row> <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"divider small tight\"></div> <h6>Placement photos</h6> <p><strong>Is this a cover-up?</strong> {{$ctrl.formattedNewProject.project.coverupDescription}}</p> <ink-file-upload images=$ctrl.coverupImages></ink-file-upload> </div> </div> <div class=row> <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"divider small tight\"></div> <h6>Size</h6> <p><strong>Size:</strong> {{$ctrl.formattedNewProject.project.size.name}}, {{$ctrl.formattedNewProject.project.size.measurement}}</p> </div> </div> <div class=row> <div class=\"col-sm-8 col-sm-offset-2\"> <div class=\"divider small tight\"></div> <h6>Style</h6> <p><strong>Color profile:</strong> {{$ctrl.formattedNewProject.project.colorDescription}} </p><p><strong>Style:</strong> {{$ctrl.formattedNewProject.project.style.name}}<br/> <small>{{$ctrl.formattedNewProject.project.style.description}}</small> </p> <div class=row> <div class=\"list uploads\"> <div class=\"col-md-4 col-xs-6\"> <div class=\"item upload\"> <div class=upload-background ng-if=$ctrl.formattedNewProject.project.style.image_341 ng-style=\"{'background-image':'url(' + $ctrl.formattedNewProject.project.style.image_341 + ')'}\"> </div> </div> </div> </div> </div> </div> </div> <div class=\"button-container margin center\"> <button class=\"button large shop-solid equal-medium\" type=submit ng-disabled=addProjectForm.$invalid>Save</button> <a class=\"button large finder equal-medium\" ng-click=$ctrl.startOver()>Edit</a> </div> </div> </form> </div> </div> </div> ";

/***/ }),

/***/ "./components/projects/project/add/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/projects/project/add/add-project.component.js");

__webpack_require__("./components/projects/project/add/add-project.controller.js");

__webpack_require__("./components/projects/project/add/_add-project.styles.scss");

/***/ }),

/***/ "./components/projects/project/completed-photo/completed-photo.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

CompletedPhotoController.$inject = ['$uibModalInstance', 'project', 'appointment', 'Session', 'Project', 'FormatProject'];


/**
 * @name CompletedPhotoController
 * @description Controller for adding a copmleted photo to projects
 * @param {library} $uibModalInstance The modal instance from UI Boostrap
 * @param {object} project The project resolve
 * @param {object} appointment The appointment resolve
 * @param {service} Session The Session service
 * @param {service} Project The project service
 * @param {service} FormatProject The format project service
 * @param {library} _ The Lodash library
 */
function CompletedPhotoController($uibModalInstance, project, appointment, Session, Project, FormatProject) {
  var vm = this;

  vm.projectTmp = _lodash2.default.cloneDeep(project);
  vm.appointment = appointment;
  vm.session = Session;
  vm.saveCompletedPhotos = saveCompletedPhotos;
  vm.cancel = cancel;

  /**
   * @name saveCompletedPhotos
   * @description Function to save completed photos to the project
   */
  function saveCompletedPhotos() {
    Project.update(vm.projectTmp).then(function (updatedProject) {
      var formattedProject = FormatProject.format(updatedProject);

      // Close the modal and send the updated appointment and project
      $uibModalInstance.close(formattedProject);
    });
  }

  /**
   * @name cancel
   * @description Function to close the modal without saving
   */
  function cancel() {
    $uibModalInstance.dismiss();
  }
}

angular.module('inkfinder').controller('CompletedPhotoController', CompletedPhotoController);

/***/ }),

/***/ "./components/projects/project/completed-photo/completed-photo.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=completeAppointmentForm ng-submit=\"completeAppointmentForm.$valid && $ctrl.saveCompletedPhotos()\" novalidate> <div class=modal-header> <h4 class=modal-title>Add a completed photo</h4> </div> <div class=\"modal-body background-light\"> <div class=\"row center\"> <div class=players> <div class=\"col-sm-10 col-sm-offset-1\"> <h4>{{$ctrl.appointment.name}}</h4> <div class=row> <div class=\"col-sm-5 center\"> <ink-profile-photo profile=$ctrl.projectTmp.collector image-id=$ctrl.projectTmp.collector.profile_photo></ink-profile-photo> </div> <div class=col-sm-2> <div class=\"plus margin\"> <div class=width></div> <div class=height></div> </div> </div> <div class=\"col-sm-5 center\"> <ink-profile-photo profile=$ctrl.appointment.artist image-id=$ctrl.appointment.artist.profile_photo></ink-profile-photo> </div> </div> </div> </div> </div> <div class=row> <div class=col-md-12> <div class=\"divider tight transparent\"></div> <h5>Upload a completed photo of this project</h5> <p ng-if=\"$ctrl.session.activeState.role === 'operator' || $ctrl.session.activeState.role === 'artist'\">Add to your <span ng-if=\"$ctrl.session.activeState.role === 'operator'\">shop and artist’s</span> portfolio and share a completed photo with {{$ctrl.projectTmp.collector.first_name}}.</p> <p ng-if=\"$ctrl.session.activeState.role === 'collector'\">Share a completed photo with your artist and shop.</p> </div> <ink-file-upload images=$ctrl.projectTmp.completedImages> </ink-file-upload> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/projects/project/completed-photo/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/projects/project/completed-photo/completed-photo.controller.js");

/***/ }),

/***/ "./components/projects/project/img/transparent_200x200.png":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/transparent_200x200.png";

/***/ }),

/***/ "./components/projects/project/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/projects/project/add/index.js");

__webpack_require__("./components/projects/project/completed-photo/index.js");

__webpack_require__("./components/projects/project/update/index.js");

__webpack_require__("./components/projects/project/project.component.js");

__webpack_require__("./components/projects/project/project.controller.js");

__webpack_require__("./components/projects/project/project.service.js");

__webpack_require__("./components/projects/project/_project.styles.scss");

/***/ }),

/***/ "./components/projects/project/project.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkProject = {
  bindings: {
    project: '<',
    currentAppointment: '<',
    role: '<?',
    open: '<?',
    onProjectChange: '&',
    onAppointmentChange: '&'
  },
  controller: 'ProjectController',
  template: __webpack_require__("./components/projects/project/project.template.html")
};

angular.module('inkfinder').component('inkProject', inkProject);

/***/ }),

/***/ "./components/projects/project/project.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ProjectController.$inject = ['$uibModal', 'Lightbox', 'AlertMessages', 'Session', 'RESPONSE_MESSAGES', '$rootScope', 'Shop', 'MessageTemplates'];
/**
 * @description The controller invoked when viewing project details
 * @param {library} $uibModal Unknown
 * @param {library} Lightbox Unknown
 * @param {service} AlertMessages Unknown
 * @param {service} Session The user session service.
 * @param {constant} RESPONSE_MESSAGES Response messages constant.
 * @param {angular} $rootScope The Angular $rootScope service
 * @param {service} Shop The Shop service
 * @param {service} MessageTemplates The MessageTemplates service
 */
function ProjectController($uibModal, Lightbox, AlertMessages, Session, RESPONSE_MESSAGES, $rootScope, Shop, MessageTemplates) {
  var vm = this;
  vm.$onInit = function () {
    vm.session = Session;

    // Public methods
    vm.openPhotoLightbox = openPhotoLightbox;
    vm.openProjectModal = openProjectModal;
    vm.addCompletedphoto = addCompletedphoto;

    // Defaults
    vm.selectedOptions = {};
    vm.archiveConfirm = false;
  };

  // Open a specific modal after loading the project and appointment
  vm.open === 'add-completed-photo' && vm.currentAppointment.current_status === 70 ? addCompletedphoto() : null;

  /**
   * @description Reference and coverup images modal
   * @param {array} array The array of photos used to go to the next or previous
   * photo in the collection when inside the lightbox
   * @param {number} photo The photo, by index, to load in the modal
   */
  function openPhotoLightbox(array, photo) {
    Lightbox.openModal(array, photo);
  }

  /**
   * @description Open the project update modal for editing
   */
  function openProjectModal() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/projects/project/update/project-update.template.html"),
      animation: true,
      controller: 'ProjectUpdateController',
      controllerAs: '$ctrl',
      size: 'lg',
      resolve: {
        project: function project() {
          return vm.project;
        },
        appointment: function appointment() {
          return vm.currentAppointment;
        }
      }
    });
    modalInstance.result.then(function (returnData) {
      // When the project is saved, the modal close function is called, which
      // Delivers back the returnData. We set the project and appointment in
      // this scope to the updated versions
      if (returnData.formattedProject) {
        vm.project = returnData.formattedProject;
        vm.onProjectChange({ project: returnData.formattedProject });
        // Update appointment activity
        var conversationId = void 0;
        var appointmentId = void 0;
        $rootScope.$broadcast('merge-activity', conversationId, appointmentId, returnData.formattedProject.id);
      }

      // Update the appointment if it changed
      if (returnData.updatedAppointment) {
        Shop.get(returnData.updatedAppointment.shop).then(function (response) {
          returnData.updatedAppointment.shop = response;

          // Get the shop's message tempaltes
          MessageTemplates.get(returnData.updatedAppointment.shop.message_templates).then(function (response) {
            returnData.updatedAppointment.shop.messageTemplates = response;
            // Update the current appointment on the parent component
            vm.onAppointmentChange({ appointment: returnData.updatedAppointment });
          });
        });
      }
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name addCompletedphoto
   * @description Function to open the add completed photo modalInstance.
   */
  function addCompletedphoto() {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/projects/project/completed-photo/completed-photo.template.html"),
      animation: true,
      controller: 'CompletedPhotoController as $ctrl',
      resolve: {
        project: function project() {
          return vm.project;
        },
        appointment: function appointment() {
          return vm.currentAppointment;
        }
      }
    });
    modalInstance.result.then(function (project) {
      vm.project = project;
      vm.onProjectChange({ project: project });

      // Update appointment activity
      var conversationId = void 0;
      var appointmentId = void 0;
      $rootScope.$broadcast('merge-activity', conversationId, appointmentId, project.id);
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.saved,
        type: 'success'
      });
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }
}

angular.module('inkfinder').controller('ProjectController', ProjectController);

/***/ }),

/***/ "./components/projects/project/project.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formatProjectApi = __webpack_require__("./utils/format-project-api.js");

var _formatProjectApi2 = _interopRequireDefault(_formatProjectApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('inkfinder').factory('Project', ['$http', 'ENDPOINT', 'FormatProject', 'Session', 'AlertMessages', '_', function Project($http, ENDPOINT, FormatProject, Session, AlertMessages, _) {
  // Public methods
  Project.get = get;
  Project.getOptions = getOptions;
  Project.update = update;
  Project.create = create;

  /**
   * @name get
   * @description Get a single project for collectors by passing
   * {type: 'collector', id: id}
   * @param {id} id The ID of the project to retrieve.
   * @return {object} data Returns the project object.
   */
  function get(id) {
    var role = Session.activeState.role;
    var associationId = void 0;
    if (!_.isUndefined(Session.activeState.association)) {
      associationId = Session.activeState.association.id;
    }
    return $http.get(ENDPOINT.server + 'projects/api/v1.1/' + id + '/' + '?role=' + role + (associationId ? '&association_id=' + associationId : '')).then(function (response) {
      return FormatProject.format(response.data);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
  * @name getOptions
  * @description Function to get all options for size and area select boxes.
  * @return {unknown} data Returns the project options.
  */
  function getOptions() {
    return $http.get(ENDPOINT.server + 'projects/api/v1.1/area-location/').then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name update
   * @description Function to update a project
   * @param {object} project The project to update.
   * @return {object} data Returns the updated project.
   */
  function update(project) {
    var formattedProject = (0, _formatProjectApi2.default)(project);
    formattedProject.role = Session.activeState.role;
    if (!_.isUndefined(Session.activeState.association)) {
      formattedProject.association_id = Session.activeState.association.id;
    }
    return $http.put(ENDPOINT.server + 'projects/api/v1.1/' + project.id + '/', formattedProject).then(function (response) {
      return FormatProject.format(response.data);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name create
   * @description Function to create a new project
   * @param {object} input The project data
   * @return {$http} Returns the $http service
   */
  function create(input) {
    // Move the location object inside the area object
    if (input.location) {
      input.area.location = input.location;
    }
    var project = (0, _formatProjectApi2.default)(input);
    project.role = Session.activeState.role;
    if (!_.isUndefined(Session.activeState.association)) {
      project.association_id = Session.activeState.association.id;
    }
    return $http.post(ENDPOINT.server + 'projects/api/v1.1/', project).then(function (response) {
      return FormatProject.format(response.data);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return Project;
}]);

/***/ }),

/***/ "./components/projects/project/project.template.html":
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<div class=project-bar> <div class=row> <div class=col-sm-12> <div ng-if=\"$ctrl.currentAppointment.last_status.status_id === 70 && ($ctrl.project.allow_operator_edit || $ctrl.session.activeState.role === 'collector')\"> <h5 class=no-margin>Proud of your new art?</h5> <p class=no-margin>Add a photo to share your project.</p> <div class=\"divider small xxtight transparent\"></div> <button class=\"button medium finder-solid\" ng-click=$ctrl.addCompletedphoto()>Add a photo</button> <div class=\"divider small tight\"></div> </div> <a ng-click=\"($ctrl.project.allow_operator_edit || $ctrl.session.activeState.role === 'collector') && $ctrl.openProjectModal()\" tooltip-placement=top uib-tooltip=\"This project is locked.\" tooltip-class=light tooltip-append-to-body=true tooltip-enable=\"!$ctrl.project.allow_operator_edit && $ctrl.session.activeState.role !== 'collector'\" ng-if=\"$ctrl.project.reference_images.length > 0\"> <div class=project-reference-photo ng-style=\"$ctrl.project.reference_images != '' && {'background-image': 'url(' + $ctrl.project.reference_images[0].image_1024 + ')'}\"> </div> </a> <h4 class=project-name> <a ng-click=\"($ctrl.project.allow_operator_edit || $ctrl.session.activeState.role === 'collector') && $ctrl.openProjectModal()\" tooltip-placement=top uib-tooltip=\"This project is locked.\" tooltip-class=light tooltip-append-to-body=true tooltip-enable=\"!$ctrl.project.allow_operator_edit && $ctrl.session.activeState.role !== 'collector'\"> {{$ctrl.project.name}}&nbsp;<fa name=pencil class=\"icon light small link\" ng-if=\"$ctrl.project.allow_operator_edit || $ctrl.session.activeState.role === 'collector'\"></fa> <fa name=lock class=\"icon light small\" ng-if=\"!$ctrl.project.allow_operator_edit && $ctrl.session.activeState.role !== 'collector'\"></fa> </a> </h4> <div class=row ng-if=\"$ctrl.session.activeState.role !== 'collector'\"> <div class=\"col-xs-4 col-sm-3\"> <ink-profile-photo profile=$ctrl.project.collector image-id=$ctrl.project.collector.profile_photo size=\"'xlarge'\" show-name=false></ink-profile-photo> </div> <div class=\"col-xs-8 col-sm-9\"> <h6 class=no-margin>A project for {{$ctrl.project.collector.first_name}} {{$ctrl.project.collector.last_name}}</h6> <div ng-if=\"$ctrl.session.activeState.role === 'artist' || $ctrl.session.activeState.role === 'operator'\"> <small ng-if=\"$ctrl.project.collector.email || $ctrl.project.collector.phone\"> <div class=inline ng-if=$ctrl.project.collector.phone> <a href=tel:{{$ctrl.project.collector.phone}}> <fa name=phone fw size=1></fa> {{$ctrl.project.collector.phone | tel}} </a> &nbsp; </div> <div class=inline ng-if=$ctrl.project.collector.email> <fa name=exclamation-triangle fw class=alert-color ng-if=!$ctrl.project.collector.email_is_confirmed tooltip-append-to-body=true uib-tooltip=\"Email not verified\" tooltip-placement=top tooltip-class=light> </fa> <a href=mailto:{{$ctrl.project.collector.email}}> <fa name=envelope fw size=1></fa> {{$ctrl.project.collector.email}} </a> </div> </small> </div> </div> </div> <div class=\"divider small tight\"></div> <h5>Project details</h5> <div class=row> <div class=col-xs-6 ng-if=$ctrl.project.size.measurement> <label class=stacked>Size</label> <p>{{$ctrl.project.size.measurement}}</p> </div> <div class=col-xs-6 ng-if=$ctrl.project.area.location.name> <label class=stacked>Location</label> <p>{{$ctrl.project.area.location.name}}</p> </div> <div class=col-xs-6 ng-if=$ctrl.project.colorDescription> <label class=stacked>Color</label> <p>{{$ctrl.project.colorDescription}}</p> </div> <div class=col-xs-6 ng-if=$ctrl.project.coverupDescription> <label class=stacked>Coverup</label> <p>{{$ctrl.project.coverupDescription}}</p> </div> <div class=col-xs-6 ng-if=$ctrl.project.style.name> <label class=stacked>Style</label> <p>{{$ctrl.project.style.name}}</p> </div> </div> <div ng-if=$ctrl.project.tattoo_concept> <div class=\"divider small tight\"></div> <h5>Concept</h5> <p class=allow-breaks>{{$ctrl.project.tattoo_concept}}</p> <div class=\"divider small tight\"></div> </div> <div ng-if=\"$ctrl.project.completed_images.length > 0\"> <h5>Completed photos</h5> <div class=\"list thumbs row\"> <div class=\"item thumb col-xs-6\" ng-repeat=\"image in $ctrl.project.completed_images\"> <a ng-click=\"$ctrl.openPhotoLightbox($ctrl.project.completed_images, $index)\"> <div class=thumb-wrapper> <div class=thumb-container ng-style=\"{'background-image':'url(' + image.image_341 + ')'}\"> <div class=thumb-inner> <img src=" + __webpack_require__("./components/projects/project/img/transparent_200x200.png") + " border=0> </div> </div> </div> </a> </div> </div> </div> <div ng-if=\"$ctrl.project.reference_images.length > 0\"> <div class=\"divider small xtight transparent\"></div> <h5>Reference images</h5> <div class=\"list thumbs row\"> <div class=\"item thumb col-xs-6\" ng-repeat=\"image in $ctrl.project.reference_images\"> <a ng-click=\"$ctrl.openPhotoLightbox($ctrl.project.reference_images, $index)\"> <div class=thumb-wrapper> <div class=thumb-container ng-style=\"{'background-image':'url(' + image.image_341 + ')'}\"> <div class=thumb-inner> <img src=" + __webpack_require__("./components/projects/project/img/transparent_200x200.png") + " border=0> </div> </div> </div> </a> </div> </div> </div> <div ng-if=\"$ctrl.project.coverup_images.length > 0\"> <div class=\"divider small xtight transparent\"></div> <h5>Placement photos</h5> <div class=\"list thumbs row\"> <div class=\"item thumb col-xs-6\" ng-repeat=\"image in $ctrl.project.coverup_images\"> <a ng-click=\"$ctrl.openPhotoLightbox($ctrl.project.coverup_images, $index)\"> <div class=thumb-container ng-style=\"{'background-image':'url(' + image.image_341 + ')'}\"> <div class=thumb-inner> <img src=" + __webpack_require__("./components/projects/project/img/transparent_200x200.png") + " border=0> </div> </div> </a> </div> </div> </div> <div class=button-container> <button class=\"button large shop-solid full\" ng-if=\"$ctrl.project.allow_operator_edit || $ctrl.session.activeState.role === 'collector'\" ng-click=$ctrl.openProjectModal()>Edit project</button> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/projects/project/update/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/projects/project/update/project-update.controller.js");

/***/ }),

/***/ "./components/projects/project/update/project-update.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ProjectUpdateController.$inject = ['Project', 'FormatProject', '$rootScope', '$uibModalInstance', 'project', 'appointment', 'StyleFactory', 'AlertMessages', 'Activity', 'Session', 'Appointment', 'Notification', 'NOTIFICATIONS', 'RESPONSE_MESSAGES', 'STATUS_IDS', 'Shop', 'MessageTemplates'];


/**
 * @description The function to edit projects
 * @param {service} Project The Project service
 * @param {Unknown} FormatProject Unknown
 * @param {Unknown} $rootScope Unknown
 * @param {Unknown} $uibModalInstance Unknown
 * @param {resolve} project The resolved project
 * @param {resolve} appointment The resolved appointment
 * @param {Unknown} StyleFactory Unknown
 * @param {service} AlertMessages The alert messages service
 * @param {service} Activity The activity service
 * @param {service} Session The Session service
 * @param {service} Appointment The Appointment service
 * @param {service} Notification The Notification service
 * @param {constant} NOTIFICATIONS The NOTIFICATIONS constant
 * @param {constant} RESPONSE_MESSAGES The RESPONSE_MESSAGES constant
 * @param {constant} STATUS_IDS The STATUS_IDS constant
 * @param {service} Shop The Shop service
 * @param {service} MessageTemplates The MessageTemplates service
 */
function ProjectUpdateController(Project, FormatProject, $rootScope, $uibModalInstance, project, appointment, StyleFactory, AlertMessages, Activity, Session, Appointment, Notification, NOTIFICATIONS, RESPONSE_MESSAGES, STATUS_IDS, Shop, MessageTemplates) {
  var vm = this;

  vm.$onInit = function () {
    // Make a copy of the project and currently viewed appointment when the
    // modal controller is loaded
    vm.projectTmp = _lodash2.default.cloneDeep(project);
    vm.projectCompare = _lodash2.default.cloneDeep(project);
    vm.session = Session;
    vm.updatedAppointment;
    vm.returnData = {};

    // Public methods
    vm.saveProject = saveProject;
    vm.cancel = cancel;
    vm.agreeToUpdatePolicy = agreeToUpdatePolicy;

    // Defaults
    // vm.agreedToUpdatePolicy = false;
    vm.canEditProject = false;
    vm.iAgreeToUpdatePolicy = false;
    vm.projectUpdateConfirmedAppt = RESPONSE_MESSAGES.projectUpdateConfirmedAppt.message;

    // If a confirmed appointment exists
    if (appointment) {
      vm.appointmentTmp = _lodash2.default.cloneDeep(appointment);
      vm.privacyPolicyIsCollapsed = vm.appointmentTmp.agreed_to_cancellation_policy;
    }

    // Get the shop policy if one exists
    if (vm.appointmentTmp && vm.appointmentTmp.shop) {
      Shop.get(vm.appointmentTmp.shop.id).then(function (shop) {
        MessageTemplates.get(shop.message_templates).then(function (messageTemplates) {
          vm.shopMessageTemplates = messageTemplates;
        });
      });
    }

    // Determine the edit project status
    // If role is artist or operator, pass them to the edit form immediately
    if (Session.activeState.role === 'artist' || Session.activeState.role === 'operator') {
      vm.canEditProject = true;

      // If there is no appointment, then freely allow project edits
    } else if (!vm.appointmentTmp) {
      vm.canEditProject = true;

      // If an appointment exists but has been cancelled
    } else if (vm.appointmentTmp.last_status.status_id !== STATUS_IDS.confirmed) {
      vm.canEditProject = true;
    }
  };

  // Get Menu Options for Various Dropdowns
  Project.getOptions().then(function (options) {
    vm.options = options;
  });

  // Get Tattoo Styles
  StyleFactory.getStyles().then(function (styles) {
    vm.styles = styles;
  });

  /**
   * @name agreeToUpdatePolicy
   * @description Function to agree to the cancellation and/or project update
   * policy. When the cancellation policy hasn't been agreed to, send an appt
   * update to declare the collector has agreed to the policy.
   */
  function agreeToUpdatePolicy() {
    if (!vm.appointmentTmp.agreed_to_cancellation_policy) {
      vm.appointmentTmp.agreed_to_cancellation_policy = vm.iAgreeToUpdatePolicy;
      Appointment.update(vm.appointmentTmp).then(function (updatedAppointment) {
        vm.canEditProject = true;
        vm.returnData.updatedAppointment = updatedAppointment;
      });
    } else {
      vm.canEditProject = true;
    }
  }

  /**
   * @description Save project updates
   * @param {object} project The project to be saved
   */
  function saveProject(project) {
    Project.update(project).then(function (updatedProject) {
      vm.returnData.formattedProject = FormatProject.format(updatedProject);

      // Send project updated email notif if the project has changed and an
      // appt exists and the appt is unconfirmed or confirmed
      if (!_lodash2.default.isEqual(vm.projectTmp, vm.projectCompare) && vm.appointmentTmp && (vm.appointmentTmp.current_status === 40 || vm.appointmentTmp.current_status === 50)) {
        var notification = {
          // Recipients are now managed by the API based on notif prefs
          notificationId: NOTIFICATIONS.projectUpdated,
          messageObjects: {
            appointmentId: vm.appointmentTmp.id,
            projectId: vm.returnData.formattedProject.id,
            // The artist assigned to the appointment
            artistId: vm.appointmentTmp.artist.id,
            // The project collector
            collectorId: vm.returnData.formattedProject.collector.id,
            // The logged in user
            operatorId: Session.collector.id
          },
          messageVariables: {
            subject: 'A project you’re working on was updated'
          }
        };
        Notification.send(notification);
      }
      AlertMessages.add({
        msg: 'We saved your project updates.',
        type: 'success'
      });
      $uibModalInstance.close(vm.returnData);
      vm.projectTmp = {};
    });
  }

  /**
   * @description Dismiss the modal instance with a reason of 'Canceled'
   */
  function cancel() {
    if (vm.returnData.updatedAppointment) {
      $uibModalInstance.close(vm.returnData);
    } else {
      $uibModalInstance.dismiss('Canceled');
    }
  }
}

angular.module('inkfinder').controller('ProjectUpdateController', ProjectUpdateController);

/***/ }),

/***/ "./components/projects/project/update/project-update.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h4 class=modal-title>Edit project</h4> </div> <div class=\"modal-body background-light\" ng-if=!$ctrl.canEditProject> <div class=row> <div class=col-sm-12> <h5><span class=alert-color><fa name=exclamation-triangle></fa> Zoinks!</span> {{$ctrl.projectUpdateConfirmedAppt}}</h5> <p> <strong>Small project updates</strong> that support your existing concept, like <strong class=darkshop>adding reference or placement photos</strong> or <strong class=darkshop>improving your project description</strong>, are normally fine. It’s always nice to send a message to your shop or artist, though, to confirm. </p> <p> <strong>Large project changes</strong>, like <strong class=darkshop>changing the location, size, style,</strong> or the entire <strong class=darkshop>concept</strong>, may affect your appointment and require a reschedule. Leave a message with your shop or artist to confirm these updates are possible within your existing appointment. </p> </div> <div class=col-sm-12> <div ng-if=$ctrl.shopMessageTemplates.cancellation_policy> <h6 class=stacked> <span ng-if=$ctrl.appointmentTmp.agreed_to_cancellation_policy><fa name=thumbs-up></fa> You have agreed to the <a ng-click=\"$ctrl.privacyPolicyIsCollapsed = !$ctrl.privacyPolicyIsCollapsed\">{{$ctrl.appointmentTmp.shop.name}} cancellation policy</a> </span> <span ng-if=!$ctrl.appointmentTmp.agreed_to_cancellation_policy>{{$ctrl.appointmentTmp.shop.name}} cancellation policy</span> </h6> <div uib-collapse=$ctrl.privacyPolicyIsCollapsed> <div ng-bind-html=$ctrl.shopMessageTemplates.cancellation_policy></div> </div> </div> <div class=\"inline-alert warning\"> <label> <input name=iAgreeToUpdatePolicy ng-model=$ctrl.iAgreeToUpdatePolicy type=checkbox> <strong> I agree to the {{$ctrl.appointmentTmp.shop.name}} project edit <span ng-if=!$ctrl.appointmentTmp.agreed_to_cancellation_policy> and cancellation </span> policy above </strong> </label> </div> <div class=button-container> <button class=\"button large shop-solid equal-large\" ng-click=$ctrl.agreeToUpdatePolicy() ng-disabled=!$ctrl.iAgreeToUpdatePolicy> Agree and edit project </button> <button class=\"button large alert-btn-light equal-large\" type=reset ng-click=$ctrl.cancel()>Cancel</button> </div> </div> </div> </div> <form name=projectUpdateForm ng-submit=\"projectUpdateForm.$valid && $ctrl.saveProject($ctrl.projectTmp)\" novalidate ng-if=$ctrl.canEditProject> <div class=\"modal-body background-light\"> <div class=row> <div class=col-md-12> <h5 class=center>Add in some sweet deets.</h5> <div class=form-group> <label for=project_name>Project name <small>Required</small></label> <input name=project_name type=text placeholder=\"My awesome tattoo project\" class=form-control required ng-model=$ctrl.projectTmp.name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"projectUpdateForm.project_name.$invalid && !projectUpdateForm.project_name.$pristine\"> To help identify this project, give it a name. </p> </div> </div> <div class=form-group> <label>Tattoo concept</label> <textarea name=project_concept msd-elastic=\\n placeholder=\"I just want to be a badass...\" class=textarea ng-model=$ctrl.projectTmp.tattoo_concept>\n          </textarea> </div> </div> </div> <div class=row> <div class=col-lg-6> <div class=form-group> <label for=project_width>Width <small>in inches</small></label> <input name=project_width type=number placeholder=\"My tattoo width\" class=form-control ng-model=$ctrl.projectTmp.width min=1 ng-required=\"$ctrl.projectTmp.height && projectUpdateForm.project_height\"> <div class=\"inline-message relative\"> <p class=\"message error\" ng-if=projectUpdateForm.project_width.$invalid> If you’ve entered a height, enter a width. </p> </div> </div> </div> <div class=col-lg-6> <div class=form-group> <label for=project_height>Height <small>in inches</small></label> <input name=project_height type=number placeholder=\"My tattoo height\" class=form-control ng-model=$ctrl.projectTmp.height min=1 ng-required=\"$ctrl.projectTmp.width && projectUpdateForm.project_width\"> <div class=\"inline-message relative\"> <p class=\"message error\" ng-if=projectUpdateForm.project_height.$invalid> If you’ve entered a width, enter a height. </p> </div> </div> </div> <div class=col-lg-6> <div class=form-group> <label for=project_style>Select a style</label> <select name=project_style ng-model=$ctrl.projectTmp.style ng-value=option.id ng-options=\"option.name for option in $ctrl.styles | orderBy:'name' track by option.id\"> <option value=\"\">Choose one</option> </select> </div> </div> <div class=col-lg-6> <div class=form-group> <label for=project_area>Select an area</label> <select name=project_area ng-model=$ctrl.projectTmp.area ng-value=area.id ng-options=\"area.name for area in $ctrl.options.areas track by area.id\"> <option value=\"\">Choose one</option> </select> </div> </div> <div class=col-lg-6> <div class=form-group> <label for=project_location>Specific location</label> <select name=project_location ng-required=\"$ctrl.projectTmp.area && projectUpdateForm.project_area\" ng-disabled=!$ctrl.projectTmp.area ng-model=$ctrl.projectTmp.area.location ng-value=location.id ng-options=\"location.name for location in ($ctrl.options.locations | filter: {area: {id: $ctrl.projectTmp.area.id}}) track by location.id\"> <option value=\"\" selected=selected>Choose one</option> </select> </div> </div> </div> <div class=\"divider small tight\"></div> <div class=row> <div class=col-lg-6> <div class=form-group> <div class=input-group> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.projectTmp.full_color === true}\"> <input type=radio name=color_options id=full_color ng-model=$ctrl.projectTmp.full_color ng-value=true> Full color </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.projectTmp.full_color === false}\"> <input type=radio name=color_options id=black_gray ng-model=$ctrl.projectTmp.full_color ng-value=false> Black and gray </label> </div> </div> </div> </div> <div class=col-lg-6> <div class=\"form-group no-margin-bottom\"> <label for=coverup><input name=coverup id=coverup ng-model=$ctrl.projectTmp.coverup type=checkbox> This is a coverup</label> </div> </div> </div> <div class=row ng-if=\"$ctrl.appointmentTmp.last_status.status_id === 70\"> <div class=col-md-12> <div class=\"divider small loose transparent\"></div> <h6>Completed photos</h6> <p>Share a completed photo of this project.</p> <ink-file-upload images=$ctrl.projectTmp.completedImages> </ink-file-upload> </div> </div> <div class=row> <div class=col-md-12> <div class=\"divider small loose transparent\"></div> <h6>Reference images</h6> <p>Good reference photos will help show your artist your vision and communicate the details you’re looking for in your project. Upload as many as you need.</p> <p><small>Maximum size: 10MB</small></p> <ink-file-upload images=$ctrl.projectTmp.referenceImages> </ink-file-upload> </div> </div> <div class=row> <div class=col-md-12> <div class=\"divider small loose transparent\"></div> <h6>Placement photos</h6> <p>Send photos of the area on your body you want your tattoo. If you want to cover-up an existing tattoo, be sure to send a clear photo of your existing tattoo.</p> <p><small>Maximum size: 10MB</small></p> <ink-file-upload images=$ctrl.projectTmp.coverupImages> </ink-file-upload> </div> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid equal-medium\" type=submit ng-disabled=projectUpdateForm.$invalid>Save</button> <button class=\"button large alert-btn equal-medium\" type=reset ng-click=$ctrl.cancel()>Cancel</button> </div> </form> ";

/***/ }),

/***/ "./components/projects/projects.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkProjects = {
  controller: 'ProjectsController',
  template: __webpack_require__("./components/projects/projects.template.html")
};

angular.module('inkfinder').component('inkProjects', inkProjects);

/***/ }),

/***/ "./components/projects/projects.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _findLastUpdatedAppt = __webpack_require__("./utils/find-last-updated-appt.js");

var _findLastUpdatedAppt2 = _interopRequireDefault(_findLastUpdatedAppt);

var _groupByApptStatus = __webpack_require__("./utils/group-by-appt-status.js");

var _groupByApptStatus2 = _interopRequireDefault(_groupByApptStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ProjectsController.$inject = ['Projects', 'Session', 'FormatAppointment', '_'];


/**
 * @name ProjectListController
 * @description None
 * @param {unknown} Projects unknown
 * @param {unknown} Session unknown
 * @param {object} FormatAppointment Service to format appointments.
 * @param {unknown} _ Lodash service
 */
function ProjectsController(Projects, Session, FormatAppointment, _) {
  var vm = this;

  // Public variables
  vm.confirmedProjects = [];
  vm.unconfirmedProjects = [];
  vm.requestedProjects = [];
  vm.noAppointmentsProjects = [];
  vm.completedProjects = [];
  vm.projectCount = null;
  vm.collector = Session.collector;

  // Get projects for collector when the controller loads */
  getProjects();

  /**
   * Get projects
   * @param {string} role The role of the logged in user. This determines
   * data permissions on the endpoint.
   */
  function getProjects() {
    Projects.get().then(function (projects) {
      var groupedProjects = [];
      if (projects.length > 0) {
        var formatted = [];
        _.each(projects, function (project) {
          var data = {};
          data.project = project;
          data.project.appointments = _.each(project.appointments, function (appointment) {
            FormatAppointment.format(appointment);
          });
          data.appointment = (0, _findLastUpdatedAppt2.default)(project.appointments);
          formatted.push(data);
        });
        groupedProjects = (0, _groupByApptStatus2.default)(formatted);
      }
      vm.confirmedProjects = groupedProjects.confirmed;
      vm.unconfirmedProjects = groupedProjects.unconfirmed;
      vm.requestedProjects = groupedProjects.requested;
      vm.noAppointmentsProjects = groupedProjects.noAppointments;
      vm.completedProjects = groupedProjects.completed;

      // Display a project count on the view
      vm.projectCount = _.size(groupedProjects.confirmed) + _.size(groupedProjects.unconfirmed) + _.size(groupedProjects.requested) + _.size(groupedProjects.noAppointments) + _.size(groupedProjects.completed);
    });
  }
}

angular.module('inkfinder').controller('ProjectsController', ProjectsController);

/***/ }),

/***/ "./components/projects/projects.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Projects', ['$http', 'ENDPOINT', 'FormatProject', 'FormatAppointment', 'AlertMessages', 'Session', '_', function Projects($http, ENDPOINT, FormatProject, FormatAppointment, AlertMessages, Session, _) {
  // Public methods
  Projects.get = get;

  /**
   * @name getProjects
   * @description Get a collection of projects
   * @param {string} ids A string of project ids to get an array of projects.
   * @param {number} collector A collector ID to return results filtered by collector.
   * @return {array} formattedProjects Returns an array of formatted projects
   * and appointments sorted by appointment status.
   */
  function get(ids, collector) {
    var role = Session.activeState.role;
    var url = ENDPOINT.server + 'projects/api/v1.1/?role=' + role;
    if (!_.isUndefined(Session.activeState.association)) {
      var associationId = Session.activeState.association.id;
      url += '&association_id=' + associationId;
    }
    if (!_.isUndefined(ids)) {
      url += '&ids=' + ids;
    }
    if (!_.isUndefined(collector)) {
      url += '&collector_id=' + collector;
    }
    return $http.get(url).then(function (response) {
      return FormatProject.formatCollection(response.data);
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return Projects;
}]);

/***/ }),

/***/ "./components/projects/projects.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=dashboard class=\"section photo background-dark\"> <div class=background-photo></div> <div class=container-fluid> <div class=\"row animate fade-in fade-out\"> <div class=\"col-md-6 col-md-offset-3\"> <ink-account-alerts></ink-account-alerts> <div class=\"intro center\"> <h1>Hey, {{$ctrl.collector.first_name}}.</h1> <h5 ng-if=$ctrl.projectCount>You have <ng-pluralize count=$ctrl.projectCount when=\"{'0': 'no proejcts to work on. :(', 'one': 'a project to work on. Awesome!',\n            'other': '{} projects to work on. Get it!'}\"> </ng-pluralize> </h5> </div> </div> <div class=\"col-sm-12 center\" ng-if=\"$ctrl.projectCount === 0\"> <h6>We didn't find a single project with your name on it.</h6> </div> <div class=\"list projects col-sm-12\" ng-if=\"$ctrl.projectCount > 0\"> <div class=project-group ng-show=\"$ctrl.noAppointmentsProjects.length > 0\"> <h6>New projects</h6> <div class=\"divider small tight\"></div> <a class=\"item project link\" ng-repeat=\"data in $ctrl.noAppointmentsProjects track by data.project.id\" ui-sref=inkfinder.projects.details({id:data.project.id})> <ink-project-card card=data show-artist=false show-collector=false show-name=true></ink-project-card> </a> </div> <div class=project-group ng-show=\"$ctrl.unconfirmedProjects.length > 0\"> <h6>Projects with unconfirmed appointments</h6> <div class=\"divider small tight\"></div> <a class=\"item project link\" ng-repeat=\"data in $ctrl.unconfirmedProjects track by data.project.id\" ui-sref=inkfinder.appointments.details({appointment_id:data.appointment.id})> <ink-project-card card=data show-collector=false show-estimate=true show-name=true></ink-project-card> </a> </div> <div class=project-group ng-show=\"$ctrl.confirmedProjects.length > 0\"> <h6>Projects with confirmed appointments</h6> <div class=\"divider small tight\"></div> <a class=\"item project link\" ng-repeat=\"data in $ctrl.confirmedProjects track by data.project.id\" ui-sref=inkfinder.appointments.details({appointment_id:data.appointment.id})> <ink-project-card card=data show-collector=false show-estimate=true show-name=true></ink-project-card> </a> </div> <div class=project-group ng-show=\"$ctrl.requestedProjects.length > 0\"> <h6>Projects with requested appointments</h6> <div class=\"divider small tight\"></div> <a class=\"item project link\" ng-repeat=\"data in $ctrl.requestedProjects track by data.project.id\" ui-sref=inkfinder.appointments.details({appointment_id:data.appointment.id})> <ink-project-card card=data show-collector=false show-estimate=false show-name=true></ink-project-card> </a> </div> <div class=project-group ng-show=\"$ctrl.completedProjects.length > 0\"> <h6>Completed projects</h6> <div class=\"divider small tight\"></div> <a class=\"item project link\" ng-repeat=\"data in $ctrl.completedProjects track by data.project.id\" ui-sref=inkfinder.appointments.details({appointment_id:data.appointment.id})> <ink-project-card card=data show-collector=false show-estimate=false show-name=true></ink-project-card> </a> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/projects/util/format-projects.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('FormatProject', ['FormatAppointment', '_', function FormatProject(FormatAppointment, _) {
  // Public methods
  FormatProject.formatCollection = formatCollection;
  FormatProject.format = format;

  /**
   * @name formatCollection
   * @param {array} collection Array of appointments/projects objects to format.
   * @return {array} projectCollection Returns the array of formatted projects.
   */
  function formatCollection(collection) {
    var projectCollection = [];
    projectCollection = _.map(collection, function (project) {
      return format(project);
    });
    return projectCollection;
  }

  /**
   * @name format
   * @description Function to format the data of a Ink Finder project object
   * @param {object} project The project to format.
   * @return {object} formatted Returns the formatted project.
   */
  function format(project) {
    var formatted = project;

    // Reference, coverup, and completed images
    formatted.referenceImages = [];
    if (project.reference_images && project.reference_images.length) {
      formatted.referenceImage = project.reference_images[0].image_1024;
      _.each(project.reference_images, function (image) {
        image.type = 'reference';
        formatted.referenceImages.push({
          result: image,
          progress: 100
        });
      });
    }
    formatted.coverupImages = [];
    if (project.coverup_images && project.coverup_images.length) {
      _.each(project.coverup_images, function (image) {
        image.type = 'coverup';
        formatted.coverupImages.push({
          result: image,
          progress: 100
        });
      });
    }
    formatted.completedImages = [];
    if (project.completed_images && project.completed_images.length) {
      _.each(project.completed_images, function (image) {
        image.type = 'completed';
        formatted.completedImages.push({
          result: image,
          progress: 100
        });
      });
    }

    // Copy the original server data for coverup. Set the coverup description
    // to 'Yes' or 'No'
    if (project.coverup === true) {
      formatted.coverupDescription = 'Yes';
    } else {
      formatted.coverupDescription = 'No';
    }

    // Copy the origin server data for full_color. Set the color message to
    // 'Full color' or 'Black and gray'
    if (project.full_color === true) {
      formatted.colorDescription = 'Full color';
    } else {
      formatted.colorDescription = 'Black and gray';
    }

    // Format project appointments
    if (project.appointments && project.appointments.length > 0) {
      formatted.appointments = FormatAppointment.formatCollection(project.appointments);
    }
    return formatted;
  }
  return FormatProject;
}]);

/***/ }),

/***/ "./components/reset-password/_reset-password.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182509075
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/reset-password/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/reset-password/reset-password.component.js");

__webpack_require__("./components/reset-password/reset-password.controller.js");

__webpack_require__("./components/reset-password/reset-password.service.js");

__webpack_require__("./components/reset-password/_reset-password.styles.scss");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('resetpassword', {
    url: '/reset-password?uid&token',
    views: {
      '@': {
        component: 'inkResetPassword'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Request a password reset';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/reset-password/reset-password.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkResetPassword = {
  controller: 'ResetPasswordController',
  template: __webpack_require__("./components/reset-password/reset-password.template.html")
};

angular.module('inkfinder').component('inkResetPassword', inkResetPassword);

/***/ }),

/***/ "./components/reset-password/reset-password.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ResetPasswordController.$inject = ['$state', 'ResetPasswordFactory', '_'];
/**
 * @description The controller for the reset password component
 * @param {unknown} $state Unknown
 * @param {unknown} ResetPasswordFactory The service to send the reset
 * password request and password change
 * @param {library} _ The Lodash libray
 */
function ResetPasswordController($state, ResetPasswordFactory, _) {
  var vm = this;

  vm.$onInit = function () {
    vm.reset = false;
    vm.ResponseRecieved = false;

    // Public functions
    vm.sendResetEmail = sendResetEmail;
    vm.sendNewPassword = sendNewPassword;

    if (!_.isUndefined($state.params.uid) && !_.isUndefined($state.params.token)) {
      vm.reset = true;
    }
  };

  /**
   * @description Enter your email address and send a password reset request
   * @param {object} email The address to send the password reset confirmation
   * email to
   */
  function sendResetEmail(email) {
    ResetPasswordFactory.sendResetEmail(email).then(function (response) {
      if (response) {
        vm.ResponseRecieved = true;
      }
    });
  }

  /**
   * @description Enter a new password and confirmation to update your account
   * password
   * @param {object} request The object containing the new password, and confirmed
   * password
   */
  function sendNewPassword(request) {
    request.uid = $state.params.uid;
    request.token = $state.params.token;
    ResetPasswordFactory.sendNewPassword(request);
  }
}

angular.module('inkfinder').controller('ResetPasswordController', ResetPasswordController);

/***/ }),

/***/ "./components/reset-password/reset-password.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('ResetPasswordFactory', ['$rootScope', '$state', '$http', 'AlertMessages', 'ENDPOINT', 'Auth', 'Events', 'Session', '$cookies', '$auth', function ResetPasswordFactory($rootScope, $state, $http, AlertMessages, ENDPOINT, Auth, Events, Session, $cookies, $auth) {
  ResetPasswordFactory.sendResetEmail = sendResetEmail;
  ResetPasswordFactory.sendNewPassword = sendNewPassword;

  /**
    * @name sendResetEmail
    * @description Send password reset request to server
    * @param {string} email The email address to perform the reset workflow on
    * @return {object} Returns a promise from $http
    */
  function sendResetEmail(email) {
    return $http.post(ENDPOINT.server + 'collectors/api/v1.1/password/reset/', {
      email: email
    }).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
    * @name sendNewPassword
    * @description Send new passwords to server
    * @param {object} request The object containing the password, token, and uid
    * @return {object} Returns a promise from $http
    */
  function sendNewPassword(request) {
    return $http.post(ENDPOINT.server + 'collectors/api/v1.1/password/reset/confirm/', {
      uid: request.uid,
      token: request.token,
      password1: request.password,
      password2: request.password_confirm
    }).then(function (response) {
      AlertMessages.add({ msg: response.data, type: 'success' });
      $state.go('login');
      $rootScope.$broadcast('clear-data');
      Events.loggedIn = false;
      Session.destroy(); // Remove roles, token, and collector
      $cookies.remove('inkfinder');
      $auth.logout(); // Satellizer logout
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return ResetPasswordFactory;
}]);

/***/ }),

/***/ "./components/reset-password/reset-password.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=reset class=\"no-sidebar section first last background-dark\"> <div class=background-photo></div> <div class=region-header> <div class=container> <div class=row> <div class=\"col-sm-12 center\"> <span class=\"logo finder full-logo\"></span> </div> </div> </div> </div> <div class=container-fluid> <div class=row ng-if=\"$ctrl.reset === false\"> <div class=\"col-sm-12 center\"> <div class=intro> <h1>Forget something?</h1> <p><small>I’m good. <a ui-sref=login>Sign in.</a></small></p> </div> <div class=row> <div class=\"col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 left\"> <form name=resetPasswordForm ng-submit=\"resetPasswordForm.$valid && $ctrl.sendResetEmail(email)\" novalidate ng-if=!$ctrl.ResponseRecieved> <p>Enter your email address below and we’ll send you password reset instructions.</p> <div class=form-group> <label for=email>Email</label> <input name=email id=email type=email autocapitalize=off class=form-control required ng-model=email> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"resetPasswordForm.email.$invalid && !resetPasswordForm.email.$pristine\"> Hmm...I don’t think that's a real email address. </p> </div> </div> <div class=\"button-container margin\"> <button class=\"button large finder-solid\" type=submit ng-disabled=resetPasswordForm.$invalid>Send</button> </div> </form> <div ng-if=$ctrl.ResponseRecieved> <p class=center> <strong>Check your inbox now.</strong><br/> If we found your email, we'll send you password reset instructions. </p> </div> </div> </div> </div> </div> <div class=row ng-if=\"$ctrl.reset === true\"> <div class=\"col-sm-12 center\"> <div class=intro> <h1>Reset your password.</h1> </div> <div class=row> <div class=\"col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 left\"> <form name=resetPasswordForm ng-submit=\"resetPasswordForm.$valid && $ctrl.sendNewPassword(request)\" novalidate> <p>Enter your new password below. We need at least 5 letters or numbers.</p> <div class=form-group> <label for=password>Password</label> <input name=password id=password type=password class=form-control required ng-minlength=5 ng-model=request.password> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"resetPasswordForm.password.$invalid && !resetPasswordForm.password.$pristine\"> Your password needs to be at least 5 characters, yo. </p> </div> </div> <div class=form-group> <label for=password_confirm>Confirm password</label> <input name=password_confirm id=password_confirm type=password class=form-control compare-to=request.password ng-model=request.password_confirm> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"resetPasswordForm.password_confirm.$error.compareTo && !resetPasswordForm.password_confirm.$pristine\"> Your passwords don’t match, or they are too short. </p> </div> </div> <div class=\"button-container margin\"> <button class=\"button large finder-solid\" type=submit ng-disabled=resetPasswordForm.$invalid>Reset password</button> </div> </form> </div> <div class=\"col-md-1 animate fade-in\" ng-if=request.password> <small class=pass-strength-label> <span ng-if=\"passStrength < 37\">Too weak</span> <span ng-if=\"passStrength > 37 && passStrength < 80\">Weak</span> <span ng-if=\"passStrength > 80\">Strong</span> </small> <div ng-password-strength=request.password mode=bootstrap inner-class=progress-bar inner-class-prefix=progress-bar- strength=passStrength> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/schedule/availability/_availability.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182510099
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/schedule/availability/availability.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAvailability = {
  bindings: {
    appointment: '<',
    type: '<?'
  },
  controller: 'AvailabilityController',
  template: __webpack_require__("./components/schedule/availability/availability.template.html")
};

angular.module('inkfinder').component('inkAvailability', inkAvailability);

/***/ }),

/***/ "./components/schedule/availability/availability.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AvailabilityController.$inject = ['Artists', 'SchedulingFactory', 'CheckCollisions', 'ScheduleUtilFactory', 'moment', 'Session', 'Appointments', 'ShopHours', 'Schedule', 'CalculateAvailability', '$q', '_'];


/**
 * @name AvailabilityController
 * @description Controller for availability
 * @param {type} Artists Description
 * @param {type} SchedulingFactory Description
 * @param {type} CheckCollisions Description
 * @param {type} ScheduleUtilFactory Description
 * @param {type} moment Description
 * @param {type} Session Description
 * @param {type} Appointments Description
 * @param {type} ShopHours Description
 * @param {type} Schedule Description
 * @param {type} CalculateAvailability Description
 * @param {type} $q Description
 * @param {type} _ Description
 */
function AvailabilityController(Artists, SchedulingFactory, CheckCollisions, ScheduleUtilFactory, moment, Session, Appointments, ShopHours, Schedule, CalculateAvailability, $q, _) {
  var vm = this;
  vm.type = _.isUndefined(vm.type) ? 'full' : vm.type;

  // Exposed Functions
  vm.selectArtist = selectArtist;
  vm.updateSearch = updateSearch;
  vm.getAvailability = getAvailability;
  vm.getSchedule = getSchedule;
  vm.detectCollision = detectCollision;
  vm.pagerPrev = pagerPrev;
  vm.pagerNext = pagerNext;
  vm.updateTime = updateTime;
  vm.reset = reset;
  vm.appointmentCompare = _.clone(vm.appointment);

  // Defaults
  vm.session = Session;
  vm.searchType = 1;
  vm.firstRun = true;
  vm.accordions = {};
  vm.range = {
    minDate: moment().toDate(),
    startDate: moment().toDate()
  };
  vm.time = {
    hours: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    minutes: [0, 15, 30, 45]
  };

  if (_.isUndefined(vm.appointment)) {
    vm.appointment = {};
  }

  // Block Data
  vm.availability = {};
  vm.selected = {};

  // Pager
  vm.resultLimit = 5;
  vm.pagerStart = 0;
  vm.pagerEnd = vm.resultLimit;

  // If you're an operator, get the full list of active artists at your shop.
  if (vm.session.activeState.role === 'operator') {
    Artists.refreshArtists().then(function (artists) {
      vm.artists = artists.confirmed;
    });
  }

  if (vm.appointment.appointment_datetime) {
    vm.accordions.openSchedule = false;
  } else {
    vm.accordions.openSchedule = true;
  }

  /**
   * @name getAvailability
   * @description Get artist time slots
   * @return {object} Unknown.
   */
  function getAvailability() {
    vm.accordions.openSchedule = true;
    vm.loading = true;
    var defaultSearch = vm.searchType === 1;
    var processedDates = SchedulingFactory.preprocessAvailabilityLookup(vm.range, defaultSearch);
    var duration = ScheduleUtilFactory.calculateDuration(vm.appointment.durationHours, vm.appointment.durationMinutes);
    var search = false;
    var timestamp = void 0;
    var promise1 = ShopHours.get(Session.activeState.association.shop.id).then(function (hours) {
      var data = {};
      var shopHours = ScheduleUtilFactory.getShopTimes(hours.all, processedDates.start, processedDates.end);
      return Appointments.get(search, shopHours.earliest.start, shopHours.latest.end, timestamp, vm.appointment.artist.id).then(function (appointments) {
        data = {
          shopHours: shopHours,
          appointments: appointments
        };
        return data;
      });
    });

    var promise2 = Schedule.fetchSchedules().then(function (rules) {
      return rules;
    });

    return $q.all([promise1, promise2]).then(function (result) {
      var data = {
        shopHours: result[0].shopHours,
        appointments: result[0].appointments,
        rules: result[1],
        artist: vm.appointment.artist
      };
      calculateSchedule(data.rules, data.shopHours, data.appointments, data.artist).then(function (schedule) {
        vm.schedule = schedule;
        var available = vm.schedule.available;
        var start = moment(vm.appointment.appointment_datetime);
        // Check to see if the artist is the same as before. If so, don't bother
        // adding the current appointment time to the available block of time.
        if (vm.appointmentCompare && vm.appointmentCompare.artist && vm.appointmentCompare.artist.id === vm.appointment.artist.id && start >= processedDates.start && vm.appointment.last_status && vm.appointment.last_status.status_name !== 'Unconfirmed') {
          var end = moment(vm.appointment.end_date);
          available.push({
            start: start,
            end: end,
            start_time: start.format('HH:mm:ss'),
            end_time: end.format('HH:mm:ss'),
            length: end.diff(start, 'minutes')
          });
        }
        available = ScheduleUtilFactory.mergeConsecutive(available);
        vm.availability.blocks = ScheduleUtilFactory.filterByDuration(available, duration);
        vm.pagerStart = 0;
        vm.pagerEnd = vm.resultLimit;
        pagerStatus();
        vm.firstRun = false;
        vm.loading = false;
      });
    });
  }

  /**
   * @name calculateSchedule
   * @description description
   * @param {type} rules Description
   * @param {type} shopHours Description
   * @param {type} appointments Description
   * @param {type} artist Description
   * @return {type} Description
   */
  function calculateSchedule(rules, shopHours, appointments, artist) {
    return $q(function (resolve, reject) {
      var schedule = {
        artist: artist,
        schedules: [],
        appointments: [],
        artist_start_end_times: []
      };

      var start = shopHours.earliest.start;
      var end = shopHours.latest.end;
      var artistScheduleInstances = ScheduleUtilFactory.generateRuleInstances(rules, start, end);
      artistScheduleInstances = ScheduleUtilFactory.filterExceptions(artistScheduleInstances);
      //  Add schedule instances to the schedule object, grouped by artist.
      _.each(artistScheduleInstances, function (instance) {
        var artistSelected = instance.rule.artist;
        if (schedule.artist.id === artistSelected) {
          schedule.schedules.push(instance);
        }
      });

      for (var j = 0; j < appointments.length; j++) {
        var appointment = appointments[j];
        var status = appointment.last_status.status_name;
        var date = appointment.date;
        if (start <= date && date <= end && (status === 'Confirmed' || status === 'Completed')) {
          schedule.appointments.push(appointment);
        }
      }
      var processedSchedule = processSchedule(schedule, shopHours);
      resolve(processedSchedule);
    });
  }

  /**
   * @name processSchedule
   * @description description
   * @param {type} scheduleGroup Description
   * @param {type} shopHours Description
   * @return {type} Description
   */
  function processSchedule(scheduleGroup, shopHours) {
    var start = shopHours.earliest.start;
    var end = shopHours.latest.end;

    var output = {
      artist: scheduleGroup.artist,
      artist_start_end_times: [],
      shop_start_time: start.diff(moment(start).startOf('day'), 'minutes'), // Not universally needed
      shop_end_time: end.diff(moment(end).startOf('day'), 'minutes'), // Not universally needed
      appointments: [],
      available: []
    };

    var appointments = scheduleGroup.appointments;
    if (appointments) {
      for (var i = 0; i < appointments.length; i++) {
        var appointment = appointments[i];
        var newBlock = {
          appointment_buffer: null, //  Do we still need this?
          start: appointment.date,
          end: appointment.end,
          start_time: appointment.date.format('HH:mm:ss'),
          end_time: appointment.end.format('HH:mm:ss'),
          interval_back_to_shop_start_time: appointment.date.diff(start, 'minutes'),
          length: appointment.duration, //  Should rename this to duration?
          appointment: appointment
        };
        output.appointments.push(newBlock);
      }
    }

    var scheduleInstances = scheduleGroup.schedules;
    if (scheduleInstances) {
      for (var x = 0; x < scheduleInstances.length; x++) {
        var instance = scheduleInstances[x];
        var rule = instance.rule;

        var interval = {
          start: instance.start,
          end: instance.end,
          start_time: rule.start_time,
          end_time: rule.end_time
        };
        output.artist_start_end_times.push(interval);
      }

      var available = CalculateAvailability.calculate(scheduleInstances, appointments);
      for (var d = 0; d < available.length; d++) {
        var item = available[d];
        item.start_time = item.start.format('HH:mm:ss');
        item.end_time = item.end.format('HH:mm:ss');
        item.length = item.end.diff(item.start, 'minutes'); //  Change to duration?
        item.interval_back_to_shop_start_time = item.start.diff(start, 'minutes');
      }
      output.available = available;
    }
    return output;
  }

  /**
  * @name getSchedule
  * @description Get the Schedule (after selecting the time block).
  * @param {unknown} block Unknown.
  */
  function getSchedule(block) {
    resetAlerts();
    var duration = ScheduleUtilFactory.calculateDuration(vm.appointment.durationHours, vm.appointment.durationMinutes);
    vm.selected.block = block;

    // Set Timepickers
    vm.appointment.appointment_start_time = vm.selected.block.start.toDate();
    vm.appointment.appointment_end_time = moment(vm.selected.block.start).add(duration, 'minutes').toDate();
  }

  /**
  * @name updateSearch
  * @description Start an avaibility search.
  */
  function updateSearch() {
    if (vm.appointment.artist.id && (vm.appointment.durationHours || vm.appointment.durationMinutes)) {
      getAvailability();
    }
  }

  /**
  * @name detectCollision
  * @description Function to detect collisions with the current appointment and
  * other appointments on the schedule.
  */
  function detectCollision() {
    var available = vm.availability.blocks;
    var appointments = vm.schedule.appointments;
    var block = vm.selected.block;
    var appointment = {
      start: moment(vm.appointment.appointment_start_time),
      end: moment(vm.appointment.appointment_end_time),
      id: vm.appointment.id
    };
    CheckCollisions.check(available, appointments, block, appointment).then(function (data) {
      vm.clientAlerts.errors = data.errors;
      vm.clientAlerts.warnings = data.warnings;

      // Use the properly verified Date.
      vm.appointment.adjusted_appointment_date = appointment.start;
    });
  }

  /**
  * @name selectArtist
  * @description Select an artist.
  * @param {unknown} artist Unknown.
  */
  function selectArtist(artist) {
    if (vm.appointment.artist && vm.appointment.artist.id === artist.id) {
      vm.appointment.artist = {};
      resetAvailabilityData();
    } else {
      vm.appointment.artist = artist;
      updateSearch();
    }
  }

  /**
  * @name updateTime
  * @description Update the start or end time to be a certain duration.
  * @param {sting} type Unknown.
  */
  function updateTime(type) {
    var update = vm.appointment;
    var duration = ScheduleUtilFactory.calculateDuration(update.durationHours, update.durationMinutes);
    if (type === 'start') {
      update.appointment_start_time = moment(update.appointment_end_time).subtract(duration, 'minutes').toDate();
    } else {
      update.appointment_end_time = moment(update.appointment_start_time).add(duration, 'minutes').toDate();
    }
    detectCollision();
  }

  /**
  * @name pagerPrev
  * @description Pager controls for the Previous button.
  */
  function pagerPrev() {
    vm.pagerStart -= vm.resultLimit;
    vm.pagerEnd -= vm.resultLimit;
    pagerStatus();
  }

  /**
  * @name pagerNext
  * @description Pager controls for the Next button.
  */
  function pagerNext() {
    vm.pagerStart += vm.resultLimit;
    vm.pagerEnd += vm.resultLimit;
    pagerStatus();
  }

  /**
  * @name processOverflow
  * @description Calculates the correct quantity for the last results in the pager.
  * @return {unknown} Unknown
  */
  function processOverflow() {
    return Math.max(vm.pagerEnd - vm.availability.blocks.length, 0);
  }

  /**
  * @name pagerStatus
  * @description Determine if the pager (Prev/Next) needs to be disabled or not.
  */
  function pagerStatus() {
    vm.prevDisabled = vm.pagerStart < vm.resultLimit;
    vm.nextDisabled = vm.pagerEnd >= vm.availability.blocks.length;
    vm.availability.pagedBlocks = vm.availability.blocks.slice(vm.pagerStart, vm.pagerEnd);
    vm.resultsOverflow = processOverflow();
    vm.selected = {};
  }

  /**
  * @name reset
  * @description Unknown.
  */
  function reset() {
    vm.firstRun = true;
    delete vm.selected_date;
    resetAlerts();
    resetAvailabilityData();
  }

  /**
  * @name resetAvailabilityData
  * @description Reset values to empty.
  */
  function resetAvailabilityData() {
    vm.availability = {};
  }

  /**
  * @name resetAlerts
  * @description Reset values to empty.
  */
  function resetAlerts() {
    vm.clientAlerts = { errors: [], warnings: [] };
    // vm.serverAlerts = {errors: [], warnings: []};
  }
}

angular.module('inkfinder').controller('AvailabilityController', AvailabilityController);

/***/ }),

/***/ "./components/schedule/availability/availability.template.html":
/***/ (function(module, exports) {

module.exports = "<div> <div class=row> <div class=col-sm-12> <div class=\"list profiles\" ng-if=\"$ctrl.session.activeState.role === 'operator'\"> <h5 class=center>Select an artist.</h5> <div class=\"item profile\" ng-repeat=\"artist in $ctrl.artists track by artist.id\" ng-click=$ctrl.selectArtist(artist)> <ink-profile-photo selectable=true profile=artist selected=\"artist.id == $ctrl.appointment.artist.id\" image-id=artist.profile_photo></ink-profile-photo> </div> <div class=status-message> <p ng-if=!$ctrl.artists>Loading...</p> <p ng-if=\"$ctrl.artists.length === 0\"> <small>No artists found.</small> </p> </div> </div> </div> </div> <div class=row ng-if=\"$ctrl.type === 'full' || $ctrl.type === 'check'\"> <div class=col-sm-12> <uib-accordion class=\"accordion medium inline-accordion\"> <div uib-accordion-group is-open=$ctrl.accordions.openSchedule> <uib-accordion-heading> <div class=heading> <p class=\"headline animate\" ng-if=!$ctrl.appointment.appointment_datetime> <fa name=clock-o class=\"icon large dark\"></fa> <span ng-if=\"$ctrl.type === 'full'\">Set a date and time for this session</span> <span ng-if=\"$ctrl.type === 'check'\">Check availability for <span ng-if=!$ctrl.appointment.artist.id> an artist</span> <span ng-if=$ctrl.appointment.artist> {{$ctrl.appointment.artist.first_name}}</span> </span> </p> <p class=headline ng-if=$ctrl.appointment.appointment_datetime> <fa name=clock-o class=\"icon large dark\"></fa> This appointment is scheduled for {{$ctrl.appointment.appointment_datetime | amDateFormat:'MM/DD/YYYY'}} at {{$ctrl.appointment.appointment_datetime | amDateFormat:'h:mm a'}} </p> </div> </uib-accordion-heading> <div class=row> <div class=col-md-12> <h6 ng-if=$ctrl.appointment.appointment_datetime> Change this appointment date and time </h6> <p> <small ng-if=\"$ctrl.appointment.preferred_startDate || $ctrl.appointment.preferred_end_date || $ctrl.appointment.preferredTime\"> Preferred: {{$ctrl.appointment.preferred_startDate | amDateFormat:'MM/DD/YYYY'}}<span ng-if=\"$ctrl.appointment.preferred_startDate && $ctrl.appointment.preferred_end_date\"> - </span> {{$ctrl.appointment.preferred_end_date | amDateFormat:'MM/DD/YYYY'}}<span ng-if=\"$ctrl.appointment.preferredTime && ($ctrl.appointment.preferred_startDate || $ctrl.appointment.preferred_end_date)\"> | </span><span ng-if=$ctrl.appointment.preferredTime>{{$ctrl.appointment.preferredTime.description}}</span> </small> </p> <p>Appointment duration</p> </div> <div class=\"col-md-6 form-group\"> <label for=length_hours>Hours</label> <select name=length_hours id=length_hours ng-model=$ctrl.appointment.durationHours ng-change=$ctrl.updateSearch(); ng-options=\"hour for hour in $ctrl.time.hours\"> <option value=\"\">Select one</option> </select> </div> <div class=\"col-md-6 form-group\"> <label for=length_minutes>Minutes</label> <select name=length_minutes id=length_minutes ng-model=$ctrl.appointment.durationMinutes ng-change=$ctrl.updateSearch(); ng-options=\"minute for minute in $ctrl.time.minutes\"> <option value=\"\">Select one</option> </select> </div> <div class=col-md-12> <div class=form-group ng-init=\"$ctrl.searchType = 1\"> <div class=\"input-group toggle\"> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.searchType === 1}\"> <input type=radio name=set_appointment ng-change=$ctrl.updateSearch(); ng-model=$ctrl.searchType ng-value=1> Find the first available options </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.searchType === 2}\"> <input type=radio name=set_appointment ng-change=$ctrl.updateSearch(); ng-model=$ctrl.searchType ng-value=2> Search a specific day </label> </div> </div> </div> </div> <div class=col-md-6 ng-if=\"$ctrl.searchType === 2\"> <div class=form-group> <label for=available_start_range>Start Date</label> <div class=input-group> <input name=available_start_range id=available_start_range ng-change=$ctrl.updateSearch(); ng-required=true type=text class=form-control placeholder=MM/DD/YYYY min-date=$ctrl.range.minDate max-date=maxDate uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=$ctrl.range.startDate is-open=$ctrl.date_picker.start_open datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"$ctrl.date_picker.start_open = !$ctrl.date_picker.start_open\"> <fa name=calendar-o></fa> </button> </span> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateAppointment.available_start_range.$invalid &&\n                      !updateAppointment.available_start_range.$pristine\"> Please enter a valid date. </p> </div> </div> </div> <div class=col-md-6 ng-if=\"$ctrl.searchType === 2\"> <div class=form-group> <label for=available_end_range>End Date</label> <div class=input-group> <input name=available_end_range id=available_end_range ng-change=$ctrl.updateSearch(); type=text class=form-control placeholder=MM/DD/YYYY min-date=$ctrl.range.startDate max-date=maxDate uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=$ctrl.range.endDate is-open=$ctrl.date_picker.end_open datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"$ctrl.date_picker.end_open = !$ctrl.date_picker.end_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-12> <div class=button-container> <button type=button class=\"button small shop-solid\" ng-disabled=!$ctrl.appointment.artist.id ng-click=$ctrl.updateSearch()>Search</button> <button class=\"button small alert-btn-light\" type=button ng-click=$ctrl.reset() ng-disabled=\"$ctrl.loading || !$ctrl.availability.blocks.length\">Reset</button> </div> </div> <div class=col-md-12 ng-if=$ctrl.availability.blocks.length> <div class=\"divider small tight\"></div> </div> <div class=col-md-12 ng-if=\"!$ctrl.availability.blocks.length && !$ctrl.firstRun && !$ctrl.loading && $ctrl.appointment.artist.id\"> <p>Sorry, there are no available time slots for {{$ctrl.appointment.artist.first_name}} {{$ctrl.appointment.artist.last_name}}.</p> </div> <div class=col-md-12 ng-if=$ctrl.availability.blocks.length> <div class=available-dates ng-class=\"{'loading': $ctrl.loading}\"> <div class=row> <div class=col-md-12> <p class=inline>Available time slots for {{$ctrl.appointment.artist.first_name}} {{$ctrl.appointment.artist.last_name}}:</p> <span class=time-listings-navigation ng-if=\"$ctrl.availability.blocks.length > $ctrl.resultLimit\"> <div class=\"button-container double\"> <button class=\"button small\" type=button ng-disabled=$ctrl.prevDisabled ng-click=$ctrl.pagerPrev()> Previous </button> <button class=\"button small\" type=button ng-disabled=$ctrl.nextDisabled ng-click=$ctrl.pagerNext()> Next </button> </div> </span> </div> </div> <div class=available-date ng-repeat=\"available_block in $ctrl.availability.pagedBlocks track by $index\" ng-class=\"{'selected':$ctrl.selected.index === $index}\"> <label class=full> <input ng-if=\"$ctrl.type === 'full'\" type=radio name=date id=date ng-value=available_block.start ng-change=\"$ctrl.getSchedule(available_block); $ctrl.selected.index = $index\" ng-model=$ctrl.appointment.appointment_date> {{available_block.start | amDateFormat:'dddd, MMMM Do'}} — <small> Available from {{available_block.start | amDateFormat:'h:mm a'}} – {{available_block.end | amDateFormat:'h:mm a'}} </small> </label> <div ng-if=\"$ctrl.appointment.appointment_date && $ctrl.selected.index === $index\"> <fieldset ng-disabled=$ctrl.loading> <div class=col-md-12> <div class=\"divider small tight\"></div> <p>Adjust the appointment time, if needed.</p> </div> <div class=col-md-6> <div class=form-group> <label for=appointment_start_time>Start time</label> <div uib-timepicker name=appointment_start_time hour-step=1 minute-step=15 mousewheel=false show-meridian=true class=time-picker ng-model=$ctrl.appointment.appointment_start_time ng-change=\"$ctrl.updateTime('end')\"></div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateAppointment.appointment_start_time.$invalid && !updateAppointment.appointment_start_time.$pristine\"> Please enter a valid time. </p> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=appointment_end_time>End time</label> <div uib-timepicker name=appointment_end_time hour-step=1 minute-step=15 mousewheel=false show-meridian=true class=time-picker ng-model=$ctrl.appointment.appointment_end_time ng-change=\"$ctrl.updateTime('start')\"></div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"updateAppointment.appointment_end_time.$invalid && !updateAppointment.appointment_end_time.$pristine\"> Please enter a valid time. </p> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert warning\" ng-repeat=\"warning in $ctrl.clientAlerts.warnings\" ng-hide=\"$ctrl.clientAlerts.errors.length > 0\"> {{warning}} </p> <p class=\"inline-alert error\" ng-repeat=\"error in $ctrl.clientAlerts.errors\"> {{error}} </p> </div> </div> </fieldset> </div> </div> </div> </div> </div> </div> </uib-accordion> </div> </div> </div> ";

/***/ }),

/***/ "./components/schedule/availability/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/schedule/availability/availability.component.js");

__webpack_require__("./components/schedule/availability/availability.controller.js");

__webpack_require__("./components/schedule/availability/_availability.styles.scss");

/***/ }),

/***/ "./components/schedule/check-availability/availability.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


AvailabilityCheckController.$inject = ['$uibModalInstance'];


/**
 * @name AvailabilityCheckController
 * @description Controller to check availability
 * @param {type} $uibModalInstance Description
 */
function AvailabilityCheckController($uibModalInstance) {
  var vm = this;

  vm.close = function () {
    $uibModalInstance.dismiss('close');
  };
}

angular.module('inkfinder').controller('AvailabilityCheckController', AvailabilityCheckController);

/***/ }),

/***/ "./components/schedule/check-availability/check-availability.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h3 class=modal-title>Check artist availability</h3> </div> <div class=\"modal-body background-light\"> <ink-availability type=\"'check'\"></ink-availability> </div> <div class=modal-footer> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.close()>Close</button> </div> ";

/***/ }),

/***/ "./components/schedule/check-availability/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/schedule/check-availability/availability.controller.js");

/***/ }),

/***/ "./components/schedule/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/schedule/availability/index.js");

__webpack_require__("./components/schedule/check-availability/index.js");

__webpack_require__("./components/schedule/update/index.js");

__webpack_require__("./components/schedule/util/index.js");

__webpack_require__("./components/schedule/schedule.service.js");

__webpack_require__("./components/schedule/schedules.service.js");

/***/ }),

/***/ "./components/schedule/schedule.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('SchedulingFactory', ['$q', 'ShopHours', 'Appointments', 'MergeProjects', 'Artists', 'ScheduleUtilFactory', 'Schedule', 'moment', 'CalculateAvailability', 'Session', '_', function SchedulingFactory($q, ShopHours, Appointments, MergeProjects, Artists, ScheduleUtilFactory, Schedule, moment, CalculateAvailability, Session, _) {
  // Public methods
  SchedulingFactory.getSchedule = getSchedule;
  SchedulingFactory.fetchScheduleData = fetchScheduleData;
  SchedulingFactory.calculateSchedule = calculateSchedule;
  SchedulingFactory.preprocessAvailabilityLookup = preprocessAvailabilityLookup;

  /**
   * @name getSchedule
   * @description Returns one or more schedules between start and end. If
   * artistId is specified, the schedule data for that artist will be returned
   * if it exists. If no artistId is specified, an array of all schedule data
   * will be returned.
   * @param {unknown} start Unknown
   * @param {unknown} end Unknown
   * @param {unknown} artistId Unknown
   * @return {unknown} Unknown
   */
  function getSchedule(start, end) {
    return $q(function (resolve, reject) {
      fetchScheduleData(start, end).then(function (data) {
        var schedules = calculateSchedule(data.rules, data.shopHours, data.appointments, data.artists);
        resolve(schedules);
      });
    });
  }

  /**
   * @name fetchScheduleData
   * @description Function to call endpoints needed to return schedule data for
   * the Appointments controller.
   * @param {unknown} start Unknown
   * @param {unknown} end Unknown
   * @param {unknown} request The type of request sent. If request.force = true,
   * then reject any return of data till the forced request is returned.
   * @return {object} scheduleData Returns an object with appointments, artist
   * hours rules, artists, and shop hours.
   */
  function fetchScheduleData(start, end) {
    var search = false;
    var timestamp = void 0;
    var scheduleData = void 0;
    var artist = void 0;
    if (Session.activeState.role === 'artist') {
      artist = Session.collector.id;
    }
    var promise1 = ShopHours.get(Session.activeState.association.shop.id).then(function (hours) {
      var data = {
        mergedData: [],
        shopHours: {}
      };
      var shopHours = ScheduleUtilFactory.getShopTimes(hours.all, start, end);
      return Appointments.get(search, shopHours.earliest.start, shopHours.latest.end, timestamp, artist).then(function (appointments) {
        // only need appointments that are not archived
        var nonArchivedAppointments = _.filter(appointments, function (appt) {
          return !(appt.current_status == 100);
        });
        if (nonArchivedAppointments.length > 0) {
          // group appointments by artists
          var artistAppointments = _.groupBy(nonArchivedAppointments, function (appointment) {
            return appointment.artist.id;
          });
          var allApptsSortedByDate = [];
          Object.keys(artistAppointments).forEach(function (key, index) {
            // Find overlapping appointments
            // Sort by start
            var apptsSortedByDate = _.sortBy(artistAppointments[key], function (appointment) {
              return appointment.start.valueOf();
            });
            // Loop through sorted appts and compare start and end
            // times of consecutive appts
            for (var i = 1; i < apptsSortedByDate.length; ++i) {
              if (apptsSortedByDate[i].start < apptsSortedByDate[i - 1].end) {
                apptsSortedByDate[i].overlappingAppt = true;
                apptsSortedByDate[i].apptLevel = i;
                apptsSortedByDate[i - 1].overlappingAppt = true;
              }
            }
            allApptsSortedByDate = allApptsSortedByDate.concat(apptsSortedByDate);
          });
          return MergeProjects.merge(allApptsSortedByDate).then(function (mergedData) {
            data = {
              mergedData: mergedData,
              shopHours: shopHours
            };
            return data;
          });
        }
        data = {
          mergedData: [],
          shopHours: shopHours
        };
        return data;
      });
    });

    var promise2 = Schedule.fetchSchedules().then(function (rules) {
      return rules;
    });

    var promise3 = Artists.fetchArtists().then(function (artists) {
      if (Session.activeState.role === 'artist') {
        var selectedArtist = _.find(artists.valid, function (artist) {
          if (Session.activeState.association.id === artist.association.id) {
            return true;
          }
        });
        artists.valid = [];
        artists.valid.push(selectedArtist);
        return artists.valid;
      }

      // Find associations with duplicate artists and use the latest one
      var duplicateGroups = _(artists.valid).groupBy(function (group) {
        return group.artist.id;
      }).filter(function (group) {
        return group.length > 1;
      }).value();

      // Remove all but the latest association
      var newestAssociations = _.map(duplicateGroups, function (group) {
        return _.maxBy(group, 'id');
      });

      // Find all associations that have unque artsts
      var singleGroups = _(artists.valid).groupBy(function (group) {
        return group.artist.id;
      }).filter(function (group) {
        return group.length == 1;
      }).flatMap(function (group) {
        return group;
      }).value();

      // Concat together latest and unique associations
      var updatedArtists = singleGroups.concat(newestAssociations);
      return updatedArtists;
    });
    return $q.all([promise1, promise2, promise3]).then(function (result) {
      scheduleData = {
        shopHours: result[0].shopHours,
        appointments: result[0].mergedData,
        rules: result[1],
        artists: result[2]
      };
      return scheduleData;
    });
  }

  /**
   * @name calculateSchedule
   * @description Function to calculate the schedule based on artist hours,
   * shop hours, appoitments, and artists
   * @param {unknown} rules unknown
   * @param {unknown} shopHours unknown
   * @param {array} appointments The array of projects and appointments
   * @param {array} artists unknown
   * @return {unknown} schedules Unknown
   */
  function calculateSchedule(rules, shopHours, appointments, artists) {
    var schedule = {};
    _.each(artists, function (artist) {
      schedule[artist.id] = {
        artist: artist,
        schedules: [],
        appointments: [],
        artist_start_end_times: []
      };
    });
    var start = shopHours.earliest.start;
    var end = shopHours.latest.end;
    var artistScheduleInstances = ScheduleUtilFactory.generateRuleInstances(rules, start, end);
    artistScheduleInstances = ScheduleUtilFactory.filterExceptions(artistScheduleInstances);
    //  Add schedule instances to the schedule object, grouped by artist.
    _.each(artistScheduleInstances, function (instance) {
      var artistSelected = instance.rule.artist;
      if (schedule[artistSelected]) {
        schedule[artistSelected].schedules.push(instance);
      }
    });

    for (var j = 0; j < appointments.length; j++) {
      var appointment = appointments[j];
      var status = appointment.appointment.last_status.status_name;
      var date = moment(appointment.appointment.appointment_datetime);
      if (start <= date && date <= end && (status === 'Collector cancelled' || status === 'Artist cancelled' || status === 'Requested' || status === 'Unconfirmed' || status === 'Confirmed' || status === 'Completed')) {
        var artistForAppointment = appointment.appointment.artist.id;
        if (schedule[artistForAppointment]) {
          schedule[artistForAppointment].appointments.push(appointment);
        }
      }
    }

    var schedules = [];
    for (var key in schedule) {
      if ({}.hasOwnProperty.call(schedule, key)) {
        var artistSchedule = processSchedule(schedule[key], shopHours);
        schedules.push(artistSchedule);
      }
    }
    return schedules;
  }

  /**
   * @name processSchedule
   * @description Function to (I think) build schedule blocks
   * @param {unknown} scheduleGroup Unknown
   * @param {unknown} shopHours Unknown
   * @return {unknown} Unknown Unknown
   */
  function processSchedule(scheduleGroup, shopHours) {
    var start = shopHours.earliest.start;
    var end = shopHours.latest.end;

    var output = {
      artist: scheduleGroup.artist,
      artist_start_end_times: [],
      shop_start_time: start.diff(moment(start).startOf('day'), 'minutes'), // Not universally needed
      shop_end_time: end.diff(moment(end).startOf('day'), 'minutes'), // Not universally needed
      appointments: [],
      available: []
    };

    var appointments = scheduleGroup.appointments;
    if (appointments) {
      for (var i = 0; i < appointments.length; i++) {
        var project = appointments[i].project;
        var appointment = appointments[i].appointment;
        var newBlock = {
          appointment_buffer: null, //  Do we still need this?
          start: appointment.date,
          end: appointment.end,
          start_time: appointment.date.format('HH:mm:ss'),
          end_time: appointment.end.format('HH:mm:ss'),
          interval_back_to_shop_start_time: appointment.date.diff(start, 'minutes'),
          length: appointment.duration, //  Should rename this to duration?
          project: project,
          appointment: appointment
        };
        output.appointments.push(newBlock);
      }
    }

    var scheduleInstances = scheduleGroup.schedules;
    if (scheduleInstances) {
      for (var x = 0; x < scheduleInstances.length; x++) {
        var instance = scheduleInstances[x];
        var rule = instance.rule;

        var interval = {
          start: instance.start,
          end: instance.end,
          start_time: rule.start_time,
          end_time: rule.end_time
        };
        output.artist_start_end_times.push(interval);
      }

      //  Each 'appointment' object is a wrapper for a project and appointment, get the appointments within the wrapper
      var appointmentInner = [];
      for (var j = 0; j < appointments.length; j++) {
        appointmentInner.push(appointments[j].appointment);
      }

      var available = CalculateAvailability.calculate(scheduleInstances, appointmentInner);
      for (var d = 0; d < available.length; d++) {
        var item = available[d];
        item.start_time = item.start.format('HH:mm:ss');
        item.end_time = item.end.format('HH:mm:ss');
        item.length = item.end.diff(item.start, 'minutes'); //  Change to duration?
        item.interval_back_to_shop_start_time = item.start.diff(start, 'minutes');
      }
      output.available = available;
    }
    return output;
  }

  /**
   * @name preprocessAvailabilityLookup
   * @description description
   * @param {type} range Description
   * @param {type} defaultSearch Description
   * @return {type} Description
   */
  function preprocessAvailabilityLookup(range, defaultSearch) {
    var start = moment(range.startDate);
    var end = void 0;
    if (defaultSearch) {
      end = moment(start).add(1, 'year');
    } else if (range.endDate) {
      end = moment(range.endDate).endOf('day');
    } else {
      end = moment(start).add(1, 'day');
    }
    return { start: start, end: end };
  }
  return SchedulingFactory;
}]);

/***/ }),

/***/ "./components/schedule/schedules.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Schedule', ['$q', '$http', '$rootScope', '$interval', 'ENDPOINT', 'Shop', 'ScheduleUtilFactory', 'Session', 'moment', '_', function Schedule($q, $http, $rootScope, $interval, ENDPOINT, Shop, ScheduleUtilFactory, Session, moment, _) {
  // Public methods
  Schedule.fetchSchedules = fetchSchedules;
  Schedule.editRule = editRule;
  Schedule.removeRule = removeRule;
  Schedule.getArtistSchedule = getArtistSchedule;
  Schedule.parseSchedules = parseSchedules;
  Schedule.refreshSchedules = refreshSchedules;
  Schedule.generate_selected_days_object = generate_selected_days_object;

  // Private variables
  var qwe = void 0;

  // Called to Reset Data on Logout
  var deregister = $rootScope.$on('clear-data', function () {
    $interval.cancel(qwe.schedules.timer);
    resetVariables();
  });
  $rootScope.$on('$destroy', deregister);

  resetVariables();

  /**
   * @name resetVariables
   */
  function resetVariables() {
    qwe = {
      schedules: {}
    };
    Schedule.rules = [];
  }

  /**
   * @name createScheduleTimer
   */
  function createScheduleTimer() {
    if (!qwe.schedules.timer) {
      qwe.schedules.timer = $interval(makeNewSchedulePromise, 1000);
    }
  }

  /**
   * @name makeNewSchedulePromise
   */
  function makeNewSchedulePromise() {
    if (!shouldRefresh()) {
      return;
    }

    qwe.schedules.promise = $q(function (resolve, reject) {
      var id = Session.activeState.association.id;
      if (id) {
        qwe.schedules.refreshing = true;

        // Check if artist is logged in
        if (Session.activeState.role === 'artist') {
          // call for single artist hours
          var shopId = Session.activeState.association.shop.id;
          $http.get(ENDPOINT.server + 'schedules/api/v1.1/artist-hours/?artist_id=' + Session.collector.id + '&shop_id=' + shopId).then(function (response) {
            if (qwe.schedules.timer) {
              parseSchedules(response.data);
              Schedule.rules = response.data;
              qwe.schedules.updated = moment();
              resolve(Schedule.rules);
            }
            qwe.schedules.refreshing = false;
            resolve(Schedule.rules);
          }, function (error) {
            reject(error);
          });
        } else {
          // For all other user types, like operator
          $http.get(ENDPOINT.server + 'schedules/api/v1.1/artist-hours/all/?association_id=' + id).then(function (response) {
            if (qwe.schedules.timer) {
              parseSchedules(response.data);
              Schedule.rules = response.data;
              qwe.schedules.updated = moment();
              resolve(Schedule.rules);
            }
            qwe.schedules.refreshing = false;
            resolve(Schedule.rules);
          }, function (error) {
            reject(error);
          });
        }
      } else {
        reject('Association not Set');
      }
    });
  }

  /**
   * @name shouldRefresh
   * @return {unknown} Unknown
   */
  function shouldRefresh() {
    return !qwe.schedules.refreshing && (!qwe.schedules.updated || moment().diff(qwe.schedules.updated, 'seconds') >= 61);
  }

  /**
   * @name fetchSchedules
   * @return {unknown} Unknown
   */
  function fetchSchedules() {
    createScheduleTimer();
    makeNewSchedulePromise();
    return qwe.schedules.promise;
  }

  /**
   * @name refreshSchedules
   * @return {unknown} Unknown
   */
  function refreshSchedules() {
    qwe.schedules.updated = null;
    return fetchSchedules();
  }

  /**
   * @name parseSchedules
   * @param {unknown} data Unknown
   */
  function parseSchedules(data) {
    for (var i = 0; i < data.length; i++) {
      var rule = data[i];
      rule.start = moment(rule.start_date + 'T' + rule.start_time);
      rule.first_sunday = moment(rule.start).startOf('week');
      ScheduleUtilFactory.booleansToDays(rule);
      ScheduleUtilFactory.daysToText(rule);
      if (rule.end_date) {
        rule.end = moment(rule.end_date + 'T' + rule.end_time);
      }
    }
  }

  /**
   * @name getArtistSchedule
   * @description Unknown
   * @param {Unknown} id Unknown
   * @return {unknown} Unknown
   */
  function getArtistSchedule(id) {
    var returnVal = [];
    for (var i = 0; i < Schedule.rules.length; i++) {
      if (Schedule.rules[i].artist === id) {
        returnVal.push(Schedule.rules[i]);
      }
    }
    return returnVal;
  }

  Schedule.check_dates = function (form, override, today) {
    var errors = [];
    if (form.temp.raw_end_date) {
      if (moment(form.temp.raw_end_date).startOf('day').unix() < moment(form.temp.raw_start_date).startOf('day').unix()) {
        errors.push('End date cannot be before start date.');
      }
      if (moment(form.temp.raw_end_date).startOf('day').unix() < moment().startOf('day').unix()) {
        errors.push('End date cannot be before today.');
      }
    }
    if (moment(form.temp.raw_start_date).startOf('day').unix() < moment().startOf('day').unix() && override) {
      errors.push('You can’t add a schedule to the past.');
    }
    return errors;
  };

  // Submit the Exception to the API
  Schedule.submitNewRule = function (rule) {
    rule.role = Session.activeState.role;
    rule.association_id = Session.activeState.association.id;

    return $http.post(ENDPOINT.server + 'schedules/api/v1.1/artist-hours/create/', rule).then(function (response) {
      return response.data;
    }, function (error) {
      throw error;
    });
  };

  /**
   * @name editRule
   * @description description
   * @param {type} rule Description
   * @return {type} Description
   */
  function editRule(rule) {
    rule.association_id = Session.activeState.association.id;
    return $http.post(ENDPOINT.server + 'schedules/api/v1.1/artist-hours/' + rule.artist_hour_id + '/', rule).then(function (response) {
      return response.data;
    }, function (error) {
      throw error;
    });
  }

  /**
   * @name removeRule
   * @description description
   * @param {type} rule Description
   * @param {type} day Description
   * @return {type} Description
   */
  function removeRule(rule, day) {
    // Becuase we want to preserve the rules, we expire the rule by setting it before the currently selected day.
    var processed = _.cloneDeep(rule);

    if (moment(rule.start_date).startOf('day') >= moment().startOf('day')) {
      processed.deleted = true;
    } else if (rule.is_off) {
      processed.end_date = moment().startOf('day').format('YYYY-MM-DD');
    } else if (moment(rule.start_time, 'HH:mm:ss').unix() > moment(rule.end_time, 'HH:mm:ss').unix()) {
      processed.end_date = moment().startOf('day').format('YYYY-MM-DD');
    } else {
      processed.end_date = moment().startOf('day').subtract(1, 'day').format('YYYY-MM-DD');
    }

    processed.association_id = Session.activeState.association.id;

    var url = ENDPOINT.server + 'schedules/api/v1.1/artist-hours/' + processed.artist_hour_id + '/';

    return $http.post(url, processed).then(function (response) {
      return response.data;
    }, function (error) {
      throw error;
    });
  }

  Schedule.sort_hour_types = function (hours, date) {
    var hours_by_rules = [];
    var hours_by_exceptions = [];
    var hours_by_off = [];
    // let off_count = 0;

    _.each(hours, function (hour_data) {
      // If no end_date is set the schedule hasn't expired. If the end date is specified make sure it's still valid.
      if (moment(hour_data.end_date, 'YYYY-MM-DD').endOf('day').unix() >= date.unix() || !hour_data.end_date) {
        if (hour_data.is_exception === true) {
          hours_by_exceptions.push(hour_data);
        } else {
          hours_by_rules.push(hour_data);
        }
        if (hour_data.is_off === true) {
          hours_by_off.push(hour_data);
        }
      }
    });
    return {
      by_rules: hours_by_rules,
      by_exceptions: hours_by_exceptions
    };
  };

  /**
   * @name generate_selected_days_object
   * @description description
   * @param {type} day Description
   * @param {type} all Description
   * @return {type} Description
   */
  function generate_selected_days_object(day, all) {
    var processed = [];
    if (all) {
      return processed.concat(ScheduleUtilFactory.daysArray);
    }
    return processed.concat(ScheduleUtilFactory.days[day.format('dddd').toLowerCase()]);
  }
  return Schedule;
}]);

/***/ }),

/***/ "./components/schedule/update/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/schedule/update/schedule-update-controller.js");

/***/ }),

/***/ "./components/schedule/update/schedule-update-controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _groupApptsByDay = __webpack_require__("./utils/group-appts-by-day.js");

var _groupApptsByDay2 = _interopRequireDefault(_groupApptsByDay);

var _groupByApptStatus = __webpack_require__("./utils/group-by-appt-status.js");

var _groupByApptStatus2 = _interopRequireDefault(_groupByApptStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ScheduleUpdateController.$inject = ['$uibModalInstance', '$q', 'Schedule', 'ScheduleUtilFactory', 'Artists', 'ShopHours', 'Appointments', 'artist', 'schedule', 'date', 'moment', 'ProcessSchedule', 'ScheduleApiFormat', 'ExceptionApiFormat', 'CheckHoursCollisions', 'Session', '_'];


/**
 * @name ScheduleUpdateController
 * @description Controller for schedule updating
 * @param {type} $uibModalInstance Description
 * @param {type} $q Description
 * @param {type} Schedule Description
 * @param {type} ScheduleUtilFactory Description
 * @param {type} Artists Description
 * @param {type} ShopHours Description
 * @param {type} Appointments Description
 * @param {type} artist Description
 * @param {type} schedule Description
 * @param {type} date Description
 * @param {type} moment Description
 * @param {type} ProcessSchedule Description
 * @param {type} ScheduleApiFormat Description
 * @param {type} ExceptionApiFormat Description
 * @param {type} CheckHoursCollisions Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 */
function ScheduleUpdateController($uibModalInstance, $q, Schedule, ScheduleUtilFactory, Artists, ShopHours, Appointments, artist, schedule, date, moment, ProcessSchedule, ScheduleApiFormat, ExceptionApiFormat, CheckHoursCollisions, Session, _) {
  var vm = this;
  vm.isFuture = isFuture;
  vm.schedule = schedule;
  vm.artist = artist;
  vm.day = moment(date);
  vm.loading = false;
  var today = moment();

  // Public methods
  vm.submitException = submitException;
  vm.removeException = removeException;
  vm.editException = editException;
  vm.removeRule = removeRule;
  vm.edit = edit;

  var unsorted_artist_hours = [];
  var unsorted_selected_hours = [];

  vm.artist_schedule = { by_rules: [], by_exceptions: [] };
  vm.selected_hours = { by_rules: [], by_exceptions: [] };
  vm.artists = [];
  vm.appointments = [];
  vm.status = {};

  vm.shop_hours = ShopHours.shopHours;

  // For the Day Selector Plugin
  vm.weekdays = ScheduleUtilFactory.daysArray;

  // Swap text depending on Method of Creation
  vm.title_text = vm.artist ? 'Update schedule' : 'Add schedule';

  // Default Values for Form Fields.
  var temp = {
    raw_start_time: moment(vm.shop_hours[0].start_time, 'HH:mm:ss'), // Not ideal using [0] works for now.
    raw_end_time: moment(vm.shop_hours[0].end_time, 'HH:mm:ss'), // Not ideal using [0] works for now.
    raw_start_date: moment().toDate(),
    raw_end_date: moment().add(1, 'days').toDate()
  };

  vm.new_exception = { temp: _.cloneDeep(temp) };
  vm.new_schedule = { temp: _.cloneDeep(temp) };
  delete vm.new_schedule.temp.raw_end_date;

  var search = false;
  var timestamp = void 0;
  if (vm.artist) {
    Appointments.get(search, moment().startOf('day'), moment('2200-12-31'), timestamp, vm.artist.id).then(function (appointments) {
      if (appointments.length > 0) {
        // Generate the Appointment Rules
        var statusGroups = (0, _groupByApptStatus2.default)(appointments);
        var dayGroups = void 0;
        if (!_.isUndefined(statusGroups.confirmed)) {
          dayGroups = (0, _groupApptsByDay2.default)(statusGroups.confirmed);
        }
        vm.appointments = appointments;
        vm.appointmentDayGroups = dayGroups;
      } else {
        vm.appointmentDayGroups = (0, _groupApptsByDay2.default)(vm.appointments);
      }
    });
  } else {
    Appointments.get(search, moment().startOf('day'), moment('2200-12-31'), timestamp).then(function (appointments) {
      vm.appointments = appointments;
    });
  }

  // Artist Check
  if (vm.artist) {
    vm.status.adding = false;
    get_schedule();
  } else {
    vm.status.adding = true;
    Artists.fetchArtists().then(function (response) {
      var artists = response.confirmed;
      _.each(vm.schedule, function (schedule_data) {
        _.each(artists, function (tempArtist) {
          if (tempArtist && tempArtist.id === schedule_data.artist.id) {
            artists.splice(artists.indexOf(tempArtist), 1);
          }
        });
      });
      vm.artists = artists;
    });
  }

  // Select an Artist (When Adding to Schedule).
  vm.select_artist = function (artist) {
    vm.artist = vm.artist && vm.artist.id === artist.id ? {} : artist;
    get_schedule();
  };

  // Detect Hour Collisions
  vm.detect_hours_collision = function (form_data) {
    CheckHoursCollisions.check(form_data, vm.appointments, vm.artist, vm.day.format('YYYY/MM/DD')).then(function (data) {
      form_data.collision_errors = [];
      form_data.collision_warnings = data.warnings;
    }, function (data) {
      form_data.collision_errors = data.errors;
      form_data.collision_warnings = data.warnings;
    });
  };

  // Check Form Dates
  vm.check_dates = function (form_data, override) {
    form_data.date_errors = Schedule.check_dates(form_data, override, vm.day);
  };

  // Submit the Schedule
  vm.submit_schedule = function (form_data) {
    var processed = ScheduleApiFormat.format(form_data, vm.artist);
    addRule(processed).then(function () {
      vm.status.add_new = false; // Close
    });
  };

  /**
   * @name submitException
   * @description Function to add an exception type rule to an artists hours.
   * @param {object} data The rule to send to the endpoint.
   */
  function submitException(data) {
    var processed = ExceptionApiFormat.format(data, vm.status, vm.day, vm.artist);
    addRule(processed).then(function () {
      vm.status.add_exception = false; // Close
    });
  }

  /**
   * @name addRule
   * @description Function to add a rule to artist hours.
   * @param {unknown} rule Unknown.
   * @return {empty} empty Returns nothing.
   */
  function addRule(rule) {
    return Schedule.submitNewRule(rule).then(function (newRule) {
      var added = ProcessSchedule.process([newRule], vm.day)[0];
      processAddition(added).then(function () {
        Schedule.refreshSchedules();
        return;
      });
    });
  }

  /**
   * @name editRule
   * @description Function to edit a rule exception.
   * @param {object} rule The rule to edit.
   * @param {unknown} submit_override unknown
   */
  vm.editRule = function (rule, submit_override) {
    var processed = ScheduleApiFormat.format(_.cloneDeep(rule), vm.artist);
    var auto_override = true;
    var diff_count = vm.calc_diff(rule);
    var _isFuture = isFuture(rule.start_date);

    var appointment_collision_data = Appointments.detectAppointmentCollisions(rule, vm.appointmentDayGroups, vm.appointments, vm.day);

    if (diff_count) {
      rule.confirm_save = true;
      auto_override = false;

      if (appointment_collision_data.applicable_appointments.length) {
        var appointment_text = appointment_collision_data.applicable_appointments.length > 1 ? 'appointments' : 'appointment';
        rule.appointment_warning = 'By modifying this rule, you may need to update ' + appointment_collision_data.applicable_appointments.length + ' current or future ' + appointment_text + '.';
      }
    } else {
      rule.confirm_save = false;
      auto_override = true;
    }

    // Simple Edits
    if (auto_override && !submit_override || _isFuture && !submit_override) {
      edit(processed);
    }

    // Substantial Edits
    if (submit_override) {
      var original = void 0;
      _.each(unsorted_artist_hours, function (artist_hours) {
        if (artist_hours.id === rule.id) {
          original = _.cloneDeep(artist_hours);
        }
      });
      original = ScheduleApiFormat.format(original, vm.artist);
      // Set the Current Rule to Expire
      Schedule.removeRule(original, vm.day).then(function (removedRule) {
        var removed = ProcessSchedule.process([removedRule], vm.day)[0];
        // Process
        process_removal(removed);
        // New Start Time
        processed.start_date = moment();
        Schedule.submitNewRule(processed).then(function (newRule) {
          var added = ProcessSchedule.process([newRule], vm.day)[0];
          // Process
          processAddition(added);
        });
      });
    }
  };

  /**
   * @name editException
   * @description Editing an Exception
   * @param {object} rule The exception rule to edit.
   */
  function editException(rule) {
    var processedRule = ExceptionApiFormat.format(rule, vm.status, vm.day, vm.artist);
    edit(processedRule);
  }

  /**
   * @name edit
   * @description Function to edit an artist hours rule.
   * @param {object} rule The rule to edit.
   */
  function edit(rule) {
    Schedule.editRule(rule).then(function (editedRule) {
      var updated = ProcessSchedule.process([editedRule], vm.day)[0];
      processUpdated(updated);
      Schedule.refreshSchedules();
    });
  }

  /**
   * @name removeRule
   * @description Remove a Schedule Rule
   * @param {type} rule Description
   */
  function removeRule(rule) {
    var processedRule = ScheduleApiFormat.format(rule, vm.artist);
    remove(processedRule);
  }

  /**
   * @name removeException
   * @description Function to remove an exception rule from artist hours.
   * @param {object} data The rule to remove.
   */
  function removeException(data) {
    var processed = ExceptionApiFormat.format(data, vm.status, vm.day, vm.artist);
    remove(processed);
  }

  /**
   * @name removeRule
   * @description Function to remove a rule from artist hours.
   * @param {object} rule The rule to remove.
   */
  function remove(rule) {
    Schedule.removeRule(rule, vm.day).then(function (removedRule) {
      var removed = ProcessSchedule.process([removedRule], vm.day)[0];
      process_removal(removed);
      Schedule.refreshSchedules();
    });
  }

  /**
   * @name isFuture
   * @description Determine if the Date is Today going Forward
   * @param {type} date Description
   * @return {type} Description
   */
  function isFuture(date) {
    return moment(date).unix() >= moment().startOf('day').unix();
  }

  // Check Appointment Collisions
  vm.check_appointment_collisions = function (form_data) {
    form_data.warnings = {};

    // Re Create the Selected Day for the Form
    if (!form_data.selected_days) {
      form_data.selected_days = [{ id: moment(vm.day).day(), name: moment(vm.day).format('dddd') }];
    }
    var appointment_collision_data = Appointments.detectAppointmentCollisions(form_data, vm.appointmentDayGroups, vm.appointments, vm.day);

    if (appointment_collision_data.applicable_appointments.length) {
      var applicableText = appointment_collision_data.applicable_appointments.length > 1 ? 'appointments' : 'appointment';
      form_data.appointment_warning = 'By modifying this rule, you may need to update ' + appointment_collision_data.applicable_appointments.length + ' current or future ' + applicableText + '.';
    }

    // Used to show Daily Appointment Conflicts
    if (appointment_collision_data.daily_appointments.length) {
      var dailyText = appointment_collision_data.daily_appointments.length > 1 ? 'appointments' : 'appointment';
      form_data.daily_appointments_warning = 'By modifying this rule, you may need to update the ' + appointment_collision_data.daily_appointments.length + ' ' + dailyText + ' on this day’s schedule.';
    }
  };

  /**
   * @name processAddition
   * @description Process addition
   * @param {type} added Description
   * @return {type} Description
   */
  function processAddition(added) {
    return ShopHours.get(Session.activeState.association.shop.id).then(function (hours) {
      var shopHours = ScheduleUtilFactory.getShopTimes(hours.all, vm.day);
      var startOfDay = shopHours.earliest.start;
      var endOfDay = shopHours.latest.end;

      // Parse the Data
      Schedule.parseSchedules([added]);

      var selected_rule = findSelectedDay([added], startOfDay, endOfDay);

      // Push it to the Data Array
      unsorted_artist_hours.push(_.cloneDeep(added));

      if (selected_rule.length) {
        // Push it to the Data Array
        unsorted_selected_hours.push(_.cloneDeep(added));
      }

      vm.new_schedule = { temp: _.cloneDeep(temp) };
      delete vm.new_schedule.temp.raw_end_date;
      vm.status.add_new = false;

      copySortHours();
      return;
    });
  }

  /**
   * @name processUpdated
   * @description Process updated data
   * @param {type} updated Description
   */
  function processUpdated(updated) {
    Schedule.parseSchedules([updated]);

    // Find Existing and Replace.
    for (var i = 0; i < unsorted_artist_hours.length; i++) {
      if (unsorted_artist_hours[i].id === updated.id) {
        unsorted_artist_hours[i] = _.cloneDeep(updated);
      }
    }

    // Find Existing and Replace.
    for (var j = 0; j < unsorted_selected_hours.length; j++) {
      if (unsorted_selected_hours[j].id === updated.id) {
        unsorted_selected_hours[j] = _.cloneDeep(updated);
      }
    }
    copySortHours();
  }

  /**
   * @name process_removal
   * @description Process data removal
   * @param {type} removed Description
   */
  function process_removal(removed) {
    // Find Existing and Remove.
    for (var i = 0; i < unsorted_artist_hours.length; i++) {
      if (unsorted_artist_hours[i].id === removed.id) {
        unsorted_artist_hours.splice(i, 1);
      }
    }

    // Find Existing and Remove.
    for (var z = 0; z < unsorted_selected_hours.length; z++) {
      if (unsorted_selected_hours[z].id === removed.id) {
        unsorted_selected_hours.splice(z, 1);
      }
    }
    copySortHours();
  }

  // Determine the difference Between Original and New Form Data
  vm.calc_diff = function (form_data) {
    var processed = ScheduleApiFormat.format(_.cloneDeep(form_data), vm.artist);
    var _isFuture = isFuture(form_data.start_date);
    var diff_count = 0;
    var original = void 0;

    // Find Original
    _.each(unsorted_artist_hours, function (artist_hours) {
      if (artist_hours.id === form_data.id) {
        original = artist_hours;
      }
    });

    // Current Rules Only
    if (!_isFuture) {
      // Weekly Frequency
      if (original.weekly_frequency !== processed.interval) {
        diff_count++;
      }

      // Start Time
      if (moment(original.start_time).format('HH:mm:ss') !== processed.start_time) {
        diff_count++;
      }

      // End Time
      if (moment(original.end_time).format('HH:mm:ss') !== processed.end_time) {
        diff_count++;
      }

      // Selected Days
      if (!_.isEqual(original.selected_days, processed.selected_days)) {
        diff_count++;
      }
    }

    // Hide the Confirm Prompt
    form_data.confirm_save = diff_count ? null : false;
    return diff_count;
  };

  /**
   * @name get_schedule
   * @description Get the Schedule for an Artist
  =   */
  function get_schedule() {
    vm.loading = true;

    ShopHours.get(Session.activeState.association.shop.id).then(function (hours) {
      var shopHours = ScheduleUtilFactory.getShopTimes(hours.all, vm.day);
      var startOfDay = shopHours.earliest.start;
      var endOfDay = shopHours.latest.end;

      Schedule.refreshSchedules().then(function () {
        vm.loading = false;

        // Get the Artist Schedule
        unsorted_artist_hours = ProcessSchedule.process(Schedule.getArtistSchedule(vm.artist.id), vm.day);

        // Get 'this' day's Schedule
        unsorted_selected_hours = findSelectedDay(unsorted_artist_hours, startOfDay, endOfDay);
        copySortHours();
      });
    });

    // Generate the Appointment Rules
    // TODO Check the callstack here to ensure the data is ready for whatever this function is trying to accomplish.
    // Appointments.organizeAppointments(vm.appointments, vm.artist, vm.day);
  }

  // Determine if the schedule data contains an 'off' exeception.
  vm.is_off = function () {
    for (var i = 0; i < unsorted_selected_hours.length; i++) {
      if (unsorted_selected_hours[i].is_off) {
        return true;
      }
    }
    return false;
  };

  /**
   * @name findSelectedDay
   * @description Return only the hours for the selected day
   * @param {type} artistHours Description
   * @param {type} start Description
   * @param {type} end Description
   * @return {type} Description
   */
  function findSelectedDay(artistHours, start, end) {
    return ProcessSchedule.process(ScheduleUtilFactory.getApplicableRules(start, end, artistHours), start);
  }

  /**
   * @name copySortHours
   * @description description
   */
  function copySortHours() {
    vm.artist_schedule = _.cloneDeep(Schedule.sort_hour_types(unsorted_artist_hours, today));
    vm.selected_hours = _.cloneDeep(Schedule.sort_hour_types(unsorted_selected_hours, vm.day));
  }

  // Cancel and Close the Modal.
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };
}

angular.module('inkfinder').controller('ScheduleUpdateController', ScheduleUpdateController);

/***/ }),

/***/ "./components/schedule/update/update-schedule.html":
/***/ (function(module, exports) {

module.exports = "<div class=modal-header> <h3 class=modal-title>{{$ctrl.title_text}}</h3> </div> ​ <div class=\"modal-body inner-padding background-light\"> <div class=row ng-if=\"$ctrl.artists.length && !$ctrl.artist\"> <div class=\"list profiles col-md-12\"> <h5>Select an artist</h5> <div class=\"item profile\" ng-repeat=\"artist in $ctrl.artists\" ng-click=\"$ctrl.select_artist(artist); $ctrl.update_search(schedule);\"> <ink-profile-photo selectable=true selected=\"artist.id === $ctrl.artist.id\" profile=artist image-id=artist.profile_photo></ink-profile-photo> </div> </div> <div class=\"col-md-12 center\" ng-if=!$ctrl.artists> <p>Loading artists...</p> </div> </div> <div class=row> <div class=\"col-md-12 center\" ng-if=\"!$ctrl.artist && $ctrl.artists.length===0\"> <p>You’re all out of artists!</p> <div class=\"button-container margin\"> <button class=\"button medium dark\" ui-sref=inkfinder.artists ng-click=$ctrl.cancel()> Add more </button> </div> </div> </div> <div class=modal-footer ng-if=!$ctrl.artist> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.cancel()>Close</button> </div> <uib-tabset class=sub-nav ng-if=$ctrl.artist> <uib-tab heading=\"This day’s schedule\" class=sub-nav-tab> <div class=\"modal-body background-light\"> <div class=row ng-if=$ctrl.artist> <div class=\"col-md-12 center\"> <ink-profile-photo show-name=false profile=$ctrl.artist image-id=$ctrl.artist.profile_photo></ink-profile-photo> <h6 class=no-margin>{{$ctrl.artist.first_name}} {{$ctrl.artist.last_name}}</h6> <small>Schedule for {{$ctrl.day | amDateFormat:'MMMM Do, YYYY'}}</small> <div ng-repeat=\"hours_data in $ctrl.selected_hours.by_rules | orderBy: 'display.start_time'\"> <h5 class=darkshop ng-class=\"{'disabled':$ctrl.selected_hours.by_exceptions.length}\"> <fa name=clock-o class=shop-color></fa> {{hours_data.display.start_time | amDateFormat:'h:mm a'}} – {{hours_data.display.end_time | amDateFormat:'h:mm a'}} </h5> </div> <div ng-if=\"$ctrl.selected_hours.by_rules.length === 0\"> <h5 class=darkshop ng-class=\"{'disabled':$ctrl.selected_hours.by_exceptions.length}\">{{$ctrl.artist.first_name}} is off this day</h5></div> <div class=button-container ng-if=\"$ctrl.selected_hours.by_exceptions.length === 0 && !$ctrl.status.adding\"> <button type=button class=\"button medium dark\" ng-click=\"$ctrl.status.add_exception = !$ctrl.status.add_exception\">Change this schedule</button> </div> <div ng-if=\"$ctrl.status.add_exception && !$ctrl.status.adding && !$ctrl.selected_hours.by_exceptions.length\"> <form name=updateSchedule class=left ng-submit=\"updateSchedule.$valid && $ctrl.submitException($ctrl.new_exception)\" novalidate> <div class=row> <div class=col-md-12> <div class=\"divider small tight\"></div> <div class=form-group> <div class=toggle> <div class=btn-group data-toggle=buttons> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.status.change_shift === 'off'}\"> <input type=radio name=change_shift id=off ng-model=$ctrl.status.change_shift value=off ng-change=$ctrl.check_appointment_collisions($ctrl.new_exception)> Mark this day as off </label> <label class=\"btn btn-default\" ng-class=\"{'active': $ctrl.status.change_shift === 'change_hours'}\"> <input type=radio name=change_shift id=change_hours ng-model=$ctrl.status.change_shift value=change_hours ng-change=$ctrl.check_appointment_collisions($ctrl.new_exception)> Change shift hours for this day </label> </div> </div> </div> </div> </div> <div class=row ng-if=$ctrl.new_exception.daily_appointments_warning> <div class=\"col-md-12 inline-alerts\"> <div class=\"inline-alert warning\"> {{$ctrl.new_exception.daily_appointments_warning}} </div> </div> </div> <div class=\"row left\"> <div class=\"col-md-12 animate fade-in-down\" ng-if=\"$ctrl.status.change_shift === 'change_hours'\"> <p>Enter new start and end times</p> <div class=row> <div class=col-md-6> <label for=start_time>Start time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision($ctrl.new_exception) ng-model=$ctrl.new_exception.temp.raw_start_time> </div> </div> <div class=col-md-6> <label for=start_time>End time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision($ctrl.new_exception) ng-model=$ctrl.new_exception.temp.raw_end_time> </div> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert warning\" ng-repeat=\"warning in $ctrl.new_exception.collision_warnings\" ng-hide=\"error in $ctrl.new_exception.collision_errors > 0\"> {{warning}} </p> <p class=\"inline-alert error\" ng-repeat=\"error in $ctrl.new_exception.collision_errors\"> {{error}} </p> </div> </div> </div> <div class=\"row left animate fade-in-down\" ng-if=\"$ctrl.status.change_shift === 'off'\"> <div class=col-md-12> <p ng-if=\"$ctrl.status.change_shift === 'off'\"> <label for=date_range> <input name=date_range id=date_range ng-model=$ctrl.status.date_range type=checkbox> Apply this change to multiple days </label> </p> <div class=\"row animate fade-in-down\" ng-if=$ctrl.status.date_range> <div class=col-md-6> <div class=form-group> <label for=raw_start_date class=\"stacked animate fade-in\">Start date</label> <div class=input-group> <input name=raw_start_date id=raw_start_date type=text class=form-control ng-change=\"$ctrl.check_dates($ctrl.new_exception, true); $ctrl.check_appointment_collisions($ctrl.new_exception)\" uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=$ctrl.new_exception.temp.raw_start_date placeholder=MM/DD/YYYY is-open=$ctrl.date_picker.start_open datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" ng-required=true close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"$ctrl.date_picker.start_open = !$ctrl.date_picker.start_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-6 class=\"animate fade-in\"> <div class=form-group> <label for=raw_end_date>End date</label> <div class=input-group> <input name=raw_end_date id=raw_end_date type=text class=form-control uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=$ctrl.new_exception.temp.raw_end_date placeholder=MM/DD/YYYY ng-change=\"$ctrl.check_dates($ctrl.new_exception, false); $ctrl.check_appointment_collisions($ctrl.new_exception)\" is-open=$ctrl.date_picker.end_open min-date=$ctrl.new_exception.temp.raw_start_date datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" ng-required=true close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"$ctrl.date_picker.end_open = !$ctrl.date_picker.end_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert error\" ng-repeat=\"error in $ctrl.new_exception.date_errors\"> {{error}} </p> </div> </div> </div> </div> </div> <div class=button-container> <button class=\"button medium dark\" type=submit ng-disabled=\"updateSchedule.$invalid ||\n                    ($ctrl.new_exception.collision_errors.length && $ctrl.status.change_shift === 'change_hours') || !$ctrl.status.change_shift || $ctrl.new_exception.date_errors.length\"> Save </button> <button class=\"button medium alert-btn-light\" type=button ng-click=\"$ctrl.status.add_exception = !$ctrl.status.add_exception\"> Cancel </button> </div> </form> </div> <div ng-if=\"$ctrl.status.adding && $ctrl.selected_hours.by_exceptions.length === 0\"> <form name=exceptionHours class=left ng-submit=\"exceptionHours.$valid && $ctrl.submitException($ctrl.new_exception)\" novalidate> <div class=\"row left\"> <div class=\"col-md-12 animate fade-in-down\"> <p>Enter new start and end times</p> <div class=row> <div class=col-md-6> <label for=start_time>Start time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision($ctrl.new_exception) ng-model=$ctrl.new_exception.temp.raw_start_time> </div> </div> <div class=col-md-6> <label for=start_time>End time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision($ctrl.new_exception) ng-model=$ctrl.new_exception.temp.raw_end_time> </div> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert warning\" ng-repeat=\"warning in $ctrl.new_exception.collision_warnings\" ng-hide=\"error in $ctrl.new_exception.collision_errors > 0\"> {{warning}} </p> <p class=\"inline-alert error\" ng-repeat=\"error in $ctrl.new_exception.collision_errors\"> {{error}} </p> </div> </div> </div> <div class=button-container> <button class=\"button medium dark\" type=submit ng-disabled=\"exceptionHours.$invalid || $ctrl.new_exception.collision_errors.length\"> Save </button> </div> </form> </div> </div> <div class=wrapper> <div class=col-md-12 ng-class=\"{'selected': hours_data.id === $ctrl.selected.$ctrl.id}\"> <uib-accordion class=\"accordion medium\"> <div ng-if=$ctrl.selected_hours.by_exceptions.length> <div class=\"divider small tight\"></div> <p class=no-margin>Schedule changes</p> <small ng-if=$ctrl.selected_hours.by_rules.length>The repeating schedule above have been overridden by the following schedule changes.</small> <small ng-if=!$ctrl.selected_hours.by_rules.length>Schedule changes override any repeating schedules for this day.</small> </div> <div uib-accordion-group is-open=hours_data.accordion.is_open ng-repeat=\"hours_data in $ctrl.selected_hours.by_exceptions | orderBy: 'start_time'\"> <uib-accordion-heading> <h5 class=\"darkshop no-margin\" ng-if=!hours_data.is_off> <fa name=clock-o class=shop-color></fa> {{hours_data.display.start_time | amDateFormat:'h:mm a'}} – {{hours_data.display.end_time | amDateFormat:'h:mm a'}} </h5> <small class=no-margin ng-if=!hours_data.is_off>Schedule change for {{hours_data.display.start_date | amDateFormat:'MMMM Do, YYYY'}}</small> <h5 class=darkshop ng-if=hours_data.is_off> {{$ctrl.artist.first_name}} is off this day </h5> <small class=no-margin ng-if=\"hours_data.is_off && hours_data.start_date !== hours_data.end_date && ! hours_data.date_override\">From {{hours_data.display.start_date | amDateFormat: 'MM/DD/YYYY'}} to {{hours_data.display.end_date | amDateFormat: 'MM/DD/YYYY'}}</small> <small class=no-margin ng-if=\"hours_data.is_off && hours_data.start_date === hours_data.end_date || hours_data.date_override\">On {{hours_data.display.start_date | amDateFormat: 'MM/DD/YYYY'}}</small> </uib-accordion-heading> <div> <form name=editException ng-submit=\"editException.$valid && $ctrl.editException(hours_data)\" novalidate> <div class=\"row left\" ng-if=!hours_data.is_off> <div class=\"col-md-12 animate fade-in-down\"> <p>Edit start and end times</p> <div class=row> <div class=col-md-6> <label for=start_time>Start time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision(hours_data) ng-model=hours_data.temp.raw_start_time> </div> </div> <div class=col-md-6> <label for=start_time>End time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision(hours_data) ng-model=hours_data.temp.raw_end_time> </div> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert warning\" ng-repeat=\"warning in hours_data.collision_warnings\" ng-hide=\"error in hours_data.collision_errors > 0\"> {{warning}} </p> <p class=\"inline-alert error\" ng-repeat=\"error in hours_data.collision_errors\"> {{error}} </p> </div> </div> </div> <div class=\"row animate fade-in-down\" ng-if=hours_data.is_off> <div class=col-md-6 ng-if=$ctrl.isFuture(hours_data)> <div class=form-group> <label for=raw_start_date class=\"stacked animate fade-in\">Start date</label> <div class=input-group> <input name=raw_start_date id=raw_start_date type=text class=form-control ng-change=\"$ctrl.check_dates(hours_data, true)\" uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=hours_data.temp.raw_start_date placeholder=MM/DD/YYYY is-open=hours_data.date_picker.start_open min-date=\"\" max-date=maxDate datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" ng-required=true close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"hours_data.date_picker.start_open = !hours_data.date_picker.start_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-6 ng-if=!$ctrl.isFuture(hours_data)> <div class=form-group> <label for=raw_start_date class=\"stacked animate fade-in\">Start date (currently active)</label> <div class=input-group> <input name=raw_start_date id=raw_start_date type=text class=form-control ng-change=$ctrl.check_dates(hours_data) disabled=disabled ng-model=hours_data.temp.raw_start_date placeholder=MM/DD/YYYY /> </div> </div> </div> <div class=col-md-6 class=\"animate fade-in\"> <div class=form-group> <label for=raw_end_date>End date</label> <div class=input-group> <input name=raw_end_date id=raw_end_date type=text class=form-control ng-change=\"$ctrl.check_dates(hours_data, false)\" uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=hours_data.temp.raw_end_date placeholder=MM/DD/YYYY is-open=hours_data.date_picker.end_open min-date=hours_data.temp.raw_start_date max-date=maxDate datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" ng-required=true close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"hours_data.date_picker.end_open = !hours_data.date_picker.end_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert error\" ng-repeat=\"error in hours_data.date_errors\"> {{error}} </p> </div> </div> </div> <div class=button-container> <button class=\"button medium dark\" type=submit ng-disabled=\"editException.$invalid || hours_data.collision_errors.length || hours_data.date_errors.length\">Save</button> <button class=\"button medium alert-btn-light\" ng-click=\"hours_data.confirm_delete = true\" type=button>Delete</button> </div> <div class=row ng-if=hours_data.confirm_delete> <div class=col-md-12> <div class=\"divider small xtight\"></div> <p>Are you sure you want to remove this exception? <br/> <a class=\"button small dark\" ng-click=$ctrl.removeException(hours_data)>Confirm</a> or <a ng-click=\"hours_data.confirm_delete = false\" class=alert-color>cancel</a>.</p> </div> </div> </form> </div> </div> </uib-accordion> </div> </div> </div> </div> <div class=modal-footer> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.cancel()>Close</button> </div> </uib-tab> <uib-tab heading=\"All schedules\" class=sub-nav-tab> <div class=row> <div class=\"col-md-12 center\"> <div class=\"modal-body background-light\"> <ink-profile-photo show-name=false profile=$ctrl.artist image-id=$ctrl.artist.profile_photo></ink-profile-photo> <h6 class=\"center no-margin\">{{$ctrl.artist.first_name}} {{$ctrl.artist.last_name}}</h6> <div class=wrapper> <p ng-if=\"$ctrl.artist_$ctrl.length === 0\" class=center>We didn't find any schedules for this artist.</p> <uib-accordion class=\"accordion medium\"> <div class=left ng-if=$ctrl.artist_schedule.by_rules.length> <p class=no-margin>Repeating schedules</p> <small>Repeating schedules automatically set the schedule every day they repeat on.</small> </div> <div uib-accordion-group is-open=hours_data.accordion.is_open ng-repeat=\"hours_data in $ctrl.artist_schedule.by_rules | orderBy: 'start_time'\"> <uib-accordion-heading> <p>{{hours_data.daysOfWeek}}</p> <h5 class=darkshop><fa name=clock-o class=shop-color></fa> {{hours_data.display.start_time | amDateFormat:'h:mm a'}} – {{hours_data.display.end_time | amDateFormat:'h:mm a'}} </h5> <small class=no-margin>Repeats {{hours_data.text}}</small> </uib-accordion-heading> <div> <form name=editSchedule ng-submit=\"editSchedule.$valid && $ctrl.edit_schedule(hours_data)\" novalidate> <div class=\"row left\"> <div class=\"col-md-12 animate fade-in-down\"> <h6>Edit start and end times for this schedule</h6> <div class=row> <div class=col-md-6> <label for=start_time>Start time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=\"$ctrl.detect_hours_collision(hours_data); $ctrl.calc_diff(hours_data)\" ng-model=hours_data.temp.raw_start_time> </div> </div> <div class=col-md-6> <label for=start_time>End time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=\"$ctrl.detect_hours_collision(hours_data); $ctrl.calc_diff(hours_data)\" ng-model=hours_data.temp.raw_end_time> </div> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert warning\" ng-repeat=\"warning in hours_data.collision_warnings\" ng-hide=\"error in hours_data.collision_errors > 0\"> {{warning}} </p> <p class=\"inline-alert error\" ng-repeat=\"error in hours_data.collision_errors\"> {{error}} </p> </div> </div> <div class=col-md-6 ng-if=$ctrl.isFuture(hours_data)> <div class=form-group> <label for=raw_start_date class=\"stacked animate fade-in\">Start date</label> <div class=input-group> <input name=raw_start_date id=raw_start_date type=text class=form-control ng-change=\"$ctrl.check_dates(hours_data, true)\" uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=hours_data.temp.raw_start_date placeholder=MM/DD/YYYY is-open=hours_data.date_picker.start_open datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" ng-required=true close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"hours_data.date_picker.start_open = !hours_data.date_picker.start_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-6 ng-if=!$ctrl.isFuture(hours_data)> <div class=form-group> <label for=raw_start_date class=\"stacked animate fade-in\">Start date (currently active)</label> <div class=input-group> <input name=raw_start_date id=raw_start_date type=text class=form-control ng-change=$ctrl.check_dates(hours_data) disabled=disabled ng-model=hours_data.temp.raw_start_date placeholder=MM/DD/YYYY /> </div> </div> </div> <div class=col-md-6 class=\"animate fade-in\"> <div class=form-group> <label for=raw_end_date>End date <small>Optional</small></label> <div class=input-group> <input name=raw_end_date id=raw_end_date type=text class=form-control ng-change=\"$ctrl.check_dates(hours_data, false); $ctrl.calc_diff(hours_data)\" uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=hours_data.temp.raw_end_date placeholder=MM/DD/YYYY is-open=hours_data.date_picker.end_open min-date=hours_data.temp.raw_start_date datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"hours_data.date_picker.end_open = !hours_data.date_picker.end_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert error\" ng-repeat=\"error in hours_data.date_errors\"> {{error}} </p> </div> </div> <div class=col-md-12> <small>Repeat this schedule <label class=inline><input type=radio name=repeat_type value=1 ng-change=$ctrl.calc_diff(hours_data) ng-model=hours_data.weekly_frequency>weekly </label> <label class=inline><input type=radio name=repeat_type value=2 ng-change=$ctrl.calc_diff(hours_data) ng-model=hours_data.weekly_frequency>bi-weekly </label> on the following days: </small> </div> <div class=col-md-12> <ui-select multiple=multiple ng-model=hours_data.selected_days theme=bootstrap ng-disabled=disabled ng-change=$ctrl.calc_diff(hours_data) close-on-select=false> <ui-select-match placeholder=\"Select days...\"> {{$item.name}} </ui-select-match> <ui-select-choices repeat=\"days in $ctrl.weekdays\"> {{days.name}} </ui-select-choices> </ui-select> </div> </div> <div class=\"divider small tight\"></div> <div class=button-container> <button class=\"button medium dark\" type=button ng-click=\"$ctrl.editRule(hours_data); hours_data.confirm_delete = false\" ng-disabled=\"editSchedule.$invalid || hours_data.collision_errors.length || hours_data.date_errors.length\">Save</button> <button class=\"button medium alert-btn-light\" ng-click=\"hours_data.confirm_delete = true; hours_data.confirm_save = false; $ctrl.check_appointment_collisions(hours_data)\" type=button>Delete</button> </div> <div class=row ng-if=hours_data.confirm_delete> <div ng-if=hours_data.appointment_warning class=\"col-md-12 inline-alerts\"> <div class=\"inline-alert warning\"> {{hours_data.appointment_warning}} </div> </div> <div class=col-md-12> <div class=\"divider small tight\"></div> <p>Are you sure you want to remove this schedule? <a class=\"button small dark\" ng-click=$ctrl.removeRule(hours_data)> Confirm</a> or <a ng-click=\"hours_data.confirm_delete = false\" class=alert-color>cancel</a>.<br/> <small>Removing a schedule will archive it so schedules in the past display correctly.</small> </p> </div> </div> <div class=row ng-if=\"hours_data.confirm_save && !(editSchedule.$invalid || hours_data.collision_errors.length)\"> <div ng-if=hours_data.appointment_warning class=\"col-md-12 inline-alerts\"> <div class=\"inline-alert warning\"> {{hours_data.appointment_warning}} </div> </div> <div class=col-md-12> <div class=\"divider small tight\"></div> <p>Are you sure you want to save this schedule? <a ng-click=\"$ctrl.editRule(hours_data, true)\"> <br/>Confirm</a> or <a ng-click=\"hours_data.confirm_save = false\" class=alert-color>cancel</a>.<br/> <small>By updating this schedule, the current version will be expired and a new version created.</small> </p> </div> </div> </form> </div> </div> <div class=left ng-if=$ctrl.artist_schedule.by_exceptions.length> <div class=\"divider small tight\"></div> <p class=no-margin>Schedule changes</p> <small>Schedule changes override any repeating schedules for the day.</small> </div> <div uib-accordion-group is-open=hours_data.accordion.is_open ng-repeat=\"hours_data in $ctrl.artist_schedule.by_exceptions | orderBy: 'start_date'\"> <uib-accordion-heading> <p>{{hours_data.start_date | amDateFormat:'MMMM Do, YYYY'}}</p> <h5 class=darkshop ng-if=!hours_data.is_off> <fa name=clock-o class=shop-color></fa> {{hours_data.display.start_time | amDateFormat:'h:mm a'}} – {{hours_data.display.end_time | amDateFormat:'h:mm a'}} </h5> <small class=no-margin ng-if=!hours_data.is_off>Schedule change for {{hours_data.display.start_date | amDateFormat:'MMMM Do, YYYY'}}</small> <h5 class=darkshop ng-if=hours_data.is_off>{{$ctrl.artist.first_name}} is off this day</h5> <small class=no-margin ng-if=\"hours_data.is_off && hours_data.start_date !== hours_data.end_date || hours_data.date_override\">Off from {{hours_data.display.start_date | amDateFormat: 'MM/DD/YYYY'}} to {{hours_data.display.end_date | amDateFormat: 'MM/DD/YYYY'}}</small> <small class=no-margin ng-if=\"hours_data.is_off && hours_data.start_date === hours_data.end_date && !hours_data.date_override\">On {{hours_data.display.start_date | amDateFormat: 'MM/DD/YYYY'}}</small> </uib-accordion-heading> <div> <form name=editException ng-submit=\"editException.$valid && $ctrl.editException(hours_data)\" novalidate> <div class=\"row left\" ng-if=!hours_data.is_off> <div class=\"col-md-12 animate fade-in-down\"> <p>Edit start and end times</p> <div class=row> <div class=col-md-6> <label for=start_time>Start time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision(hours_data) ng-model=hours_data.temp.raw_start_time> </div> </div> <div class=col-md-6> <label for=start_time>End time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision(hours_data) ng-model=hours_data.temp.raw_end_time> </div> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert warning\" ng-repeat=\"warning in hours_data.collision_warnings\" ng-hide=\"error in hours_data.collision_errors > 0\"> {{warning}} </p> <p class=\"inline-alert error\" ng-repeat=\"error in hours_data.collision_errors\"> {{error}} </p> </div> </div> </div> <div class=\"row animate fade-in-down\" ng-if=hours_data.is_off> <div class=col-md-6 ng-if=$ctrl.isFuture(hours_data)> <div class=form-group> <label for=raw_start_date class=\"stacked animate fade-in\">Start date</label> <div class=input-group> <input name=raw_start_date id=raw_start_date type=text class=form-control ng-change=\"$ctrl.check_dates(hours_data, true)\" uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=hours_data.temp.raw_start_date placeholder=MM/DD/YYYY is-open=hours_data.date_picker.start_open min-date=\"\" max-date=maxDate datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" ng-required=true close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"hours_data.date_picker.start_open = !hours_data.date_picker.start_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-6 ng-if=!$ctrl.isFuture(hours_data)> <div class=form-group> <label for=raw_start_date class=\"stacked animate fade-in\">Start date (currently active)</label> <div class=input-group> <input name=raw_start_date id=raw_start_date type=text class=form-control ng-change=$ctrl.check_dates(hours_data) disabled=disabled ng-model=hours_data.temp.raw_start_date placeholder=MM/DD/YYYY /> </div> </div> </div> <div class=col-md-6 class=\"animate fade-in\"> <div class=form-group> <label for=raw_end_date>End date</label> <div class=input-group> <input name=raw_end_date id=raw_end_date type=text class=form-control ng-change=\"$ctrl.check_dates(hours_data, false)\" uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=hours_data.temp.raw_end_date placeholder=MM/DD/YYYY is-open=hours_data.date_picker.end_open min-date=hours_data.temp.raw_start_date max-date=maxDate datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" ng-required=true close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"hours_data.date_picker.end_open = !hours_data.date_picker.end_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert error\" ng-repeat=\"error in hours_data.date_errors\"> {{error}} </p> </div> </div> </div> <div class=button-container> <button class=\"button medium dark\" type=submit ng-disabled=\"editException.$invalid || hours_data.collision_errors.length || hours_data.date_errors.length\">Save</button> <button class=\"button medium alert-btn-light\" ng-click=\"hours_data.confirm_delete = true\" type=button>Delete</button> </div> <div class=row ng-if=hours_data.confirm_delete> <div class=col-md-12> <div class=\"divider small xtight\"></div> <p>Are you sure you want to remove this exception? <br/> <a class=\"button small dark\" ng-click=$ctrl.removeException(hours_data)>Confirm</a> or <a ng-click=\"hours_data.confirm_delete = false\" class=alert-color>cancel</a>.</p> </div> </div> </form> </div> </div> </uib-accordion> </div> <div class=\"row left clearifx\"> <div class=\"col-md-12 center\"> <div class=button-add> <button class=\"button circle\" ng-click=\"$ctrl.status.add_new = !$ctrl.status.add_new\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> <small>Add a schedule</small> </div> </div> </div> <div> <form name=addNewSchedule ng-if=$ctrl.status.add_new ng-submit=\"addNewSchedule.$valid && $ctrl.submit_schedule($ctrl.new_schedule)\" ng-model-options=\"{debounce: 100}\" novalidate> <div class=\"row animate fade-in-down left\"> <div class=col-md-12> <div class=\"divider small tight\"></div> <p>Pick the day this schedule will apply to.</p> </div> <div class=col-md-6> <div class=form-group> <label for=raw_start_date class=\"stacked animate fade-in\">Start date</label> <div class=input-group> <input name=raw_start_date id=raw_start_date type=text class=form-control ng-change=\"$ctrl.check_dates($ctrl.new_schedule, true)\" uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=$ctrl.new_schedule.temp.raw_start_date placeholder=MM/DD/YYYY is-open=$ctrl.new_schedule.date_picker.start_open datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" ng-required=true close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"$ctrl.new_schedule.date_picker.start_open = !$ctrl.new_schedule.date_picker.start_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-6 class=\"animate fade-in\"> <div class=form-group> <label for=raw_end_date>End date <small>Optional</small></label> <div class=input-group> <input name=raw_end_date id=raw_end_date type=text class=form-control ng-change=\"$ctrl.check_dates($ctrl.new_schedule, false)\" uib-datepicker-popup=\"{{'MM/dd/yyyy'}}\" ng-model=$ctrl.new_schedule.temp.raw_end_date placeholder=MM/DD/YYYY is-open=$ctrl.new_schedule.date_picker.end_open min-date=$ctrl.new_schedule.temp.raw_start_date max-date=maxDate datepicker-options=dateOptions date-disabled=\"disabled(date, mode)\" close-text=Close /> <span class=input-group-btn> <button type=button class=\"btn btn-default large shop calendar-button\" ng-click=\"$ctrl.new_schedule.date_picker.end_open = !$ctrl.new_schedule.date_picker.end_open\"> <fa name=calendar-o></fa> </button> </span> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert error\" ng-repeat=\"error in $ctrl.new_schedule.date_errors\"> {{error}} </p> </div> </div> <div class=col-md-12> <p>Add a start and end time</p> </div> <div class=col-md-6> <label for=start_time>Start time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision($ctrl.new_schedule) ng-model=$ctrl.new_schedule.temp.raw_start_time> </div> </div> <div class=col-md-6> <label for=start_time>End time</label> <div uib-timepicker name=start_time id=start_time hour-step=1 minute-step=15 show-meridian=true mousewheel=false class=time-picker ng-change=$ctrl.detect_hours_collision($ctrl.new_schedule) ng-model=$ctrl.new_schedule.temp.raw_end_time> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert warning\" ng-repeat=\"warning in $ctrl.new_schedule.collision_warnings\" ng-hide=\"error in $ctrl.new_schedule.collision_errors > 0\"> {{warning}} </p> <p class=\"inline-alert error\" ng-repeat=\"error in $ctrl.new_schedule.collision_errors\"> {{error}} </p> </div> </div> <div> <div class=col-md-12> <small>Repeat this schedule <label class=inline><input type=radio required name=repeat_type value=1 ng-model=$ctrl.new_schedule.weekly_frequency>weekly </label> <label class=inline><input type=radio required name=repeat_type value=2 ng-model=$ctrl.new_schedule.weekly_frequency>bi-weekly </label> on the following days: </small> </div> <div class=col-md-12> <ui-select multiple=multiple ng-model=$ctrl.new_schedule.selected_days theme=bootstrap ng-disabled=disabled close-on-select=false> <ui-select-match placeholder=\"Select days...\">{{$item.name}}</ui-select-match> <ui-select-choices repeat=\"days in $ctrl.weekdays\"> {{days.name}} </ui-select-choices> </ui-select> </div> </div> </div> <div class=col-md-12> <div class=inline-alerts> <p class=\"inline-alert warning\" ng-repeat=\"warning in $ctrl.new_schedule.warnings\" ng-hide=\"error in $ctrl.new_schedule.errors > 0\"> {{warning}} </p> <p class=\"inline-alert error\" ng-repeat=\"error in $ctrl.new_schedule.errors\"> {{error}} </p> </div> </div> <div class=\"divider small tight\"></div> <div class=button-container> <button class=\"button medium dark\" type=submit ng-disabled=\"addNewSchedule.$invalid || !$ctrl.new_schedule.selected_days.length || $ctrl.new_schedule.collision_errors.length || $ctrl.new_schedule.date_errors.length\">Save</button> <button class=\"button medium alert-btn-light\" type=button ng-click=\"$ctrl.status.add_new = false\" class=alert-color>Cancel</button> </div> </form> </div> </div> </div> </div> <div class=modal-footer> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.cancel()>Close</button> </div> </uib-tab> </uib-tabset> </div> ";

/***/ }),

/***/ "./components/schedule/util/api-format-exception.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('ExceptionApiFormat', ['Session', 'moment', 'Schedule', '_', function ExceptionApiFormat(Session, moment, Schedule, _) {
  // Public methods
  ExceptionApiFormat.format = format;

  /**
   * @name format
   * @description Pre-process the Sending of an Exception to the API
   * @param {unknown} form Unknown
   * @param {unknown} status Unknown
   * @param {unknown} day Unknown
   * @param {unknown} artist Unknown
   * @return {unknown} Unknown
   */
  function format(form, status, day, artist) {
    var processed = {};
    // Editing
    if (form.id) {
      var start_date = void 0;
      var end_date = void 0;

      // No Need to Change
      processed.is_off = form.is_off;
      processed.is_exception = form.is_exception;
      processed.artist_hour_id = form.id;
      processed.interval = form.weekly_frequency;
      processed.selected_days = Schedule.generate_selected_days_object(day, true);

      // Editing Is Off
      if (form.is_off) {
        start_date = moment(form.temp.raw_start_date);
        end_date = moment(form.temp.raw_end_date).add(1, 'day');
      } else {
        // Editing Hour Change
        // Hour changes are only Applicable to selected day ONLY, so disregard date data from API.
        start_date = moment(day).format('YYYY-MM-DD');
        end_date = moment(day);

        if (form.temp.raw_start_time >= form.temp.raw_end_time) {
          // Account for time wrap around.
          end_date = moment(day).add(1, 'day');
        }
      }

      processed.start_date = moment(start_date).format('YYYY-MM-DD');
      processed.end_date = moment(end_date).format('YYYY-MM-DD');
      processed.start_time = moment(form.temp.raw_start_time).format('HH:mm:ss');
      processed.end_time = moment(form.temp.raw_end_time).format('HH:mm:ss');

      processed.deleted = false;

      if (status.date_range) {
        processed.selected_days = Schedule.generate_selected_days_object(day, true);
      }
    } else {
      // Create New
      processed.is_exception = true;

      // Default Options
      processed.artist_id = artist.id;
      processed.deleted = false;

      // Shared Base between both Options
      processed.interval = 1;
      processed.selected_days = Schedule.generate_selected_days_object(day, true);
      processed.start_date = moment(day).format('YYYY-MM-DD');

      // Off
      if (status.change_shift === 'off') {
        processed.is_off = true;
        processed.start_time = '00:00:00';
        processed.end_time = '00:00:00';
        processed.start_date = moment(day).format('YYYY-MM-DD');
        processed.end_date = moment(day);

        // Only Available when Marking a day as Off
        if (status.date_range) {
          var start = moment(form.temp.raw_start_date);
          var end = moment(form.temp.raw_end_date);

          processed.start_date = moment(start).format('YYYY-MM-DD');
          processed.end_date = moment(end);
        }
        processed.end_date = moment(processed.end_date).add(1, 'day').format('YYYY-MM-DD');
      } else {
        // Hour Shift (Default)
        processed.end_date = moment(day).format('YYYY-MM-DD');

        if (form.temp.raw_start_time >= form.temp.raw_end_time) {
          processed.end_date = moment(day).add(1, 'day').format('YYYY-MM-DD');
        }

        processed.end_time = moment(form.temp.raw_end_time).format('HH:mm:ss');
        processed.start_time = moment(form.temp.raw_start_time).format('HH:mm:ss');
      }
    }
    return processed;
  }
  return ExceptionApiFormat;
}]);

/***/ }),

/***/ "./components/schedule/util/api-format-schedule.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('ScheduleApiFormat', ['Session', 'moment', '_', function ScheduleApiFormat(Session, moment, _) {
  // Public methods
  ScheduleApiFormat.format = format;

  /**
   * @name format
   * @description Pre-process the Sending of an Exception to the API
   * @param {unknown} form unknown
   * @param {unknown} artist unknown
   * @return {unknown} Unknown
   */
  function format(form, artist) {
    var processed = {};
    // Editing
    if (form.id) {
      // Default Options
      processed.artist_id = artist.id;
      processed.artist_hour_id = form.id;

      processed.start_date = moment(form.temp.raw_start_date).format('YYYY-MM-DD');
      if (form.temp.raw_end_date) {
        processed.end_date = moment(form.temp.raw_end_date).format('YYYY-MM-DD');
      }
      processed.selected_days = form.selected_days;
      processed.interval = parseInt(form.weekly_frequency, 10);

      processed.end_time = moment(form.temp.raw_end_time).format('HH:mm:ss');
      processed.start_time = moment(form.temp.raw_start_time).format('HH:mm:ss');
      processed.deleted = false;
    } else {
      // Create New
      // Default Options
      processed.artist_id = artist.id;

      processed.start_date = moment(form.temp.raw_start_date).format('YYYY-MM-DD');
      if (form.temp.raw_end_date) {
        processed.end_date = moment(form.temp.raw_end_date).format('YYYY-MM-DD');
      }
      processed.selected_days = form.selected_days;
      processed.interval = parseInt(form.weekly_frequency, 10);

      processed.end_time = moment(form.temp.raw_end_time).format('HH:mm:ss');
      processed.start_time = moment(form.temp.raw_start_time).format('HH:mm:ss');
      processed.deleted = false;
    }
    return processed;
  }
  return ScheduleApiFormat;
}]);

/***/ }),

/***/ "./components/schedule/util/calculate-availability.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('CalculateAvailability', ['$q', 'ScheduleUtilFactory', 'Shop', 'moment', 'RESPONSE_MESSAGES', function CalculateAvailability($q, ScheduleUtilFactory, Shop, moment, RESPONSE_MESSAGES) {
  // Public methods
  CalculateAvailability.calculate = calculate;

  /**
  * @name calculate
  * @description Takes a list of schedule instances and appointments and returns
  * a set of start/end pairs corresponding to availability between appointments.
  * @param {unknown} schedules Unknown.
  * @param {unknown} appointments Unknown.
  * @return {unknown} results
  */
  function calculate(schedules, appointments) {
    var results = [];

    var scheduleTotal = schedules.length;
    if (!scheduleTotal) {
      return results;
    }

    schedules.sort(function (a, b) {
      return a.start - b.start;
    });
    appointments.sort(function (a, b) {
      return a.date - b.date;
    });

    var aCount = void 0;
    var sCount = void 0;
    aCount = sCount = 0;
    // let startTime;
    // startTime = currentTime = schedules[sCount].start;
    var currentTime = void 0;
    currentTime = schedules[sCount].start;
    var endTime = schedules[scheduleTotal - 1].end;
    var appointmentTotal = appointments.length;

    // Iterate until the end of the schedule has been reached.
    while (currentTime < endTime) {
      // Skip over any appointments before the current time.
      while (aCount < appointmentTotal && appointments[aCount].end < currentTime) {
        aCount++;
      }
      // If there are no more appointments or the next appointment starts after the current schedule object ends, create an available time block from now until the end of the schedule object.
      if (aCount >= appointmentTotal || appointments[aCount].date >= schedules[sCount].end) {
        var start = currentTime;
        var end = void 0;
        end = currentTime = schedules[sCount].end;
        results.push({ start: start, end: end });
      } else {
        // There are more appointments overlapping the current one, create available time blocks as needed.
        // Iterate across all appointments which start before the schedule block ends
        while (aCount < appointmentTotal && appointments[aCount].date < schedules[sCount].end) {
          // If there is a gap between the current time and the next appointment, create an available time block from now until the next appointment starts.
          if (currentTime < appointments[aCount].date) {
            var _start = currentTime;
            var _end = appointments[aCount].date;
            results.push({ start: _start, end: _end });
          }
          // Advance the time to the end of the next appointment and move on to the next appointment
          currentTime = appointments[aCount].end;
          aCount++;
        }
        // Given the previous while() loop, there should be no more appointments starting before the end of the current schedule block. If there is any free time before the end of the schedule block, create an available time block from now until the end of the schedule object.
        if (currentTime < schedules[sCount].end) {
          var _start2 = currentTime;
          var _end2 = void 0;
          _end2 = currentTime = schedules[sCount].end;
          results.push({ start: _start2, end: _end2 });
        }
      }
      // Given the previous conditions, we should've added all available time blocks which overlap this schedule block. Move on to the next schedule block.
      sCount++;
      // If this isn't the last schedule block, advance the current time to the start of the next schedule block.
      if (sCount < schedules.length && currentTime < schedules[sCount].start) {
        currentTime = schedules[sCount].start;
      }
    }
    return results;
  }
  return CalculateAvailability;
}]);

/***/ }),

/***/ "./components/schedule/util/check-collision.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('CheckCollisions', ['$q', 'ScheduleUtilFactory', 'ShopHours', 'Session', 'moment', 'RESPONSE_MESSAGES', function CheckCollisions($q, ScheduleUtilFactory, ShopHours, Session, moment, RESPONSE_MESSAGES) {
  // Public methods
  CheckCollisions.check = check;

  /**
  * @name check
  * @description Takes an appointment and set of availability data and returns
  * a set of errors and warnings based on overlap between the appointment and
  * availability blocks/other appointments.
  * @param {unknown} availableInput Unknown.
  * @param {unknown} appointmentInput Unknown.
  * @param {unknown} inputBlock Unknown.
  * @param {unknown} appointment Unknown.
  * @return {unknown} Unknown
  */
  function check(availableInput, appointmentInput, inputBlock, appointment) {
    return $q(function (resolve, reject) {
      ShopHours.get(Session.activeState.association.shop.id).then(function (hours) {
        var start = appointment.start;
        var end = appointment.end;
        var id = appointment.id ? appointment.id : null;

        var errors = [];
        var warnings = [];
        var outsideShopHours = false;

        var shopHours = ScheduleUtilFactory.getShopTimes(hours.all, inputBlock.start);
        var shopStart = shopHours.earliest.start;
        var shopEnd = shopHours.latest.end;

        if (inputBlock.end < shopStart) {
          shopHours = ScheduleUtilFactory.getShopTimes(hours.all, moment(inputBlock.start).subtract(1, 'day'));
          shopStart = shopHours.earliest.start;
          shopEnd = shopHours.latest.end;
        }

        // If the shop isn't open on the day in question, they may be trying to schedule something for the next day
        if (start < shopStart || end > shopEnd) {
          // Increment the dates by 1 and try one last time
          start.add(1, 'day');
          end.add(1, 'day');

          if (start < shopStart || end > shopEnd) {
            errors.push(RESPONSE_MESSAGES.outsideShopHours.message);
            outsideShopHours = true;
          } else {
            warnings.push('This appointment starts on ' + start.format('MMMM Do [at] h:mm a'));
          }
        }
        if (!outsideShopHours) {
          var appointments = ScheduleUtilFactory.getRulesInRange(appointmentInput, shopStart, shopEnd);
          var available = ScheduleUtilFactory.getRulesInRange(availableInput, shopStart, shopEnd);
          var overlappingAppointments = ScheduleUtilFactory.getRulesInRange(appointments, start, end);
          var overlap = false;
          for (var i = 0; i < overlappingAppointments.length; i++) {
            if (overlappingAppointments[i].appointment.id !== id) {
              overlap = true;
            }
          }
          if (overlap) {
            errors.push(RESPONSE_MESSAGES.existingAppointment.message);
          } else {
            var fitsSchedule = false;
            for (var x = 0; x < available.length; x++) {
              var block = available[x];
              if (block.start <= start && end <= block.end) {
                fitsSchedule = true;
                break;
              }
            }
            var sameAppointment = false;
            for (var _i = 0; _i < overlappingAppointments.length; _i++) {
              if (overlappingAppointments[_i].appointment.id === id) {
                sameAppointment = true;
              }
            }
            if (!fitsSchedule && !sameAppointment) {
              warnings.push(RESPONSE_MESSAGES.artistNotScheduled.message);
            } else if (!fitsSchedule && sameAppointment) {
              warnings.push(RESPONSE_MESSAGES.sameAppointmentTime.message);
            }
          }
        }
        resolve({
          errors: errors,
          warnings: warnings
        });
      });
    });
  }
  return CheckCollisions;
}]);

/***/ }),

/***/ "./components/schedule/util/check-hours-collision.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('CheckHoursCollisions', ['$q', 'ShopHours', 'moment', function CheckHoursCollisions($q, ShopHours, moment) {
  // Public methods
  CheckHoursCollisions.check = check;

  /**
   * @name check
   * @description description
   * @param {type} data Description
   * @param {type} appointments Description
   * @param {type} artist Description
   * @param {type} selected_date Description
   * @return {type} Description
   */
  function check(data, appointments, artist, selected_date) {
    return $q(function (resolve, reject) {
      var shop_hours = ShopHours.getHoursByDay(selected_date);
      var errors = [];
      var warnings = [];

      var base_date_string = moment(selected_date).format('YYYY-MM-DD');

      var shop_start = moment(base_date_string + ' ' + shop_hours.start_time, 'YYYY-MM-DD HH:mm:ss');
      var shop_end = moment(base_date_string + ' ' + shop_hours.end_time, 'YYYY-MM-DD HH:mm:ss');

      // Date Correction
      if (shop_end < shop_start) {
        shop_end = shop_end.add(1, 'day');
      }

      var start_time_string = moment(data.temp.raw_start_time).format('HH:mm:ss');
      var end_time_string = moment(data.temp.raw_end_time).format('HH:mm:ss');

      var start_time = moment(base_date_string + ' ' + start_time_string, 'YYYY-MM-DD HH:mm:ss');
      var end_time = moment(base_date_string + ' ' + end_time_string, 'YYYY-MM-DD HH:mm:ss');

      if (parseInt(end_time.unix(), 10) === parseInt(start_time.unix(), 10)) {
        errors.push('Start and end time cannot be the same.');
      }

      // Date Correction
      if (end_time < start_time) {
        end_time.add(1, 'day');
      }

      // If the Requested Start time is less than the Shop Start && the End Time is greater than the Shop End
      if (start_time < shop_start || end_time > shop_end) {
        errors.push('This time is outside of shop hours. This schedule can’t be saved.');
      }

      if (errors.length) {
        reject({
          errors: errors,
          warnings: warnings
        });
      } else {
        resolve({
          warnings: warnings
        });
      }
    });
  }
  return CheckHoursCollisions;
}]);

/***/ }),

/***/ "./components/schedule/util/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/schedule/util/api-format-exception.service.js");

__webpack_require__("./components/schedule/util/api-format-schedule.service.js");

__webpack_require__("./components/schedule/util/calculate-availability.service.js");

__webpack_require__("./components/schedule/util/check-collision.service.js");

__webpack_require__("./components/schedule/util/check-hours-collision.service.js");

__webpack_require__("./components/schedule/util/process-schedule.service.js");

__webpack_require__("./components/schedule/util/schedule-util.service.js");

/***/ }),

/***/ "./components/schedule/util/process-schedule.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('ProcessSchedule', ['Session', 'moment', '_', function ProcessSchedule(Session, moment, _) {
  // Public methods
  ProcessSchedule.process = process;

  /**
   * @name process
   * @description Preprocess the Data before Parsing the Schedule.
   * @param {unknown} input Unknown
   * @param {unknown} day Unknown
   * @return {unknown} Unknown
   */
  function process(input, day) {
    var data = _.cloneDeep(input);
    var output = [];

    _.each(data, function (hours) {
      var processed = hours;
      processed.temp = {};
      processed.display = {};

      // Convert Moment Object to String (From the Form as a Moment Object)
      if (_.isObject(hours.start_time)) {
        processed.start_time = moment(hours.start_time).format('HH:mm:ss');
      } else {
        processed.temp.raw_start_time = moment(hours.start_time, 'HH:mm:ss');
      }

      // Convert Moment Object to String (From the Form as a Moment Object)
      if (_.isObject(hours.end_time)) {
        processed.end_time = moment(hours.end_time).format('HH:mm:ss');
      } else {
        processed.temp.raw_end_time = moment(hours.end_time, 'HH:mm:ss');
      }

      // Convert Moment Object to String
      if (hours.start_date) {
        processed.temp.raw_start_date = moment(hours.start_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
        processed.display.start_date = moment(hours.start_date);
      }

      // Convert Moment Object to String
      if (hours.end_date) {
        processed.temp.raw_end_date = moment(hours.end_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
        processed.display.end_date = moment(hours.end_date);
      }
      if (day) {
        processed.display.start_time = moment(moment(day).format('YYYY-MM-DD') + 'T' + hours.start_time, 'YYYY-MM-DDTHH:mm:ss');
        processed.display.end_time = moment(moment(day).format('YYYY-MM-DD') + 'T' + hours.end_time, 'YYYY-MM-DDTHH:mm:ss');
      }
      if (hours.start_date && hours.end_date) {
        var start_datetime = moment(hours.start_date + 'T' + hours.start_time, 'YYYY-MM-DDTHH:mm:ss');
        var end_datetime = moment(hours.end_date + 'T' + hours.end_time, 'YYYY-MM-DDTHH:mm:ss');
        if (end_datetime.unix() <= start_datetime.unix()) {
          processed.end_date = moment(hours.end_date).add(1, 'day').format('YYYY-MM-DD');
        }
      }
      if (hours.is_off) {
        processed.temp.raw_end_date = moment(hours.end_date, 'YYYY-MM-DD').subtract(1, 'day').format('MM/DD/YYYY');
        processed.display.end_date = moment(hours.end_date).subtract(1, 'day');

        var daysInSeconds = Math.abs(moment(hours.start_date).unix() - moment(hours.end_date).unix());
        if (daysInSeconds / 86400 <= 1) {
          processed.date_override = true;
        }
      }
      output.push(processed);
    });
    return output;
  }
  return ProcessSchedule;
}]);

/***/ }),

/***/ "./components/schedule/util/schedule-util.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('ScheduleUtilFactory', ['moment', '_', function ScheduleUtilFactory(moment, _) {
  ScheduleUtilFactory.booleansToDays = booleansToDays;
  ScheduleUtilFactory.daysToText = daysToText;
  ScheduleUtilFactory.daysToBoolean = daysToBoolean;
  ScheduleUtilFactory.getApplicableRules = getApplicableRules;
  ScheduleUtilFactory.groupByDay = groupByDay;
  ScheduleUtilFactory.getShopTimes = getShopTimes;
  ScheduleUtilFactory.generateRuleInstances = generateRuleInstances;
  ScheduleUtilFactory.getRulesInRange = getRulesInRange;
  ScheduleUtilFactory.mergeConsecutive = mergeConsecutive;
  ScheduleUtilFactory.calculateDuration = calculateDuration;
  ScheduleUtilFactory.filterByDuration = filterByDuration;
  ScheduleUtilFactory.sort = sort;
  ScheduleUtilFactory.filterExceptions = filterExceptions;

  // Day-of-week object constants
  var sunday = { id: 0, name: 'Sunday' };
  var monday = { id: 1, name: 'Monday' };
  var tuesday = { id: 2, name: 'Tuesday' };
  var wednesday = { id: 3, name: 'Wednesday' };
  var thursday = { id: 4, name: 'Thursday' };
  var friday = { id: 5, name: 'Friday' };
  var saturday = { id: 6, name: 'Saturday' };

  ScheduleUtilFactory.daysArray = [sunday, monday, tuesday, wednesday, thursday, friday, saturday];
  ScheduleUtilFactory.days = {
    sunday: sunday,
    monday: monday,
    tuesday: tuesday,
    wednesday: wednesday,
    thursday: thursday,
    friday: friday,
    saturday: saturday };

  /**
   * @name booleansToDays
   * @description description
   * @param {type} rule Description
   */
  function booleansToDays(rule) {
    rule.days = [];
    if (rule.is_sunday) {
      rule.days.push(sunday);
    }
    if (rule.is_monday) {
      rule.days.push(monday);
    }
    if (rule.is_tuesday) {
      rule.days.push(tuesday);
    }
    if (rule.is_wednesday) {
      rule.days.push(wednesday);
    }
    if (rule.is_thursday) {
      rule.days.push(thursday);
    }
    if (rule.is_friday) {
      rule.days.push(friday);
    }
    if (rule.is_saturday) {
      rule.days.push(saturday);
    }
    rule.selected_days = rule.days;
    // See where we need selected_days vs days
  }

  /**
   * @name daysToText
   * @description description
   * @param {type} rule Description
   */
  function daysToText(rule) {
    var text = '';
    var daysOfWeek = '';
    var days = rule.selected_days;
    var dayCount = days.length;
    if (!days.length) {
      return;
    }
    for (var i = 0; i < days.length; i++) {
      daysOfWeek += days[i].name;
      if (i < dayCount - 2) {
        daysOfWeek += ', ';
      } else if (i === dayCount - 2) {
        daysOfWeek += ' and ';
      }
    }
    if (dayCount === 7) {
      text = 'every day';
    } else if (dayCount === 5 && days.indexOf(saturday) === -1 && days.indexOf(sunday) === -1) {
      text = 'weekdays';
    } else if (dayCount === 2 && days.indexOf(saturday) >= 0 && days.indexOf(sunday) >= 0) {
      text = 'weekends';
    } else {
      text += daysOfWeek;
    }

    if (rule.weekly_frequency === 1) {
      text += ' of every week';
    }
    if (rule.weekly_frequency === 2) {
      text += ' of every other week';
    }

    rule.text = text;
    rule.daysOfWeek = daysOfWeek;
  }

  /**
   * @name daysToBoolean
   * @description description
   * @param {type} rule Description
   */
  function daysToBoolean(rule) {
    for (var i = 0; i < rule.selectedDays.length; i++) {
      var selectedDay = rule.selectedDays[i];
      if (selectedDay.id === 1) {
        rule.is_sunday = true;
      }
      if (selectedDay.id === 2) {
        rule.is_monday = true;
      }
      if (selectedDay.id === 3) {
        rule.is_tuesday = true;
      }
      if (selectedDay.id === 4) {
        rule.is_wednesday = true;
      }
      if (selectedDay.id === 5) {
        rule.is_thursday = true;
      }
      if (selectedDay.id === 6) {
        rule.is_friday = true;
      }
      if (selectedDay.id === 7) {
        rule.is_saturday = true;
      }
    }
  }

  /**
   * @name getApplicableRules
   * @description Takes a set of time-related rules and returns any which are active during the requested range.
   * @param {type} start Description
   * @param {type} end Description
   * @param {type} rules Description
   * @return {type} Description
   */
  function getApplicableRules(start, end, rules) {
    // Performance improvement: filter out rules which end before 'start' and start after 'end'
    var results = [];
    var days = groupByDay(rules);

    for (var current = moment(start); current < end; current.add(1, 'day')) {
      var dayOfWeek = current.day();
      var firstSunday = moment(current).startOf('week');
      var endOfDay = moment(current).endOf('day');
      var currentRules = days[dayOfWeek];

      for (var i = 0; i < currentRules.length; i++) {
        var rule = currentRules[i];
        if (rule.start <= endOfDay && (_.isUndefined(rule.end) || rule.end > current) && !(firstSunday.diff(rule.first_sunday, 'weeks') % rule.weekly_frequency)) {
          if (results.indexOf(rule) === -1) {
            results.push(rule);
          }
        }
      }
    }
    return results;
  }

  // Takes multiple instances and 'merges' them when appropriate.
  // Instances are merged if the end of one coincides perfectly with the start of another.
  // The first instance gets the end and end_time of the second instance, and its length is updated.
  // More than two back-to-back instances will be chained into a larger instance.
  // The original array is not modified; a copy with the merged set is returned instead.
  /**
   * @name mergeConsecutive
   * @description description
   * @param {type} input Description
   * @return {type} Description
   */
  function mergeConsecutive(input) {
    var instances = _.cloneDeep(input);
    sort(instances);

    var output = [];
    for (var i = 0; i < instances.length;) {
      var first = void 0;
      var last = void 0;
      var endTime = void 0;
      var j = i;

      first = instances[i];
      do {
        last = instances[j++];
        endTime = last.end;
      } while (j < instances.length && endTime.unix() === instances[j].start.unix());

      if (first !== last) {
        first.end = last.end;
        first.end_time = last.end_time;
        first.length = last.end.diff(first.start, 'minutes');
      }
      output.push(first);
      i = j;
    }
    return output;
  }

  /**
   * @name sort
   * @description Description
   * @param {type} items Description
   */
  function sort(items) {
    items.sort(function (a, b) {
      return a.start - b.start;
    });
  }

  // Returns all rules which overlap the specified date range based purely on start/end dates.
  // Rules may or may not have actual occurences during the date range; this is not calculated
  // in this function for the sake of performance.
  /**
   * @name getRulesInRange
   * @description description
   * @param {type} rules Description
   * @param {type} start Description
   * @param {type} end Description
   * @return {type} Description
   */
  function getRulesInRange(rules, start, end) {
    var results = [];
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (rule.start < end && (_.isUndefined(rule.end) || start < rule.end)) {
        results.push(rule);
      }
    }
    return results;
  }

  // Returns instances (with start and end moments) of all rules which take place,
  // in part or in full, between start and end.
  /**
   * @name generateRuleInstances
   * @description description
   * @param {type} rules Description
   * @param {type} start Description
   * @param {type} end Description
   * @return {type} Description
   */
  function generateRuleInstances(rules, start, end) {
    var results = [];

    // Filter out rules which don't even overlap this range
    var possibleRules = getRulesInRange(rules, start, end);

    // Step through the days, from start to end
    for (var current = moment(start); current <= end; current.add(1, 'day')) {
      var dateString = moment(current).format('YYYY-MM-DD[T]');
      var firstSunday = moment(current).startOf('week');
      var startTime = current === start ? start : moment(current).startOf('day');
      var endTime = moment(current).endOf('day');
      if (endTime > end) {
        endTime = end;
      }

      // Filter out rules which don't even overlap this day
      var todayRules = getRulesInRange(possibleRules, startTime, endTime);
      // Group possible matches by day
      var days = groupByDay(todayRules);
      // Filter out rules which don't happen on this day of the week
      todayRules = days[current.day()];

      for (var i = 0; i < todayRules.length; i++) {
        var rule = todayRules[i];

        var ruleStartTime = moment(dateString + rule.start_time);
        var ruleEndTime = moment(dateString + rule.end_time);
        if (ruleEndTime <= ruleStartTime) {
          ruleEndTime.add(1, 'day');
        }

        // TODO Confusing use of '!'
        if (startTime < ruleEndTime && ruleStartTime <= endTime && !(firstSunday.diff(rule.first_sunday, 'weeks') % rule.weekly_frequency) && (!rule.end || ruleEndTime <= rule.end)) {
          results.push({
            start: ruleStartTime,
            end: ruleEndTime,
            rule: rule,
            duration: ruleEndTime.diff(ruleStartTime, 'minutes')
          });
        }
      }
    }
    return results;
  }

  // Takes a set of rule instances and removes normal rules based on
  // the existence of exceptions or days off during the same time period.
  /**
   * @name filterExceptions
   * @description description
   * @param {type} instances Description
   * @return {type} Description
   */
  function filterExceptions(instances) {
    var dates = {};
    var results = [];

    // Group each rule instance by the day that it starts on and then by artist ID
    for (var i = 0; i < instances.length; i++) {
      var instance = instances[i];
      var rule = instance.rule;
      var start = instance.start;

      var date = moment(start).startOf('day').format('YYYY-MM-DD');
      var artistsToday = dates[date];
      if (!artistsToday) {
        artistsToday = dates[date] = {};
      }

      var artist = artistsToday[rule.artist];
      if (!artist) {
        artist = artistsToday[rule.artist] = {
          normal: [],
          exceptions: [],
          daysOff: []
        };
      }

      if (rule.is_off) {
        artist.daysOff.push(instance);
      } else if (rule.is_exception) {
        artist.exceptions.push(instance);
      } else {
        artist.normal.push(instance);
      }
    }

    // Go through every artist-grouped set of rules on every date
    for (var artistDate in dates) {
      if (Object.prototype.hasOwnProperty.call(dates, artistDate)) {
        var artists = dates[artistDate];
        for (var id in artists) {
          if (Object.prototype.hasOwnProperty.call(artists, id)) {
            var thisArtist = artists[id];

            // If the artist doesn't have a daysOff instance starting on that day
            // add any exceptions they have on that day if they exist, otherwise
            // add normal rules that exist on that day
            if (!thisArtist.daysOff.length) {
              results = results.concat(thisArtist.exceptions.length ? thisArtist.exceptions : thisArtist.normal);
            }
          }
        }
      }
    }
    return results;
  }

  // Gets first rule on the start date and last rule on the end date.
  // End date is optional; if omitted it will get the last rule on the start date.
  /**
   * @name getShopTimes
   * @description description
   * @param {type} rules Description
   * @param {type} start Description
   * @param {type} end Description
   * @return {type} Description
   */
  function getShopTimes(rules, start, end) {
    var startDayInstances = generateRuleInstances(rules, moment(start).startOf('day'), moment(start).endOf('day'));
    var endDayInstances = end ? generateRuleInstances(rules, moment(end).startOf('day'), moment(end).endOf('day')) : startDayInstances;

    var earliest = findFirst(startDayInstances);
    var latest = findLast(endDayInstances);

    var interval = {
      earliest: earliest ? earliest : { start: moment(start).endOf('day') },
      latest: latest ? latest : { end: moment(end ? end : start).endOf('day') }
    };

    return interval;
  }

  /**
   * @name calculateDuration
   * @description Calculate Duration given Hours and Minutes
   * @param {type} hours Description
   * @param {type} minutes Description
   * @return {type} Description
   */
  function calculateDuration(hours, minutes) {
    return (hours ? 60 * hours : 0) + (minutes ? minutes : 0);
  }

  /**
   * @name filterByDuration
   * @description Returns a new array containing all items with a 'length' of at least 'duration'
   * @param {type} items Description
   * @param {type} duration Description
   * @return {type} Description
   */
  function filterByDuration(items, duration) {
    var output = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.length >= duration) {
        output.push(item);
      }
    }
    return output;
  }

  /**
   * @name findFirst
   * @description description
   * @param {type} instances Description
   * @return {type} Description
   */
  function findFirst(instances) {
    var earliest = void 0;
    for (var i = 0; i < instances.length; i++) {
      var instance = instances[i];

      if (!earliest || instance.start < earliest.start) {
        earliest = instance;
      }
    }
    return earliest;
  }

  /**
   * @name findLast
   * @description description
   * @param {type} instances Description
   * @return {type} Description
   */
  function findLast(instances) {
    var latest = void 0;
    for (var i = 0; i < instances.length; i++) {
      var instance = instances[i];

      if (!latest || instance.end > latest.end) {
        latest = instance;
      }
    }
    return latest;
  }

  // Takes a set of rules and returns an array of 7 arrays, corresponding to the rules that apply to each day, Sunday ([0]) through Saturday ([6])
  /**
   * @name groupByDay
   * @description description
   * @param {type} rules Description
   * @return {type} Description
   */
  function groupByDay(rules) {
    var days = [[], [], [], [], [], [], []];
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      for (var j = 0; j < rule.days.length; j++) {
        days[rule.days[j].id].push(rule);
      }
    }
    return days;
  }

  return ScheduleUtilFactory;
}]);

/***/ }),

/***/ "./components/shop/_shop.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508574
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/shop/base.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=shop class=\"section photo background-dark\"> <div class=background-photo></div> <div class=container> <div class=row> <div class=\"content-inner col-lg-6 col-lg-offset-3 col-sm-8 col-sm-offset-2\"> <div class=\"intro center\"> <h1>Your shop.</h1> <h5>Get your shop on.</h5> </div> </div> </div> <div class=row> <div class=\"col-sm-12 sub-nav\"> <ul class=nav-tabs> <li class=sub-nav-tab ui-sref=inkfinder.shop.profile ui-sref-active=active><a>Profile</a></li> <li class=sub-nav-tab ui-sref=inkfinder.shop.operators ui-sref-active=active><a>Operators</a></li> <li class=sub-nav-tab ui-sref=inkfinder.shop.payments ui-sref-active=active><a>Settings</a></li> <li class=sub-nav-tab ui-sref=inkfinder.shop.goals ui-sref-active=active><a>Goals</a></li> <li class=sub-nav-tab ui-sref=inkfinder.shop.message-templates ui-sref-active=active><a>Messages</a></li> <li class=sub-nav-tab ui-sref=inkfinder.shop.hours ui-sref-active=active><a>Hours</a></li> </ul> </div> <div class=col-sm-12 ui-view=shop></div> </div> </div> </div> ";

/***/ }),

/***/ "./components/shop/goals/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/goals/shop-goals.component.js");

__webpack_require__("./components/shop/goals/shop-goals.controller.js");

__webpack_require__("./components/shop/goals/shop-goals.service.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.shop.goals', {
    url: '/goals',
    views: {
      shop: {
        component: 'inkShopGoals'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Shop goals';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/shop/goals/shop-goals.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkShopGoals = {
  controller: 'ShopGoalsController',
  template: __webpack_require__("./components/shop/goals/shop-goals.template.html")
};

angular.module('inkfinder').component('inkShopGoals', inkShopGoals);

/***/ }),

/***/ "./components/shop/goals/shop-goals.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ShopGoalsController.$inject = ['ShopGoals'];


/**
 * @name ShopGoalsController
 * @description Controller for shop goals
 * @param {service} ShopGoals The ShopGoals service
 */
function ShopGoalsController(ShopGoals) {
  var vm = this;
  vm.$onInit = function () {
    vm.create = create;
    vm.update = update;
    vm.isAddGoalCollapsed = true;
    vm.editCurrentGoal = false;
    vm.newGoal = {
      weekly_revenue_goal: null
    };
    get();
  };

  /**
   * @name get
   * @description Function to get shop goals
   */
  function get() {
    ShopGoals.get().then(function (goals) {
      vm.goals = goals;
      vm.currentGoal = _lodash2.default.find(goals, function (goal) {
        if (!goal.end_datetime) {
          return true;
        }
      });
    });
  }

  /**
   * @name create
   * @description Function to create a goal
   * @param {type} goal The goal to create
   */
  function create(goal) {
    ShopGoals.create(goal).then(function (newGoal) {
      vm.isAddGoalCollapsed = true;
      get();
      resetGoalForm();
    });
  }

  /**
   * @name update
   * @description Function to update a goal
   * @param {type} goal The goal to update
   */
  function update(goal) {
    ShopGoals.update(goal).then(function (updatedGoal) {
      get();
      vm.editCurrentGoal = false;
    });
  }

  /**
   * @name resetGoalForm
   * @description Function to reset the form back to default
   */
  function resetGoalForm() {
    vm.newGoal = {
      weekly_revenue_goal: null
    };
    vm.shopGoalForm.$setPristine();
  }
}

angular.module('inkfinder').controller('ShopGoalsController', ShopGoalsController);

/***/ }),

/***/ "./components/shop/goals/shop-goals.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ShopGoals.$inject = ['$http', 'ENDPOINT', 'Session', 'moment', 'AlertMessages'];
/**
 * @name ShopGoals
 * @description Function for the shop goals service
 * @param {service} $http Angular $http service
 * @param {constant} ENDPOINT The ENDPOINT constant
 * @param {service} Session The Session service
 * @param {library} moment The moment library
 * @param {service} AlertMessages The AlertMessages service
 * @return {function} Returns the shop goals service
 */
function ShopGoals($http, ENDPOINT, Session, moment, AlertMessages) {
  ShopGoals.get = get;
  ShopGoals.create = create;
  ShopGoals.update = update;

  /**
   * @name get
   * @description Function to get a shop goal
   * @return {object} Returns the shop goal
   */
  function get() {
    var id = Session.activeState.association.id;
    if (id) {
      return $http.get(ENDPOINT.server + 'shops/api/v1.1/shop-goals/?association_id=' + id).then(function (response) {
        return parseGoals(response.data);
      }, function (error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
      });
    }
  }

  /**
   * @name create
   * @description Function to create a goal
   * @param {object} goal The goal to create
   * @return {object} Returns the new goal
   */
  function create(goal) {
    goal.association_id = Session.activeState.association.id;
    return $http.post(ENDPOINT.server + 'shops/api/v1.1/shop-goals/', goal).then(function (response) {
      AlertMessages.add({
        msg: 'Your shop goal has been saved.',
        type: 'success'
      });
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name update
   * @description Function to update a shop goal
   * @param {object} goal The goal to update
   * @return {object} Returns the udpated goal object
   */
  function update(goal) {
    goal.association_id = Session.activeState.association.id;
    return $http.put(ENDPOINT.server + 'shops/api/v1.1/shop-goals/' + goal.id + '/', goal).then(function (response) {
      AlertMessages.add({
        msg: 'Your shop goal has been saved.',
        type: 'success'
      });
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name parseGoals
   * @param {unknown} goals The goals to parse
   * @return {array} Returns the array of parsed goals
   */
  function parseGoals(goals) {
    for (var i = 0; i < goals.length; i++) {
      var goal = goals[i];
      goal.start = moment(goal.start_datetime);
      if (goal.end_datetime) {
        goal.end = moment(goal.end_datetime);
      }
    }
    return goals;
  }
  return ShopGoals;
}

angular.module('inkfinder').factory('ShopGoals', ShopGoals);

/***/ }),

/***/ "./components/shop/goals/shop-goals.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=col-sm-12> <h4>Your shop goals</h4> </div> <div class=col-sm-8> <div class=row> <div class=\"col-sm-12 center\"> <div class=\"divider small tight\"></div> <div class=\"button-add openable no-margin\" ng-class=\"{'open': !$ctrl.isAddGoalCollapsed}\"> <button class=\"button circle\" ng-click=\"$ctrl.isAddGoalCollapsed = !$ctrl.isAddGoalCollapsed\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> </div> </div> <div class=col-sm-12 uib-collapse=$ctrl.isAddGoalCollapsed> <div class=\"divider small tight transparent\"></div> <h6>Add a new weekly revenue goal</h6> <p>Enter a goal for the income your shop receives in one week</p> <form name=$ctrl.shopGoalForm ng-submit=\"$ctrl.shopGoalForm.$valid && $ctrl.create($ctrl.newGoal)\" novalidate> <div class=form-group> <div class=input-group> <span class=input-group-addon>$</span> <input name=goal id=goal type=text fcsa-number=\"{preventInvalidInput: true, maxDecimals: 2}\" ng-model=$ctrl.newGoal.weekly_revenue_goal class=form-control> </div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"$ctrl.shopGoalForm.goal.$invalid && !$ctrl.shopGoalForm.goal.$pristine\"> Hmm...we need a number here. </p> </div> </div> <div class=button-container> <div> <button class=\"button large shop-solid\" type=submit ng-disabled=\"$ctrl.shopGoalForm.$invalid || $ctrl.newGoal.weekly_revenue_goal === ''\">Save</button> </div> </div> </form> </div> <div class=col-sm-12> <div class=\"divider small tight\"></div> <h5>Current weekly revenue goal</h5> <p ng-if=!$ctrl.currentGoal>No goal found.</p> <div ng-if=$ctrl.currentGoal> <a ng-click=\"$ctrl.editCurrentGoal = !$ctrl.editCurrentGoal\" ng-class=\"{'hidden': $ctrl.editCurrentGoal}\" event-focus=click event-focus-id=updateGoal> <h4 class=\"no-margin inline shop-color\"> {{$ctrl.currentGoal.weekly_revenue_goal | noFractionCurrency}} <fa name=pencil size=1 class=\"icon light small link\"></fa> </h4> </a> <div class=form-group ng-class=\"{'hidden': !$ctrl.editCurrentGoal}\"> <input type=text id=updateGoal step=0.01 class=\"light-color inline\" fcsa-number=\"{ prepend: '$', maxDecimals: 2 }\" ng-model=$ctrl.currentGoal.weekly_revenue_goal ng-keyup=\"$event.keyCode === 13 && $ctrl.update($ctrl.currentGoal)\"> <div class=inline-confirm-icons> <a ng-click=$ctrl.update($ctrl.currentGoal)> <fa name=check class=\"shop-color confirm\"></fa> </a> <a ng-click=\"$ctrl.editCurrentGoal = !$ctrl.editCurrentGoal\"> <fa name=times-circle class=\"alert-color cancel\"></fa> </a> </div> </div> <div> <small> Created on {{$ctrl.currentGoal.start | amDateFormat:'MM/DD/YYYY'}} </small> </div> </div> </div> <div class=col-sm-12> <div class=\"divider small loose transparent\"></div> <h5>Previous weekly revenue goals</h5> <p ng-if=\"$ctrl.goals.length <= 1\">No goals found.</p> <div ng-if=\"$ctrl.goals.length > 1\"> <div ng-repeat=\"goal in $ctrl.goals | orderBy:'-end' track by goal.id\" ng-if=!$first> <h4 class=\"no-margin inline\"> {{goal.weekly_revenue_goal | noFractionCurrency}} </h4> <div> <small> Active from {{goal.start | amDateFormat:'MM/DD/YYYY'}} to {{goal.end | amDateFormat:'MM/DD/YYYY'}} </small> </div> <div class=\"divider small tight\" ng-class=\"{'transparent': $last}\"></div> </div> </div> </div> </div> </div> <div class=\"col-sm-3 col-sm-offset-1\"> <h6 class=finder-color><fa name=info-circle></fa> How goals work</h6> <p> <small class=finder-color>Your shop’s revenue progress bar stat is based on your latest active weekly revenue goal. So if you’re looking at stats for last week and you created a new goal for this week, your goal last week will be used to calculate your progress for that time period.</small> </p> <p> <small class=finder-color>The Shop Daily email will use the latest active weekly revenue goal to show your progress toward that goal.</small> </p> </div> ";

/***/ }),

/***/ "./components/shop/hours/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/hours/util/index.js");

__webpack_require__("./components/shop/hours/shop-hours.component.js");

__webpack_require__("./components/shop/hours/shop-hours.controller.js");

__webpack_require__("./components/shop/hours/shop-hours.service.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.shop.hours', {
    url: '/hours',
    views: {
      shop: {
        component: 'inkShopHours'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Shop hours';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/shop/hours/shop-hours.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkShopHours = {
  controller: 'ShopHoursController',
  template: __webpack_require__("./components/shop/hours/shop-hours.template.html")
};

angular.module('inkfinder').component('inkShopHours', inkShopHours);

/***/ }),

/***/ "./components/shop/hours/shop-hours.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ShopHoursController.$inject = ['$rootScope', 'ShopHours', 'Shop', 'ScheduleUtilFactory', 'Association', 'moment', 'AlertMessages', 'Session', '_'];


/**
 * @name ShopHoursController
 * @description Controller for shop hours
 * @param {type} $rootScope Description
 * @param {service} ShopHours The shop hours service
 * @param {service} Shop The shop service
 * @param {type} ScheduleUtilFactory Description
 * @param {type} Association Description
 * @param {type} moment Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 */
function ShopHoursController($rootScope, ShopHours, Shop, ScheduleUtilFactory, Association, moment, AlertMessages, Session, _) {
  var vm = this;
  vm.$onInit = function () {
    vm.weekdays = ScheduleUtilFactory.daysArray;
    vm.status = {};
    vm.busy = false;
    vm.shopHours = [];
  };

  // Get the shop of the logged in operator
  var shop = Session.activeState.association.shop;

  // Get shop profile
  Shop.get(shop.id).then(function (shop) {
    vm.shop = shop;
  });

  // Get the Shop Hours
  ShopHours.get(Session.activeState.association.shop.id).then(function (hours) {
    vm.shopHours = hours.current;
  });

  // Send a new/updated shop schedule (to API)
  vm.update_shop_hours = function (shop_hours) {
    // Check if we're busy
    if (vm.busy === false) {
      // Indeed we NOW Are
      vm.busy = true;
      var newShopHours = _.cloneDeep(shop_hours.update);

      // New Shop Schedule
      if (shop_hours.is_new) {
        ShopHours.create(newShopHours).then(function (newHours) {
          replaceHours(shop_hours, newHours);
        });
        // Updating Existing Shop Schedule
      } else if (moment(newShopHours.startDate).startOf('day') < moment().startOf('day')) {
        // Past Shop Hours (Expire then Create New)
        newShopHours.startDate = moment().startOf('day').format('YYYY-MM-DD');

        // Expire
        ShopHours.expire(shop_hours).then(function (response) {
          // Create
          ShopHours.create(newShopHours).then(function (newHours) {
            replaceHours(shop_hours, newHours);
          });
        });
        // Update Only
      } else {
        ShopHours.update(newShopHours).then(function (newHours) {
          replaceHours(shop_hours, newHours);
          shop_hours.accordion_open = false;
        });
      }
    } else {
      AlertMessages.add({ msg: 'Please Wait.', type: 'warning' });
    }
  };

  /**
   * @name replaceHours
   * @description description
   * @param {type} oldHours Description
   * @param {type} newHours Description
   */
  function replaceHours(oldHours, newHours) {
    ShopHours.parse([newHours]);
    vm.shopHours[vm.shopHours.indexOf(oldHours)] = newHours;
    vm.busy = false;
    AlertMessages.add({ msg: 'Your shop hours have been saved.', type: 'success' });
  }

  // Cancel Adding/Updating a Shop's Hours
  vm.cancel_shop_hours_update = function (shop_hours) {
    shop_hours.accordion_open = false;
    if (shop_hours.is_new) {
      vm.status.adding = false;
      vm.shopHours.pop();
    }
  };

  // Add more Shop Hours (fill out form with blank deta).
  vm.add_shop_hours = function () {
    vm.shopHours.push({ update: { startTime: moment().startOf('day'), endTime: moment().startOf('day') }, is_new: true, accordion_open: true });
    vm.status.adding = true;
  };
}

angular.module('inkfinder').controller('ShopHoursController', ShopHoursController);

/***/ }),

/***/ "./components/shop/hours/shop-hours.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ShopHours.$inject = ['$q', '$http', '$interval', '$rootScope', 'ENDPOINT', 'ScheduleUtilFactory', 'moment', 'AlertMessages', 'Session', '_'];


/**
 * @name ShopHours
 * @description The shop hours service
 * @param {type} $q Description
 * @param {type} $http Description
 * @param {type} $interval Description
 * @param {type} $rootScope Description
 * @param {type} ENDPOINT Description
 * @param {type} ScheduleUtilFactory Description
 * @param {type} moment Description
 * @param {type} AlertMessages Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 * @return {type} Description
 */
function ShopHours($q, $http, $interval, $rootScope, ENDPOINT, ScheduleUtilFactory, moment, AlertMessages, Session, _) {
  ShopHours.get = get;
  ShopHours.refresh = refresh;
  ShopHours.expire = expire;
  ShopHours.parse = parse;
  ShopHours.create = create;
  ShopHours.update = update;
  ShopHours.process = process;
  ShopHours.getHoursByDay = getHoursByDay;

  // The object holding all variables relating to queries
  var qwe = void 0;

  resetvariables();

  /**
   * @name resetvariables
   * @description description
   */
  function resetvariables() {
    qwe = {
      shopHours: {}
    };

    ShopHours.shopHours = {};
    ShopHours.allShopHours = [];
  }

  // Called to Reset Data on Logout
  var deregister = $rootScope.$on('clear-data', function () {
    $interval.cancel(qwe.shopHours.timer);
    resetvariables();
  });
  $rootScope.$on('$destroy', deregister);

  /**
   * @name createShopHourTimer
   * @description description
   * @param {number} shopId The ID of the shop
   */
  function createShopHourTimer(shopId) {
    if (!qwe.shopHours.timer) {
      qwe.shopHours.timer = $interval(function () {
        makeNewShopHoursPromise(shopId);
      }, 1000);
    }
  }

  /**
   * @name makeNewShopHoursPromise
   * @description description
   * @param {number} shopId The ID of the shop
   */
  function makeNewShopHoursPromise(shopId) {
    if (!shouldRefresh()) {
      return;
    }
    qwe.shopHours.override = false;
    qwe.shopHours.promise = $q(function (resolve, reject) {
      qwe.shopHours.refreshing = true;
      $http.get(ENDPOINT.server + 'schedules/api/v1.1/shop-hours/all/?shop_id=' + shopId).then(function (response) {
        if (qwe.shopHours.timer) {
          parse(response.data);
          ShopHours.allShopHours = response.data;

          var activeRules = [];
          for (var i = 0; i < ShopHours.allShopHours.length; i++) {
            var hour = ShopHours.allShopHours[i];
            if (hour && !hour.end_date) {
              activeRules.push(hour);
            }
          }
          ShopHours.shopHours = activeRules;
          qwe.shopHours.updated = moment();
          resolve({ all: ShopHours.allShopHours, current: activeRules });
        }
        qwe.shopHours.refreshing = false;
      }, function (error) {
        reject(error);
      });
    });
  }

  /**
   * @name shouldRefresh
   * @description description
   * @return {boolean} Description
   */
  function shouldRefresh() {
    return qwe.shopHours.override || !qwe.shopHours.refreshing && (!qwe.shopHours.updated || moment().diff(qwe.shopHours.updated, 'seconds') >= 23);
  }

  /**
   * @name get
   * @description Function to get shop hours
   * @param {number} shopId The ID of the shop
   * @return {object} Unknown
   */
  function get(shopId) {
    createShopHourTimer(shopId);
    makeNewShopHoursPromise(shopId);
    return qwe.shopHours.promise;
  }

  /**
   * @name refresh
   * @description description
   * @return {function} Description
   */
  function refresh() {
    qwe.shopHours.override = true;
    return get();
  }

  /**
   * @name create
   * @description Create new shops hours
   * @param {type} shopHours Description
   * @return {type} Description
   */
  function create(shopHours) {
    // Some Preprocessing
    ScheduleUtilFactory.daysToBoolean(shopHours);
    packageHoursData(shopHours);

    var url = ENDPOINT.server + 'schedules/api/v1.1/shop-hours/create/';

    return $http.post(url, shopHours).then(function (response) {
      return response.data;
    }, function (error) {
      throw error;
    });
  }

  /**
   * @name update
   * @description Function to update existing shop hours
   * @param {type} shopHours Description
   * @return {type} Description
   */
  function update(shopHours) {
    var url = ENDPOINT.server + 'schedules/api/v1.1/shop-hours/';

    // Some Preprocessing
    ScheduleUtilFactory.daysToBoolean(shopHours);
    packageHoursData(shopHours);

    return $http.post(url, shopHours).then(function (response) {
      return response.data;
    }, function (error) {
      throw error;
    });
  }

  /**
   * @name process
   * @description description
   * @param {type} data Description
   * @return {type} Description
   */
  function process(data) {
    var processed = data;

    // Convert time to 12hr Format.
    processed.start_time = moment(data.start_time, 'HH:mm:ss');
    processed.end_time = moment(data.end_time, 'HH:mm:ss');

    if (!processed.selected_days) {
      ScheduleUtilFactory.booleansToDays(processed);
      ScheduleUtilFactory.daysToText(processed);
    }
    return processed;
  }

  /**
   * @name getHoursByDay
   * @description description
   * @param {type} date Description
   * @return {type} Description
   */
  function getHoursByDay(date) {
    var selected_day = moment(date, 'YYYY/MM/DD').format('dddd');
    var selected_hour_set = void 0;

    _.each(ShopHours.shopHours, function (hour_set) {
      var days = [];
      if (hour_set.is_sunday) {
        days.push('Sunday');
      }
      if (hour_set.is_monday) {
        days.push('Monday');
      }
      if (hour_set.is_tuesday) {
        days.push('Tuesday');
      }
      if (hour_set.is_wednesday) {
        days.push('Wednesday');
      }
      if (hour_set.is_thursday) {
        days.push('Thursday');
      }
      if (hour_set.is_friday) {
        days.push('Friday');
      }
      if (hour_set.is_saturday) {
        days.push('Saturday');
      }

      _.each(days, function (day) {
        if (selected_day === day) {
          selected_hour_set = hour_set;
        }
      });
    });

    return selected_hour_set;
  }

  /**
   * @name parse
   * @description description
   * @param {type} hours Description
   */
  function parse(hours) {
    for (var i = 0; i < hours.length; i++) {
      var hour = hours[i];

      hour.start = moment(hour.start_date + 'T' + hour.start_time);
      // Not necessarily when the first instance of the rule is, it may not take place on that day
      hour.first_sunday = moment(hour.start).startOf('week');

      ScheduleUtilFactory.booleansToDays(hour);

      if (hour.end_date) {
        hour.end = moment(hour.end_date + 'T' + hour.end_time); // Not necessarily when the last instance of the rule is, it may not take place on that day
      }

      hour.original = {
        id: hour.id,
        selectedDays: hour.days,
        startTime: moment(hour.start_time, 'HH:mm:ss'),
        endTime: moment(hour.end_time, 'HH:mm:ss'),
        startDate: moment(hour.start_date, 'YYYY-MM-DD').startOf('day')
      };

      if (hour.end) {
        hour.original.endDate = moment(hour.end).startOf('day');
      }

      hour.display = {
        selectedDays: hour.days,
        startTime: hour.original.startTime.format('h:mm a'),
        endTime: hour.original.endTime.format('h:mm a')
      };

      hour.update = _.cloneDeep(hour.original);
    }
  }

  /**
   * @name expire
   * @description Pre-canned method of Expiring the Shop Hour Set
   * @param {type} hoursData Description
   * @return {type} Description
   */
  function expire(hoursData) {
    var shopHours = _.cloneDeep(hoursData.original);

    ScheduleUtilFactory.daysToBoolean(shopHours);
    packageHoursData(shopHours);

    if (moment(hoursData.start_time, 'HH:mm:ss').unix() > moment(hoursData.end_time, 'HH:mm:ss').unix()) {
      shopHours.end_date = moment().format('YYYY-MM-DD');
    } else {
      shopHours.end_date = moment().subtract(1, 'day').format('YYYY-MM-DD');
    }
    var url = ENDPOINT.server + 'schedules/api/v1.1/shop-hours/';
    return $http.post(url, shopHours).then(function (response) {
      return response.data;
    }, function (error) {
      throw error;
    });
  }

  /**
   * @name packageHoursData
   * @description Format for Sending
   * @param {type} shopHours Description
   */
  function packageHoursData(shopHours) {
    shopHours.shop_hour_id = shopHours.id;
    shopHours.start_time = moment(shopHours.startTime).format('HH:mm:ss');
    shopHours.end_time = moment(shopHours.endTime).format('HH:mm:ss');
    shopHours.start_date = moment(shopHours.startDate).format('YYYY-MM-DD');
    shopHours.interval = 1;
    shopHours.selected_days = shopHours.selectedDays;
    shopHours.association_id = Session.activeState.association.id;
  }
  return ShopHours;
}

angular.module('inkfinder').factory('ShopHours', ShopHours);

/***/ }),

/***/ "./components/shop/hours/shop-hours.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"col-sm-8 col-sm-offset-2\"> <h4>Your shop hours</h4> <div class=\"divider small tight transparent\"></div> <p>Select the days you're open and enter your start and end times.</p> <div class=form> <uib-accordion class=\"accordion inline-accordion\" ng-if=$ctrl.shopHours> <div uib-accordion-group is-open=shop_hours.accordion_open ng-repeat=\"shop_hours in $ctrl.shopHours track by shop_hours.id\"> <uib-accordion-heading> <div class=clearfix> <div class=col-md-12> <h5 ng-if=!shop_hours.is_new><fa name=clock-o class=shop-color></fa> {{shop_hours.display.startTime}} – {{shop_hours.display.endTime}} <fa name=pencil class=\"light small link\"></fa></h5> <h5 ng-if=shop_hours.is_new><fa name=clock-o class=shop-color></fa> Add shop hours <fa name=pencil class=\"light small link\"></fa></h5> </div> <div class=col-md-12> <p ng-if=shop_hours.display.selectedDays.length><small>Repeats every <span ng-repeat=\"day in shop_hours.display.selectedDays\"> <span ng-if=$last>and </span>{{day.name}}<span ng-if=!$last>,</span><span ng-if=$last>.</span></span></small></p> </div> </div> </uib-accordion-heading> <form name=shopHoursForm ng-submit=\"shopHoursForm.$valid && $ctrl.update_shop_hours(shop_hours)\" novalidate> <div class=row> <div class=col-md-12 ng-if=!shop_hours.is_new> <h6>Edit this schedule</h6> </div> <div class=col-md-12> <div class=form-group> <label>Select days to repeat</label> <ui-select multiple=multiple ng-model=shop_hours.update.selectedDays theme=bootstrap ng-disabled=disabled required close-on-select=false> <ui-select-match placeholder=\"Select days...\"> {{$item.name}} </ui-select-match> <ui-select-choices required repeat=\"days in $ctrl.weekdays | filter: $select.search track by days.id\"> {{days.name}} </ui-select-choices> </ui-select> </div> <div class=\"divider small tight\"></div> </div> <div class=col-md-6> <div class=form-group> <label for=startTime>Start time</label> <div uib-timepicker name=start_time id=start_time ng-model=shop_hours.update.startTime hour-step=1 minute-step=15 show-meridian=true class=time-picker></div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"shopHoursForm.startTime.$invalid && !shopHoursForm.startTime.$pristine\"> Pardon me, do you have the time? </p> </div> </div> </div> <div class=col-md-6> <div class=form-group> <label for=endTime>End time</label> <div uib-timepicker name=end_time id=end_time ng-model=shop_hours.update.endTime hour-step=1 minute-step=15 show-meridian=true class=time-picker></div> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"shopHoursForm.endTime.$invalid && !shopHoursForm.endTime.$pristine\"> Pardon me, do you have the time? </p> </div> </div> </div> <div class=\"button-container padding\"> <button class=\"button large shop-solid\" type=submit ng-disabled=\"shopHoursForm.$invalid || !shop_hours.update.selectedDays.length || $ctrl.busy\">Save</button> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.cancel_shop_hours_update(shop_hours)>Cancel</button> </div> </div> </form> </div> <div class=row ng-if=!$ctrl.shopHours.length> <div class=\"col-md-12 center\"> <div class=button-add ng-click=$ctrl.add_shop_hours() ng-if=!$ctrl.status.adding> <button class=\"button circle\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> <small>Add shop hours</small> </div> </div> </div> </uib-accordion> </div> </div> ";

/***/ }),

/***/ "./components/shop/hours/util/format-shop-hours-description.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('FormatShopHoursDescription', ['_', function FormatShopHoursDescription(_) {
  // Public methods
  FormatShopHoursDescription.format = format;
  /**
   * @name format
   * @description Function to format the description of shop hours in a human
   * readable format.
   * @param {array} hours The hours to format.
   * @return {string} Returns the description of shop hours.
   */
  function format(hours) {
    var formattedHoursDescription = void 0;
    if (hours[0].display.selectedDays.length === 7) {
      formattedHoursDescription = 'Open daily from ';
    } else {
      var dayNames = _.map(hours[0].display.selectedDays, function (day) {
        return day.name + ', ';
      });
      formattedHoursDescription = 'Open ' + dayNames.toString() + ' from ';
    }
    formattedHoursDescription += hours[0].display.startTime + ' to ' + hours[0].display.endTime;
    return formattedHoursDescription;
  }
  return FormatShopHoursDescription;
}]);

/***/ }),

/***/ "./components/shop/hours/util/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/hours/util/format-shop-hours-description.service.js");

/***/ }),

/***/ "./components/shop/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/goals/index.js");

__webpack_require__("./components/shop/hours/index.js");

__webpack_require__("./components/shop/messages/index.js");

__webpack_require__("./components/shop/operators/index.js");

__webpack_require__("./components/shop/payments/index.js");

__webpack_require__("./components/shop/profile/index.js");

__webpack_require__("./components/shop/util/index.js");

__webpack_require__("./components/shop/shop.service.js");

__webpack_require__("./components/shop/_shop.styles.scss");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider
  // Shop profile base
  .state('inkfinder.shop', {
    url: '/shop',
    abstract: true,
    views: {
      '@': {
        template: __webpack_require__("./components/shop/base.template.html")
      }
    },
    data: {
      authorizedRoles: [USER_ROLES.operator]
    }
  });
}]);

/***/ }),

/***/ "./components/shop/messages/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/messages/shop-messages-route.component.js");

__webpack_require__("./components/shop/messages/shop-messages-route.controller.js");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.shop.message-templates', {
    url: '/message-templates',
    views: {
      shop: {
        component: 'inkShopMessagesRoute'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Shop messages';
      },
      messageTemplatesOwner: ['Session', 'Shop', function messageTemplatesOwner(Session, Shop) {
        var shopId = Session.activeState.association.shop.id;
        return Shop.get(shopId).then(function (response) {
          return response;
        });
      }]
    }
  });
}]);

/***/ }),

/***/ "./components/shop/messages/shop-messages-route.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkShopMessagesRoute = {
  // controller: 'ShopMessagesController',
  bindings: {
    messageTemplatesOwner: '<'
  },
  template: __webpack_require__("./components/shop/messages/shop-messages-route.template.html")
};

angular.module('inkfinder').component('inkShopMessagesRoute', inkShopMessagesRoute);

/***/ }),

/***/ "./components/shop/messages/shop-messages-route.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ShopMessagesController.$inject = ['Shop', 'Session'];
/**
 * @name ShopMessagesController
 * @description Controller for shop message templates.
 * @param {Unknown} Shop Shop service
 * @param {Unknown} Session Session service
 */
function ShopMessagesController(Shop, Session) {}

angular.module('inkfinder').controller('ShopMessagesController', ShopMessagesController);

/***/ }),

/***/ "./components/shop/messages/shop-messages-route.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"col-sm-8 col-sm-offset-2\"> <h4>Your shop messages</h4> <div class=\"divider small tight transparent\"></div> <ink-message-templates message-templates-owner=$ctrl.messageTemplatesOwner> </ink-message-templates> </div> ";

/***/ }),

/***/ "./components/shop/operators/add/collector-create.html":
/***/ (function(module, exports) {

module.exports = " <div class=intro> <h1>Create an account.</h1> <h5>Create an Ink Finder account for a new operator.</h5> </div> <div class=row> <div class=\"col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 center\"> <form name=createCollector class=left ng-submit=\"createCollector.$valid && AddUserController.createCollector('inkfinder.shop.add.operator-association')\" novalidate> <div class=form-group> <label for=first_name>First name</label> <input name=first_name id=first_name type=text class=form-control placeholder=Darth required ng-model=AddUserController.newCollector.first_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.first_name.$invalid && !createCollector.first_name.$pristine\"> We need a first name! </p> </div> </div> <div class=form-group> <label for=last_name>Last name</label> <input name=last_name id=last_name type=text class=form-control placeholder=Vader required ng-model=AddUserController.newCollector.last_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.last_name.$invalid && !createCollector.last_name.$pristine\"> We need a last name! </p> </div> </div> <div class=form-group> <label for=email>Email</label> <input name=email id=email type=email class=form-control placeholder=vader@deathstar.com required ng-model=AddUserController.newCollector.email> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.email.$invalid && !createCollector.email.$pristine\"> Hmm...I don’t think that's a real email address. </p> </div> </div> <div class=form-group> <label for=phone>Phone <small>Optional</small></label> <input name=phone id=phone placeholder=\"(555) 555–1234\" mask=\"(999) 999-9999\" clean=true restrict=reject type=text ng-model=AddUserController.newCollector.phone> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"createCollector.phone.$invalid && !createCollector.phone.$pristine\"> You won’t be talking to anyone with that number. </p> </div> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" type=submit ng-disabled=createCollector.$invalid>Create account</button> <button class=\"button large alert-btn\" type=reset ng-click=AddUserController.startOver()>Start Over</button> </div> </form> </div> </div> ";

/***/ }),

/***/ "./components/shop/operators/add/collector-search-add.html":
/***/ (function(module, exports) {

module.exports = " <div class=intro> <h1>Add an operator.</h1> <h5>Search for an existing operator or add a new one.</h5> </div> <div class=row> <div class=\"col-sm-5 col-sm-offset-1 left\"> <h6>Search for an operator on Ink Finder</h6> <form name=searchCollectors ng-submit=\"searchCollectors.$valid && AddUserController.searchCollectors(query, 'operator', 'inkfinder.shop.add.operator-collector-select')\" novalidate> <div class=form-group> <label for=search>Enter an email or phone number</label> <input name=search id=search type=text autocapitalize=off placeholder=\"Email or phone number\" class=form-control required ng-init=\"query = ''\" ng-model=query ng-keyup=\"$event.keyCode === 13 && searchCollectors.$invalid\"> </div> <div class=\"button-container left\"> <button class=\"button large shop-solid\" type=submit ng-disabled=searchCollectors.$invalid>Search</button> </div> </form> </div> <div class=\"col-sm-6 center\"> <h6 class=center>Add a new operator</h6> <div class=\"button-add no-margin\" ui-sref=inkfinder.shop.add.operator-collector-create> <button class=\"button circle\"> <div class=plus> <div class=width></div> <div class=height></div> </div> </button> </div> </div> </div> ";

/***/ }),

/***/ "./components/shop/operators/add/collector-select.html":
/***/ (function(module, exports) {

module.exports = " <div ng-if=\"AddUserController.collectors.length > 0\"> <div class=intro> <h1>Recognize anyone?</h1> <h5>Select someone below, <a ui-sref=inkfinder.shop.add.operator-collector-create>create a new account</a>, or <a ng-click=AddUserController.startOver()>search again</a>. </h5> </div> <ink-collector-list list=AddUserController.collectors type=\"'operator'\" select=\"AddUserController.selectCollector(collector, 'inkfinder.shop.add.operator-association')\"> </ink-collector-list></div> <div ng-if=\"AddUserController.collectors.length === 0\"> <div class=intro> <h1>Oops. We couldn't find anyone...</h1> <h5><a ui-sref=inkfinder.shop.add.operator-collector-create>Create a new account</a>, or <a ng-click=AddUserController.startOver()>search again</a>.</h5> </div> </div> ";

/***/ }),

/***/ "./components/shop/operators/add/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider
  // Add an operator template
  .state('inkfinder.shop.add', {
    url: '/operators',
    abstract: true,
    views: {
      '@': {
        template: __webpack_require__("./components/shop/operators/add/operator-add.html"),
        controller: 'AddUserController as AddUserController'
      }
    },

    // Set the starting route of the add operator process
    data: {
      startingRoute: ['inkfinder.shop.add.operator-search-add'],
      authorizedRoles: [USER_ROLES.operator]
    }
  })

  // Add an operator: Collector search
  .state('inkfinder.shop.add.operator-search-add', {
    url: '/search',
    template: __webpack_require__("./components/shop/operators/add/collector-search-add.html"),
    resolve: {
      $title: function $title() {
        return 'Invite an operator';
      }
    }
  })

  // Add an operator: Select a collector
  .state('inkfinder.shop.add.operator-collector-select', {
    url: '/select',
    template: __webpack_require__("./components/shop/operators/add/collector-select.html"),
    resolve: {
      $title: function $title() {
        return 'Search results';
      }
    }
  })

  // Add an operator: Add a collector
  .state('inkfinder.shop.add.operator-collector-create', {
    url: '/invite',
    template: __webpack_require__("./components/shop/operators/add/collector-create.html"),
    resolve: {
      $title: function $title() {
        return 'Create an account';
      }
    }
  })

  // Add an operator: Confirm the association
  .state('inkfinder.shop.add.operator-association', {
    url: '/association',
    template: __webpack_require__("./components/shop/operators/add/operator-association.html"),
    resolve: {
      $title: function $title() {
        return 'Confirm this operator';
      }
    }
  })

  // Add an operator: Invite complete
  .state('inkfinder.shop.add.operator-invite-complete', {
    url: '/complete',
    template: __webpack_require__("./components/shop/operators/add/operator-add-complete.html"),
    resolve: {
      $title: function $title() {
        return 'Operator invite complete';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/shop/operators/add/operator-add-complete.html":
/***/ (function(module, exports) {

module.exports = " <div class=intro> <h1>Sent!</h1> <h5>We’ll alert you as soon as {{AddUserController.selectedCollector.first_name}} accepts your invitation.</h5> </div> <div class=row> <div class=\"col-md-8 col-md-offset-2 center\"> <div class=\"collector center\"> <ink-profile-photo profile=AddUserController.selectedCollector image-id=AddUserController.selectedCollector.profile_photo></ink-profile-photo> </div> <div class=\"button-container margin\"> <button class=\"button large shop-solid\" ui-sref=inkfinder.shop.operators>View operators</button> </div> </div> </div> ";

/***/ }),

/***/ "./components/shop/operators/add/operator-add.html":
/***/ (function(module, exports) {

module.exports = "<div id=shop class=\"section photo background-dark\"> <div class=background-photo></div> <div class=\"container-fluid center\"> <div class=row> <div ui-view=\"\" class=col-sm-12></div> </div> </div> </div> ";

/***/ }),

/***/ "./components/shop/operators/add/operator-association.html":
/***/ (function(module, exports) {

module.exports = " <div class=intro> <h1>Confirm it.</h1> <h5>Ready to invite <span ng-if=AddUserController.selectedCollector.first_name>{{AddUserController.selectedCollector.first_name}}</span> <span ng-if=!AddUserController.selectedCollector.first_name>this operator</span> to your shop? </h5> </div> <div class=row> <div class=\"col-md-8 col-md-offset-2 center\"> <div class=\"collector center\"> <ink-profile-photo profile=AddUserController.selectedCollector image-id=AddUserController.selectedCollector.profile_photo></ink-profile-photo> </div> </div> <div class=\"col-lg-6 col-lg-offset-3 col-md-8 col-md-offset-2 center\"> <div class=\"divider small tight transparent\"></div> <form name=createAssociation class=left ng-submit=\"createAssociation.$valid && AddUserController.createAssociation('Operator', 'inkfinder.shop.add.operator-invite-complete')\" novalidate> <div class=form-group ng-if=AddUserController.session.activeState.association.operatorOwner> <label> <input name=canUpdateAppts type=checkbox ng-model=AddUserController.association.operatorAdmin> {{AddUserController.selectedCollector.first_name}} is an admin of this shop<br/> <small>Admins can add and remove other operators and artists and can edit artist connection settings</small> </label> </div> <div class=form-group ng-if=AddUserController.session.activeState.association.operatorOwner> <label> <input name=canUpdateAppts type=checkbox ng-model=AddUserController.association.operatorOwner> {{AddUserController.selectedCollector.first_name}} is an owner of this shop<br/> <small>Owners can make other operators owners and admins</small> </label> </div> <div class=\"button-container margin center\"> <button class=\"button large shop-solid equal-medium\" type=submit ng-disabled=createAssociation.$invalid>Send invite</button> <button class=\"button large alert-btn equal-medium\" type=reset ng-click=AddUserController.startOver()>Start Over</button> </div> </form> </div> </div> ";

/***/ }),

/***/ "./components/shop/operators/cancel-invite-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


CancelInviteModalController.$inject = ['$uibModalInstance', 'Association', 'operator'];


/**
 * @name CancelInviteModalController
 * @description Function to handle operator invite cancellations
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} Association The association service
 * @param {unknown} operator Resolved operator from the shop operators controller
 */
function CancelInviteModalController($uibModalInstance, Association, operator) {
  var vm = this;
  vm.operator = operator;

  vm.cancelInvite = function (operator) {
    Association.declineByShop(operator.association).then(function () {
      $uibModalInstance.close();
    });
  };

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('CancelInviteModalController', CancelInviteModalController);

/***/ }),

/***/ "./components/shop/operators/cancel-invite-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=cancelInviteForm ng-submit=\"cancelInviteForm.$valid && $ctrl.cancelInvite($ctrl.operator)\" novalidate> <div class=modal-header> <h4 class=modal-title>Cancel the invite to {{$ctrl.operator.first_name}}?</h4> </div> <div class=\"modal-body background-light center\"> <ink-profile-photo profile=$ctrl.operator image-id=$ctrl.operator.profile_photo></ink-profile-photo> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Cancel invite</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/shop/operators/expire/expire-operator-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ExpireOperatorModalController.$inject = ['$uibModalInstance', 'Association', 'operator'];


/**
 * @name ExpireOperatorModalController
 * @description Function to remove operators from a shop
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} Association The association service
 * @param {unknown} operator Resolved operator from the shop operators controller
 */
function ExpireOperatorModalController($uibModalInstance, Association, operator) {
  var vm = this;
  vm.operator = operator;

  vm.expireOperator = function (operator) {
    Association.expire(operator.association).then(function () {
      $uibModalInstance.close();
    });
  };

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('ExpireOperatorModalController', ExpireOperatorModalController);

/***/ }),

/***/ "./components/shop/operators/expire/expire-operator-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=expireOperatorForm ng-submit=\"expireOperatorForm.$valid && $ctrl.expireOperator($ctrl.operator)\" novalidate> <div class=modal-header> <h4 class=modal-title>Remove {{$ctrl.operator.first_name}} from your shop?</h4> </div> <div class=\"modal-body background-light center\"> <ink-profile-photo profile=$ctrl.operator image-id=$ctrl.operator.profile_photo></ink-profile-photo> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Remove</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/shop/operators/expire/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/operators/expire/expire-operator-modal.controller.js");

/***/ }),

/***/ "./components/shop/operators/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/operators/add/index.js");

__webpack_require__("./components/shop/operators/expire/index.js");

__webpack_require__("./components/shop/operators/notification-prefs/index.js");

__webpack_require__("./components/shop/operators/update/index.js");

__webpack_require__("./components/shop/operators/cancel-invite-modal.controller.js");

__webpack_require__("./components/shop/operators/shop-operators.component.js");

__webpack_require__("./components/shop/operators/shop-operators.controller.js");

__webpack_require__("./components/shop/operators/shop-operators.service.js");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.shop.operators', {
    url: '/operators',
    views: {
      shop: {
        component: 'inkShopOperators'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Shop operators';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/shop/operators/notification-prefs/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/operators/notification-prefs/operator-notification-prefs.service.js");

/***/ }),

/***/ "./components/shop/operators/notification-prefs/operator-notification-prefs.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


OperatorNotificationPrefs.$inject = ['$http', 'ENDPOINT', 'Session', 'moment', 'AlertMessages', '_'];


/**
 * @name OperatorNotificationPrefs
 * @description The OperatorNotificationPrefs service
 * @param {library} $http Angular $http
 * @param {constant} ENDPOINT The ENDPOINT constant
 * @param {service} Session The Session service
 * @param {library} moment The moment library
 * @param {service} AlertMessages The AlertMessages service
 * @param {library} _ The lodash library
 * @return {service} Returns the service
 */
function OperatorNotificationPrefs($http, ENDPOINT, Session, moment, AlertMessages, _) {
  // Public Functions
  OperatorNotificationPrefs.get = get;
  OperatorNotificationPrefs.create = create;
  OperatorNotificationPrefs.update = update;

  /**
   * @name getArtistPrefs
   * @description Function to retrieve artist notification preferences
   * @param {number} id The ID of the preferences to retrieve
   * @return {object} Returns the notification preferences objdect
   */
  function get(id) {
    return $http.get(ENDPOINT.server + 'collectors/api/v1.1/email/operator-preference/' + id + '/').then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name create
   * @description Function to create notification preferences for artists
   * @return {object} Returns the notification preferences objdect
   */
  function create() {
    var associationId = Session.activeState.association.id;
    return $http.post(ENDPOINT.server + 'collectors/api/v1.1/email/operator-preference/', associationId).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }

  /**
   * @name update
   * @description Function to update notification preferences for artists
   * @param {number} id The ID of the notification preferences to update
   * @param {object} notPrefs The notification preferences to update
   * @return {object} Returns the updated notification preferences
   */
  function update(id, notPrefs) {
    return $http.put(ENDPOINT.server + 'collectors/api/v1.1/email/operator-preference/' + id + '/', notPrefs).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
      throw error;
    });
  }
  return OperatorNotificationPrefs;
}

angular.module('inkfinder').factory('OperatorNotificationPrefs', OperatorNotificationPrefs);

/***/ }),

/***/ "./components/shop/operators/shop-operators.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkShopOperators = {
  controller: 'ShopOperatorsController',
  template: __webpack_require__("./components/shop/operators/shop-operators.template.html")
};

angular.module('inkfinder').component('inkShopOperators', inkShopOperators);

/***/ }),

/***/ "./components/shop/operators/shop-operators.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ShopOperatorsController.$inject = ['Operators', 'Session', 'Association', '$uibModal', 'AlertMessages', 'RESPONSE_MESSAGES'];
/**
 * @name ShopOperatorsController
 * @description Controller for shop operators
 * @param {service} Operators The operators service
 * @param {service} Session The session service
 * @param {service} Association The associations service
 * @param {service} $uibModal The $uibModal service from UI Bootstrap
 * @param {service} AlertMessages The alert messages service
 * @param {service} RESPONSE_MESSAGES The response messages constant
 */
function ShopOperatorsController(Operators, Session, Association, $uibModal, AlertMessages, RESPONSE_MESSAGES) {
  var vm = this;
  vm.$onInit = function () {
    vm.cancelInvite = cancelInvite;
    vm.updateOperatorAssociation = updateOperatorAssociation;
    vm.expireOperatorAssociation = expireOperatorAssociation;
    vm.shop = Session.activeState.association.shop;
    vm.session = Session;
    getOperators(vm.shop.id);
  };

  /**
   * @name getOperators
   * @description Get shop operators
   * @param {number} shopId The ID of the shop
   */
  function getOperators(shopId) {
    Operators.getAllForShop(shopId).then(function (operators) {
      vm.operators = operators;
    });
  }

  /**
   * @name cancelInvite
   * @description Function to cancel the invite of a collector
   * @param {object} operator The collector to cancel
   */
  function cancelInvite(_operator) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/shop/operators/cancel-invite-modal.template.html"),
      animation: true,
      controller: 'CancelInviteModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        operator: function operator() {
          return _operator;
        }
      }
    });
    modalInstance.result.then(function () {
      getOperators(vm.shop.id);
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name expireOperatorAssociation
   * @description Function to change association status to expired
   * @param {object} operator The collector to cancel
   */
  function expireOperatorAssociation(_operator2) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/shop/operators/expire/expire-operator-modal.template.html"),
      animation: true,
      controller: 'ExpireOperatorModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        operator: function operator() {
          return _operator2;
        }
      }
    });
    modalInstance.result.then(function () {
      getOperators(vm.shop.id);
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }

  /**
   * @name updateOperatorAssociation
   * @description Function to change association status to expired
   * @param {object} operator The collector to cancel
   */
  function updateOperatorAssociation(_operator3) {
    var modalInstance = $uibModal.open({
      template: __webpack_require__("./components/shop/operators/update/update-operator-modal.template.html"),
      animation: true,
      controller: 'UpdateOperatorModalController',
      bindToController: true,
      controllerAs: '$ctrl',
      resolve: {
        operator: function operator() {
          return _operator3;
        }
      }
    });
    modalInstance.result.then(function () {
      getOperators(vm.shop.id);
    }, function () {
      AlertMessages.add({
        msg: RESPONSE_MESSAGES.closedWithoutSaving,
        type: 'warning'
      });
    });
  }
}

angular.module('inkfinder').controller('ShopOperatorsController', ShopOperatorsController);

/***/ }),

/***/ "./components/shop/operators/shop-operators.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Operators', ['$q', '$http', 'ENDPOINT', 'Association', 'Session', 'AlertMessages', function Operators($q, $http, ENDPOINT, Association, Session, AlertMessages) {
  // Public Methods
  Operators.update = update;
  Operators.getAllForShop = getAllForShop;
  Operators.get = get;
  Operators.create = create;

  /**
   * @name getOperators
   * @description Get all operators
   * @param {number} shopId The ID of the shop
   * @return {promise} Returns a promise object
   */
  function getAllForShop(shopId) {
    return $q(function (resolve, reject) {
      Association.getShopAssociations(shopId, 'operator', 'operator').then(function (collectors) {
        resolve(collectors.operators);
      }, function (error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
        reject(error);
      });
    });
  }

  /**
   * @name get
   * @description Get an operator
   * @param {unknown} id The Id of the operator to retrieve.
   * @return {promise} Returns a promise object
   */
  function get(id) {
    return $q(function (resolve, reject) {
      var url = ENDPOINT.server + 'operators/api/v1.1/' + id + '/?association_id=' + Session.activeState.association.id;
      return $http.get(url).then(function (response) {
        resolve(response.data);
      }, function (error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
        reject(error);
      });
    });
  }

  /**
   * @name create
   * @description Create an operator
   * @param {object} input The data for the new operator
   * @return {promise} Returns a promist object of the new operator
   */
  function create(input) {
    return $http.post(ENDPOINT.server + 'operators/api/v1.1/', input).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name update
   * @description Update the operator
   * @param {object} operator The updated operator data
   * @return {promise} Returns a promise object of the udpated operator
   */
  function update(operator) {
    operator.association_id = Session.activeState.association.id;
    operator.type = Session.activeState.role;
    return $http.put(ENDPOINT.server + 'operators/api/v1.1/' + operator.id + '/', operator).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Operators;
}]);

/***/ }),

/***/ "./components/shop/operators/shop-operators.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=row> <div class=\"col-sm-8 col-sm-offset-2 center\"> <h4>Your operators</h4> <p> <ng-pluralize count=$ctrl.operators.confirmed.length when=\"{'0': 'Feels a little lonely in here, huh?',\n        'one': 'You have one operator. That lucky ducky.',\n        'other': 'You have {} operators on staff. Nice!'}\"> </ng-pluralize> </p> <div class=row> <div class=col-sm-12> <div class=button-container> <button class=\"button large finder-solid\" ui-sref=inkfinder.shop.add.operator-search-add> Add an operator </button> </div> <div class=\"divider small tight transparent\"></div> </div> </div> </div> </div> <div class=row> <div class=\"cards profiles\"> <div class=\"row flex-container flex-wrap\"> <div class=\"col-sm-6 col-md-4 col-lg-3 card profile link flex\" ng-repeat=\"operator in $ctrl.operators.confirmed | orderBy: 'operator.last_name' track by operator.id\" ng-class=\"{'expire': operator.expireToggle}\"> <div class=profile-container> <div ng-if=\"($ctrl.session.activeState.association.operatorAdmin || $ctrl.session.activeState.association.operatorOwner) && $ctrl.session.activeState.association.type === 'operator'\"> <a ng-if=$ctrl.session.activeState.association.operatorOwner ng-click=$ctrl.updateOperatorAssociation(operator) class=profile-container__edit> <fa name=pencil></fa> </a> <a ng-click=$ctrl.expireOperatorAssociation(operator) class=profile-container__expire> <fa name=trash></fa> </a> </div> <ink-profile-photo profile=operator image-id=operator.profile_photo size=\"'xxlarge'\" show-name=false> </ink-profile-photo> <p class=profile-container__name>{{operator.first_name}} {{operator.last_name}}</p> <div class=profile-details-container> <div class=row> <div class=\"col-xs-6 col-sm-12\"> <div class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <fa name=exclamation-triangle fw class=alert-color ng-if=!operator.email_is_confirmed tooltip-append-to-body=true uib-tooltip=\"Email not verified\" tooltip-placement=top tooltip-class=light></fa> <a href=mailto:{{operator.email}}> <fa name=envelope fw size=1></fa> {{operator.email}} </a> </small> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <a href=tel:{{operator.phone}} ng-if=operator.phone> <fa name=phone fw size=1></fa> <span>{{operator.phone | tel}}</span> </a> <span ng-if=!operator.phone> <fa name=phone fw size=1></fa> No phone listed </span> </small> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <fa name=calendar-o fw size=1></fa> {{operator.association.startDatetime | amDateFormat:'MM/DD/YY'}} – <span ng-if=\"operator.association.endDatetime !== null\"> {{operator.association.endDatetime | amDateFormat:'MM/DD/YY'}} </span> <span ng-if=\"operator.association.endDatetime === null\"> No end </span> </small> </div> </div> <div class=\"col-xs-6 col-sm-12\"> <div class=\"profile-detail__item profile-detail--less-margin left\"> <small class=profile-container__contact-item> <span ng-if=operator.association.operatorOwner> <fa name=university fw size=1></fa> Shop owner </span> <span ng-if=\"!operator.association.operatorOwner && operator.association.operatorAdmin\"> <fa name=trophy fw size=1></fa> Shop admin </span> </small> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=row ng-if=\"$ctrl.operators.invited.length > 0\"> <div class=col-md-12> <h4>Invited operators</h4> <div class=\"list profiles\"> <div class=\"row item profile invited\" ng-class-odd=\"'odd'\" ng-repeat=\"operator in $ctrl.operators.invited\"> <div class=\"profile col-md-2 col-sm-2 col-xs-3\"> <ink-profile-photo show-name=false profile=operator image-id=operator.profile_photo></ink-profile-photo> </div> <div class=\"name col-md-3 col-sm-3 col-xs-5\"> <label>Name</label> <p><small>{{operator.first_name}} {{operator.last_name}}</small></p> </div> <div class=\"invite-details col-md-3 col-sm-2 col-xs-4\"> <label>Invited</label> <p><small>{{operator.association.startDatetime | amDateFormat: 'M/D/YY'}}</small></p> </div> <div class=\"clearfix visible-xs visible-sm\"></div> <div class=\"actions col-md-2 col-sm-6 col-xs-6\"> <button class=\"button small gray\" ng-click=$ctrl.cancelInvite(operator)>Cancel invite</button> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/shop/operators/update/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/operators/update/update-operator-modal.controller.js");

/***/ }),

/***/ "./components/shop/operators/update/update-operator-modal.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


UpdateOperatorModalController.$inject = ['$uibModalInstance', 'Association', 'operator'];
/**
 * @name UpdateOperatorModalController
 * @description Function to update artist associations with a shop
 * @param {unknown} $uibModalInstance UI Bootstrap image modal instance
 * @param {unknown} Association The association service
 * @param {unknown} operator Resolved operator from the operator controller
 */
function UpdateOperatorModalController($uibModalInstance, Association, operator) {
  var vm = this;
  vm.operator = operator;
  vm.updateArtist = updateOperator;

  /**
   * @name updateOperator
   * @description Function to update the artist association
   * @param {object} operator The artist's collector object who's association you
   * want to update
   */
  function updateOperator(operator) {
    Association.update(operator.association).then(function () {
      $uibModalInstance.close();
    });
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss();
  };
}

angular.module('inkfinder').controller('UpdateOperatorModalController', UpdateOperatorModalController);

/***/ }),

/***/ "./components/shop/operators/update/update-operator-modal.template.html":
/***/ (function(module, exports) {

module.exports = "<form name=updateArtistForm ng-submit=\"updateArtistForm.$valid && $ctrl.updateArtist($ctrl.operator)\" novalidate> <div class=modal-header> <h4 class=modal-title>Update your connection with <span ng-if=$ctrl.operator.first_name>{{$ctrl.operator.first_name}}</span><span ng-if=!$ctrl.operator.first_name>this artist</span></h4> </div> <div class=\"modal-body background-light center\"> <ink-profile-photo profile=$ctrl.operator image-id=$ctrl.operator.profile_photo></ink-profile-photo> <div class=\"divider small xtight transparent\"></div> <div class=left> <div class=form-group> <label> <input name=canUpdateAppts type=checkbox ng-model=$ctrl.operator.association.operatorAdmin> {{$ctrl.operator.first_name}} is an admin of this shop<br/> <small>Admins can add and remove other operators and artists and can edit artist connection settings</small> </label> </div> <div class=form-group> <label> <input name=canUpdateAppts type=checkbox ng-model=$ctrl.operator.association.operatorOwner> {{$ctrl.operator.first_name}} is an owner of this shop<br/> <small>Owners can make other operators owners and admins</small> </label> </div> </div> </div> <div class=modal-footer> <button class=\"button large shop-solid\" type=submit>Save</button> <button class=\"button large alert-btn\" type=reset ng-click=$ctrl.cancel()>Close</button> </div> </form> ";

/***/ }),

/***/ "./components/shop/payments/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/payments/shop-payments.component.js");

__webpack_require__("./components/shop/payments/shop-payments.controller.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.shop.payments', {
    url: '/payments',
    views: {
      shop: {
        component: 'inkShopPayments'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Shop payments';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/shop/payments/shop-payments.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkShopPayments = {
  controller: 'ShopPaymentsController',
  template: __webpack_require__("./components/shop/payments/shop-payments.template.html")
};

angular.module('inkfinder').component('inkShopPayments', inkShopPayments);

/***/ }),

/***/ "./components/shop/payments/shop-payments.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ShopPaymentsController.$inject = ['Shop', 'Session'];


/**
 * @name ShopPaymentsController
 * @description Controller for shop payments. This field is part of the shop
 * model.
 * @param {Unknown} Shop Shop service
 * @param {Unknown} Session Session service
 */
function ShopPaymentsController(Shop, Session) {
  var vm = this;

  vm.$onInit = function () {
    vm.updateShop = updateShop;
  };

  // Get the shop of the logged in operator
  var shop = Session.activeState.association.shop;

  // Get the shop profile
  Shop.get(shop.id).then(function (shop) {
    vm.shop = shop;
  });

  /**
   * @name update_shop
   * @description Function to call the shop service to update the shop
   * @param {object} shop The shop to update
   */
  function updateShop(shop) {
    Shop.update(shop).then(function (updatedShop) {
      vm.shop = updatedShop;
    });
  }
}

angular.module('inkfinder').controller('ShopPaymentsController', ShopPaymentsController);

/***/ }),

/***/ "./components/shop/payments/shop-payments.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"col-sm-8 col-sm-offset-2\"> <h4>Your shop settings</h4> <div class=\"divider small tight transparent\"></div> <form name=shopProfileForm ng-submit=\"shopProfileForm.$valid && $ctrl.updateShop($ctrl.shop)\" novalidate> <div class=form-group> <h6>Deposit payments</h6> <label for=depositUrl><p>Enter the URL where clients can pay deposits for appointments. Start with \"http://\"</p></label> <input name=depositUrl id=depositUrl type=url ng-model=$ctrl.shop.deposit_payment_URL> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"shopProfileForm.depositUrl.$invalid && !shopProfileForm.depositUrl.$pristine\"> Hmm...I don’t think that’s a real URL. </p> </div> </div> <div class=form-group> <h6>Collector appointment confirmation</h6> <input name=collectorCanConfirmAppts title=collectorCanConfirmAppts id=collectorCanConfirmAppts type=checkbox ng-model=$ctrl.shop.collector_can_confirm_appt> <label for=collectorCanConfirmAppts>Collectors can confirm their unconfirmed appointments</label> <p>This allows a collector to confirm their unconfirmed appointments through Ink Finder.</p> </div> <div class=\"divider small tight transparent\"></div> <div class=button-container> <div> <button class=\"button large shop-solid\" ng-disabled=shopProfileForm.$invalid>Save</button> </div> </div> </form> </div> ";

/***/ }),

/***/ "./components/shop/profile/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/profile/shop-profile.component.js");

__webpack_require__("./components/shop/profile/shop-profile.controller.js");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.shop.profile', {
    url: '/profile',
    views: {
      shop: {
        component: 'inkShopProfile'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Your shop';
      }
    }
  });
}]);

/***/ }),

/***/ "./components/shop/profile/shop-profile.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkShopProfile = {
  controller: 'ShopProfileController',
  template: __webpack_require__("./components/shop/profile/shop-profile.template.html")
};

angular.module('inkfinder').component('inkShopProfile', inkShopProfile);

/***/ }),

/***/ "./components/shop/profile/shop-profile.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formatGmaddressFields = __webpack_require__("./utils/format-gmaddress-fields.js");

var _formatGmaddressFields2 = _interopRequireDefault(_formatGmaddressFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ShopProfileController.$inject = ['Shop', 'ScheduleUtilFactory', 'Session', 'CheckUsername', 'AlertMessages', 'GMAPS_KEY', '$log', 'NgMap', 'Upload', 'ENDPOINT', 'InkImage', '$cookies', '_'];


/**
 * @name ShopProfileController
 * @description Controller called to displa and manage appointment details.
 * @param {Unknown} Shop Shop service
 * @param {Unknown} ScheduleUtilFactory Schedule service
 * @param {Unknown} Session Session service
 * @param {Unknown} CheckUsername CheckUsername service
 * @param {Unknown} AlertMessages AlertMessages service
 * @param {Unknown} GMAPS_KEY Google maps key constant
 * @param {Unknown} $log Angular log service
 * @param {Unknown} NgMap NgMap library
 * @param {service} Upload The Upload service from the ng-file-upload library
 * @param {string} ENDPOINT The endpoint constant
 * @param {service} InkImage The image servce
 * @param {service} $cookies Angular cookies service
  @param {library} _ The Lodash library
 */
function ShopProfileController(Shop, ScheduleUtilFactory, Session, CheckUsername, AlertMessages, GMAPS_KEY, $log, NgMap, Upload, ENDPOINT, InkImage, $cookies, _) {
  var vm = this;

  vm.$onInit = function () {
    vm.googleMapsUrl = 'https://maps.googleapis.com/maps/api/js?&libraries=places&key=' + GMAPS_KEY;
    vm.placeChanged = placeChanged;
    vm.checkUsername = checkUsername;
    vm.updateShop = updateShop;
    vm.updateProfileLogo = updateProfileLogo;
    vm.uploadFullLogo = uploadFullLogo;
    vm.remove = remove;
  };

  // Get the shop of the logged in operator
  var shop = Session.activeState.association.shop;

  // Get the shop profile
  Shop.get(shop.id).then(function (shop) {
    vm.shop = shop;
    vm.gmaddressTmp = vm.shop.gmaddress;
    vm.currentShopUsername = _.cloneDeep(shop.username);
    if (vm.shop.full_logo) {
      InkImage.get(vm.shop.full_logo).then(function (fullLogo) {
        vm.fullLogo = fullLogo;
      });
    }
    NgMap.getMap().then(function (map) {
      vm.map = map;
      vm.map.setCenter({
        lat: Number(vm.shop.lat),
        lng: Number(vm.shop.lng)
      });
    });
  });

  /**
   * @name placeChanged
   * @description Google maps autocomplete
   */
  function placeChanged() {
    vm.place = this.getPlace(); // Use of 'this' is based on the library
    (0, _formatGmaddressFields2.default)(vm.place.address_components).then(function (addressFields) {
      Object.assign(vm.shop, addressFields);
    });

    vm.shop.gmaddress = vm.place.formatted_address;
    vm.gmaddressTmp = vm.place.formatted_address;
    vm.shop.lat = vm.place.geometry.location.lat();
    vm.shop.lng = vm.place.geometry.location.lng();
    vm.shop.gmaddress_url = vm.place.url;
    vm.map.setCenter(vm.place.geometry.location);
  }

  /**
   * @name checkUsername
   * @description Function to check it a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username, vm.currentShopUsername).then(function (results) {
      vm.usernameResults = results;
    });
  }

  /**
   * @name update_shop
   * @description Function to call the shop service to update the shop
   * @param {object} shop The shop to update
   */
  function updateShop(shop) {
    Shop.update(shop).then(function (updatedShop) {
      vm.shop = updatedShop;
    });
  }

  /**
   * @name updateProfileLogo
   * @description Function to update the shop profile logo
   * @param {number} imageId The ID of the new profile logo
   */
  function updateProfileLogo(imageId) {
    vm.shop.profile_logo = imageId;
    Shop.update(vm.shop).then(function (updatedShop) {
      vm.shop = updatedShop;
      var updateAssociationShop = {
        id: updatedShop.id,
        name: updatedShop.name,
        profile_logo: updatedShop.profile_logo
      };
      Session.activeState.association.shop = updateAssociationShop;
      $cookies.putObject('inkfinder', Session.activeState);
    });
  }

  /**
   * @name updateFullLogo
   * @description Function to update the shop full logo
   * @param {number} imageId The ID of the new full logo
   */
  function updateFullLogo(imageId) {
    vm.shop.full_logo = imageId;
    Shop.update(vm.shop).then(function (updatedShop) {
      vm.shop = updatedShop;
      if (vm.shop.full_logo) {
        InkImage.get(vm.shop.full_logo).then(function (fullLogo) {
          vm.fullLogo = fullLogo;
        });
      }
    });
  }

  /**
   * @name uploadFullLogo
   * @description Function to upload the shop full logo
   * @param {file} file The file to upload
   * @param {array} errFiles Errors array
   */
  function uploadFullLogo(file, errFiles) {
    vm.f = file;
    vm.errFile = errFiles && errFiles[0];
    if (file) {
      file.upload = Upload.upload({
        url: ENDPOINT.server + 'inkutils/api/v1.1/image/',
        data: { file: file }
      });
      file.upload.then(function (response) {
        file.result = response.data;
        updateFullLogo(file.result.id);
      }, function (response) {
        if (response.status > 0) {
          vm.errorMsg = response.status + ': ' + response.data;
        }
      }, function (evt) {
        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total, 10));
      });
    }
  }

  /**
   * @name remove
   * @description Function to remove the profile image
   * @param {number} imageId The image to remove
   */
  function remove(imageId) {
    var file = '';
    InkImage.remove(imageId, file).then(function (image) {
      vm.fullLogo.image = null;
      vm.shop.full_logo = '';
      updateFullLogo(vm.shop.full_logo);
    });
  }
}

angular.module('inkfinder').controller('ShopProfileController', ShopProfileController);

/***/ }),

/***/ "./components/shop/profile/shop-profile.template.html":
/***/ (function(module, exports) {

module.exports = " <div class=\"content-inner col-sm-8 col-sm-offset-2\"> <h4>Shop logos</h4> <div class=\"divider small loose transparent\"></div> <div class=form-group> <div class=row> <div class=\"col-sm-6 tight-margin-bottom\"> <label>Full logo</label> <uib-progressbar ng-if=\"$ctrl.f.progress < 100\" class=\"progress-striped active\" value=$ctrl.f.progress></uib-progressbar> <div ng-if=!$ctrl.shop.full_logo class=\"button-container margin\"> <button class=\"button medium gray\" ngf-select=\"$ctrl.uploadFullLogo($file, $invalidFiles)\" accept=image/* ngf-max-size=5MB> Upload </button> </div> <div ng-if=$ctrl.shop.full_logo uib-dropdown on-toggle=toggled(open)> <div ng-if=$ctrl.fullLogo.image uib-dropdown-toggle> <img ng-src={{$ctrl.fullLogo.image}} title=\"Full shop logo\"> </div> <ul class=dropdown-menu uib-dropdown-menu aria-labelledby=edit-menu> <li> <a ngf-select=\"$ctrl.uploadFullLogo($file, $invalidFiles)\" accept=image/* ngf-max-size=5MB> Upload image </a> </li> <li ng-if=$ctrl.fullLogo.image> <a ng-click=$ctrl.remove($ctrl.shop.full_logo)>Remove</a> </li> <li> <a uib-dropdown-toggle>Cancel</a> </li> </ul> </div> </div> <div class=\"col-sm-6 tight-margin-bottom\"> <label>Profile logo</label> <ink-profile-photo image-id=$ctrl.shop.profile_logo editable=true linkable=true on-change=$ctrl.updateProfileLogo(imageId) type=\"'shop'\"> </ink-profile-photo> </div> </div> </div> <h4>Shop profile</h4> <div class=\"divider small xtight\"></div> <form name=shopProfileForm ng-submit=\"shopProfileForm.$valid && $ctrl.updateShop($ctrl.shop)\" novalidate> <div class=form-group> <label for=username>Shop username</label> <input name=username id=username type=text ng-model=$ctrl.shop.username ng-pattern=/^[a-z0-9]*$/ ng-trim=false ng-model-options=\"{updateOn: 'default blur', debounce: {'default': 500, 'blur': 0}}\" ng-change=$ctrl.checkUsername($ctrl.shop.username)> <div class=\"inline-message relative\"> <p class=\"message error absolute\"> <span ng-if=\"!shopProfileForm.username.$invalid && $ctrl.usernameResults.usernameValid !== null\" ng-class=\"{\n          'shop-color': $ctrl.usernameResults.usernameValid === true,\n          'alert-color': $ctrl.usernameResults.usernameValid === false}\"> {{$ctrl.usernameResults.usernameCheckMessage}} </span> <span ng-if=\"shopProfileForm.username.$invalid && !shopProfileForm.username.$pristine\" class=alert-color> Use lowercase letters and numbers only </span> </p> </div> <div class=inline-alert ng-show=\"$ctrl.shop.username && $ctrl.usernameResults.usernameValid\"> <p><small>Your shop profile URL is <strong>http://inkfinder.tattoo/{{$ctrl.shop.username}}</strong></small></p> </div> </div> <div class=form-group> <label for=name>Shop name</label> <input name=name id=name type=text required ng-model=$ctrl.shop.name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"shopProfileForm.name.$invalid && !shopProfileForm.name.$pristine\"> Please enter your shop name. </p> </div> </div> <div class=form-group> <label for=name>Shop description</label> <textarea msd-elastic=\\n name=name id=name ng-model=$ctrl.shop.description class=textarea placeholder=\"Describe your shop...\">\n      </textarea> </div> <div class=form-group map-lazy-load=http://maps.google.com/maps/api/js map-lazy-load-params={{$ctrl.googleMapsUrl}}> <label for=address>Shop address</label> <input type=text places-auto-complete type=\"'establishment'\" on-place-changed=$ctrl.placeChanged() placeholder=\"Enter a location\" autocomplete=off ng-model=$ctrl.gmaddressTmp required> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"shopProfileForm.gmaddressTmp.$invalid && !shopProfileForm.gmaddressTmp.$pristine\"> Please enter your shop address. </p> </div> <ng-map default-style=false class=address-map> <marker position={{$ctrl.shop.gmaddress}}></marker> </ng-map> <div class=inline-alert ng-show=$ctrl.place> <p><small>Your shop is located at {{$ctrl.place.formatted_address}}</small></p> </div> </div> <div class=form-group> <label for=email>Shop email</label> <input name=email id=email type=email ng-model=$ctrl.shop.email> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"shopProfileForm.email.$invalid && !shopProfileForm.email.$pristine\"> Hmm...I don’t think that’s a real email address. </p> </div> </div> <div class=form-group> <label for=phone>Shop phone</label> <input name=phone id=phone type=text mask=\"(999) 999-9999\" clean=true required ng-model=$ctrl.shop.phone> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"shopProfileForm.phone.$invalid && !shopProfileForm.phone.$pristine\"> Please enter your shop phone. </p> </div> </div> <div class=form-group> <label for=url>Shop website URL</label> <input name=url id=url type=text ng-model=$ctrl.shop.url pattern=^(https?://)?([a-zA-Z0-9]([a-zA-ZäöüÄÖÜ0-9\\-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,6}$ placeholder=http://www.example.com> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"shopProfileForm.url.$invalid && !shopProfileForm.url.$pristine\"> Hmm...I don’t think that’s a real URL. </p> </div> </div> <div class=\"button-container margin\"> <div> <button class=\"button large shop-solid\" ng-disabled=shopProfileForm.$invalid>Save changes</button> </div> </div> </form> </div> ";

/***/ }),

/***/ "./components/shop/shop.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('Shop', ['$q', '$http', '$interval', '$rootScope', 'ENDPOINT', 'ScheduleUtilFactory', 'moment', 'AlertMessages', 'Session', '_', function Shop($q, $http, $interval, $rootScope, ENDPOINT, ScheduleUtilFactory, moment, AlertMessages, Session, _) {
  Shop.get = get;
  Shop.getShops = getShops;
  Shop.update = update;
  Shop.add = add;

  /**
   * @name add
   * @description Add a shop
   * @param {object} input The shop to add
   * @return {object} Returns the new shop
   */
  function add(input) {
    return $http.post(ENDPOINT.server + 'shops/api/v1.1/', input).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name get
   * @description Get shop profile
   * @param {number} id The Id of the shop
   * @return {object} Returns a promise object of the shop.
   */
  function get(id) {
    var url = ENDPOINT.server + 'shops/api/v1.1/' + id + '/';
    if (!_.isUndefined(Session.activeState.association)) {
      url += '?association_id=' + Session.activeState.association.id;
    }
    return $http.get(url).then(function (response) {
      Shop.shop = response.data;
      return Shop.shop;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name getShops
   * @description Function to get an array of shops based on URL params
   * @param {number} username The username to filter by
   * @return {array} Returns an array of shops
   */
  function getShops(username) {
    var url = ENDPOINT.server + 'shops/api/v1.1/';
    if (!_.isUndefined(username)) {
      url += '?username=' + username;
    }
    return $http.get(url).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
  * @name update
  * @description Function to update the shop profile
  * @param {object} shop The shop to update
  * @return {object} Returns the udpated shop object
  */
  function update(shop) {
    shop.association_id = Session.activeState.association.id;
    return $http.put(ENDPOINT.server + 'shops/api/v1.1/' + shop.id + '/', shop).then(function (response) {
      AlertMessages.add({
        msg: 'Your shop profile has been saved.',
        type: 'success'
      });
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Shop;
}]);

/***/ }),

/***/ "./components/shop/util/get-appointment.shop.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('GetAppointmentShop', ['Shop', '$q', '_', function GetAppointmentShop(Shop, $q, _) {
  // Public methods
  GetAppointmentShop.get = get;
  /**
   * @name get
   * @description Function to get and set the shop object on appointments.
   * @param {array} collection The collection of appointments containing shop
   * IDs.
   * @return {array} appointmentsWithShops Returns the grouped collection.
   */
  function get(collection) {
    if (_.isArray(collection)) {
      var promises = [];
      _.each(collection, function (appointment) {
        var promise = Shop.get(appointment.shop);
        promises.push(promise);
      });
      return $q.all(promises);
    }
    return Shop.get(collection.shop);
  }
  return GetAppointmentShop;
}]);

/***/ }),

/***/ "./components/shop/util/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/shop/util/get-appointment.shop.js");

/***/ }),

/***/ "./components/signup/_signup.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508528
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/signup/collector/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/signup/collector/signup-collector.component.js");

__webpack_require__("./components/signup/collector/signup-collector.controller.js");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('signup.collector', {
    url: '/signup/collector',
    views: {
      '@': {
        component: 'inkSignupCollector'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Complete your personal profile';
      },
      as: ['$stateParams', '_', function as($stateParams, _) {
        if (_.isUndefined($stateParams.as)) {
          return 'collector';
        }
        return $stateParams.as;
      }]
    },
    data: {
      authorizedRoles: [USER_ROLES.collector]
    }
  });
}]);

/***/ }),

/***/ "./components/signup/collector/signup-collector.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkSignupCollector = {
  controller: 'SignupCollectorController',
  bindings: {
    as: '<'
  },
  template: __webpack_require__("./components/signup/collector/signup-collector.html")
};

angular.module('inkfinder').component('inkSignupCollector', inkSignupCollector);

/***/ }),

/***/ "./components/signup/collector/signup-collector.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SignupCollectorController.$inject = ['Session', 'ENDPOINT', 'CheckUsername', 'Collector', '_', '$log', '$state', 'DEFAULT_STATES'];


/**
 * @name SignupShopController
 * @description Controller for the sign up shop process
 * @param {unknown} Session The session service
 * @param {unknown} ENDPOINT The Endpoint constant
 * @param {unknown} CheckUsername The check username service
 * @param {unknown} Collector The collector service
 * @param {unknown} _ Lodash
 * @param {unknown} $log Angular $log service
 * @param {unknown} $state UI Router $state service
 * @param {unknown} DEFAULT_STATES The default states constant
 */
function SignupCollectorController(Session, ENDPOINT, CheckUsername, Collector, _, $log, $state, DEFAULT_STATES) {
  var vm = this;

  vm.$onInit = function () {
    $log.debug('As: ', vm.as);
    vm.collectorTmp = _.cloneDeep(Session.collector);
    vm.collectorTmp.is_new_user = false;
    vm.checkUsername = checkUsername;
    vm.updateCollector = updateCollector;
    vm.collectorTmp.profile_photo = null;
    vm.steps = [{
      id: 1,
      name: 'create-collector',
      title: 'Create your collector profile'
    }, {
      id: 2,
      name: 'update-collector',
      title: 'Complete your personal profile'
    }, {
      id: 3,
      name: 'create-shop',
      title: 'Create your shop profile'
    }];
    vm.activeStep = _.find(vm.steps, { name: 'update-collector' });
  };

  /**
   * @name checkUsername
   * @description Function to check it a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username).then(function (results) {
      vm.usernameResults = results;
    });
  }

  /**
   * @name updateCollector
   * @description Function to update the collector
   * @param {object} collector The data from the form.
   */
  function updateCollector(collector) {
    Collector.updateProfile(collector).then(function (updatedCollector) {
      var next = '';
      if (vm.as === 'collector') {
        next = DEFAULT_STATES.buying;
      } else {
        next = 'signup.' + vm.as;
      }
      $state.go(next);
    });
  }
}

angular.module('inkfinder').controller('SignupCollectorController', SignupCollectorController);

/***/ }),

/***/ "./components/signup/collector/signup-collector.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"signup-steptwo section first last background-dark\"> <div class=background-photo></div> <div class=container-fluid> <div class=row> <div class=\"col-sm-12 center\"> <h1>Complete your profile.</h1> </div> <div class=\"col-lg-6 col-lg-offset-3 col-sm-8 col-sm-offset-2\"> <ink-progress steps=$ctrl.steps active-step=$ctrl.activeStep description=false></ink-progress> <form name=signupCollectorForm ng-submit=\"signupCollectorForm.$valid && $ctrl.updateCollector($ctrl.collectorTmp)\" novalidate> <div class=center> <div class=margin> <ink-profile-photo linkable=true editable=true on-change=\"$ctrl.collectorTmp.profile_photo = imageId\"> </ink-profile-photo> <small ng-if=!$ctrl.collectorTmp.profile_photo>Add a profile photo</small> <small ng-if=$ctrl.collectorTmp.profile_photo>Hey, good lookin’</small> </div> </div> <div class=form-group> <label for=username>Username <small>Optional</small></label> <input name=username id=username type=text class=form-control placeholder=darthvader ng-pattern=/^[a-z0-9]*$/ ng-trim=false ng-model=$ctrl.collectorTmp.username ng-model-options=\"{updateOn: 'default blur', debounce: {'default': 500, 'blur': 0}}\" ng-change=$ctrl.checkUsername($ctrl.collectorTmp.username)> <div class=\"inline-message relative\"> <p class=\"message error absolute\"> <span ng-if=\"!profileForm.username.$invalid && $ctrl.usernameResults.usernameValid !== null\" ng-class=\"{'shop-color': $ctrl.usernameResults.usernameValid === true, 'alert-color': $ctrl.usernameResults.usernameValid === false}\"> {{$ctrl.usernameResults.usernameCheckMessage}} </span> <span ng-if=\"profileForm.username.$invalid && !profileForm.username.$pristine\" class=alert-color> Use lowercase letters and numbers only </span> </p> </div> </div> <div class=form-group> <label for=first_name>First name</label> <input name=first_name id=first_name type=text class=form-control placeholder=Seemore required ng-model=$ctrl.collectorTmp.first_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupCollectorForm.first_name.$invalid && !signupCollectorForm.first_name.$pristine\"> We need a first name! </p> </div> </div> <div class=form-group> <label for=last_name>Last name</label> <input name=last_name id=last_name type=text class=form-control placeholder=Butts required ng-model=$ctrl.collectorTmp.last_name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupCollectorForm.last_name.$invalid && !signupCollectorForm.last_name.$pristine\"> We need a last name! </p> </div> </div> <div class=form-group> <label for=email>Email</label> <input name=email id=email type=email class=form-control placeholder=seemore@butts.com required ng-model=$ctrl.collectorTmp.email> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupCollectorForm.email.$invalid && !signupCollectorForm.email.$pristine\"> Hmm...I don’t think that's a real email address. </p> </div> </div> <div class=form-group> <label for=phone>Phone <small>Optional</small></label> <input name=phone id=phone type=text class=form-control placeholder=\"(555) 555–1234\" mask=\"(999) 999-9999\" clean=true restrict=reject ng-model=$ctrl.collectorTmp.phone> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupCollectorForm.phone.$invalid && !signupCollectorForm.phone.$pristine\"> You won’t be talking to anyone with that number. </p> </div> </div> <div class=\"button-container margin\"> <button class=\"button large finder-solid\" type=submit ng-disabled=\"signupCollectorForm.$invalid || $ctrl.usernameResults.usernameValid === false\"> Complete profile </button> </div> </form> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/signup/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/signup/collector/index.js");

__webpack_require__("./components/signup/shop/index.js");

__webpack_require__("./components/signup/signup.component.js");

__webpack_require__("./components/signup/signup.controller.js");

__webpack_require__("./components/signup/_signup.styles.scss");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('signup', {
    url: '/signup?as',
    views: {
      '@': {
        component: 'inkSignup'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Signup for Ink Finder';
      },
      as: ['$stateParams', '_', function as($stateParams, _) {
        if (_.isUndefined($stateParams.as)) {
          return 'collector';
        }
        return $stateParams.as;
      }]
    }
  });
}]);

/***/ }),

/***/ "./components/signup/shop/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/signup/shop/signup.shop.component.js");

__webpack_require__("./components/signup/shop/signup.shop.controller.js");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('signup.operator', {
    url: '/signup/operator',
    views: {
      '@': {
        component: 'inkSignupShop'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Add your shop to the Ink Finder Shop Network';
      }
    },
    data: {
      authorizedRoles: [USER_ROLES.collector]
    }
  });
}]);

/***/ }),

/***/ "./components/signup/shop/signup.shop.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkSignupShop = {
  controller: 'SignupShopController',
  template: __webpack_require__("./components/signup/shop/template.signup.shop.html")
};

angular.module('inkfinder').component('inkSignupShop', inkSignupShop);

/***/ }),

/***/ "./components/signup/shop/signup.shop.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _formatGmaddressFields = __webpack_require__("./utils/format-gmaddress-fields.js");

var _formatGmaddressFields2 = _interopRequireDefault(_formatGmaddressFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

SignupShopController.$inject = ['Session', 'ENDPOINT', 'GMAPS_KEY', 'NgMap', 'CheckUsername', 'Shop', 'Operators', 'moment', 'Association', 'Auth', '$auth', '$rootScope', 'AUTH_EVENTS', 'Events', 'AlertMessages', 'Collector', '_', 'InkImage', 'Upload'];


/**
 * @name SignupShopController
 * @description Controller for the sign up shop process
 * @param {unknown} Session The session service
 * @param {unknown} ENDPOINT The Endpoint constant
 * @param {unknown} GMAPS_KEY The gmaps key constant
 * @param {unknown} NgMap The NgMap library for Google maps
 * @param {unknown} CheckUsername The check username service
 * @param {unknown} Shop The shop service
 * @param {unknown} Operators The operators service
 * @param {unknown} moment The moment library
 * @param {unknown} Association The associations service
 * @param {unknown} Auth The auth service
 * @param {unknown} $auth The satellizer $auth service
 * @param {unknown} $rootScope Angular $rootScope
 * @param {unknown} AUTH_EVENTS The auth events constant
 * @param {unknown} Events The events service
 * @param {unknown} AlertMessages The alert messages service
 * @param {unknown} Collector The collector service
 * @param {unknown} _ Lodash
 * @param {unknown} InkImage The image service
 * @param {unknown} Upload The upload library from ng-file-upload
 */
function SignupShopController(Session, ENDPOINT, GMAPS_KEY, NgMap, CheckUsername, Shop, Operators, moment, Association, Auth, $auth, $rootScope, AUTH_EVENTS, Events, AlertMessages, Collector, _, InkImage, Upload) {
  var vm = this;

  vm.$onInit = function () {
    vm.shopTmp = {};
    vm.googleMapsUrl = 'https://maps.googleapis.com/maps/api/js?&libraries=places&key=' + GMAPS_KEY;
    vm.placeChanged = placeChanged;
    vm.checkUsername = checkUsername;
    vm.createShop = createShop;
    vm.getFullLogo = getFullLogo;
    vm.remove = remove;
    vm.uploadFullLogo = uploadFullLogo;
    vm.createdShop = {};
    vm.createdAssociation = {};
    vm.steps = [{
      id: 1,
      name: 'create-collector',
      title: 'Create your collector profile'
    }, {
      id: 2,
      name: 'update-collector',
      title: 'Complete your personal profile'
    }, {
      id: 3,
      name: 'create-shop',
      title: 'Create your shop profile'
    }];
    vm.activeStep = _.find(vm.steps, { name: 'create-shop' });
  };

  /**
   * @name placeChanged
   * @description Google maps autocomplete
   */
  function placeChanged() {
    vm.place = this.getPlace(); // Use of 'this' is based on the library
    (0, _formatGmaddressFields2.default)(vm.place.address_components).then(function (addressFields) {
      Object.assign(vm.shopTmp, addressFields);
    });
    vm.shopTmp.gmaddress = vm.place.formatted_address;
    vm.gmaddressTmp = vm.place.formatted_address;
    vm.shopTmp.lat = vm.place.geometry.location.lat();
    vm.shopTmp.lng = vm.place.geometry.location.lng();
    vm.shopTmp.gmaddress_url = vm.place.url;
    vm.map.setCenter(vm.place.geometry.location);
  }

  NgMap.getMap().then(function (map) {
    vm.map = map;
  });

  /**
   * @name checkUsername
   * @description Function to check if a username exists when setting one
   * @param {string} username The username to check
   */
  function checkUsername(username) {
    CheckUsername.check(username, vm.currentShopUsername).then(function (results) {
      vm.usernameResults = results;
    });
  }

  /**
   * @name getFullLogo
   * @description Function to get the shop full logo
   * @param {number} imageId The ID of the new full logo
   */
  function getFullLogo(imageId) {
    InkImage.get(imageId).then(function (fullLogo) {
      vm.fullLogo = fullLogo;
    });
  }

  /**
   * @name uploadFullLogo
   * @description Function to upload the shop full logo
   * @param {file} file The file to upload
   * @param {array} errFiles Errors array
   */
  function uploadFullLogo(file, errFiles) {
    vm.f = file;
    vm.errFile = errFiles && errFiles[0];
    if (file) {
      file.upload = Upload.upload({
        url: ENDPOINT.server + 'inkutils/api/v1.1/image/',
        data: { file: file }
      });
      file.upload.then(function (response) {
        file.result = response.data;
        vm.shopTmp.full_logo = file.result.id;
        getFullLogo(file.result.id);
      }, function (response) {
        if (response.status > 0) {
          vm.errorMsg = response.status + ': ' + response.data;
        }
      }, function (evt) {
        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total, 10));
      });
    }
  }

  /**
   * @name remove
   * @description Function to remove the profile image
   * @param {number} imageId The image to remove
   */
  function remove(imageId) {
    var file = '';
    InkImage.remove(imageId, file).then(function (image) {
      vm.fullLogo.image = null;
      vm.shopTmp.full_logo = '';
    });
  }

  /**
   * @name createShop
   * @description Function to create a shop object. When this is run, an
   * operator and association is created and connected to the shop.
   * @param {object} shop The data from the form.
   */
  function createShop(shop) {
    Shop.add(shop).then(function (newShop) {
      vm.createdShop = newShop;
      var _collector = {
        collector_id: Session.collector.id,
        shop_id: vm.createdShop.id,
        role: 'Operator'
      };
      return Operators.create(_collector);
    }).then(function (updatedCollector) {
      vm.updatedCollector = updatedCollector;
      var type = 'Operator';
      var _association = {
        collector_id: updatedCollector.id,
        shop_id: vm.createdShop.id,
        status: 'Confirmed',
        startDatetime: moment().format(),
        operatorAdmin: true,
        operatorOwner: true,
        can_update_appts: true
      };
      return Association.createAssociation(type, _association);
    }).then(function (association) {
      vm.createdAssociation = association;
      return Collector.getCollector(vm.updatedCollector.id);
    }).then(function (_collector) {
      var roles = Auth.getRoles(_collector);
      Session.create($auth.getToken(), roles, _collector);
      return Collector.getCollector(vm.updatedCollector.id);
    }).then(function (_collector) {
      return Auth.setState(_collector);
    }).then(function () {
      $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
      Events.loggedIn = true;
      Auth.routeAfterAuthentication();
    }).catch(function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
}

angular.module('inkfinder').controller('SignupShopController', SignupShopController);

/***/ }),

/***/ "./components/signup/shop/template.signup.shop.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"signup-steptwo section first last background-dark\"> <div class=background-photo></div> <div class=container-fluid> <div class=row> <div class=\"col-sm-12 center\"> <h1>Add your shop.</h1> </div> <div class=\"col-lg-6 col-lg-offset-3 col-sm-8 col-sm-offset-2\"> <ink-progress steps=$ctrl.steps active-step=$ctrl.activeStep description=false></ink-progress> <form name=signupForm ng-submit=\"signupForm.$valid && $ctrl.createShop($ctrl.shopTmp)\" novalidate> <div class=form-group> <div class=row> <div class=col-sm-6> <label>Full logo</label> <uib-progressbar ng-if=\"$ctrl.f.progress < 100\" class=\"progress-striped active\" value=$ctrl.f.progress></uib-progressbar> <div ng-if=!$ctrl.shopTmp.full_logo class=\"button-container margin\"> <button class=\"button medium gray\" ngf-select=\"$ctrl.uploadFullLogo($file, $invalidFiles)\" accept=image/* ngf-max-size=5MB> Upload </button> </div> <div ng-if=$ctrl.shopTmp.full_logo uib-dropdown on-toggle=toggled(open)> <div ng-if=$ctrl.fullLogo.image uib-dropdown-toggle> <img ng-src={{$ctrl.fullLogo.image}}> </div> <ul class=dropdown-menu uib-dropdown-menu aria-labelledby=edit-menu> <li> <a ngf-select=\"$ctrl.uploadFullLogo($file, $invalidFiles)\" accept=image/* ngf-max-size=5MB> Upload image </a> </li> <li ng-if=$ctrl.fullLogo.image> <a ng-click=$ctrl.remove($ctrl.shopTmp.full_logo)>Remove</a> </li> <li> <a uib-dropdown-toggle>Cancel</a> </li> </ul> </div> </div> <div class=col-sm-6> <label>Profile logo</label> <ink-profile-photo image-id=$ctrl.shopTmp.profile_logo editable=true selectable=true on-change=\"$ctrl.shopTmp.profile_logo = imageId\" type=\"'shop'\"> </ink-profile-photo> </div> </div> </div> <div class=form-group> <label for=username>Shop username <small>Optional</small></label> <input name=username id=username type=text placeholder=inkshop ng-model=$ctrl.shopTmp.username ng-pattern=/^[a-z0-9]*$/ ng-trim=false ng-model-options=\"{updateOn: 'default blur', debounce: {'default': 500, 'blur': 0}}\" ng-change=$ctrl.checkUsername($ctrl.shopTmp.username)> <div class=\"inline-message relative\"> <p class=\"message error absolute\"> <span ng-if=\"!shopProfileForm.username.$invalid && $ctrl.usernameResults.usernameValid !== null\" ng-class=\"{\n                'shop-color': $ctrl.usernameResults.usernameValid === true,\n                'alert-color': $ctrl.usernameResults.usernameValid === false}\"> {{$ctrl.usernameResults.usernameCheckMessage}} </span> <span ng-if=\"shopProfileForm.username.$invalid && !shopProfileForm.username.$pristine\" class=alert-color> Use lowercase letters and numbers only </span> </p> </div> <div class=inline-alert ng-show=\"$ctrl.shopTmp.username && $ctrl.usernameResults.usernameValid\"> <p><small>Your shop profile URL is <strong>http://inkfinder.tattoo/{{$ctrl.shopTmp.username}}</strong></small></p> </div> </div> <div class=form-group> <label for=name>Shop name</label> <input name=name id=name type=text class=form-control placeholder=\"My awesome shop\" required ng-model=$ctrl.shopTmp.name ng-value=shop.name> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupForm.name.$invalid && !signupForm.name.$pristine\"> Please enter your shop name. </p> </div> </div> <div class=form-group> <label for=shopEmail>Shop email <small>Optional</small></label> <input name=shopEmail id=email type=email class=form-control placeholder=hello@myshop.com ng-model=$ctrl.shopTmp.email> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupForm.shopEmail.$invalid && !signupForm.shopEmail.$pristine\"> Hmm...I don’t think that's a real email address. </p> </div> </div> <div class=form-group> <label for=shopPhone>Shop phone</label> <input name=shopPhone id=phone type=text class=form-control placeholder=\"(555) 555–1234\" mask=\"(999) 999-9999\" clean=true restrict=reject required ng-model=$ctrl.shopTmp.phone> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupForm.shopPhone.$invalid && !signupForm.shopPhone.$pristine\"> You won’t be talking to anyone with that number. </p> </div> </div> <div class=form-group> <label for=name>Shop description</label> <textarea msd-elastic=\\n name=name id=name ng-model=$ctrl.shopTmp.description class=textarea placeholder=\"Describe your shop...\">\n            </textarea> </div> <div class=form-group map-lazy-load=http://maps.google.com/maps/api/js map-lazy-load-params={{$ctrl.googleMapsUrl}}> <label for=address>Shop address</label> <input type=text places-auto-complete type=\"'establishment'\" on-place-changed=$ctrl.placeChanged() placeholder=\"Enter a location\" autocomplete=off required ng-model=$ctrl.gmaddressTmp> <ng-map default-style=false class=address-map> <marker position={{$ctrl.shopTmp.gmaddress}}></marker> </ng-map> <div class=inline-alert ng-show=$ctrl.place> <p><small>Your shop is located at {{$ctrl.shopTmp.gmaddress}}</small></p> </div> </div> <div class=form-group> <label for=url>Shop website URL</label> <input name=url id=url type=text ng-model=$ctrl.shopTmp.url pattern=^(https?://)?([a-zA-Z0-9]([a-zA-ZäöüÄÖÜ0-9\\-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,6}$ placeholder=http://www.example.com> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupForm.url.$invalid && !signupForm.url.$pristine\"> Hmm...I don’t think that’s a real URL. </p> </div> </div> <div class=\"button-container margin\"> <button class=\"button large finder-solid\" type=submit ng-disabled=\"signupForm.$invalid || $ctrl.usernameResults.usernameValid === false\">Create my shop</button> </div> </form> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/signup/signup.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkSignup = {
  controller: 'SignupController',
  template: __webpack_require__("./components/signup/template.signup.html"),
  bindings: {
    as: '<'
  }
};

angular.module('inkfinder').component('inkSignup', inkSignup);

/***/ }),

/***/ "./components/signup/signup.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


SignupController.$inject = ['Auth', '$state', 'AlertMessages', '$cookies'];


/**
 * @description The function to create a new account and signup for Ink Finder
 * @param {object} Auth The service called to authenticate
 * @param {unknown} $state Service from ui-router
 * @param {unknown} AlertMessages Alerts service
 * @param {unknown} $cookies Angular cookies service
 */
function SignupController(Auth, $state, AlertMessages, $cookies) {
  var vm = this;
  vm.$onInit = function () {
    vm.signup = signup;
    vm.authenticate = authenticate;
    vm.required = false;
  };

  /**
   * @description Signup with Ink Finder username and password
   * @param {object} credentials The user object containing an email and password
   * @param {object} $state Unknown
   * TODO $stateParams.as; $stateParams or $state.params doesn't load in this
   * controller for some readon.
   */
  function signup(credentials) {
    $cookies.remove('inkfinder');
    Auth.signupInkFinder(credentials).then(function () {
      $state.go('signup.collector');
    }).catch(function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
    * @description Via Social API
    * @param {unknown} provider Unknown
    */
  function authenticate(provider) {
    $cookies.remove('inkfinder');
    Auth.loginSocial(provider).then(function () {
      var next = 'signup.' + $state.params.as;
      $state.go(next);
    }).catch(function (error) {
      AlertMessages.add({
        msg: error, // Errors from Satellizer
        type: 'danger'
      });
    });
  }
}

angular.module('inkfinder').controller('SignupController', SignupController);

/***/ }),

/***/ "./components/signup/template.signup.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"signup no-sidebar section first last background-dark\" ng-class=\"{'artist': $ctrl.as === 'artist', 'operator': $ctrl.as === 'operator'}\"> <div class=background-photo></div> <div class=region-header> <div class=container> <div class=row> <div class=\"col-sm-12 center\"> <span class=\"logo finder full-logo\"></span> </div> </div> </div> </div> <div class=container-fluid> <div class=row> <div class=\"col-sm-12 center\"> <div class=intro> <h1>Let’s do this!</h1> <h5 ng-if=\"$ctrl.as === 'operator'\">Add your shop to the Ink Finder Shop Network.</h5> <h5 ng-if=\"$ctrl.as === 'collector'\">Create art that fits your style.</h5> <h5 ng-if=\"$ctrl.as === 'artist'\">Join the Ink Finder Artist Network.</h5> </div> <div class=row> <div class=\"col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3 left\"> <form name=signupForm ng-submit=\"signupForm.$valid && $ctrl.signup($ctrl.user)\" novalidate> <div class=form-group> <label for=email>Email</label> <input name=email id=email type=email autocapitalize=off class=form-control required ng-model=$ctrl.user.email> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupForm.email.$invalid && !signupForm.email.$pristine\"> Hmm...I don’t think that's a real email address. </p> </div> </div> <div class=form-group> <label for=password>Password</label> <input name=password type=password class=form-control required ng-minlength=5 ng-model=$ctrl.user.password> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupForm.password.$invalid && !signupForm.password.$pristine\"> Your password needs to be at least 5 characters, yo. </p> </div> </div> <div class=form-group> <label for=password_confirm>Confirm password</label> <input name=password_confirm type=password class=form-control compare-to=$ctrl.user.password ng-model=$ctrl.user.password_confirm> <div class=\"inline-message relative\"> <p class=\"message error absolute animate fade-in fade-out\" ng-if=\"signupForm.password_confirm.$error.compareTo && !signupForm.password_confirm.$pristine\"> Your passwords don’t match, or they are too short. </p> </div> </div> <div class=form-group> <label> <input name=terms ng-model=$ctrl.required type=checkbox ng-required=!$ctrl.required> I agree to the Ink Finder <a href=https://inkfinder.tattoo/legal/terms-providers/ target=_blank>Provider Terms of Service</a>, <a href=https://inkfinder.tattoo/legal/terms-collectors/ target=_blank> Collector Terms of Service</a>, and <a href=https://inkfinder.tattoo/legal/privacy/ target=_blank>Privacy Policy</a>. </label> </div> <div class=\"button-container margin\"> <button class=\"button large finder-solid\" type=submit ng-disabled=signupForm.$invalid>Sign up</button> </div> </form> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./components/stats/_stats.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508482
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/stats/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/stats/stats.component.js");

__webpack_require__("./components/stats/stats.controller.js");

__webpack_require__("./components/stats/stats.service.js");

__webpack_require__("./components/stats/_stats.styles.scss");

/***/ }),

/***/ "./components/stats/stats.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkStatsShelf = {
  controller: 'StatsController',
  template: __webpack_require__("./components/stats/stats.template.html")
};

angular.module('inkfinder').component('inkStatsShelf', inkStatsShelf);

/***/ }),

/***/ "./components/stats/stats.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


StatsController.$inject = ['$scope', '$interval', 'Appointments', 'StatsFactory', 'Schedule', 'ShopGoals', 'ShopHours', 'ScheduleUtilFactory', 'Events', 'Session', '_'];
/**
 * @name StatsController
 * @description Controller for shop stats
 * @param {type} $scope Description
 * @param {type} $interval Description
 * @param {type} Appointments Description
 * @param {type} StatsFactory Description
 * @param {type} Schedule Description
 * @param {service} ShopGoals The ShopGoals service
 * @param {type} ShopHours Description
 * @param {type} ScheduleUtilFactory Description
 * @param {type} Events Description
 * @param {type} Session Description
 * @param {library} _ The Lodash library
 */
function StatsController($scope, $interval, Appointments, StatsFactory, Schedule, ShopGoals, ShopHours, ScheduleUtilFactory, Events, Session, _) {
  var vm = this;
  var statsTimer = void 0;

  vm.updateFilter = setIntervals;
  vm.intervalSelect = 'today';
  vm.period = '';
  vm.current = {};
  vm.updating = false;
  vm.adverb = '';
  vm.statsToggle = statsToggle;
  vm.events = Events;
  vm.session = Session;

  /**
   * @name statsToggle
   * @description Function to toggle the stats shelf open and closed
   */
  function statsToggle() {
    if (Events.statsOpen === false) {
      Events.statsOpen = true;
    } else {
      Events.statsOpen = false;
    }
  }
  setIntervals();
  statsTimer = $interval(update, 60000);

  // Called to Reset Data on Logout
  $scope.$on('clear-data', function () {
    $interval.cancel(statsTimer);
  });

  /**
   * @name update
   * @description Function to update stats.
   */
  function update() {
    vm.updating = true;
    if (Session.activeState.role === 'operator') {
      if (!_.isUndefined(Session.activeState.association)) {
        ShopHours.get(Session.activeState.association.shop.id).then(function (hours) {
          StatsFactory.shopHours = hours.all;
          StatsFactory.resetIntervalTimes();
          var start = StatsFactory.periodRange.start;
          var end = StatsFactory.periodRange.end;
          var search = false;
          var timestamp = null;

          Appointments.get(search, start, end, timestamp).then(function (appointments) {
            StatsFactory.appointments = appointments;
            Schedule.fetchSchedules().then(function (rules) {
              var allInstances = ScheduleUtilFactory.generateRuleInstances(rules, start, end);
              StatsFactory.schedules = ScheduleUtilFactory.filterExceptions(allInstances);

              ShopGoals.get().then(function (goals) {
                StatsFactory.goals = goals;
                StatsFactory.resetDataStats();
                StatsFactory.recalculateStats();
                vm.current = StatsFactory.currentPeriod;
                vm.updating = false;
              });
            });
          });
        });
      }
    }
  }

  /**
   * @name setIntervals
   * @description Function to set the intervals of the quick stats shelf.
   */
  function setIntervals() {
    vm.updating = true;

    var number = void 0;
    var interval = void 0;
    interval = vm.intervalSelect;

    if (interval.indexOf('week') >= 0) {
      vm.period = 'week';
    } else if (interval.indexOf('month') >= 0) {
      vm.period = 'month';
    } else if (interval.indexOf('quarter') >= 0) {
      vm.period = 'quarter';
    } else if (interval.indexOf('year') >= 0) {
      vm.period = 'year';
    } else {
      vm.period = 'day';
    }

    if (vm.period === 'day') {
      vm.adverb = 'daily';
    } else {
      vm.adverb = vm.period + 'ly';
    }

    if (interval.indexOf('this') >= 0 || interval.indexOf('today') >= 0) {
      number = 0;
    } else {
      number = 1;
    }
    if (vm.intervalSelect === 'today') {
      Events.statsDateRange = 'today';
    } else if (vm.intervalSelect === 'yesterday') {
      Events.statsDateRange = 'yesterday';
    } else if (vm.intervalSelect === 'this_week') {
      Events.statsDateRange = 'this week';
    } else if (vm.intervalSelect === 'this_month') {
      Events.statsDateRange = 'this month';
    } else if (vm.intervalSelect === 'this_quarter') {
      Events.statsDateRange = 'this quarter';
    } else if (vm.intervalSelect === 'this_year') {
      Events.statsDateRange = 'this year';
    } else if (vm.intervalSelect === 'last_week') {
      Events.statsDateRange = 'last week';
    } else if (vm.intervalSelect === 'last_month') {
      Events.statsDateRange = 'last month';
    } else if (vm.intervalSelect === 'last_quarter') {
      Events.statsDateRange = 'last quarter';
    } else if (vm.intervalSelect === 'last_year') {
      Events.statsDateRange = 'last year';
    }

    StatsFactory.resetIntervals(vm.period, number);
    update();
  }
}

angular.module('inkfinder').controller('StatsController', StatsController);

/***/ }),

/***/ "./components/stats/stats.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('StatsFactory', ['$rootScope', 'ScheduleUtilFactory', 'moment', '_', function StatsFactory($rootScope, ScheduleUtilFactory, moment, _) {
  StatsFactory.resetDataStats = resetDataStats;
  StatsFactory.resetIntervals = resetIntervals;
  StatsFactory.resetIntervalTimes = resetIntervalTimes;
  StatsFactory.recalculateStats = recalculateStats;

  resetVariables();

  /**
   * @name resetVariables
   */
  function resetVariables() {
    StatsFactory.artistStats = {};
    StatsFactory.periods = {};
    StatsFactory.periodRange = {};
    StatsFactory.currentPeriod = {};
    StatsFactory.appointments = [];
    StatsFactory.goals = [];
    StatsFactory.schedules = [];
    StatsFactory.shopHours = [];
  }

  // Called to Reset Data on Logout
  var deregister = $rootScope.$on('clear-data', function () {
    resetVariables();
  });
  $rootScope.$on('$destroy', deregister);

  /**
   * @name resetDataStats
   */
  function resetDataStats() {
    for (var periodKey in StatsFactory.periods) {
      if (Object.prototype.hasOwnProperty.call(StatsFactory.periods, periodKey)) {
        var period = StatsFactory.periods[periodKey];
        period.data = {
          appointments: [],
          hours: [],
          goals: [] };
        period.stats = {
          estimates: { goal_percent: 0 },
          revenue: { goal_percent: 0 } };
        period.change = {};
      }
    }
  }

  /**
   * @name resetIntervals
   * @param {unknown} timePeriod Unknown
   * @param {unknown} number Unknown
   */
  function resetIntervals(timePeriod, number) {
    var periods = StatsFactory.periods = {};

    for (var i = 0; i < 2; i++) {
      var dates = getDateInterval(timePeriod, number + i);
      var dateKey = dates.start.format('MM/DD/YYYY') + '-' + dates.end.format('MM/DD/YYYY');
      var prevDates = getDateInterval(timePeriod, number + i + 1);
      var prevDateKey = prevDates.start.format('MM/DD/YYYY') + '-' + prevDates.end.format('MM/DD/YYYY');
      var period = { calendarInterval: dates, relativeToCurrent: i, prev: prevDateKey };
      periods[dateKey] = period;
    }
  }

  /**
   * @name resetIntervalTimes
   */
  function resetIntervalTimes() {
    var periodRange = StatsFactory.periodRange = {};
    var periods = StatsFactory.periods;

    for (var periodKey in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKey)) {
        var period = periods[periodKey];
        var shopTimes = ScheduleUtilFactory.getShopTimes(StatsFactory.shopHours, period.calendarInterval.start, period.calendarInterval.end);
        period.interval = {
          start: shopTimes.earliest.start,
          end: shopTimes.latest.end
        };
        if (!periodRange.end || period.interval.end > periodRange.end) {
          periodRange.end = period.interval.end;
        }
        if (!periodRange.start || period.interval.start < periodRange.start) {
          periodRange.start = period.interval.start;
        }
      }
    }
  }

  /**
   * @name getDateInterval
   * @param {unknown} period Unknown
   * @param {unknown} number Unknown
   * @return {unknown} Unknown
   */
  function getDateInterval(period, number) {
    var firstDay = moment().startOf(period);

    if (number) {
      firstDay.subtract(number, period);
    }
    var lastDay = moment(firstDay).endOf(period);

    return { start: firstDay, end: lastDay };
  }

  /**
   * @name updateShopStats
   * @param {unknown} period Unknown
   */
  function updateShopStats(period) {
    var stats = period.stats = {};
    var data = period.data;
    var appointments = data.appointments;
    var hours = data.hours;
    var goals = data.goals;
    var artists = [];

    var revenueTotal = void 0;
    var estimates = void 0;
    var projectTotal = void 0;
    var scheduleSum = void 0;
    var appointmentDurationSum = void 0;
    var revenueGoal = void 0;
    revenueTotal = estimates = projectTotal = scheduleSum = appointmentDurationSum = revenueGoal = 0;
    for (var i = 0; i < appointments.length; i++) {
      var current = appointments[i];
      var status = current.last_status;

      if (status) {
        status = status.status_name;
      }

      if (status === 'Completed') {
        if (current.artist && artists.indexOf(current.artist.id) === -1) {
          artists.push(current.artist.id);
        }

        projectTotal++;
        revenueTotal += current.price;
      }
      if (status === 'Confirmed') {
        estimates += current.estimate_min + current.estimate_max;
      }
      if (status === 'Completed' || status === 'Confirmed') {
        appointmentDurationSum += current.duration;
      }
    }

    for (var currentPeriod = moment(period.interval.start); currentPeriod < period.interval.end; currentPeriod.add(1, 'day')) {
      var endOfDay = moment(currentPeriod).endOf('day');
      var latest = void 0;
      for (var a = 0; a < goals.length; a++) {
        var goal = goals[a];
        if (goal.start <= endOfDay && (!goal.end || goal.end > currentPeriod) && (!latest || latest.start < goal.start)) {
          latest = goal;
        }
      }

      if (latest) {
        revenueGoal += latest.weekly_revenue_goal / 7;
      }
    }

    for (var b = 0; b < hours.length; b++) {
      scheduleSum += hours[b].duration;
    }

    stats.goals = { revenue: revenueGoal };
    stats.appointments = projectTotal;
    stats.revenue = {
      total: revenueTotal,
      goal_percent: revenueGoal ? revenueTotal / revenueGoal : revenueTotal ? 1 : 0 };
    stats.estimates = {
      total: estimates / 2,
      goal_percent: revenueGoal ? estimates / (2 * revenueGoal) : estimates ? 1 : 0 };
    stats.artists = {
      total: artists.length,
      average_revenue: artists.length ? revenueTotal / artists.length : 0 };
    stats.utilization = scheduleSum ? appointmentDurationSum / scheduleSum : appointmentDurationSum ? 1 : 0;
  }

  StatsFactory.updateArtistStats = function (period) {
    var stats = period.stats;
    var data = period.data;

    var appointments = data.appointments;
    var hours = data.hours;

    var revenueTotal = 0;
    var tipTotal = 0;
    var projectTotal = 0;
    var scheduleSum = 0;
    var appointmentDurationSum = 0;
    for (var i = 0; i < appointments.length; i++) {
      var current = appointments[i];
      var status = current.last_status;
      if (status) {
        status = status.status_name;
      }
      if (status === 'Completed') {
        projectTotal++;
        revenueTotal += current.price;
        current.paymentData.tipTotal ? tipTotal += current.paymentData.tipTotal : tipTotal + 0;
      }
      if (status === 'Completed' || status === 'Confirmed') {
        appointmentDurationSum += current.duration;
      }
    }

    for (var c = 0; c < hours.length; c++) {
      scheduleSum += hours[c].duration;
    }

    stats.appointments = projectTotal;
    stats.revenue = revenueTotal;
    stats.tips = tipTotal;
    stats.average = projectTotal ? revenueTotal / projectTotal : 0;
    stats.utilization = scheduleSum ? appointmentDurationSum / scheduleSum : appointmentDurationSum ? 1 : 0;
  };

  StatsFactory.getArtistStats = function (id) {
    var artist = StatsFactory.artistStats[id];
    if (!artist) {
      artist = prepareArtist({});
      StatsFactory.artistStats[id] = artist;
    }
    return artist;
  };

  /**
   * @name prepareArtist
   * @param {unknown} artist Unknown
   * @return {unknown} Unknown
   */
  function prepareArtist(artist) {
    var periods = StatsFactory.periods;
    artist.periods = {};
    for (var periodKey in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKey)) {
        var period = periods[periodKey];
        var newPeriod = {
          prev: period.prev,
          data: { appointments: [], hours: [] },
          stats: {
            appointments: 0,
            revenue: 0,
            tips: 0,
            average: 0,
            utilization: 0 },
          change: {},
          relativeToCurrent: period.relativeToCurrent
        };
        artist.periods[periodKey] = newPeriod;
        if (period.relativeToCurrent === 0) {
          artist.current = newPeriod;
        }
      }
    }
    return artist;
  }

  /**
   * @name recalculateStats
   */
  function recalculateStats() {
    var appointments = StatsFactory.appointments;
    var goals = StatsFactory.goals;
    var artistHours = StatsFactory.schedules;
    var periods = StatsFactory.periods;
    _.each(StatsFactory.artistStats, function (artist) {
      prepareArtist(artist);
    });

    for (var periodKey in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKey)) {
        var period = periods[periodKey];
        for (var i = 0; i < appointments.length; i++) {
          var appointment = appointments[i];
          if (appointment.date >= period.interval.start && appointment.date <= period.interval.end) {
            period.data.appointments.push(appointment);
            if (appointment.artist) {
              var artistValues = StatsFactory.getArtistStats(appointment.artist.id);
              if (artistValues) {
                artistValues.periods[periodKey].data.appointments.push(appointment);
              }
            }
          }
        }
        for (var d = 0; d < goals.length; d++) {
          var goal = goals[d];
          if (goal.start < period.interval.end && (!goal.end || goal.end > period.interval.start)) {
            period.data.goals.push(goal);
          }
        }

        for (var e = 0; e < artistHours.length; e++) {
          var schedule = artistHours[e];
          if (period.interval.start <= schedule.start && schedule.start < period.interval.end) {
            period.data.hours.push(schedule);
            var artistHoursValues = StatsFactory.getArtistStats(schedule.rule.artist);
            if (artistHoursValues) {
              artistHoursValues.periods[periodKey].data.hours.push(schedule);
            }
          }
        }
      }
    }

    //  Calculate shop stats
    for (var periodKeyStats in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKeyStats)) {
        var periodStats = periods[periodKeyStats];
        updateShopStats(periodStats);
        if (periodStats.relativeToCurrent === 0) {
          StatsFactory.currentPeriod = periodStats;
        }
      }
    }

    //  Calculate changes
    for (var periodKeyCalc in periods) {
      if (Object.prototype.hasOwnProperty.call(periods, periodKeyCalc)) {
        var current = periods[periodKeyCalc];
        var previous = periods[current.prev];
        if (previous) {
          var text = void 0;
          var diff = void 0;
          var change = current.change = {};

          diff = Math.round(100 * (current.stats.revenue.goal_percent - previous.stats.revenue.goal_percent));
          if (diff > 0) {
            text = 'more than the ' + Math.round(100 * previous.stats.revenue.goal_percent) + '% you earned of';
          } else if (diff < 0) {
            text = 'less than the ' + Math.round(100 * previous.stats.revenue.goal_percent) + '% you earned of';
          } else {
            text = 'on par with';
          }
          change.revenue = {
            text: text,
            value: diff };

          diff = current.stats.appointments - previous.stats.appointments;
          if (diff > 0) {
            text = Math.abs(diff) + ' more project' + (diff === 1 ? '' : 's') + ' than';
          } else if (diff < 0) {
            text = (diff === -1 ? '1 less project' : Math.abs(diff) + ' fewer projects') + ' than';
          } else {
            text = 'the same number of projects as';
          }
          change.appointments = {
            text: text,
            value: diff };

          diff = Math.round(current.stats.artists.average_revenue - previous.stats.artists.average_revenue);
          if (diff > 0) {
            text = '$' + Math.abs(diff) + ' more than';
          } else if (diff < 0) {
            text = '$' + Math.abs(diff) + ' less than';
          } else {
            text = 'the same as';
          }
          change.artist_revenue = {
            text: text,
            value: diff };

          diff = Math.round(100 * (current.stats.utilization - previous.stats.utilization));
          if (diff > 0) {
            text = Math.abs(diff) + '% more than';
          } else if (diff < 0) {
            text = Math.abs(diff) + '% less than';
          } else {
            text = 'the same as';
          }
          change.utilization = {
            text: text,
            value: diff };
        }
      }
    }

    _.each(StatsFactory.artistStats, function (artistStat) {
      for (var periodKeyUpdate in artistStat.periods) {
        if (Object.prototype.hasOwnProperty.call(artistStat.periods, periodKeyUpdate)) {
          StatsFactory.updateArtistStats(artistStat.periods[periodKeyUpdate]);
        }
      }
      for (var _periodKey in artistStat.periods) {
        if (Object.prototype.hasOwnProperty.call(artistStat.periods, _periodKey)) {
          var _current = artistStat.periods[_periodKey];
          var _previous = artistStat.periods[_current.prev];
          if (_previous) {
            _current.change = {
              appointments: {
                value: _current.stats.appointments - _previous.stats.appointments
              },
              revenue: { value: _current.stats.revenue - _previous.stats.revenue },
              tips: { value: _current.stats.tips - _previous.stats.tips },
              average: { value: _current.stats.average - _previous.stats.average },
              utilization: {
                value: _current.stats.utilization - _previous.stats.utilization
              }
            };
          }
        }
      }
    });
  }
  return StatsFactory;
}]);

/***/ }),

/***/ "./components/stats/stats.template.html":
/***/ (function(module, exports) {

module.exports = "<div id=aux-nav> <a class=aux-nav-item ng-if=\"$ctrl.session.activeState.role === 'operator'\" ng-click=$ctrl.statsToggle() ng-class=\"{'stats-open': $ctrl.events.statsOpen === true, 'update': is_updated === true}\"> <fa name=bar-chart></fa> </a> </div> <div id=quick-stats-wrapper ng-class=\"{'open': $ctrl.events.statsOpen === true && $ctrl.session.activeState.role === 'operator', 'loading': $ctrl.updating}\"> <div id=quick-stats class=\"list stats\"> <div class=\"stat-container progressbar\" ng-class=\"{'negative':$ctrl.current.change.revenue.value < 0, 'positive':$ctrl.current.change.revenue.value > 0}\"> <div class=\"item stat\"> <uib-progress animate> <uib-bar ng-show=$ctrl.current.stats.revenue.goal_percent value=100*$ctrl.current.stats.revenue.goal_percent class=earned tooltip-placement=bottom tooltip-class=light uib-tooltip=\"You have earned {{$ctrl.current.stats.revenue.total | currency:'$':0}} ({{$ctrl.current.stats.revenue.goal_percent | percent:1}}) of your {{$ctrl.adverb}} goal of {{$ctrl.current.stats.goals.revenue | currency:'$':0}}. This is {{$ctrl.current.change.revenue.text}} your previous {{$ctrl.adverb}} goal.\"> <span ng-show=\"(100*$ctrl.current.stats.revenue.goal_percent) > 10\">{{$ctrl.current.stats.revenue.goal_percent | percent:1}}</span> </uib-bar> <uib-bar ng-show=$ctrl.current.stats.estimates.goal_percent value=100*$ctrl.current.stats.estimates.goal_percent class=scheduled tooltip-placement=bottom tooltip-class=light uib-tooltip=\"You have {{$ctrl.current.stats.estimates.total | currency:'$':0}} in scheduled earnings\"> </uib-bar> <div style=margin-top:-2px> <small ng-if=\"$ctrl.current.stats.revenue.goal_percent === 0 && $ctrl.current.stats.estimates.goal_percent === 0\"> No revenue to report </small> </div> </uib-progress> </div> <div class=status-bar></div> </div> <div class=stat-container ng-class=\"{'negative':$ctrl.current.change.appointments.value < 0, 'positive': $ctrl.current.change.appointments.value > 0}\" tooltip-placement=bottom tooltip-class=light uib-tooltip=\"You completed {{$ctrl.current.change.appointments.text}} the previous {{$ctrl.period}}\"> <div class=\"item stat\"> <h5><span class=arrow></span>{{$ctrl.current.stats.appointments}} <small>Appts.</small></h5> </div> <div class=status-bar></div> </div> <div class=stat-container ng-class=\"{'negative':$ctrl.current.change.artist_revenue.value < 0, 'positive': $ctrl.current.change.artist_revenue.value > 0}\" tooltip-placement=bottom tooltip-class=light uib-tooltip=\"Your artist average is {{$ctrl.current.change.artist_revenue.text}} the previous {{$ctrl.period}}\"> <div class=\"item stat\"> <h5><span class=arrow></span>{{$ctrl.current.stats.artists.average_revenue | bigmoney:'$':0}} <small>Artist ave.</small></h5> </div> <div class=status-bar></div> </div> <div class=stat-container ng-class=\"{'negative': $ctrl.current.change.utilization.value < 0, 'positive': $ctrl.current.change.utilization.value > 0}\" tooltip-placement=bottom tooltip-class=light uib-tooltip=\"Your artist utilization is {{$ctrl.current.change.utilization.text}} the previous {{$ctrl.period}}\"> <div class=\"item stat\"> <h5><span class=arrow></span>{{$ctrl.current.stats.utilization | percent:0}} <small>Artist utilization</small></h5> </div> <div class=status-bar></div> </div> <div class=\"stat-container stats-select\"> <div class=\"item stat\"> <select class=\"small no-border\" ng-model=$ctrl.intervalSelect ng-change=$ctrl.updateFilter()> <option value=today>Stats today</option> <option value=yesterday>Stats yesterday</option> <option value=this_week>Stats this week</option> <option value=this_month>Stats this month</option> <option value=this_quarter>Stats this quarter</option> <option value=this_year>Stats this year</option> <option value=last_week>Stats last week</option> <option value=last_month>Stats last month</option> <option value=last_quarter>Stats last quarter</option> <option value=last_year>Stats last year</option> </select> </div> <div class=status-bar></div> </div> </div> </div> ";

/***/ }),

/***/ "./components/styles/_styles.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508418
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./components/styles/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./components/styles/styles.service.js");

__webpack_require__("./components/styles/_styles.styles.scss");

/***/ }),

/***/ "./components/styles/styles.service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('StyleFactory', ['$q', '$http', 'ENDPOINT', 'AlertMessages', function StyleFactory($q, $http, ENDPOINT, AlertMessages) {
  StyleFactory.getStyles = getStyles;

  /**
    * @description Get styles to provide in a select box for users to choose
    * @return {array?} Returns an array of styles?
    */
  function getStyles() {
    return $http.get(ENDPOINT.server + 'styles/api/v1.1/all/', { cache: true }).then(function (response) {
      return response.data;
    }, function (error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return StyleFactory;
}]);

/***/ }),

/***/ "./constants/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('_', ['$window', function ($window) {
  return $window._;
}])
// App version numbers
.constant('APP_VERSION', '0.9.7').constant('AUTH_EVENTS', {
  loginSuccess: 'auth-login-success',
  loginFailed: 'auth-login-failed',
  logoutSuccess: 'auth-logout-success',
  sessionTimeout: 'auth-session-timeout',
  notAuthenticated: 'auth-not-authenticated',
  notAuthorized: 'auth-not-authorized',
  notFound: 'server-not-found',
  collectorUpdated: 'collector-session-updated'
})
// UI messages for switching modes
.constant('SWITCH_MESSAGE', {
  buying: 'Switch to selling',
  selling: 'Switch to buying'
})
// User role names, descriptions, and action messages
.constant('USER_ROLES', {
  collector: 'collector',
  operator: 'operator',
  artist: 'artist'
})
// Reserved routes
.constant('RESERVED_ROUTES', ['login', 'dashboard', 'appointment', 'appointments', 'artist', 'artists', 'client', 'clients', 'profile', 'invitation', 'project', 'projects', 'reset-password', 'shop', 'shops', 'signup', 'messages', 'request-appt'])
// Appointment preferred time
.constant('PREFERRED_TIME', {
  morning: {
    id: 1,
    description: 'Morning'
  },
  afternoon: {
    id: 2,
    description: 'Afternoon'
  },
  evening: {
    id: 3,
    description: 'Evening'
  }
}).constant('RESPONSE_MESSAGES', {
  authorizationError: {
    message: 'Sorry. You can’t view that screen.',
    code: 1
  },
  authenticationError: {
    message: 'Damn. You need to sign in.',
    code: 2
  },
  serverError: {
    message: 'We can’t access the server right now. Try logging in again.',
    code: 3
  },
  emailNotificationSent: {
    message: 'We sent out an email notification.',
    code: 4
  },
  emailNotificationFailed: {
    message: 'We tried to send an email notification, but it failed.',
    code: 5
  },
  paymentUpdateError: {
    message: 'There was a problem updating the price.',
    code: 6
  },
  notFoundError: {
    message: 'We couldn’t find what you were looking for.',
    code: 7
  },
  closedWithoutSaving: {
    message: 'Just a heads up...You closed the window without saving any changes.',
    code: 8
  },
  saved: {
    message: 'Your changes were saved.',
    code: 9
  },
  artistNotScheduled: {
    message: 'This artist is not scheduled at the time you selected. You can still save\n    this appointment, though.',
    code: 10
  },
  existingAppointment: {
    message: 'There is an existing appointment during this time. This appointment can\u2019t\n    be saved.',
    code: 11
  },
  outsideShopHours: {
    message: 'This time is outside of shop hours. This appointment can\'t be saved.',
    code: 11
  },
  sameAppointmentTime: {
    message: 'This is the same time block as the original appointment.',
    code: 12
  },
  projectUpdateConfirmedAppt: {
    message: 'You have a confirmed appointment for this project. Making changes may\n    require your appointment to change.',
    code: 13
  },
  archived: {
    message: 'This appointment has been archived.',
    code: 14
  }
})
// Default state names for each role
.constant('DEFAULT_STATES', {
  public: 'login',
  buying: 'inkfinder.projects',
  selling: 'inkfinder.dashboard',
  operator: 'inkfinder.dashboard',
  artist: 'inkfinder.dashboard'
})
// Intercom app ID
.constant('INTERCOM_APPID', 'mbl97ptq').constant('STATUS', {
  all: 'All types of',
  requested: 'Requested',
  requestDeclined: 'Request declined',
  expired: 'Expired',
  unconfirmed: 'Unconfirmed',
  confirmed: 'Confirmed',
  declined: 'Declined',
  completed: 'Completed',
  collectorCancelled: 'Collector cancelled',
  artistCancelled: 'Artist cancelled',
  archived: 'Archived'
}).constant('STATUS_IDS', {
  requested: 10,
  requestDeclined: 20,
  expired: 30,
  unconfirmed: 40,
  confirmed: 50,
  declined: 60,
  completed: 70,
  collectorCancelled: 80,
  artistCancelled: 90,
  archived: 100
}).constant('PAYMENT_STATUS_IDS', {
  approved: 1,
  void: 2,
  refund: 3,
  declined: 4
}).constant('SORTOPTIONS', {
  appointmentDatetime: 'Appointment date',
  collectorLastName: 'Client last name'
})
// Email notification codes
.constant('NOTIFICATIONS', {
  // "Welcome to Ink Finder"/Generic welcome email when a collector creates an
  // Ink Finder account.
  collectorWelcome: 1,

  // "Project created."/Email sent for collectors when an artist or operator
  // creates a project for them on their behalf.
  projectCreated: 2,

  // "<Artist name> at <Shop name> sent you an estimate"/Email sent when an
  // estimate is created/sent to a collector
  collectorEstimate: 3,

  // "<Shop name> invited you to join their shop as an operator"/Email sent when
  // an operator is invited to a shop roster
  operatorInvite: 4,

  // "<Shop name> invited you to join their artist roster"/Email sent when an
  // artist is invited to a shop roster
  artistInvite: 5,

  // "<Artist name> accepted your invitation to join your artist roster/Email
  // sent when an artist confirms an invitation
  artistAccept: 6,

  // "<Operator name> accepted your invitation to join your shop roster/Email
  // sent when an operator confirms an invitation
  operatorAccept: 7,

  // "The artist daily"/Email sent for artist daily stats and appointments
  artistDaily: 8,

  // "The shop daily"/Email sent for operators daily shop stats and appointments
  operatorDaily: 9,

  // "Merge accounts"/Email sent for collectors to merge their Ink Finder
  // account with their Facebook account. This merge adds a Facebook ID to a
  // collector account.
  facebookMerge: 10,

  // "Password reset."/Email sent for collectors to reset their password after
  // they request a reset. The link in the email confirms the token on the API
  // and allows them to choose and save a new password on their Ink Finder
  // account.
  passwordReset: 11,

  // Appointment update /Email sent to collectos when their appointment
  // information has been updated by an artist or operator.
  appointmentUpdate: 12,

  // Appointment confirmation by collector /Email sent to all confirmed
  // operators at a shop to notify them when a collector confirs an appointment
  appointmentConfirmedByCollector: 13,

  // Appointment declined by collector /Email sent to all confirmed operators at
  // a shop to notify them when a collector declines an appointment
  appointmentDeclinedByCollector: 14,

  // Appointment confirmation by operator/artist /Email sent to the collector to
  // notify them when an artist or operator confirms their appointment
  appointmentConfirmedByOperatorOrArtist: 15,

  // 16 Email sent to a collector when an appointment is upcoming

  // Appointment completed by operator/artist /Email sent to the collector to
  // notify them when an artist or operator completes their appointment
  appointmentCompleteToCollector: 17,

  // Appointment completed by operator/artist /Email sent to the artist to
  // notify them when an operator completes one of their appointment
  appointmentCompleteToArtist: 18,

  // Appointment update /Email sent to artists when their appointment
  // information has been updated by an operator.
  artistAppointmentUpdate: 19,

  // "<Operator name> at <Shop name> sent an estimate for your appointment"
  // Email sent to artists when an estimate is created/sent to a collector by an
  // operator
  artistEstimate: 20,

  // "<Operator name> at <Shop name> confirmed your appointment"/Email sent to
  // artists when an appointment is confirmed by an operator
  artistConfirmed: 21,

  // "<Operator name> at <Shop name> updated a project you're working on" Email
  // sent to artist/shop operators when an project is updated
  projectUpdated: 22,

  // 23 is for appointment message nofication

  // Email sent to collectors to confirm their email address
  emailConfirmation: 24,

  // Email sent to artists, operators, and collectors when an appointment is
  // marked to be rescheduled later.
  appointmentReschedule: 25,

  // Email sent to artists, operators, and collectors when an appointment is
  // cancelled.
  appointmentCancellation: 26

  // 27 Email sent to the collector to notify them about the 14-day or the
  // 30-day followup message
}).constant('BASE', {
  path: 'templates/src/' // Refactor this to point to shared template assets
})
// Google maps key
.constant('GMAPS_KEY', 'AIzaSyA7T4K49Snq8GL5v1XIrYn2ZInsnty7H-c');

/***/ }),

/***/ "./constants/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./constants/constants.js");

/***/ }),

/***/ "./directives/directives.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').factory('focus', ['$timeout', '$window', function ($timeout, $window) {
  return function (id) {
    // timeout makes sure that it is invoked after any other event has been triggered.
    // e.g. click events that need to run before the focus or
    // inputs elements that are in a disabled state but are enabled when those events
    // are triggered.
    $timeout(function () {
      var element = $window.document.getElementById(id);
      if (element) {
        element.focus();
      }
    });
  };
}]);

angular.module('inkfinder').directive('eventFocus', ['focus', function (focus) {
  return function (scope, elem, attr) {
    elem.on(attr.eventFocus, function () {
      focus(attr.eventFocusId);
    });

    // Removes bound events in the element itself
    // when the scope is destroyed
    scope.$on('$destroy', function () {
      elem.off(attr.eventFocus);
    });
  };
}]).directive('compareTo', function () {
  return {
    require: 'ngModel',
    scope: {
      otherModelValue: '=compareTo'
    },
    link: function link(scope, element, attributes, ngModel) {
      ngModel.$validators.compareTo = function (modelValue) {
        return modelValue === scope.otherModelValue;
      };
      scope.$watch('otherModelValue', function () {
        ngModel.$validate();
      });
    }
  };
});

/***/ }),

/***/ "./directives/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./directives/directives.js");

/***/ }),

/***/ "./filters/filters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').filter('positionFilter', ['_', function (_) {
  return function (input, area_id) {
    var output = [];

    _.each(input, function (location) {
      if (location.area.id === area_id) {
        output.push(location);
      }
    });
    return output;
  };
}]).filter('hour_range', function () {
  return function (input, min, max) {
    min = parseInt(min, 10); // Make string input int
    max = parseInt(max, 10);
    for (var i = min; i <= max; i++) {
      input.push(i);
    }
    return input;
  };
}).filter('minute_range', function () {
  return function (input, min, max) {
    min = parseInt(min, 10); // Make string input int
    max = parseInt(max, 10);
    for (var i = min; i <= max; i += 15) {
      input.push(i);
    }
    return input;
  };
}).filter('reverse', function () {
  return function (items) {
    return items.slice().reverse();
  };
}).filter('bigmoney', ['_', function (_) {
  return function (input, currency, decimals) {
    if (_.isUndefined(input)) {
      return '';
    }
    var val = input ? input : 0;
    var thousands = 0;
    if (val < 1000) {
      val = Math.round(val);
    }
    while (val >= 1000 && thousands < 2) {
      val /= 1000;
      thousands++;
    }
    if (thousands) {
      if (decimals === null) {
        decimals = 1;
      }
      var factor_of_ten = Math.pow(10, decimals);
      val = Math.round(val * factor_of_ten) / factor_of_ten;
    }
    if (thousands === 1) {
      val += 'k';
    } else if (thousands === 2) {
      val += 'm';
    }
    if (currency) {
      return currency + val;
    }
    return '$' + val;
  };
}]).filter('tel', function () {
  return function (tel) {
    if (!tel) {
      return '';
    }
    var value = tel.toString().trim().replace(/^\+/, '');
    if (value.match(/[^0-9]/)) {
      return tel;
    }
    var country = void 0;
    var city = void 0;
    var number = void 0;
    switch (value.length) {
      case 10:
        // +1PPP####### -> C (PPP) ###-####
        country = 1;
        city = value.slice(0, 3);
        number = value.slice(3);
        break;
      case 11:
        // +CPPP####### -> CCC (PP) ###-####
        country = value[0];
        city = value.slice(1, 4);
        number = value.slice(4);
        break;
      case 12:
        // +CCCPP####### -> CCC (PP) ###-####
        country = value.slice(0, 3);
        city = value.slice(3, 5);
        number = value.slice(5);
        break;
      default:
        return tel;
    }
    if (country === 1) {
      country = '';
    }
    number = number.slice(0, 3) + '-' + number.slice(3);
    return (country + ' (' + city + ') ' + number).trim();
  };
}).filter('noFractionCurrency', ['$filter', '$locale', function ($filter, $locale) {
  var currencyFilter = $filter('currency');
  var formats = $locale.NUMBER_FORMATS;
  return function (amount, currencySymbol) {
    amount = amount ? Number(amount).toFixed(2) : 0.00;
    var value = currencyFilter(amount, currencySymbol);
    // split into parts
    var parts = value.split(formats.DECIMAL_SEP);
    var dollar = parts[0];
    var cents = parts[1] || '00';
    cents = cents.substring(0, 2).toString() === '00' ? cents.substring(2) : '.' + cents; // remove '00' cent amount
    return dollar + cents;
  };
}]).filter('percent', ['$filter', '_', function ($filter, _) {
  return function (input, decimals) {
    if (_.isUndefined(input)) {
      return '';
    }
    return $filter('number')(input * 100, decimals) + '%';
  };
}]).filter('cut', function () {
  return function (value, wordwise, max, tail) {
    if (!value) return '';

    max = parseInt(max, 10);
    if (!max) return value;
    if (value.length <= max) return value;

    value = value.substr(0, max);
    if (wordwise) {
      var lastspace = value.lastIndexOf(' ');
      if (lastspace !== -1) {
        // Also remove . and , so its gives a cleaner result.
        if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
          lastspace -= 1;
        }
        value = value.substr(0, lastspace);
      }
    }
    return value + (tail || ' …');
  };
}).filter('activityFilter', ['_', function (_) {
  return function (items, hasMessages, hasAppointmentActivity, hasProjectActivity) {
    var filtered = [];
    _.each(items, function (item) {
      if (!_.isUndefined(item)) {
        if (hasMessages && _.isUndefined(item.type)) {
          filtered.push(item);
        }
        if (hasAppointmentActivity && item.object === 'appointment') {
          filtered.push(item);
        }
        if (hasProjectActivity && item.object === 'project') {
          filtered.push(item);
        }
      }
    });
    return filtered;
  };
}]);

/***/ }),

/***/ "./filters/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./filters/filters.js");

/***/ }),

/***/ "./index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./app.js");

__webpack_require__("./app.config.js");

__webpack_require__("./app.environment.js");

__webpack_require__("./app.run.js");

__webpack_require__("./_app.styles.scss");

__webpack_require__("./common/index.js");

__webpack_require__("./components/index.js");

__webpack_require__("./constants/index.js");

__webpack_require__("./directives/index.js");

__webpack_require__("./filters/index.js");

__webpack_require__("./routes/index.js");

/***/ }),

/***/ "./routes/appointment/appointment-route.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkAppointmentRoute = {
  controller: 'AppointmentRouteController',
  bindings: {
    appointments: '<',
    project: '<',
    open: '<?'
  },
  template: __webpack_require__("./routes/appointment/appointment-route.template.html")
};

angular.module('inkfinder').component('inkAppointmentRoute', inkAppointmentRoute);

/***/ }),

/***/ "./routes/appointment/appointment-route.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

AppointmentRouteController.$inject = ['$log', '$stateParams', 'GetAppointmentShop', 'MessageTemplates'];


/**
 * @name AppointmentRouteController
 * @description Controller called to display/manage appointments and projects
 * @param {angular} $log The Angular $log service
 * @param {angular} $stateParams The Angular $log service
 * @param {service} GetAppointmentShop The GetAppointmentShop service
 * @param {service} MessageTemplates The MessageTemplates service
 */
function AppointmentRouteController($log, $stateParams, GetAppointmentShop, MessageTemplates) {
  var vm = this;
  vm.$onInit = function () {
    vm.updateProject = updateProject;
    vm.updateAppointment = updateAppointment;
    vm.uiOnParamsChanged = uiOnParamsChanged;
  };

  vm.currentAppointment = findCurrentAppointment($stateParams.appointment_id);

  /**
   * @name findCurrentAppointment
   * @description Function to find the current appointment based on the URL
   * param appointment_id
   * @param {number} currentAppointmentId The ID of the current appointment
   * @return {object} Returns the current appointment
   */
  function findCurrentAppointment(currentAppointmentId) {
    return _lodash2.default.find(vm.appointments, function (appointment) {
      if (appointment.id === Number(currentAppointmentId)) {
        return true;
      }
    });
  }

  /**
   * @name uiOnParamsChanged
   * @description A ui-router function callback when param values change
   * @param {object} newParams The name of the param that changed
   */
  function uiOnParamsChanged(newParams) {
    vm.currentAppointment = findCurrentAppointment(newParams.appointment_id);
  }

  /**
   * @name updateProject
   * @description Function to update the project object after it's changed
   * @param {object} project The project update
   */
  function updateProject(project) {
    vm.project = project;
  }

  /**
   * @name updateAppointment
   * @description Function to update the current appt object after it has change
   * @param {object} appointment The appointment update
   */
  function updateAppointment(appointment) {
    vm.currentAppointment = appointment;

    // Update the appointments array
    var newAppointment = [];
    newAppointment.push(appointment);
    vm.appointments = _lodash2.default.unionBy(newAppointment, vm.appointments, function (data) {
      return data.id;
    });
  }

  // Set the shop object data for each appointment
  GetAppointmentShop.get(vm.appointments).then(function (shops) {
    _lodash2.default.each(shops, function (shop) {
      MessageTemplates.get(shop.message_templates).then(function (response) {
        shop.messageTemplates = response;
      });

      _lodash2.default.each(vm.appointments, function (appointment) {
        if (appointment.shop === shop.id) {
          appointment.shop = shop;
        }
      });
    });
  });

  $log.debug('Appointments from appointment route: ', vm.appointments);
  $log.debug('Project from appointment route: ', vm.project);
  $log.debug('Current appt from appointment route: ', vm.currentAppointment);
}

angular.module('inkfinder').controller('AppointmentRouteController', AppointmentRouteController);

/***/ }),

/***/ "./routes/appointment/appointment-route.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid background-dark\"> <div class=\"row standard-margin-bottom\"> <div class=\"col-lg-10 col-lg-offset-1\"> <ink-appointment appointments=$ctrl.appointments project=$ctrl.project current-appointment=$ctrl.currentAppointment on-appointment-change=$ctrl.updateAppointment(appointment)> </ink-appointment> </div> <div class=\"col-sm-12 col-md-5 col-md-push-7 col-lg-4\"> <ink-project project=$ctrl.project current-appointment=$ctrl.currentAppointment on-project-change=$ctrl.updateProject(project) on-appointment-change=$ctrl.updateAppointment(appointment) open=$ctrl.open> </ink-project> </div> <div class=\"col-sm-12 col-md-7 col-md-pull-5 col-lg-6 col-lg-pull-3 feature-margin-bottom\"> <div ng-if=$ctrl.currentAppointment> <h4>Add a message</h4> <ink-participants conversation-id=$ctrl.currentAppointment.conversations artist=$ctrl.currentAppointment.artist collector=$ctrl.project.collector appointment-id=$ctrl.currentAppointment.id> </ink-participants> <ink-add-message conversation-id=$ctrl.currentAppointment.conversations appointment-id=$ctrl.currentAppointment.id> </ink-add-message> <ink-activity conversation-id=$ctrl.currentAppointment.conversations appointment-id=$ctrl.currentAppointment.id project-id=$ctrl.project.id activity-title=\"'Activity'\"> </ink-activity> </div> </div> </div> </div> ";

/***/ }),

/***/ "./routes/appointment/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./routes/appointment/appointment-route.component.js");

__webpack_require__("./routes/appointment/appointment-route.controller.js");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('inkfinder.appointments.details', {
    url: '/{appointment_id:[0-9]{1,100}}?open',
    views: {
      '@': {
        component: 'inkAppointmentRoute'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Your appointment';
      },
      project: ['Appointment', 'Project', '$stateParams', '_', function project(Appointment, Project, $stateParams, _) {
        return Appointment.get($stateParams.appointment_id).then(function (appointment) {
          return Project.get(appointment.project).then(function (project) {
            return project;
          });
        });
      }],
      appointments: ['project', 'Appointments', function appointments(project, Appointments) {
        var search = false;
        var start = void 0;
        var end = void 0;
        var timestamp = void 0;
        var artist = void 0;
        var collector = void 0;
        var projectId = project.id;
        return Appointments.get(search, start, end, timestamp, artist, collector, projectId).then(function (appointments) {
          return appointments;
        });
      }],
      currentAppointment: ['appointments', '_', '$stateParams', function currentAppointment(appointments, _, $stateParams) {
        return _.find(appointments, function (appointment) {
          if (appointment.id === Number($stateParams.appointment_id)) {
            return true;
          }
        });
      }],
      open: ['$stateParams', function open($stateParams) {
        return $stateParams.open;
      }]
    },
    params: {
      appointment_id: { dynamic: true }
    }
  });
}]);

/***/ }),

/***/ "./routes/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./routes/appointment/index.js");

__webpack_require__("./routes/login/index.js");

__webpack_require__("./routes/logout/index.js");

__webpack_require__("./routes/messages/index.js");

__webpack_require__("./routes/project/index.js");

/***/ }),

/***/ "./routes/login/_login.styles.scss":
/***/ (function(module, exports, __webpack_require__) {

// removed by extract-text-webpack-plugin
    if(true) {
      // 1738182508388
      var cssReload = __webpack_require__("../node_modules/css-hot-loader/hotModuleReplacement.js")(module.i, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  

/***/ }),

/***/ "./routes/login/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./routes/login/_login.styles.scss");

angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('login', {
    url: '/login',
    views: {
      '@': {
        template: __webpack_require__("./routes/login/login-route.template.html"),
        controller: ['session', '$scope', function controller(session, $scope) {
          this.session = session;
        }],
        controllerAs: '$ctrl'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Sign in to Ink Finder';
      },
      session: ['Session', function session(Session) {
        return Session;
      }]
    }
  });
}]);

/***/ }),

/***/ "./routes/login/login-route.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"login-state inkfinder section first last background-dark\"> <div class=background-photo></div> <div class=region-header> <div class=container> <div class=row> <div class=\"col-sm-12 center\"> <span class=\"logo finder full-logo\"></span> </div> </div> </div> </div> <div class=container-fluid> <div class=row> <div class=col-sm-12> <div class=intro> <h1 class=center ng-if=!$ctrl.session.collector>Sign in.</h1> <h1 class=center ng-if=$ctrl.session.collector>Welcome, {{$ctrl.session.collector.first_name}}.</h1> </div> <div class=row> <div class=\"col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-3 col-sm-6 col-sm-offset-3\"> <ink-login></ink-login> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./routes/logout/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('inkfinder').config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('logout', {
    url: '/logout',
    views: {
      '@': {
        template: __webpack_require__("./routes/logout/logout-route.template.html")
      }
    },
    resolve: {
      $title: function $title() {
        return 'You’ve sucessfully logged out';
      }
    }
  });
}]);

/***/ }),

/***/ "./routes/logout/logout-route.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"login-state inkfinder section first last background-dark\"> <div class=background-photo></div> <div class=region-header> <div class=container> <div class=row> <div class=\"col-sm-12 center\"> <span class=\"logo finder full-logo\"></span> </div> </div> </div> </div> <div class=container> <div class=row> <div class=col-sm-12> <div class=\"intro center\"> <h1>See you again soon.</h1> <h3>We signed you out successfully.</h3> <div class=\"button-container margin\"> <button class=\"button large finder-solid\" ui-sref=login>Sign back in</button> </div> </div> </div> </div> </div> </div> ";

/***/ }),

/***/ "./routes/messages/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./routes/messages/messages-route.component.js");

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.messages', {
    url: '/messages',
    abstract: true,
    views: {
      '@': {
        component: 'inkMessagesRoute'
      }
    },
    data: {
      authorizedRoles: [USER_ROLES.collector, USER_ROLES.operator, USER_ROLES.artist]
    }
  }).state('inkfinder.messages.inbox', {
    url: '/inbox?page',
    views: {
      messagesView: {
        component: 'inkMessages'
      }
    },
    params: {
      page: {
        value: '1',
        dynamic: true
      }
    },
    resolve: {
      participants: ['$stateParams', 'Participants', 'Session', 'GroupParticipants', function participants($stateParams, Participants, Session, GroupParticipants) {
        var collectorId = Session.collector.id;
        var conversationId = void 0;
        var appointmentId = void 0;
        var read = 'False';
        var page = $stateParams.page;
        var sort = 'last_message_date';
        var lastMessage = 'notnull';
        return Participants.get(conversationId, appointmentId, collectorId, read, page, sort, lastMessage).then(function (participants) {
          return participants;
        });
      }],
      messagesType: function messagesType() {
        return 'inbox';
      },
      $title: function $title() {
        return 'Messages - Inbox';
      }
    },
    bindings: {
      $transition$: '<'
    }
  }).state('inkfinder.messages.archive', {
    url: '/archive?page',
    views: {
      messagesView: {
        component: 'inkMessages'
      }
    },
    params: {
      page: {
        value: '1',
        dynamic: true
      }
    },
    resolve: {
      participants: ['$stateParams', 'Participants', 'Session', 'GroupParticipants', function participants($stateParams, Participants, Session, GroupParticipants) {
        var collectorId = Session.collector.id;
        var conversationId = void 0;
        var appointmentId = void 0;
        var read = 'True';
        var page = $stateParams.page;
        var sort = 'last_message_date';
        var lastMessage = 'notnull';
        return Participants.get(conversationId, appointmentId, collectorId, read, page, sort, lastMessage).then(function (participants) {
          participants.results = GroupParticipants.group(participants.results);
          return participants;
        });
      }],
      messagesType: function messagesType() {
        return 'archive';
      },
      $title: function $title() {
        return 'Messages - Archive';
      }
    },
    bindings: {
      $transition$: '<'
    }
  });
}]);

/***/ }),

/***/ "./routes/messages/messages-route.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkMessagesRoute = {
  template: __webpack_require__("./routes/messages/messages-route.template.html")
};

angular.module('inkfinder').component('inkMessagesRoute', inkMessagesRoute);

/***/ }),

/***/ "./routes/messages/messages-route.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"flex-container flex-column height100\"> <div class=\"section background-light-gray tight no-bottom-padding messages-container\"> <div class=container> <div class=row> <div class=\"col-sm-12 section-tabs\"> <a class=section-tab ui-sref=inkfinder.messages.inbox ui-sref-active=active><span>Inbox</span></a> <a class=section-tab ui-sref=inkfinder.messages.archive ui-sref-active=active><span>Archive</span></a> </div> </div> </div> </div> <div class=\"section tight background-light flex-col\" ui-view=messagesView> </div> </div> ";

/***/ }),

/***/ "./routes/project/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("./routes/project/project-route.component.js");

__webpack_require__("./routes/project/project-route.controller.js");

var _findLastUpdatedAppt = __webpack_require__("./utils/find-last-updated-appt.js");

var _findLastUpdatedAppt2 = _interopRequireDefault(_findLastUpdatedAppt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.module('inkfinder').config(['$stateProvider', 'USER_ROLES', function ($stateProvider, USER_ROLES) {
  $stateProvider.state('inkfinder.projects.details', {
    url: '/{id:[0-9]{1,100}}?open',
    views: {
      '@': {
        component: 'inkProjectRoute'
      }
    },
    resolve: {
      $title: function $title() {
        return 'Project details';
      },
      project: ['Project', '$stateParams', function project(Project, $stateParams) {
        return Project.get($stateParams.id).then(function (response) {
          return response;
        });
      }],
      open: ['$stateParams', function open($stateParams) {
        return $stateParams.open;
      }]
    },
    redirectTo: function redirectTo(trans) {
      // getAsync tells the resolve to load
      var resolvePromise = trans.injector().getAsync('project');
      return resolvePromise.then(function (project) {
        if (project.appointments.length) {
          var currentAppointment = (0, _findLastUpdatedAppt2.default)(project.appointments);
          return {
            state: 'inkfinder.appointments.details',
            params: { appointment_id: currentAppointment.id }
          };
        }
        return;
      });
    }
  });
}]);

/***/ }),

/***/ "./routes/project/project-route.component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inkProjectRoute = {
  bindings: {
    project: '<'
  },
  controller: 'ProjectRouteController',
  template: __webpack_require__("./routes/project/project-route.template.html")
};

angular.module('inkfinder').component('inkProjectRoute', inkProjectRoute);

/***/ }),

/***/ "./routes/project/project-route.controller.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


ProjectRouteController.$inject = ['$log', '$stateParams'];
/**
 * @name ProjectRouteController
 * @description Controller called to display/manage projects and appts
 * @param {angular} $log The Angular $log service
 * @param {angular} $stateParams The Angular $log service
 */
function ProjectRouteController($log, $stateParams) {
  var vm = this;
  vm.$onInit = function () {
    vm.updateProject = updateProject;
  };

  /**
   * @name updateProject
   * @description Function to update the project object after it's changed
   * @param {object} project The project update
   */
  function updateProject(project) {
    vm.project = project;
  }

  $log.debug('Project from project route: ', vm.project);
}

angular.module('inkfinder').controller('ProjectRouteController', ProjectRouteController);

/***/ }),

/***/ "./routes/project/project-route.template.html":
/***/ (function(module, exports) {

module.exports = "<div class=\"container-fluid background-dark\"> <div class=\"row standard-margin-bottom\"> <div class=\"col-lg-6 col-lg-offset-1\"> <ink-project project=$ctrl.project current-appointment=$ctrl.currentAppointment on-project-change=$ctrl.updateProject(project) open=$ctrl.open> </ink-project> </div> <div class=col-lg-4> </div> </div> </div> ";

/***/ }),

/***/ "./utils/find-duplicate-association.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = findDuplicateAssociation;

/**
 * @name find
 * @description Group appointments by target statuses.
 * @param {array} associations The collection to group.
 * @param {array} shopToCheck The statuses to filter by.
 * @param {array} typeToCheck The statuses to filter by.
 * @return {array} duplicateAssociations Returns the grouped collection.
 */

function findDuplicateAssociation(associations, shopToCheck, typeToCheck) {
  var duplicateAssociations = _lodash2.default.find(associations.all, function (association) {
    return association.shop.id === shopToCheck && association.type === typeToCheck.toLowerCase();
  });
  return !_lodash2.default.isUndefined(duplicateAssociations);
}

/***/ }),

/***/ "./utils/find-last-updated-appt.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = findLastUpdatedAppt;

/**
 * @name find
 * @description Function to find the last updated appointment based on the
 * last_status created date.
 * @param {array} collection The collection to group.
 * @return {array} latest Returns the grouped collection.
 */

function findLastUpdatedAppt(collection) {
  var latest = _lodash2.default.orderBy(collection, function (appointment) {
    return appointment.last_status.created;
  }, 'desc');
  return latest[0];
}

/***/ }),

/***/ "./utils/format-activity.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("../node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__("../node_modules/moment-duration-format/lib/moment-duration-format.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = formatActivity;

/**
 * @name formatActivity
 * @description Formats an appointment
 * @param {object} type The type of object activity to format
 * @param {object} activity The activity to format
 * @return {object} formatted Returns the formatted activity
 */

function formatActivity(type, activity) {
  if (type === 'project') {
    return formatProjectActivity(activity);
  }
  return formatAppointmentActivity(activity);
}

/**
 * @name formatProjectActivity
 * @description Function to format project activity
 * @param {array} activity The activity to format
 * @return {string} Returns the formatted activity
 */
function formatProjectActivity(activity) {
  var formattedActivities = [];
  _lodash2.default.forEach(activity, function (eachActivity) {
    var activityObject = {
      type: 'activity',
      object: 'project',
      projectId: eachActivity.object_id,
      created: eachActivity.created,
      collector: eachActivity.collector,
      id: eachActivity.id,
      description: []
    };

    // Coverup field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.coverup)) {
      var changeValues = [];
      _lodash2.default.forEach(eachActivity.changes.coverup, function (value) {
        if (value === true) {
          changeValues.push('Yes');
        } else {
          changeValues.push('No');
        }
      });
      var formattedChange = {};
      if (eachActivity.changes.coverup[0] === null) {
        formattedChange.message = 'set the coverup status';
        formattedChange.oldValue = null;
        formattedChange.newValue = eachActivity.changes.style[1];
      } else {
        formattedChange.message = 'changed the coverup status';
        formattedChange.oldValue = changeValues[0];
        formattedChange.newValue = changeValues[1];
      }
      activityObject.description.push(formattedChange);
    }

    // Full color field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.full_color)) {
      var _changeValues = [];
      _lodash2.default.forEach(eachActivity.changes.full_color, function (colorValue) {
        if (colorValue === true) {
          _changeValues.push('Full color');
        } else {
          _changeValues.push('Black and gray');
        }
      });
      var _formattedChange = {};
      if (eachActivity.changes.full_color[0] === null) {
        _formattedChange.message = 'set the color type';
        _formattedChange.oldValue = null;
        _formattedChange.newValue = eachActivity.changes.style[1];
      } else {
        _formattedChange.message = 'changed the color type';
        _formattedChange.oldValue = _changeValues[0];
        _formattedChange.newValue = _changeValues[1];
      }
      activityObject.description.push(_formattedChange);
    }

    // Area and location field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.location)) {
      var _formattedChange2 = {};
      if (eachActivity.changes.location[0] === null) {
        _formattedChange2.message = 'set the tattoo location';
        _formattedChange2.oldValue = null;
        _formattedChange2.newValue = eachActivity.changes.location[1].area + ': ' + eachActivity.changes.location[1].location;
      } else if (eachActivity.changes.location[1] === null) {
        _formattedChange2.message = 'removed the tattoo location';
        _formattedChange2.oldValue = eachActivity.changes.location[0].area + ': ' + eachActivity.changes.location[0].location;
        _formattedChange2.newValue = null;
      } else {
        _formattedChange2.message = 'changed the tattoo location';
        _formattedChange2.oldValue = eachActivity.changes.location[0].area + ': ' + eachActivity.changes.location[0].location;
        _formattedChange2.newValue = eachActivity.changes.location[1].area + ': ' + eachActivity.changes.location[1].location;
      }
      activityObject.description.push(_formattedChange2);
    }

    // Name field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.name)) {
      var _formattedChange3 = {};
      if (eachActivity.changes.name[0] === null) {
        _formattedChange3.message = 'set the project name';
        _formattedChange3.oldValue = null;
        _formattedChange3.newValue = eachActivity.changes.name[1];
      } else {
        _formattedChange3.message = 'changed the project name';
        _formattedChange3.oldValue = eachActivity.changes.name[0];
        _formattedChange3.newValue = eachActivity.changes.name[1];
      }
      activityObject.description.push(_formattedChange3);
    }

    // Size field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.size)) {
      var _formattedChange4 = {};
      if (eachActivity.changes.size[0] === null) {
        _formattedChange4.message = 'set the tattoo size';
        _formattedChange4.oldValue = null;
        _formattedChange4.newValue = eachActivity.changes.size[1];
      } else if (eachActivity.changes.size[1] === null) {
        _formattedChange4.message = 'removed the tattoo size';
        _formattedChange4.oldValue = eachActivity.changes.size[0];
        _formattedChange4.newValue = null;
      } else {
        _formattedChange4.message = 'changed the tattoo size';
        _formattedChange4.oldValue = eachActivity.changes.size[0];
        _formattedChange4.newValue = eachActivity.changes.size[1];
      }
      activityObject.description.push(_formattedChange4);
    }

    // width field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.width)) {
      var _formattedChange5 = {};
      if (eachActivity.changes.width[0] === null) {
        _formattedChange5.message = 'set the project width';
        _formattedChange5.oldValue = null;
        _formattedChange5.newValue = eachActivity.changes.width[1] + '"';
      } else if (eachActivity.changes.width[1] === null) {
        _formattedChange5.message = 'removed the tattoo width';
        _formattedChange5.oldValue = null;
        _formattedChange5.newValue = null;
      } else {
        _formattedChange5.message = 'changed the project width';
        _formattedChange5.oldValue = eachActivity.changes.width[0] + '"';
        _formattedChange5.newValue = eachActivity.changes.width[1] + '"';
      }
      activityObject.description.push(_formattedChange5);
    }

    // height field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.height)) {
      var _formattedChange6 = {};
      if (eachActivity.changes.height[0] === null) {
        _formattedChange6.message = 'set the project height';
        _formattedChange6.oldValue = null;
        _formattedChange6.newValue = eachActivity.changes.height[1] + '"';
      } else if (eachActivity.changes.height[1] === null) {
        _formattedChange6.message = 'removed the tattoo height';
        _formattedChange6.oldValue = null;
        _formattedChange6.newValue = null;
      } else {
        _formattedChange6.message = 'changed the project height';
        _formattedChange6.oldValue = eachActivity.changes.height[0] + '"';
        _formattedChange6.newValue = eachActivity.changes.height[1] + '"';
      }
      activityObject.description.push(_formattedChange6);
    }

    // Style field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.style)) {
      var _formattedChange7 = {};
      if (eachActivity.changes.style[0] === null) {
        _formattedChange7.message = 'set the project style';
        _formattedChange7.oldValue = null;
        _formattedChange7.newValue = eachActivity.changes.style[1];
      } else if (eachActivity.changes.style[1] === null) {
        _formattedChange7.message = 'removed the tattoo style';
        _formattedChange7.oldValue = eachActivity.changes.style[0];
        _formattedChange7.newValue = null;
      } else {
        _formattedChange7.message = 'changed the project style';
        _formattedChange7.oldValue = eachActivity.changes.style[0];
        _formattedChange7.newValue = eachActivity.changes.style[1];
      }
      activityObject.description.push(_formattedChange7);
    }

    // Tattoo concept field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.tattoo_concept)) {
      var _formattedChange8 = {};
      if (eachActivity.changes.tattoo_concept[0] === null) {
        _formattedChange8.message = 'added a concept for this project';
        _formattedChange8.oldValue = null;
        _formattedChange8.newValue = null;
      } else {
        _formattedChange8.message = 'updated the concept of this project';
        _formattedChange8.oldValue = null;
        _formattedChange8.newValue = null;
      }
      activityObject.description.push(_formattedChange8);
    }

    // Reference images updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.reference_images)) {
      var _formattedChange9 = {};

      // New images
      if (eachActivity.changes.reference_images[1].length > 0) {
        var newImages = _lodash2.default.filter(eachActivity.changes.reference_images[1], function (image) {
          return image.indexOf('tmpimages') > -1;
        });

        if (newImages.length === 1) {
          _formattedChange9.message = 'added ' + newImages.length + ' reference image';
        } else if (newImages.length > 1) {
          _formattedChange9.message = 'added ' + newImages.length + ' reference images';
        }
        _formattedChange9.oldValue = null;
        _formattedChange9.newValue = null;
      }

      // Deleted images
      // if (eachActivity.changes.reference_images[0].length > 0 &&
      // eachActivity.changes.reference_images[1].length >= 0) {
      //   let unchangedImages = _.intersection(eachActivity.changes.reference_images[0], eachActivity.changes.reference_images[1]);
      //   let deletedImages =
      //   _.difference(eachActivity.changes.reference_images[0],
      //   eachActivity.changes.reference_images[1]);
      //
      //   if (deletedImages.length > 0) {
      //     formattedChange.message += ' and removed ' +
      //     deletedImages.length + ' images';
      //   }
      // }
      activityObject.description.push(_formattedChange9);
    }

    // Placement images updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.coverup_images)) {
      var _formattedChange10 = {};

      // New images
      if (eachActivity.changes.coverup_images[1].length > 0) {
        var _newImages = _lodash2.default.filter(eachActivity.changes.coverup_images[1], function (image) {
          return image.indexOf('tmpimages') > -1;
        });

        if (_newImages.length === 1) {
          _formattedChange10.message = 'added ' + _newImages.length + ' placement photo';
        } else if (_newImages.length > 1) {
          _formattedChange10.message = 'added ' + _newImages.length + ' placement photos';
        }
        _formattedChange10.oldValue = null;
        _formattedChange10.newValue = null;
      }
      activityObject.description.push(_formattedChange10);
    }

    // Completed images updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.completed_images)) {
      var _formattedChange11 = {};

      // New images
      if (eachActivity.changes.completed_images[1].length > 0) {
        var _newImages2 = _lodash2.default.filter(eachActivity.changes.completed_images[1], function (image) {
          return image.indexOf('tmpimages') > -1;
        });

        if (_newImages2.length === 1) {
          _formattedChange11.message = 'added ' + _newImages2.length + ' completed photo';
        } else if (_newImages2.length > 1) {
          _formattedChange11.message = 'added ' + _newImages2.length + ' completed photos';
        }
        _formattedChange11.oldValue = null;
        _formattedChange11.newValue = null;
      }
      activityObject.description.push(_formattedChange11);
    }
    formattedActivities.push(activityObject);
  });
  return formattedActivities;
}

/**
 * @name formatAppointmentActivity
 * @description Function to format appointment activity
 * @param {array} activity The activity to format
 * @return {string} Returns the placeholder message
 */
function formatAppointmentActivity(activity) {
  var formattedActivities = [];
  _lodash2.default.forEach(activity, function (eachActivity) {
    var activityObject = {
      type: 'activity',
      object: 'appointment',
      appointmentId: eachActivity.object_id,
      created: eachActivity.created,
      collector: eachActivity.collector,
      id: eachActivity.id,
      description: []
    };

    // Status field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.status)) {
      var formattedChange = {};

      // Request declined
      if (eachActivity.changes.status[1] === 'Request declined') {
        formattedChange.message = 'declined this appointment request';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Expired
      if (eachActivity.changes.status[1] === 'Expired') {
        formattedChange.message = 'allowed this appointment request to expire';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Unconfirmed = appointment sent to collector to confirm
      if (eachActivity.changes.status[1] === 'Unconfirmed') {
        formattedChange.message = 'sent an appointment for confirmation';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Unconfirmed and estimate min/max old values are NOT null = Project
      // set to reschedule later
      if (eachActivity.changes.status[1] === 'Requested' && eachActivity.changes.status[0] === 'Confirmed') {
        formattedChange.message = 'set this appointment to be rescheduled later';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;

        // Requested
      } else if (eachActivity.changes.status[1] === 'Requested') {
        formattedChange.message = 'requested an appointment for this project';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Confirmed
      if (eachActivity.changes.status[1] === 'Confirmed') {
        formattedChange.message = 'confirmed this appointment request';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Collector declined
      if (eachActivity.changes.status[1] === 'Declined') {
        formattedChange.message = 'declined this appointment';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Completed
      if (eachActivity.changes.status[1] === 'Completed') {
        formattedChange.message = 'completed this appointment';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Collector and artist cancelled
      if (eachActivity.changes.status[1] === 'Collector cancelled' || eachActivity.changes.status[1] === 'Artist cancelled') {
        formattedChange.message = 'cancelled this appointment';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      // Collector archived
      if (eachActivity.changes.status[1] === 'Archived') {
        formattedChange.message = 'archived this appointment';
        formattedChange.oldValue = null;
        formattedChange.newValue = null;
      }

      activityObject.description.push(formattedChange);
    }

    // Price field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.price)) {
      var _formattedChange12 = {};
      if (eachActivity.changes.price[0] === null) {
        _formattedChange12.message = 'set the price';
        _formattedChange12.oldValue = null;
        _formattedChange12.newValue = '$' + eachActivity.changes.price[1];
      } else {
        _formattedChange12.message = 'changed the price';
        _formattedChange12.oldValue = '$' + eachActivity.changes.price[0];
        _formattedChange12.newValue = '$' + eachActivity.changes.price[1];
      }
      activityObject.description.push(_formattedChange12);
    }

    // Estimate min and max field updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.estimate_min) && _lodash2.default.isUndefined(eachActivity.changes.estimate_max)) {
      var _formattedChange13 = {};
      if (eachActivity.changes.estimate_min[0] === null) {
        _formattedChange13.message = 'set the estimate minimum';
        _formattedChange13.oldValue = null;
        _formattedChange13.newValue = '$' + eachActivity.changes.estimate_min[1];
      } else {
        _formattedChange13.message = 'changed the estimate minimum';
        _formattedChange13.oldValue = '$' + eachActivity.changes.estimate_min[0];
        _formattedChange13.newValue = '$' + eachActivity.changes.estimate_min[1];
      }
      activityObject.description.push(_formattedChange13);
    }
    if (!_lodash2.default.isUndefined(eachActivity.changes.estimate_max) && _lodash2.default.isUndefined(eachActivity.changes.estimate_min)) {
      var _formattedChange14 = {};
      if (eachActivity.changes.estimate_max[0] === null) {
        _formattedChange14.message = 'set the estimate maximum';
        _formattedChange14.oldValue = null;
        _formattedChange14.newValue = '$' + eachActivity.changes.estimate_max[1];
      } else {
        _formattedChange14.message = 'changed the estimate maximum';
        _formattedChange14.oldValue = '$' + eachActivity.changes.estimate_max[0];
        _formattedChange14.newValue = '$' + eachActivity.changes.estimate_max[1];
      }
      activityObject.description.push(_formattedChange14);
    }
    if (!_lodash2.default.isUndefined(eachActivity.changes.estimate_min) && !_lodash2.default.isUndefined(eachActivity.changes.estimate_max)) {
      var _formattedChange15 = {};
      if (eachActivity.changes.estimate_min[0] === null) {
        _formattedChange15.message = 'set the estimate range';
        _formattedChange15.oldValue = null;
        _formattedChange15.newValue = '$' + eachActivity.changes.estimate_min[1];
      } else {
        _formattedChange15.message = 'changed the estimate range';
        _formattedChange15.oldValue = '$' + eachActivity.changes.estimate_min[0];
        _formattedChange15.newValue = '$' + eachActivity.changes.estimate_min[1];
      }
      if (eachActivity.changes.estimate_max[0] === null) {
        _formattedChange15.oldValue = null;
        _formattedChange15.newValue += ' to $' + eachActivity.changes.estimate_max[1];
      } else {
        _formattedChange15.oldValue += ' to $' + eachActivity.changes.estimate_max[0];
        _formattedChange15.newValue += ' to $' + eachActivity.changes.estimate_max[1];
      }
      activityObject.description.push(_formattedChange15);
    }

    // Deposit amount
    if (!_lodash2.default.isUndefined(eachActivity.changes.deposit_amount)) {
      var _formattedChange16 = {};
      if (eachActivity.changes.deposit_amount[0] === null && eachActivity.changes.deposit_amount[1] === 0) {
        _formattedChange16.message = 'set no deposit required';
        _formattedChange16.oldValue = null;
        _formattedChange16.newValue = null;
      } else if (eachActivity.changes.deposit_amount[1] === 0 || eachActivity.changes.deposit_amount[1] === null) {
        _formattedChange16.message = 'removed a required deposit amount';
        _formattedChange16.oldValue = null;
        _formattedChange16.newValue = null;
      } else if ((eachActivity.changes.deposit_amount[0] === null || eachActivity.changes.deposit_amount[0] === 0) && eachActivity.changes.deposit_amount[1] !== 0) {
        _formattedChange16.message = 'set the deposit amount';
        _formattedChange16.oldValue = null;
        _formattedChange16.newValue = '$' + eachActivity.changes.deposit_amount[1];
      } else {
        _formattedChange16.message = 'changed the deposit amount';
        _formattedChange16.oldValue = '$' + eachActivity.changes.deposit_amount[0];
        _formattedChange16.newValue = '$' + eachActivity.changes.deposit_amount[1];
      }
      activityObject.description.push(_formattedChange16);
    }

    // Previously paid
    if (!_lodash2.default.isUndefined(eachActivity.changes.previously_paid)) {
      var changeValues = [];
      _lodash2.default.forEach(eachActivity.changes.previously_paid, function (value) {
        if (value === true) {
          changeValues.push('Yes');
        } else {
          changeValues.push('No');
        }
      });
      var _formattedChange17 = {};
      if (eachActivity.changes.previously_paid[0] === null) {
        _formattedChange17.message = 'set the previously paid status';
        _formattedChange17.oldValue = null;
        _formattedChange17.newValue = changeValues[1];
      } else {
        _formattedChange17.message = 'changed the previously paid status';
        _formattedChange17.oldValue = changeValues[0];
        _formattedChange17.newValue = changeValues[1];
      }
      activityObject.description.push(_formattedChange17);
    }

    // Appointment datetime
    if (!_lodash2.default.isUndefined(eachActivity.changes.appointment_datetime)) {
      var _formattedChange18 = {};
      if (eachActivity.changes.appointment_datetime[0] === null) {
        _formattedChange18.message = 'set the appointment date and time';
        _formattedChange18.oldValue = null;
        _formattedChange18.newValue = (0, _moment2.default)(eachActivity.changes.appointment_datetime[1]).format('MMMM Do, YYYY') + ' at ' + (0, _moment2.default)(eachActivity.changes.appointment_datetime[1]).format('h:mm a');
      } else {
        _formattedChange18.message = 'changed the appointment date and time';
        _formattedChange18.oldValue = (0, _moment2.default)(eachActivity.changes.appointment_datetime[0]).format('MMMM Do, YYYY') + ' at ' + (0, _moment2.default)(eachActivity.changes.appointment_datetime[0]).format('h:mm a');
        _formattedChange18.newValue = (0, _moment2.default)(eachActivity.changes.appointment_datetime[1]).format('MMMM Do, YYYY') + ' at ' + (0, _moment2.default)(eachActivity.changes.appointment_datetime[1]).format('h:mm a');
      }
      activityObject.description.push(_formattedChange18);
    }

    // Artist updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.artist)) {
      var _formattedChange19 = {};
      if (eachActivity.changes.artist[0] === null) {
        _formattedChange19.message = 'set the artist';
        _formattedChange19.oldValue = null;
        _formattedChange19.newValue = eachActivity.changes.artist[1].first_name + ' ' + eachActivity.changes.artist[1].last_name;
      } else {
        _formattedChange19.message = 'changed the artist';
        _formattedChange19.oldValue = eachActivity.changes.artist[0].first_name + ' ' + eachActivity.changes.artist[0].last_name;
        _formattedChange19.newValue = eachActivity.changes.artist[1].first_name + ' ' + eachActivity.changes.artist[1].last_name;
      }
      activityObject.description.push(_formattedChange19);
    }

    // Managed by updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.managed_by)) {
      var _formattedChange20 = {};
      if (eachActivity.changes.managed_by[0] === null) {
        _formattedChange20.message = 'set the operator managing this appointment';
        _formattedChange20.oldValue = null;
        _formattedChange20.newValue = eachActivity.changes.managed_by[1].first_name + ' ' + eachActivity.changes.managed_by[1].last_name;
      } else if (eachActivity.changes.managed_by[1] === null) {
        _formattedChange20.message = 'removed this operator as appointment manager:';
        _formattedChange20.oldValue = eachActivity.changes.managed_by[0].first_name + ' ' + eachActivity.changes.managed_by[0].last_name;
        _formattedChange20.newValue = null;
      } else {
        _formattedChange20.message = 'changed the operator managing this appointment';
        _formattedChange20.oldValue = eachActivity.changes.managed_by[0].first_name + ' ' + eachActivity.changes.managed_by[0].last_name;
        _formattedChange20.newValue = eachActivity.changes.managed_by[1].first_name + ' ' + eachActivity.changes.managed_by[1].last_name;
      }
      activityObject.description.push(_formattedChange20);
    }

    // Length updates
    if (!_lodash2.default.isUndefined(eachActivity.changes.length)) {
      var _formattedChange21 = {};
      if (eachActivity.changes.length[0] === null) {
        _formattedChange21.message = 'set the appointment length';
        _formattedChange21.oldValue = null;
        _formattedChange21.newValue = _moment2.default.duration(eachActivity.changes.length[1]).format('h [hours] m [minutes]').replace(/\s0\s\w+/g, '');
      } else {
        _formattedChange21.message = 'changed the appointment length';
        _formattedChange21.oldValue = _moment2.default.duration(eachActivity.changes.length[0]).format('h [hours] m [minutes]').replace(/\s0\s\w+/g, '');
        _formattedChange21.newValue = _moment2.default.duration(eachActivity.changes.length[1]).format('h [hours] m [minutes]').replace(/\s0\s\w+/g, '');
      }
      activityObject.description.push(_formattedChange21);
    }

    // Cancellation policy
    if (!_lodash2.default.isUndefined(eachActivity.changes.agreed_to_cancellation_policy)) {
      var _formattedChange22 = {};
      _formattedChange22.oldValue = null;
      _formattedChange22.newValue = null;
      if (eachActivity.changes.agreed_to_cancellation_policy[1] === true) {
        _formattedChange22.message = 'agreed to the cancellation policy';
      }
      activityObject.description.push(_formattedChange22);
    }

    // Push the formatted object to the array if there's a collector available
    if (activityObject.collector !== null) {
      formattedActivities.push(activityObject);
    }
  });
  return formattedActivities;
}

/***/ }),

/***/ "./utils/format-gmaddress-fields.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = formatGmaddressFields;

/**
 * @name formatGmaddressFields
 * @description Formats a Google Maps object into the fields we want to save in
 * the API
 * @param {object} gmaddress The type of object activity to format
 * @return {object} Returns the address fields
 */

function formatGmaddressFields(gmaddress) {
  return new Promise(function (resolve, reject) {
    var addressFields = {};

    // Find specific components in the Google address components array
    var addressComponents = _lodash2.default.map(gmaddress);

    // Street number
    if (_lodash2.default.some(addressComponents, { types: ['street_number'] })) {
      var streetNumber = _lodash2.default.find(addressComponents, {
        types: ['street_number']
      });
      addressFields.street_number = streetNumber.long_name;
    }

    // Street address
    if (_lodash2.default.some(addressComponents, { types: ['street_address'] })) {
      var streetAddress = _lodash2.default.find(addressComponents, {
        types: ['street_address']
      });
      addressFields.street_address = streetAddress.long_name;
    } else if (_lodash2.default.some(addressComponents, { types: ['route'] })) {
      var route = _lodash2.default.find(addressComponents, {
        types: ['route']
      });
      addressFields.street_address = route.long_name;
    }

    // Locality
    if (_lodash2.default.some(addressComponents, { types: ['locality'] })) {
      var locality = _lodash2.default.find(addressComponents, {
        types: ['locality']
      });
      addressFields.locality = locality.long_name;
    }

    // Postal code
    if (_lodash2.default.some(addressComponents, { types: ['postal_code'] })) {
      var postalCode = _lodash2.default.find(addressComponents, {
        types: ['postal_code']
      });
      addressFields.postal_code = postalCode.long_name;
    }

    // Postal code
    if (_lodash2.default.some(addressComponents, { types: ['administrative_area_level_1'] })) {
      var state = _lodash2.default.find(addressComponents, {
        types: ['administrative_area_level_1']
      });
      addressFields.state = state.long_name;
    }

    // Country
    if (_lodash2.default.some(addressComponents, { types: ['country'] })) {
      var country = _lodash2.default.find(addressComponents, {
        types: ['country']
      });
      addressFields.country = country.short_name;
    }

    // Subpremise
    if (_lodash2.default.some(addressComponents, { types: ['subpremise'] })) {
      var subpremise = _lodash2.default.find(addressComponents, {
        types: ['subpremise']
      });
      addressFields.subpremise = subpremise.long_name;
    }
    resolve(addressFields);
  });
}

/***/ }),

/***/ "./utils/format-messages.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("../node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = formatMessages;

/**
 * @name formatMessages
 * @description Format messages from the API
 * @param {array} messages The collection to group
 * @return {array} Returns an array of formatted messages
 */

function formatMessages(messages) {
  var formattedMessages = [];
  _lodash2.default.each(messages, function (message) {
    var formattedMessage = message;
    formattedMessage.localCreatedDate = (0, _moment2.default)(message.created).format('YYYY-MM-DDTHH:mm:ss');
    formattedMessages.push(formattedMessage);
  });
  return formattedMessages;
}

/***/ }),

/***/ "./utils/format-project-api.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = formatProjectApi;

/**
 * @name formatProject
 * @description Format the Project (to API)
 * @param {object} project The project to be formatted
 * @return {object} Returns the project ready to send to the endpoint.
 */

function formatProjectApi(project) {
  var formattedProject = project;

  // Adjust the collector field value to the API standard.
  formattedProject.collector_id = project.collector;
  delete formattedProject.collector;

  // Process the Reference Photos
  if (project.referenceImages && project.referenceImages.length) {
    formattedProject.reference_images = [];
    _lodash2.default.each(project.referenceImages, function (photo) {
      if (photo.result.image && photo.result.image_1024 && photo.result.image_341) {
        formattedProject.reference_images.push(photo.result);
      }
    });
  }

  // Process Coverup Photos
  if (project.coverupImages && project.coverupImages.length) {
    formattedProject.coverup_images = [];
    _lodash2.default.each(project.coverupImages, function (photo) {
      if (photo.result.image && photo.result.image_1024 && photo.result.image_341) {
        formattedProject.coverup_images.push(photo.result);
      }
    });
  }

  // Process Completed Photos
  if (project.completedImages && project.completedImages.length) {
    formattedProject.completed_images = [];
    _lodash2.default.each(project.completedImages, function (photo) {
      if (photo.result.image && photo.result.image_1024 && photo.result.image_341) {
        formattedProject.completed_images.push(photo.result);
      }
    });
  }
  return formattedProject;
}

/***/ }),

/***/ "./utils/group-appts-by-date.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__("../node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = groupApptByDate;

/**
 * @name groupApptByDate
 * @description Funtion to group the appointments by appointment datetime.
 * @param {array} objects The array of appointments to group
 * @return {array} Returns an array of appointments grouped by dates
 */

function groupApptByDate(objects) {
  var dateGroups = _lodash2.default.chain(objects).groupBy(function (object) {
    if (object.appointment.appointment_datetime !== null) {
      return (0, _moment2.default)(object.appointment.appointment_datetime).format('MMMM Do, YYYY');
    }
    return 'No appointment date';
  }).toPairs().map(function (object) {
    return {
      dateTime: (0, _moment2.default)(object[1][0].appointment.appointment_datetime).format('MM-DD-YYYY'),
      date: object[0],
      appointments: object[1]
    };
  }).value();
  return dateGroups;
}

/***/ }),

/***/ "./utils/group-appts-by-day.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__("../node_modules/moment/moment.js");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = groupApptByDay;

/**
 * @name groupApptByDay
 * @description Function to group appointments by days on the calendar
 * @param {unknown} data Unknown
 * @return {array} Returns an array of sorted appointments by
 * day groups.
 */

function groupApptByDay(data) {
  var dayGroups = [[], [], [], [], [], [], []];

  // Push to days array
  for (var v = 0; v < data.length; v++) {
    dayGroups[(0, _moment2.default)(data[v].appointment_datetime, 'YYYY-MM-DDTHH:mm:ss').day()].push(data[v]);
  }
  return dayGroups;
}

/***/ }),

/***/ "./utils/group-by-appt-status.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__("../node_modules/lodash/lodash.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = groupByApptStatus;

/**
 * @name groupByApptStatus
 * @description Group appointments by status
 * @param {array} collection The collection of appointments to group
 * @return {array} groupedAppointments Returns the grouped collection
 */

function groupByApptStatus(collection) {
  var groupedCollection = void 0;
  if (collection[0].appointment) {
    groupedCollection = _lodash2.default.groupBy(collection, function (object) {
      if (!_lodash2.default.isUndefined(object.appointment) && !_lodash2.default.isUndefined(object.appointment.last_status)) {
        return _lodash2.default.camelCase(object.appointment.last_status.status_name);
      }
      return 'noAppointments';
    });
  } else {
    groupedCollection = _lodash2.default.groupBy(collection, function (appointment) {
      if (!_lodash2.default.isUndefined(appointment) && !_lodash2.default.isUndefined(appointment.last_status)) {
        return _lodash2.default.camelCase(appointment.last_status.status_name);
      }
      return 'noAppointments';
    });
  }
  return groupedCollection;
}

/***/ }),

/***/ "./utils/set-if-exists.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setIfExists;
/**
 * @name setIfExists
 * @description
 * If the value exists as a property of the input, set it to the property of
 * the output. Used when formatting data being sent to the API.
 * Sometimes there's a data disparity between the app and the api.
 * modelAttribute is designed to fix this (patch, really).
 * If you use modelAttribute, this is the value that the api expects us to send.
 * @param {unknown} input Unknown
 * @param {unknown} attribute Unknown
 * @param {unknown} output Unknown
 * @param {unknown} modelAttribute Unknown
 * @return {boolean} Returns a boolean based on the evaluation
 */
function setIfExists(input, attribute, output, modelAttribute) {
  if (attribute in input) {
    output[modelAttribute ? modelAttribute : attribute] = input[attribute];
    return true;
  }
  return false;
}

/***/ })

},["./index.js"]);


// WEBPACK FOOTER //
// bundle.app.d38532338056342e385c.js